webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(134);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(136);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(138);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	__webpack_require__(140);
	
	var _angularFileUpload = __webpack_require__(141);
	
	var _angularFileUpload2 = _interopRequireDefault(_angularFileUpload);
	
	var _ngclipboard = __webpack_require__(142);
	
	var _ngclipboard2 = _interopRequireDefault(_ngclipboard);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(145);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _app = __webpack_require__(147);
	
	var _navbar = __webpack_require__(148);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(150);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(152);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _user = __webpack_require__(156);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _search = __webpack_require__(162);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _survey = __webpack_require__(166);
	
	var _survey2 = _interopRequireDefault(_survey);
	
	var _feedback = __webpack_require__(170);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _multiplication = __webpack_require__(176);
	
	var _multiplication2 = _interopRequireDefault(_multiplication);
	
	var _notebook = __webpack_require__(180);
	
	var _notebook2 = _interopRequireDefault(_notebook);
	
	var _highlight = __webpack_require__(184);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _mark = __webpack_require__(188);
	
	var _mark2 = _interopRequireDefault(_mark);
	
	var _order = __webpack_require__(192);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _speechtype = __webpack_require__(196);
	
	var _speechtype2 = _interopRequireDefault(_speechtype);
	
	var _speechprofile = __webpack_require__(200);
	
	var _speechprofile2 = _interopRequireDefault(_speechprofile);
	
	var _speechdetails = __webpack_require__(204);
	
	var _speechdetails2 = _interopRequireDefault(_speechdetails);
	
	var _paysub = __webpack_require__(208);
	
	var _paysub2 = _interopRequireDefault(_paysub);
	
	var _adsub = __webpack_require__(212);
	
	var _adsub2 = _interopRequireDefault(_adsub);
	
	var _sharelink = __webpack_require__(216);
	
	var _sharelink2 = _interopRequireDefault(_sharelink);
	
	var _pushtoken = __webpack_require__(220);
	
	var _pushtoken2 = _interopRequireDefault(_pushtoken);
	
	var _custom = __webpack_require__(224);
	
	var _custom2 = _interopRequireDefault(_custom);
	
	var _oneday = __webpack_require__(228);
	
	var _oneday2 = _interopRequireDefault(_oneday);
	
	var _speechtypeen = __webpack_require__(244);
	
	var _speechtypeen2 = _interopRequireDefault(_speechtypeen);
	
	var _speechprofileen = __webpack_require__(248);
	
	var _speechprofileen2 = _interopRequireDefault(_speechprofileen);
	
	var _speechdetailsen = __webpack_require__(252);
	
	var _speechdetailsen2 = _interopRequireDefault(_speechdetailsen);
	
	var _speechtypees = __webpack_require__(256);
	
	var _speechtypees2 = _interopRequireDefault(_speechtypees);
	
	var _speechprofilees = __webpack_require__(260);
	
	var _speechprofilees2 = _interopRequireDefault(_speechprofilees);
	
	var _speechdetailses = __webpack_require__(264);
	
	var _speechdetailses2 = _interopRequireDefault(_speechdetailses);
	
	var _new = __webpack_require__(268);
	
	var _new2 = _interopRequireDefault(_new);
	
	var _setpoint = __webpack_require__(272);
	
	var _setpoint2 = _interopRequireDefault(_setpoint);
	
	var _iosdata = __webpack_require__(276);
	
	var _iosdata2 = _interopRequireDefault(_iosdata);
	
	var _shareimg = __webpack_require__(280);
	
	var _shareimg2 = _interopRequireDefault(_shareimg);
	
	var _plantype = __webpack_require__(284);
	
	var _plantype2 = _interopRequireDefault(_plantype);
	
	var _planstatus = __webpack_require__(288);
	
	var _planstatus2 = _interopRequireDefault(_planstatus);
	
	var _admanage = __webpack_require__(292);
	
	var _admanage2 = _interopRequireDefault(_admanage);
	
	var _emaileditor = __webpack_require__(296);
	
	var _emaileditor2 = _interopRequireDefault(_emaileditor);
	
	var _story = __webpack_require__(300);
	
	var _story2 = _interopRequireDefault(_story);
	
	var _adDefaults = __webpack_require__(306);
	
	var _adDefaults2 = _interopRequireDefault(_adDefaults);
	
	var _adDefaults3 = __webpack_require__(311);
	
	var _adDefaults4 = _interopRequireDefault(_adDefaults3);
	
	var _adDefaultStat = __webpack_require__(315);
	
	var _adDefaultStat2 = _interopRequireDefault(_adDefaultStat);
	
	var _adAggregation = __webpack_require__(318);
	
	var _adAggregation2 = _interopRequireDefault(_adAggregation);
	
	var _quiz = __webpack_require__(322);
	
	var _quiz2 = _interopRequireDefault(_quiz);
	
	var _app2 = __webpack_require__(326);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(328);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _socket = __webpack_require__(330);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _storyStat = __webpack_require__(382);
	
	var _storyStat2 = _interopRequireDefault(_storyStat);
	
	var _appSwitch = __webpack_require__(385);
	
	var _appSwitch2 = _interopRequireDefault(_appSwitch);
	
	var _commonImagesCenter = __webpack_require__(389);
	
	var _commonImagesCenter2 = _interopRequireDefault(_commonImagesCenter);
	
	var _complaint = __webpack_require__(393);
	
	var _complaint2 = _interopRequireDefault(_complaint);
	
	var _uba = __webpack_require__(397);
	
	var _uba2 = _interopRequireDefault(_uba);
	
	__webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('tttApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, 'btford.socket-io', 'ng.ueditor', _angularUiRouter2.default, _angularUiBootstrap2.default, _navbar2.default, _footer2.default, _main2.default, _user2.default, _search2.default, _survey2.default, _feedback2.default, _multiplication2.default, _notebook2.default, _highlight2.default, _mark2.default, _order2.default, _speechtype2.default, _speechprofile2.default, _speechdetails2.default, _paysub2.default, _adsub2.default, _sharelink2.default, _pushtoken2.default, _custom2.default, _oneday2.default, _speechtypeen2.default, _speechtypees2.default, _speechprofileen2.default, _speechprofilees2.default, _speechdetailsen2.default, _speechdetailses2.default, _new2.default, _setpoint2.default, _iosdata2.default, _shareimg2.default, _plantype2.default, _planstatus2.default, _admanage2.default, _emaileditor2.default, _app3.default, _socket2.default, _util2.default, 'angularFileUpload', _story2.default, _adDefaults2.default, _storyStat2.default, _adAggregation2.default, _quiz2.default, _appSwitch2.default, _commonImagesCenter2.default, 'ngclipboard', _complaint2.default, _adDefaultStat2.default, _adDefaults4.default, _uba2.default]).config(_app.routeConfig).run(['$rootScope', '$cookies', '$http', '$window', '$interval', '$location', function ($rootScope, $cookies, $http, $window, $interval, $location) {
	    'ngInject';
	
	    $rootScope.$on('$stateChangeStart', function (evt, next, current) {
	        if ($cookies.get('token')) {
	            $rootScope.islogin = true;
	        } else {
	            $rootScope.islogin = false;
	            $location.path('main');
	        }
	
	        console.log($rootScope.islogin);
	    });
	    $rootScope.$on('$stateChangeSuccess', function (evt, current, previous) {
	        console.log('route have already changed ：' + $location.path());
	    });
	}]);
	
	_angular2.default.element(document).ready(function () {
	    _angular2.default.bootstrap(document, ['tttApp'], {
	        strictDi: true
	    });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 angular-file-upload v2.5.0
	 https://github.com/nervgh/angular-file-upload
	*/
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["angular-file-upload"] = factory();
		else
			root["angular-file-upload"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		var _options = __webpack_require__(2);
		
		var _options2 = _interopRequireDefault(_options);
		
		var _FileUploader = __webpack_require__(3);
		
		var _FileUploader2 = _interopRequireDefault(_FileUploader);
		
		var _FileLikeObject = __webpack_require__(4);
		
		var _FileLikeObject2 = _interopRequireDefault(_FileLikeObject);
		
		var _FileItem = __webpack_require__(5);
		
		var _FileItem2 = _interopRequireDefault(_FileItem);
		
		var _FileDirective = __webpack_require__(6);
		
		var _FileDirective2 = _interopRequireDefault(_FileDirective);
		
		var _FileSelect = __webpack_require__(7);
		
		var _FileSelect2 = _interopRequireDefault(_FileSelect);
		
		var _Pipeline = __webpack_require__(8);
		
		var _Pipeline2 = _interopRequireDefault(_Pipeline);
		
		var _FileDrop = __webpack_require__(9);
		
		var _FileDrop2 = _interopRequireDefault(_FileDrop);
		
		var _FileOver = __webpack_require__(10);
		
		var _FileOver2 = _interopRequireDefault(_FileOver);
		
		var _FileSelect3 = __webpack_require__(11);
		
		var _FileSelect4 = _interopRequireDefault(_FileSelect3);
		
		var _FileDrop3 = __webpack_require__(12);
		
		var _FileDrop4 = _interopRequireDefault(_FileDrop3);
		
		var _FileOver3 = __webpack_require__(13);
		
		var _FileOver4 = _interopRequireDefault(_FileOver3);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		angular.module(_config2.default.name, []).value('fileUploaderOptions', _options2.default).factory('FileUploader', _FileUploader2.default).factory('FileLikeObject', _FileLikeObject2.default).factory('FileItem', _FileItem2.default).factory('FileDirective', _FileDirective2.default).factory('FileSelect', _FileSelect2.default).factory('FileDrop', _FileDrop2.default).factory('FileOver', _FileOver2.default).factory('Pipeline', _Pipeline2.default).directive('nvFileSelect', _FileSelect4.default).directive('nvFileDrop', _FileDrop4.default).directive('nvFileOver', _FileOver4.default).run(['FileUploader', 'FileLikeObject', 'FileItem', 'FileDirective', 'FileSelect', 'FileDrop', 'FileOver', 'Pipeline', function (FileUploader, FileLikeObject, FileItem, FileDirective, FileSelect, FileDrop, FileOver, Pipeline) {
		    // only for compatibility
		    FileUploader.FileLikeObject = FileLikeObject;
		    FileUploader.FileItem = FileItem;
		    FileUploader.FileDirective = FileDirective;
		    FileUploader.FileSelect = FileSelect;
		    FileUploader.FileDrop = FileDrop;
		    FileUploader.FileOver = FileOver;
		    FileUploader.Pipeline = Pipeline;
		}]);
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = {
			"name": "angularFileUpload"
		};
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = {
		    url: '/',
		    alias: 'file',
		    headers: {},
		    queue: [],
		    progress: 0,
		    autoUpload: false,
		    removeAfterUpload: false,
		    method: 'POST',
		    filters: [],
		    formData: [],
		    queueLimit: Number.MAX_VALUE,
		    withCredentials: false,
		    disableMultipart: false
		};
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var bind = _angular.bind;
		var copy = _angular.copy;
		var extend = _angular.extend;
		var forEach = _angular.forEach;
		var isObject = _angular.isObject;
		var isNumber = _angular.isNumber;
		var isDefined = _angular.isDefined;
		var isArray = _angular.isArray;
		var isUndefined = _angular.isUndefined;
		var element = _angular.element;
		function __identity(fileUploaderOptions, $rootScope, $http, $window, $timeout, FileLikeObject, FileItem, Pipeline) {
		    var File = $window.File;
		    var FormData = $window.FormData;
		
		    var FileUploader = function () {
		        /**********************
		         * PUBLIC
		         **********************/
		        /**
		         * Creates an instance of FileUploader
		         * @param {Object} [options]
		         * @constructor
		         */
		
		        function FileUploader(options) {
		            _classCallCheck(this, FileUploader);
		
		            var settings = copy(fileUploaderOptions);
		
		            extend(this, settings, options, {
		                isUploading: false,
		                _nextIndex: 0,
		                _directives: { select: [], drop: [], over: [] }
		            });
		
		            // add default filters
		            this.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
		            this.filters.unshift({ name: 'folder', fn: this._folderFilter });
		        }
		        /**
		         * Adds items to the queue
		         * @param {File|HTMLInputElement|Object|FileList|Array<Object>} files
		         * @param {Object} [options]
		         * @param {Array<Function>|String} filters
		         */
		
		
		        FileUploader.prototype.addToQueue = function addToQueue(files, options, filters) {
		            var _this = this;
		
		            var incomingQueue = this.isArrayLikeObject(files) ? Array.prototype.slice.call(files) : [files];
		            var arrayOfFilters = this._getFilters(filters);
		            var count = this.queue.length;
		            var addedFileItems = [];
		
		            var next = function next() {
		                var something = incomingQueue.shift();
		
		                if (isUndefined(something)) {
		                    return done();
		                }
		
		                var fileLikeObject = _this.isFile(something) ? something : new FileLikeObject(something);
		                var pipes = _this._convertFiltersToPipes(arrayOfFilters);
		                var pipeline = new Pipeline(pipes);
		                var onThrown = function onThrown(err) {
		                    var originalFilter = err.pipe.originalFilter;
		
		                    var _err$args = _slicedToArray(err.args, 2);
		
		                    var fileLikeObject = _err$args[0];
		                    var options = _err$args[1];
		
		                    _this._onWhenAddingFileFailed(fileLikeObject, originalFilter, options);
		                    next();
		                };
		                var onSuccessful = function onSuccessful(fileLikeObject, options) {
		                    var fileItem = new FileItem(_this, fileLikeObject, options);
		                    addedFileItems.push(fileItem);
		                    _this.queue.push(fileItem);
		                    _this._onAfterAddingFile(fileItem);
		                    next();
		                };
		                pipeline.onThrown = onThrown;
		                pipeline.onSuccessful = onSuccessful;
		                pipeline.exec(fileLikeObject, options);
		            };
		
		            var done = function done() {
		                if (_this.queue.length !== count) {
		                    _this._onAfterAddingAll(addedFileItems);
		                    _this.progress = _this._getTotalProgress();
		                }
		
		                _this._render();
		                if (_this.autoUpload) _this.uploadAll();
		            };
		
		            next();
		        };
		        /**
		         * Remove items from the queue. Remove last: index = -1
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.removeFromQueue = function removeFromQueue(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            if (item.isUploading) item.cancel();
		            this.queue.splice(index, 1);
		            item._destroy();
		            this.progress = this._getTotalProgress();
		        };
		        /**
		         * Clears the queue
		         */
		
		
		        FileUploader.prototype.clearQueue = function clearQueue() {
		            while (this.queue.length) {
		                this.queue[0].remove();
		            }
		            this.progress = 0;
		        };
		        /**
		         * Uploads a item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.uploadItem = function uploadItem(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var transport = this.isHTML5 ? '_xhrTransport' : '_iframeTransport';
		
		            item._prepareToUploading();
		            if (this.isUploading) return;
		
		            this._onBeforeUploadItem(item);
		            if (item.isCancel) return;
		
		            item.isUploading = true;
		            this.isUploading = true;
		            this[transport](item);
		            this._render();
		        };
		        /**
		         * Cancels uploading of item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.cancelItem = function cancelItem(value) {
		            var _this2 = this;
		
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var prop = this.isHTML5 ? '_xhr' : '_form';
		            if (!item) return;
		            item.isCancel = true;
		            if (item.isUploading) {
		                // It will call this._onCancelItem() & this._onCompleteItem() asynchronously
		                item[prop].abort();
		            } else {
		                (function () {
		                    var dummy = [undefined, 0, {}];
		                    var onNextTick = function onNextTick() {
		                        _this2._onCancelItem.apply(_this2, [item].concat(dummy));
		                        _this2._onCompleteItem.apply(_this2, [item].concat(dummy));
		                    };
		                    $timeout(onNextTick); // Trigger callbacks asynchronously (setImmediate emulation)
		                })();
		            }
		        };
		        /**
		         * Uploads all not uploaded items of queue
		         */
		
		
		        FileUploader.prototype.uploadAll = function uploadAll() {
		            var items = this.getNotUploadedItems().filter(function (item) {
		                return !item.isUploading;
		            });
		            if (!items.length) return;
		
		            forEach(items, function (item) {
		                return item._prepareToUploading();
		            });
		            items[0].upload();
		        };
		        /**
		         * Cancels all uploads
		         */
		
		
		        FileUploader.prototype.cancelAll = function cancelAll() {
		            var items = this.getNotUploadedItems();
		            forEach(items, function (item) {
		                return item.cancel();
		            });
		        };
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFile = function isFile(value) {
		            return this.constructor.isFile(value);
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFileLikeObject = function isFileLikeObject(value) {
		            return this.constructor.isFileLikeObject(value);
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.prototype.isArrayLikeObject = function isArrayLikeObject(value) {
		            return this.constructor.isArrayLikeObject(value);
		        };
		        /**
		         * Returns a index of item from the queue
		         * @param {Item|Number} value
		         * @returns {Number}
		         */
		
		
		        FileUploader.prototype.getIndexOfItem = function getIndexOfItem(value) {
		            return isNumber(value) ? value : this.queue.indexOf(value);
		        };
		        /**
		         * Returns not uploaded items
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getNotUploadedItems = function getNotUploadedItems() {
		            return this.queue.filter(function (item) {
		                return !item.isUploaded;
		            });
		        };
		        /**
		         * Returns items ready for upload
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getReadyItems = function getReadyItems() {
		            return this.queue.filter(function (item) {
		                return item.isReady && !item.isUploading;
		            }).sort(function (item1, item2) {
		                return item1.index - item2.index;
		            });
		        };
		        /**
		         * Destroys instance of FileUploader
		         */
		
		
		        FileUploader.prototype.destroy = function destroy() {
		            var _this3 = this;
		
		            forEach(this._directives, function (key) {
		                forEach(_this3._directives[key], function (object) {
		                    object.destroy();
		                });
		            });
		        };
		        /**
		         * Callback
		         * @param {Array} fileItems
		         */
		
		
		        FileUploader.prototype.onAfterAddingAll = function onAfterAddingAll(fileItems) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onAfterAddingFile = function onAfterAddingFile(fileItem) {};
		        /**
		         * Callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         */
		
		
		        FileUploader.prototype.onWhenAddingFileFailed = function onWhenAddingFileFailed(item, filter, options) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onBeforeUploadItem = function onBeforeUploadItem(fileItem) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressItem = function onProgressItem(fileItem, progress) {};
		        /**
		         * Callback
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressAll = function onProgressAll(progress) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onSuccessItem = function onSuccessItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onErrorItem = function onErrorItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCancelItem = function onCancelItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCompleteItem = function onCompleteItem(item, response, status, headers) {};
		        /**
		         * Callback
		         */
		
		
		        FileUploader.prototype.onCompleteAll = function onCompleteAll() {};
		        /**********************
		         * PRIVATE
		         **********************/
		        /**
		         * Returns the total progress
		         * @param {Number} [value]
		         * @returns {Number}
		         * @private
		         */
		
		
		        FileUploader.prototype._getTotalProgress = function _getTotalProgress(value) {
		            if (this.removeAfterUpload) return value || 0;
		
		            var notUploaded = this.getNotUploadedItems().length;
		            var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
		            var ratio = 100 / this.queue.length;
		            var current = (value || 0) * ratio / 100;
		
		            return Math.round(uploaded * ratio + current);
		        };
		        /**
		         * Returns array of filters
		         * @param {Array<Function>|String} filters
		         * @returns {Array<Function>}
		         * @private
		         */
		
		
		        FileUploader.prototype._getFilters = function _getFilters(filters) {
		            if (!filters) return this.filters;
		            if (isArray(filters)) return filters;
		            var names = filters.match(/[^\s,]+/g);
		            return this.filters.filter(function (filter) {
		                return names.indexOf(filter.name) !== -1;
		            });
		        };
		        /**
		        * @param {Array<Function>} filters
		        * @returns {Array<Function>}
		        * @private
		        */
		
		
		        FileUploader.prototype._convertFiltersToPipes = function _convertFiltersToPipes(filters) {
		            var _this4 = this;
		
		            return filters.map(function (filter) {
		                var fn = bind(_this4, filter.fn);
		                fn.isAsync = filter.fn.length === 3;
		                fn.originalFilter = filter;
		                return fn;
		            });
		        };
		        /**
		         * Updates html
		         * @private
		         */
		
		
		        FileUploader.prototype._render = function _render() {
		            if (!$rootScope.$$phase) $rootScope.$apply();
		        };
		        /**
		         * Returns "true" if item is a file (not folder)
		         * @param {File|FileLikeObject} item
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._folderFilter = function _folderFilter(item) {
		            return !!(item.size || item.type);
		        };
		        /**
		         * Returns "true" if the limit has not been reached
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._queueLimitFilter = function _queueLimitFilter() {
		            return this.queue.length < this.queueLimit;
		        };
		        /**
		         * Checks whether upload successful
		         * @param {Number} status
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._isSuccessCode = function _isSuccessCode(status) {
		            return status >= 200 && status < 300 || status === 304;
		        };
		        /**
		         * Transforms the server response
		         * @param {*} response
		         * @param {Object} headers
		         * @returns {*}
		         * @private
		         */
		
		
		        FileUploader.prototype._transformResponse = function _transformResponse(response, headers) {
		            var headersGetter = this._headersGetter(headers);
		            forEach($http.defaults.transformResponse, function (transformFn) {
		                response = transformFn(response, headersGetter);
		            });
		            return response;
		        };
		        /**
		         * Parsed response headers
		         * @param headers
		         * @returns {Object}
		         * @see https://github.com/angular/angular.js/blob/master/src/ng/http.js
		         * @private
		         */
		
		
		        FileUploader.prototype._parseHeaders = function _parseHeaders(headers) {
		            var parsed = {},
		                key,
		                val,
		                i;
		
		            if (!headers) return parsed;
		
		            forEach(headers.split('\n'), function (line) {
		                i = line.indexOf(':');
		                key = line.slice(0, i).trim().toLowerCase();
		                val = line.slice(i + 1).trim();
		
		                if (key) {
		                    parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
		                }
		            });
		
		            return parsed;
		        };
		        /**
		         * Returns function that returns headers
		         * @param {Object} parsedHeaders
		         * @returns {Function}
		         * @private
		         */
		
		
		        FileUploader.prototype._headersGetter = function _headersGetter(parsedHeaders) {
		            return function (name) {
		                if (name) {
		                    return parsedHeaders[name.toLowerCase()] || null;
		                }
		                return parsedHeaders;
		            };
		        };
		        /**
		         * The XMLHttpRequest transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._xhrTransport = function _xhrTransport(item) {
		            var _this5 = this;
		
		            var xhr = item._xhr = new XMLHttpRequest();
		            var sendable;
		
		            if (!item.disableMultipart) {
		                sendable = new FormData();
		                forEach(item.formData, function (obj) {
		                    forEach(obj, function (value, key) {
		                        sendable.append(key, value);
		                    });
		                });
		
		                sendable.append(item.alias, item._file, item.file.name);
		            } else {
		                sendable = item._file;
		            }
		
		            if (typeof item._file.size != 'number') {
		                throw new TypeError('The file specified is no longer valid');
		            }
		
		            xhr.upload.onprogress = function (event) {
		                var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
		                _this5._onProgressItem(item, progress);
		            };
		
		            xhr.onload = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                var gist = _this5._isSuccessCode(xhr.status) ? 'Success' : 'Error';
		                var method = '_on' + gist + 'Item';
		                _this5[method](item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onerror = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onErrorItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onabort = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onCancelItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.open(item.method, item.url, true);
		
		            xhr.withCredentials = item.withCredentials;
		
		            forEach(item.headers, function (value, name) {
		                xhr.setRequestHeader(name, value);
		            });
		
		            xhr.send(sendable);
		        };
		        /**
		         * The IFrame transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._iframeTransport = function _iframeTransport(item) {
		            var _this6 = this;
		
		            var form = element('<form style="display: none;" />');
		            var iframe = element('<iframe name="iframeTransport' + Date.now() + '">');
		            var input = item._input;
		
		            if (item._form) item._form.replaceWith(input); // remove old form
		            item._form = form; // save link to new form
		
		            input.prop('name', item.alias);
		
		            forEach(item.formData, function (obj) {
		                forEach(obj, function (value, key) {
		                    var element_ = element('<input type="hidden" name="' + key + '" />');
		                    element_.val(value);
		                    form.append(element_);
		                });
		            });
		
		            form.prop({
		                action: item.url,
		                method: 'POST',
		                target: iframe.prop('name'),
		                enctype: 'multipart/form-data',
		                encoding: 'multipart/form-data' // old IE
		            });
		
		            iframe.bind('load', function () {
		                var html = '';
		                var status = 200;
		
		                try {
		                    // Fix for legacy IE browsers that loads internal error page
		                    // when failed WS response received. In consequence iframe
		                    // content access denied error is thrown becouse trying to
		                    // access cross domain page. When such thing occurs notifying
		                    // with empty response object. See more info at:
		                    // http://stackoverflow.com/questions/151362/access-is-denied-error-on-accessing-iframe-document-object
		                    // Note that if non standard 4xx or 5xx error code returned
		                    // from WS then response content can be accessed without error
		                    // but 'XHR' status becomes 200. In order to avoid confusion
		                    // returning response via same 'success' event handler.
		
		                    // fixed angular.contents() for iframes
		                    html = iframe[0].contentDocument.body.innerHTML;
		                } catch (e) {
		                    // in case we run into the access-is-denied error or we have another error on the server side
		                    // (intentional 500,40... errors), we at least say 'something went wrong' -> 500
		                    status = 500;
		                }
		
		                var xhr = { response: html, status: status, dummy: true };
		                var headers = {};
		                var response = _this6._transformResponse(xhr.response, headers);
		
		                _this6._onSuccessItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            });
		
		            form.abort = function () {
		                var xhr = { status: 0, dummy: true };
		                var headers = {};
		                var response;
		
		                iframe.unbind('load').prop('src', 'javascript:false;');
		                form.replaceWith(input);
		
		                _this6._onCancelItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            input.after(form);
		            form.append(input).append(iframe);
		
		            form[0].submit();
		        };
		        /**
		         * Inner callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         * @private
		         */
		
		
		        FileUploader.prototype._onWhenAddingFileFailed = function _onWhenAddingFileFailed(item, filter, options) {
		            this.onWhenAddingFileFailed(item, filter, options);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         */
		
		
		        FileUploader.prototype._onAfterAddingFile = function _onAfterAddingFile(item) {
		            this.onAfterAddingFile(item);
		        };
		        /**
		         * Inner callback
		         * @param {Array<FileItem>} items
		         */
		
		
		        FileUploader.prototype._onAfterAddingAll = function _onAfterAddingAll(items) {
		            this.onAfterAddingAll(items);
		        };
		        /**
		         *  Inner callback
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._onBeforeUploadItem = function _onBeforeUploadItem(item) {
		            item._onBeforeUpload();
		            this.onBeforeUploadItem(item);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileUploader.prototype._onProgressItem = function _onProgressItem(item, progress) {
		            var total = this._getTotalProgress(progress);
		            this.progress = total;
		            item._onProgress(progress);
		            this.onProgressItem(item, progress);
		            this.onProgressAll(total);
		            this._render();
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onSuccessItem = function _onSuccessItem(item, response, status, headers) {
		            item._onSuccess(response, status, headers);
		            this.onSuccessItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onErrorItem = function _onErrorItem(item, response, status, headers) {
		            item._onError(response, status, headers);
		            this.onErrorItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCancelItem = function _onCancelItem(item, response, status, headers) {
		            item._onCancel(response, status, headers);
		            this.onCancelItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCompleteItem = function _onCompleteItem(item, response, status, headers) {
		            item._onComplete(response, status, headers);
		            this.onCompleteItem(item, response, status, headers);
		
		            var nextItem = this.getReadyItems()[0];
		            this.isUploading = false;
		
		            if (isDefined(nextItem)) {
		                nextItem.upload();
		                return;
		            }
		
		            this.onCompleteAll();
		            this.progress = this._getTotalProgress();
		            this._render();
		        };
		        /**********************
		         * STATIC
		         **********************/
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFile = function isFile(value) {
		            return File && value instanceof File;
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFileLikeObject = function isFileLikeObject(value) {
		            return value instanceof FileLikeObject;
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.isArrayLikeObject = function isArrayLikeObject(value) {
		            return isObject(value) && 'length' in value;
		        };
		        /**
		         * Inherits a target (Class_1) by a source (Class_2)
		         * @param {Function} target
		         * @param {Function} source
		         */
		
		
		        FileUploader.inherit = function inherit(target, source) {
		            target.prototype = Object.create(source.prototype);
		            target.prototype.constructor = target;
		            target.super_ = source;
		        };
		
		        return FileUploader;
		    }();
		
		    /**********************
		     * PUBLIC
		     **********************/
		    /**
		     * Checks a support the html5 uploader
		     * @returns {Boolean}
		     * @readonly
		     */
		
		
		    FileUploader.prototype.isHTML5 = !!(File && FormData);
		    /**********************
		     * STATIC
		     **********************/
		    /**
		     * @borrows FileUploader.prototype.isHTML5
		     */
		    FileUploader.isHTML5 = FileUploader.prototype.isHTML5;
		
		    return FileUploader;
		}
		
		__identity.$inject = ['fileUploaderOptions', '$rootScope', '$http', '$window', '$timeout', 'FileLikeObject', 'FileItem', 'Pipeline'];
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var copy = _angular.copy;
		var isElement = _angular.isElement;
		var isString = _angular.isString;
		function __identity() {
		
		    return function () {
		        /**
		         * Creates an instance of FileLikeObject
		         * @param {File|HTMLInputElement|Object} fileOrInput
		         * @constructor
		         */
		
		        function FileLikeObject(fileOrInput) {
		            _classCallCheck(this, FileLikeObject);
		
		            var isInput = isElement(fileOrInput);
		            var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
		            var postfix = isString(fakePathOrObject) ? 'FakePath' : 'Object';
		            var method = '_createFrom' + postfix;
		            this[method](fakePathOrObject);
		        }
		        /**
		         * Creates file like object from fake path string
		         * @param {String} path
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromFakePath = function _createFromFakePath(path) {
		            this.lastModifiedDate = null;
		            this.size = null;
		            this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
		            this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
		        };
		        /**
		         * Creates file like object from object
		         * @param {File|FileLikeObject} object
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromObject = function _createFromObject(object) {
		            this.lastModifiedDate = copy(object.lastModifiedDate);
		            this.size = object.size;
		            this.type = object.type;
		            this.name = object.name;
		        };
		
		        return FileLikeObject;
		    }();
		}
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var copy = _angular.copy;
		var extend = _angular.extend;
		var element = _angular.element;
		var isElement = _angular.isElement;
		function __identity($compile, FileLikeObject) {
		
		    return function () {
		        /**
		         * Creates an instance of FileItem
		         * @param {FileUploader} uploader
		         * @param {File|HTMLInputElement|Object} some
		         * @param {Object} options
		         * @constructor
		         */
		
		        function FileItem(uploader, some, options) {
		            _classCallCheck(this, FileItem);
		
		            var isInput = isElement(some);
		            var input = isInput ? element(some) : null;
		            var file = !isInput ? some : null;
		
		            extend(this, {
		                url: uploader.url,
		                alias: uploader.alias,
		                headers: copy(uploader.headers),
		                formData: copy(uploader.formData),
		                removeAfterUpload: uploader.removeAfterUpload,
		                withCredentials: uploader.withCredentials,
		                disableMultipart: uploader.disableMultipart,
		                method: uploader.method
		            }, options, {
		                uploader: uploader,
		                file: new FileLikeObject(some),
		                isReady: false,
		                isUploading: false,
		                isUploaded: false,
		                isSuccess: false,
		                isCancel: false,
		                isError: false,
		                progress: 0,
		                index: null,
		                _file: file,
		                _input: input
		            });
		
		            if (input) this._replaceNode(input);
		        }
		        /**********************
		         * PUBLIC
		         **********************/
		        /**
		         * Uploads a FileItem
		         */
		
		
		        FileItem.prototype.upload = function upload() {
		            try {
		                this.uploader.uploadItem(this);
		            } catch (e) {
		                var message = e.name + ':' + e.message;
		                this.uploader._onCompleteItem(this, message, e.code, []);
		                this.uploader._onErrorItem(this, message, e.code, []);
		            }
		        };
		        /**
		         * Cancels uploading of FileItem
		         */
		
		
		        FileItem.prototype.cancel = function cancel() {
		            this.uploader.cancelItem(this);
		        };
		        /**
		         * Removes a FileItem
		         */
		
		
		        FileItem.prototype.remove = function remove() {
		            this.uploader.removeFromQueue(this);
		        };
		        /**
		         * Callback
		         * @private
		         */
		
		
		        FileItem.prototype.onBeforeUpload = function onBeforeUpload() {};
		        /**
		         * Callback
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileItem.prototype.onProgress = function onProgress(progress) {};
		        /**
		         * Callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileItem.prototype.onSuccess = function onSuccess(response, status, headers) {};
		        /**
		         * Callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileItem.prototype.onError = function onError(response, status, headers) {};
		        /**
		         * Callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileItem.prototype.onCancel = function onCancel(response, status, headers) {};
		        /**
		         * Callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileItem.prototype.onComplete = function onComplete(response, status, headers) {};
		        /**********************
		         * PRIVATE
		         **********************/
		        /**
		         * Inner callback
		         */
		
		
		        FileItem.prototype._onBeforeUpload = function _onBeforeUpload() {
		            this.isReady = true;
		            this.isUploading = false;
		            this.isUploaded = false;
		            this.isSuccess = false;
		            this.isCancel = false;
		            this.isError = false;
		            this.progress = 0;
		            this.onBeforeUpload();
		        };
		        /**
		         * Inner callback
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileItem.prototype._onProgress = function _onProgress(progress) {
		            this.progress = progress;
		            this.onProgress(progress);
		        };
		        /**
		         * Inner callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileItem.prototype._onSuccess = function _onSuccess(response, status, headers) {
		            this.isReady = false;
		            this.isUploading = false;
		            this.isUploaded = true;
		            this.isSuccess = true;
		            this.isCancel = false;
		            this.isError = false;
		            this.progress = 100;
		            this.index = null;
		            this.onSuccess(response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileItem.prototype._onError = function _onError(response, status, headers) {
		            this.isReady = false;
		            this.isUploading = false;
		            this.isUploaded = true;
		            this.isSuccess = false;
		            this.isCancel = false;
		            this.isError = true;
		            this.progress = 0;
		            this.index = null;
		            this.onError(response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileItem.prototype._onCancel = function _onCancel(response, status, headers) {
		            this.isReady = false;
		            this.isUploading = false;
		            this.isUploaded = false;
		            this.isSuccess = false;
		            this.isCancel = true;
		            this.isError = false;
		            this.progress = 0;
		            this.index = null;
		            this.onCancel(response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileItem.prototype._onComplete = function _onComplete(response, status, headers) {
		            this.onComplete(response, status, headers);
		            if (this.removeAfterUpload) this.remove();
		        };
		        /**
		         * Destroys a FileItem
		         */
		
		
		        FileItem.prototype._destroy = function _destroy() {
		            if (this._input) this._input.remove();
		            if (this._form) this._form.remove();
		            delete this._form;
		            delete this._input;
		        };
		        /**
		         * Prepares to uploading
		         * @private
		         */
		
		
		        FileItem.prototype._prepareToUploading = function _prepareToUploading() {
		            this.index = this.index || ++this.uploader._nextIndex;
		            this.isReady = true;
		        };
		        /**
		         * Replaces input element on his clone
		         * @param {JQLite|jQuery} input
		         * @private
		         */
		
		
		        FileItem.prototype._replaceNode = function _replaceNode(input) {
		            var clone = $compile(input.clone())(input.scope());
		            clone.prop('value', null); // FF fix
		            input.css('display', 'none');
		            input.after(clone); // remove jquery dependency
		        };
		
		        return FileItem;
		    }();
		}
		
		__identity.$inject = ['$compile', 'FileLikeObject'];
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var extend = _angular.extend;
		function __identity() {
		    var FileDirective = function () {
		        /**
		         * Creates instance of {FileDirective} object
		         * @param {Object} options
		         * @param {Object} options.uploader
		         * @param {HTMLElement} options.element
		         * @param {Object} options.events
		         * @param {String} options.prop
		         * @constructor
		         */
		
		        function FileDirective(options) {
		            _classCallCheck(this, FileDirective);
		
		            extend(this, options);
		            this.uploader._directives[this.prop].push(this);
		            this._saveLinks();
		            this.bind();
		        }
		        /**
		         * Binds events handles
		         */
		
		
		        FileDirective.prototype.bind = function bind() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this.element.bind(key, this[prop]);
		            }
		        };
		        /**
		         * Unbinds events handles
		         */
		
		
		        FileDirective.prototype.unbind = function unbind() {
		            for (var key in this.events) {
		                this.element.unbind(key, this.events[key]);
		            }
		        };
		        /**
		         * Destroys directive
		         */
		
		
		        FileDirective.prototype.destroy = function destroy() {
		            var index = this.uploader._directives[this.prop].indexOf(this);
		            this.uploader._directives[this.prop].splice(index, 1);
		            this.unbind();
		            // this.element = null;
		        };
		        /**
		         * Saves links to functions
		         * @private
		         */
		
		
		        FileDirective.prototype._saveLinks = function _saveLinks() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this[prop] = this[prop].bind(this);
		            }
		        };
		
		        return FileDirective;
		    }();
		
		    /**
		     * Map of events
		     * @type {Object}
		     */
		
		
		    FileDirective.prototype.events = {};
		
		    return FileDirective;
		}
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular;
		var extend = _angular.extend;
		function __identity($compile, FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileSelect, _FileDirective);
		
		        /**
		         * Creates instance of {FileSelect} object
		         * @param {Object} options
		         * @constructor
		         */
		
		        function FileSelect(options) {
		            _classCallCheck(this, FileSelect);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    change: 'onChange'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'select'
		            });
		
		            var _this = _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		
		            if (!_this.uploader.isHTML5) {
		                _this.element.removeAttr('multiple');
		            }
		            _this.element.prop('value', null); // FF fix
		            return _this;
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileSelect.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileSelect.prototype.getFilters = function getFilters() {};
		        /**
		         * If returns "true" then HTMLInputElement will be cleared
		         * @returns {Boolean}
		         */
		
		
		        FileSelect.prototype.isEmptyAfterSelection = function isEmptyAfterSelection() {
		            return !!this.element.attr('multiple');
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileSelect.prototype.onChange = function onChange() {
		            var files = this.uploader.isHTML5 ? this.element[0].files : this.element[0];
		            var options = this.getOptions();
		            var filters = this.getFilters();
		
		            if (!this.uploader.isHTML5) this.destroy();
		            this.uploader.addToQueue(files, options, filters);
		            if (this.isEmptyAfterSelection()) {
		                this.element.prop('value', null);
		                this.element.replaceWith($compile(this.element.clone())(this.scope)); // IE fix
		            }
		        };
		
		        return FileSelect;
		    }(FileDirective);
		}
		
		__identity.$inject = ['$compile', 'FileDirective'];
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = __identity;
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var bind = _angular.bind;
		var isUndefined = _angular.isUndefined;
		function __identity($q) {
		
		  return function () {
		    /**
		     * @param {Array<Function>} pipes
		     */
		
		    function Pipeline() {
		      var pipes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
		
		      _classCallCheck(this, Pipeline);
		
		      this.pipes = pipes;
		    }
		
		    Pipeline.prototype.next = function next(args) {
		      var pipe = this.pipes.shift();
		      if (isUndefined(pipe)) {
		        this.onSuccessful.apply(this, _toConsumableArray(args));
		        return;
		      }
		      var err = new Error('The filter has not passed');
		      err.pipe = pipe;
		      err.args = args;
		      if (pipe.isAsync) {
		        var deferred = $q.defer();
		        var onFulfilled = bind(this, this.next, args);
		        var onRejected = bind(this, this.onThrown, err);
		        deferred.promise.then(onFulfilled, onRejected);
		        pipe.apply(undefined, _toConsumableArray(args).concat([deferred]));
		      } else {
		        var isDone = Boolean(pipe.apply(undefined, _toConsumableArray(args)));
		        if (isDone) {
		          this.next(args);
		        } else {
		          this.onThrown(err);
		        }
		      }
		    };
		
		    Pipeline.prototype.exec = function exec() {
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
		
		      this.next(args);
		    };
		
		    Pipeline.prototype.onThrown = function onThrown(err) {};
		
		    Pipeline.prototype.onSuccessful = function onSuccessful() {};
		
		    return Pipeline;
		  }();
		}
		
		__identity.$inject = ['$q'];
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular;
		var extend = _angular.extend;
		var forEach = _angular.forEach;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileDrop, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		
		        function FileDrop(options) {
		            _classCallCheck(this, FileDrop);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    drop: 'onDrop',
		                    dragover: 'onDragOver',
		                    dragleave: 'onDragLeave'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'drop'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileDrop.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileDrop.prototype.getFilters = function getFilters() {};
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDrop = function onDrop(event) {
		            var transfer = this._getTransfer(event);
		            if (!transfer) return;
		            var options = this.getOptions();
		            var filters = this.getFilters();
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		            this.uploader.addToQueue(transfer.files, options, filters);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragOver = function onDragOver(event) {
		            var transfer = this._getTransfer(event);
		            if (!this._haveFiles(transfer.types)) return;
		            transfer.dropEffect = 'copy';
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._addOverClass, this);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragLeave = function onDragLeave(event) {
		            if (event.currentTarget === this.element[0]) return;
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._getTransfer = function _getTransfer(event) {
		            return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._preventAndStop = function _preventAndStop(event) {
		            event.preventDefault();
		            event.stopPropagation();
		        };
		        /**
		         * Returns "true" if types contains files
		         * @param {Object} types
		         */
		
		
		        FileDrop.prototype._haveFiles = function _haveFiles(types) {
		            if (!types) return false;
		            if (types.indexOf) {
		                return types.indexOf('Files') !== -1;
		            } else if (types.contains) {
		                return types.contains('Files');
		            } else {
		                return false;
		            }
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._addOverClass = function _addOverClass(item) {
		            item.addOverClass();
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._removeOverClass = function _removeOverClass(item) {
		            item.removeOverClass();
		        };
		
		        return FileDrop;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular;
		var extend = _angular.extend;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileOver, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		
		        function FileOver(options) {
		            _classCallCheck(this, FileOver);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'over',
		                // Over class
		                overClass: 'nv-file-over'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Adds over class
		         */
		
		
		        FileOver.prototype.addOverClass = function addOverClass() {
		            this.element.addClass(this.getOverClass());
		        };
		        /**
		         * Removes over class
		         */
		
		
		        FileOver.prototype.removeOverClass = function removeOverClass() {
		            this.element.removeClass(this.getOverClass());
		        };
		        /**
		         * Returns over class
		         * @returns {String}
		         */
		
		
		        FileOver.prototype.getOverClass = function getOverClass() {
		            return this.overClass;
		        };
		
		        return FileOver;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileSelect) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileSelect({
		                uploader: uploader,
		                element: element,
		                scope: scope
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileSelect'];
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileDrop) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            if (!uploader.isHTML5) return;
		
		            var object = new FileDrop({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileDrop'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity(FileUploader, FileOver) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileOver({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOverClass = function () {
		                return attributes.overClass || object.overClass;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['FileUploader', 'FileOver'];
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=angular-file-upload.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/*! ngclipboard - v2.0.0 - 2018-03-03
	* https://github.com/sachinchoolur/ngclipboard
	* Copyright (c) 2018 Sachin; Licensed MIT */
	(function() {
	    'use strict';
	    var MODULE_NAME = 'ngclipboard';
	    var angular, ClipboardJS;
	
	    // Check for CommonJS support
	    if (typeof module === 'object' && module.exports) {
	      angular = __webpack_require__(132);
	      ClipboardJS = __webpack_require__(143);
	      module.exports = MODULE_NAME;
	    } else {
	      angular = window.angular;
	      ClipboardJS = window.ClipboardJS;
	    }
	
	    angular.module(MODULE_NAME, []).directive('ngclipboard', function() {
	        return {
	            restrict: 'A',
	            scope: {
	                ngclipboardSuccess: '&',
	                ngclipboardError: '&'
	            },
	            link: function(scope, element) {
	                //constructor for clipboardjs changed to ClipboardJS
	                var clipboard = new ClipboardJS(element[0]);
	
	                clipboard.on('success', function(e) {
	                  scope.$apply(function () {
	                    scope.ngclipboardSuccess({
	                      e: e
	                    });
	                  });
	                });
	
	                clipboard.on('error', function(e) {
	                  scope.$apply(function () {
	                    scope.ngclipboardError({
	                      e: e
	                    });
	                  });
	                });
	
	                element.on('$destroy', function() {
	                    clipboard.destroy();
	                });
	
	            }
	        };
	    });
	})();


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * clipboard.js v2.0.8
	 * https://clipboardjs.com/
	 *
	 * Licensed MIT © Zeno Rocha
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["ClipboardJS"] = factory();
		else
			root["ClipboardJS"] = factory();
	})(this, function() {
	return /******/ (function() { // webpackBootstrap
	/******/ 	var __webpack_modules__ = ({
	
	/***/ 134:
	/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": function() { return /* binding */ clipboard; }
	});
	
	// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
	var tiny_emitter = __webpack_require__(279);
	var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
	// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
	var listen = __webpack_require__(370);
	var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
	// EXTERNAL MODULE: ./node_modules/select/src/select.js
	var src_select = __webpack_require__(817);
	var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
	;// CONCATENATED MODULE: ./src/clipboard-action.js
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	
	/**
	 * Inner class which performs selection from either `text` or `target`
	 * properties and then executes copy or cut operations.
	 */
	
	var ClipboardAction = /*#__PURE__*/function () {
	  /**
	   * @param {Object} options
	   */
	  function ClipboardAction(options) {
	    _classCallCheck(this, ClipboardAction);
	
	    this.resolveOptions(options);
	    this.initSelection();
	  }
	  /**
	   * Defines base properties passed from constructor.
	   * @param {Object} options
	   */
	
	
	  _createClass(ClipboardAction, [{
	    key: "resolveOptions",
	    value: function resolveOptions() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      this.action = options.action;
	      this.container = options.container;
	      this.emitter = options.emitter;
	      this.target = options.target;
	      this.text = options.text;
	      this.trigger = options.trigger;
	      this.selectedText = '';
	    }
	    /**
	     * Decides which selection strategy is going to be applied based
	     * on the existence of `text` and `target` properties.
	     */
	
	  }, {
	    key: "initSelection",
	    value: function initSelection() {
	      if (this.text) {
	        this.selectFake();
	      } else if (this.target) {
	        this.selectTarget();
	      }
	    }
	    /**
	     * Creates a fake textarea element, sets its value from `text` property,
	     */
	
	  }, {
	    key: "createFakeElement",
	    value: function createFakeElement() {
	      var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
	      this.fakeElem = document.createElement('textarea'); // Prevent zooming on iOS
	
	      this.fakeElem.style.fontSize = '12pt'; // Reset box model
	
	      this.fakeElem.style.border = '0';
	      this.fakeElem.style.padding = '0';
	      this.fakeElem.style.margin = '0'; // Move element out of screen horizontally
	
	      this.fakeElem.style.position = 'absolute';
	      this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically
	
	      var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	      this.fakeElem.style.top = "".concat(yPosition, "px");
	      this.fakeElem.setAttribute('readonly', '');
	      this.fakeElem.value = this.text;
	      return this.fakeElem;
	    }
	    /**
	     * Get's the value of fakeElem,
	     * and makes a selection on it.
	     */
	
	  }, {
	    key: "selectFake",
	    value: function selectFake() {
	      var _this = this;
	
	      var fakeElem = this.createFakeElement();
	
	      this.fakeHandlerCallback = function () {
	        return _this.removeFake();
	      };
	
	      this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
	      this.container.appendChild(fakeElem);
	      this.selectedText = select_default()(fakeElem);
	      this.copyText();
	      this.removeFake();
	    }
	    /**
	     * Only removes the fake element after another click event, that way
	     * a user can hit `Ctrl+C` to copy because selection still exists.
	     */
	
	  }, {
	    key: "removeFake",
	    value: function removeFake() {
	      if (this.fakeHandler) {
	        this.container.removeEventListener('click', this.fakeHandlerCallback);
	        this.fakeHandler = null;
	        this.fakeHandlerCallback = null;
	      }
	
	      if (this.fakeElem) {
	        this.container.removeChild(this.fakeElem);
	        this.fakeElem = null;
	      }
	    }
	    /**
	     * Selects the content from element passed on `target` property.
	     */
	
	  }, {
	    key: "selectTarget",
	    value: function selectTarget() {
	      this.selectedText = select_default()(this.target);
	      this.copyText();
	    }
	    /**
	     * Executes the copy operation based on the current selection.
	     */
	
	  }, {
	    key: "copyText",
	    value: function copyText() {
	      var succeeded;
	
	      try {
	        succeeded = document.execCommand(this.action);
	      } catch (err) {
	        succeeded = false;
	      }
	
	      this.handleResult(succeeded);
	    }
	    /**
	     * Fires an event based on the copy operation result.
	     * @param {Boolean} succeeded
	     */
	
	  }, {
	    key: "handleResult",
	    value: function handleResult(succeeded) {
	      this.emitter.emit(succeeded ? 'success' : 'error', {
	        action: this.action,
	        text: this.selectedText,
	        trigger: this.trigger,
	        clearSelection: this.clearSelection.bind(this)
	      });
	    }
	    /**
	     * Moves focus away from `target` and back to the trigger, removes current selection.
	     */
	
	  }, {
	    key: "clearSelection",
	    value: function clearSelection() {
	      if (this.trigger) {
	        this.trigger.focus();
	      }
	
	      document.activeElement.blur();
	      window.getSelection().removeAllRanges();
	    }
	    /**
	     * Sets the `action` to be performed which can be either 'copy' or 'cut'.
	     * @param {String} action
	     */
	
	  }, {
	    key: "destroy",
	
	    /**
	     * Destroy lifecycle.
	     */
	    value: function destroy() {
	      this.removeFake();
	    }
	  }, {
	    key: "action",
	    set: function set() {
	      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	      this._action = action;
	
	      if (this._action !== 'copy' && this._action !== 'cut') {
	        throw new Error('Invalid "action" value, use either "copy" or "cut"');
	      }
	    }
	    /**
	     * Gets the `action` property.
	     * @return {String}
	     */
	    ,
	    get: function get() {
	      return this._action;
	    }
	    /**
	     * Sets the `target` property using an element
	     * that will be have its content copied.
	     * @param {Element} target
	     */
	
	  }, {
	    key: "target",
	    set: function set(target) {
	      if (target !== undefined) {
	        if (target && _typeof(target) === 'object' && target.nodeType === 1) {
	          if (this.action === 'copy' && target.hasAttribute('disabled')) {
	            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	          }
	
	          if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	          }
	
	          this._target = target;
	        } else {
	          throw new Error('Invalid "target" value, use a valid Element');
	        }
	      }
	    }
	    /**
	     * Gets the `target` property.
	     * @return {String|HTMLElement}
	     */
	    ,
	    get: function get() {
	      return this._target;
	    }
	  }]);
	
	  return ClipboardAction;
	}();
	
	/* harmony default export */ var clipboard_action = (ClipboardAction);
	;// CONCATENATED MODULE: ./src/clipboard.js
	function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }
	
	function clipboard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function clipboard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function clipboard_createClass(Constructor, protoProps, staticProps) { if (protoProps) clipboard_defineProperties(Constructor.prototype, protoProps); if (staticProps) clipboard_defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	
	
	
	/**
	 * Helper function to retrieve attribute value.
	 * @param {String} suffix
	 * @param {Element} element
	 */
	
	function getAttributeValue(suffix, element) {
	  var attribute = "data-clipboard-".concat(suffix);
	
	  if (!element.hasAttribute(attribute)) {
	    return;
	  }
	
	  return element.getAttribute(attribute);
	}
	/**
	 * Base class which takes one or more elements, adds event listeners to them,
	 * and instantiates a new `ClipboardAction` on each click.
	 */
	
	
	var Clipboard = /*#__PURE__*/function (_Emitter) {
	  _inherits(Clipboard, _Emitter);
	
	  var _super = _createSuper(Clipboard);
	
	  /**
	   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	   * @param {Object} options
	   */
	  function Clipboard(trigger, options) {
	    var _this;
	
	    clipboard_classCallCheck(this, Clipboard);
	
	    _this = _super.call(this);
	
	    _this.resolveOptions(options);
	
	    _this.listenClick(trigger);
	
	    return _this;
	  }
	  /**
	   * Defines if attributes would be resolved using internal setter functions
	   * or custom functions that were passed in the constructor.
	   * @param {Object} options
	   */
	
	
	  clipboard_createClass(Clipboard, [{
	    key: "resolveOptions",
	    value: function resolveOptions() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
	    }
	    /**
	     * Adds a click event listener to the passed trigger.
	     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	     */
	
	  }, {
	    key: "listenClick",
	    value: function listenClick(trigger) {
	      var _this2 = this;
	
	      this.listener = listen_default()(trigger, 'click', function (e) {
	        return _this2.onClick(e);
	      });
	    }
	    /**
	     * Defines a new `ClipboardAction` on each click event.
	     * @param {Event} e
	     */
	
	  }, {
	    key: "onClick",
	    value: function onClick(e) {
	      var trigger = e.delegateTarget || e.currentTarget;
	
	      if (this.clipboardAction) {
	        this.clipboardAction = null;
	      }
	
	      this.clipboardAction = new clipboard_action({
	        action: this.action(trigger),
	        target: this.target(trigger),
	        text: this.text(trigger),
	        container: this.container,
	        trigger: trigger,
	        emitter: this
	      });
	    }
	    /**
	     * Default `action` lookup function.
	     * @param {Element} trigger
	     */
	
	  }, {
	    key: "defaultAction",
	    value: function defaultAction(trigger) {
	      return getAttributeValue('action', trigger);
	    }
	    /**
	     * Default `target` lookup function.
	     * @param {Element} trigger
	     */
	
	  }, {
	    key: "defaultTarget",
	    value: function defaultTarget(trigger) {
	      var selector = getAttributeValue('target', trigger);
	
	      if (selector) {
	        return document.querySelector(selector);
	      }
	    }
	    /**
	     * Returns the support of the given action, or all actions if no action is
	     * given.
	     * @param {String} [action]
	     */
	
	  }, {
	    key: "defaultText",
	
	    /**
	     * Default `text` lookup function.
	     * @param {Element} trigger
	     */
	    value: function defaultText(trigger) {
	      return getAttributeValue('text', trigger);
	    }
	    /**
	     * Destroy lifecycle.
	     */
	
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.listener.destroy();
	
	      if (this.clipboardAction) {
	        this.clipboardAction.destroy();
	        this.clipboardAction = null;
	      }
	    }
	  }], [{
	    key: "isSupported",
	    value: function isSupported() {
	      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
	      var actions = typeof action === 'string' ? [action] : action;
	      var support = !!document.queryCommandSupported;
	      actions.forEach(function (action) {
	        support = support && !!document.queryCommandSupported(action);
	      });
	      return support;
	    }
	  }]);
	
	  return Clipboard;
	}((tiny_emitter_default()));
	
	/* harmony default export */ var clipboard = (Clipboard);
	
	/***/ }),
	
	/***/ 828:
	/***/ (function(module) {
	
	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (typeof element.matches === 'function' &&
	            element.matches(selector)) {
	          return element;
	        }
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;
	
	
	/***/ }),
	
	/***/ 438:
	/***/ (function(module, __unused_webpack_exports, __webpack_require__) {
	
	var closest = __webpack_require__(828);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function _delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element|String|Array} [elements]
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(elements, selector, type, callback, useCapture) {
	    // Handle the regular Element usage
	    if (typeof elements.addEventListener === 'function') {
	        return _delegate.apply(null, arguments);
	    }
	
	    // Handle Element-less usage, it defaults to global delegation
	    if (typeof type === 'function') {
	        // Use `document` as the first parameter, then apply arguments
	        // This is a short way to .unshift `arguments` without running into deoptimizations
	        return _delegate.bind(null, document).apply(null, arguments);
	    }
	
	    // Handle Selector-based usage
	    if (typeof elements === 'string') {
	        elements = document.querySelectorAll(elements);
	    }
	
	    // Handle Array-like based usage
	    return Array.prototype.map.call(elements, function (element) {
	        return _delegate(element, selector, type, callback, useCapture);
	    });
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;
	
	
	/***/ }),
	
	/***/ 879:
	/***/ (function(__unused_webpack_module, exports) {
	
	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};
	
	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};
	
	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};
	
	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return type === '[object Function]';
	};
	
	
	/***/ }),
	
	/***/ 370:
	/***/ (function(module, __unused_webpack_exports, __webpack_require__) {
	
	var is = __webpack_require__(879);
	var delegate = __webpack_require__(438);
	
	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }
	
	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }
	
	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }
	
	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}
	
	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);
	
	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}
	
	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });
	
	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}
	
	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}
	
	module.exports = listen;
	
	
	/***/ }),
	
	/***/ 817:
	/***/ (function(module) {
	
	function select(element) {
	    var selectedText;
	
	    if (element.nodeName === 'SELECT') {
	        element.focus();
	
	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        var isReadOnly = element.hasAttribute('readonly');
	
	        if (!isReadOnly) {
	            element.setAttribute('readonly', '');
	        }
	
	        element.select();
	        element.setSelectionRange(0, element.value.length);
	
	        if (!isReadOnly) {
	            element.removeAttribute('readonly');
	        }
	
	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	
	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);
	
	        selectedText = selection.toString();
	    }
	
	    return selectedText;
	}
	
	module.exports = select;
	
	
	/***/ }),
	
	/***/ 279:
	/***/ (function(module) {
	
	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;
	module.exports.TinyEmitter = E;
	
	
	/***/ })
	
	/******/ 	});
	/************************************************************************/
	/******/ 	// The module cache
	/******/ 	var __webpack_module_cache__ = {};
	/******/ 	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/ 		// Check if module is in cache
	/******/ 		if(__webpack_module_cache__[moduleId]) {
	/******/ 			return __webpack_module_cache__[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = __webpack_module_cache__[moduleId] = {
	/******/ 			// no module.id needed
	/******/ 			// no module.loaded needed
	/******/ 			exports: {}
	/******/ 		};
	/******/ 	
	/******/ 		// Execute the module function
	/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
	/******/ 	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/ 	
	/************************************************************************/
	/******/ 	/* webpack/runtime/compat get default export */
	/******/ 	!function() {
	/******/ 		// getDefaultExport function for compatibility with non-harmony modules
	/******/ 		__webpack_require__.n = function(module) {
	/******/ 			var getter = module && module.__esModule ?
	/******/ 				function() { return module['default']; } :
	/******/ 				function() { return module; };
	/******/ 			__webpack_require__.d(getter, { a: getter });
	/******/ 			return getter;
	/******/ 		};
	/******/ 	}();
	/******/ 	
	/******/ 	/* webpack/runtime/define property getters */
	/******/ 	!function() {
	/******/ 		// define getter functions for harmony exports
	/******/ 		__webpack_require__.d = function(exports, definition) {
	/******/ 			for(var key in definition) {
	/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
	/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
	/******/ 				}
	/******/ 			}
	/******/ 		};
	/******/ 	}();
	/******/ 	
	/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
	/******/ 	!function() {
	/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
	/******/ 	}();
	/******/ 	
	/************************************************************************/
	/******/ 	// module exports must be returned from runtime so entry inlining is disabled
	/******/ 	// startup
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(134);
	/******/ })()
	.default;
	});

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var adminMenu = [{
	  title: "用户",
	  state: "user"
	}, {
	  title: "搜索",
	  state: "search"
	}, {
	  title: "调研模板",
	  state: "survey"
	}, {
	  title: "用户反馈",
	  state: "feedback"
	}, {
	  title: "版本",
	  state: "multiplication"
	}, {
	  title: "笔记",
	  state: "notebook"
	}, {
	  title: "高亮",
	  state: "highlight"
	}, {
	  title: "书签",
	  state: "mark"
	}, {
	  title: "葡语语音类型",
	  state: "speechtype"
	}, {
	  title: "葡语语音基本信息",
	  state: "speechprofile"
	}, {
	  title: "葡语语音专辑",
	  state: "speechdetails"
	}, {
	  title: "英语语音类型",
	  state: "speechtypeen"
	}, {
	  title: "英语语音基本信息",
	  state: "speechprofileen"
	}, {
	  title: "英语语音专辑",
	  state: "speechdetailsen"
	}, {
	  title: "西语语音类型",
	  state: "speechtypees"
	}, {
	  title: "西语语音基本信息",
	  state: "speechprofilees"
	}, {
	  title: "西语语音专辑",
	  state: "speechdetailses"
	}, {
	  title: "支付订单",
	  state: "paysub"
	}, {
	  title: "广告支付订单",
	  state: "adsub"
	}, {
	  title: "分享链接",
	  state: "sharelink"
	}, {
	  title: "推送数据",
	  state: "pushtoken"
	}, {
	  title: "推送设置列表",
	  state: "custom"
	}, {
	  title: "每日一句",
	  state: "oneday"
	}, {
	  title: "信息流",
	  state: "new"
	}, {
	  title: "积分兑换设置",
	  state: "setpoint"
	}, {
	  title: "ios统计数据导出",
	  state: "iosdata"
	}, {
	  title: "分享图片上传",
	  state: "shareimg"
	}, {
	  title: "计划类型",
	  state: "plantype"
	}, {
	  title: "广告管理",
	  state: "admanage"
	}, {
	  title: "邮件编辑器",
	  state: "emaileditor"
	}, {
	  title: "故事",
	  state: "story"
	}, {
	  title: "故事统计",
	  state: "storyStat"
	}, {
	  title: "默认广告投放",
	  state: "adDefaults"
	}, {
	  title: "默认广告投放（视频）",
	  state: "adDefaultsVideo"
	}, {
	  title: "默认广告投放统计",
	  state: "adDefaultStat"
	}, {
	  title: "☀广告聚合",
	  state: "ad-aggregation"
	}, {
	  title: "☀Quiz",
	  state: "quiz"
	}, {
	  title: "☀应用开关",
	  state: "app-switch"
	}, {
	  title: "☀图片中心-通用",
	  state: "common-images-center"
	}, {
	  title: "用户举报",
	  state: "complaint"
	}, {
	  title: "读想祷配置",
	  state: "uba"
	}];
	
	
	var notAdminMenu = [{
	  title: "用户",
	  state: "user"
	}, {
	  title: "用户反馈",
	  state: "feedback"
	}, {
	  title: "故事",
	  state: "story"
	}, {
	  title: "故事统计",
	  state: "storyStat"
	}];
	
	var feedback = [{
	  title: "用户反馈",
	  state: "feedback"
	}, {
	  title: "读想祷配置",
	  state: "uba"
	}];
	
	var NavbarComponent = exports.NavbarComponent = function () {
	  /*@ngInject*/
	  NavbarComponent.$inject = ['$rootScope', '$http', '$cookies', '$location'];
	  function NavbarComponent($rootScope, $http, $cookies, $location) {
	    _classCallCheck(this, NavbarComponent);
	
	    this.menu = [];
	    this.isCollapsed = true;
	
	    this.$http = $http;
	    this.$rootScope = $rootScope;
	    this.$cookies = $cookies;
	    this.$location = $location;
	  }
	
	  _createClass(NavbarComponent, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.$rootScope.$on("changeAccount", function () {
	        _this.role();
	      });
	
	      this.role();
	    }
	  }, {
	    key: "role",
	    value: function role() {
	      var that = this;
	      this.$http.get("/api/backstages/me", {
	        header: {
	          Accept: "application/json",
	          "Content-Type": "application/json",
	          token: this.$cookies.get("token")
	        }
	      }).then(function (data) {
	        console.log("data.data.role: " + data.data.role);
	        if (data && data.data) {
	          if (data.data.role === "feedback") {
	            that.menu = feedback;
	            return;
	          } else if (data.data.role !== "admin") {
	            that.menu = notAdminMenu;
	            return;
	          }
	        }
	        that.menu = adminMenu;
	      }).catch(function () {
	        that.menu = adminMenu;
	      });
	    }
	  }, {
	    key: "loginOut",
	    value: function loginOut() {
	      this.menu = [];
	      this.$cookies.remove("token");
	      this.$location.path("main");
	    }
	  }]);
	
	  return NavbarComponent;
	}();
	
	exports.default = _angular2.default.module("directives.navbar", []).component("navbar", {
	  template: __webpack_require__(149),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar navbar-default navbar-static-top\" ng-if=\"$ctrl.$rootScope.islogin\">\n    <div class=\"container\">\n        <div class=\"navbar-header\">\n            <button class=\"navbar-toggle\" type=\"button\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">\n                <span class=\"sr-only\">Toggle navigation</span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n            <a class=\"navbar-brand\">BibliaManage</a>\n        </div>\n        <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\n            <ul class=\"nav navbar-nav\">\n                <li ng-repeat=\"item in $ctrl.menu\" ui-sref-active=\"active\">\n                    <a ui-sref=\"{{item.state}}\">{{item.title}}</a>\n                </li>\n                <li ui-sref-active=\"active\">\n                    <a href=\"javascript:void(0)\" ng-click=\"$ctrl.loginOut()\">退出登录</a>\n                </li>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function FooterComponent() {
	  _classCallCheck(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(151),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = "<!--<div class=\"container\">-->\n  <!--<p>Angular Fullstack v4.2.3 |-->\n    <!--<a href=\"http://angular-fullstack.github.io/\">Documentation</a> |-->\n    <!--<a href=\"https://gitter.im/DaftMonk/generator-angular-fullstack\">Chat on Gitter</a> |-->\n    <!--<a href=\"https://github.com/angular-fullstack/generator-angular-fullstack/issues?state=open\">Issues</a> |-->\n    <!--<a href=\"https://opencollective.com/angular-fullstack\">Donate to our Open Collective</a>-->\n  <!--</p>-->\n<!--</div>-->\n"

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(153);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _add = __webpack_require__(154);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	  /*@ngInject*/
	  MainController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location', '$rootScope'];
	  function MainController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $rootScope) {
	    _classCallCheck(this, MainController);
	
	    this.awesomeThings = [];
	    this.awesomeUsers = [];
	    this.newThing = "";
	
	    this.$http = $http;
	    this.socket = socket;
	    this.$uibModal = $uibModal;
	    this.$cookies = $cookies;
	    this.$cookieStore = $cookieStore;
	    this.$location = $location;
	    this.$rootScope = $rootScope;
	
	    $scope.$on("$destroy", function () {
	      socket.unsyncUpdates("thing");
	    });
	  }
	
	  _createClass(MainController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      if (this.$cookies.get("token")) {
	        this.$location.path("user");
	      }
	    }
	  }, {
	    key: "login",
	    value: function login(form) {
	      var _this = this;
	
	      if (form.$valid === false) {
	        return false;
	      } else {
	        this.$http.post("/api/backstages/", this.vm2).then(function (response) {
	          if (response.status === 200) {
	            var expireDate = new Date();
	            expireDate.setTime(expireDate.getTime() + 30 * 24 * 60 * 60 * 1000);
	            _this.$cookies.put("token", response.data.token, {
	              expires: new Date(expireDate)
	            });
	
	            return _this.$http.get("/api/backstages/me", {
	              header: {
	                Accept: "application/json",
	                "Content-Type": "application/json",
	                token: _this.$cookies.get("token")
	              }
	            }).then(function (data) {
	              if (data && data.data) {
	                if (data.data.role === "feedback") {
	                  _this.$location.path("feedback");
	                  _this.$rootScope.$emit("changeAccount");
	                  return;
	                }
	              }
	
	              _this.$location.path("user");
	              _this.$rootScope.$emit("changeAccount");
	            });
	          }
	        }, function (error) {
	          console.log(error);
	        });
	      }
	    }
	  }]);
	
	  return MainController;
	}();
	
	exports.default = _angular2.default.module("tttApp.main", [_angularUiRouter2.default]).config(_main2.default).component("main", {
	  template: __webpack_require__(155),
	  controller: MainController
	}).name;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    template: '<main></main>'
	  });
	}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">注册<span class=\"text-danger\" >{{EXIT}}</span></h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" >\n  <form name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n    <div class=\"row\">\n      <div class=\"form-group col-sm-3\">\n        <label><span class=\"text-danger\">*</span>用户名</label>\n        <input type=\"text\" class=\"form-control\"  ng-model=\"vm.user_name\" name=\"user_name\" required\n               placeholder=\"用户名\">\n        <span class=\"text-danger\" ng-if=\"myForm.user_name.$error.required && myForm.$submitted==true\">必填项</span>\n      </div>\n\n\n      <div class=\"form-group col-sm-3\">\n        <label>邮箱</label>\n        <input type=\"email\" class=\"form-control\" ng-model=\"vm.email\" name=\"email\" placeholder=\"邮箱\" required>\n        <span class=\"text-danger\" ng-if=\"myForm.email.$error.email && myForm.$submitted==true\">填写正确的邮箱</span>\n        <span class=\"text-danger\" ng-if=\"myForm.email.$error.required && myForm.$submitted==true\">必填项</span>\n\n      </div>\n\n      <div class=\"form-group col-sm-3\">\n        <label><span class=\"text-danger\">*</span>密码</label>\n        <input type=\"password\" class=\"form-control\"  ng-model=\"vm.password\" name=\"password\" required\n               placeholder=\"密码\">\n        <span class=\"text-danger\" ng-if=\"myForm.password.$error.required && myForm.$submitted==true\">必填项</span>\n      </div>\n\n\n\n    </div>\n\n    <div class=\"row\">\n      <div class=\"form-group col-sm-12 text-center\" style=\"margin-top: 20px;\">\n        <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\" style=\"border-top: none;\"></div>\n  </form>\n</div>\n"

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	module.exports = "<header  id=\"banner\">\n  <!--class=\"hero-unit\"-->\n  <div class=\"container\">\n    <div class=\"form row\">\n      <form name=\"myForm\" ng-submit=\"$ctrl.login(myForm)\" novalidate class=\"form-horizontal col-sm-offset-3 col-md-offset-3\" id=\"login_form\">\n        <h3 class=\"form-title\">Login to your account</h3>\n        <div class=\"col-sm-9 col-md-9\">\n          <div class=\"form-group\">\n            <i class=\"fa fa-user fa-lg\"></i>\n            <input class=\"form-control required\" type=\"text\" ng-model=\"$ctrl.vm2.name\" placeholder=\"Username\" name=\"name\" autofocus=\"autofocus\" maxlength=\"20\" required/>\n            <span class=\"text-danger\" ng-if=\"myForm.name.$error.required && myForm.$submitted==true\">Please enter your account</span>\n          </div>\n          <div class=\"form-group\">\n            <i class=\"fa fa-lock fa-lg\"></i>\n            <input class=\"form-control required\" type=\"password\" ng-model=\"$ctrl.vm2.password\" placeholder=\"Password\" name=\"password\"  required/>\n            <span class=\"text-danger\" ng-if=\"myForm.password.$error.required && myForm.$submitted==true\">Please enter your password</span>\n          </div>\n          <!--<div class=\"form-group\">-->\n            <!--<label class=\"checkbox\">-->\n              <!--<input type=\"checkbox\" name=\"remember\" value=\"1\"/> Remember me-->\n            <!--</label>-->\n            <!--<hr />-->\n            <!--<a href=\"javascript:;\" id=\"register_btn\" class=\"\">Create an account</a>-->\n          <!--</div>-->\n          <div class=\"form-group text-center\">\n            <input type=\"submit\" class=\"btn btn-success\" value=\"Login \"/>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n  <!--<div class=\"row\">-->\n    <!--<div class=\"col-lg-12\">-->\n      <!--<h1 class=\"page-header\">Features:</h1>-->\n      <!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n        <!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n      <!--</ul>-->\n    <!--</div>-->\n  <!--</div>-->\n\n  <!--<form class=\"thing-form\">-->\n    <!--<label>Syncs in realtime across clients</label>-->\n    <!--<p class=\"input-group\">-->\n      <!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n      <!--<span class=\"input-group-btn\">-->\n        <!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n      <!--</span>-->\n    <!--</p>-->\n  <!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UserController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _user = __webpack_require__(157);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _add = __webpack_require__(158);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _review = __webpack_require__(159);
	
	var _review2 = _interopRequireDefault(_review);
	
	var _maximage = __webpack_require__(160);
	
	var _maximage2 = _interopRequireDefault(_maximage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserController = exports.UserController = function () {
	
	    /*@ngInject*/
	    UserController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location', '$timeout', '$rootScope'];
	    function UserController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout, $rootScope) {
	        _classCallCheck(this, UserController);
	
	        this.awesomeThings = [];
	        this.awesomeUsers = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	        this.$timeout = $timeout;
	        this.$rootScope = $rootScope;
	
	        this.reviewStatus = [{ value: 0, name: '待审核' }, { value: 1, name: '审核驳回' }, { value: 2, name: '审核通过' }];
	
	        this.loginType = [{ value: 'email', name: 'email' }, { value: 'google', name: 'google' }, { value: 'fb', name: 'fb' }, { value: 'apple', name: 'apple' }];
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('thing');
	        });
	    }
	
	    _createClass(UserController, [{
	        key: 'TransformationStatus',
	        value: function TransformationStatus(value) {
	            var ret = _.find(this.reviewStatus, { value: value });
	            if (ret) {
	                return ret.name;
	            }
	            return '';
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/users/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _angular2.default.forEach(response.data.data, function (item) {
	                            if (item.images && item.images.indexOf('http') === -1) {
	                                item.images = 'https://www.bibliagratis.mobi' + item.images;
	                            }
	                        });
	
	                        _this.awesomeUsers = response.data.data;
	                        _this.socket.syncUpdates('user', _this.awesomeUsers);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	            if (val === true && payload.user_id) {
	                payload.user_id = parseInt(payload.user_id, 10);
	            }
	
	            if (val === true && payload.status) {
	                payload.status = parseInt(payload.status, 10);
	            }
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/users/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _angular2.default.forEach(response.data.data, function (item) {
	                            if (item.images && item.images.indexOf('http') === -1) {
	                                item.images = 'https://www.bibliagratis.mobi' + item.images;
	                            }
	                        });
	                        _this2.awesomeUsers = response.data.data;
	                        _this2.socket.syncUpdates('user', _this2.awesomeUsers);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'getImage',
	        value: function getImage(images) {
	            this.$uibModal.open({
	                template: _maximage2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.maxImage = images;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'exprotExcel',
	        value: function exprotExcel() {
	            var _this3 = this;
	
	            this.$http.get('/api/users/1/1/', {}).then(function (response) {
	                if (response.status === 200) {
	                    console.log(response.data.data);
	                    _this3.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }, {
	        key: 'review',
	        value: function review(user, index) {
	            var awesomeUsers = this.awesomeUsers;
	            this.$uibModal.open({
	                template: _review2.default,
	                size: 'sm',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.ok = function (status) {
	                        var s = parseInt(status, 10);
	                        $http.put('/api/users/' + user.user_id + '/' + s + '/', {}).then(function (response) {
	                            if (response.status === 200) {
	                                $uibModalInstance.close(response.data.data);
	                            }
	                        }, function (error) {
	                            console.log(error);
	                        });
	                    };
	                    $scope.cancel = function (status) {
	                        var s = parseInt(status, 10);
	                        $http.put('/api/users/' + user.user_id + '/' + s + '/', {}).then(function (response) {
	                            if (response.status === 200) {
	                                $uibModalInstance.close(response.data.data);
	                            }
	                        }, function (error) {
	                            console.log(error);
	                        });
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    awesomeUsers[index]['status'] = ret.status;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'addUser',
	        value: function addUser() {
	            var awesomeThings = this.awesomeThings;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/users', $scope.vm).then(function (response) {
	                                console.log(response);
	                                $uibModalInstance.close(response);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {}
	            }, function () {});
	        }
	    }, {
	        key: 'deleteUser',
	        value: function deleteUser(user, index) {
	            var _this4 = this;
	
	            this.$http.delete('/api/users/' + user.user_id).then((function (response) {
	                console.log(response);
	                if (response.status === 204) {
	                    _this4.awesomeUsers.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            }));
	        }
	    }]);
	
	    return UserController;
	}();
	
	exports.default = _angular2.default.module('tttApp.user', [_angularUiRouter2.default]).config(_user2.default).component('user', {
	    template: __webpack_require__(161),
	    controller: UserController
	}).name;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('user', {
	    url: '/user',
	    template: '<user></user>'
	  });
	}

/***/ }),
/* 158 */
154,
/* 159 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">审核</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>是否审核通过？</p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok(2)\">是</button>\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">否</button>\n</div>\n"

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">大图</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>\n        <img width=\"320\" height=\"320\" src=\"{{maxImage}}\" />\n    </p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">关闭</button>\n</div>\n"

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">用户列表</h3>\n            </div>\n\n            <div class=\"panel-body\">\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.user_id\"\n                            placeholder=\"请输入用户ID\">\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.user_name\"\n                            placeholder=\"请输入用户名称\">\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.email\"\n                            placeholder=\"请输入用户邮箱\">\n                    </div>\n\n                    <div class=\"col-sm-2\">\n                        <select name=\"login_type\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.login_type\"\n                            ng-options=\"type.value as type.name for type in $ctrl.loginType\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">请选择注册来源</option>\n                        </select>\n                    </div>\n\n                    <div class=\"col-sm-2\">\n                        <select name=\"review_status\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.status\"\n                            ng-options=\"review.value as review.name for review in $ctrl.reviewStatus\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">请选择审核状态</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.user_id\">\n                            用户id:{{$ctrl.filters.user_id}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.user_id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.user_name\">\n                            用户名称:{{$ctrl.filters.user_name}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.user_name=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.email\">\n                            email:{{$ctrl.filters.email}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.email=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.login_type\">\n                            注册来源:{{$ctrl.filters.login_type}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.login_type=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                        <label class=\"criterion btn-primary\"\n                            ng-if=\"$ctrl.filters.status || $ctrl.filters.status === 0 \">\n                            审核状态:{{$ctrl.TransformationStatus($ctrl.filters.status)}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.status=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                    </div>\n                </div>\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"10\">\n                                <code style=\"text-align: right\">用户总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"2\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.exprotExcel()\">导出EXCEL</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>user_id</td>\n                            <td>用户名</td>\n                            <td>Email</td>\n                            <td>用户头像</td>\n                            <!-- <td>PID</td> -->\n                            <td>设备ID</td>\n                            <td>来源</td>\n                            <td>系统版本</td>\n                            <td>app版本</td>\n                            <td>国家</td>\n                            <td>设备</td>\n                            <td colspan=\"2\">操作</td>\n                        </tr>\n                        <tr ng-repeat=\"user in $ctrl.awesomeUsers track by $index\">\n                            <td>\n                                {{user.user_id}}\n                            </td>\n                            <td>\n                                {{user.user_name}}\n                            </td>\n                            <td>\n                                {{user.email}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" ng-click=\"$ctrl.getImage(user.images)\"\n                                    src=\"{{user.images || '/assets/personal.png'}}\" />\n                                <!-- <a target=\"_blank\" ng-href=\"{{user.images}}\" class=\"glyphicon glyphicon-new-window\"\n                                aria-hidden=\"true\"></a> -->\n                            </td>\n                            <!-- <td>\n                                {{user.pid}}\n                            </td> -->\n                            <td>\n                                {{user.device_id}}\n                            </td>\n                            <td>\n                                {{user.login_type === 'local' ? 'email' : user.login_type}}\n                            </td>\n                            <td>\n                                {{user.os_version}}\n                            </td>\n                            <td>\n                                {{user.app_version}}\n                            </td>\n                            <td>\n                                {{user.country}}\n                            </td>\n                            <td>\n                                {{user.brand}}\n                            </td>\n                            <!-- <td>\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteUser(user, $index)\">删除</button>\n\n                            </td> -->\n                            <td>\n\n                                <button ng-if=\"user.status === 0\" type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.review(user, $index)\">待审核</button>\n                                <button ng-if=\"user.status === 1\" type=\" button\" class=\"btn btn-danger\"\n                                    disabled>审核驳回</button>\n                                <button ng-if=\"user.status === 2 \" type=\"button\" class=\"btn btn-success\"\n                                    disabled>已通过</button>\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SearchController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _search = __webpack_require__(163);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _add = __webpack_require__(164);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SearchController = exports.SearchController = function () {
	
	    /*@ngInject*/
	    SearchController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SearchController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SearchController);
	
	        this.awesomeThings = [];
	        this.searchs = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SearchController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/searchs/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.searchs = response.data.data;
	                        _this.socket.syncUpdates('search', _this.searchs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this2 = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/searchs/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': this.currentPage - 1,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.searchs = response.data.data;
	
	                        _this2.socket.syncUpdates('search', _this2.searchs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'deleteSearch',
	        value: function deleteSearch(search, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/searchs/' + search.search_id).then(function (response) {
	                if (response.status === 204) {
	                    _this3.searchs.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SearchController;
	}();
	
	exports.default = _angular2.default.module('tttApp.search', [_angularUiRouter2.default]).config(_search2.default).component('search', {
	    template: __webpack_require__(165),
	    controller: SearchController
	}).name;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('search', {
	    url: '/search',
	    template: '<search></search>'
	  });
	}

/***/ }),
/* 164 */
154,
/* 165 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">搜索结果列表</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <!--<tr>-->\n                        <!--<td colspan=\"5\" class=\"text-right\">-->\n                        <!--<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addUser()\">测试</button>-->\n                        <!--</td>-->\n                        <!--</tr>-->\n                        <tr>\n                            <td>user_id</td>\n                            <td>关键词</td>\n                            <td>设备ID</td>\n                            <td>提交时间</td>\n                            <td>语言</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"search in $ctrl.searchs track by $index\">\n                            <td>\n                                {{search.user_id}}\n                            </td>\n                            <td>\n                                {{search.key_words}}\n                            </td>\n                            <td>\n                                {{search.device_id}}\n                            </td>\n                            <td>\n                                {{search.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{search.language_type ? search.language_type: 'pt'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSearch(search, $index)\">删除</button>\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"6\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SurveyController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _survey = __webpack_require__(167);
	
	var _survey2 = _interopRequireDefault(_survey);
	
	var _add = __webpack_require__(168);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SurveyController = exports.SurveyController = function () {
	
	  /*@ngInject*/
	  SurveyController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	  function SurveyController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	    _classCallCheck(this, SurveyController);
	
	    this.awesomeThings = [];
	    this.surveys = [];
	    this.newThing = '';
	
	    this.$http = $http;
	    this.socket = socket;
	    this.$uibModal = $uibModal;
	    this.$cookies = $cookies;
	    this.$cookieStore = $cookieStore;
	    this.$location = $location;
	
	    $scope.$on('$destroy', function () {
	      socket.unsyncUpdates('survey');
	    });
	  }
	
	  _createClass(SurveyController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (this.$cookies.get('token')) {
	        this.$http.get('/api/surveys/', {
	          header: {
	            'Accept': 'application/json',
	            'Content-Type': 'application/json',
	            'token': this.$cookies.get('token')
	          }
	        }).then(function (response) {
	          if (response.data.data) {
	            _this.surveys = response.data.data;
	            _this.socket.syncUpdates('survey', _this.surveys);
	          }
	        });
	      } else {
	        this.$location.path('main');
	      }
	    }
	  }, {
	    key: 'deleteSurvey',
	    value: function deleteSurvey(survey, index) {
	      var _this2 = this;
	
	      this.$http.delete('/api/surveys/' + survey._id).then(function (response) {
	        if (response.status === 204) {
	          _this2.surveys.splice(index, 1);
	        }
	      }, function (error) {
	        console.log(error);
	      });
	    }
	  }, {
	    key: 'addSurvey',
	    value: function addSurvey() {
	      var surveys = this.surveys;
	      this.$uibModal.open({
	        template: _add2.default,
	        size: 'lg',
	        /*@ngInject*/
	        controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	          $scope.vm = {};
	          $scope.save = function (myForm) {
	            if (myForm.$valid === false) {
	              return false;
	            } else {
	              $http.post('/api/surveys', $scope.vm).then(function (response) {
	                console.log(response.data);
	                $uibModalInstance.close(response.data, response.add);
	              }, function (error) {
	                console.log(error);
	              });
	            }
	          };
	          $scope.cancel = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      }).result.then(function (ret, marks) {
	        if (ret && marks) {
	          surveys.push(ret);
	        }
	        if (ret && !marks) {
	          console.log(ret);
	          console.log(surveys[0]);
	          surveys[0].name = ret.data.name;
	          surveys[0].url = ret.data.url;
	        }
	      }, function () {});
	    }
	  }]);
	
	  return SurveyController;
	}();
	
	exports.default = _angular2.default.module('tttApp.survey', [_angularUiRouter2.default]).config(_survey2.default).component('survey', {
	  template: __webpack_require__(169),
	  controller: SurveyController
	}).name;

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('survey', {
	    url: '/survey',
	    template: '<survey></survey>'
	  });
	}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" >\n  <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n    <div class=\"form-group\">\n      <label  class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>name</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.name\" name=\"name\" required placeholder=\"name\">\n        <span class=\"text-danger\" ng-if=\"myForm.name.$error.required && myForm.$submitted==true\">必填项</span>      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <label  class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>URL</label>\n      <div class=\"col-sm-10\">\n        <input type=\"url\" class=\"form-control\" ng-model=\"vm.url\" name=\"url\" required placeholder=\"url\">\n        <span class=\"text-danger\" ng-if=\"myForm.url.$error.url && myForm.$submitted==true\">填写正确的链接</span>\n        <span class=\"text-danger\" ng-if=\"myForm.url.$error.required && myForm.$submitted==true\">必填项</span>\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n      </div>\n    </div>\n  </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = "<header  id=\"banner\">\n  <!--class=\"hero-unit\"-->\n  <div class=\"container-fluid\">\n    <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">用户调研</h3>\n      </div>\n      <div class=\"panel-body\">\n        <table class=\"table table-bordered\">\n          <tr>\n            <td colspan=\"5\" class=\"text-right\">\n              <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addSurvey()\">新增</button>\n            </td>\n          </tr>\n          <tr>\n            <td>ID</td>\n            <td>name</td>\n            <td>url</td>\n<!--            <td>操作</td>-->\n          </tr>\n          <tr ng-repeat=\"survey in $ctrl.surveys track by $index\">\n            <td>\n              {{$index+1}}\n            </td>\n            <td>\n              {{survey.name}}\n            </td>\n            <td>\n              <a target=\"_blank\" href=\"{{survey.url}}\">{{survey.url}}</a>\n            </td>\n<!--            <td class=\"text-center\">-->\n<!--              <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.deleteSurvey(survey,$index)\">删除</button>-->\n<!--            </td>-->\n          </tr>\n        </table>\n      </div>\n    </div>\n\n\n  </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n  <!--<div class=\"row\">-->\n    <!--<div class=\"col-lg-12\">-->\n      <!--<h1 class=\"page-header\">Features:</h1>-->\n      <!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n        <!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n      <!--</ul>-->\n    <!--</div>-->\n  <!--</div>-->\n\n  <!--<form class=\"thing-form\">-->\n    <!--<label>Syncs in realtime across clients</label>-->\n    <!--<p class=\"input-group\">-->\n      <!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n      <!--<span class=\"input-group-btn\">-->\n        <!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n      <!--</span>-->\n    <!--</p>-->\n  <!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FeedbackController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _feedback = __webpack_require__(171);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _add = __webpack_require__(172);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FeedbackController = exports.FeedbackController = function () {
	
	    /*@ngInject*/
	    FeedbackController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function FeedbackController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, FeedbackController);
	
	        this.awesomeThings = [];
	        this.feedbacks = [];
	        this.newThing = '';
	        this.currentPage = 1;
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('feedback');
	        });
	    }
	
	    _createClass(FeedbackController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.$http.get('/api/feedbacks/', {
	                params: {
	                    'page': this.currentPage - 1,
	                    'size': 20
	                }
	            }).then(function (response) {
	                if (response.data.data) {
	                    _lodash2.default.map(response.data.data, function (item, index) {
	                        var time = new Date(item.createdAt).getTime();
	                        if (time <= 1570438358000 || item.select_problem) {
	                            item.type = '用户反馈';
	                        }
	                    });
	
	                    _this.maxSize = 20;
	                    _this.totalCount = response.data.count;
	                    _this.totalItems = response.data.count / 2;
	
	                    _this.feedbacks = response.data.data;
	
	                    _this.socket.syncUpdates('feedback', _this.feedbacks);
	                }
	            });
	        }
	    }, {
	        key: 'deleteFeedback',
	        value: function deleteFeedback(feedback, index) {
	            var _this2 = this;
	
	            this.$http.delete('/api/feedbacks/' + feedback.feed_back_id).then(function (response) {
	                if (response.status === 204) {
	                    _this2.feedbacks.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	        //     /*@ngInject*/
	
	    }]);
	
	    return FeedbackController;
	}();
	
	exports.default = _angular2.default.module('tttApp.feedback', [_angularUiRouter2.default]).config(_feedback2.default).component('feedback', {
	    template: __webpack_require__(175),
	    controller: FeedbackController
	}).name;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('feedback', {
	    url: '/feedback',
	    template: '<feedback></feedback>'
	  });
	}

/***/ }),
/* 172 */
168,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">用户反馈</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"10\">\n                                <code style=\"text-align: right\">反馈总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>类型</td>\n                            <td>姓名</td>\n                            <td>邮箱</td>\n                            <td>问题</td>\n                            <td>原因</td>\n                            <td>内容</td>\n                            <td>版本</td>\n                            <td>UID</td>\n                            <td>版本号</td>\n                            <td>提交时间</td>\n                            <td>语言</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"feedback in $ctrl.feedbacks track by $index\">\n\n                            <td>\n                                {{feedback.type}}\n                            </td>\n                            <td>\n                                {{feedback.name}}\n                            </td>\n                            <td>\n                                {{feedback.email}}\n                            </td>\n                            <td>\n                                {{feedback.select_problem}}\n                            </td>\n                            <td>\n                                {{feedback.problem_reason}}\n                            </td>\n                            <td>\n                                {{feedback.content}}\n                            </td>\n                            <td>\n                                {{feedback.edition_id}}\n                            </td>\n                            <td>\n                                {{feedback.user_id}}\n                            </td>\n                            <td>\n                                {{feedback.app_version}}\n                            </td>\n                            <td>\n                                {{feedback.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{search.language_type ? search.language_type: 'pt'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteFeedback(feedback,$index)\">删除</button>\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.$onInit()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MultiplicationController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _multiplication = __webpack_require__(177);
	
	var _multiplication2 = _interopRequireDefault(_multiplication);
	
	var _add = __webpack_require__(178);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MultiplicationController = exports.MultiplicationController = function () {
	
	    /*@ngInject*/
	    MultiplicationController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function MultiplicationController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, MultiplicationController);
	
	        this.awesomeThings = [];
	        this.multiplications = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('multiplication');
	        });
	    }
	
	    _createClass(MultiplicationController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/multiplications/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.multiplications = response.data.data;
	                        _this.socket.syncUpdates('multiplication', _this.multiplications);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'deleteMultiplication',
	        value: function deleteMultiplication(multiplication, index) {
	            var _this2 = this;
	
	            this.$http.delete('/api/multiplications/' + multiplication.edition_id + '/').then(function (response) {
	                if (response.status === 204) {
	                    _this2.multiplications.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }, {
	        key: 'addMultiplication',
	        value: function addMultiplication() {
	            var multiplications = this.multiplications;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.languageType = [{ value: 'pt', name: 'pt' }, { value: 'en', name: 'en' }, { value: 'es', name: 'es' }];
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $scope.vm.size = $scope.vm.size + 'M';
	                            $http.post('/api/multiplications', $scope.vm).then(function (response) {
	                                console.log(response.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                console.log(ret);
	                if (ret) {
	                    multiplications.push(ret);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'updateMultiplication',
	        value: function updateMultiplication(multiplication, index) {
	            var multiplications = this.multiplications;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.languageType = [{ value: 'pt', name: 'pt' }, { value: 'en', name: 'en' }, { value: 'es', name: 'es' }];
	                    $scope.vm = _angular2.default.copy(multiplication);
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            if ($scope.vm.size.indexOf('M') === -1) {
	                                $scope.vm.size = $scope.vm.size + 'M';
	                            }
	                            $http.put('/api/multiplications/' + multiplication.edition_id + '/', $scope.vm).then(function (response) {
	                                console.log(response.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                console.log(ret);
	                if (ret) {
	                    multiplications[index] = ret;
	                }
	            }, function () {});
	        }
	    }]);
	
	    return MultiplicationController;
	}();
	
	exports.default = _angular2.default.module('tttApp.multiplication', [_angularUiRouter2.default]).config(_multiplication2.default).component('multiplication', {
	    template: __webpack_require__(179),
	    controller: MultiplicationController
	}).name;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('multiplication', {
	    url: '/multiplication',
	    template: '<multiplication></multiplication>'
	  });
	}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>name</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.edition_name\" name=\"edition_name\" required\n                    placeholder=\"edition_name\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.edition_name.$error.required && myForm.$submitted==true\">必填项</span> </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>URL</label>\n            <div class=\"col-sm-10\">\n                <input type=\"url\" class=\"form-control\" ng-model=\"vm.edition_url\" name=\"edition_url\" required\n                    placeholder=\"url\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.edition_url.$error.url && myForm.$submitted==true\">填写正确的链接</span>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.edition_url.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>size</label>\n            <div class=\"col-sm-9\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.size\" name=\"size\" required placeholder=\"size\">\n                <span class=\"text-danger\" ng-if=\"myForm.size.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n            <label class=\"col-sm-1 control-label\">M</label>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>desc</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.edition_desc\" name=\"edition_desc\" required\n                    placeholder=\"edition_desc\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.edition_desc.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语言</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.language_type\" name=\"language_type\"\n                    ng-options=\"item.value as item.name for item in languageType\" required>\n                </select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.language_type.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>版本号</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.version_code\" name=\"version_code\" required\n                    placeholder=\"version_code\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.version_code.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">多版本列表</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"8\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addMultiplication()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>name</td>\n                            <td>url</td>\n                            <td>size</td>\n                            <td>desc</td>\n                            <td>版本号</td>\n                            <td>语言</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"multiplication in $ctrl.multiplications track by $index\">\n                            <td>\n                                {{$index+1}}\n                            </td>\n                            <td>\n                                {{multiplication.edition_name}}\n                            </td>\n                            <td>\n                                <a target=\"_blank\" href=\"{{multiplication.url}}\">{{multiplication.edition_url}}</a>\n                            </td>\n                            <td>\n                                {{multiplication.size}}\n                            </td>\n                            <td>\n                                {{multiplication.edition_desc}}\n                            </td>\n                            <td>\n                                {{multiplication.version_code}}\n                            </td>\n                            <td>\n                                {{multiplication.language_type ? multiplication.language_type: 'pt'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteMultiplication(multiplication,$index)\">删除</button>\n                                <button type=\"button\" class=\"btn btn-warning\"\n                                    ng-click=\"$ctrl.updateMultiplication(multiplication,$index)\">修改</button>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NoteBooksController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _notebook = __webpack_require__(181);
	
	var _notebook2 = _interopRequireDefault(_notebook);
	
	var _add = __webpack_require__(182);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NoteBooksController = exports.NoteBooksController = function () {
	
	    /*@ngInject*/
	    NoteBooksController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location', '$timeout'];
	    function NoteBooksController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout) {
	        _classCallCheck(this, NoteBooksController);
	
	        this.awesomeThings = [];
	        this.notebooks = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	        this.$timeout = $timeout;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('notebook');
	        });
	    }
	
	    _createClass(NoteBooksController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/notebooks/9527/ng/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _angular2.default.forEach(response.data.data, function (item) {
	                            item.notebook = JSON.parse(item.notebook);
	                        });
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	                        _this.notebooks = response.data.data;
	
	                        _this.socket.syncUpdates('notebooks', _this.notebooks);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this2 = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/notebooks/9527/ng', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': this.currentPage - 1,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _angular2.default.forEach(response.data.data, function (item) {
	                            item.notebook = JSON.parse(item.notebook);
	                        });
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.notebooks = response.data.data;
	
	                        _this2.socket.syncUpdates('notebooks', _this2.notebooks);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'exprotExcel',
	        value: function exprotExcel() {
	            var _this3 = this;
	
	            this.$http.get('/api/notebooks/1/1/', {}).then(function (response) {
	                if (response.status === 200) {
	                    console.log(response.data.data);
	                    _this3.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }, {
	        key: 'deleteNoteBook',
	        value: function deleteNoteBook(notebook, index) {
	            var _this4 = this;
	
	            this.$http.delete('/api/notebooks/' + notebook.note_book_id).then(function (response) {
	                if (response.status === 204) {
	                    _this4.notebooks.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	        //     /*@ngInject*/
	
	    }]);
	
	    return NoteBooksController;
	}();
	
	exports.default = _angular2.default.module('tttApp.notebook', [_angularUiRouter2.default]).config(_notebook2.default).component('notebook', {
	    template: __webpack_require__(183),
	    controller: NoteBooksController
	}).name;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('notebook', {
	    url: '/notebook',
	    template: '<notebook></notebook>'
	  });
	}

/***/ }),
/* 182 */
168,
/* 183 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">用户笔记</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"5\">\n                                <code style=\"text-align: right\">笔记总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"2\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.exprotExcel()\">导出EXCEL</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>用户id</td>\n                            <td>笔记</td>\n                            <td>内容</td>\n                            <td>公私</td>\n                            <td>版本</td>\n                            <td>提交时间</td>\n                            <td>语言</td>\n                            <!--            <td>操作</td>-->\n                        </tr>\n                        <tr ng-repeat=\"notebook in $ctrl.notebooks track by $index\">\n                            <td>\n                                {{notebook.user_id}}\n                            </td>\n                            <td>\n                                卷：{{notebook.notebook[0].chapter}} 章：{{notebook.notebook[0].space}}\n                                句：{{notebook.notebook[0].sentence}}\n                            </td>\n                            <td>\n                                {{notebook.content}}\n                            </td>\n                            <td>\n                                {{notebook.is_private}}\n                            </td>\n                            <td>\n                                {{notebook.edition_id}}\n                            </td>\n                            <td>\n                                {{notebook.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{notebook.language_type ? notebook.language_type: 'pt'}}\n                            </td>\n                            <!--            <td class=\"text-center\">-->\n                            <!--              <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.deleteNoteBook(notebook,$index)\">删除</button>-->\n                            <!--            </td>-->\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"7\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HighLightsController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _highlight = __webpack_require__(185);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _add = __webpack_require__(186);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HighLightsController = exports.HighLightsController = function () {
	
	    /*@ngInject*/
	    HighLightsController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function HighLightsController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, HighLightsController);
	
	        this.awesomeThings = [];
	        this.highlights = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('highlight');
	        });
	    }
	
	    _createClass(HighLightsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/highlights/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	                        _this.highlights = response.data.data;
	
	                        _this.socket.syncUpdates('highlights', _this.highlights);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this2 = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/highlights/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': this.currentPage - 1,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.highlights = response.data.data;
	
	                        _this2.socket.syncUpdates('highlights', _this2.highlights);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'highLight',
	        value: function highLight(highlight, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/highlights/' + highlight.highlight_id).then(function (response) {
	                if (response.status === 204) {
	                    _this3.highlights.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	        //     /*@ngInject*/
	
	    }]);
	
	    return HighLightsController;
	}();
	
	exports.default = _angular2.default.module('tttApp.highlight', [_angularUiRouter2.default]).config(_highlight2.default).component('highlight', {
	    template: __webpack_require__(187),
	    controller: HighLightsController
	}).name;

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('highlight', {
	    url: '/highlight',
	    template: '<highlight></highlight>'
	  });
	}

/***/ }),
/* 186 */
168,
/* 187 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">高亮</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"9\">\n                                <code style=\"text-align: right\">高亮总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>用户id</td>\n                            <td>卷</td>\n                            <td>章</td>\n                            <td>句</td>\n                            <td>内容</td>\n                            <td>颜色</td>\n                            <td>版本</td>\n                            <td>提交时间</td>\n                            <td>语言</td>\n                            <!--            <td>操作</td>-->\n                        </tr>\n                        <tr ng-repeat=\"highlight in $ctrl.highlights track by $index\">\n                            <td>\n                                {{highlight.user_id}}\n                            </td>\n                            <td>\n                                {{highlight.chapter}}\n                            </td>\n                            <td>\n                                {{highlight.space}}\n                            </td>\n                            <td>\n                                {{highlight.sentence}}\n                            </td>\n                            <td>\n                                {{highlight.content}}\n                            </td>\n                            <td>\n                                {{highlight.color}}\n                            </td>\n                            <td>\n                                {{highlight.edition_id}}\n                            </td>\n                            <td>\n                                {{highlight.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{highlight.language_type ? highlight.language_type: 'pt'}}\n                            </td>\n                            <!--            <td class=\"text-center\">-->\n                            <!--              <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.highLight(highlight,$index)\">删除</button>-->\n                            <!--            </td>-->\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"8\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MarksController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mark2 = __webpack_require__(189);
	
	var _mark3 = _interopRequireDefault(_mark2);
	
	var _add = __webpack_require__(190);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MarksController = function () {
	
	    /*@ngInject*/
	    MarksController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function MarksController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, MarksController);
	
	        this.awesomeThings = [];
	        this.marks = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('mark');
	        });
	    }
	
	    _createClass(MarksController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/marks/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	                        _this.marks = response.data.data;
	                        console.log(_this.marks);
	
	                        _this.socket.syncUpdates('marks', _this.marks);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this2 = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/marks/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': this.currentPage - 1,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.marks = response.data.data;
	                        console.log(_this2.marks);
	
	                        _this2.socket.syncUpdates('marks', _this2.marks);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'mark',
	        value: function mark(_mark, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/marks/' + _mark.mark_id).then(function (response) {
	                if (response.status === 204) {
	                    _this3.marks.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	        //     /*@ngInject*/
	
	    }]);
	
	    return MarksController;
	}();
	
	exports.MarksController = MarksController;
	exports.default = _angular2.default.module('tttApp.mark', [_angularUiRouter2.default]).config(_mark3.default).component('mark', {
	    template: __webpack_require__(191),
	    controller: MarksController
	}).name;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('mark', {
	    url: '/mark',
	    template: '<mark></mark>'
	  });
	}

/***/ }),
/* 190 */
168,
/* 191 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">书签</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"7\">\n                                <code style=\"text-align: right\">书签总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>用户id</td>\n                            <td>卷</td>\n                            <td>章</td>\n                            <td>内容</td>\n                            <td>版本</td>\n                            <td>提交时间</td>\n                            <td>语言</td>\n                            <!--            <td>操作</td>-->\n                        </tr>\n                        <tr ng-repeat=\"mark in $ctrl.marks track by $index\">\n                            <td>\n                                {{mark.user_id}}\n                            </td>\n                            <td>\n                                {{mark.chapter}}\n                            </td>\n                            <td>\n                                {{mark.space}}\n                            </td>\n                            <td>\n                                {{mark.content}}\n                            </td>\n                            <td>\n                                {{mark.edition_id}}\n                            </td>\n                            <td>\n                                {{mark.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{mark.language_type ? mark.language_type: 'pt'}}\n                            </td>\n                            <!--            <td class=\"text-center\">-->\n                            <!--              <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.mark(mark,$index)\">删除</button>-->\n                            <!--            </td>-->\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"7\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrderController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _order = __webpack_require__(193);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _add = __webpack_require__(194);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrderController = exports.OrderController = function () {
	
	    /*@ngInject*/
	    OrderController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function OrderController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, OrderController);
	
	        this.awesomeThings = [];
	        this.orders = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(OrderController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/orders/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.orders = response.data.data;
	                        _this.socket.syncUpdates('order', _this.orders);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/orders/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.orders = response.data.data;
	
	                        _this2.socket.syncUpdates('order', _this2.orders);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'deleteOrder',
	        value: function deleteOrder(order, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/orders/' + order.order_id).then(function (response) {
	                if (response.status === 204) {
	                    _this3.orders.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return OrderController;
	}();
	
	exports.default = _angular2.default.module('tttApp.order', [_angularUiRouter2.default]).config(_order2.default).component('order', {
	    template: __webpack_require__(195),
	    controller: OrderController
	}).name;

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('order', {
	        url: '/order',
	        template: '<order></order>'
	    });
	}

/***/ }),
/* 194 */
154,
/* 195 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">意向订单列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.uuid\"\n                            placeholder=\"请输入设备ID\">\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.uuid\">\n                            用户id:{{$ctrl.filters.uuid}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.uuid=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"16\">\n                                <code style=\"text-align: right\">高亮总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>订单id</td>\n                            <td>用户ID</td>\n                            <td>用户名</td>\n                            <td>品牌</td>\n                            <td>型号</td>\n                            <td>设备id</td>\n                            <td>邮箱</td>\n                            <td>版本</td>\n                            <td>颜色</td>\n                            <td>材料</td>\n                            <td>章</td>\n                            <td>节</td>\n                            <td>句</td>\n                            <td>国家</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"order in $ctrl.orders track by $index\">\n                            <td>\n                                {{order.order_id}}\n                            </td>\n\n                            <td>\n                                {{order.user_id}}\n                            </td>\n                            <td>\n                                {{order.user_name}}\n                            </td>\n                            <td>\n                                {{order.brand}}\n                            </td>\n                            <td>\n                                {{order.model}}\n                            </td>\n                            <td>\n                                {{order.uuid}}\n                            </td>\n                            <td>\n                                {{order.email}}\n                            </td>\n                            <td>\n                                {{order.edition_id}}\n                            </td>\n                            <td>\n                                {{order.shop_color}}\n                            </td>\n                            <td>\n                                {{order.shop_materials}}\n                            </td>\n                            <td>\n                                {{order.chapter}}\n                            </td>\n                            <td>\n                                {{order.space}}\n                            </td>\n                            <td>\n                                {{order.sentence}}\n                            </td>\n                            <td>\n                                {{order.country}}\n                            </td>\n\n                            <td>\n                                {{order.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteOrder(order, $index)\">删除</button>\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"16\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechTypeController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechtype = __webpack_require__(197);
	
	var _speechtype2 = _interopRequireDefault(_speechtype);
	
	var _add = __webpack_require__(198);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechTypeController = exports.SpeechTypeController = function () {
	
	    /*@ngInject*/
	    SpeechTypeController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechTypeController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechTypeController);
	
	        this.awesomeThings = [];
	        this.speechTypes = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechTypeController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/speech_types/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechTypes = response.data.data;
	                        _this.socket.syncUpdates('speechTypes', _this.speechTypes);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_types/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechTypes = response.data.data;
	                        _this2.socket.syncUpdates('speechTypes', _this2.speechTypes);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechType',
	        value: function addSpeechType() {
	            var speechTypes = this.speechTypes;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/speech_types/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechTypes.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechType',
	        value: function editSpeechType(type, index) {
	            var speechTypes = this.speechTypes;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = _angular2.default.copy(type);
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	
	                            $http.put('/api/speech_types/' + type.speech_type_id + '/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechTypes[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechType',
	        value: function deleteSpeechType(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_types/' + type.speech_type_id + '/').then(function (response) {
	                if (response.status === 204) {
	                    _this3.speechTypes.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechTypeController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechtype', [_angularUiRouter2.default]).config(_speechtype2.default).component('speechtype', {
	    template: __webpack_require__(199),
	    controller: SpeechTypeController
	}).name;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechtype', {
	        url: '/speechtype',
	        template: '<speechtype></speechtype>'
	    });
	}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音类型名称</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.speech_type_name\" name=\"speech_type_name\" required\n                    placeholder=\"语音类型名称\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.speech_type_name.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">语音类型列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"5\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechType()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>类型ID</td>\n                            <td>类型名称</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"type in $ctrl.speechTypes track by $index\">\n                            <td>\n                                {{type.speech_type_id}}\n                            </td>\n\n                            <td>\n                                {{type.speech_type_name}}\n                            </td>\n                            <td>\n                                {{type.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechType(type, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechType(type, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"16\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechProfileController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechprofile = __webpack_require__(201);
	
	var _speechprofile2 = _interopRequireDefault(_speechprofile);
	
	var _add = __webpack_require__(202);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechProfileController = exports.SpeechProfileController = function () {
	
	    /*@ngInject*/
	    SpeechProfileController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechProfileController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechProfileController);
	
	        this.awesomeThings = [];
	        this.speechProfile = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechProfileController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_types/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.speechTypeName = response.data.data;
	                    }
	                });
	
	                this.getTypeName = function (id) {
	                    var _name = _lodash2.default.find(this.speechTypeName, { speech_type_id: id });
	                    return _name.speech_type_name;
	                };
	
	                this.$http.get('/api/speech_profiles/1/2/3/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechProfile = response.data.data;
	                        _this.socket.syncUpdates('speechProfile', _this.speechProfile);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_profiles/1/2/3/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechProfile = response.data.data;
	                        _this2.socket.syncUpdates('speechProfile', _this2.speechProfile);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechProfile',
	        value: function addSpeechProfile() {
	            var speechProfile = this.speechProfile;
	
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/speech_profiles/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.cover_img = response.data.cover_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $http.get('/api/speech_types/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    $scope.changeType = function (index) {
	
	                        if (index === 1) {
	                            $scope.isType_one = true;
	                            $scope.isType_two = false;
	                        }
	
	                        if (index !== 1) {
	                            $scope.isType_two = true;
	                            $scope.isType_one = false;
	                        }
	                    };
	
	                    $scope.save = function (myForm) {
	                        console.log($scope.vm.profile);
	                        if (myForm.$valid === false && $scope.isload === false) {
	                            return false;
	                        } else {
	                            var ret = {};
	                            if ($scope.vm.speech_type_id === 1) {
	                                ret['speech_type_id'] = $scope.vm.speech_type_id;
	                                ret['speech_name'] = $scope.vm.speech_name;
	                                ret['cover_img'] = $scope.vm.cover_img;
	                                ret['cover_small_img'] = $scope.vm.cover_small_img;
	                                ret['speech_url'] = $scope.vm.speech_url;
	                                ret['desc'] = $scope.vm.desc;
	                                ret['speech_size'] = $scope.vm.speech_size;
	                                ret['speech_during'] = $scope.vm.speech_during;
	                            }
	                            if ($scope.vm.speech_type_id !== 1) {
	                                ret['speech_type_id'] = $scope.vm.speech_type_id;
	                                ret['speech_name'] = $scope.vm.speech_name;
	                                ret['cover_img'] = $scope.vm.cover_img;
	                                ret['desc'] = $scope.vm.desc;
	                                ret['profile'] = $scope.vm.profile;
	                            }
	                            console.log(ret);
	                            $http.post('/api/speech_profiles/', ret).then(function (response) {
	                                console.log(response.data.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechProfile.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechProfile',
	        value: function editSpeechProfile(type, index) {
	            var speechProfile = this.speechProfile;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    console.log(type);
	                    $scope.vm = _angular2.default.copy(type);
	
	                    $http.get('/api/speech_types/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    if ($scope.vm.speech_type_id === 1) {
	                        $scope.isType_one = true;
	                        $scope.isType_two = false;
	                    }
	                    if ($scope.vm.speech_type_id !== 1) {
	                        $scope.isType_two = true;
	                        $scope.isType_one = false;
	                    }
	
	                    $scope.changeType = function (index) {
	
	                        if (index === 1) {
	                            $scope.isType_one = true;
	                            $scope.isType_two = false;
	                        }
	
	                        if (index !== 1) {
	                            $scope.isType_two = true;
	                            $scope.isType_one = false;
	                        }
	                    };
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/speech_profiles/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.cover_img = response.data.cover_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.put('/api/speech_profiles/' + type.speech_profile_id + '/', $scope.vm).then(function (response) {
	                                console.log(response);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechProfile[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechProfile',
	        value: function deleteSpeechProfile(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_profiles/' + type.speech_profile_id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.speechProfile.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechProfileController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechprofile', [_angularUiRouter2.default]).config(_speechprofile2.default).component('speechprofile', {
	    template: __webpack_require__(203),
	    controller: SpeechProfileController
	}).name;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechprofile', {
	        url: '/speechprofile',
	        template: '<speechprofile></speechprofile>'
	    });
	}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音类型</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.speech_type_id\" name=\"speech_type_id\"\n                    ng-change=\"changeType(vm.speech_type_id)\"\n                    ng-options=\"item.speech_type_id as item.speech_type_name for item in speechTypes\" required></select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.speech_type_id.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div ng-if=\"vm.speech_type_id\">\n\n\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span\n                        class=\"text-danger\">*</span>{{isType_one?'语音文件名称':'专辑名称'}}</label>\n                <div class=\"col-sm-10\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.speech_name\" name=\"speech_name\" required\n                        placeholder=\"{{isType_one?'语音文件名称':'专辑名称'}}\">\n                    <span class=\"text-danger\"\n                        ng-if=\"myForm.speech_name.$error.required && myForm.$submitted==true\">必填项</span>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>封面图上传</label>\n                <div class=\"col-sm-10\">\n                    <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems1()\"\n                        ng-model=\"vm.cover_img\" name=\"cover_img\" uploader=\"uploaderImage\" />\n                    <span class=\"text-danger\">{{vm.cover_img}}</span>\n                    <span class=\"text-danger\" ng-if=\"isloadcover\">上传中...</span>\n                    <span class=\"text-danger\" ng-if=\"isloadcoverError\">格式不正确</span>\n\n                </div>\n            </div>\n            <div ng-if=\"isType_one\">\n                <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>播放器小尺寸图</label>\n                    <div class=\"col-sm-10\">\n                        <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems2()\"\n                            ng-model=\"vm.cover_small_img\" name=\"cover_small_img\" uploader=\"uploaderImageSmall\" />\n                        <span class=\"text-danger\">{{vm.cover_small_img}}</span>\n                        <span class=\"text-danger\" ng-if=\"isloadcoversmall\">上传中...</span>\n                        <span class=\"text-danger\" ng-if=\"isloadcoversmallError\">格式不正确</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>描述</label>\n                <div class=\"col-sm-10\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.desc\" name=\"desc\" required placeholder=\"描述\">\n                    <span class=\"text-danger\" ng-if=\"myForm.desc.$error.required && myForm.$submitted==true\">必填项</span>\n                </div>\n            </div>\n            <div ng-if=\"isType_two\">\n                <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>专辑简介</label>\n                    <div class=\"col-sm-10\">\n                        <textarea class=\"form-control\" ng-model=\"vm.profile\" name=\"profile\" required rows=\"5\"\n                            placeholder=\"专辑简介\"></textarea>\n                        <span class=\"text-danger\"\n                            ng-if=\"myForm.profile.$error.required && myForm.$submitted==true\">必填项</span>\n                    </div>\n                </div>\n            </div>\n\n\n            <div ng-if=\"isType_one\">\n                <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音文件上传</label>\n                    <div class=\"col-sm-10\">\n\n                        <input type=\"file\" nv-file-select=\"\" ng-click=\"clearItems()\" class=\"form-control\"\n                            ng-model=\"vm.speech_url\" name=\"speech_url\" uploader=\"uploader\" />\n\n                        <span class=\"text-danger\">{{vm.speech_url}}</span>\n\n                        <span class=\"text-danger\" ng-if=\"isload\">上传中...</span>\n                        <span class=\"text-danger\" ng-if=\"isloadSpeechUrlError\">格式不正确</span>\n\n                    </div>\n                </div>\n\n\n                <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音文件大小</label>\n                    <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" disabled ng-model=\"vm.speech_size\" name=\"speech_size\"\n                            required placeholder=\"语音文件大小\">\n                        <span class=\"text-danger\"\n                            ng-if=\"myForm.speech_size.$error.required && myForm.$submitted==true\">必填项</span>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音时长</label>\n                    <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.speech_during\" name=\"speech_during\"\n                            required placeholder=\"语音时长\">\n                        <span class=\"text-danger\"\n                            ng-if=\"myForm.speech_during.$error.required && myForm.$submitted==true\">必填项</span>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">语音基本信息列表</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <select name=\"speech_type\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.speech_type_id\"\n                            ng-options=\"type.speech_type_id as type.speech_type_name for type in $ctrl.speechTypeName\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">选择语音类型</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.speech_type_id\">\n                            语音类型:{{$ctrl.getTypeName($ctrl.filters.speech_type_id)}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.speech_type_id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"10\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechProfile()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>语音类型</td>\n                            <td>语音名称</td>\n                            <td>语音文件url</td>\n                            <td>封面图</td>\n                            <td>播放器小图</td>\n                            <td>描述</td>\n                            <td>语音文件大小</td>\n                            <td>语音时长</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"profile in $ctrl.speechProfile track by $index\">\n                            <td>\n                                {{profile.speech_profile_id}}\n                            </td>\n                            <td>\n                                {{$ctrl.getTypeName(profile.speech_type_id)}}\n                            </td>\n                            <td>\n                                {{profile.speech_name}}\n                            </td>\n                            <td ng-if=\"profile.speech_url\">\n                                <a target=\"_blank\" ng-href=\"{{profile.speech_url}}\"\n                                    class=\"glyphicon glyphicon-new-window\" aria-hidden=\"true\"></a>\n                            </td>\n                            <td ng-if=\"!profile.speech_url\">\n                                {{profile.speech_url}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{profile.cover_img}}\" />\n                            </td>\n                            <td ng-if=\"profile.cover_small_img\">\n                                <img width=\"72\" height=\"51\" src=\"{{profile.cover_small_img}}\" />\n                            </td>\n                            <td ng-if=\"!profile.cover_small_img\">\n                                {{profile.cover_small_img}}\n                            </td>\n                            <td>\n                                {{profile.desc}}\n                            </td>\n                            <td>\n                                {{profile.speech_size ? (profile.speech_size +' M'): ''}}\n                            </td>\n                            <td>\n                                {{profile.speech_during ? profile.speech_during:''}}\n                            </td>\n                            <td>\n                                {{profile.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechProfile(profile, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechProfile(profile, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechDetailsController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechdetails = __webpack_require__(205);
	
	var _speechdetails2 = _interopRequireDefault(_speechdetails);
	
	var _add = __webpack_require__(206);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechDetailsController = exports.SpeechDetailsController = function () {
	
	    /*@ngInject*/
	    SpeechDetailsController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechDetailsController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechDetailsController);
	
	        this.awesomeThings = [];
	        this.speechDetails = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechDetailsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_types/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.speechTypeName = response.data.data;
	                    }
	                });
	
	                this.getTypeName = function (id) {
	                    var _name = _lodash2.default.find(this.speechTypeName, { speech_type_id: id });
	                    return _name.speech_type_name;
	                };
	
	                this.$http.get('/api/speech_details/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechDetails = response.data.data;
	                        _this.socket.syncUpdates('speechDetails', _this.speechDetails);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_details/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechDetails = response.data.data;
	                        _this2.socket.syncUpdates('speechDetails', _this2.speechDetails);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechDetails',
	        value: function addSpeechDetails() {
	            var speechDetails = this.speechDetails;
	
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    $http.get('/api/speech_types/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            response.data.data.splice(0, 1);
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    $scope.changeType = function (index) {
	
	                        $http.get('/api/speech_profiles/' + index + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                            }
	                        });
	                    };
	
	                    $scope.selectProfile = function (value) {
	                        var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': value });
	                        $scope.vm['cover_img'] = obj.cover_img;
	                        $scope.vm['collection_name'] = obj.speech_name;
	                        $scope.vm['profile'] = obj.profile;
	                        console.log($scope.vm);
	                    };
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            console.log(options);
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoversmallError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        console.log($scope.vm.profile);
	                        if (myForm.$valid === false && $scope.isload === false) {
	                            return false;
	                        } else {
	                            var ret = {
	                                speech_profile_id: $scope.vm.speech_profile_id,
	                                collection_name: $scope.vm.collection_name,
	                                speech_type_id: $scope.vm.speech_type_id,
	                                speech_name: $scope.vm.speech_name,
	                                speech_url: $scope.vm.speech_url,
	                                cover_img: $scope.vm.cover_img,
	                                cover_small_img: $scope.vm.cover_small_img,
	                                profile: $scope.vm.profile,
	                                desc: $scope.vm.desc,
	                                speech_size: $scope.vm.speech_size,
	                                speech_during: $scope.vm.speech_during
	                            };
	
	                            $http.post('/api/speech_details/', ret).then(function (response) {
	                                console.log(response.data.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechDetails.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechDetails',
	        value: function editSpeechDetails(type, index) {
	            var speechDetails = this.speechDetails;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = _angular2.default.copy(type);
	                    console.log($scope.vm);
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    $http.get('/api/speech_types/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            response.data.data.splice(0, 1);
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    if ($scope.vm.speech_type_id) {
	                        $http.get('/api/speech_profiles/' + $scope.vm.speech_type_id + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                                var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': $scope.vm.speech_profile_id });
	                                if (obj) {
	                                    $scope.vm['cover_img'] = obj.cover_img;
	                                    $scope.vm['collection_name'] = obj.speech_name;
	                                    $scope.vm['profile'] = obj.profile;
	                                }
	                            }
	                        });
	                    }
	
	                    $scope.changeType = function (index) {
	
	                        $http.get('/api/speech_profiles/' + index + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                            }
	                        });
	                    };
	
	                    $scope.selectProfile = function (value) {
	                        var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': value });
	                        if (obj) {
	                            $scope.vm['cover_img'] = obj.cover_img;
	                            $scope.vm['collection_name'] = obj.speech_name;
	                            $scope.vm['profile'] = obj.profile;
	                            console.log($scope.vm);
	                        }
	                    };
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            console.log(options);
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoversmallError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.put('/api/speech_details/' + type.details_id + '/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechDetails[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechDetails',
	        value: function deleteSpeechDetails(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_details/' + type.details_id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.speechDetails.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechDetailsController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechdetails', [_angularUiRouter2.default]).config(_speechdetails2.default).component('speechdetails', {
	    template: __webpack_require__(207),
	    controller: SpeechDetailsController
	}).name;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechdetails', {
	        url: '/speechdetails',
	        template: '<speechdetails></speechdetails>'
	    });
	}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音类型</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.speech_type_id\" name=\"speech_type_id\"\n                    ng-change=\"changeType(vm.speech_type_id)\"\n                    ng-options=\"item.speech_type_id as item.speech_type_name for item in speechTypes\" required></select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.speech_type_id.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div ng-if=\"vm.speech_type_id\">\n\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>选择专辑</label>\n                <div class=\"col-sm-10\">\n                    <select class=\"form-control\" ng-model=\"vm.speech_profile_id\" name=\"speech_profile_id\"\n                        ng-change=\"selectProfile(vm.speech_profile_id)\"\n                        ng-options=\"item.speech_profile_id as item.speech_name for item in speechProfile\"\n                        required></select>\n                    <span class=\"text-danger\"\n                        ng-if=\"myForm.speech_profile_id.$error.required && myForm.$submitted==true\">必填项</span>\n                </div>\n            </div>\n\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音文件名称</label>\n                <div class=\"col-sm-10\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.speech_name\" name=\"speech_name\" required\n                        placeholder=\"语音文件名称\">\n                    <span class=\"text-danger\"\n                        ng-if=\"myForm.speech_name.$error.required && myForm.$submitted==true\">必填项</span>\n                </div>\n            </div>\n\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>播放器小尺寸图</label>\n                <div class=\"col-sm-10\">\n                    <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems2()\"\n                        ng-model=\"vm.cover_small_img\" name=\"cover_small_img\" uploader=\"uploaderImageSmall\" />\n                    <span class=\"text-danger\">{{vm.cover_small_img}}</span>\n                    <span class=\"text-danger\" ng-if=\"isloadcoversmall\">上传中...</span>\n                    <span class=\"text-danger\" ng-if=\"isloadcoversmallError\">格式不正确</span>\n\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>描述</label>\n                <div class=\"col-sm-10\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.desc\" name=\"desc\" required placeholder=\"描述\">\n                    <span class=\"text-danger\" ng-if=\"myForm.desc.$error.required && myForm.$submitted==true\">必填项</span>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音文件上传</label>\n                <div class=\"col-sm-10\">\n\n                    <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems()\"\n                        ng-model=\"vm.speech_url\" name=\"speech_url\" uploader=\"uploader\" />\n\n                    <span class=\"text-danger\">{{vm.speech_url}}</span>\n                    <span class=\"text-danger\" ng-if=\"isload\">上传中...</span>\n                    <span class=\"text-danger\" ng-if=\"isloadSpeechUrlError\">格式不正确</span>\n\n                </div>\n            </div>\n\n\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音文件大小</label>\n                <div class=\"col-sm-10\">\n                    <input type=\"text\" class=\"form-control\" disabled ng-model=\"vm.speech_size\" name=\"speech_size\"\n                        required placeholder=\"语音文件大小\">\n                    <span class=\"text-danger\"\n                        ng-if=\"myForm.speech_size.$error.required && myForm.$submitted==true\">必填项</span>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语音时长</label>\n                <div class=\"col-sm-10\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.speech_during\" name=\"speech_during\" required\n                        placeholder=\"语音时长\">\n                    <span class=\"text-danger\"\n                        ng-if=\"myForm.speech_during.$error.required && myForm.$submitted==true\">必填项</span>\n                </div>\n            </div>\n\n        </div>\n\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">语音专辑基本信息列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"10\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechDetails()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>语音类型</td>\n                            <td>专辑名称</td>\n                            <td>语音名称</td>\n                            <td>语音文件url</td>\n                            <td>封面图</td>\n                            <td>播放器小图</td>\n                            <td>描述</td>\n                            <td>语音文件大小</td>\n                            <td>语音时长</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"Details in $ctrl.speechDetails track by $index\">\n                            <td>\n                                {{Details.details_id}}\n                            </td>\n                            <td>\n                                {{$ctrl.getTypeName(Details.speech_type_id)}}\n                            </td>\n                            <td>\n                                {{Details.collection_name}}\n                            </td>\n                            <td>\n                                {{Details.speech_name}}\n                            </td>\n                            <td ng-if=\"Details.speech_url\">\n                                <a target=\"_blank\" ng-href=\"{{Details.speech_url}}\"\n                                    class=\"glyphicon glyphicon-new-window\" aria-hidden=\"true\"></a>\n                            </td>\n                            <td ng-if=\"!Details.speech_url\">\n                                {{Details.speech_url}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{Details.cover_img}}\" />\n                            </td>\n                            <td ng-if=\"Details.cover_small_img\">\n                                <img width=\"72\" height=\"51\" src=\"{{Details.cover_small_img}}\" />\n                            </td>\n                            <td ng-if=\"!Details.cover_small_img\">\n                                {{Details.cover_small_img}}\n                            </td>\n                            <td>\n                                {{Details.desc}}\n                            </td>\n                            <td>\n                                {{Details.speech_size ? (Details.speech_size +' M'): ''}}\n                            </td>\n                            <td>\n                                {{Details.speech_during ? Details.speech_during:''}}\n                            </td>\n                            <td>\n                                {{Details.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechDetails(Details, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechDetails(Details, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PaySubController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paysub = __webpack_require__(209);
	
	var _paysub2 = _interopRequireDefault(_paysub);
	
	var _add = __webpack_require__(210);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PaySubController = exports.PaySubController = function () {
	
	    /*@ngInject*/
	    PaySubController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function PaySubController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, PaySubController);
	
	        this.paysubs = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.subStatus = [{ value: '终身', name: '终身' }, { value: '订阅中', name: '订阅中' }, { value: '已过期', name: '已过期' }, { value: '订阅中[赠]', name: '订阅中[赠]' }, { value: '已过期[赠]', name: '已过期[赠]' }];
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('paysub');
	        });
	    }
	
	    _createClass(PaySubController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/pay_sub/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.paysubs = response.data.data;
	                        _this.socket.syncUpdates('paysubs', _this.paysubs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/pay_sub/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.paysubs = response.data.data;
	
	                        _this2.socket.syncUpdates('paysubs', _this2.paysubs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addPaysub',
	        value: function addPaysub() {
	            var paysubs = this.paysubs;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.platformTypes = ['Android', 'ios'];
	                    $scope.isDisabled = false;
	                    $scope.popup2 = {
	                        opened: false
	                    };
	
	                    $scope.open2 = function () {
	                        $scope.popup2.opened = true;
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            var data = {
	                                user_id: $scope.vm.user_id,
	                                platform: $scope.vm.platform,
	                                pay_id: $scope.vm.platform + $scope.vm.user_id,
	                                expires_date_ms: $scope.vm.expires_date_ms.getTime(),
	                                is_give: 1
	                            };
	                            $http.post('/api/pay_sub/1/', data).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    paysubs.push(ret);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'updatePaysub',
	        value: function updatePaysub(paysub, index) {
	            var paysubs = this.paysubs;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    var copyData = _angular2.default.copy(paysub);
	                    $scope.popup2 = {
	                        opened: false
	                    };
	
	                    $scope.open2 = function () {
	                        $scope.popup2.opened = true;
	                    };
	                    $scope.vm = {
	                        user_id: copyData.user_id,
	                        platform: copyData.platform,
	                        pay_id: copyData.pay_id,
	                        expires_date_ms: new Date(parseInt(copyData.expires_date_ms, 10))
	                    };
	                    $scope.platformTypes = ['Android', 'ios'];
	                    $scope.isDisabled = true;
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            var data = {
	                                expires_date_ms: $scope.vm.expires_date_ms.getTime()
	                            };
	                            $http.put('/api/pay_sub/' + $scope.vm.platform + $scope.vm.user_id + '/', data).then(function (response) {
	                                var date = data.expires_date_ms;
	                                $uibModalInstance.close({ req: response.data.data, date: date });
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret.req) {
	                    paysubs[index]['expires_date_ms'] = ret.date;
	                }
	            }, function () {});
	        }
	    }]);
	
	    return PaySubController;
	}();
	
	exports.default = _angular2.default.module('tttApp.paysub', [_angularUiRouter2.default]).config(_paysub2.default).component('paysub', {
	    template: __webpack_require__(211),
	    controller: PaySubController
	}).name;

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('paysub', {
	        url: '/paysub',
	        template: '<paysub></paysub>'
	    });
	}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>USER_ID</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-disabled={{isDisabled}} ng-model=\"vm.user_id\"\n                    name=\"user_id\" required placeholder=\"user_id\">\n                <span class=\"text-danger\" ng-if=\"myForm.user_id.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>平台</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.platform\" ng-disabled={{isDisabled}} name=\"platform\"\n                    ng-options=\"item for item in platformTypes\" required>\n                </select>\n                <span class=\"text-danger\" ng-if=\"myForm.platform.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>过期时间</label>\n            <div class=\"col-sm-10\">\n                <p class=\"input-group\">\n                    <input type=\"date\" class=\"form-control\" name=\"expires_date_ms\" uib-datepicker-popup\n                        ng-model=\"vm.expires_date_ms\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required\n                        close-text=\"Close\" />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i\n                                class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </p>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.expires_date_ms.$error.required && myForm.$submitted==true\">必填项</span>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.expires_date_ms.$error.date && myForm.$submitted==true\">日期格式错误</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">支付订单列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <select name=\"share_platform\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.sub_status\"\n                            ng-options=\"item.value as item.name for item in $ctrl.subStatus\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">订阅状态</option>\n                        </select>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.sub_status\">\n                            订阅状态:{{$ctrl.filters.sub_status}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.sub_status=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"10\">\n                                <code style=\"text-align: right\">用户总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"2\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addPaysub()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>支付ID</td>\n                            <td>用户ID</td>\n                            <td>平台</td>\n                            <td>订单ID</td>\n                            <td>原始订单ID</td>\n                            <td>token</td>\n                            <td>productID</td>\n                            <td>创建时间(UTC)</td>\n                            <td>过期时间(UTC)</td>\n                            <td>是否过期</td>\n                            <td>语言</td>\n                            <!-- <td>修改时间(UTC)</td> -->\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"paysub in $ctrl.paysubs track by $index\">\n                            <td>\n                                {{paysub.pay_id}}\n                            </td>\n\n                            <td>\n                                {{paysub.user_id}}\n                            </td>\n                            <td>\n                                {{paysub.platform}}\n                            </td>\n                            <td>\n                                {{paysub.order_id}}\n                            </td>\n                            <td>\n                                {{paysub.original_transaction_id}}\n                            </td>\n                            <td>\n                                <span uib-dropdown on-toggle=\"toggled(open)\" ng-if=\"paysub.token\">\n                                    <a href id=\"simple-dropdown\" uib-dropdown-toggle>\n                                        token\n                                    </a>\n                                    <ul class=\"dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n                                        <li>\n                                            <a href>{{paysub.token}}</a>\n                                        </li>\n                                    </ul>\n                                </span>\n\n                            </td>\n                            <td>\n                                {{paysub.product_id}}\n                            </td>\n                            <td>\n                                {{paysub.purchase_date_ms | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{paysub.expires_date_ms | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td ng-if=\"paysub.is_expires === '终身'\" class=\"bg-success\">\n                                {{paysub.is_expires}}\n                            </td>\n                            <td ng-if=\"paysub.is_expires === '订阅中'\" class=\"bg-primary\">\n                                {{paysub.is_expires}}\n                            </td>\n                            <td ng-if=\"paysub.is_expires === '已过期'\" class=\"bg-danger\">\n                                {{paysub.is_expires}}\n                            </td>\n                            <td ng-if=\"paysub.is_expires === '订阅中[赠]'\" class=\"bg-warning\">\n                                {{paysub.is_expires}}\n                            </td>\n                            <td ng-if=\"paysub.is_expires === '已过期[赠]'\" class=\"bg-danger\">\n                                {{paysub.is_expires}}\n                            </td>\n\n                            <!-- <td>\n                                {{paysub.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td> -->\n                            <td>\n                                {{paysub.language_type ? paysub.language_type: 'pt'}}\n                            </td>\n\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\" ng-if=\"paysub.is_give === 1\"\n                                    ng-click=\"$ctrl.updatePaysub(paysub, $index)\">修改</button>\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AdSubController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adsub = __webpack_require__(213);
	
	var _adsub2 = _interopRequireDefault(_adsub);
	
	var _add = __webpack_require__(214);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdSubController = exports.AdSubController = function () {
	
	    /*@ngInject*/
	    AdSubController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function AdSubController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, AdSubController);
	
	        this.adsubs = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.subStatus = [{ value: '终身', name: '终身' }, { value: '订阅中', name: '订阅中' }, { value: '已过期', name: '已过期' }, { value: '订阅中[赠]', name: '订阅中[赠]' }, { value: '已过期[赠]', name: '已过期[赠]' }];
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('adsub');
	        });
	    }
	
	    _createClass(AdSubController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/ad_sub/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.adsubs = response.data.data;
	                        _this.socket.syncUpdates('adsubs', _this.adsubs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/ad_sub/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.adsubs = response.data.data;
	
	                        _this2.socket.syncUpdates('adsubs', _this2.adsubs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addAdsub',
	        value: function addAdsub() {
	            var adsubs = this.adsubs;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.platformTypes = ['Android', 'ios'];
	                    $scope.isDisabled = false;
	
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	
	                            var data = {
	                                user_id: $scope.vm.user_id,
	                                platform: $scope.vm.platform,
	                                pay_id: $scope.vm.platform + $scope.vm.user_id,
	                                expires_date_ms: $scope.vm.expires_date_ms,
	                                is_give: 1
	                            };
	                            $http.post('/api/ad_sub/1/', data).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    adsubs.push(ret);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'updateAdsub',
	        value: function updateAdsub(adsub, index) {
	            var adsubs = this.adsubs;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    var copyData = _angular2.default.copy(adsub);
	                    $scope.popup2 = {
	                        opened: false
	                    };
	
	                    $scope.open2 = function () {
	                        $scope.popup2.opened = true;
	                    };
	                    $scope.vm = {
	                        user_id: copyData.user_id,
	                        platform: copyData.platform,
	                        pay_id: copyData.pay_id,
	                        expires_date_ms: new Date(parseInt(copyData.expires_date_ms, 10))
	                    };
	                    $scope.platformTypes = ['Android', 'ios'];
	                    $scope.isDisabled = true;
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            var data = {
	                                expires_date_ms: $scope.vm.expires_date_ms.getTime()
	                            };
	                            $http.put('/api/ad_sub/' + $scope.vm.platform + $scope.vm.user_id + '/', data).then(function (response) {
	                                var date = data.expires_date_ms;
	                                $uibModalInstance.close({ req: response.data.data, date: date });
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret.req) {
	                    adsubs[index]['expires_date_ms'] = ret.date;
	                }
	            }, function () {});
	        }
	    }]);
	
	    return AdSubController;
	}();
	
	exports.default = _angular2.default.module('tttApp.adsub', [_angularUiRouter2.default]).config(_adsub2.default).component('adsub', {
	    template: __webpack_require__(215),
	    controller: AdSubController
	}).name;

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('adsub', {
	        url: '/adsub',
	        template: '<adsub></adsub>'
	    });
	}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>USER_ID</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-disabled={{isDisabled}} ng-model=\"vm.user_id\"\n                    name=\"user_id\" required placeholder=\"user_id\">\n                <span class=\"text-danger\" ng-if=\"myForm.user_id.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>平台</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.platform\" ng-disabled={{isDisabled}} name=\"platform\"\n                    ng-options=\"item for item in platformTypes\" required>\n                </select>\n                <span class=\"text-danger\" ng-if=\"myForm.platform.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>赠送天数</label>\n            <div class=\"col-sm-10\">\n                <!-- <p class=\"input-group\">\n                    <input type=\"date\" class=\"form-control\" name=\"expires_date_ms\" uib-datepicker-popup\n                        ng-model=\"vm.expires_date_ms\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required\n                        close-text=\"Close\" />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i\n                                class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </p> -->\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.expires_date_ms\" name=\"expires_date_ms\" required\n                    placeholder=\"赠送天数\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.expires_date_ms.$error.required && myForm.$submitted==true\">必填项</span>\n                <!-- <span class=\"text-danger\"\n                    ng-if=\"myForm.expires_date_ms.$error.date && myForm.$submitted==true\">日期格式错误</span> -->\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">广告支付订单列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <select name=\"share_platform\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.sub_status\"\n                            ng-options=\"item.value as item.name for item in $ctrl.subStatus\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">订阅状态</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" ng-model=\"$ctrl.filters.user_id\" placeholder=\"请输入用户id\" type=\"number\"/>\n                    </div>\n                    <div class=\"col-xs-4\">\n                        <input class=\"form-control input-sm\" ng-model=\"$ctrl.filters.order_id\" placeholder=\"请输入订单id\" type=\"text\"/>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn-success btn-sm\" ng-click=\"$ctrl.search(true)\">搜索</button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.sub_status\">\n                            订阅状态:{{$ctrl.filters.sub_status}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.sub_status=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.user_id\">\n                            用户id:{{$ctrl.filters.user_id}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.user_id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.order_id\">\n                            订单id:{{$ctrl.filters.order_id}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.order_id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"9\">\n                                <code style=\"text-align: right\">用户总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"2\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addAdsub()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>支付ID</td>\n                            <td>用户ID</td>\n                            <td>平台</td>\n                            <td>订单ID</td>\n                            <td>原始订单ID</td>\n                            <td>token</td>\n                            <td>productID</td>\n                            <td>创建时间(UTC)</td>\n                            <td>过期时间(UTC)</td>\n                            <td>是否过期</td>\n                            <td>语言</td>\n                            <!-- <td>修改时间(UTC)</td> -->\n                            <!-- <td>操作</td> -->\n                        </tr>\n                        <tr ng-repeat=\"adsub in $ctrl.adsubs track by $index\">\n                            <td>\n                                {{adsub.pay_id}}\n                            </td>\n\n                            <td>\n                                {{adsub.user_id}}\n                            </td>\n                            <td>\n                                {{adsub.platform}}\n                            </td>\n                            <td>\n                                {{adsub.order_id}}\n                            </td>\n                            <td>\n                                {{adsub.original_transaction_id}}\n                            </td>\n                            <td>\n                                <span uib-dropdown on-toggle=\"toggled(open)\" ng-if=\"adsub.token\">\n                                    <a href id=\"simple-dropdown\" uib-dropdown-toggle>\n                                        token\n                                    </a>\n                                    <ul class=\"dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n                                        <li>\n                                            <a href>{{adsub.token}}</a>\n                                        </li>\n                                    </ul>\n                                </span>\n\n                            </td>\n                            <td>\n                                {{adsub.product_id}}\n                            </td>\n                            <td>\n                                {{adsub.purchase_date_ms | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{adsub.expires_date_ms | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td ng-if=\"adsub.is_expires === '终身'\" class=\"bg-success\">\n                                {{adsub.is_expires}}\n                            </td>\n                            <td ng-if=\"adsub.is_expires === '订阅中'\" class=\"bg-primary\">\n                                {{adsub.is_expires}}\n                            </td>\n                            <td ng-if=\"adsub.is_expires === '已过期'\" class=\"bg-danger\">\n                                {{adsub.is_expires}}\n                            </td>\n                            <td ng-if=\"adsub.is_expires === '订阅中[赠]'\" class=\"bg-warning\">\n                                {{adsub.is_expires}}\n                            </td>\n                            <td ng-if=\"adsub.is_expires === '已过期[赠]'\" class=\"bg-danger\">\n                                {{adsub.is_expires}}\n                            </td>\n                            <td>\n                                {{adsub.language_type ? adsub.language_type: 'pt'}}\n                            </td>\n                            <!-- <td>\n                                {{adsub.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td> -->\n\n                            <!-- <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\" ng-if=\"adsub.is_give === 1\"\n                                    ng-click=\"$ctrl.updateAdsub(adsub, $index)\">修改</button>\n                            </td> -->\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"11\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ShareLinkController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sharelink = __webpack_require__(217);
	
	var _sharelink2 = _interopRequireDefault(_sharelink);
	
	var _add = __webpack_require__(218);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShareLinkController = exports.ShareLinkController = function () {
	
	    /*@ngInject*/
	    ShareLinkController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function ShareLinkController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, ShareLinkController);
	
	        this.sharelinks = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.features = [{ value: 'emotion_sharing_text', name: 'emotion_sharing_text' }, { value: 'reading_sharing_text', name: 'reading_sharing_text' }, { value: 'sharing_image', name: 'sharing_image' }, { value: 'dailyverse_sharing_text', name: 'dailyverse_sharing_text' }, { value: 'sharing_audio', name: 'sharing_audio' }, { value: 'account_sharing_link', name: 'account_sharing_link' }, { value: 'sharing_covid', name: 'sharing_covid' }, { value: 'sharing_feed', name: 'sharing_feed' }, { value: 'sharing_group', name: 'sharing_group' }];
	
	        this.sharePlatforms = [{ value: 'iOS', name: 'iOS' }, { value: 'Android', name: 'Android' }];
	
	        this.openPlatforms = [{ value: 'iOS', name: 'iOS' }, { value: 'Android', name: 'Android' }];
	
	        this.firstOpen = [{ value: 0, name: '否' }, { value: 1, name: '是' }];
	
	        this.isDisabled = false;
	        this.popup2 = {
	            opened: false
	        };
	
	        this.open2 = function () {
	            this.popup2.opened = true;
	        };
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('sharelinks');
	        });
	    }
	
	    _createClass(ShareLinkController, [{
	        key: 'TransformationFirstOpen',
	        value: function TransformationFirstOpen(value) {
	            var ret = _.find(this.firstOpen, { value: value });
	            if (ret) {
	                return ret.name;
	            }
	            return '';
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/sharelinks/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.sharelinks = response.data.data;
	                        _this.socket.syncUpdates('sharelinks', _this.sharelinks);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	
	            var payload = _angular2.default.copy(this.filters);
	            if (payload && payload.createdAt) {
	                payload.createdAt = new Date(payload.createdAt).valueOf();
	            }
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/sharelinks/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.sharelinks = response.data.data;
	
	                        _this2.socket.syncUpdates('sharelinks', _this2.sharelinks);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }]);
	
	    return ShareLinkController;
	}();
	
	exports.default = _angular2.default.module('tttApp.sharelink', [_angularUiRouter2.default]).config(_sharelink2.default).component('sharelink', {
	    template: __webpack_require__(219),
	    controller: ShareLinkController
	}).name;

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('sharelink', {
	        url: '/sharelink',
	        template: '<sharelink></sharelink>'
	    });
	}

/***/ }),
/* 218 */
210,
/* 219 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">分享链接</h3>\n            </div>\n            <div class=\"panel-body\">\n\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"number\" ng-model=\"$ctrl.filters.user_id\"\n                            placeholder=\"请输入用户ID\">\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <select name=\"share_platform\" class=\"form-control input-sm\"\n                            ng-model=\"$ctrl.filters.share_platform\"\n                            ng-options=\"item.value as item.name for item in $ctrl.sharePlatforms\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">分享设备平台</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <select name=\"open_platform\" class=\"form-control input-sm\"\n                            ng-model=\"$ctrl.filters.open_platform\"\n                            ng-options=\"item.value as item.name for item in $ctrl.openPlatforms\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">打开链接平台</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <select name=\"feature\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.feature\"\n                            ng-options=\"item.value as item.name for item in $ctrl.features\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">场景</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <select name=\"first_open\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.first_open\"\n                            ng-options=\"item.value as item.name for item in $ctrl.firstOpen\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">是否首次安装</option>\n                        </select>\n                    </div>\n\n                    <div class=\"col-xs-2\">\n                        <p class=\"input-group\">\n                            <input type=\"date\" class=\"form-control\" name=\"expires_date_ms\" uib-datepicker-popup\n                                ng-model=\"$ctrl.filters.createdAt\" is-open=\"$ctrl.popup2.opened\"\n                                datepicker-options=\"dateOptions\" required close-text=\"Close\"\n                                ng-change=\"$ctrl.search(true)\" />\n                            <span class=\"input-group-btn\">\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.open2()\"><i\n                                        class=\"glyphicon glyphicon-calendar\"></i></button>\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.user_id\">\n                            用户id:{{$ctrl.filters.user_id}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.user_id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.share_platform\">\n                            分享设备平台:{{$ctrl.filters.share_platform}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.share_platform=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.open_platform\">\n                            打开链接平台:{{$ctrl.filters.open_platform}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.open_platform=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.feature\">\n                            场景:{{$ctrl.filters.feature}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.feature=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                        <label class=\"criterion btn-primary\"\n                            ng-if=\"$ctrl.filters.first_open || $ctrl.filters.first_open === 0 \">\n                            是否首次安装:{{$ctrl.TransformationFirstOpen($ctrl.filters.first_open)}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.first_open=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.createdAt\">\n                            日期:{{$ctrl.filters.createdAt | date:'yyyy-MM-dd'}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.createdAt=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"9\">\n                                <code style=\"text-align: right\">链接总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>分享ID</td>\n                            <td>用户ID</td>\n                            <td>分享平台</td>\n                            <td>打开平台</td>\n                            <td>场景</td>\n                            <td>是否首次安装</td>\n                            <td>创建时间(UTC)</td>\n                            <td>语言</td>\n                            <td>国家</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.sharelinks track by $index\">\n                            <td>\n                                {{item.share_link_id}}\n                            </td>\n                            <td>\n                                {{item.user_id}}\n                            </td>\n                            <td>\n                                {{item.share_platform}}\n                            </td>\n                            <td>\n                                {{item.open_platform}}\n                            </td>\n                            <td>\n                                {{item.feature}}\n                            </td>\n                            <td>\n                                {{item.first_open}}\n                            </td>\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{item.language_type ? item.language_type: 'pt'}}\n                            </td>\n                            <td>\n                                {{item.country}}\n                            </td>\n\n\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"9\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PushTokenController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pushtoken = __webpack_require__(221);
	
	var _pushtoken2 = _interopRequireDefault(_pushtoken);
	
	var _add = __webpack_require__(222);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PushTokenController = exports.PushTokenController = function () {
	
	    /*@ngInject*/
	    PushTokenController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function PushTokenController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, PushTokenController);
	
	        this.pushtokens = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('pushtoken');
	        });
	    }
	
	    _createClass(PushTokenController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/push_tokens/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.pushtokens = response.data.data;
	                        _this.socket.syncUpdates('pushtokens', _this.pushtokens);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/push_tokens/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.pushtokens = response.data.data;
	
	                        _this2.socket.syncUpdates('pushtokens', _this2.pushtokens);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addPushToken',
	        value: function addPushToken() {
	            var pushtokens = this.pushtokens;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.IsSubscribe = [{ value: 0, name: '非定制' }, { value: 1, name: '定制' }];
	                    $scope.IsPolling = [{ value: 0, name: '否' }, { value: 1, name: '是' }];
	                    $scope.Hours = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
	                    $scope.Minutes = ['00', '15', '30', '45'];
	                    $scope.PushTemplate = [{ value: 1, name: '第一次' }, { value: 2, name: '第二次' }];
	                    $scope.contentData = [{}];
	                    $scope.addContent = function () {
	                        $scope.contentData.push({});
	                    };
	
	                    $scope.delContent = function (index) {
	                        $scope.contentData.splice(index, 1);
	                    };
	
	                    $scope.popup2 = {
	                        opened: false
	                    };
	
	                    $scope.open2 = function () {
	                        $scope.popup2.opened = true;
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            var data = {};
	
	                            var content = "";
	                            if ($scope.vm.content) {
	                                content = eval('(' + $scope.vm.content + ')');
	                                for (var key in content) {
	                                    if (content.hasOwnProperty(key)) {
	                                        content[key] = content[key].toString();
	                                    }
	                                }
	                            }
	
	                            var push_date_time = "";
	                            if ($scope.vm.push_date_time) {
	                                var date = new Date($scope.vm.push_date_time);
	                                var y = date.getFullYear();
	                                var m = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
	                                var d = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
	                                push_date_time = '' + y + '-' + m + '-' + d + '';
	                            }
	
	                            if ($scope.vm.is_subscribe === 1) {
	                                data = {
	                                    is_subscribe: $scope.vm.is_subscribe,
	                                    push_date_time: push_date_time,
	                                    push_Template: $scope.vm.push_Template,
	                                    push_title: $scope.vm.push_title,
	                                    push_body: $scope.vm.push_body,
	                                    content: JSON.stringify(content)
	                                };
	                            } else {
	                                data = {
	                                    is_subscribe: $scope.vm.is_subscribe,
	                                    is_polling: $scope.vm.is_polling,
	                                    push_date: '' + $scope.vm.hours + ':' + $scope.vm.minutes + '',
	                                    push_date_time: push_date_time,
	                                    push_title: $scope.vm.push_title,
	                                    push_body: $scope.vm.push_body,
	                                    content: content ? JSON.stringify(content) : ''
	                                };
	                            }
	
	                            $http.post('/api/customs/', data).then(function (response) {
	                                if (response.status === 200) {
	                                    $uibModalInstance.close();
	                                }
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }]);
	
	    return PushTokenController;
	}();
	
	exports.default = _angular2.default.module('tttApp.pushtoken', [_angularUiRouter2.default]).config(_pushtoken2.default).component('pushtoken', {
	    template: __webpack_require__(223),
	    controller: PushTokenController
	}).name;

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('pushtoken', {
	        url: '/pushtoken',
	        template: '<pushtoken></pushtoken>'
	    });
	}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">推送</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>类型</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.is_subscribe\" name=\"is_subscribe\"\n                    ng-options=\"item.value as item.name for item in IsSubscribe\" required>\n                </select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.is_subscribe.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"vm.is_subscribe !== 1\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>是否轮询</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.is_polling\" name=\"is_polling\"\n                    ng-options=\"item.value as item.name for item in IsPolling\" required>\n                </select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.is_polling.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>推送时间</label>\n            <div class=\"col-sm-6\" ng-if=\"vm.is_polling !== 1\">\n                <p class=\"input-group\">\n                    <input type=\"date\" class=\"form-control\" name=\"push_date_time\" uib-datepicker-popup\n                        ng-model=\"vm.push_date_time\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required\n                        close-text=\"Close\" />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i\n                                class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </p>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.push_date_time.$error.required && myForm.$submitted==true\">必填项</span>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.push_date_time.$error.date && myForm.$submitted==true\">日期格式错误</span>\n            </div>\n            <div class=\"col-sm-2\" ng-if=\"vm.is_subscribe !== 1\">\n                <select class=\"form-control\" ng-model=\"vm.hours\" name=\"hours\" ng-options=\"item for item in Hours\"\n                    required>\n                </select>\n                <span class=\"text-danger\" ng-if=\"myForm.hours.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n            <div class=\"col-sm-2\" ng-if=\"vm.is_subscribe !== 1\">\n                <select class=\"form-control\" ng-model=\"vm.minutes\" name=\"minutes\" ng-options=\"item for item in Minutes\"\n                    required>\n                </select>\n                <span class=\"text-danger\" ng-if=\"myForm.minutes.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"vm.is_subscribe === 1\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>每日推送模板</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.push_Template\" name=\"push_Template\"\n                    ng-options=\"item.value as item.name for item in PushTemplate\" required>\n                </select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.push_Template.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>title</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.push_title\" name=\"push_title\" required\n                    placeholder=\"title\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.push_title.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>Body</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.push_body\" name=\"push_body\" required\n                    placeholder=\"Body\">\n                <span class=\"text-danger\" ng-if=\"myForm.push_body.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"vm.is_subscribe === 1\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>内容</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.content\" name=\"content\" required\n                    placeholder=\"JSON数据\">\n                <span class=\"text-danger\" ng-if=\"myForm.content.$error.required && myForm.$submitted==true\">必填项</span>\n                <span\n                    class=\"text-danger\">格式：{\"action\":\"action_voice_play\",\"speech_profile_id\":\"42\",\"speech_type_id\":\"1\"}</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"vm.is_subscribe !== 1\">\n            <label class=\"col-sm-2 control-label\">内容</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.content\" name=\"content\" placeholder=\"JSON数据\">\n                <span\n                    class=\"text-danger\">格式：{\"action\":\"action_voice_play\",\"speech_profile_id\":\"42\",\"speech_type_id\":\"1\"}</span>\n            </div>\n        </div>\n\n\n        <!-- <div class=\"form-group\" ng-repeat=\"item in contentData track by $index\">\n            <label class=\"col-sm-2 control-label\"><span ng-if=\"$first\"><span\n                        class=\"text-danger\">*</span>内容</span></label>\n            <div class=\"col-sm-3\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"item.content_key\" name=\"content_key_{{$index}}\"\n                    required placeholder=\"key\">\n            </div>\n            <div class=\"col-sm-3\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"item.content_value\" name=\"content_value_{{$index}}\"\n                    required placeholder=\"value\">\n            </div>\n            <div class=\"col-sm-2\" ng-if=\"$first\" ng-show=\"$last\">\n                <a class=\"btn btn-default\" ng-click=\"addContent()\">+</a>\n            </div>\n            <div class=\"col-sm-2\" ng-hide=\"$first\">\n                <a class=\"btn btn-default\" ng-click=\"delContent($index)\">-</a>\n            </div>\n            <div class=\"col-sm-2\" ng-if=\"!$first && $last\" ng-show=\"$last\">\n                <a class=\"btn btn-default\" ng-click=\"addContent()\">+</a>\n            </div>\n        </div> -->\n\n\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">firebasetoken列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n\n                <!-- <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <select name=\"share_platform\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.sub_status\"\n                            ng-options=\"item.value as item.name for item in $ctrl.subStatus\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">订阅状态</option>\n                        </select>\n                    </div>\n                </div> -->\n                <!-- \n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.sub_status\">\n                            订阅状态:{{$ctrl.filters.sub_status}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.sub_status=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div> -->\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"11\">\n                                <code style=\"text-align: right\">用户总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <!-- <td colspan=\"1\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addPushToken()\">推送</button>\n                            </td> -->\n                        </tr>\n                        <tr>\n                            <td>用户ID</td>\n                            <td>用户名</td>\n                            <td>设备ID</td>\n                            <td>品牌</td>\n                            <td>国家</td>\n                            <td>系统版本</td>\n                            <td>app版本</td>\n                            <td>token</td>\n                            <td>first_push</td>\n                            <td>second_push</td>\n                            <td>修改时间(UTC)</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.pushtokens track by $index\">\n                            <td>\n                                {{item.user_id}}\n                            </td>\n\n                            <td>\n                                {{item.user_name}}\n                            </td>\n                            <td>\n                                {{item.uuid}}\n                            </td>\n                            <td>\n                                {{item.brand}}\n                            </td>\n                            <td>\n                                {{item.country}}\n                            </td>\n                            <td>\n                                {{item.os_version}}\n                            </td>\n                            <td>\n                                {{item.app_version}}\n                            </td>\n                            <td>\n\n                                <span uib-dropdown on-toggle=\"toggled(open)\">\n                                    <a href id=\"simple-dropdown\" uib-dropdown-toggle>\n                                        token\n                                    </a>\n                                    <ul class=\"dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n                                        <li>\n                                            <a href> {{item.firebase_token}}</a>\n                                        </li>\n                                    </ul>\n                                </span>\n                            </td>\n\n                            <td>\n                                {{item.first_push}}\n                            </td>\n                            <td>\n                                {{item.second_push}}\n                            </td>\n                            <td>\n                                {{item.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"11\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CustomController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _custom = __webpack_require__(225);
	
	var _custom2 = _interopRequireDefault(_custom);
	
	var _add = __webpack_require__(226);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CustomController = exports.CustomController = function () {
	
	    /*@ngInject*/
	    CustomController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function CustomController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, CustomController);
	
	        this.customs = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('custom');
	        });
	    }
	
	    _createClass(CustomController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/customs/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.customs = response.data.data;
	                        _this.socket.syncUpdates('customs', _this.customs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/customs/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.customs = response.data.data;
	
	                        _this2.socket.syncUpdates('customs', _this2.customs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addPushToken',
	        value: function addPushToken() {
	            var customs = this.customs;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.IsSubscribe = [{ value: 0, name: '非定制' }, { value: 1, name: '定制' }];
	                    $scope.IsPolling = [{ value: 0, name: '否' }, { value: 1, name: '是' }];
	                    $scope.Hours = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
	                    $scope.Minutes = ['00', '15', '30', '45'];
	                    $scope.PushTemplate = [{ value: 1, name: '第一次' }, { value: 2, name: '第二次' }];
	                    $scope.languageType = [{ value: 'pt', name: 'pt' }, { value: 'en', name: 'en' }, { value: 'es', name: 'es' }];
	                    $scope.contentData = [{}];
	                    $scope.addContent = function () {
	                        $scope.contentData.push({});
	                    };
	
	                    $scope.delContent = function (index) {
	                        $scope.contentData.splice(index, 1);
	                    };
	
	                    $scope.popup2 = {
	                        opened: false
	                    };
	
	                    $scope.open2 = function () {
	                        $scope.popup2.opened = true;
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            var data = {};
	
	                            var content = "";
	                            if ($scope.vm.content) {
	                                content = eval('(' + $scope.vm.content + ')');
	                                for (var key in content) {
	                                    if (content.hasOwnProperty(key)) {
	                                        content[key] = content[key].toString();
	                                    }
	                                }
	                            }
	
	                            var push_date_time = "";
	                            if ($scope.vm.push_date_time) {
	                                var date = new Date($scope.vm.push_date_time);
	                                var y = date.getFullYear();
	                                var m = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
	                                var d = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
	                                push_date_time = '' + y + '-' + m + '-' + d + '';
	                            }
	
	                            if ($scope.vm.is_subscribe === 1) {
	                                data = {
	                                    is_subscribe: $scope.vm.is_subscribe,
	                                    push_date_time: push_date_time,
	                                    push_Template: $scope.vm.push_Template,
	                                    push_title: $scope.vm.push_title,
	                                    push_body: $scope.vm.push_body,
	                                    content: content ? JSON.stringify(content) : '',
	                                    language_type: $scope.vm.language_type
	                                };
	                            } else {
	                                data = {
	                                    is_subscribe: $scope.vm.is_subscribe,
	                                    is_polling: $scope.vm.is_polling,
	                                    push_date: '' + $scope.vm.hours + ':' + $scope.vm.minutes + '',
	                                    push_date_time: push_date_time,
	                                    push_title: $scope.vm.push_title,
	                                    push_body: $scope.vm.push_body,
	                                    content: content ? JSON.stringify(content) : '',
	                                    language_type: $scope.vm.language_type
	                                };
	                            }
	
	                            $http.post('/api/customs/', data).then(function (response) {
	                                if (response.status === 200) {
	                                    $uibModalInstance.close(response.data.data);
	                                }
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    customs.push(ret);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteCustom',
	        value: function deleteCustom(item, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/customs/' + item._id + '/').then(function (response) {
	                console.log(response);
	                if (response.status === 200) {
	                    _this3.customs.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return CustomController;
	}();
	
	exports.default = _angular2.default.module('tttApp.custom', [_angularUiRouter2.default]).config(_custom2.default).component('custom', {
	    template: __webpack_require__(227),
	    controller: CustomController
	}).name;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('custom', {
	        url: '/custom',
	        template: '<custom></custom>'
	    });
	}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">推送</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>类型</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.is_subscribe\" name=\"is_subscribe\"\n                    ng-options=\"item.value as item.name for item in IsSubscribe\" required>\n                </select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.is_subscribe.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"vm.is_subscribe !== 1\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>是否轮询</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.is_polling\" name=\"is_polling\"\n                    ng-options=\"item.value as item.name for item in IsPolling\" required>\n                </select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.is_polling.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>推送时间</label>\n            <div class=\"col-sm-6\" ng-if=\"vm.is_polling !== 1\">\n                <p class=\"input-group\">\n                    <input type=\"date\" class=\"form-control\" name=\"push_date_time\" uib-datepicker-popup\n                        ng-model=\"vm.push_date_time\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required\n                        close-text=\"Close\" />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i\n                                class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </p>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.push_date_time.$error.required && myForm.$submitted==true\">必填项</span>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.push_date_time.$error.date && myForm.$submitted==true\">日期格式错误</span>\n            </div>\n            <div class=\"col-sm-2\" ng-if=\"vm.is_subscribe !== 1\">\n                <select class=\"form-control\" ng-model=\"vm.hours\" name=\"hours\" ng-options=\"item for item in Hours\"\n                    required>\n                </select>\n                <span class=\"text-danger\" ng-if=\"myForm.hours.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n            <div class=\"col-sm-2\" ng-if=\"vm.is_subscribe !== 1\">\n                <select class=\"form-control\" ng-model=\"vm.minutes\" name=\"minutes\" ng-options=\"item for item in Minutes\"\n                    required>\n                </select>\n                <span class=\"text-danger\" ng-if=\"myForm.minutes.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"vm.is_subscribe === 1\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>每日推送模板</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.push_Template\" name=\"push_Template\"\n                    ng-options=\"item.value as item.name for item in PushTemplate\" required>\n                </select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.push_Template.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>title</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.push_title\" name=\"push_title\" required\n                    placeholder=\"title\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.push_title.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>Body</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.push_body\" name=\"push_body\" required\n                    placeholder=\"Body\">\n                <span class=\"text-danger\" ng-if=\"myForm.push_body.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <!-- <div class=\"form-group\" ng-if=\"vm.is_subscribe === 1\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>内容</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.content\" name=\"content\" required\n                    placeholder=\"JSON数据\">\n                <span class=\"text-danger\" ng-if=\"myForm.content.$error.required && myForm.$submitted==true\">必填项</span>\n                <span\n                    class=\"text-danger\">格式：{\"action\":\"action_voice_play\",\"speech_profile_id\":\"42\",\"speech_type_id\":\"1\"}</span>\n            </div>\n        </div> -->\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">内容</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.content\" name=\"content\" placeholder=\"JSON数据\">\n                <span\n                    class=\"text-danger\">格式：{\"action\":\"action_voice_play\",\"speech_profile_id\":\"42\",\"speech_type_id\":\"1\"}</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语言</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.language_type\" name=\"language_type\"\n                    ng-options=\"item.value as item.name for item in languageType\" required>\n                </select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.language_type.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n\n        <!-- <div class=\"form-group\" ng-repeat=\"item in contentData track by $index\">\n            <label class=\"col-sm-2 control-label\"><span ng-if=\"$first\"><span\n                        class=\"text-danger\">*</span>内容</span></label>\n            <div class=\"col-sm-3\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"item.content_key\" name=\"content_key_{{$index}}\"\n                    required placeholder=\"key\">\n            </div>\n            <div class=\"col-sm-3\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"item.content_value\" name=\"content_value_{{$index}}\"\n                    required placeholder=\"value\">\n            </div>\n            <div class=\"col-sm-2\" ng-if=\"$first\" ng-show=\"$last\">\n                <a class=\"btn btn-default\" ng-click=\"addContent()\">+</a>\n            </div>\n            <div class=\"col-sm-2\" ng-hide=\"$first\">\n                <a class=\"btn btn-default\" ng-click=\"delContent($index)\">-</a>\n            </div>\n            <div class=\"col-sm-2\" ng-if=\"!$first && $last\" ng-show=\"$last\">\n                <a class=\"btn btn-default\" ng-click=\"addContent()\">+</a>\n            </div>\n        </div> -->\n\n\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">推送设置列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n\n                <!-- <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <select name=\"share_platform\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.sub_status\"\n                            ng-options=\"item.value as item.name for item in $ctrl.subStatus\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">订阅状态</option>\n                        </select>\n                    </div>\n                </div> -->\n                <!-- \n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.sub_status\">\n                            订阅状态:{{$ctrl.filters.sub_status}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.sub_status=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div> -->\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"10\">\n                                <code style=\"text-align: right\">用户总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"1\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addPushToken()\">推送</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>是否定制</td>\n                            <td>推送日期</td>\n                            <td>推送时间</td>\n                            <td>推送模板</td>\n                            <td>是否轮询</td>\n                            <td>标题</td>\n                            <td>Body</td>\n                            <td>内容</td>\n                            <td>创建时间</td>\n                            <td>语言</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.customs track by $index\">\n                            <td>\n                                {{item.is_subscribe === 1 ? '是':'否'}}\n                            </td>\n\n                            <td>\n                                {{item.push_date_time}}\n                            </td>\n                            <td>\n                                {{item.push_date}}\n                            </td>\n                            <td>\n                                {{item.push_Template === 1 ? '第一次': (item.push_Template === 2 ? '第二次':'')}}\n                            </td>\n\n                            <td>\n                                {{item.is_polling === 1 ? '是':''}}\n                            </td>\n                            <td>\n                                {{item.push_title}}\n                            </td>\n                            <td>\n                                {{item.push_body}}\n                            </td>\n                            <td>\n                                {{item.content}}\n                            </td>\n                            <td>\n                                {{item.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{item.language_type}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteCustom(item, $index)\">删除</button>\n                            </td>\n\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"11\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OneDayController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _oneday = __webpack_require__(229);
	
	var _oneday2 = _interopRequireDefault(_oneday);
	
	var _add = __webpack_require__(230);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _xlsx = __webpack_require__(231);
	
	var _xlsx2 = _interopRequireDefault(_xlsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OneDayController = exports.OneDayController = function () {
	
	    /*@ngInject*/
	    OneDayController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location', '$timeout', '$state'];
	    function OneDayController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout, $state) {
	        _classCallCheck(this, OneDayController);
	
	        this.awesomeThings = [];
	        this.onedays = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	        this.$timeout = $timeout;
	        this.$state = $state;
	
	        this.languageType = [{ value: 'pt', name: '葡语' }, { value: 'es', name: '西语' }, { value: 'en', name: '英语' }];
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('oneday');
	        });
	    }
	
	    _createClass(OneDayController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/onedays/?getAll=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	                        _this.onedays = response.data.data;
	
	                        _this.socket.syncUpdates('onedays', _this.onedays);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/onedays/?getAll=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.onedays = response.data.data;
	
	                        _this2.socket.syncUpdates('onedays', _this2.onedays);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'importExcel',
	        value: function importExcel() {
	            var onedays = this.onedays;
	            var state = this.$state;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	
	                    $scope.vm = {};
	                    var excel_data = null;
	                    $scope.daoru = function (evt) {
	                        var _this3 = this;
	
	                        var target = evt.target;
	                        if (target.files.length !== 1) throw new Error('Cannot use multiple files');
	                        var reader = new FileReader();
	                        reader.onload = function (e) {
	                            var bstr = e.target.result;
	                            var wb = _xlsx2.default.WorkBook = _xlsx2.default.read(bstr, { type: 'binary' });
	
	                            var wsname = wb.SheetNames[0];
	                            var ws = _xlsx2.default.WorkSheet = wb.Sheets[wsname];
	
	                            _this3.inputdata = _xlsx2.default.utils.sheet_to_json(ws, { header: 1 });
	                            excel_data = _this3.inputdata;
	
	                            evt.target.value = "";
	                        };
	                        reader.readAsBinaryString(target.files[0]);
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (!excel_data) {
	                            alert('请上传excel');
	                        } else {
	                            $http.post('/api/onedays/', excel_data).then(function (response) {
	                                if (response.status === 200) {
	                                    $uibModalInstance.close();
	                                    state.reload();
	                                } else {
	                                    alert('格式错误');
	                                }
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'deleteOneDay',
	        value: function deleteOneDay(oneday, index) {
	            var _this4 = this;
	
	            this.$http.delete('/api/onedays/' + oneday._id).then(function (response) {
	                if (response.status === 200) {
	                    _this4.onedays.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	        //     /*@ngInject*/
	
	    }]);
	
	    return OneDayController;
	}();
	
	exports.default = _angular2.default.module('tttApp.oneday', [_angularUiRouter2.default]).config(_oneday2.default).component('oneday', {
	    template: __webpack_require__(243),
	    controller: OneDayController
	}).name;

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('oneday', {
	        url: '/oneday',
	        template: '<oneday></oneday>'
	    });
	}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>上传excel</label>\n            <div class=\"col-sm-10\">\n                <input type=\"file\" class=\"form-control\" name=\"excel_data\"\n                    onchange=\"angular.element(this).scope().daoru(event)\" multiple=\"false\" />\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.excel_data.$error.required && myForm.$submitted==true\">必填项</span> </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported XLSX */
	/*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */
	var XLSX = {};
	function make_xlsx_lib(XLSX){
	XLSX.version = '0.15.5';
	var current_codepage = 1200, current_ansi = 1252;
	/*global cptable:true, window */
	if(true) {
		if(typeof cptable === 'undefined') {
			if(typeof global !== 'undefined') global.cptable = __webpack_require__(237);
			else if(typeof window !== 'undefined') window.cptable = __webpack_require__(237);
		}
	}
	
	var VALID_ANSI = [ 874, 932, 936, 949, 950 ];
	for(var i = 0; i <= 8; ++i) VALID_ANSI.push(1250 + i);
	/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
	var CS2CP = ({
	0:    1252, /* ANSI */
	1:   65001, /* DEFAULT */
	2:   65001, /* SYMBOL */
	77:  10000, /* MAC */
	128:   932, /* SHIFTJIS */
	129:   949, /* HANGUL */
	130:  1361, /* JOHAB */
	134:   936, /* GB2312 */
	136:   950, /* CHINESEBIG5 */
	161:  1253, /* GREEK */
	162:  1254, /* TURKISH */
	163:  1258, /* VIETNAMESE */
	177:  1255, /* HEBREW */
	178:  1256, /* ARABIC */
	186:  1257, /* BALTIC */
	204:  1251, /* RUSSIAN */
	222:   874, /* THAI */
	238:  1250, /* EASTEUROPE */
	255:  1252, /* OEM */
	69:   6969  /* MISC */
	});
	
	var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
	function reset_ansi() { set_ansi(1252); }
	
	var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	function reset_cp() { set_cp(1200); reset_ansi(); }
	
	function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }
	
	function utf16leread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
		return o.join("");
	}
	function utf16beread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
		return o.join("");
	}
	
	var debom = function(data) {
		var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
		if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
		if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
		if(c1 == 0xFEFF) return data.slice(1);
		return data;
	};
	
	var _getchar = function _gc1(x) { return String.fromCharCode(x); };
	var _getansi = function _ga1(x) { return String.fromCharCode(x); };
	if(typeof cptable !== 'undefined') {
		set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
		debom = function(data) {
			if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return cptable.utils.decode(1200, char_codes(data.slice(2))); }
			return data;
		};
		_getchar = function _gc2(x) {
			if(current_codepage === 1200) return String.fromCharCode(x);
			return cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
		};
		_getansi = function _ga2(x) {
			return cptable.utils.decode(current_ansi, [x])[0];
		};
	}
	var DENSE = null;
	var DIF_XL = true;
	var Base64 = (function make_b64(){
		var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
		return {
			encode: function(input) {
				var o = "";
				var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
				for(var i = 0; i < input.length; ) {
					c1 = input.charCodeAt(i++);
					e1 = (c1 >> 2);
	
					c2 = input.charCodeAt(i++);
					e2 = ((c1 & 3) << 4) | (c2 >> 4);
	
					c3 = input.charCodeAt(i++);
					e3 = ((c2 & 15) << 2) | (c3 >> 6);
					e4 = (c3 & 63);
					if (isNaN(c2)) { e3 = e4 = 64; }
					else if (isNaN(c3)) { e4 = 64; }
					o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
				}
				return o;
			},
			decode: function b64_decode(input) {
				var o = "";
				var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
				input = input.replace(/[^\w\+\/\=]/g, "");
				for(var i = 0; i < input.length;) {
					e1 = map.indexOf(input.charAt(i++));
					e2 = map.indexOf(input.charAt(i++));
					c1 = (e1 << 2) | (e2 >> 4);
					o += String.fromCharCode(c1);
	
					e3 = map.indexOf(input.charAt(i++));
					c2 = ((e2 & 15) << 4) | (e3 >> 2);
					if (e3 !== 64) { o += String.fromCharCode(c2); }
	
					e4 = map.indexOf(input.charAt(i++));
					c3 = ((e3 & 3) << 6) | e4;
					if (e4 !== 64) { o += String.fromCharCode(c3); }
				}
				return o;
			}
		};
	})();
	var has_buf = (typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node);
	
	var Buffer_from = function(){};
	
	if(typeof Buffer !== 'undefined') {
		var nbfs = !Buffer.from;
		if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
		Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
		// $FlowIgnore
		if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
		// $FlowIgnore
		if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
	}
	
	function new_raw_buf(len) {
		/* jshint -W056 */
		return has_buf ? Buffer.alloc(len) : new Array(len);
		/* jshint +W056 */
	}
	
	function new_unsafe_buf(len) {
		/* jshint -W056 */
		return has_buf ? Buffer.allocUnsafe(len) : new Array(len);
		/* jshint +W056 */
	}
	
	var s2a = function s2a(s) {
		if(has_buf) return Buffer_from(s, "binary");
		return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
	};
	
	function s2ab(s) {
		if(typeof ArrayBuffer === 'undefined') return s2a(s);
		var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
		for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	}
	
	function a2s(data) {
		if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
		var o = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
	}
	
	function a2u(data) {
		if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
		return new Uint8Array(data);
	}
	
	function ab2a(data) {
		if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
		if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	var o = new Array(data.length);
		for(var i = 0; i < data.length; ++i) o[i] = data[i];
		return o;
	}
	
	var bconcat = function(bufs) { return [].concat.apply([], bufs); };
	
	var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
	/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	var SSF = ({});
	var make_ssf = function make_ssf(SSF){
	SSF.version = '0.10.2';
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	function isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	var days = [
		['Sun', 'Sunday'],
		['Mon', 'Monday'],
		['Tue', 'Tuesday'],
		['Wed', 'Wednesday'],
		['Thu', 'Thursday'],
		['Fri', 'Friday'],
		['Sat', 'Saturday']
	];
	var months = [
		['J', 'Jan', 'January'],
		['F', 'Feb', 'February'],
		['M', 'Mar', 'March'],
		['A', 'Apr', 'April'],
		['M', 'May', 'May'],
		['J', 'Jun', 'June'],
		['J', 'Jul', 'July'],
		['A', 'Aug', 'August'],
		['S', 'Sep', 'September'],
		['O', 'Oct', 'October'],
		['N', 'Nov', 'November'],
		['D', 'Dec', 'December']
	];
	function init_table(t) {
		t[0]=  'General';
		t[1]=  '0';
		t[2]=  '0.00';
		t[3]=  '#,##0';
		t[4]=  '#,##0.00';
		t[9]=  '0%';
		t[10]= '0.00%';
		t[11]= '0.00E+00';
		t[12]= '# ?/?';
		t[13]= '# ??/??';
		t[14]= 'm/d/yy';
		t[15]= 'd-mmm-yy';
		t[16]= 'd-mmm';
		t[17]= 'mmm-yy';
		t[18]= 'h:mm AM/PM';
		t[19]= 'h:mm:ss AM/PM';
		t[20]= 'h:mm';
		t[21]= 'h:mm:ss';
		t[22]= 'm/d/yy h:mm';
		t[37]= '#,##0 ;(#,##0)';
		t[38]= '#,##0 ;[Red](#,##0)';
		t[39]= '#,##0.00;(#,##0.00)';
		t[40]= '#,##0.00;[Red](#,##0.00)';
		t[45]= 'mm:ss';
		t[46]= '[h]:mm:ss';
		t[47]= 'mmss.0';
		t[48]= '##0.0E+0';
		t[49]= '@';
		t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
		t[65535]= 'General';
	}
	
	var table_fmt = {};
	init_table(table_fmt);
	function frac(x, D, mixed) {
		var sgn = x < 0 ? -1 : 1;
		var B = x * sgn;
		var P_2 = 0, P_1 = 1, P = 0;
		var Q_2 = 1, Q_1 = 0, Q = 0;
		var A = Math.floor(B);
		while(Q_1 < D) {
			A = Math.floor(B);
			P = A * P_1 + P_2;
			Q = A * Q_1 + Q_2;
			if((B - A) < 0.00000005) break;
			B = 1 / (B - A);
			P_2 = P_1; P_1 = P;
			Q_2 = Q_1; Q_1 = Q;
		}
		if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
		if(!mixed) return [0, sgn * P, Q];
		var q = Math.floor(sgn * P/Q);
		return [q, sgn*P - q*Q, Q];
	}
	function parse_date_code(v,opts,b2) {
		if(v > 2958465 || v < 0) return null;
		var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
		var dout=[];
		var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
		if(Math.abs(out.u) < 1e-6) out.u = 0;
		if(opts && opts.date1904) date += 1462;
		if(out.u > 0.9999) {
			out.u = 0;
			if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
		}
		if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
		else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
		else {
			if(date > 60) --date;
			/* 1 = Jan 1 1900 in Gregorian */
			var d = new Date(1900, 0, 1);
			d.setDate(d.getDate() + date - 1);
			dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
			dow = d.getDay();
			if(date < 60) dow = (dow + 6) % 7;
			if(b2) dow = fix_hijri(d, dout);
		}
		out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
		out.S = time % 60; time = Math.floor(time / 60);
		out.M = time % 60; time = Math.floor(time / 60);
		out.H = time;
		out.q = dow;
		return out;
	}
	SSF.parse_date_code = parse_date_code;
	var basedate = new Date(1899, 11, 31, 0, 0, 0);
	var dnthresh = basedate.getTime();
	var base1904 = new Date(1900, 2, 1, 0, 0, 0);
	function datenum_local(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1461*24*60*60*1000;
		else if(v >= base1904) epoch += 24*60*60*1000;
		return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
	}
	function general_fmt_int(v) { return v.toString(10); }
	SSF._general_int = general_fmt_int;
	var general_fmt_num = (function make_general_fmt_num() {
	var gnr1 = /\.(\d*[1-9])0+$/, gnr2 = /\.0*$/, gnr4 = /\.(\d*[1-9])0+/, gnr5 = /\.0*[Ee]/, gnr6 = /(E[+-])(\d)$/;
	function gfn2(v) {
		var w = (v<0?12:11);
		var o = gfn5(v.toFixed(12)); if(o.length <= w) return o;
		o = v.toPrecision(10); if(o.length <= w) return o;
		return v.toExponential(5);
	}
	function gfn3(v) {
		var o = v.toFixed(11).replace(gnr1,".$1");
		if(o.length > (v<0?12:11)) o = v.toPrecision(6);
		return o;
	}
	function gfn4(o) {
		for(var i = 0; i != o.length; ++i) if((o.charCodeAt(i) | 0x20) === 101) return o.replace(gnr4,".$1").replace(gnr5,"E").replace("e","E").replace(gnr6,"$10$2");
		return o;
	}
	function gfn5(o) {
		return o.indexOf(".") > -1 ? o.replace(gnr2,"").replace(gnr1,".$1") : o;
	}
	return function general_fmt_num(v) {
		var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
		if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
		else if(Math.abs(V) <= 9) o = gfn2(v);
		else if(V === 10) o = v.toFixed(10).substr(0,12);
		else o = gfn3(v);
		return gfn5(gfn4(o));
	};})();
	SSF._general_num = general_fmt_num;
	function general_fmt(v, opts) {
		switch(typeof v) {
			case 'string': return v;
			case 'boolean': return v ? "TRUE" : "FALSE";
			case 'number': return (v|0) === v ? general_fmt_int(v) : general_fmt_num(v);
			case 'undefined': return "";
			case 'object':
				if(v == null) return "";
				if(v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
		}
		throw new Error("unsupported value in General format: " + v);
	}
	SSF._general = general_fmt;
	function fix_hijri() { return 0; }
	/*jshint -W086 */
	function write_date(type, fmt, val, ss0) {
		var o="", ss=0, tt=0, y = val.y, out, outl = 0;
		switch(type) {
			case 98: /* 'b' buddhist year */
				y = val.y + 543;
				/* falls through */
			case 121: /* 'y' year */
			switch(fmt.length) {
				case 1: case 2: out = y % 100; outl = 2; break;
				default: out = y % 10000; outl = 4; break;
			} break;
			case 109: /* 'm' month */
			switch(fmt.length) {
				case 1: case 2: out = val.m; outl = fmt.length; break;
				case 3: return months[val.m-1][1];
				case 5: return months[val.m-1][0];
				default: return months[val.m-1][2];
			} break;
			case 100: /* 'd' day */
			switch(fmt.length) {
				case 1: case 2: out = val.d; outl = fmt.length; break;
				case 3: return days[val.q][0];
				default: return days[val.q][1];
			} break;
			case 104: /* 'h' 12-hour */
			switch(fmt.length) {
				case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 72: /* 'H' 24-hour */
			switch(fmt.length) {
				case 1: case 2: out = val.H; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 77: /* 'M' minutes */
			switch(fmt.length) {
				case 1: case 2: out = val.M; outl = fmt.length; break;
				default: throw 'bad minute format: ' + fmt;
			} break;
			case 115: /* 's' seconds */
				if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
				if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
	if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
				else tt = ss0 === 1 ? 10 : 1;
				ss = Math.round((tt)*(val.S + val.u));
				if(ss >= 60*tt) ss = 0;
				if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
				o = pad0(ss,2 + ss0);
				if(fmt === 'ss') return o.substr(0,2);
				return "." + o.substr(2,fmt.length-1);
			case 90: /* 'Z' absolute time */
			switch(fmt) {
				case '[h]': case '[hh]': out = val.D*24+val.H; break;
				case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
				case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
				default: throw 'bad abstime format: ' + fmt;
			} outl = fmt.length === 3 ? 1 : 2; break;
			case 101: /* 'e' era */
				out = y; outl = 1;
		}
		if(outl > 0) return pad0(out, outl); else return "";
	}
	/*jshint +W086 */
	function commaify(s) {
		var w = 3;
		if(s.length <= w) return s;
		var j = (s.length % w), o = s.substr(0,j);
		for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
		return o;
	}
	var write_num = (function make_write_num(){
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_cm(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_exp(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(o.indexOf("e") === -1) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				while(o.substr(0,2) === "0.") {
					o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
					o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
				}
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
		var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
		var myn = (rr - base*den), myd = den;
		return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
		return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.([0#]+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
		var o = "", cc;
		for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
			case 35: break;
			case 63: o+= " "; break;
			case 48: o+= "0"; break;
			default: o+= String.fromCharCode(cc);
		}
		return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 0;
		}
		return Math.round((val-Math.floor(val))*Math.pow(10,d));
	}
	function carry(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 1;
		}
		return 0;
	}
	function flr(val) { if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0)); return ""+Math.floor(val); }
	function write_num_flt(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_flt('n', ffmt, val);
			return '(' + write_num_flt('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = pad0r(val,0); if(o === "0") o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
			o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_flt(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = pad0r(val, 0);
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			ri = dec(val, r[1].length);
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
		}
		switch(fmt) {
			case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
			case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
			case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp2(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(!o.match(/[Ee]/)) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_int('n', ffmt, val);
			return '(' + write_num_int('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = (""+val); if(val === 0) o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
	o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
			o = o.replace(/\.(\d*)$/,function($$, $1) {
	return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_int(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = "" + val;
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
		}
		switch(fmt) {
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
			default:
				if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	return function write_num(type, fmt, val) {
		return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	};})();
	function split_fmt(fmt) {
		var out = [];
		var in_str = false/*, cc*/;
		for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
			case 34: /* '"' */
				in_str = !in_str; break;
			case 95: case 42: case 92: /* '_' '*' '\\' */
				++i; break;
			case 59: /* ';' */
				out[out.length] = fmt.substr(j,i-j);
				j = i+1;
		}
		out[out.length] = fmt.substr(j);
		if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
		return out;
	}
	SSF._split = split_fmt;
	var abstime = /\[[HhMmSs]*\]/;
	function fmt_is_date(fmt) {
		var i = 0, /*cc = 0,*/ c = "", o = "";
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': if(isgeneral(fmt, i)) i+= 6; i++; break;
				case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) ++i; ++i; break;
				case '\\': i+=2; break;
				case '_': i+=2; break;
				case '@': ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
				case 'A': case 'a':
					if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
					if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
					++i; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.match(abstime)) return true;
					break;
				case '.':
					/* falls through */
				case '0': case '#':
					while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
					break;
				case '?': while(fmt.charAt(++i) === c){/* empty */} break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
				case '(': case ')': ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
				case ' ': ++i; break;
				default: ++i; break;
			}
		}
		return false;
	}
	SSF.is_date = fmt_is_date;
	function eval_fmt(fmt, v, opts, flen) {
		var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
		var hr='H';
		/* Tokenize */
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': /* General */
					if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
					out[out.length] = {t:'G', v:'General'}; i+=7; break;
				case '"': /* Literal text */
					for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
					out[out.length] = {t:'t', v:o}; ++i; break;
				case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
					out[out.length] = {t:t, v:w}; ++i; break;
				case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
				case '@': /* Text Placeholder */
					out[out.length] = {t:'T', v:v}; ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
						if(dt==null) { dt=parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
						out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
					}
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					c = c.toLowerCase();
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
					if(v < 0) return "";
					if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
					o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
					if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
					if(c === 'h') c = hr;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case 'A': case 'a':
					var q={t:c, v:c};
					if(dt==null) dt=parse_date_code(v, opts);
					if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
					else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
					else { q.t = "t"; ++i; }
					if(dt==null && q.t === 'T') return "";
					out[out.length] = q; lst = c; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
					if(o.match(abstime)) {
						if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
						out[out.length] = {t:'Z', v:o.toLowerCase()};
						lst = o.charAt(1);
					} else if(o.indexOf("$") > -1) {
						o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
						if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
					}
					break;
				/* Numbers */
				case '.':
					if(dt != null) {
						o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
						out[out.length] = {t:'s', v:o}; break;
					}
					/* falls through */
				case '0': case '#':
					o = c; while((++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) || (c=='\\' && fmt.charAt(i+1) == "-" && i < fmt.length - 2 && "0#".indexOf(fmt.charAt(i+2))>-1)) o += c;
					out[out.length] = {t:'n', v:o}; break;
				case '?':
					o = c; while(fmt.charAt(++i) === c) o+=c;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
				case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
					out[out.length] = {t:'D', v:o}; break;
				case ' ': out[out.length] = {t:c, v:c}; ++i; break;
				default:
					if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
					out[out.length] = {t:'t', v:c}; ++i; break;
			}
		}
		var bt = 0, ss0 = 0, ssm;
		for(i=out.length-1, lst='t'; i >= 0; --i) {
			switch(out[i].t) {
				case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
				case 's':
					if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
					if(bt < 3) bt = 3;
				/* falls through */
				case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
				case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
				case 'X': /*if(out[i].v === "B2");*/
					break;
				case 'Z':
					if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
					if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
					if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
			}
		}
		switch(bt) {
			case 0: break;
			case 1:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				if(dt.M >=  60) { dt.M = 0; ++dt.H; }
				break;
			case 2:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				break;
		}
		/* replace fields */
		var nstr = "", jj;
		for(i=0; i < out.length; ++i) {
			switch(out[i].t) {
				case 't': case 'T': case ' ': case 'D': break;
				case 'X': out[i].v = ""; out[i].t = ";"; break;
				case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
	out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
					out[i].t = 't'; break;
				case 'n': case '(': case '?':
					jj = i+1;
					while(out[jj] != null && (
						(c=out[jj].t) === "?" || c === "D" ||
						((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
						(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
						(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
					)) {
						out[i].v += out[jj].v;
						out[jj] = {v:"", t:";"}; ++jj;
					}
					nstr += out[i].v;
					i = jj-1; break;
				case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
			}
		}
		var vv = "", myv, ostr;
		if(nstr.length > 0) {
			if(nstr.charCodeAt(0) == 40) /* '(' */ {
				myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
				ostr = write_num('(', nstr, myv);
			} else {
				myv = (v<0 && flen > 1 ? -v : v);
				ostr = write_num('n', nstr, myv);
				if(myv < 0 && out[0] && out[0].t == 't') {
					ostr = ostr.substr(1);
					out[0].v = "-" + out[0].v;
				}
			}
			jj=ostr.length-1;
			var decpt = out.length;
			for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
			var lasti=out.length;
			if(decpt === out.length && ostr.indexOf("E") === -1) {
				for(i=out.length-1; i>= 0;--i) {
					if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
					if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
					else if(jj < 0) out[i].v = "";
					else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			}
			else if(decpt !== out.length && ostr.indexOf("E") === -1) {
				jj = ostr.indexOf(".")-1;
				for(i=decpt; i>= 0; --i) {
					if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
					vv = out[i].v.substr(j+1);
					for(; j>=0; --j) {
						if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
				jj = ostr.indexOf(".")+1;
				for(i=decpt; i<out.length; ++i) {
					if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
					vv = out[i].v.substr(0,j);
					for(; j<out[i].v.length; ++j) {
						if(jj<ostr.length) vv += ostr.charAt(jj++);
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
			}
		}
		for(i=0; i<out.length; ++i) if(out[i] != null && 'n(?'.indexOf(out[i].t)>-1) {
			myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
			out[i].v = write_num(out[i].t, out[i].v, myv);
			out[i].t = 't';
		}
		var retval = "";
		for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
		return retval;
	}
	SSF._eval = eval_fmt;
	var cfregex = /\[[=<>]/;
	var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
	function chkcond(v, rr) {
		if(rr == null) return false;
		var thresh = parseFloat(rr[2]);
		switch(rr[1]) {
			case "=":  if(v == thresh) return true; break;
			case ">":  if(v >  thresh) return true; break;
			case "<":  if(v <  thresh) return true; break;
			case "<>": if(v != thresh) return true; break;
			case ">=": if(v >= thresh) return true; break;
			case "<=": if(v <= thresh) return true; break;
		}
		return false;
	}
	function choose_fmt(f, v) {
		var fmt = split_fmt(f);
		var l = fmt.length, lat = fmt[l-1].indexOf("@");
		if(l<4 && lat>-1) --l;
		if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
		if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
		switch(fmt.length) {
			case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
			case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
			case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
			case 4: break;
		}
		var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
		if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
		if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
			var m1 = fmt[0].match(cfregex2);
			var m2 = fmt[1].match(cfregex2);
			return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
		}
		return [l, ff];
	}
	function format(fmt,v,o) {
		if(o == null) o = {};
		var sfmt = "";
		switch(typeof fmt) {
			case "string":
				if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
				else sfmt = fmt;
				break;
			case "number":
				if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
				else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
				break;
		}
		if(isgeneral(sfmt,0)) return general_fmt(v, o);
		if(v instanceof Date) v = datenum_local(v, o.date1904);
		var f = choose_fmt(sfmt, v);
		if(isgeneral(f[1])) return general_fmt(v, o);
		if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
		else if(v === "" || v == null) return "";
		return eval_fmt(f[1], v, o, f[0]);
	}
	function load_entry(fmt, idx) {
		if(typeof idx != 'number') {
			idx = +idx || -1;
	for(var i = 0; i < 0x0188; ++i) {
	if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
				if(table_fmt[i] == fmt) { idx = i; break; }
			}
	if(idx < 0) idx = 0x187;
		}
	table_fmt[idx] = fmt;
		return idx;
	}
	SSF.load = load_entry;
	SSF._table = table_fmt;
	SSF.get_table = function get_table() { return table_fmt; };
	SSF.load_table = function load_table(tbl) {
		for(var i=0; i!=0x0188; ++i)
			if(tbl[i] !== undefined) load_entry(tbl[i], i);
	};
	SSF.init_table = init_table;
	SSF.format = format;
	};
	make_ssf(SSF);
	/* map from xlml named formats to SSF TODO: localize */
	var XLMLFormatMap/*{[string]:string}*/ = ({
		"General Number": "General",
		"General Date": SSF._table[22],
		"Long Date": "dddd, mmmm dd, yyyy",
		"Medium Date": SSF._table[15],
		"Short Date": SSF._table[14],
		"Long Time": SSF._table[19],
		"Medium Time": SSF._table[18],
		"Short Time": SSF._table[20],
		"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"Fixed": SSF._table[2],
		"Standard": SSF._table[4],
		"Percent": SSF._table[10],
		"Scientific": SSF._table[11],
		"Yes/No": '"Yes";"Yes";"No";@',
		"True/False": '"True";"True";"False";@',
		"On/Off": '"Yes";"Yes";"No";@'
	});
	
	var SSFImplicit/*{[number]:string}*/ = ({
		"5": '"$"#,##0_);\\("$"#,##0\\)',
		"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"23": 'General', "24": 'General', "25": 'General', "26": 'General',
		"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
		"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
		"36": 'm/d/yy',
		"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
		"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
		"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
		"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
		"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
		"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
		"59": '0',
		"60": '0.00',
		"61": '#,##0',
		"62": '#,##0.00',
		"63": '"$"#,##0_);\\("$"#,##0\\)',
		"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"67": '0%',
		"68": '0.00%',
		"69": '# ?/?',
		"70": '# ??/??',
		"71": 'm/d/yy',
		"72": 'm/d/yy',
		"73": 'd-mmm-yy',
		"74": 'd-mmm',
		"75": 'mmm-yy',
		"76": 'h:mm',
		"77": 'h:mm:ss',
		"78": 'm/d/yy h:mm',
		"79": 'mm:ss',
		"80": '[h]:mm:ss',
		"81": 'mmss.0'
	});
	
	/* dateNF parse TODO: move to SSF */
	var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
	function dateNF_regex(dateNF) {
		var fmt = typeof dateNF == "number" ? SSF._table[dateNF] : dateNF;
		fmt = fmt.replace(dateNFregex, "(\\d+)");
		return new RegExp("^" + fmt + "$");
	}
	function dateNF_fix(str, dateNF, match) {
		var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
		(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
			var v = parseInt(match[i+1], 10);
			switch(n.toLowerCase().charAt(0)) {
				case 'y': Y = v; break; case 'd': d = v; break;
				case 'h': H = v; break; case 's': S = v; break;
				case 'm': if(H >= 0) M = v; else m = v; break;
			}
		});
		if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
		var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
		if(datestr.length == 7) datestr = "0" + datestr;
		if(datestr.length == 8) datestr = "20" + datestr;
		var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
		if(H == -1 && M == -1 && S == -1) return datestr;
		if(Y == -1 && m == -1 && d == -1) return timestr;
		return datestr + "T" + timestr;
	}
	
	var DO_NOT_EXPORT_CFB = true;
	/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint eqnull:true */
	/*exported CFB */
	/*global module, require:false, process:false, Buffer:false, Uint8Array:false, Uint16Array:false */
	
	/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported CRC32 */
	var CRC32;
	(function (factory) {
		/*jshint ignore:start */
		/*eslint-disable */
		factory(CRC32 = {});
		/*eslint-enable */
		/*jshint ignore:end */
	}(function(CRC32) {
	CRC32.version = '1.2.0';
	/* see perf/crc32table.js */
	/*global Int32Array */
	function signed_crc_table() {
		var c = 0, table = new Array(256);
	
		for(var n =0; n != 256; ++n){
			c = n;
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			table[n] = c;
		}
	
		return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
	}
	
	var T = signed_crc_table();
	function crc32_bstr(bstr, seed) {
		var C = seed ^ -1, L = bstr.length - 1;
		for(var i = 0; i < L;) {
			C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
			C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
		}
		if(i === L) C = (C>>>8) ^ T[(C ^ bstr.charCodeAt(i))&0xFF];
		return C ^ -1;
	}
	
	function crc32_buf(buf, seed) {
		if(buf.length > 10000) return crc32_buf_8(buf, seed);
		var C = seed ^ -1, L = buf.length - 3;
		for(var i = 0; i < L;) {
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		}
		while(i < L+3) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		return C ^ -1;
	}
	
	function crc32_buf_8(buf, seed) {
		var C = seed ^ -1, L = buf.length - 7;
		for(var i = 0; i < L;) {
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		}
		while(i < L+7) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		return C ^ -1;
	}
	
	function crc32_str(str, seed) {
		var C = seed ^ -1;
		for(var i = 0, L=str.length, c, d; i < L;) {
			c = str.charCodeAt(i++);
			if(c < 0x80) {
				C = (C>>>8) ^ T[(C ^ c)&0xFF];
			} else if(c < 0x800) {
				C = (C>>>8) ^ T[(C ^ (192|((c>>6)&31)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
				C = (C>>>8) ^ T[(C ^ (240|((c>>8)&7)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|((c>>2)&63)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|(d&63)))&0xFF];
			} else {
				C = (C>>>8) ^ T[(C ^ (224|((c>>12)&15)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|((c>>6)&63)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
			}
		}
		return C ^ -1;
	}
	CRC32.table = T;
	CRC32.bstr = crc32_bstr;
	CRC32.buf = crc32_buf;
	CRC32.str = crc32_str;
	}));
	/* [MS-CFB] v20171201 */
	var CFB = (function _CFB(){
	var exports = {};
	exports.version = '1.1.3';
	/* [MS-CFB] 2.6.4 */
	function namecmp(l, r) {
		var L = l.split("/"), R = r.split("/");
		for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
			if((c = L[i].length - R[i].length)) return c;
			if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
		}
		return L.length - R.length;
	}
	function dirname(p) {
		if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(0, c+1);
	}
	
	function filename(p) {
		if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(c+1);
	}
	/* -------------------------------------------------------------------------- */
	/* DOS Date format:
	   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
	   add 1980 to stored year
	   stored second should be doubled
	*/
	
	/* write JS date to buf as a DOS date */
	function write_dos_date(buf, date) {
		if(typeof date === "string") date = new Date(date);
		var hms = date.getHours();
		hms = hms << 6 | date.getMinutes();
		hms = hms << 5 | (date.getSeconds()>>>1);
		buf.write_shift(2, hms);
		var ymd = (date.getFullYear() - 1980);
		ymd = ymd << 4 | (date.getMonth()+1);
		ymd = ymd << 5 | date.getDate();
		buf.write_shift(2, ymd);
	}
	
	/* read four bytes from buf and interpret as a DOS date */
	function parse_dos_date(buf) {
		var hms = buf.read_shift(2) & 0xFFFF;
		var ymd = buf.read_shift(2) & 0xFFFF;
		var val = new Date();
		var d = ymd & 0x1F; ymd >>>= 5;
		var m = ymd & 0x0F; ymd >>>= 4;
		val.setMilliseconds(0);
		val.setFullYear(ymd + 1980);
		val.setMonth(m-1);
		val.setDate(d);
		var S = hms & 0x1F; hms >>>= 5;
		var M = hms & 0x3F; hms >>>= 6;
		val.setHours(hms);
		val.setMinutes(M);
		val.setSeconds(S<<1);
		return val;
	}
	function parse_extra_field(blob) {
		prep_blob(blob, 0);
		var o = {};
		var flags = 0;
		while(blob.l <= blob.length - 4) {
			var type = blob.read_shift(2);
			var sz = blob.read_shift(2), tgt = blob.l + sz;
			var p = {};
			switch(type) {
				/* UNIX-style Timestamps */
				case 0x5455: {
					flags = blob.read_shift(1);
					if(flags & 1) p.mtime = blob.read_shift(4);
					/* for some reason, CD flag corresponds to LFH */
					if(sz > 5) {
						if(flags & 2) p.atime = blob.read_shift(4);
						if(flags & 4) p.ctime = blob.read_shift(4);
					}
					if(p.mtime) p.mt = new Date(p.mtime*1000);
				}
				break;
			}
			blob.l = tgt;
			o[type] = p;
		}
		return o;
	}
	var fs;
	function get_fs() { return fs || (fs = __webpack_require__(238)); }
	function parse(file, options) {
	if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
	if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
	var mver = 3;
	var ssz = 512;
	var nmfs = 0; // number of mini FAT sectors
	var difat_sec_cnt = 0;
	var dir_start = 0;
	var minifat_start = 0;
	var difat_start = 0;
	
	var fat_addrs = []; // locations of FAT sectors
	
	/* [MS-CFB] 2.2 Compound File Header */
	var blob = file.slice(0,512);
	prep_blob(blob, 0);
	
	/* major version */
	var mv = check_get_mver(blob);
	mver = mv[0];
	switch(mver) {
		case 3: ssz = 512; break; case 4: ssz = 4096; break;
		case 0: if(mv[1] == 0) return parse_zip(file, options);
		/* falls through */
		default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
	}
	
	/* reprocess header */
	if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
	/* Save header for final object */
	var header = file.slice(0,ssz);
	
	check_shifts(blob, mver);
	
	// Number of Directory Sectors
	var dir_cnt = blob.read_shift(4, 'i');
	if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
	
	// Number of FAT Sectors
	blob.l += 4;
	
	// First Directory Sector Location
	dir_start = blob.read_shift(4, 'i');
	
	// Transaction Signature
	blob.l += 4;
	
	// Mini Stream Cutoff Size
	blob.chk('00100000', 'Mini Stream Cutoff Size: ');
	
	// First Mini FAT Sector Location
	minifat_start = blob.read_shift(4, 'i');
	
	// Number of Mini FAT Sectors
	nmfs = blob.read_shift(4, 'i');
	
	// First DIFAT sector location
	difat_start = blob.read_shift(4, 'i');
	
	// Number of DIFAT Sectors
	difat_sec_cnt = blob.read_shift(4, 'i');
	
	// Grab FAT Sector Locations
	for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
		q = blob.read_shift(4, 'i');
		if(q<0) break;
		fat_addrs[j] = q;
	}
	
	/** Break the file up into sectors */
	var sectors = sectorify(file, ssz);
	
	sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
	
	/** Chains */
	var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
	
	sector_list[dir_start].name = "!Directory";
	if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
	sector_list[fat_addrs[0]].name = "!FAT";
	sector_list.fat_addrs = fat_addrs;
	sector_list.ssz = ssz;
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	var files = {}, Paths = [], FileIndex = [], FullPaths = [];
	read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
	
	build_full_paths(FileIndex, FullPaths, Paths);
	Paths.shift();
	
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	
	// $FlowIgnore
	if(options && options.raw) o.raw = {header: header, sectors: sectors};
	return o;
	} // parse
	
	/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
	function check_get_mver(blob) {
		if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
		// header signature 8
		blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
	
		// clsid 16
		//blob.chk(HEADER_CLSID, 'CLSID: ');
		blob.l += 16;
	
		// minor version 2
		var mver = blob.read_shift(2, 'u');
	
		return [blob.read_shift(2,'u'), mver];
	}
	function check_shifts(blob, mver) {
		var shift = 0x09;
	
		// Byte Order
		//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
		blob.l += 2;
	
		// Sector Shift
		switch((shift = blob.read_shift(2))) {
			case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
			case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
			default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
		}
	
		// Mini Sector Shift
		blob.chk('0600', 'Mini Sector Shift: ');
	
		// Reserved
		blob.chk('000000000000', 'Reserved: ');
	}
	
	/** Break the file up into sectors */
	function sectorify(file, ssz) {
		var nsectors = Math.ceil(file.length/ssz)-1;
		var sectors = [];
		for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
		sectors[nsectors-1] = file.slice(nsectors*ssz);
		return sectors;
	}
	
	/* [MS-CFB] 2.6.4 Red-Black Tree */
	function build_full_paths(FI, FP, Paths) {
		var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
		var dad = [], q = [];
	
		for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }
	
		for(; j < q.length; ++j) {
			i = q[j];
			L = FI[i].L; R = FI[i].R; C = FI[i].C;
			if(dad[i] === i) {
				if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
				if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
			}
			if(C !== -1 /*NOSTREAM*/) dad[C] = i;
			if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
			if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
		}
		for(i=1; i < pl; ++i) if(dad[i] === i) {
			if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
			else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
		}
	
		for(i=1; i < pl; ++i) {
			if(FI[i].type === 0 /* unknown */) continue;
			j = i;
			if(j != dad[j]) do {
				j = dad[j];
				FP[i] = FP[j] + "/" + FP[i];
			} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
			dad[i] = -1;
		}
	
		FP[0] += "/";
		for(i=1; i < pl; ++i) {
			if(FI[i].type !== 2 /* stream */) FP[i] += "/";
		}
	}
	
	function get_mfat_entry(entry, payload, mini) {
		var start = entry.start, size = entry.size;
		//return (payload.slice(start*MSSZ, start*MSSZ + size));
		var o = [];
		var idx = start;
		while(mini && size > 0 && idx >= 0) {
			o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
			size -= MSSZ;
			idx = __readInt32LE(mini, idx * 4);
		}
		if(o.length === 0) return (new_buf(0));
		return (bconcat(o).slice(0, entry.size));
	}
	
	/** Chase down the rest of the DIFAT chain to build a comprehensive list
	    DIFAT chains by storing the next sector number as the last 32 bits */
	function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
		var q = ENDOFCHAIN;
		if(idx === ENDOFCHAIN) {
			if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
		} else if(idx !== -1 /*FREESECT*/) {
			var sector = sectors[idx], m = (ssz>>>2)-1;
			if(!sector) return;
			for(var i = 0; i < m; ++i) {
				if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
				fat_addrs.push(q);
			}
			sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
		}
	}
	
	/** Follow the linked list of sectors for a given starting point */
	function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
		var buf = [], buf_chain = [];
		if(!chkd) chkd = [];
		var modulus = ssz - 1, j = 0, jj = 0;
		for(j=start; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		return {nodes: buf, data:__toBuffer([buf_chain])};
	}
	
	/** Chase down the sector linked lists */
	function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
		var sl = sectors.length, sector_list = ([]);
		var chkd = [], buf = [], buf_chain = [];
		var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
		for(i=0; i < sl; ++i) {
			buf = ([]);
			k = (i + dir_start); if(k >= sl) k-=sl;
			if(chkd[k]) continue;
			buf_chain = [];
			for(j=k; j>=0;) {
				chkd[j] = true;
				buf[buf.length] = j;
				buf_chain.push(sectors[j]);
				var addr = fat_addrs[Math.floor(j*4/ssz)];
				jj = ((j*4) & modulus);
				if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
				if(!sectors[addr]) break;
				j = __readInt32LE(sectors[addr], jj);
			}
			sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
		}
		return sector_list;
	}
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
		var minifat_store = 0, pl = (Paths.length?2:0);
		var sector = sector_list[dir_start].data;
		var i = 0, namelen = 0, name;
		for(; i < sector.length; i+= 128) {
			var blob = sector.slice(i, i+128);
			prep_blob(blob, 64);
			namelen = blob.read_shift(2);
			name = __utf16le(blob,0,namelen-pl);
			Paths.push(name);
			var o = ({
				name:  name,
				type:  blob.read_shift(1),
				color: blob.read_shift(1),
				L:     blob.read_shift(4, 'i'),
				R:     blob.read_shift(4, 'i'),
				C:     blob.read_shift(4, 'i'),
				clsid: blob.read_shift(16),
				state: blob.read_shift(4, 'i'),
				start: 0,
				size: 0
			});
			var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
			var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
			o.start = blob.read_shift(4, 'i');
			o.size = blob.read_shift(4, 'i');
			if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
			if(o.type === 5) { /* root */
				minifat_store = o.start;
				if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
				/*minifat_size = o.size;*/
			} else if(o.size >= 4096 /* MSCSZ */) {
				o.storage = 'fat';
				if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
				sector_list[o.start].name = o.name;
				o.content = (sector_list[o.start].data.slice(0,o.size));
			} else {
				o.storage = 'minifat';
				if(o.size < 0) o.size = 0;
				else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
					o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
				}
			}
			if(o.content) prep_blob(o.content, 0);
			files[name] = o;
			FileIndex.push(o);
		}
	}
	
	function read_date(blob, offset) {
		return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
	}
	
	function read_file(filename, options) {
		get_fs();
		return parse(fs.readFileSync(filename), options);
	}
	
	function read(blob, options) {
		switch(options && options.type || "base64") {
			case "file": return read_file(blob, options);
			case "base64": return parse(s2a(Base64.decode(blob)), options);
			case "binary": return parse(s2a(blob), options);
		}
		return parse(blob, options);
	}
	
	function init_cfb(cfb, opts) {
		var o = opts || {}, root = o.root || "Root Entry";
		if(!cfb.FullPaths) cfb.FullPaths = [];
		if(!cfb.FileIndex) cfb.FileIndex = [];
		if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
		if(cfb.FullPaths.length === 0) {
			cfb.FullPaths[0] = root + "/";
			cfb.FileIndex[0] = ({ name: root, type: 5 });
		}
		if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
		seed_cfb(cfb);
	}
	function seed_cfb(cfb) {
		var nm = "\u0001Sh33tJ5";
		if(CFB.find(cfb, "/" + nm)) return;
		var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
		cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
		cfb.FullPaths.push(cfb.FullPaths[0] + nm);
		rebuild_cfb(cfb);
	}
	function rebuild_cfb(cfb, f) {
		init_cfb(cfb);
		var gc = false, s = false;
		for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
			var _file = cfb.FileIndex[i];
			switch(_file.type) {
				case 0:
					if(s) gc = true;
					else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
					break;
				case 1: case 2: case 5:
					s = true;
					if(isNaN(_file.R * _file.L * _file.C)) gc = true;
					if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
					break;
				default: gc = true; break;
			}
		}
		if(!gc && !f) return;
	
		var now = new Date(1987, 1, 19), j = 0;
		var data = [];
		for(i = 0; i < cfb.FullPaths.length; ++i) {
			if(cfb.FileIndex[i].type === 0) continue;
			data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
		}
		for(i = 0; i < data.length; ++i) {
			var dad = dirname(data[i][0]);
			s = false;
			for(j = 0; j < data.length; ++j) if(data[j][0] === dad) s = true;
			if(!s) data.push([dad, ({
				name: filename(dad).replace("/",""),
				type: 1,
				clsid: HEADER_CLSID,
				ct: now, mt: now,
				content: null
			})]);
		}
	
		data.sort(function(x,y) { return namecmp(x[0], y[0]); });
		cfb.FullPaths = []; cfb.FileIndex = [];
		for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
		for(i = 0; i < data.length; ++i) {
			var elt = cfb.FileIndex[i];
			var nm = cfb.FullPaths[i];
	
			elt.name =  filename(nm).replace("/","");
			elt.L = elt.R = elt.C = -(elt.color = 1);
			elt.size = elt.content ? elt.content.length : 0;
			elt.start = 0;
			elt.clsid = (elt.clsid || HEADER_CLSID);
			if(i === 0) {
				elt.C = data.length > 1 ? 1 : -1;
				elt.size = 0;
				elt.type = 5;
			} else if(nm.slice(-1) == "/") {
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
				elt.C = j >= data.length ? -1 : j;
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
				elt.R = j >= data.length ? -1 : j;
				elt.type = 1;
			} else {
				if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
				elt.type = 2;
			}
		}
	
	}
	
	function _write(cfb, options) {
		var _opts = options || {};
		rebuild_cfb(cfb);
		if(_opts.fileType == 'zip') return write_zip(cfb, _opts);
		var L = (function(cfb){
			var mini_size = 0, fat_size = 0;
			for(var i = 0; i < cfb.FileIndex.length; ++i) {
				var file = cfb.FileIndex[i];
				if(!file.content) continue;
	var flen = file.content.length;
				if(flen > 0){
					if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
					else fat_size += (flen + 0x01FF) >> 9;
				}
			}
			var dir_cnt = (cfb.FullPaths.length +3) >> 2;
			var mini_cnt = (mini_size + 7) >> 3;
			var mfat_cnt = (mini_size + 0x7F) >> 7;
			var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
			var fat_cnt = (fat_base + 0x7F) >> 7;
			var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
			cfb.FileIndex[0].size = mini_size << 6;
			L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
			return L;
		})(cfb);
		var o = new_buf(L[7] << 9);
		var i = 0, T = 0;
		{
			for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
			for(i = 0; i < 8; ++i) o.write_shift(2, 0);
			o.write_shift(2, 0x003E);
			o.write_shift(2, 0x0003);
			o.write_shift(2, 0xFFFE);
			o.write_shift(2, 0x0009);
			o.write_shift(2, 0x0006);
			for(i = 0; i < 3; ++i) o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, L[2]);
			o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
			o.write_shift(4, 0);
			o.write_shift(4, 1<<12);
			o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
			o.write_shift(4, L[3]);
			o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
			o.write_shift(4, L[1]);
			for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
		}
		if(L[1]) {
			for(T = 0; T < L[1]; ++T) {
				for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
				o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
			}
		}
		var chainit = function(w) {
			for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
			if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
		};
		T = i = 0;
		for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
		for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
		chainit(L[3]);
		chainit(L[4]);
		var j = 0, flen = 0;
		var file = cfb.FileIndex[0];
		for(; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(flen < 0x1000) continue;
			file.start = T;
			chainit((flen + 0x01FF) >> 9);
		}
		chainit((L[6] + 7) >> 3);
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		T = i = 0;
		for(j = 0; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(!flen || flen >= 0x1000) continue;
			file.start = T;
			chainit((flen + 0x3F) >> 6);
		}
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		for(i = 0; i < L[4]<<2; ++i) {
			var nm = cfb.FullPaths[i];
			if(!nm || nm.length === 0) {
				for(j = 0; j < 17; ++j) o.write_shift(4, 0);
				for(j = 0; j < 3; ++j) o.write_shift(4, -1);
				for(j = 0; j < 12; ++j) o.write_shift(4, 0);
				continue;
			}
			file = cfb.FileIndex[i];
			if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
			var _nm = (i === 0 && _opts.root) || file.name;
			flen = 2*(_nm.length+1);
			o.write_shift(64, _nm, "utf16le");
			o.write_shift(2, flen);
			o.write_shift(1, file.type);
			o.write_shift(1, file.color);
			o.write_shift(-4, file.L);
			o.write_shift(-4, file.R);
			o.write_shift(-4, file.C);
			if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
			else o.write_shift(16, file.clsid, "hex");
			o.write_shift(4, file.state || 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, file.start);
			o.write_shift(4, file.size); o.write_shift(4, 0);
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size >= 0x1000) {
				o.l = (file.start+1) << 9;
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x1FF; ++j) o.write_shift(1, 0);
			}
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size > 0 && file.size < 0x1000) {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x3F; ++j) o.write_shift(1, 0);
			}
		}
		while(o.l < o.length) o.write_shift(1, 0);
		return o;
	}
	/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
	function find(cfb, path) {
		var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
		var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
		var k = false;
		if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
		else k = path.indexOf("/") !== -1;
		var UCPath = path.toUpperCase();
		var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
		if(w !== -1) return cfb.FileIndex[w];
	
		var m = !UCPath.match(chr1);
		UCPath = UCPath.replace(chr0,'');
		if(m) UCPath = UCPath.replace(chr1,'!');
		for(w = 0; w < UCFullPaths.length; ++w) {
			if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
			if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		}
		return null;
	}
	/** CFB Constants */
	var MSSZ = 64; /* Mini Sector Size = 1<<6 */
	//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
	/* 2.1 Compound File Sector Numbers and Types */
	var ENDOFCHAIN = -2;
	/* 2.2 Compound File Header */
	var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
	var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
	var HEADER_CLSID = '00000000000000000000000000000000';
	var consts = {
		/* 2.1 Compund File Sector Numbers and Types */
		MAXREGSECT: -6,
		DIFSECT: -4,
		FATSECT: -3,
		ENDOFCHAIN: ENDOFCHAIN,
		FREESECT: -1,
		/* 2.2 Compound File Header */
		HEADER_SIGNATURE: HEADER_SIGNATURE,
		HEADER_MINOR_VERSION: '3e00',
		MAXREGSID: -6,
		NOSTREAM: -1,
		HEADER_CLSID: HEADER_CLSID,
		/* 2.6.1 Compound File Directory Entry */
		EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
	};
	
	function write_file(cfb, filename, options) {
		get_fs();
		var o = _write(cfb, options);
	fs.writeFileSync(filename, o);
	}
	
	function a2s(o) {
		var out = new Array(o.length);
		for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
		return out.join("");
	}
	
	function write(cfb, options) {
		var o = _write(cfb, options);
		switch(options && options.type) {
			case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
			case "binary": return a2s(o);
			case "base64": return Base64.encode(a2s(o));
		}
		return o;
	}
	/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
	var _zlib;
	function use_zlib(zlib) { try {
		var InflateRaw = zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
		if(InflRaw.bytesRead) _zlib = zlib;
		else throw new Error("zlib does not expose bytesRead");
	} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }
	
	function _inflateRawSync(payload, usz) {
		if(!_zlib) return _inflate(payload, usz);
		var InflateRaw = _zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
		payload.l += InflRaw.bytesRead;
		return out;
	}
	
	function _deflateRawSync(payload) {
		return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
	}
	var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
	var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];
	
	/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
	var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];
	
	function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }
	
	var use_typed_arrays = typeof Uint8Array !== 'undefined';
	
	var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
	for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);
	
	function bit_swap_n(n, b) {
		var rev = bitswap8[n & 0xFF];
		if(b <= 8) return rev >>> (8-b);
		rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
		if(b <= 16) return rev >>> (16-b);
		rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
		return rev >>> (24-b);
	}
	
	/* helpers for unaligned bit reads */
	function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
	function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
	function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
	function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
	function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }
	
	/* works up to n = 3 * 8 + 1 = 25 */
	function read_bits_n(buf, bl, n) {
		var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
		var v = buf[h] >>> w;
		if(n < 8 - w) return v & f;
		v |= buf[h+1]<<(8-w);
		if(n < 16 - w) return v & f;
		v |= buf[h+2]<<(16-w);
		if(n < 24 - w) return v & f;
		v |= buf[h+3]<<(24-w);
		return v & f;
	}
	
	/* until ArrayBuffer#realloc is a thing, fake a realloc */
	function realloc(b, sz) {
		var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
		if(L >= sz) return b;
		if(has_buf) {
			var o = new_unsafe_buf(M);
			// $FlowIgnore
			if(b.copy) b.copy(o);
			else for(; i < b.length; ++i) o[i] = b[i];
			return o;
		} else if(use_typed_arrays) {
			var a = new Uint8Array(M);
			if(a.set) a.set(b);
			else for(; i < b.length; ++i) a[i] = b[i];
			return a;
		}
		b.length = M;
		return b;
	}
	
	/* zero-filled arrays for older browsers */
	function zero_fill_array(n) {
		var o = new Array(n);
		for(var i = 0; i < n; ++i) o[i] = 0;
		return o;
	}var _deflate = (function() {
	var _deflateRaw = (function() {
		return function deflateRaw(data, out) {
			var boff = 0;
			while(boff < data.length) {
				var L = Math.min(0xFFFF, data.length - boff);
				var h = boff + L == data.length;
				/* TODO: this is only type 0 stored */
				out.write_shift(1, +h);
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
			}
			return out.l;
		};
	})();
	
	return function(data) {
		var buf = new_buf(50+Math.floor(data.length*1.1));
		var off = _deflateRaw(data, buf);
		return buf.slice(0, off);
	};
	})();
	/* modified inflate function also moves original read head */
	
	/* build tree (used for literals and lengths) */
	function build_tree(clens, cmap, MAX) {
		var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
	
		var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
		for(i = 0; i < 32; ++i) bl_count[i] = 0;
	
		for(i = L; i < MAX; ++i) clens[i] = 0;
		L = clens.length;
	
		var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
	
		/* build code tree */
		for(i = 0; i < L; ++i) {
			bl_count[(w = clens[i])]++;
			if(maxlen < w) maxlen = w;
			ctree[i] = 0;
		}
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
		for(i = 0; i < L; ++i) {
			ccode = clens[i];
			if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
		}
	
		/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
				for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
					cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
			}
		}
		return maxlen;
	}
	
	var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
	var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
	if(!use_typed_arrays) {
		for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
		for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
	}
	(function() {
		var dlens = [];
		var i = 0;
		for(;i<32; i++) dlens.push(5);
		build_tree(dlens, fix_dmap, 32);
	
		var clens = [];
		i = 0;
		for(; i<=143; i++) clens.push(8);
		for(; i<=255; i++) clens.push(9);
		for(; i<=279; i++) clens.push(7);
		for(; i<=287; i++) clens.push(8);
		build_tree(clens, fix_lmap, 288);
	})();
	
	var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
	var dyn_len_1 = 1, dyn_len_2 = 1;
	
	/* 5.5.3 Expanding Huffman Codes */
	function dyn(data, boff) {
		/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
		var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
		var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
		var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
		var w = 0;
	
		/* grab and store code lengths */
		var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
		var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
		var maxlen = 1;
		var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var L = clens.length; /* 19 */
		for(var i = 0; i < _HCLEN; ++i) {
			clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
			if(maxlen < w) maxlen = w;
			bl_count[w]++;
			boff += 3;
		}
	
		/* build code tree */
		var ccode = 0;
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
		for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
		/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bitswap8[ctree[i]]>>(8-cleni);
				for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
			}
		}
	
		/* read literal and dist codes at once */
		var hcodes = [];
		maxlen = 1;
		for(; hcodes.length < _HLIT + _HDIST;) {
			ccode = dyn_cmap[read_bits_7(data, boff)];
			boff += ccode & 7;
			switch((ccode >>>= 3)) {
				case 16:
					w = 3 + read_bits_2(data, boff); boff += 2;
					ccode = hcodes[hcodes.length - 1];
					while(w-- > 0) hcodes.push(ccode);
					break;
				case 17:
					w = 3 + read_bits_3(data, boff); boff += 3;
					while(w-- > 0) hcodes.push(0);
					break;
				case 18:
					w = 11 + read_bits_7(data, boff); boff += 7;
					while(w -- > 0) hcodes.push(0);
					break;
				default:
					hcodes.push(ccode);
					if(maxlen < ccode) maxlen = ccode;
					break;
			}
		}
	
		/* build literal / length trees */
		var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
		for(i = _HLIT; i < 286; ++i) h1[i] = 0;
		for(i = _HDIST; i < 30; ++i) h2[i] = 0;
		dyn_len_1 = build_tree(h1, dyn_lmap, 286);
		dyn_len_2 = build_tree(h2, dyn_dmap, 30);
		return boff;
	}
	
	/* return [ data, bytesRead ] */
	function inflate(data, usz) {
		/* shortcircuit for empty buffer [0x03, 0x00] */
		if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }
	
		/* bit offset */
		var boff = 0;
	
		/* header includes final bit and type bits */
		var header = 0;
	
		var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
		var woff = 0;
		var OL = outbuf.length>>>0;
		var max_len_1 = 0, max_len_2 = 0;
	
		while((header&1) == 0) {
			header = read_bits_3(data, boff); boff += 3;
			if((header >>> 1) == 0) {
				/* Stored block */
				if(boff & 7) boff += 8 - (boff&7);
				/* 2 bytes sz, 2 bytes bit inverse */
				var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
				boff += 32;
				/* push sz bytes */
				if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
				if(typeof data.copy === 'function') {
					// $FlowIgnore
					data.copy(outbuf, woff, boff>>>3, (boff>>>3)+sz);
					woff += sz; boff += 8*sz;
				} else while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
				continue;
			} else if((header >>> 1) == 1) {
				/* Fixed Huffman */
				max_len_1 = 9; max_len_2 = 5;
			} else {
				/* Dynamic Huffman */
				boff = dyn(data, boff);
				max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
			}
			if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
			for(;;) { // while(true) is apparently out of vogue in modern JS circles
				/* ingest code and move read head */
				var bits = read_bits_n(data, boff, max_len_1);
				var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
				boff += code & 15; code >>>= 4;
				/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
				if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
				else if(code == 256) break;
				else {
					code -= 257;
					var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
					var tgt = woff + LEN_LN[code];
					/* length extra bits */
					if(len_eb > 0) {
						tgt += read_bits_n(data, boff, len_eb);
						boff += len_eb;
					}
	
					/* dist code */
					bits = read_bits_n(data, boff, max_len_2);
					code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
					boff += code & 15; code >>>= 4;
					var dst_eb = (code < 4 ? 0 : (code-2)>>1);
					var dst = DST_LN[code];
					/* dist extra bits */
					if(dst_eb > 0) {
						dst += read_bits_n(data, boff, dst_eb);
						boff += dst_eb;
					}
	
					/* in the common case, manual byte copy is faster than TA set / Buffer copy */
					if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt); OL = outbuf.length; }
					while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
				}
			}
		}
		return [usz ? outbuf : outbuf.slice(0, woff), (boff+7)>>>3];
	}
	
	function _inflate(payload, usz) {
		var data = payload.slice(payload.l||0);
		var out = inflate(data, usz);
		payload.l += out[1];
		return out[0];
	}
	
	function warn_or_throw(wrn, msg) {
		if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
		else throw new Error(msg);
	}
	
	function parse_zip(file, options) {
		var blob = file;
		prep_blob(blob, 0);
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o, { root: options.root });
	
		/* find end of central directory, start just after signature */
		var i = blob.length - 4;
		while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
		blob.l = i + 4;
	
		/* parse end of central directory */
		blob.l += 4;
		var fcnt = blob.read_shift(2);
		blob.l += 6;
		var start_cd = blob.read_shift(4);
	
		/* parse central directory */
		blob.l = start_cd;
	
		for(i = 0; i < fcnt; ++i) {
			/* trust local file header instead of CD entry */
			blob.l += 20;
			var csz = blob.read_shift(4);
			var usz = blob.read_shift(4);
			var namelen = blob.read_shift(2);
			var efsz = blob.read_shift(2);
			var fcsz = blob.read_shift(2);
			blob.l += 8;
			var offset = blob.read_shift(4);
			var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
			blob.l += namelen + efsz + fcsz;
	
			var L = blob.l;
			blob.l = offset + 4;
			parse_local_file(blob, csz, usz, o, EF);
			blob.l = L;
		}
	
		return o;
	}
	
	
	/* head starts just after local file header signature */
	function parse_local_file(blob, csz, usz, o, EF) {
		/* [local file header] */
		blob.l += 2;
		var flags = blob.read_shift(2);
		var meth = blob.read_shift(2);
		var date = parse_dos_date(blob);
	
		if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
		var crc32 = blob.read_shift(4);
		var _csz = blob.read_shift(4);
		var _usz = blob.read_shift(4);
	
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
	
		// TODO: flags & (1<<11) // UTF8
		var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
		if(efsz) {
			var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
			if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
			if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
		}
		blob.l += efsz;
	
		/* [encryption header] */
	
		/* [file data] */
		var data = blob.slice(blob.l, blob.l + _csz);
		switch(meth) {
			case 8: data = _inflateRawSync(blob, _usz); break;
			case 0: break;
			default: throw new Error("Unsupported ZIP Compression method " + meth);
		}
	
		/* [data descriptor] */
		var wrn = false;
		if(flags & 8) {
			crc32 = blob.read_shift(4);
			if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
			_csz = blob.read_shift(4);
			_usz = blob.read_shift(4);
		}
	
		if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
		if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
		var _crc32 = CRC32.buf(data, 0);
		if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
		cfb_add(o, name, data, {unsafe: true, mt: date});
	}
	function write_zip(cfb, options) {
		var _opts = options || {};
		var out = [], cdirs = [];
		var o = new_buf(1);
		var method = (_opts.compression ? 8 : 0), flags = 0;
		var desc = false;
		if(desc) flags |= 8;
		var i = 0, j = 0;
	
		var start_cd = 0, fcnt = 0;
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		var crcs = [];
		var sz_cd = 0;
	
		for(i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
			var start = start_cd;
	
			/* TODO: CP437 filename */
			var namebuf = new_buf(fp.length);
			for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
			namebuf = namebuf.slice(0, namebuf.l);
			crcs[fcnt] = CRC32.buf(fi.content, 0);
	
			var outbuf = fi.content;
			if(method == 8) outbuf = _deflateRawSync(outbuf);
	
			/* local file header */
			o = new_buf(30);
			o.write_shift(4, 0x04034b50);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			/* TODO: last mod file time/date */
			if(fi.mt) write_dos_date(o, fi.mt);
			else o.write_shift(4, 0);
			o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
			o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
			o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
	
			start_cd += o.length;
			out.push(o);
			start_cd += namebuf.length;
			out.push(namebuf);
	
			/* TODO: encryption header ? */
			start_cd += outbuf.length;
			out.push(outbuf);
	
			/* data descriptor */
			if(flags & 8) {
				o = new_buf(12);
				o.write_shift(-4, crcs[fcnt]);
				o.write_shift(4, outbuf.length);
				o.write_shift(4, fi.content.length);
				start_cd += o.l;
				out.push(o);
			}
	
			/* central directory */
			o = new_buf(46);
			o.write_shift(4, 0x02014b50);
			o.write_shift(2, 0);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			o.write_shift(4, 0); /* TODO: last mod file time/date */
			o.write_shift(-4, crcs[fcnt]);
	
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, start);
	
			sz_cd += o.l;
			cdirs.push(o);
			sz_cd += namebuf.length;
			cdirs.push(namebuf);
			++fcnt;
		}
	
		/* end of central directory */
		o = new_buf(22);
		o.write_shift(4, 0x06054b50);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, fcnt);
		o.write_shift(2, fcnt);
		o.write_shift(4, sz_cd);
		o.write_shift(4, start_cd);
		o.write_shift(2, 0);
	
		return bconcat(([bconcat((out)), bconcat(cdirs), o]));
	}
	function cfb_new(opts) {
		var o = ({});
		init_cfb(o, opts);
		return o;
	}
	
	function cfb_add(cfb, name, content, opts) {
		var unsafe = opts && opts.unsafe;
		if(!unsafe) init_cfb(cfb);
		var file = !unsafe && CFB.find(cfb, name);
		if(!file) {
			var fpath = cfb.FullPaths[0];
			if(name.slice(0, fpath.length) == fpath) fpath = name;
			else {
				if(fpath.slice(-1) != "/") fpath += "/";
				fpath = (fpath + name).replace("//","/");
			}
			file = ({name: filename(name), type: 2});
			cfb.FileIndex.push(file);
			cfb.FullPaths.push(fpath);
			if(!unsafe) CFB.utils.cfb_gc(cfb);
		}
	file.content = (content);
		file.size = content ? content.length : 0;
		if(opts) {
			if(opts.CLSID) file.clsid = opts.CLSID;
			if(opts.mt) file.mt = opts.mt;
			if(opts.ct) file.ct = opts.ct;
		}
		return file;
	}
	
	function cfb_del(cfb, name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex.splice(j, 1);
			cfb.FullPaths.splice(j, 1);
			return true;
		}
		return false;
	}
	
	function cfb_mov(cfb, old_name, new_name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, old_name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex[j].name = filename(new_name);
			cfb.FullPaths[j] = new_name;
			return true;
		}
		return false;
	}
	
	function cfb_gc(cfb) { rebuild_cfb(cfb, true); }
	
	exports.find = find;
	exports.read = read;
	exports.parse = parse;
	exports.write = write;
	exports.writeFile = write_file;
	exports.utils = {
		cfb_new: cfb_new,
		cfb_add: cfb_add,
		cfb_del: cfb_del,
		cfb_mov: cfb_mov,
		cfb_gc: cfb_gc,
		ReadShift: ReadShift,
		CheckField: CheckField,
		prep_blob: prep_blob,
		bconcat: bconcat,
		use_zlib: use_zlib,
		_deflateRaw: _deflate,
		_inflateRaw: _inflate,
		consts: consts
	};
	
	return exports;
	})();
	
	if("function" !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }
	var _fs;
	if(true) try { _fs = __webpack_require__(238); } catch(e) {}
	
	/* normalize data for blob ctor */
	function blobify(data) {
		if(typeof data === "string") return s2ab(data);
		if(Array.isArray(data)) return a2u(data);
		return data;
	}
	/* write or download file */
	function write_dl(fname, payload, enc) {
		/*global IE_SaveFile, Blob, navigator, saveAs, URL, document, File, chrome */
		if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
		var data = (enc == "utf8") ? utf8write(payload) : payload;
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
		if(typeof Blob !== 'undefined') {
			var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
	if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
	if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
			if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
				var url = URL.createObjectURL(blob);
	if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
				}
				var a = document.createElement("a");
				if(a.download != null) {
	a.download = fname; a.href = url; document.body.appendChild(a); a.click();
	document.body.removeChild(a);
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return url;
				}
			}
		}
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var out = File(fname); out.open("w"); out.encoding = "binary";
			if(Array.isArray(payload)) payload = a2s(payload);
			out.write(payload); out.close(); return payload;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("cannot save file " + fname);
	}
	
	/* read binary data from file */
	function read_binary(path) {
		if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var infile = File(path); infile.open("r"); infile.encoding = "binary";
			var data = infile.read(); infile.close();
			return data;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("Cannot access file " + path);
	}
	function keys(o) {
		var ks = Object.keys(o), o2 = [];
		for(var i = 0; i < ks.length; ++i) if(o.hasOwnProperty(ks[i])) o2.push(ks[i]);
		return o2;
	}
	
	function evert_key(obj, key) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
		return o;
	}
	
	function evert(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
		return o;
	}
	
	function evert_num(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
		return o;
	}
	
	function evert_arr(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) {
			if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
			o[obj[K[i]]].push(K[i]);
		}
		return o;
	}
	
	var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
	var dnthresh = basedate.getTime() + (new Date().getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	function datenum(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1462*24*60*60*1000;
		return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
	}
	function numdate(v) {
		var out = new Date();
		out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
		return out;
	}
	
	/* ISO 8601 Duration */
	function parse_isodur(s) {
		var sec = 0, mt = 0, time = false;
		var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
		if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
		for(var i = 1; i != m.length; ++i) {
			if(!m[i]) continue;
			mt = 1;
			if(i > 3) time = true;
			switch(m[i].slice(m[i].length-1)) {
				case 'Y':
					throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
				case 'D': mt *= 24;
					/* falls through */
				case 'H': mt *= 60;
					/* falls through */
				case 'M':
					if(!time) throw new Error("Unsupported ISO Duration Field: M");
					else mt *= 60;
					/* falls through */
				case 'S': break;
			}
			sec += mt * parseInt(m[i], 10);
		}
		return sec;
	}
	
	var good_pd_date = new Date('2017-02-19T19:06:09.000Z');
	if(isNaN(good_pd_date.getFullYear())) good_pd_date = new Date('2/19/17');
	var good_pd = good_pd_date.getFullYear() == 2017;
	/* parses a date as a local date */
	function parseDate(str, fixdate) {
		var d = new Date(str);
		if(good_pd) {
	if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
			else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
			return d;
		}
		if(str instanceof Date) return str;
		if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
			var s = d.getFullYear();
			if(str.indexOf("" + s) > -1) return d;
			d.setFullYear(d.getFullYear() + 100); return d;
		}
		var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
		var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
		if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
		return out;
	}
	
	function cc2str(arr) {
		var o = "";
		for(var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]);
		return o;
	}
	
	function dup(o) {
		if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
		if(typeof o != 'object' || o == null) return o;
		if(o instanceof Date) return new Date(o.getTime());
		var out = {};
		for(var k in o) if(o.hasOwnProperty(k)) out[k] = dup(o[k]);
		return out;
	}
	
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	
	/* TODO: stress test */
	function fuzzynum(s) {
		var v = Number(s);
		if(!isNaN(v)) return v;
		var wt = 1;
		var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
		if(!isNaN(v = Number(ss))) return v / wt;
		ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
		if(!isNaN(v = Number(ss))) return v / wt;
		return v;
	}
	function fuzzydate(s) {
		var o = new Date(s), n = new Date(NaN);
		var y = o.getYear(), m = o.getMonth(), d = o.getDate();
		if(isNaN(d)) return n;
		if(y < 0 || y > 8099) return n;
		if((m > 0 || d > 1) && y != 101) return o;
		if(s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) return o;
		if(s.match(/[^-0-9:,\/\\]/)) return n;
		return o;
	}
	
	var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
	function split_regex(str, re, def) {
		if(safe_split_regex || typeof re == "string") return str.split(re);
		var p = str.split(re), o = [p[0]];
		for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
		return o;
	}
	function getdatastr(data) {
		if(!data) return null;
		if(data.data) return debom(data.data);
		if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
		if(data.asBinary) return debom(data.asBinary());
		if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
		if(data.content && data.type) return debom(cc2str(data.content));
		return null;
	}
	
	function getdatabin(data) {
		if(!data) return null;
		if(data.data) return char_codes(data.data);
		if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
		if(data._data && data._data.getContent) {
			var o = data._data.getContent();
			if(typeof o == "string") return char_codes(o);
			return Array.prototype.slice.call(o);
		}
		if(data.content && data.type) return data.content;
		return null;
	}
	
	function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }
	
	/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
	/* OASIS does not comment on filename case sensitivity */
	function safegetzipfile(zip, file) {
		var k = zip.FullPaths || keys(zip.files);
		var f = file.toLowerCase(), g = f.replace(/\//g,'\\');
		for(var i=0; i<k.length; ++i) {
			var n = k[i].toLowerCase();
			if(f == n || g == n) return zip.files[k[i]];
		}
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	function getzipstr(zip, file, safe) {
		if(!safe) return getdatastr(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipstr(zip, file); } catch(e) { return null; }
	}
	
	function zipentries(zip) {
		var k = zip.FullPaths || keys(zip.files), o = [];
		for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i]);
		return o.sort();
	}
	
	function zip_add_file(zip, path, content) {
		if(zip.FullPaths) CFB.utils.cfb_add(zip, path, content);
		else zip.file(path, content);
	}
	
	var jszip;
	/*global JSZipSync:true */
	if(typeof JSZipSync !== 'undefined') jszip = JSZipSync;
	if(true) {
		if(typeof module !== 'undefined' && module.exports) {
			if(typeof jszip === 'undefined') jszip = __webpack_require__(239);
		}
	}
	
	function zip_new() {
		if(!jszip) return CFB.utils.cfb_new();
		return new jszip();
	}
	
	function zip_read(d, o) {
		var zip;
		if(jszip) switch(o.type) {
			case "base64": zip = new jszip(d, { base64:true }); break;
			case "binary": case "array": zip = new jszip(d, { base64:false }); break;
			case "buffer": zip = new jszip(d); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		else switch(o.type) {
			case "base64": zip = CFB.read(d, { type: "base64" }); break;
			case "binary": zip = CFB.read(d, { type: "binary" }); break;
			case "buffer": case "array": zip = CFB.read(d, { type: "buffer" }); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		return zip;
	}
	
	function resolve_path(path, base) {
		if(path.charAt(0) == "/") return path.slice(1);
		var result = base.split('/');
		if(base.slice(-1) != "/") result.pop(); // folder path
		var target = path.split('/');
		while (target.length !== 0) {
			var step = target.shift();
			if (step === '..') result.pop();
			else if (step !== '.') result.push(step);
		}
		return result.join('/');
	}
	var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
	var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
	var tagregex=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s?[\/\?]?>/g;
	
	if(!(XML_HEADER.match(tagregex))) tagregex = /<[^>]*>/g;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root, skip_LC) {
		var z = ({});
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.slice(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.slice(0,c).trim();
			while(cc.charCodeAt(c+1) == 32) ++c;
			quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
			v = cc.slice(c+1+quot, cc.length-quot);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) {
				if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
				z[q] = v;
				if(!skip_LC) z[q.toLowerCase()] = v;
			}
			else {
				var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
				if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
				z[k] = v;
				if(!skip_LC) z[k.toLowerCase()] = v;
			}
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = evert(encodings);
	//var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var unescapexml = (function() {
		/* 22.4.2.4 bstr (Basic String) */
		var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g, coderegex = /_x([\da-fA-F]{4})_/g;
		return function unescapexml(text) {
			var s = text + '', i = s.indexOf("<![CDATA[");
			if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
			var j = s.indexOf("]]>");
			return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
		};
	})();
	
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
	}
	function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }
	
	var htmlcharegex = /[\u0000-\u001f]/g;
	function escapehtml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
	}
	
	function escapexlml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
	}
	
	/* TODO: handle codepages */
	var xlml_fixstr = (function() {
		var entregex = /&#(\d+);/g;
		function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
		return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
	})();
	var xlml_unfixstr = (function() {
		return function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); };
	})();
	
	function parsexmlbool(value) {
		switch(value) {
			case 1: case true: case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	var utf8read = function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	};
	
	var utf8write = function(orig) {
		var out = [], i = 0, c = 0, d = 0;
		while(i < orig.length) {
			c = orig.charCodeAt(i++);
			switch(true) {
				case c < 128: out.push(String.fromCharCode(c)); break;
				case c < 2048:
					out.push(String.fromCharCode(192 + (c >> 6)));
					out.push(String.fromCharCode(128 + (c & 63)));
					break;
				case c >= 55296 && c < 57344:
					c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
					out.push(String.fromCharCode(240 + ((d >>18) & 7)));
					out.push(String.fromCharCode(144 + ((d >>12) & 63)));
					out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
					out.push(String.fromCharCode(128 + (d & 63)));
					break;
				default:
					out.push(String.fromCharCode(224 + (c >> 12)));
					out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
					out.push(String.fromCharCode(128 + (c & 63)));
			}
		}
		return out.join("");
	};
	
	if(has_buf) {
		var utf8readb = function utf8readb(data) {
			var out = Buffer.alloc(2*data.length), w, i, j = 1, k = 0, ww=0, c;
			for(i = 0; i < data.length; i+=j) {
				j = 1;
				if((c=data.charCodeAt(i)) < 128) w = c;
				else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
				else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
				else { j = 4;
					w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
					w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
				}
				if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
				out[k++] = w%256; out[k++] = w>>>8;
			}
			return out.slice(0,k).toString('ucs2');
		};
		var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
		if(utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
		var utf8readc = function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); };
		if(utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;
	
		utf8write = function(data) { return Buffer_from(data, 'utf8').toString("binary"); };
	}
	
	// matches <foo>...</foo> extracts content
	var matchtag = (function() {
		var mtcache = ({});
		return function matchtag(f,g) {
			var t = f+"|"+(g||"");
			if(mtcache[t]) return mtcache[t];
			return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
		};
	})();
	
	var htmldecode = (function() {
		var entities = [
			['nbsp', ' '], ['middot', '·'],
			['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
		].map(function(x) { return [new RegExp('&' + x[0] + ';', "g"), x[1]]; });
		return function htmldecode(str) {
			var o = str
					// Remove new lines and spaces from start of content
					.replace(/^[\t\n\r ]+/, "")
					// Remove new lines and spaces from end of content
					.replace(/[\t\n\r ]+$/,"")
					// Added line which removes any white space characters after and before html tags
					.replace(/>\s+/g,">").replace(/\s+</g,"<")
					// Replace remaining new lines and spaces with space
					.replace(/[\t\n\r ]+/g, " ")
					// Replace <br> tags with new lines
					.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
					// Strip HTML elements
					.replace(/<[^>]*>/g,"");
			for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
			return o;
		};
	})();
	
	var vtregex = (function(){ var vt_cache = {};
		return function vt_regex(bt) {
			if(vt_cache[bt] !== undefined) return vt_cache[bt];
			return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
	};})();
	var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
	function parseVector(data, opts) {
		var h = parsexmltag(data);
	
		var matches = data.match(vtregex(h.baseType))||[];
		var res = [];
		if(matches.length != h.size) {
			if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
			return res;
		}
		matches.forEach(function(x) {
			var v = x.replace(vtvregex,"").match(vtmregex);
			if(v) res.push({v:utf8read(v[2]), t:v[1]});
		});
		return res;
	}
	
	var wtregex = /(^\s|\s$|\n)/;
	function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }
	
	function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
	function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}
	
	function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }
	
	function write_vt(s) {
		switch(typeof s) {
			case 'string': return writextag('vt:lpwstr', escapexml(s));
			case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
			case 'boolean': return writextag('vt:bool',s?'true':'false');
		}
		if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
		throw new Error("Unable to serialize " + s);
	}
	
	var XMLNS = ({
		'dc': 'http://purl.org/dc/elements/1.1/',
		'dcterms': 'http://purl.org/dc/terms/',
		'dcmitype': 'http://purl.org/dc/dcmitype/',
		'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
		'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
		'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
		'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
		'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
		'xsd': 'http://www.w3.org/2001/XMLSchema'
	});
	
	XMLNS.main = [
		'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
		'http://purl.oclc.org/ooxml/spreadsheetml/main',
		'http://schemas.microsoft.com/office/excel/2006/main',
		'http://schemas.microsoft.com/office/excel/2006/2'
	];
	
	var XLMLNS = ({
		'o':    'urn:schemas-microsoft-com:office:office',
		'x':    'urn:schemas-microsoft-com:office:excel',
		'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
		'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
		'mv':   'http://macVmlSchemaUri',
		'v':    'urn:schemas-microsoft-com:vml',
		'html': 'http://www.w3.org/TR/REC-html40'
	});
	function read_double_le(b, idx) {
		var s = 1 - 2 * (b[idx + 7] >>> 7);
		var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
		var m = (b[idx+6]&0x0f);
		for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
		if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
		if(e == 0) e = -1022;
		else { e -= 1023; m += Math.pow(2,52); }
		return s * Math.pow(2, e - 52) * m;
	}
	
	function write_double_le(b, v, idx) {
		var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
		var av = bs ? (-v) : v;
		if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
		else if(av == 0) e = m = 0;
		else {
			e = Math.floor(Math.log(av) / Math.LN2);
			m = av * Math.pow(2, 52 - e);
			if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
			else { m -= Math.pow(2,52); e+=1023; }
		}
		for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
		b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
		b[idx + 7] = (e >> 4) | bs;
	}
	
	var __toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
	var ___toBuffer = __toBuffer;
	var __utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
	var ___utf16le = __utf16le;
	var __hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
	var ___hexlify = __hexlify;
	var __utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
	var ___utf8 = __utf8;
	var __lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___lpstr = __lpstr;
	var __cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___cpstr = __cpstr;
	var __lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___lpwstr = __lpwstr;
	var __lpp4, ___lpp4;
	__lpp4 = ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
	var __8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
	var ___8lpp4 = __8lpp4;
	var __double, ___double;
	__double = ___double = function(b, idx) { return read_double_le(b, idx);};
	var is_buf = function is_buf_a(a) { return Array.isArray(a); };
	
	if(has_buf) {
		__utf16le = function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; };
		__hexlify = function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
		__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
		__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
		__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
		__utf8 = function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); };
		__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs);};
		bconcat = function(bufs) { return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : [].concat.apply([], bufs); };
		__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
		is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a); };
	}
	
	/* from js-xls */
	if(typeof cptable !== 'undefined') {
		__utf16le = function(b,s,e) { return cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
		__utf8 = function(b,s,e) { return cptable.utils.decode(65001, b.slice(s,e)); };
		__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
		__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
		__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
		__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
		__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
	}
	
	var __readUInt8 = function(b, idx) { return b[idx]; };
	var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
	var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
	var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
	var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
	var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };
	
	function ReadShift(size, t) {
		var o="", oI, oR, oo=[], w, vv, i, loc;
		switch(t) {
			case 'dbcs':
				loc = this.l;
				if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
				else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
				size *= 2;
				break;
	
			case 'utf8': o = __utf8(this, this.l, this.l + size); break;
			case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;
	
			case 'wstr':
				if(typeof cptable !== 'undefined') o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
				else return ReadShift.call(this, size, 'dbcs');
				size = 2 * size; break;
	
			/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
			case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
			case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
			/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
			case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
			/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
			case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;
	
			case 'cstr': size = 0; o = "";
				while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
				o = oo.join(""); break;
			case '_wstr': size = 0; o = "";
				while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
				size+=2; o = oo.join(""); break;
	
			/* sbcs and dbcs support continue records in the SST way TODO codepages */
			case 'dbcs-cont': o = ""; loc = this.l;
				for(i = 0; i < size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt16LE(this, loc)));
					loc+=2;
				} o = oo.join(""); size *= 2; break;
	
			case 'cpstr':
				if(typeof cptable !== 'undefined') {
					o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
					break;
				}
			/* falls through */
			case 'sbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt8(this, loc)));
					loc+=1;
				} o = oo.join(""); break;
	
			default:
		switch(size) {
			case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
			case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
			case 4: case -4:
				if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
				else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
			case 8: case -8:
				if(t === 'f') {
					if(size == 8) oR = __double(this, this.l);
					else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
					this.l += 8; return oR;
				} else size = 8;
			/* falls through */
			case 16: o = __hexlify(this, this.l, size); break;
		}}
		this.l+=size; return o;
	}
	
	var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
	var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
	var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };
	
	function WriteShift(t, val, f) {
		var size = 0, i = 0;
		if(f === 'dbcs') {
	for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
			size = 2 * val.length;
		} else if(f === 'sbcs') {
			if(typeof cptable !== 'undefined' && current_ansi == 874) {
				/* TODO: use tables directly, don't encode */
	for(i = 0; i != val.length; ++i) {
					var cppayload = cptable.utils.encode(current_ansi, val.charAt(i));
					this[this.l + i] = cppayload[0];
				}
			} else {
	val = val.replace(/[^\x00-\x7F]/g, "_");
	for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
			}
			size = val.length;
		} else if(f === 'hex') {
			for(; i < t; ++i) {
	this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
			} return this;
		} else if(f === 'utf16le') {
	var end = Math.min(this.l + t, this.length);
				for(i = 0; i < Math.min(val.length, t); ++i) {
					var cc = val.charCodeAt(i);
					this[this.l++] = (cc & 0xff);
					this[this.l++] = (cc >> 8);
				}
				while(this.l < end) this[this.l++] = 0;
				return this;
		} else  switch(t) {
			case  1: size = 1; this[this.l] = val&0xFF; break;
			case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
			case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
			case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
			case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
			/* falls through */
			case 16: break;
			case -4: size = 4; __writeInt32LE(this, val, this.l); break;
		}
		this.l += size; return this;
	}
	
	function CheckField(hexstr, fld) {
		var m = __hexlify(this,this.l,hexstr.length>>1);
		if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
		this.l += hexstr.length>>1;
	}
	
	function prep_blob(blob, pos) {
		blob.l = pos;
		blob.read_shift = ReadShift;
		blob.chk = CheckField;
		blob.write_shift = WriteShift;
	}
	
	function parsenoop(blob, length) { blob.l += length; }
	
	function new_buf(sz) {
		var o = new_raw_buf(sz);
		prep_blob(o, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.4 Record */
	function recordhopper(data, cb, opts) {
		if(!data) return;
		var tmpbyte, cntbyte, length;
		prep_blob(data, data.l || 0);
		var L = data.length, RT = 0, tgt = 0;
		while(data.l < L) {
			RT = data.read_shift(1);
			if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
			var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
			tmpbyte = data.read_shift(1);
			length = tmpbyte & 0x7F;
			for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
			tgt = data.l + length;
			var d = (R.f||parsenoop)(data, length, opts);
			data.l = tgt;
			if(cb(d, R.n, RT)) return;
		}
	}
	
	/* control buffer usage for fixed-length buffers */
	function buf_array() {
		var bufs = [], blksz = has_buf ? 256 : 2048;
		var newblk = function ba_newblk(sz) {
			var o = (new_buf(sz));
			prep_blob(o, 0);
			return o;
		};
	
		var curbuf = newblk(blksz);
	
		var endbuf = function ba_endbuf() {
			if(!curbuf) return;
			if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
			if(curbuf.length > 0) bufs.push(curbuf);
			curbuf = null;
		};
	
		var next = function ba_next(sz) {
			if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
			endbuf();
			return (curbuf = newblk(Math.max(sz+1, blksz)));
		};
	
		var end = function ba_end() {
			endbuf();
			return __toBuffer([bufs]);
		};
	
		var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };
	
		return ({ next:next, push:push, end:end, _bufs:bufs });
	}
	
	function write_record(ba, type, payload, length) {
		var t = +XLSBRE[type], l;
		if(isNaN(t)) return; // TODO: throw something here?
		if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
		l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
		if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
		var o = ba.next(l);
		if(t <= 0x7F) o.write_shift(1, t);
		else {
			o.write_shift(1, (t & 0x7F) + 0x80);
			o.write_shift(1, (t >> 7));
		}
		for(var i = 0; i != 4; ++i) {
			if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
			else { o.write_shift(1, length); break; }
		}
		if(length > 0 && is_buf(payload)) ba.push(payload);
	}
	/* XLS ranges enforced */
	function shift_cell_xls(cell, tgt, opts) {
		var out = dup(cell);
		if(tgt.s) {
			if(out.cRel) out.c += tgt.s.c;
			if(out.rRel) out.r += tgt.s.r;
		} else {
			if(out.cRel) out.c += tgt.c;
			if(out.rRel) out.r += tgt.r;
		}
		if(!opts || opts.biff < 12) {
			while(out.c >= 0x100) out.c -= 0x100;
			while(out.r >= 0x10000) out.r -= 0x10000;
		}
		return out;
	}
	
	function shift_range_xls(cell, range, opts) {
		var out = dup(cell);
		out.s = shift_cell_xls(out.s, range.s, opts);
		out.e = shift_cell_xls(out.e, range.s, opts);
		return out;
	}
	
	function encode_cell_xls(c, biff) {
		if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
		if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
		var s = encode_cell(c);
		if(!c.cRel && c.cRel != null) s = fix_col(s);
		if(!c.rRel && c.rRel != null) s = fix_row(s);
		return s;
	}
	
	function encode_range_xls(r, opts) {
		if(r.s.r == 0 && !r.s.rRel) {
			if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
				return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
			}
		}
		if(r.s.c == 0 && !r.s.cRel) {
			if(r.e.c == (opts.biff >= 12 ? 0xFFFF : 0xFF) && !r.e.cRel) {
				return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
			}
		}
		return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
	}
	var OFFCRYPTO = {};
	
	var make_offcrypto = function(O, _crypto) {
		var crypto;
		if(typeof _crypto !== 'undefined') crypto = _crypto;
		else if(true) {
			try { crypto = __webpack_require__(241); }
			catch(e) { crypto = null; }
		}
	
		O.rc4 = function(key, data) {
			var S = new Array(256);
			var c = 0, i = 0, j = 0, t = 0;
			for(i = 0; i != 256; ++i) S[i] = i;
			for(i = 0; i != 256; ++i) {
				j = (j + S[i] + (key[i%key.length]).charCodeAt(0))&255;
				t = S[i]; S[i] = S[j]; S[j] = t;
			}
			// $FlowIgnore
			i = j = 0; var out = Buffer(data.length);
			for(c = 0; c != data.length; ++c) {
				i = (i + 1)&255;
				j = (j + S[i])%256;
				t = S[i]; S[i] = S[j]; S[j] = t;
				out[c] = (data[c] ^ S[(S[i]+S[j])&255]);
			}
			return out;
		};
	
		O.md5 = function(hex) {
			if(!crypto) throw new Error("Unsupported crypto");
			return crypto.createHash('md5').update(hex).digest('hex');
		};
	};
	/*global crypto:true */
	make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);
	
	function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
	function encode_row(row) { return "" + (row + 1); }
	function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
	function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }
	
	function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
	function encode_col(col) { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
	function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
	function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }
	
	function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
	function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
	function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
	function decode_range(range) { var x =range.split(":").map(decode_cell); return {s:x[0],e:x[x.length-1]}; }
	function encode_range(cs,ce) {
		if(typeof ce === 'undefined' || typeof ce === 'number') {
	return encode_range(cs.s, cs.e);
		}
	if(typeof cs !== 'string') cs = encode_cell((cs));
		if(typeof ce !== 'string') ce = encode_cell((ce));
	return cs == ce ? cs : cs + ":" + ce;
	}
	
	function safe_decode_range(range) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		var idx = 0, i = 0, cc = 0;
		var len = range.length;
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.s.c = --idx;
	
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.s.r = --idx;
	
		if(i === len || range.charCodeAt(++i) === 58) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.e.c = --idx;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.e.r = --idx;
		return o;
	}
	
	function safe_format_cell(cell, v) {
		var q = (cell.t == 'd' && v instanceof Date);
		if(cell.z != null) try { return (cell.w = SSF.format(cell.z, q ? datenum(v) : v)); } catch(e) { }
		try { return (cell.w = SSF.format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
	}
	
	function format_cell(cell, v, o) {
		if(cell == null || cell.t == null || cell.t == 'z') return "";
		if(cell.w !== undefined) return cell.w;
		if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
		if(v == undefined) return safe_format_cell(cell, cell.v);
		return safe_format_cell(cell, v);
	}
	
	function sheet_to_workbook(sheet, opts) {
		var n = opts && opts.sheet ? opts.sheet : "Sheet1";
		var sheets = {}; sheets[n] = sheet;
		return { SheetNames: [n], Sheets: sheets };
	}
	
	function sheet_add_aoa(_ws, data, opts) {
		var o = opts || {};
		var dense = _ws ? Array.isArray(_ws) : o.dense;
		if(DENSE != null && dense == null) dense = DENSE;
		var ws = _ws || (dense ? ([]) : ({}));
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.s.c = _range.s.c;
			range.s.r = _range.s.r;
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) range.e.r = _R = _range.e.r + 1;
		}
		for(var R = 0; R != data.length; ++R) {
			if(!data[R]) continue;
			if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
			for(var C = 0; C != data[R].length; ++C) {
				if(typeof data[R][C] === 'undefined') continue;
				var cell = ({v: data[R][C] });
				var __R = _R + R, __C = _C + C;
				if(range.s.r > __R) range.s.r = __R;
				if(range.s.c > __C) range.s.c = __C;
				if(range.e.r < __R) range.e.r = __R;
				if(range.e.c < __C) range.e.c = __C;
				if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
				else {
					if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
					if(cell.v === null) { if(cell.f) cell.t = 'n'; else if(!o.sheetStubs) continue; else cell.t = 'z'; }
					else if(typeof cell.v === 'number') cell.t = 'n';
					else if(typeof cell.v === 'boolean') cell.t = 'b';
					else if(cell.v instanceof Date) {
						cell.z = o.dateNF || SSF._table[14];
						if(o.cellDates) { cell.t = 'd'; cell.w = SSF.format(cell.z, datenum(cell.v)); }
						else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF.format(cell.z, cell.v); }
					}
					else cell.t = 's';
				}
				if(dense) {
					if(!ws[__R]) ws[__R] = [];
					if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
					ws[__R][__C] = cell;
				} else {
					var cell_ref = encode_cell(({c:__C,r:__R}));
					if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
					ws[cell_ref] = cell;
				}
			}
		}
		if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
		return ws;
	}
	function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }
	
	function write_UInt32LE(x, o) {
		if(!o) o = new_buf(4);
		o.write_shift(4, x);
		return o;
	}
	
	/* [MS-XLSB] 2.5.168 */
	function parse_XLWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLWideString(data, o) {
		var _null = false; if(o == null) { _null = true; o = new_buf(4+2*data.length); }
		o.write_shift(4, data.length);
		if(data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.143 */
	function parse_StrRun(data) {
		return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
	}
	function write_StrRun(run, o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, run.ich || 0);
		o.write_shift(2, run.ifnt || 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.121 */
	function parse_RichStr(data, length) {
		var start = data.l;
		var flags = data.read_shift(1);
		var str = parse_XLWideString(data);
		var rgsStrRun = [];
		var z = ({ t: str, h: str });
		if((flags & 1) !== 0) { /* fRichStr */
			/* TODO: formatted string */
			var dwSizeStrRun = data.read_shift(4);
			for(var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
			z.r = rgsStrRun;
		}
		else z.r = [{ich:0, ifnt:0}];
		//if((flags & 2) !== 0) { /* fExtStr */
		//	/* TODO: phonetic string */
		//}
		data.l = start + length;
		return z;
	}
	function write_RichStr(str, o) {
		/* TODO: formatted string */
		var _null = false; if(o == null) { _null = true; o = new_buf(15+4*str.t.length); }
		o.write_shift(1,0);
		write_XLWideString(str.t, o);
		return _null ? o.slice(0, o.l) : o;
	}
	/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
	var parse_BrtCommentText = parse_RichStr;
	function write_BrtCommentText(str, o) {
		/* TODO: formatted string */
		var _null = false; if(o == null) { _null = true; o = new_buf(23+4*str.t.length); }
		o.write_shift(1,1);
		write_XLWideString(str.t, o);
		o.write_shift(4,1);
		write_StrRun({ich:0,ifnt:0}, o);
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.9 */
	function parse_XLSBCell(data) {
		var col = data.read_shift(4);
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) <<16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c:col, iStyleRef: iStyleRef };
	}
	function write_XLSBCell(cell, o) {
		if(o == null) o = new_buf(8);
		o.write_shift(-4, cell.c);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	
	/* [MS-XLSB] 2.5.21 */
	var parse_XLSBCodeName = parse_XLWideString;
	var write_XLSBCodeName = write_XLWideString;
	
	/* [MS-XLSB] 2.5.166 */
	function parse_XLNullableWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLNullableWideString(data, o) {
		var _null = false; if(o == null) { _null = true; o = new_buf(127); }
		o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
		if(data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.165 */
	var parse_XLNameWideString = parse_XLWideString;
	//var write_XLNameWideString = write_XLWideString;
	
	/* [MS-XLSB] 2.5.114 */
	var parse_RelID = parse_XLNullableWideString;
	var write_RelID = write_XLNullableWideString;
	
	
	/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
	function parse_RkNumber(data) {
		var b = data.slice(data.l, data.l+4);
		var fX100 = (b[0] & 1), fInt = (b[0] & 2);
		data.l+=4;
		b[0] &= 0xFC; // b[0] &= ~3;
		var RK = fInt === 0 ? __double([0,0,0,0,b[0],b[1],b[2],b[3]],0) : __readInt32LE(b,0)>>2;
		return fX100 ? (RK/100) : RK;
	}
	function write_RkNumber(data, o) {
		if(o == null) o = new_buf(4);
		var fX100 = 0, fInt = 0, d100 = data * 100;
		if((data == (data | 0)) && (data >= -(1<<29)) && (data < (1 << 29))) { fInt = 1; }
		else if((d100 == (d100 | 0)) && (d100 >= -(1<<29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
		if(fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
		else throw new Error("unsupported RkNumber " + data); // TODO
	}
	
	
	/* [MS-XLSB] 2.5.117 RfX */
	function parse_RfX(data ) {
		var cell = ({s: {}, e: {}});
		cell.s.r = data.read_shift(4);
		cell.e.r = data.read_shift(4);
		cell.s.c = data.read_shift(4);
		cell.e.c = data.read_shift(4);
		return cell;
	}
	function write_RfX(r, o) {
		if(!o) o = new_buf(16);
		o.write_shift(4, r.s.r);
		o.write_shift(4, r.e.r);
		o.write_shift(4, r.s.c);
		o.write_shift(4, r.e.c);
		return o;
	}
	
	/* [MS-XLSB] 2.5.153 UncheckedRfX */
	var parse_UncheckedRfX = parse_RfX;
	var write_UncheckedRfX = write_RfX;
	
	
	/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
	/* TODO: error checking, NaN and Infinity values are not valid Xnum */
	function parse_Xnum(data) { return data.read_shift(8, 'f'); }
	function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }
	
	/* [MS-XLSB] 2.5.97.2 */
	var BErr = {
	0x00: "#NULL!",
	0x07: "#DIV/0!",
	0x0F: "#VALUE!",
	0x17: "#REF!",
	0x1D: "#NAME?",
	0x24: "#NUM!",
	0x2A: "#N/A",
	0x2B: "#GETTING_DATA",
	0xFF: "#WTF?"
	};
	var RBErr = evert_num(BErr);
	
	/* [MS-XLSB] 2.4.324 BrtColor */
	function parse_BrtColor(data) {
		var out = {};
		var d = data.read_shift(1);
	
		//var fValidRGB = d & 1;
		var xColorType = d >>> 1;
	
		var index = data.read_shift(1);
		var nTS = data.read_shift(2, 'i');
		var bR = data.read_shift(1);
		var bG = data.read_shift(1);
		var bB = data.read_shift(1);
		data.l++; //var bAlpha = data.read_shift(1);
	
		switch(xColorType) {
			case 0: out.auto = 1; break;
			case 1:
				out.index = index;
				var icv = XLSIcv[index];
				/* automatic pseudo index 81 */
				if(icv) out.rgb = rgb2Hex(icv);
				break;
			case 2:
				/* if(!fValidRGB) throw new Error("invalid"); */
				out.rgb = rgb2Hex([bR, bG, bB]);
				break;
			case 3: out.theme = index; break;
		}
		if(nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
	
		return out;
	}
	function write_BrtColor(color, o) {
		if(!o) o = new_buf(8);
		if(!color||color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
		if(color.index != null) {
			o.write_shift(1, 0x02);
			o.write_shift(1, color.index);
		} else if(color.theme != null) {
			o.write_shift(1, 0x06);
			o.write_shift(1, color.theme);
		} else {
			o.write_shift(1, 0x05);
			o.write_shift(1, 0);
		}
		var nTS = color.tint || 0;
		if(nTS > 0) nTS *= 32767;
		else if(nTS < 0) nTS *= 32768;
		o.write_shift(2, nTS);
		if(!color.rgb || color.theme != null) {
			o.write_shift(2, 0);
			o.write_shift(1, 0);
			o.write_shift(1, 0);
		} else {
			var rgb = (color.rgb || 'FFFFFF');
			if(typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
			o.write_shift(1, parseInt(rgb.slice(0,2),16));
			o.write_shift(1, parseInt(rgb.slice(2,4),16));
			o.write_shift(1, parseInt(rgb.slice(4,6),16));
			o.write_shift(1, 0xFF);
		}
		return o;
	}
	
	/* [MS-XLSB] 2.5.52 */
	function parse_FontFlags(data) {
		var d = data.read_shift(1);
		data.l++;
		var out = {
			fBold: d & 0x01,
			fItalic: d & 0x02,
			fUnderline: d & 0x04,
			fStrikeout: d & 0x08,
			fOutline: d & 0x10,
			fShadow: d & 0x20,
			fCondense: d & 0x40,
			fExtend: d & 0x80
		};
		return out;
	}
	function write_FontFlags(font, o) {
		if(!o) o = new_buf(2);
		var grbit =
			(font.italic   ? 0x02 : 0) |
			(font.strike   ? 0x08 : 0) |
			(font.outline  ? 0x10 : 0) |
			(font.shadow   ? 0x20 : 0) |
			(font.condense ? 0x40 : 0) |
			(font.extend   ? 0x80 : 0);
		o.write_shift(1, grbit);
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-OLEDS] 2.3.1 and 2.3.2 */
	function parse_ClipboardFormatOrString(o, w) {
		// $FlowIgnore
		var ClipFmt = {2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};
		var m = o.read_shift(4);
		switch(m) {
			case 0x00000000: return "";
			case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)]||"";
		}
		if(m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
		o.l -= 4;
		return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
	}
	function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
	function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }
	
	/* [MS-OLEPS] 2.2 PropertyType */
	//var VT_EMPTY    = 0x0000;
	//var VT_NULL     = 0x0001;
	var VT_I2       = 0x0002;
	var VT_I4       = 0x0003;
	//var VT_R4       = 0x0004;
	//var VT_R8       = 0x0005;
	//var VT_CY       = 0x0006;
	//var VT_DATE     = 0x0007;
	//var VT_BSTR     = 0x0008;
	//var VT_ERROR    = 0x000A;
	var VT_BOOL     = 0x000B;
	var VT_VARIANT  = 0x000C;
	//var VT_DECIMAL  = 0x000E;
	//var VT_I1       = 0x0010;
	//var VT_UI1      = 0x0011;
	//var VT_UI2      = 0x0012;
	var VT_UI4      = 0x0013;
	//var VT_I8       = 0x0014;
	//var VT_UI8      = 0x0015;
	//var VT_INT      = 0x0016;
	//var VT_UINT     = 0x0017;
	var VT_LPSTR    = 0x001E;
	//var VT_LPWSTR   = 0x001F;
	var VT_FILETIME = 0x0040;
	var VT_BLOB     = 0x0041;
	//var VT_STREAM   = 0x0042;
	//var VT_STORAGE  = 0x0043;
	//var VT_STREAMED_Object  = 0x0044;
	//var VT_STORED_Object    = 0x0045;
	//var VT_BLOB_Object      = 0x0046;
	var VT_CF       = 0x0047;
	//var VT_CLSID    = 0x0048;
	//var VT_VERSIONED_STREAM = 0x0049;
	var VT_VECTOR   = 0x1000;
	//var VT_ARRAY    = 0x2000;
	
	var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
	var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
	var VT_CUSTOM   = [VT_STRING, VT_USTR];
	
	/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
	var DocSummaryPIDDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Category', t: VT_STRING },
	0x03: { n: 'PresentationFormat', t: VT_STRING },
	0x04: { n: 'ByteCount', t: VT_I4 },
	0x05: { n: 'LineCount', t: VT_I4 },
	0x06: { n: 'ParagraphCount', t: VT_I4 },
	0x07: { n: 'SlideCount', t: VT_I4 },
	0x08: { n: 'NoteCount', t: VT_I4 },
	0x09: { n: 'HiddenCount', t: VT_I4 },
	0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
	0x0b: { n: 'ScaleCrop', t: VT_BOOL },
	0x0c: { n: 'HeadingPairs', t: VT_VECTOR | VT_VARIANT },
	0x0d: { n: 'TitlesOfParts', t: VT_VECTOR | VT_LPSTR },
	0x0e: { n: 'Manager', t: VT_STRING },
	0x0f: { n: 'Company', t: VT_STRING },
	0x10: { n: 'LinksUpToDate', t: VT_BOOL },
	0x11: { n: 'CharacterCount', t: VT_I4 },
	0x13: { n: 'SharedDoc', t: VT_BOOL },
	0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
	0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
	0x18: { n: 'DigSig', t: VT_BLOB },
	0x1A: { n: 'ContentType', t: VT_STRING },
	0x1B: { n: 'ContentStatus', t: VT_STRING },
	0x1C: { n: 'Language', t: VT_STRING },
	0x1D: { n: 'Version', t: VT_STRING },
	0xFF: {}
	};
	
	/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
	var SummaryPIDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Title', t: VT_STRING },
	0x03: { n: 'Subject', t: VT_STRING },
	0x04: { n: 'Author', t: VT_STRING },
	0x05: { n: 'Keywords', t: VT_STRING },
	0x06: { n: 'Comments', t: VT_STRING },
	0x07: { n: 'Template', t: VT_STRING },
	0x08: { n: 'LastAuthor', t: VT_STRING },
	0x09: { n: 'RevNumber', t: VT_STRING },
	0x0A: { n: 'EditTime', t: VT_FILETIME },
	0x0B: { n: 'LastPrinted', t: VT_FILETIME },
	0x0C: { n: 'CreatedDate', t: VT_FILETIME },
	0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
	0x0E: { n: 'PageCount', t: VT_I4 },
	0x0F: { n: 'WordCount', t: VT_I4 },
	0x10: { n: 'CharCount', t: VT_I4 },
	0x11: { n: 'Thumbnail', t: VT_CF },
	0x12: { n: 'Application', t: VT_STRING },
	0x13: { n: 'DocSecurity', t: VT_I4 },
	0xFF: {}
	};
	
	/* [MS-OLEPS] 2.18 */
	var SpecialProperties = {
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	(function() {
		for(var y in SpecialProperties) if(SpecialProperties.hasOwnProperty(y))
		DocSummaryPIDDSI[y] = SummaryPIDSI[y] = SpecialProperties[y];
	})();
	
	var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
	var SummaryRE = evert_key(SummaryPIDSI, "n");
	
	/* [MS-XLS] 2.4.63 Country/Region codes */
	var CountryEnum = {
	0x0001: "US", // United States
	0x0002: "CA", // Canada
	0x0003: "", // Latin America (except Brazil)
	0x0007: "RU", // Russia
	0x0014: "EG", // Egypt
	0x001E: "GR", // Greece
	0x001F: "NL", // Netherlands
	0x0020: "BE", // Belgium
	0x0021: "FR", // France
	0x0022: "ES", // Spain
	0x0024: "HU", // Hungary
	0x0027: "IT", // Italy
	0x0029: "CH", // Switzerland
	0x002B: "AT", // Austria
	0x002C: "GB", // United Kingdom
	0x002D: "DK", // Denmark
	0x002E: "SE", // Sweden
	0x002F: "NO", // Norway
	0x0030: "PL", // Poland
	0x0031: "DE", // Germany
	0x0034: "MX", // Mexico
	0x0037: "BR", // Brazil
	0x003d: "AU", // Australia
	0x0040: "NZ", // New Zealand
	0x0042: "TH", // Thailand
	0x0051: "JP", // Japan
	0x0052: "KR", // Korea
	0x0054: "VN", // Viet Nam
	0x0056: "CN", // China
	0x005A: "TR", // Turkey
	0x0069: "JS", // Ramastan
	0x00D5: "DZ", // Algeria
	0x00D8: "MA", // Morocco
	0x00DA: "LY", // Libya
	0x015F: "PT", // Portugal
	0x0162: "IS", // Iceland
	0x0166: "FI", // Finland
	0x01A4: "CZ", // Czech Republic
	0x0376: "TW", // Taiwan
	0x03C1: "LB", // Lebanon
	0x03C2: "JO", // Jordan
	0x03C3: "SY", // Syria
	0x03C4: "IQ", // Iraq
	0x03C5: "KW", // Kuwait
	0x03C6: "SA", // Saudi Arabia
	0x03CB: "AE", // United Arab Emirates
	0x03CC: "IL", // Israel
	0x03CE: "QA", // Qatar
	0x03D5: "IR", // Iran
	0xFFFF: "US"  // United States
	};
	
	/* [MS-XLS] 2.5.127 */
	var XLSFillPattern = [
		null,
		'solid',
		'mediumGray',
		'darkGray',
		'lightGray',
		'darkHorizontal',
		'darkVertical',
		'darkDown',
		'darkUp',
		'darkGrid',
		'darkTrellis',
		'lightHorizontal',
		'lightVertical',
		'lightDown',
		'lightUp',
		'lightGrid',
		'lightTrellis',
		'gray125',
		'gray0625'
	];
	
	function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }
	
	/* [MS-XLS] 2.5.161 */
	/* [MS-XLSB] 2.5.75 Icv */
	var _XLSIcv = rgbify([
		/* Color Constants */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		/* Overridable Defaults */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		0x800000,
		0x008000,
		0x000080,
		0x808000,
		0x800080,
		0x008080,
		0xC0C0C0,
		0x808080,
		0x9999FF,
		0x993366,
		0xFFFFCC,
		0xCCFFFF,
		0x660066,
		0xFF8080,
		0x0066CC,
		0xCCCCFF,
	
		0x000080,
		0xFF00FF,
		0xFFFF00,
		0x00FFFF,
		0x800080,
		0x800000,
		0x008080,
		0x0000FF,
		0x00CCFF,
		0xCCFFFF,
		0xCCFFCC,
		0xFFFF99,
		0x99CCFF,
		0xFF99CC,
		0xCC99FF,
		0xFFCC99,
	
		0x3366FF,
		0x33CCCC,
		0x99CC00,
		0xFFCC00,
		0xFF9900,
		0xFF6600,
		0x666699,
		0x969696,
		0x003366,
		0x339966,
		0x003300,
		0x333300,
		0x993300,
		0x993366,
		0x333399,
		0x333333,
	
		/* Other entries to appease BIFF8/12 */
		0xFFFFFF, /* 0x40 icvForeground ?? */
		0x000000, /* 0x41 icvBackground ?? */
		0x000000, /* 0x42 icvFrame ?? */
		0x000000, /* 0x43 icv3D ?? */
		0x000000, /* 0x44 icv3DText ?? */
		0x000000, /* 0x45 icv3DHilite ?? */
		0x000000, /* 0x46 icv3DShadow ?? */
		0x000000, /* 0x47 icvHilite ?? */
		0x000000, /* 0x48 icvCtlText ?? */
		0x000000, /* 0x49 icvCtlScrl ?? */
		0x000000, /* 0x4A icvCtlInv ?? */
		0x000000, /* 0x4B icvCtlBody ?? */
		0x000000, /* 0x4C icvCtlFrame ?? */
		0x000000, /* 0x4D icvCtlFore ?? */
		0x000000, /* 0x4E icvCtlBack ?? */
		0x000000, /* 0x4F icvCtlNeutral */
		0x000000, /* 0x50 icvInfoBk ?? */
		0x000000 /* 0x51 icvInfoText ?? */
	]);
	var XLSIcv = dup(_XLSIcv);
	/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
	/* 12.3 Part Summary <SpreadsheetML> */
	/* 14.2 Part Summary <DrawingML> */
	/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
	var ct2type/*{[string]:string}*/ = ({
		/* Workbook */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
	
		/* Worksheet */
		"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */
	
		/* Macrosheet */
		"application/vnd.ms-excel.intlmacrosheet": "TODO",
		"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */
	
		/* File Properties */
		"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
		"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
		"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
	
		/* Custom Data Properties */
		"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
	
		/* PivotTable */
		"application/vnd.ms-excel.pivotTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
	
		/* Chart Objects */
		"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	
		/* Chart Colors */
		"application/vnd.ms-office.chartcolorstyle+xml": "TODO",
	
		/* Chart Style */
		"application/vnd.ms-office.chartstyle+xml": "TODO",
	
		/* Chart Advanced */
		"application/vnd.ms-office.chartex+xml": "TODO",
	
		/* Calculation Chain */
		"application/vnd.ms-excel.calcChain": "calcchains",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
	
		/* Printer Settings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
	
		/* ActiveX */
		"application/vnd.ms-office.activeX": "TODO",
		"application/vnd.ms-office.activeX+xml": "TODO",
	
		/* Custom Toolbars */
		"application/vnd.ms-excel.attachedToolbars": "TODO",
	
		/* External Data Connections */
		"application/vnd.ms-excel.connections": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
	
		/* External Links */
		"application/vnd.ms-excel.externalLink": "links",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
	
		/* Metadata */
		"application/vnd.ms-excel.sheetMetadata": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",
	
		/* PivotCache */
		"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
		"application/vnd.ms-excel.pivotCacheRecords": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
	
		/* Query Table */
		"application/vnd.ms-excel.queryTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
	
		/* Shared Workbook */
		"application/vnd.ms-excel.userNames": "TODO",
		"application/vnd.ms-excel.revisionHeaders": "TODO",
		"application/vnd.ms-excel.revisionLog": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
	
		/* Single Cell Table */
		"application/vnd.ms-excel.tableSingleCells": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
	
		/* Slicer */
		"application/vnd.ms-excel.slicer": "TODO",
		"application/vnd.ms-excel.slicerCache": "TODO",
		"application/vnd.ms-excel.slicer+xml": "TODO",
		"application/vnd.ms-excel.slicerCache+xml": "TODO",
	
		/* Sort Map */
		"application/vnd.ms-excel.wsSortMap": "TODO",
	
		/* Table */
		"application/vnd.ms-excel.table": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
	
		/* Themes */
		"application/vnd.openxmlformats-officedocument.theme+xml": "themes",
	
		/* Theme Override */
		"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
	
		/* Timeline */
		"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
		"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */
	
		/* VBA */
		"application/vnd.ms-office.vbaProject": "vba",
		"application/vnd.ms-office.vbaProjectSignature": "vba",
	
		/* Volatile Dependencies */
		"application/vnd.ms-office.volatileDependencies": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
	
		/* Control Properties */
		"application/vnd.ms-excel.controlproperties+xml": "TODO",
	
		/* Data Model */
		"application/vnd.openxmlformats-officedocument.model+data": "TODO",
	
		/* Survey */
		"application/vnd.ms-excel.Survey+xml": "TODO",
	
		/* Drawing */
		"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
		"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
	
		/* VML */
		"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
	
		"application/vnd.openxmlformats-package.relationships+xml": "rels",
		"application/vnd.openxmlformats-officedocument.oleObject": "TODO",
	
		/* Image */
		"image/png": "TODO",
	
		"sheet": "js"
	});
	
	var CT_LIST = (function(){
		var o = {
			workbooks: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
				xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
				xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
				xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
				xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
			},
			strs: { /* Shared Strings */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
				xlsb: "application/vnd.ms-excel.sharedStrings"
			},
			comments: { /* Comments */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
				xlsb: "application/vnd.ms-excel.comments"
			},
			sheets: { /* Worksheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
				xlsb: "application/vnd.ms-excel.worksheet"
			},
			charts: { /* Chartsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
				xlsb: "application/vnd.ms-excel.chartsheet"
			},
			dialogs: { /* Dialogsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
				xlsb: "application/vnd.ms-excel.dialogsheet"
			},
			macros: { /* Macrosheet (Excel 4.0 Macros) */
				xlsx: "application/vnd.ms-excel.macrosheet+xml",
				xlsb: "application/vnd.ms-excel.macrosheet"
			},
			styles: { /* Styles */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
				xlsb: "application/vnd.ms-excel.styles"
			}
		};
		keys(o).forEach(function(k) { ["xlsm", "xlam"].forEach(function(v) { if(!o[k][v]) o[k][v] = o[k].xlsx; }); });
		keys(o).forEach(function(k){ keys(o[k]).forEach(function(v) { ct2type[o[k][v]] = k; }); });
		return o;
	})();
	
	var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);
	
	XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';
	
	function new_ct() {
		return ({
			workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
			rels:[], strs:[], comments:[], links:[],
			coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
			calcchains:[], vba: [], drawings: [],
			TODO:[], xmlns: "" });
	}
	
	function parse_ct(data) {
		var ct = new_ct();
		if(!data || !data.match) return ct;
		var ctext = {};
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0].replace(nsregex,"<")) {
				case '<?xml': break;
				case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
				case '<Default': ctext[y.Extension] = y.ContentType; break;
				case '<Override':
					if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
					break;
			}
		});
		if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
		ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
		ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
		ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
		ct.defaults = ctext;
		delete ct.calcchains;
		return ct;
	}
	
	var CTYPE_XML_ROOT = writextag('Types', null, {
		'xmlns': XMLNS.CT,
		'xmlns:xsd': XMLNS.xsd,
		'xmlns:xsi': XMLNS.xsi
	});
	
	var CTYPE_DEFAULTS = [
		['xml', 'application/xml'],
		['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
		['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
		['data', 'application/vnd.openxmlformats-officedocument.model+data'],
		/* from test files */
		['bmp', 'image/bmp'],
		['png', 'image/png'],
		['gif', 'image/gif'],
		['emf', 'image/x-emf'],
		['wmf', 'image/x-wmf'],
		['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
		['tif', 'image/tiff'], ['tiff', 'image/tiff'],
		['pdf', 'application/pdf'],
		['rels', type2ct.rels[0]]
	].map(function(x) {
		return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
	});
	
	function write_ct(ct, opts) {
		var o = [], v;
		o[o.length] = (XML_HEADER);
		o[o.length] = (CTYPE_XML_ROOT);
		o = o.concat(CTYPE_DEFAULTS);
	
		/* only write first instance */
		var f1 = function(w) {
			if(ct[w] && ct[w].length > 0) {
				v = ct[w][0];
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
				}));
			}
		};
	
		/* book type-specific */
		var f2 = function(w) {
			(ct[w]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
				}));
			});
		};
	
		/* standard type */
		var f3 = function(t) {
			(ct[t]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': type2ct[t][0]
				}));
			});
		};
	
		f1('workbooks');
		f2('sheets');
		f2('charts');
		f3('themes');
		['strs', 'styles'].forEach(f1);
		['coreprops', 'extprops', 'custprops'].forEach(f3);
		f3('vba');
		f3('comments');
		f3('drawings');
		if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 9.3 Relationships */
	var RELS = ({
		WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
		VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
		XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
		XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
		XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
		VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
	});
	
	/* 9.3.3 Representing Relationships */
	function get_rels_path(file) {
		var n = file.lastIndexOf("/");
		return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
	}
	
	function parse_rels(data, currentFilePath) {
		var rels = {"!id":{}};
		if (!data) return rels;
		if (currentFilePath.charAt(0) !== '/') {
			currentFilePath = '/'+currentFilePath;
		}
		var hash = {};
	
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			/* 9.3.2.2 OPC_Relationships */
			if (y[0] === '<Relationship') {
				var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; rel.TargetMode = y.TargetMode;
				var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
				rels[canonictarget] = rel;
				hash[y.Id] = rel;
			}
		});
		rels["!id"] = hash;
		return rels;
	}
	
	XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';
	
	var RELS_ROOT = writextag('Relationships', null, {
		//'xmlns:ns0': XMLNS.RELS,
		'xmlns': XMLNS.RELS
	});
	
	/* TODO */
	function write_rels(rels) {
		var o = [XML_HEADER, RELS_ROOT];
		keys(rels['!id']).forEach(function(rid) {
			o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
		});
		if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	var RELS_EXTERN = [RELS.HLINK, RELS.XPATH, RELS.XMISS];
	function add_rels(rels, rId, f, type, relobj, targetmode) {
		if(!relobj) relobj = {};
		if(!rels['!id']) rels['!id'] = {};
		if(rId < 0) for(rId = 1; rels['!id']['rId' + rId]; ++rId){/* empty */}
		relobj.Id = 'rId' + rId;
		relobj.Type = type;
		relobj.Target = f;
		if(targetmode) relobj.TargetMode = targetmode;
		else if(RELS_EXTERN.indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
		if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
		rels['!id'][relobj.Id] = relobj;
		rels[('/' + relobj.Target).replace("//","/")] = relobj;
		return rId;
	}
	/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
	/* Part 3 Section 4 Manifest File */
	var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
	function parse_manifest(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var FEtag;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'manifest': break; // 4.2 <manifest:manifest>
			case 'file-entry': // 4.3 <manifest:file-entry>
				FEtag = parsexmltag(Rn[0], false);
				if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
				break;
			case 'encryption-data': // 4.4 <manifest:encryption-data>
			case 'algorithm': // 4.5 <manifest:algorithm>
			case 'start-key-generation': // 4.6 <manifest:start-key-generation>
			case 'key-derivation': // 4.7 <manifest:key-derivation>
				throw new Error("Unsupported ODS Encryption");
			default: if(opts && opts.WTF) throw Rn;
		}
	}
	
	function write_manifest(manifest) {
		var o = [XML_HEADER];
		o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
		o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
		for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
		o.push('</manifest:manifest>');
		return o.join("");
	}
	
	/* Part 3 Section 6 Metadata Manifest File */
	function write_rdf_type(file, res, tag) {
		return [
			'  <rdf:Description rdf:about="' + file + '">\n',
			'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf_has(base, file) {
		return [
			'  <rdf:Description rdf:about="' + base + '">\n',
			'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf(rdf) {
		var o = [XML_HEADER];
		o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
		for(var i = 0; i != rdf.length; ++i) {
			o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
			o.push(write_rdf_has("",rdf[i][0]));
		}
		o.push(write_rdf_type("","Document", "pkg"));
		o.push('</rdf:RDF>');
		return o.join("");
	}
	/* TODO: pull properties */
	var write_meta_ods = (function() {
		var payload = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
		return function wmo() {
			return payload;
		};
	})();
	
	/* ECMA-376 Part II 11.1 Core Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var CORE_PROPS = [
		["cp:category", "Category"],
		["cp:contentStatus", "ContentStatus"],
		["cp:keywords", "Keywords"],
		["cp:lastModifiedBy", "LastAuthor"],
		["cp:lastPrinted", "LastPrinted"],
		["cp:revision", "RevNumber"],
		["cp:version", "Version"],
		["dc:creator", "Author"],
		["dc:description", "Comments"],
		["dc:identifier", "Identifier"],
		["dc:language", "Language"],
		["dc:subject", "Subject"],
		["dc:title", "Title"],
		["dcterms:created", "CreatedDate", 'date'],
		["dcterms:modified", "ModifiedDate", 'date']
	];
	
	XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
	RELS.CORE_PROPS  = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';
	
	var CORE_PROPS_REGEX = (function() {
		var r = new Array(CORE_PROPS.length);
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
			r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
		}
		return r;
	})();
	
	function parse_core_props(data) {
		var p = {};
		data = utf8read(data);
	
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
			if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
			if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
		}
	
		return p;
	}
	
	var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
		//'xmlns': XMLNS.CORE_PROPS,
		'xmlns:cp': XMLNS.CORE_PROPS,
		'xmlns:dc': XMLNS.dc,
		'xmlns:dcterms': XMLNS.dcterms,
		'xmlns:dcmitype': XMLNS.dcmitype,
		'xmlns:xsi': XMLNS.xsi
	});
	
	function cp_doit(f, g, h, o, p) {
		if(p[f] != null || g == null || g === "") return;
		p[f] = g;
		g = escapexml(g);
		o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
	}
	
	function write_core_props(cp, _opts) {
		var opts = _opts || {};
		var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {};
		if(!cp && !opts.Props) return o.join("");
	
		if(cp) {
			if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
			if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		}
	
		for(var i = 0; i != CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
			if(v === true) v = "1";
			else if(v === false) v = "0";
			else if(typeof v == "number") v = String(v);
			if(v != null) cp_doit(f[0], v, null, o, p);
		}
		if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.3 Extended File Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var EXT_PROPS = [
		["Application", "Application", "string"],
		["AppVersion", "AppVersion", "string"],
		["Company", "Company", "string"],
		["DocSecurity", "DocSecurity", "string"],
		["Manager", "Manager", "string"],
		["HyperlinksChanged", "HyperlinksChanged", "bool"],
		["SharedDoc", "SharedDoc", "bool"],
		["LinksUpToDate", "LinksUpToDate", "bool"],
		["ScaleCrop", "ScaleCrop", "bool"],
		["HeadingPairs", "HeadingPairs", "raw"],
		["TitlesOfParts", "TitlesOfParts", "raw"]
	];
	
	XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
	RELS.EXT_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';
	
	var PseudoPropsPairs = [
		"Worksheets",  "SheetNames",
		"NamedRanges", "DefinedNames",
		"Chartsheets", "ChartNames"
	];
	function load_props_pairs(HP, TOP, props, opts) {
		var v = [];
		if(typeof HP == "string") v = parseVector(HP, opts);
		else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
		var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
		var idx = 0, len = 0;
		if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
			len = +(v[i+1].v);
			switch(v[i].v) {
				case "Worksheets":
				case "工作表":
				case "Листы":
				case "أوراق العمل":
				case "ワークシート":
				case "גליונות עבודה":
				case "Arbeitsblätter":
				case "Çalışma Sayfaları":
				case "Feuilles de calcul":
				case "Fogli di lavoro":
				case "Folhas de cálculo":
				case "Planilhas":
				case "Regneark":
				case "Hojas de cálculo":
				case "Werkbladen":
					props.Worksheets = len;
					props.SheetNames = parts.slice(idx, idx + len);
					break;
	
				case "Named Ranges":
				case "Rangos con nombre":
				case "名前付き一覧":
				case "Benannte Bereiche":
				case "Navngivne områder":
					props.NamedRanges = len;
					props.DefinedNames = parts.slice(idx, idx + len);
					break;
	
				case "Charts":
				case "Diagramme":
					props.Chartsheets = len;
					props.ChartNames = parts.slice(idx, idx + len);
					break;
			}
			idx += len;
		}
	}
	
	function parse_ext_props(data, p, opts) {
		var q = {}; if(!p) p = {};
		data = utf8read(data);
	
		EXT_PROPS.forEach(function(f) {
			var xml = (data.match(matchtag(f[0]))||[])[1];
			switch(f[2]) {
				case "string": p[f[1]] = unescapexml(xml||""); break;
				case "bool": p[f[1]] = xml === "true"; break;
				case "raw":
					var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
					if(cur && cur.length > 0) q[f[1]] = cur[1];
					break;
			}
		});
	
		if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
	
		return p;
	}
	
	var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
		'xmlns': XMLNS.EXT_PROPS,
		'xmlns:vt': XMLNS.vt
	});
	
	function write_ext_props(cp) {
		var o = [], W = writextag;
		if(!cp) cp = {};
		cp.Application = "SheetJS";
		o[o.length] = (XML_HEADER);
		o[o.length] = (EXT_PROPS_XML_ROOT);
	
		EXT_PROPS.forEach(function(f) {
			if(cp[f[1]] === undefined) return;
			var v;
			switch(f[2]) {
				case 'string': v = escapexml(String(cp[f[1]])); break;
				case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
			}
			if(v !== undefined) o[o.length] = (W(f[0], v));
		});
	
		/* TODO: HeadingPairs, TitlesOfParts */
		o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
		o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
		if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.2 Custom File Properties Part */
	XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
	RELS.CUST_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';
	
	var custregex = /<[^>]+>[^<]*/g;
	function parse_cust_props(data, opts) {
		var p = {}, name = "";
		var m = data.match(custregex);
		if(m) for(var i = 0; i != m.length; ++i) {
			var x = m[i], y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				case '<Properties': break;
				case '<property': name = unescapexml(y.name); break;
				case '</property>': name = null; break;
				default: if (x.indexOf('<vt:') === 0) {
					var toks = x.split('>');
					var type = toks[0].slice(4), text = toks[1];
					/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
					switch(type) {
						case 'lpstr': case 'bstr': case 'lpwstr':
							p[name] = unescapexml(text);
							break;
						case 'bool':
							p[name] = parsexmlbool(text);
							break;
						case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
							p[name] = parseInt(text, 10);
							break;
						case 'r4': case 'r8': case 'decimal':
							p[name] = parseFloat(text);
							break;
						case 'filetime': case 'date':
							p[name] = parseDate(text);
							break;
						case 'cy': case 'error':
							p[name] = unescapexml(text);
							break;
						default:
							if(type.slice(-1) == '/') break;
							if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
					}
				} else if(x.slice(0,2) === "</") {/* empty */
				} else if(opts.WTF) throw new Error(x);
			}
		}
		return p;
	}
	
	var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
		'xmlns': XMLNS.CUST_PROPS,
		'xmlns:vt': XMLNS.vt
	});
	
	function write_cust_props(cp) {
		var o = [XML_HEADER, CUST_PROPS_XML_ROOT];
		if(!cp) return o.join("");
		var pid = 1;
		keys(cp).forEach(function custprop(k) { ++pid;
			o[o.length] = (writextag('property', write_vt(cp[k]), {
				'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
				'pid': pid,
				'name': escapexml(k)
			}));
		});
		if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* Common Name -> XLML Name */
	var XLMLDocPropsMap = {
		Title: 'Title',
		Subject: 'Subject',
		Author: 'Author',
		Keywords: 'Keywords',
		Comments: 'Description',
		LastAuthor: 'LastAuthor',
		RevNumber: 'Revision',
		Application: 'AppName',
		/* TotalTime: 'TotalTime', */
		LastPrinted: 'LastPrinted',
		CreatedDate: 'Created',
		ModifiedDate: 'LastSaved',
		/* Pages */
		/* Words */
		/* Characters */
		Category: 'Category',
		/* PresentationFormat */
		Manager: 'Manager',
		Company: 'Company',
		/* Guid */
		/* HyperlinkBase */
		/* Bytes */
		/* Lines */
		/* Paragraphs */
		/* CharactersWithSpaces */
		AppVersion: 'Version',
	
		ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
		Identifier: 'Identifier', /* NOTE: missing from schema */
		Language: 'Language' /* NOTE: missing from schema */
	};
	var evert_XLMLDPM = evert(XLMLDocPropsMap);
	
	function xlml_set_prop(Props, tag, val) {
		tag = evert_XLMLDPM[tag] || tag;
		Props[tag] = val;
	}
	
	function xlml_write_docprops(Props, opts) {
		var o = [];
		keys(XLMLDocPropsMap).map(function(m) {
			for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
			for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
			throw m;
		}).forEach(function(p) {
			if(Props[p[1]] == null) return;
			var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
			switch(p[2]) {
				case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
			}
			if(typeof m == 'number') m = String(m);
			else if(m === true || m === false) { m = m ? "1" : "0"; }
			else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
			o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
		});
		return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
	}
	function xlml_write_custprops(Props, Custprops) {
		var BLACKLIST = ["Worksheets","SheetNames"];
		var T = 'CustomDocumentProperties';
		var o = [];
		if(Props) keys(Props).forEach(function(k) {
	if(!Props.hasOwnProperty(k)) return;
			for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
			for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
			for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;
	
			var m = Props[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		if(Custprops) keys(Custprops).forEach(function(k) {
	if(!Custprops.hasOwnProperty(k)) return;
			if(Props && Props.hasOwnProperty(k)) return;
			var m = Custprops[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
	}
	/* [MS-DTYP] 2.3.3 FILETIME */
	/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
	/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
	function parse_FILETIME(blob) {
		var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
		return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
	}
	function write_FILETIME(time) {
		var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
		var t = date.getTime() / 1000 + 11644473600;
		var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
		l *= 1e7; h *= 1e7;
		var w = (l / Math.pow(2,32)) | 0;
		if(w > 0) { l = l % Math.pow(2,32); h += w; }
		var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
	}
	
	/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
	function parse_lpstr(blob, type, pad) {
		var start = blob.l;
		var str = blob.read_shift(0, 'lpstr-cp');
		if(pad) while((blob.l - start) & 3) ++blob.l;
		return str;
	}
	
	/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
	function parse_lpwstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpwstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.11 VtString */
	/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
	function parse_VtStringBase(blob, stringType, pad) {
		if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
		return parse_lpstr(blob, stringType, pad);
	}
	
	function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
	function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }
	
	/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
	function parse_VtVecUnalignedLpstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
		return ret;
	}
	
	/* [MS-OSHARED] 2.3.3.1.10 VtVecUnalignedLpstr */
	function parse_VtVecUnalignedLpstr(blob) {
		return parse_VtVecUnalignedLpstrValue(blob);
	}
	
	/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
	function parse_VtHeadingPair(blob) {
		var headingString = parse_TypedPropertyValue(blob, VT_USTR);
		var headerParts = parse_TypedPropertyValue(blob, VT_I4);
		return [headingString, headerParts];
	}
	
	/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
	function parse_VtVecHeadingPairValue(blob) {
		var cElements = blob.read_shift(4);
		var out = [];
		for(var i = 0; i != cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
		return out;
	}
	
	/* [MS-OSHARED] 2.3.3.1.15 VtVecHeadingPair */
	function parse_VtVecHeadingPair(blob) {
		// NOTE: When invoked, wType & padding were already consumed
		return parse_VtVecHeadingPairValue(blob);
	}
	
	/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
	function parse_dictionary(blob,CodePage) {
		var cnt = blob.read_shift(4);
		var dict = ({});
		for(var j = 0; j != cnt; ++j) {
			var pid = blob.read_shift(4);
			var len = blob.read_shift(4);
			dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
			if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
		}
		if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
		return dict;
	}
	
	/* [MS-OLEPS] 2.9 BLOB */
	function parse_BLOB(blob) {
		var size = blob.read_shift(4);
		var bytes = blob.slice(blob.l,blob.l+size);
		blob.l += size;
		if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
		return bytes;
	}
	
	/* [MS-OLEPS] 2.11 ClipboardData */
	function parse_ClipboardData(blob) {
		// TODO
		var o = {};
		o.Size = blob.read_shift(4);
		//o.Format = blob.read_shift(4);
		blob.l += o.Size + 3 - (o.Size - 1) % 4;
		return o;
	}
	
	/* [MS-OLEPS] 2.15 TypedPropertyValue */
	function parse_TypedPropertyValue(blob, type, _opts) {
		var t = blob.read_shift(2), ret, opts = _opts||{};
		blob.l += 2;
		if(type !== VT_VARIANT)
		if(t !== type && VT_CUSTOM.indexOf(type)===-1) throw new Error('Expected type ' + type + ' saw ' + t);
		switch(type === VT_VARIANT ? t : type) {
			case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
			case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
			case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
			case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
			case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
			case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
			case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
			case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
			case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
			case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
			case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
			case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPair(blob);
			case 0x101E /*VT_LPSTR*/: return parse_VtVecUnalignedLpstr(blob);
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
		}
	}
	function write_TypedPropertyValue(type, value) {
		var o = new_buf(4), p = new_buf(4);
		o.write_shift(4, type == 0x50 ? 0x1F : type);
		switch(type) {
			case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
			case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
			case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
			case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
			case 0x1F /*VT_LPWSTR*/:
			case 0x50 /*VT_STRING*/:
	p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				p.write_shift(4, value.length + 1);
				p.write_shift(0, value, "dbcs");
				while(p.l != p.length) p.write_shift(1, 0);
				break;
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
		}
		return bconcat([o, p]);
	}
	
	/* [MS-OLEPS] 2.20 PropertySet */
	function parse_PropertySet(blob, PIDSI) {
		var start_addr = blob.l;
		var size = blob.read_shift(4);
		var NumProps = blob.read_shift(4);
		var Props = [], i = 0;
		var CodePage = 0;
		var Dictionary = -1, DictObj = ({});
		for(i = 0; i != NumProps; ++i) {
			var PropID = blob.read_shift(4);
			var Offset = blob.read_shift(4);
			Props[i] = [PropID, Offset + start_addr];
		}
		Props.sort(function(x,y) { return x[1] - y[1]; });
		var PropH = {};
		for(i = 0; i != NumProps; ++i) {
			if(blob.l !== Props[i][1]) {
				var fail = true;
				if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
					case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
					case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
					case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				}
				if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
				if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
			}
			if(PIDSI) {
				var piddsi = PIDSI[Props[i][0]];
				PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
				if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
				if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
					case 0: PropH[piddsi.n] = 1252;
						/* falls through */
					case 874:
					case 932:
					case 936:
					case 949:
					case 950:
					case 1250:
					case 1251:
					case 1253:
					case 1254:
					case 1255:
					case 1256:
					case 1257:
					case 1258:
					case 10000:
					case 1200:
					case 1201:
					case 1252:
					case 65000: case -536:
					case 65001: case -535:
						set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
					default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
				}
			} else {
				if(Props[i][0] === 0x1) {
					CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
					set_cp(CodePage);
					if(Dictionary !== -1) {
						var oldpos = blob.l;
						blob.l = Props[Dictionary][1];
						DictObj = parse_dictionary(blob,CodePage);
						blob.l = oldpos;
					}
				} else if(Props[i][0] === 0) {
					if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
					DictObj = parse_dictionary(blob,CodePage);
				} else {
					var name = DictObj[Props[i][0]];
					var val;
					/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
					switch(blob[blob.l]) {
						case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
						case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
						case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
						case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
						case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
						case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
						default: throw new Error("unparsed value: " + blob[blob.l]);
					}
					PropH[name] = val;
				}
			}
		}
		blob.l = start_addr + size; /* step ahead to skip padding */
		return PropH;
	}
	var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ].concat(PseudoPropsPairs);
	function guess_property_type(val) {
		switch(typeof val) {
			case "boolean": return 0x0B;
			case "number": return ((val|0)==val) ? 0x03 : 0x05;
			case "string": return 0x1F;
			case "object": if(val instanceof Date) return 0x40; break;
		}
		return -1;
	}
	function write_PropertySet(entries, RE, PIDSI) {
		var hdr = new_buf(8), piao = [], prop = [];
		var sz = 8, i = 0;
	
		var pr = new_buf(8), pio = new_buf(8);
		pr.write_shift(4, 0x0002);
		pr.write_shift(4, 0x04B0);
		pio.write_shift(4, 0x0001);
		prop.push(pr); piao.push(pio);
		sz += 8 + pr.length;
	
		if(!RE) {
			pio = new_buf(8);
			pio.write_shift(4, 0);
			piao.unshift(pio);
	
			var bufs = [new_buf(4)];
			bufs[0].write_shift(4, entries.length);
			for(i = 0; i < entries.length; ++i) {
				var value = entries[i][0];
				pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				pr.write_shift(4, i+2);
				pr.write_shift(4, value.length + 1);
				pr.write_shift(0, value, "dbcs");
				while(pr.l != pr.length) pr.write_shift(1, 0);
				bufs.push(pr);
			}
			pr = bconcat(bufs);
			prop.unshift(pr);
			sz += 8 + pr.length;
		}
	
		for(i = 0; i < entries.length; ++i) {
			if(RE && !RE[entries[i][0]]) continue;
			if(XLSPSSkip.indexOf(entries[i][0]) > -1) continue;
			if(entries[i][1] == null) continue;
	
			var val = entries[i][1], idx = 0;
			if(RE) {
				idx = +RE[entries[i][0]];
				var pinfo = (PIDSI)[idx];
				if(pinfo.p == "version" && typeof val == "string") {
	var arr = val.split(".");
					val = ((+arr[0])<<16) + ((+arr[1])||0);
				}
				pr = write_TypedPropertyValue(pinfo.t, val);
			} else {
				var T = guess_property_type(val);
				if(T == -1) { T = 0x1F; val = String(val); }
				pr = write_TypedPropertyValue(T, val);
			}
			prop.push(pr);
	
			pio = new_buf(8);
			pio.write_shift(4, !RE ? 2+i : idx);
			piao.push(pio);
	
			sz += 8 + pr.length;
		}
	
		var w = 8 * (prop.length + 1);
		for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
		hdr.write_shift(4, sz);
		hdr.write_shift(4, prop.length);
		return bconcat([hdr].concat(piao).concat(prop));
	}
	
	/* [MS-OLEPS] 2.21 PropertySetStream */
	function parse_PropertySetStream(file, PIDSI, clsid) {
		var blob = file.content;
		if(!blob) return ({});
		prep_blob(blob, 0);
	
		var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
		blob.chk('feff', 'Byte Order: ');
	
		/*var vers = */blob.read_shift(2); // TODO: check version
		var SystemIdentifier = blob.read_shift(4);
		var CLSID = blob.read_shift(16);
		if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
		NumSets = blob.read_shift(4);
		if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
		FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);
	
		if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
		else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
		var PSet0 = parse_PropertySet(blob, PIDSI);
	
		var rval = ({ SystemIdentifier: SystemIdentifier });
		for(var y in PSet0) rval[y] = PSet0[y];
		//rval.blob = blob;
		rval.FMTID = FMTID0;
		//rval.PSet0 = PSet0;
		if(NumSets === 1) return rval;
		if(Offset1 - blob.l == 2) blob.l += 2;
		if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
		var PSet1;
		try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
		for(y in PSet1) rval[y] = PSet1[y];
		rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
		return rval;
	}
	function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
		var hdr = new_buf(entries2 ? 68 : 48);
		var bufs = [hdr];
		hdr.write_shift(2, 0xFFFE);
		hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
		hdr.write_shift(4, 0x32363237);
		hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
		hdr.write_shift(4, (entries2 ? 2 : 1));
		hdr.write_shift(16, clsid, "hex");
		hdr.write_shift(4, (entries2 ? 68 : 48));
		var ps0 = write_PropertySet(entries, RE, PIDSI);
		bufs.push(ps0);
	
		if(entries2) {
			var ps1 = write_PropertySet(entries2, null, null);
			hdr.write_shift(16, clsid2, "hex");
			hdr.write_shift(4, 68 + ps0.length);
			bufs.push(ps1);
		}
		return bconcat(bufs);
	}
	
	function parsenoop2(blob, length) { blob.read_shift(length); return null; }
	function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }
	
	function parslurp(blob, length, cb) {
		var arr = [], target = blob.l + length;
		while(blob.l < target) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
	function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }
	
	function parseuint16(blob) { return blob.read_shift(2, 'u'); }
	function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
	function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}
	
	/* --- 2.5 Structures --- */
	
	/* [MS-XLS] 2.5.10 Bes (boolean or error) */
	function parse_Bes(blob) {
		var v = blob.read_shift(1), t = blob.read_shift(1);
		return t === 0x01 ? v : v === 0x01;
	}
	function write_Bes(v, t, o) {
		if(!o) o = new_buf(2);
		o.write_shift(1, +v);
		o.write_shift(1, ((t == 'e') ? 1 : 0));
		return o;
	}
	
	/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
	function parse_ShortXLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
		var encoding = 'sbcs-cont';
		var cp = current_codepage;
		if(opts && opts.biff >= 8) current_codepage = 1200;
		if(!opts || opts.biff == 8 ) {
			var fHighByte = blob.read_shift(1);
			if(fHighByte) { encoding = 'dbcs-cont'; }
		} else if(opts.biff == 12) {
			encoding = 'wstr';
		}
		if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
		var o = cch ? blob.read_shift(cch, encoding) : "";
		current_codepage = cp;
		return o;
	}
	
	/* 2.5.293 XLUnicodeRichExtendedString */
	function parse_XLUnicodeRichExtendedString(blob) {
		var cp = current_codepage;
		current_codepage = 1200;
		var cch = blob.read_shift(2), flags = blob.read_shift(1);
		var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
		var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
		var cRun = 0, cbExtRst;
		var z = {};
		if(fRichSt) cRun = blob.read_shift(2);
		if(fExtSt) cbExtRst = blob.read_shift(4);
		var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
		var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
		if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
		if(fExtSt) blob.l += cbExtRst; //TODO: parse this
		z.t = msg;
		if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
		current_codepage = cp;
		return z;
	}
	
	/* 2.5.296 XLUnicodeStringNoCch */
	function parse_XLUnicodeStringNoCch(blob, cch, opts) {
		var retval;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
			if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
		}
		var fHighByte = blob.read_shift(1);
		if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
		else { retval = blob.read_shift(cch, 'dbcs-cont'); }
		return retval;
	}
	
	/* 2.5.294 XLUnicodeString */
	function parse_XLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		if(cch === 0) { blob.l++; return ""; }
		return parse_XLUnicodeStringNoCch(blob, cch, opts);
	}
	/* BIFF5 override */
	function parse_XLUnicodeString2(blob, length, opts) {
		if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
	}
	/* TODO: BIFF5 and lower, codepage awareness */
	function write_XLUnicodeString(str, opts, o) {
		if(!o) o = new_buf(3 + 2 * str.length);
		o.write_shift(2, str.length);
		o.write_shift(1, 1);
		o.write_shift(31, str, 'utf16le');
		return o;
	}
	
	/* [MS-XLS] 2.5.61 ControlInfo */
	function parse_ControlInfo(blob) {
		var flags = blob.read_shift(1);
		blob.l++;
		var accel = blob.read_shift(2);
		blob.l += 2;
		return [flags, accel];
	}
	
	/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
	function parse_URLMoniker(blob) {
		var len = blob.read_shift(4), start = blob.l;
		var extra = false;
		if(len > 24) {
			/* look ahead */
			blob.l += len - 24;
			if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
			blob.l = start;
		}
		var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
		if(extra) blob.l += 24;
		return url;
	}
	
	/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
	function parse_FileMoniker(blob) {
		blob.l += 2; //var cAnti = blob.read_shift(2);
		var ansiPath = blob.read_shift(0, 'lpstr-ansi');
		blob.l += 2; //var endServer = blob.read_shift(2);
		if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
		var sz = blob.read_shift(4);
		if(sz === 0) return ansiPath.replace(/\\/g,"/");
		var bytes = blob.read_shift(4);
		if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
		var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
		return unicodePath;
	}
	
	/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
	function parse_HyperlinkMoniker(blob, length) {
		var clsid = blob.read_shift(16); length -= 16;
		switch(clsid) {
			case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
			case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
			default: throw new Error("Unsupported Moniker " + clsid);
		}
	}
	
	/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
	function parse_HyperlinkString(blob) {
		var len = blob.read_shift(4);
		var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
		return o;
	}
	
	/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
	function parse_Hyperlink(blob, length) {
		var end = blob.l + length;
		var sVer = blob.read_shift(4);
		if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
		var flags = blob.read_shift(2);
		blob.l += 2;
		var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
		if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
		if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0020) guid = blob.read_shift(16);
		if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
		blob.l = end;
		var target = targetFrameName||moniker||oleMoniker||"";
		if(target && Loc) target+="#"+Loc;
		if(!target) target = "#" + Loc;
		var out = ({Target:target});
		if(guid) out.guid = guid;
		if(fileTime) out.time = fileTime;
		if(displayName) out.Tooltip = displayName;
		return out;
	}
	function write_Hyperlink(hl) {
		var out = new_buf(512), i = 0;
		var Target = hl.Target;
		var F = Target.indexOf("#") > -1 ? 0x1f : 0x17;
		switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
		out.write_shift(4,2); out.write_shift(4, F);
		var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
		if(F == 0x1C) {
			Target = Target.slice(1);
			out.write_shift(4, Target.length + 1);
			for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
			out.write_shift(2, 0);
		} else if(F & 0x02) {
			data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			out.write_shift(4, 2*(Target.length + 1));
			for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
			out.write_shift(2, 0);
		} else {
			data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var P = 0;
			while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
			out.write_shift(2, P);
			out.write_shift(4, Target.length + 1);
			for(i = 0; i < Target.length; ++i) out.write_shift(1, Target.charCodeAt(i) & 0xFF);
			out.write_shift(1, 0);
			out.write_shift(2, 0xFFFF);
			out.write_shift(2, 0xDEAD);
			for(i = 0; i < 6; ++i) out.write_shift(4, 0);
		}
		return out.slice(0, out.l);
	}
	
	/* 2.5.178 LongRGBA */
	function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }
	
	/* 2.5.177 LongRGB */
	function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }
	
	
	/* [MS-XLS] 2.5.19 */
	function parse_XLSCell(blob) {
		var rw = blob.read_shift(2); // 0-indexed
		var col = blob.read_shift(2);
		var ixfe = blob.read_shift(2);
		return ({r:rw, c:col, ixfe:ixfe});
	}
	function write_XLSCell(R, C, ixfe, o) {
		if(!o) o = new_buf(6);
		o.write_shift(2, R);
		o.write_shift(2, C);
		o.write_shift(2, ixfe||0);
		return o;
	}
	
	/* [MS-XLS] 2.5.134 */
	function parse_frtHeader(blob) {
		var rt = blob.read_shift(2);
		var flags = blob.read_shift(2); // TODO: parse these flags
		blob.l += 8;
		return {type: rt, flags: flags};
	}
	
	
	
	function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }
	
	/* [MS-XLS] 2.5.344 */
	function parse_XTI(blob, length, opts) {
		var w = opts.biff > 8 ? 4 : 2;
		var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
		return [iSupBook, itabFirst, itabLast];
	}
	
	/* [MS-XLS] 2.5.218 */
	function parse_RkRec(blob) {
		var ixfe = blob.read_shift(2);
		var RK = parse_RkNumber(blob);
		return [ixfe, RK];
	}
	
	/* [MS-XLS] 2.5.1 */
	function parse_AddinUdf(blob, length, opts) {
		blob.l += 4; length -= 4;
		var l = blob.l + length;
		var udfName = parse_ShortXLUnicodeString(blob, length, opts);
		var cb = blob.read_shift(2);
		l -= blob.l;
		if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
		blob.l += cb;
		return udfName;
	}
	
	/* [MS-XLS] 2.5.209 TODO: Check sizes */
	function parse_Ref8U(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(2);
		var colLast = blob.read_shift(2);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	function write_Ref8U(r, o) {
		if(!o) o = new_buf(8);
		o.write_shift(2, r.s.r);
		o.write_shift(2, r.e.r);
		o.write_shift(2, r.s.c);
		o.write_shift(2, r.e.c);
		return o;
	}
	
	/* [MS-XLS] 2.5.211 */
	function parse_RefU(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(1);
		var colLast = blob.read_shift(1);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* [MS-XLS] 2.5.207 */
	var parse_Ref = parse_RefU;
	
	/* [MS-XLS] 2.5.143 */
	function parse_FtCmo(blob) {
		blob.l += 4;
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var flags = blob.read_shift(2);
		blob.l+=12;
		return [id, ot, flags];
	}
	
	/* [MS-XLS] 2.5.149 */
	function parse_FtNts(blob) {
		var out = {};
		blob.l += 4;
		blob.l += 16; // GUID TODO
		out.fSharedNote = blob.read_shift(2);
		blob.l += 4;
		return out;
	}
	
	/* [MS-XLS] 2.5.142 */
	function parse_FtCf(blob) {
		var out = {};
		blob.l += 4;
		blob.cf = blob.read_shift(2);
		return out;
	}
	
	/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
	function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
	var FtTab = {
	0x00: parse_FtSkip,      /* FtEnd */
	0x04: parse_FtSkip,      /* FtMacro */
	0x05: parse_FtSkip,      /* FtButton */
	0x06: parse_FtSkip,      /* FtGmo */
	0x07: parse_FtCf,        /* FtCf */
	0x08: parse_FtSkip,      /* FtPioGrbit */
	0x09: parse_FtSkip,      /* FtPictFmla */
	0x0A: parse_FtSkip,      /* FtCbls */
	0x0B: parse_FtSkip,      /* FtRbo */
	0x0C: parse_FtSkip,      /* FtSbs */
	0x0D: parse_FtNts,       /* FtNts */
	0x0E: parse_FtSkip,      /* FtSbsFmla */
	0x0F: parse_FtSkip,      /* FtGboData */
	0x10: parse_FtSkip,      /* FtEdoData */
	0x11: parse_FtSkip,      /* FtRboData */
	0x12: parse_FtSkip,      /* FtCblsData */
	0x13: parse_FtSkip,      /* FtLbsData */
	0x14: parse_FtSkip,      /* FtCblsFmla */
	0x15: parse_FtCmo
	};
	function parse_FtArray(blob, length) {
		var tgt = blob.l + length;
		var fts = [];
		while(blob.l < tgt) {
			var ft = blob.read_shift(2);
			blob.l-=2;
			try {
				fts.push(FtTab[ft](blob, tgt - blob.l));
			} catch(e) { blob.l = tgt; return fts; }
		}
		if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
		return fts;
	}
	
	/* --- 2.4 Records --- */
	
	/* [MS-XLS] 2.4.21 */
	function parse_BOF(blob, length) {
		var o = {BIFFVer:0, dt:0};
		o.BIFFVer = blob.read_shift(2); length -= 2;
		if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
		switch(o.BIFFVer) {
			case 0x0600: /* BIFF8 */
			case 0x0500: /* BIFF5 */
			case 0x0400: /* BIFF4 */
			case 0x0300: /* BIFF3 */
			case 0x0200: /* BIFF2 */
			case 0x0002: case 0x0007: /* BIFF2 */
				break;
			default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
		}
	
		blob.read_shift(length);
		return o;
	}
	function write_BOF(wb, t, o) {
		var h = 0x0600, w = 16;
		switch(o.bookType) {
			case 'biff8': break;
			case 'biff5': h = 0x0500; w = 8; break;
			case 'biff4': h = 0x0004; w = 6; break;
			case 'biff3': h = 0x0003; w = 6; break;
			case 'biff2': h = 0x0002; w = 4; break;
			case 'xla': break;
			default: throw new Error("unsupported BIFF version");
		}
		var out = new_buf(w);
		out.write_shift(2, h);
		out.write_shift(2, t);
		if(w > 4) out.write_shift(2, 0x7262);
		if(w > 6) out.write_shift(2, 0x07CD);
		if(w > 8) {
			out.write_shift(2, 0xC009);
			out.write_shift(2, 0x0001);
			out.write_shift(2, 0x0706);
			out.write_shift(2, 0x0000);
		}
		return out;
	}
	
	
	/* [MS-XLS] 2.4.146 */
	function parse_InterfaceHdr(blob, length) {
		if(length === 0) return 0x04b0;
		if((blob.read_shift(2))!==0x04b0){/* empty */}
		return 0x04b0;
	}
	
	
	/* [MS-XLS] 2.4.349 */
	function parse_WriteAccess(blob, length, opts) {
		if(opts.enc) { blob.l += length; return ""; }
		var l = blob.l;
		// TODO: make sure XLUnicodeString doesnt overrun
		var UserName = parse_XLUnicodeString2(blob, 0, opts);
		blob.read_shift(length + l - blob.l);
		return UserName;
	}
	function write_WriteAccess(s, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(b8 ? 112 : 54);
		o.write_shift(opts.biff == 8 ? 2 : 1, 7);
		if(b8) o.write_shift(1, 0);
		o.write_shift(4, 0x33336853);
		o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
		while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
		return o;
	}
	
	/* [MS-XLS] 2.4.351 */
	function parse_WsBool(blob, length, opts) {
		var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
		return { fDialog: flags & 0x10 };
	}
	
	/* [MS-XLS] 2.4.28 */
	function parse_BoundSheet8(blob, length, opts) {
		var pos = blob.read_shift(4);
		var hidden = blob.read_shift(1) & 0x03;
		var dt = blob.read_shift(1);
		switch(dt) {
			case 0: dt = 'Worksheet'; break;
			case 1: dt = 'Macrosheet'; break;
			case 2: dt = 'Chartsheet'; break;
			case 6: dt = 'VBAModule'; break;
		}
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		if(name.length === 0) name = "Sheet1";
		return { pos:pos, hs:hidden, dt:dt, name:name };
	}
	function write_BoundSheet8(data, opts) {
		var w = (!opts || opts.biff >= 8 ? 2 : 1);
		var o = new_buf(8 + w * data.name.length);
		o.write_shift(4, data.pos);
		o.write_shift(1, data.hs || 0);
		o.write_shift(1, data.dt);
		o.write_shift(1, data.name.length);
		if(opts.biff >= 8) o.write_shift(1, 1);
		o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
		var out = o.slice(0, o.l);
		out.l = o.l; return out;
	}
	
	/* [MS-XLS] 2.4.265 TODO */
	function parse_SST(blob, length) {
		var end = blob.l + length;
		var cnt = blob.read_shift(4);
		var ucnt = blob.read_shift(4);
		var strs = ([]);
		for(var i = 0; i != ucnt && blob.l < end; ++i) {
			strs.push(parse_XLUnicodeRichExtendedString(blob));
		}
		strs.Count = cnt; strs.Unique = ucnt;
		return strs;
	}
	
	/* [MS-XLS] 2.4.107 */
	function parse_ExtSST(blob, length) {
		var extsst = {};
		extsst.dsst = blob.read_shift(2);
		blob.l += length-2;
		return extsst;
	}
	
	
	/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
	function parse_Row(blob) {
		var z = ({});
		z.r = blob.read_shift(2);
		z.c = blob.read_shift(2);
		z.cnt = blob.read_shift(2) - z.c;
		var miyRw = blob.read_shift(2);
		blob.l += 4; // reserved(2), unused(2)
		var flags = blob.read_shift(1); // various flags
		blob.l += 3; // reserved(8), ixfe(12), flags(4)
		if(flags & 0x07) z.level = flags & 0x07;
		// collapsed: flags & 0x10
		if(flags & 0x20) z.hidden = true;
		if(flags & 0x40) z.hpt = miyRw / 20;
		return z;
	}
	
	
	/* [MS-XLS] 2.4.125 */
	function parse_ForceFullCalculation(blob) {
		var header = parse_frtHeader(blob);
		if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
		var fullcalc = blob.read_shift(4);
		return fullcalc !== 0x0;
	}
	
	
	
	
	
	/* [MS-XLS] 2.4.215 rt */
	function parse_RecalcId(blob) {
		blob.read_shift(2);
		return blob.read_shift(4);
	}
	
	/* [MS-XLS] 2.4.87 */
	function parse_DefaultRowHeight(blob, length, opts) {
		var f = 0;
		if(!(opts && opts.biff == 2)) {
			f = blob.read_shift(2);
		}
		var miyRw = blob.read_shift(2);
		if((opts && opts.biff == 2)) {
			f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
		}
		var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
		return [fl, miyRw];
	}
	
	/* [MS-XLS] 2.4.345 TODO */
	function parse_Window1(blob) {
		var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
		var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
		var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
		return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
			FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
	}
	function write_Window1() {
		var o = new_buf(18);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0x7260);
		o.write_shift(2, 0x44c0);
		o.write_shift(2, 0x38);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 1);
		o.write_shift(2, 0x01f4);
		return o;
	}
	/* [MS-XLS] 2.4.346 TODO */
	function parse_Window2(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff < 8) return {};
		var f = blob.read_shift(2);
		return { RTL: f & 0x40 };
	}
	function write_Window2(view) {
		var o = new_buf(18), f = 0x6b6;
		if(view && view.RTL) f |= 0x40;
		o.write_shift(2, f);
		o.write_shift(4, 0);
		o.write_shift(4, 64);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.189 TODO */
	function parse_Pane(/*blob, length, opts*/) {
	}
	
	/* [MS-XLS] 2.4.122 TODO */
	function parse_Font(blob, length, opts) {
		var o = {
			dyHeight: blob.read_shift(2),
			fl: blob.read_shift(2)
		};
		switch((opts && opts.biff) || 8) {
			case 2: break;
			case 3: case 4: blob.l += 2; break;
			default: blob.l += 10; break;
		}
		o.name = parse_ShortXLUnicodeString(blob, 0, opts);
		return o;
	}
	function write_Font(data, opts) {
		var name = data.name || "Arial";
		var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
		var o = new_buf(w);
		o.write_shift(2, (data.sz || 12) * 20);
		o.write_shift(4, 0);
		o.write_shift(2, 400);
		o.write_shift(4, 0);
		o.write_shift(2, 0);
		o.write_shift(1, name.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
		return o;
	}
	
	/* [MS-XLS] 2.4.149 */
	function parse_LabelSst(blob) {
		var cell = parse_XLSCell(blob);
		cell.isst = blob.read_shift(4);
		return cell;
	}
	
	/* [MS-XLS] 2.4.148 */
	function parse_Label(blob, length, opts) {
		var target = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) blob.l++;
		var str = parse_XLUnicodeString(blob, target - blob.l, opts);
		cell.val = str;
		return cell;
	}
	function write_Label(R, C, v, os, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
		write_XLSCell(R, C, os, o);
		o.write_shift(2, v.length);
		if(b8) o.write_shift(1, 1);
		o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
		return o;
	}
	
	
	/* [MS-XLS] 2.4.126 Number Formats */
	function parse_Format(blob, length, opts) {
		var numFmtId = blob.read_shift(2);
		var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
		return [numFmtId, fmtstr];
	}
	function write_Format(i, f, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
		o.write_shift(2, i);
		o.write_shift((b5 ? 1 : 2), f.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(out.l == null) out.l = out.length;
		return out;
	}
	var parse_BIFF2Format = parse_XLUnicodeString2;
	
	/* [MS-XLS] 2.4.90 */
	function parse_Dimensions(blob, length, opts) {
		var end = blob.l + length;
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var r = blob.read_shift(w), R = blob.read_shift(w);
		var c = blob.read_shift(2), C = blob.read_shift(2);
		blob.l = end;
		return {s: {r:r, c:c}, e: {r:R, c:C}};
	}
	function write_Dimensions(range, opts) {
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var o = new_buf(2*w + 6);
		o.write_shift(w, range.s.r);
		o.write_shift(w, range.e.r + 1);
		o.write_shift(2, range.s.c);
		o.write_shift(2, range.e.c + 1);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.220 */
	function parse_RK(blob) {
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrec = parse_RkRec(blob);
		return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
	}
	
	/* [MS-XLS] 2.4.175 */
	function parse_MulRk(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrecs = [];
		while(blob.l < target) rkrecs.push(parse_RkRec(blob));
		if(blob.l !== target) throw new Error("MulRK read error");
		var lastcol = blob.read_shift(2);
		if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
		return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
	}
	/* [MS-XLS] 2.4.174 */
	function parse_MulBlank(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var ixfes = [];
		while(blob.l < target) ixfes.push(blob.read_shift(2));
		if(blob.l !== target) throw new Error("MulBlank read error");
		var lastcol = blob.read_shift(2);
		if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
		return {r:rw, c:col, C:lastcol, ixfe:ixfes};
	}
	
	/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
	function parse_CellStyleXF(blob, length, style, opts) {
		var o = {};
		var a = blob.read_shift(4), b = blob.read_shift(4);
		var c = blob.read_shift(4), d = blob.read_shift(2);
		o.patternType = XLSFillPattern[c >> 26];
	
		if(!opts.cellStyles) return o;
		o.alc = a & 0x07;
		o.fWrap = (a >> 3) & 0x01;
		o.alcV = (a >> 4) & 0x07;
		o.fJustLast = (a >> 7) & 0x01;
		o.trot = (a >> 8) & 0xFF;
		o.cIndent = (a >> 16) & 0x0F;
		o.fShrinkToFit = (a >> 20) & 0x01;
		o.iReadOrder = (a >> 22) & 0x02;
		o.fAtrNum = (a >> 26) & 0x01;
		o.fAtrFnt = (a >> 27) & 0x01;
		o.fAtrAlc = (a >> 28) & 0x01;
		o.fAtrBdr = (a >> 29) & 0x01;
		o.fAtrPat = (a >> 30) & 0x01;
		o.fAtrProt = (a >> 31) & 0x01;
	
		o.dgLeft = b & 0x0F;
		o.dgRight = (b >> 4) & 0x0F;
		o.dgTop = (b >> 8) & 0x0F;
		o.dgBottom = (b >> 12) & 0x0F;
		o.icvLeft = (b >> 16) & 0x7F;
		o.icvRight = (b >> 23) & 0x7F;
		o.grbitDiag = (b >> 30) & 0x03;
	
		o.icvTop = c & 0x7F;
		o.icvBottom = (c >> 7) & 0x7F;
		o.icvDiag = (c >> 14) & 0x7F;
		o.dgDiag = (c >> 21) & 0x0F;
	
		o.icvFore = d & 0x7F;
		o.icvBack = (d >> 7) & 0x7F;
		o.fsxButton = (d >> 14) & 0x01;
		return o;
	}
	//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
	//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
	
	/* [MS-XLS] 2.4.353 TODO: actually do this right */
	function parse_XF(blob, length, opts) {
		var o = {};
		o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
		o.fStyle = (o.flags >> 2) & 0x01;
		length -= 6;
		o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
		return o;
	}
	function write_XF(data, ixfeP, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? 16 : 20);
		o.write_shift(2, 0);
		if(data.style) {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, 0xFFF4);
		} else {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, (ixfeP<<4));
		}
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		if(!b5) o.write_shift(4, 0);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.134 */
	function parse_Guts(blob) {
		blob.l += 4;
		var out = [blob.read_shift(2), blob.read_shift(2)];
		if(out[0] !== 0) out[0]--;
		if(out[1] !== 0) out[1]--;
		if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
		return out;
	}
	function write_Guts(guts) {
		var o = new_buf(8);
		o.write_shift(4, 0);
		o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
		o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.24 */
	function parse_BoolErr(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_Bes(blob, 2);
		cell.val = val;
		cell.t = (val === true || val === false) ? 'b' : 'e';
		return cell;
	}
	function write_BoolErr(R, C, v, os, opts, t) {
		var o = new_buf(8);
		write_XLSCell(R, C, os, o);
		write_Bes(v, t, o);
		return o;
	}
	
	/* [MS-XLS] 2.4.180 Number */
	function parse_Number(blob) {
		var cell = parse_XLSCell(blob, 6);
		var xnum = parse_Xnum(blob, 8);
		cell.val = xnum;
		return cell;
	}
	function write_Number(R, C, v, os) {
		var o = new_buf(14);
		write_XLSCell(R, C, os, o);
		write_Xnum(v, o);
		return o;
	}
	
	var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
	
	/* [MS-XLS] 2.4.271 */
	function parse_SupBook(blob, length, opts) {
		var end = blob.l + length;
		var ctab = blob.read_shift(2);
		var cch = blob.read_shift(2);
		opts.sbcch = cch;
		if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
		if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
		var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
		/* TODO: 2.5.277 Virtual Path */
		var rgst = [];
		while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
		return [cch, ctab, virtPath, rgst];
	}
	
	/* [MS-XLS] 2.4.105 TODO */
	function parse_ExternName(blob, length, opts) {
		var flags = blob.read_shift(2);
		var body;
		var o = ({
			fBuiltIn: flags & 0x01,
			fWantAdvise: (flags >>> 1) & 0x01,
			fWantPict: (flags >>> 2) & 0x01,
			fOle: (flags >>> 3) & 0x01,
			fOleLink: (flags >>> 4) & 0x01,
			cf: (flags >>> 5) & 0x3FF,
			fIcon: flags >>> 15 & 0x01
		});
		if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
		//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
		o.body = body || blob.read_shift(length-2);
		if(typeof body === "string") o.Name = body;
		return o;
	}
	
	/* [MS-XLS] 2.4.150 TODO */
	var XLSLblBuiltIn = [
		"_xlnm.Consolidate_Area",
		"_xlnm.Auto_Open",
		"_xlnm.Auto_Close",
		"_xlnm.Extract",
		"_xlnm.Database",
		"_xlnm.Criteria",
		"_xlnm.Print_Area",
		"_xlnm.Print_Titles",
		"_xlnm.Recorder",
		"_xlnm.Data_Form",
		"_xlnm.Auto_Activate",
		"_xlnm.Auto_Deactivate",
		"_xlnm.Sheet_Title",
		"_xlnm._FilterDatabase"
	];
	function parse_Lbl(blob, length, opts) {
		var target = blob.l + length;
		var flags = blob.read_shift(2);
		var chKey = blob.read_shift(1);
		var cch = blob.read_shift(1);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var itab = 0;
		if(!opts || opts.biff >= 5) {
			if(opts.biff != 5) blob.l += 2;
			itab = blob.read_shift(2);
			if(opts.biff == 5) blob.l += 2;
			blob.l += 4;
		}
		var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
		if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
		var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
		var rgce = target == blob.l || cce === 0 ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
		return {
			chKey: chKey,
			Name: name,
			itab: itab,
			rgce: rgce
		};
	}
	
	/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
	function parse_ExternSheet(blob, length, opts) {
		if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
		var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
		while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
			// [iSupBook, itabFirst, itabLast];
		if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
		return o;
	}
	function parse_BIFF5ExternSheet(blob, length, opts) {
		if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
		var o = parse_ShortXLUnicodeString(blob, length, opts);
		return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
	}
	
	/* [MS-XLS] 2.4.176 TODO: check older biff */
	function parse_NameCmt(blob, length, opts) {
		if(opts.biff < 8) { blob.l += length; return; }
		var cchName = blob.read_shift(2);
		var cchComment = blob.read_shift(2);
		var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
		var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
		return [name, comment];
	}
	
	/* [MS-XLS] 2.4.260 */
	function parse_ShrFmla(blob, length, opts) {
		var ref = parse_RefU(blob, 6);
		blob.l++;
		var cUse = blob.read_shift(1);
		length -= 8;
		return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
	}
	
	/* [MS-XLS] 2.4.4 TODO */
	function parse_Array(blob, length, opts) {
		var ref = parse_Ref(blob, 6);
		/* TODO: fAlwaysCalc */
		switch(opts.biff) {
			case 2: blob.l ++; length -= 7; break;
			case 3: case 4: blob.l += 2; length -= 8; break;
			default: blob.l += 6; length -= 12;
		}
		return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
	}
	
	/* [MS-XLS] 2.4.173 */
	function parse_MTRSettings(blob) {
		var fMTREnabled = blob.read_shift(4) !== 0x00;
		var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
		var cUserThreadCount = blob.read_shift(4);
		return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
	}
	
	/* [MS-XLS] 2.5.186 TODO: BIFF5 */
	function parse_NoteSh(blob, length, opts) {
		if(opts.biff < 8) return;
		var row = blob.read_shift(2), col = blob.read_shift(2);
		var flags = blob.read_shift(2), idObj = blob.read_shift(2);
		var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
		if(opts.biff < 8) blob.read_shift(1);
		return [{r:row,c:col}, stAuthor, idObj, flags];
	}
	
	/* [MS-XLS] 2.4.179 */
	function parse_Note(blob, length, opts) {
		/* TODO: Support revisions */
		return parse_NoteSh(blob, length, opts);
	}
	
	/* [MS-XLS] 2.4.168 */
	function parse_MergeCells(blob, length) {
		var merges = [];
		var cmcs = blob.read_shift(2);
		while (cmcs--) merges.push(parse_Ref8U(blob,length));
		return merges;
	}
	function write_MergeCells(merges) {
		var o = new_buf(2 + merges.length * 8);
		o.write_shift(2, merges.length);
		for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
		return o;
	}
	
	/* [MS-XLS] 2.4.181 TODO: parse all the things! */
	function parse_Obj(blob, length, opts) {
		if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
		var cmo = parse_FtCmo(blob, 22); // id, ot, flags
		var fts = parse_FtArray(blob, length-22, cmo[1]);
		return { cmo: cmo, ft:fts };
	}
	/* from older spec */
	var parse_BIFF5OT = [];
	parse_BIFF5OT[0x08] = function(blob, length) {
		var tgt = blob.l + length;
		blob.l += 10; // todo
		var cf = blob.read_shift(2);
		blob.l += 4;
		blob.l += 2; //var cbPictFmla = blob.read_shift(2);
		blob.l += 2;
		blob.l += 2; //var grbit = blob.read_shift(2);
		blob.l += 4;
		var cchName = blob.read_shift(1);
		blob.l += cchName; // TODO: stName
		blob.l = tgt; // TODO: fmla
		return { fmt:cf };
	};
	
	function parse_BIFF5Obj(blob, length, opts) {
		blob.l += 4; //var cnt = blob.read_shift(4);
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var grbit = blob.read_shift(2);
		blob.l += 2; //var colL = blob.read_shift(2);
		blob.l += 2; //var dxL = blob.read_shift(2);
		blob.l += 2; //var rwT = blob.read_shift(2);
		blob.l += 2; //var dyT = blob.read_shift(2);
		blob.l += 2; //var colR = blob.read_shift(2);
		blob.l += 2; //var dxR = blob.read_shift(2);
		blob.l += 2; //var rwB = blob.read_shift(2);
		blob.l += 2; //var dyB = blob.read_shift(2);
		blob.l += 2; //var cbMacro = blob.read_shift(2);
		blob.l += 6;
		length -= 36;
		var fts = [];
		fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
		return { cmo: [id, ot, grbit], ft:fts };
	}
	
	/* [MS-XLS] 2.4.329 TODO: parse properly */
	function parse_TxO(blob, length, opts) {
		var s = blob.l;
		var texts = "";
	try {
		blob.l += 4;
		var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
		var controlInfo; // eslint-disable-line no-unused-vars
		if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
		else controlInfo = parse_ControlInfo(blob, 6, opts);
		var cchText = blob.read_shift(2);
		/*var cbRuns = */blob.read_shift(2);
		/*var ifntEmpty = */parseuint16(blob, 2);
		var len = blob.read_shift(2);
		blob.l += len;
		//var fmla = parse_ObjFmla(blob, s + length - blob.l);
	
		for(var i = 1; i < blob.lens.length-1; ++i) {
			if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
			var hdr = blob[blob.l];
			var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
			texts += t;
			if(texts.length >= (hdr ? cchText : 2*cchText)) break;
		}
		if(texts.length !== cchText && texts.length !== cchText*2) {
			throw new Error("cchText: " + cchText + " != " + texts.length);
		}
	
		blob.l = s + length;
		/* [MS-XLS] 2.5.272 TxORuns */
	//	var rgTxoRuns = [];
	//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
	//	var cchText2 = blob.read_shift(2);
	//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
	//	blob.l += 6;
	//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
		return { t: texts };
	} catch(e) { blob.l = s + length; return { t: texts }; }
	}
	
	/* [MS-XLS] 2.4.140 */
	function parse_HLink(blob, length) {
		var ref = parse_Ref8U(blob, 8);
		blob.l += 16; /* CLSID */
		var hlink = parse_Hyperlink(blob, length-24);
		return [ref, hlink];
	}
	function write_HLink(hl) {
		var O = new_buf(24);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
		return bconcat([O, write_Hyperlink(hl[1])]);
	}
	
	
	/* [MS-XLS] 2.4.141 */
	function parse_HLinkTooltip(blob, length) {
		blob.read_shift(2);
		var ref = parse_Ref8U(blob, 8);
		var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
		wzTooltip = wzTooltip.replace(chr0,"");
		return [ref, wzTooltip];
	}
	function write_HLinkTooltip(hl) {
		var TT = hl[1].Tooltip;
		var O = new_buf(10 + 2 * (TT.length + 1));
		O.write_shift(2, 0x0800);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
		O.write_shift(2, 0);
		return O;
	}
	
	/* [MS-XLS] 2.4.63 */
	function parse_Country(blob) {
		var o = [0,0], d;
		d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
		d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
		return o;
	}
	function write_Country(o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, 0x01);
		o.write_shift(2, 0x01);
		return o;
	}
	
	/* [MS-XLS] 2.4.50 ClrtClient */
	function parse_ClrtClient(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.188 */
	function parse_Palette(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.354 */
	function parse_XFCRC(blob) {
		blob.l += 2;
		var o = {cxfs:0, crc:0};
		o.cxfs = blob.read_shift(2);
		o.crc = blob.read_shift(4);
		return o;
	}
	
	/* [MS-XLS] 2.4.53 TODO: parse flags */
	/* [MS-XLSB] 2.4.323 TODO: parse flags */
	function parse_ColInfo(blob, length, opts) {
		if(!opts.cellStyles) return parsenoop(blob, length);
		var w = opts && opts.biff >= 12 ? 4 : 2;
		var colFirst = blob.read_shift(w);
		var colLast = blob.read_shift(w);
		var coldx = blob.read_shift(w);
		var ixfe = blob.read_shift(w);
		var flags = blob.read_shift(2);
		if(w == 2) blob.l += 2;
		var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags});
		if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
		return o;
	}
	
	/* [MS-XLS] 2.4.257 */
	function parse_Setup(blob, length) {
		var o = {};
		if(length < 32) return o;
		blob.l += 16;
		o.header = parse_Xnum(blob, 8);
		o.footer = parse_Xnum(blob, 8);
		blob.l += 2;
		return o;
	}
	
	/* [MS-XLS] 2.4.261 */
	function parse_ShtProps(blob, length, opts) {
		var def = {area:false};
		if(opts.biff != 5) { blob.l += length; return def; }
		var d = blob.read_shift(1); blob.l += 3;
		if((d & 0x10)) def.area = true;
		return def;
	}
	
	/* [MS-XLS] 2.4.241 */
	function write_RRTabId(n) {
		var out = new_buf(2 * n);
		for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
		return out;
	}
	
	var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
	var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
	var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */
	
	/* --- Specific to versions before BIFF8 --- */
	function parse_ImData(blob) {
		var cf = blob.read_shift(2);
		var env = blob.read_shift(2);
		var lcb = blob.read_shift(4);
		var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
		blob.l += lcb;
		return o;
	}
	
	/* BIFF2_??? where ??? is the name from [XLS] */
	function parse_BIFF2STR(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var str = parse_XLUnicodeString2(blob, length-7, opts);
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	
	function parse_BIFF2NUM(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = parse_Xnum(blob, 8);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2NUM(r, c, val) {
		var out = new_buf(15);
		write_BIFF2Cell(out, r, c);
		out.write_shift(8, val, 'f');
		return out;
	}
	
	function parse_BIFF2INT(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = blob.read_shift(2);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2INT(r, c, val) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		out.write_shift(2, val);
		return out;
	}
	
	function parse_BIFF2STRING(blob) {
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, 'sbcs-cont');
	}
	
	/* TODO: convert to BIFF8 font struct */
	function parse_BIFF2FONTXTRA(blob, length) {
		blob.l += 6; // unknown
		blob.l += 2; // font weight "bls"
		blob.l += 1; // charset
		blob.l += 3; // unknown
		blob.l += 1; // font family
		blob.l += length - 13;
	}
	
	/* TODO: parse rich text runs */
	function parse_RString(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		var cch = blob.read_shift(2);
		var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
		blob.l = end;
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	/* from js-harb (C) 2014-present  SheetJS */
	var DBF = (function() {
	var dbf_codepage_map = {
		/* Code Pages Supported by Visual FoxPro */
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	
		/* shapefile DBF extension */
	0x00: 20127,           0x08:   865,
	0x09:   437,           0x0A:   850,
	0x0B:   437,           0x0D:   437,
	0x0E:   850,           0x0F:   437,
	0x10:   850,           0x11:   437,
	0x12:   850,           0x13:   932,
	0x14:   850,           0x15:   437,
	0x16:   850,           0x17:   865,
	0x18:   437,           0x19:   437,
	0x1A:   850,           0x1B:   437,
	0x1C:   863,           0x1D:   850,
	0x1F:   852,           0x22:   852,
	0x23:   852,           0x24:   860,
	0x25:   850,           0x26:   866,
	0x37:   850,           0x40:   852,
	0x4D:   936,           0x4E:   949,
	0x4F:   950,           0x50:   874,
	0x57:  1252,           0x58:  1252,
	0x59:  1252,
	
	0xFF: 16969
	};
	var dbf_reverse_map = evert({
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	0x00: 20127
	});
	/* TODO: find an actual specification */
	function dbf_to_aoa(buf, opts) {
		var out = [];
		/* TODO: browser based */
		var d = (new_raw_buf(1));
		switch(opts.type) {
			case 'base64': d = s2a(Base64.decode(buf)); break;
			case 'binary': d = s2a(buf); break;
			case 'buffer':
			case 'array': d = buf; break;
		}
		prep_blob(d, 0);
		/* header */
		var ft = d.read_shift(1);
		var memo = false;
		var vfp = false, l7 = false;
		switch(ft) {
			case 0x02: case 0x03: break;
			case 0x30: vfp = true; memo = true; break;
			case 0x31: vfp = true; break;
			case 0x83: memo = true; break;
			case 0x8B: memo = true; break;
			case 0x8C: memo = true; l7 = true; break;
			case 0xF5: memo = true; break;
			default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
		}
		var /*filedate = new Date(),*/ nrow = 0, fpos = 0;
		if(ft == 0x02) nrow = d.read_shift(2);
		/*filedate = new Date(d.read_shift(1) + 1900, d.read_shift(1) - 1, d.read_shift(1));*/d.l += 3;
		if(ft != 0x02) nrow = d.read_shift(4);
		if(ft != 0x02) fpos = d.read_shift(2);
		var rlen = d.read_shift(2);
	
		var /*flags = 0,*/ current_cp = 1252;
		if(ft != 0x02) {
		d.l+=16;
		/*flags = */d.read_shift(1);
		//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
	
		/* codepage present in FoxPro */
		if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
		d.l+=1;
	
		d.l+=2;
		}
		if(l7) d.l += 36;
	var fields = [], field = ({});
		var hend = fpos - 10 - (vfp ? 264 : 0), ww = l7 ? 32 : 11;
		while(ft == 0x02 ? d.l < d.length && d[d.l] != 0x0d: d.l < hend) {
			field = ({});
			field.name = cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
			d.l += ww;
			field.type = String.fromCharCode(d.read_shift(1));
			if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
			field.len = d.read_shift(1);
			if(ft == 0x02) field.offset = d.read_shift(2);
			field.dec = d.read_shift(1);
			if(field.name.length) fields.push(field);
			if(ft != 0x02) d.l += l7 ? 13 : 14;
			switch(field.type) {
				case 'B': // VFP Double
					if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'G': // General
				case 'P': // Picture
					if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'C': // character
				case 'D': // date
				case 'F': // floating point
				case 'I': // long
				case 'L': // boolean
				case 'M': // memo
				case 'N': // number
				case 'O': // double
				case 'T': // datetime
				case 'Y': // currency
				case '0': // VFP _NullFlags
				case '@': // timestamp
				case '+': // autoincrement
					break;
				default: throw new Error('Unknown Field Type: ' + field.type);
			}
		}
		if(d[d.l] !== 0x0D) d.l = fpos-1;
		else if(ft == 0x02) d.l = 0x209;
		if(ft != 0x02) {
			if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
			d.l = fpos;
		}
		/* data */
		var R = 0, C = 0;
		out[0] = [];
		for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
		while(nrow-- > 0) {
			if(d[d.l] === 0x2A) { d.l+=rlen; continue; }
			++d.l;
			out[++R] = []; C = 0;
			for(C = 0; C != fields.length; ++C) {
				var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
				prep_blob(dd, 0);
				var s = cptable.utils.decode(current_cp, dd);
				switch(fields[C].type) {
					case 'C':
						out[R][C] = cptable.utils.decode(current_cp, dd);
						out[R][C] = out[R][C].trim();
						break;
					case 'D':
						if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
						else out[R][C] = s;
						break;
					case 'F': out[R][C] = parseFloat(s.trim()); break;
					case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
					case 'L': switch(s.toUpperCase()) {
						case 'Y': case 'T': out[R][C] = true; break;
						case 'N': case 'F': out[R][C] = false; break;
						case ' ': case '?': out[R][C] = false; break; /* NOTE: technically uninitialized */
						default: throw new Error("DBF Unrecognized L:|" + s + "|");
						} break;
					case 'M': /* TODO: handle memo files */
						if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
						out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
						break;
					case 'N': out[R][C] = +s.replace(/\u0000/g,"").trim(); break;
					case '@': out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400); break;
					case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
					case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4; break;
					case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
					case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
						/* falls through */
					case 'G': case 'P': dd.l += fields[C].len; break;
					case '0':
						if(fields[C].name === '_NullFlags') break;
						/* falls through */
					default: throw new Error("DBF Unsupported data type " + fields[C].type);
				}
			}
		}
		if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
		if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
		return out;
	}
	
	function dbf_to_sheet(buf, opts) {
		var o = opts || {};
		if(!o.dateNF) o.dateNF = "yyyymmdd";
		return aoa_to_sheet(dbf_to_aoa(buf, o), o);
	}
	
	function dbf_to_workbook(buf, opts) {
		try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
		catch(e) { if(opts && opts.WTF) throw e; }
		return ({SheetNames:[],Sheets:{}});
	}
	
	var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
	function sheet_to_dbf(ws, opts) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write DBF to JS string");
		var ba = buf_array();
		var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
		var headers = aoa[0], data = aoa.slice(1);
		var i = 0, j = 0, hcnt = 0, rlen = 1;
		for(i = 0; i < headers.length; ++i) {
			if(i == null) continue;
			++hcnt;
			if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
			if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
			if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
				if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
		}
		var range = safe_decode_range(ws['!ref']);
		var coltypes = [];
		for(i = 0; i <= range.e.c - range.s.c; ++i) {
			var col = [];
			for(j=0; j < data.length; ++j) {
				if(data[j][i] != null) col.push(data[j][i]);
			}
			if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
			var guess = '', _guess = '';
			for(j = 0; j < col.length; ++j) {
				switch(typeof col[j]) {
					/* TODO: check if L2 compat is desired */
					case 'number': _guess = 'B'; break;
					case 'string': _guess = 'C'; break;
					case 'boolean': _guess = 'L'; break;
					case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
					default: _guess = 'C';
				}
				guess = guess && guess != _guess ? 'C' : _guess;
				if(guess == 'C') break;
			}
			rlen += _RLEN[guess] || 0;
			coltypes[i] = guess;
		}
	
		var h = ba.next(32);
		h.write_shift(4, 0x13021130);
		h.write_shift(4, data.length);
		h.write_shift(2, 296 + 32 * hcnt);
		h.write_shift(2, rlen);
		for(i=0; i < 4; ++i) h.write_shift(4, 0);
		h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[current_ansi] || 0x03)<<8));
	
		for(i = 0, j = 0; i < headers.length; ++i) {
			if(headers[i] == null) continue;
			var hf = ba.next(32);
			var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
			hf.write_shift(1, _f, "sbcs");
			hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
			hf.write_shift(4, j);
			hf.write_shift(1, _RLEN[coltypes[i]] || 0);
			hf.write_shift(1, 0);
			hf.write_shift(1, 0x02);
			hf.write_shift(4, 0);
			hf.write_shift(1, 0);
			hf.write_shift(4, 0);
			hf.write_shift(4, 0);
			j += _RLEN[coltypes[i]] || 0;
		}
	
		var hb = ba.next(264);
		hb.write_shift(4, 0x0000000D);
		for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
		for(i=0; i < data.length; ++i) {
			var rout = ba.next(rlen);
			rout.write_shift(1, 0);
			for(j=0; j<headers.length; ++j) {
				if(headers[j] == null) continue;
				switch(coltypes[j]) {
					case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
					case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
					case 'D':
						if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
						else {
							rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
							rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
							rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
						} break;
					case 'C':
						var _s = String(data[i][j]||"");
						rout.write_shift(1, _s, "sbcs");
						for(hcnt=0; hcnt < 250-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
				}
			}
			// data
		}
		ba.next(1).write_shift(1, 0x1A);
		return ba.end();
	}
		return {
			to_workbook: dbf_to_workbook,
			to_sheet: dbf_to_sheet,
			from_sheet: sheet_to_dbf
		};
	})();
	
	var SYLK = (function() {
		/* TODO: stress test sequences */
		var sylk_escapes = ({
			AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
			AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
			AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
			AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
			AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
			Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
			Ae:'è', Be:'é', Ce:'ê',         He:'ë',
			Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
			Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
			Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
			KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
			DN:209, Dn:241, Hy:255,
			S:169,  c:170,  R:174,  B:180,
	0:176,    1:177,  2:178,
	3:179,    5:181,  6:182,
	7:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
			"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
			"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
		});
		var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
		var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
		var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
		sylk_escapes["|"] = 254;
		/* TODO: find an actual specification */
		function sylk_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return sylk_to_aoa_str(Base64.decode(d), opts);
				case 'binary': return sylk_to_aoa_str(d, opts);
				case 'buffer': return sylk_to_aoa_str(d.toString('binary'), opts);
				case 'array': return sylk_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function sylk_to_aoa_str(str, opts) {
			var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
			var formats = [];
			var next_cell_format = null;
			var sht = {}, rowinfo = [], colinfo = [], cw = [];
			var Mval = 0, j;
			if(+opts.codepage >= 0) set_cp(+opts.codepage);
			for (; ri !== records.length; ++ri) {
				Mval = 0;
				var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
				var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
				var RT=record[0], val;
				if(rstr.length > 0) switch(RT) {
				case 'ID': break; /* header */
				case 'E': break; /* EOF */
				case 'B': break; /* dimensions */
				case 'O': break; /* options? */
				case 'P':
					if(record[1].charAt(0) == 'P')
						formats.push(rstr.slice(3).replace(/;;/g, ";"));
					break;
				case 'C':
				var C_seen_K = false, C_seen_X = false;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'K':
						val = record[rj].slice(1);
						if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
						else if(val === 'TRUE') val = true;
						else if(val === 'FALSE') val = false;
						else if(!isNaN(fuzzynum(val))) {
							val = fuzzynum(val);
							if(next_cell_format !== null && SSF.is_date(next_cell_format)) val = numdate(val);
						} else if(!isNaN(fuzzydate(val).getDate())) {
							val = parseDate(val);
						}
						if(typeof cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = cptable.utils.decode(opts.codepage, val);
						C_seen_K = true;
						break;
					case 'E':
						var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
						arr[R][C] = [arr[R][C], formula];
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(C_seen_K) { arr[R][C] = val; next_cell_format = null; }
				break;
				case 'F':
				var F_seen = 0;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
					case 'F': break; /* ??? */
					case 'G': break; /* hide grid */
					case 'P':
						next_cell_format = formats[parseInt(record[rj].slice(1))];
						break;
					case 'S': break; /* cell style */
					case 'D': break; /* column */
					case 'N': break; /* font */
					case 'W':
						cw = record[rj].slice(1).split(" ");
						for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
							Mval = parseInt(cw[2], 10);
							colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
						} break;
					case 'C': /* default column format */
						C = parseInt(record[rj].slice(1))-1;
						if(!colinfo[C]) colinfo[C] = {};
						break;
					case 'R': /* row properties */
						R = parseInt(record[rj].slice(1))-1;
						if(!rowinfo[R]) rowinfo[R] = {};
						if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
						else if(Mval === 0) rowinfo[R].hidden = true;
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(F_seen < 1) next_cell_format = null; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
			}
			if(rowinfo.length > 0) sht['!rows'] = rowinfo;
			if(colinfo.length > 0) sht['!cols'] = colinfo;
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return [arr, sht];
		}
	
		function sylk_to_sheet(d, opts) {
			var aoasht = sylk_to_aoa(d, opts);
			var aoa = aoasht[0], ws = aoasht[1];
			var o = aoa_to_sheet(aoa, opts);
			keys(ws).forEach(function(k) { o[k] = ws[k]; });
			return o;
		}
	
		function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }
	
		function write_ws_cell_sylk(cell, ws, R, C) {
			var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
			switch(cell.t) {
				case 'n':
					o += (cell.v||0);
					if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
				case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
				case 'e': o += cell.w || cell.v; break;
				case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
				case 's': o += '"' + cell.v.replace(/"/g,"") + '"'; break;
			}
			return o;
		}
	
		function write_ws_cols_sylk(out, cols) {
			cols.forEach(function(col, i) {
				var rec = "F;W" + (i+1) + " " + (i+1) + " ";
				if(col.hidden) rec += "0";
				else {
					if(typeof col.width == 'number') col.wpx = width2px(col.width);
					if(typeof col.wpx == 'number') col.wch = px2char(col.wpx);
					if(typeof col.wch == 'number') rec += Math.round(col.wch);
				}
				if(rec.charAt(rec.length - 1) != " ") out.push(rec);
			});
		}
	
		function write_ws_rows_sylk(out, rows) {
			rows.forEach(function(row, i) {
				var rec = "F;";
				if(row.hidden) rec += "M0;";
				else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
				else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
				if(rec.length > 2) out.push(rec + "R" + (i+1));
			});
		}
	
		function sheet_to_sylk(ws, opts) {
			var preamble = ["ID;PWXL;N;E"], o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			var RS = "\r\n";
	
			preamble.push("P;PGeneral");
			preamble.push("F;P0;DG0G8;M255");
			if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
			if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
	
			preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
					o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
				}
			}
			return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
		}
	
		return {
			to_workbook: sylk_to_workbook,
			to_sheet: sylk_to_sheet,
			from_sheet: sheet_to_sylk
		};
	})();
	
	var DIF = (function() {
		function dif_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return dif_to_aoa_str(Base64.decode(d), opts);
				case 'binary': return dif_to_aoa_str(d, opts);
				case 'buffer': return dif_to_aoa_str(d.toString('binary'), opts);
				case 'array': return dif_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function dif_to_aoa_str(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
				if (R < 0) continue;
				var metadata = records[ri].trim().split(",");
				var type = metadata[0], value = metadata[1];
				++ri;
				var data = records[ri].trim();
				switch (+type) {
					case -1:
						if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
						else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
						break;
					case 0:
						if(data === 'TRUE') arr[R][C] = true;
						else if(data === 'FALSE') arr[R][C] = false;
						else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
						else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
						else arr[R][C] = value;
						++C; break;
					case 1:
						data = data.slice(1,data.length-1);
						arr[R][C++] = data !== '' ? data : null;
						break;
				}
				if (data === 'EOD') break;
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
		function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }
	
		var sheet_to_dif = (function() {
			var push_field = function pf(o, topic, v, n, s) {
				o.push(topic);
				o.push(v + "," + n);
				o.push('"' + s.replace(/"/g,'""') + '"');
			};
			var push_value = function po(o, type, v, s) {
				o.push(type + "," + v);
				o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
			};
			return function sheet_to_dif(ws) {
				var o = [];
				var r = safe_decode_range(ws['!ref']), cell;
				var dense = Array.isArray(ws);
				push_field(o, "TABLE", 0, 1, "sheetjs");
				push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
				push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
				push_field(o, "DATA", 0, 0,"");
				for(var R = r.s.r; R <= r.e.r; ++R) {
					push_value(o, -1, 0, "BOT");
					for(var C = r.s.c; C <= r.e.c; ++C) {
						var coord = encode_cell({r:R,c:C});
						cell = dense ? (ws[R]||[])[C] : ws[coord];
						if(!cell) { push_value(o, 1, 0, ""); continue;}
						switch(cell.t) {
							case 'n':
								var val = DIF_XL ? cell.w : cell.v;
								if(!val && cell.v != null) val = cell.v;
								if(val == null) {
									if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
									else push_value(o, 1, 0, "");
								}
								else push_value(o, 0, val, "V");
								break;
							case 'b':
								push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
								break;
							case 's':
								push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
								break;
							case 'd':
								if(!cell.w) cell.w = SSF.format(cell.z || SSF._table[14], datenum(parseDate(cell.v)));
								if(DIF_XL) push_value(o, 0, cell.w, "V");
								else push_value(o, 1, 0, cell.w);
								break;
							default: push_value(o, 1, 0, "");
						}
					}
				}
				push_value(o, -1, 0, "EOD");
				var RS = "\r\n";
				var oo = o.join(RS);
				//while((oo.length & 0x7F) != 0) oo += "\0";
				return oo;
			};
		})();
		return {
			to_workbook: dif_to_workbook,
			to_sheet: dif_to_sheet,
			from_sheet: sheet_to_dif
		};
	})();
	
	var ETH = (function() {
		function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
		function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }
	
		function eth_to_aoa(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				var record = records[ri].trim().split(":");
				if(record[0] !== 'cell') continue;
				var addr = decode_cell(record[1]);
				if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
				R = addr.r; C = addr.c;
				switch(record[2]) {
					case 't': arr[R][C] = decode(record[3]); break;
					case 'v': arr[R][C] = +record[3]; break;
					case 'vtf': var _f = record[record.length - 1];
						/* falls through */
					case 'vtc':
						switch(record[3]) {
							case 'nl': arr[R][C] = +record[4] ? true : false; break;
							default: arr[R][C] = +record[4]; break;
						}
						if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
				}
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
		function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }
	
		var header = [
			"socialcalc:version:1.5",
			"MIME-Version: 1.0",
			"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
		].join("\n");
	
		var sep = [
			"--SocialCalcSpreadsheetControlSave",
			"Content-type: text/plain; charset=UTF-8"
		].join("\n") + "\n";
	
		/* TODO: the other parts */
		var meta = [
			"# SocialCalc Spreadsheet Control Save",
			"part:sheet"
		].join("\n");
	
		var end = "--SocialCalcSpreadsheetControlSave--";
	
		function sheet_to_eth_data(ws) {
			if(!ws || !ws['!ref']) return "";
			var o = [], oo = [], cell, coord = "";
			var r = decode_range(ws['!ref']);
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null || cell.t === 'z') continue;
					oo = ["cell", coord, 't'];
					switch(cell.t) {
						case 's': case 'str': oo.push(encode(cell.v)); break;
						case 'n':
							if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
							else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
							break;
						case 'b':
							oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
							oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
							break;
						case 'd':
							var t = datenum(parseDate(cell.v));
							oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
							oo[5] = cell.w || SSF.format(cell.z || SSF._table[14], t);
							break;
						case 'e': continue;
					}
					o.push(oo.join(":"));
				}
			}
			o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
			o.push("valueformat:1:text-wiki");
			//o.push("copiedfrom:" + ws['!ref']); // clipboard only
			return o.join("\n");
		}
	
		function sheet_to_eth(ws) {
			return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
			// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
		}
	
		return {
			to_workbook: eth_to_workbook,
			to_sheet: eth_to_sheet,
			from_sheet: sheet_to_eth
		};
	})();
	
	var PRN = (function() {
		function set_text_arr(data, arr, R, C, o) {
			if(o.raw) arr[R][C] = data;
			else if(data === 'TRUE') arr[R][C] = true;
			else if(data === 'FALSE') arr[R][C] = false;
			else if(data === ""){/* empty */}
			else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
			else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
			else arr[R][C] = data;
		}
	
		function prn_to_aoa_str(f, opts) {
			var o = opts || {};
			var arr = ([]);
			if(!f || f.length === 0) return arr;
			var lines = f.split(/[\r\n]/);
			var L = lines.length - 1;
			while(L >= 0 && lines[L].length === 0) --L;
			var start = 10, idx = 0;
			var R = 0;
			for(; R <= L; ++R) {
				idx = lines[R].indexOf(" ");
				if(idx == -1) idx = lines[R].length; else idx++;
				start = Math.max(start, idx);
			}
			for(R = 0; R <= L; ++R) {
				arr[R] = [];
				/* TODO: confirm that widths are always 10 */
				var C = 0;
				set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
				for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
					set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
			}
			if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
			return arr;
		}
	
		// List of accepted CSV separators
		var guess_seps = {
	0x2C: ',',
	0x09: "\t",
	0x3B: ';'
		};
	
		// CSV separator weights to be used in case of equal numbers
		var guess_sep_weights = {
	0x2C: 3,
	0x09: 2,
	0x3B: 1
		};
	
		function guess_sep(str) {
			var cnt = {}, instr = false, end = 0, cc = 0;
			for(;end < str.length;++end) {
				if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
				else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
			}
	
			cc = [];
			for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
				cc.push([ cnt[end], end ]);
			}
	
			if ( !cc.length ) {
				cnt = guess_sep_weights;
				for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
					cc.push([ cnt[end], end ]);
				}
			}
	
			cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });
	
			return guess_seps[cc.pop()[1]];
		}
	
		function dsv_to_sheet_str(str, opts) {
			var o = opts || {};
			var sep = "";
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			if(str.slice(0,4) == "sep=" && str.charCodeAt(5) == 10) { sep = str.charAt(4); str = str.slice(6); }
			else sep = guess_sep(str.slice(0,1024));
			var R = 0, C = 0, v = 0;
			var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0;
			str = str.replace(/\r\n/mg, "\n");
			var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
			function finish_cell() {
				var s = str.slice(start, end);
				var cell = ({});
				if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
				if(s.length === 0) cell.t = 'z';
				else if(o.raw) { cell.t = 's'; cell.v = s; }
				else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
				else if(s.charCodeAt(0) == 0x3D) {
					if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
					else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
					else { cell.t = 's'; cell.v = s; } }
				else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
				else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
				else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
				else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
					cell.z = o.dateNF || SSF._table[14];
					var k = 0;
					if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
					if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
					else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
					if(o.cellText !== false) cell.w = SSF.format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
					if(!o.cellNF) delete cell.z;
				} else {
					cell.t = 's';
					cell.v = s;
				}
				if(cell.t == 'z'){}
				else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
				else ws[encode_cell({c:C,r:R})] = cell;
				start = end+1;
				if(range.e.c < C) range.e.c = C;
				if(range.e.r < R) range.e.r = R;
				if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
			}
			outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
				case 0x22: instr = !instr; break;
				case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
				default: break;
			}
			if(end - start > 0) finish_cell();
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function prn_to_sheet_str(str, opts) {
			if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
			if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
			return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
		}
	
		function prn_to_sheet(d, opts) {
			var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
			switch(opts.type) {
				case 'base64': str = Base64.decode(d); break;
				case 'binary': str = d; break;
				case 'buffer':
					if(opts.codepage == 65001) str = d.toString('utf8');
					else if(opts.codepage && typeof cptable !== 'undefined') str = cptable.utils.decode(opts.codepage, d);
					else str = d.toString('binary');
					break;
				case 'array': str = cc2str(d); break;
				case 'string': str = d; break;
				default: throw new Error("Unrecognized type " + opts.type);
			}
			if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
			else if((opts.type == 'binary') && typeof cptable !== 'undefined' && opts.codepage)  str = cptable.utils.decode(opts.codepage, cptable.utils.encode(1252,str));
			if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
			return prn_to_sheet_str(str, opts);
		}
	
		function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }
	
		function sheet_to_prn(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				var oo = [];
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null) { oo.push("          "); continue; }
					var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
					while(w.length < 10) w += " ";
					oo.push(w + (C === 0 ? " " : ""));
				}
				o.push(oo.join(""));
			}
			return o.join("\n");
		}
	
		return {
			to_workbook: prn_to_workbook,
			to_sheet: prn_to_sheet,
			from_sheet: sheet_to_prn
		};
	})();
	
	/* Excel defaults to SYLK but warns if data is not valid */
	function read_wb_ID(d, opts) {
		var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
		try {
			var out = SYLK.to_workbook(d, o);
			o.WTF = OLD_WTF;
			return out;
		} catch(e) {
			o.WTF = OLD_WTF;
			if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
			return PRN.to_workbook(d, opts);
		}
	}
	
	var WK_ = (function() {
		function lotushopper(data, cb, opts) {
			if(!data) return;
			prep_blob(data, data.l || 0);
			var Enum = opts.Enum || WK1Enum;
			while(data.l < data.length) {
				var RT = data.read_shift(2);
				var R = Enum[RT] || Enum[0xFF];
				var length = data.read_shift(2);
				var tgt = data.l + length;
				var d = (R.f||parsenoop)(data, length, opts);
				data.l = tgt;
				if(cb(d, R.n, RT)) return;
			}
		}
	
		function lotus_to_workbook(d, opts) {
			switch(opts.type) {
				case 'base64': return lotus_to_workbook_buf(s2a(Base64.decode(d)), opts);
				case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
				case 'buffer':
				case 'array': return lotus_to_workbook_buf(d, opts);
			}
			throw "Unsupported type " + opts.type;
		}
	
		function lotus_to_workbook_buf(d, opts) {
			if(!d) return d;
			var o = opts || {};
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var s = ((o.dense ? [] : {})), n = "Sheet1", sidx = 0;
			var sheets = {}, snames = [n];
	
			var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
			var sheetRows = o.sheetRows || 0;
	
			if(d[2] == 0x02) o.Enum = WK1Enum;
			else if(d[2] == 0x1a) o.Enum = WK3Enum;
			else if(d[2] == 0x0e) { o.Enum = WK3Enum; o.qpro = true; d.l = 0; }
			else throw new Error("Unrecognized LOTUS BOF " + d[2]);
			lotushopper(d, function(val, Rn, RT) {
				if(d[2] == 0x02) switch(RT) {
					case 0x00:
						o.vers = val;
						if(val >= 0x1000) o.qpro = true;
						break;
					case 0x06: refguess = val; break; /* RANGE */
					case 0x0F: /* LABEL */
						if(!o.qpro) val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x0D: /* INTEGER */
					case 0x0E: /* NUMBER */
					case 0x10: /* FORMULA */
					case 0x33: /* STRING */
						/* TODO: actual translation of the format code */
						if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
							val[1].z = o.dateNF || SSF._table[14];
							if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
						}
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						break;
				} else switch(RT) {
					case 0x16: /* LABEL16 */
						val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x17: /* NUMBER17 */
					case 0x18: /* NUMBER18 */
					case 0x19: /* FORMULA19 */
					case 0x25: /* NUMBER25 */
					case 0x27: /* NUMBER27 */
					case 0x28: /* FORMULA28 */
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = "Sheet" + (sidx + 1);
							snames.push(n);
						}
						if(sheetRows > 0 && val[0].r >= sheetRows) break;
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
						if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
						break;
					default: break;
				}
			}, o);
	
			s["!ref"] = encode_range(refguess);
			sheets[n] = s;
			return { SheetNames: snames, Sheets:sheets };
		}
	
		function parse_RANGE(blob) {
			var o = {s:{c:0,r:0},e:{c:0,r:0}};
			o.s.c = blob.read_shift(2);
			o.s.r = blob.read_shift(2);
			o.e.c = blob.read_shift(2);
			o.e.r = blob.read_shift(2);
			if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
			return o;
		}
	
		function parse_cell(blob, length, opts) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			if(opts.qpro && opts.vers != 0x5120) {
				o[0].c = blob.read_shift(1);
				blob.l++;
				o[0].r = blob.read_shift(2);
				blob.l+=2;
			} else {
				o[2] = blob.read_shift(1);
				o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
			}
			return o;
		}
	
		function parse_LABEL(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			o[1].t = 's';
			if(opts.vers == 0x5120) {
				blob.l++;
				var len = blob.read_shift(1);
				o[1].v = blob.read_shift(len, 'utf8');
				return o;
			}
			if(opts.qpro) blob.l++;
			o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
			return o;
		}
	
		function parse_INTEGER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(2, 'i');
			return o;
		}
	
		function parse_NUMBER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(8, 'f');
			return o;
		}
	
		function parse_FORMULA(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			/* TODO: formula */
			o[1].v = blob.read_shift(8, 'f');
			if(opts.qpro) blob.l = tgt;
			else {
				var flen = blob.read_shift(2);
				blob.l += flen;
			}
			return o;
		}
	
		function parse_cell_3(blob) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
			return o;
		}
	
		function parse_LABEL_16(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].t = 's';
			o[1].v = blob.read_shift(length - 4, 'cstr');
			return o;
		}
	
		function parse_NUMBER_18(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].v = blob.read_shift(2);
			var v = o[1].v >> 1;
			/* TODO: figure out all of the corner cases */
			if(o[1].v & 0x1) {
				switch(v & 0x07) {
					case 1: v = (v >> 3) * 500; break;
					case 2: v = (v >> 3) / 20; break;
					case 4: v = (v >> 3) / 2000; break;
					case 6: v = (v >> 3) / 16; break;
					case 7: v = (v >> 3) / 64; break;
					default: throw "unknown NUMBER_18 encoding " + (v & 0x07);
				}
			}
			o[1].v = v;
			return o;
		}
	
		function parse_NUMBER_17(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			var v2 = blob.read_shift(4);
			var e = blob.read_shift(2);
			if(e == 0xFFFF) { o[1].v = 0; return o; }
			var s = e & 0x8000; e = (e&0x7FFF) - 16446;
			o[1].v = (s*2 - 1) * ((e > 0 ? (v2 << e) : (v2 >>> -e)) + (e > -32 ? (v1 << (e + 32)) : (v1 >>> -(e + 32))));
			return o;
		}
	
		function parse_FORMULA_19(blob, length) {
			var o = parse_NUMBER_17(blob, 14);
			blob.l += length - 14; /* TODO: formula */
			return o;
		}
	
		function parse_NUMBER_25(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			o[1].v = v1 >> 6;
			return o;
		}
	
		function parse_NUMBER_27(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(8,'f');
			o[1].v = v1;
			return o;
		}
	
		function parse_FORMULA_28(blob, length) {
			var o = parse_NUMBER_27(blob, 14);
			blob.l += length - 10; /* TODO: formula */
			return o;
		}
	
		var WK1Enum = {
	0x0000: { n:"BOF", f:parseuint16 },
	0x0001: { n:"EOF" },
	0x0002: { n:"CALCMODE" },
	0x0003: { n:"CALCORDER" },
	0x0004: { n:"SPLIT" },
	0x0005: { n:"SYNC" },
	0x0006: { n:"RANGE", f:parse_RANGE },
	0x0007: { n:"WINDOW1" },
	0x0008: { n:"COLW1" },
	0x0009: { n:"WINTWO" },
	0x000A: { n:"COLW2" },
	0x000B: { n:"NAME" },
	0x000C: { n:"BLANK" },
	0x000D: { n:"INTEGER", f:parse_INTEGER },
	0x000E: { n:"NUMBER", f:parse_NUMBER },
	0x000F: { n:"LABEL", f:parse_LABEL },
	0x0010: { n:"FORMULA", f:parse_FORMULA },
	0x0018: { n:"TABLE" },
	0x0019: { n:"ORANGE" },
	0x001A: { n:"PRANGE" },
	0x001B: { n:"SRANGE" },
	0x001C: { n:"FRANGE" },
	0x001D: { n:"KRANGE1" },
	0x0020: { n:"HRANGE" },
	0x0023: { n:"KRANGE2" },
	0x0024: { n:"PROTEC" },
	0x0025: { n:"FOOTER" },
	0x0026: { n:"HEADER" },
	0x0027: { n:"SETUP" },
	0x0028: { n:"MARGINS" },
	0x0029: { n:"LABELFMT" },
	0x002A: { n:"TITLES" },
	0x002B: { n:"SHEETJS" },
	0x002D: { n:"GRAPH" },
	0x002E: { n:"NGRAPH" },
	0x002F: { n:"CALCCOUNT" },
	0x0030: { n:"UNFORMATTED" },
	0x0031: { n:"CURSORW12" },
	0x0032: { n:"WINDOW" },
	0x0033: { n:"STRING", f:parse_LABEL },
	0x0037: { n:"PASSWORD" },
	0x0038: { n:"LOCKED" },
	0x003C: { n:"QUERY" },
	0x003D: { n:"QUERYNAME" },
	0x003E: { n:"PRINT" },
	0x003F: { n:"PRINTNAME" },
	0x0040: { n:"GRAPH2" },
	0x0041: { n:"GRAPHNAME" },
	0x0042: { n:"ZOOM" },
	0x0043: { n:"SYMSPLIT" },
	0x0044: { n:"NSROWS" },
	0x0045: { n:"NSCOLS" },
	0x0046: { n:"RULER" },
	0x0047: { n:"NNAME" },
	0x0048: { n:"ACOMM" },
	0x0049: { n:"AMACRO" },
	0x004A: { n:"PARSE" },
	0x00FF: { n:"", f:parsenoop }
		};
	
		var WK3Enum = {
	0x0000: { n:"BOF" },
	0x0001: { n:"EOF" },
	0x0003: { n:"??" },
	0x0004: { n:"??" },
	0x0005: { n:"??" },
	0x0006: { n:"??" },
	0x0007: { n:"??" },
	0x0009: { n:"??" },
	0x000a: { n:"??" },
	0x000b: { n:"??" },
	0x000c: { n:"??" },
	0x000e: { n:"??" },
	0x000f: { n:"??" },
	0x0010: { n:"??" },
	0x0011: { n:"??" },
	0x0012: { n:"??" },
	0x0013: { n:"??" },
	0x0015: { n:"??" },
	0x0016: { n:"LABEL16", f:parse_LABEL_16},
	0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
	0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
	0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
	0x001a: { n:"??" },
	0x001b: { n:"??" },
	0x001c: { n:"??" },
	0x001d: { n:"??" },
	0x001e: { n:"??" },
	0x001f: { n:"??" },
	0x0021: { n:"??" },
	0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
	0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
	0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
	0x00FF: { n:"", f:parsenoop }
		};
		return {
			to_workbook: lotus_to_workbook
		};
	})();
	/* 18.4.7 rPr CT_RPrElt */
	function parse_rpr(rpr) {
		var font = {}, m = rpr.match(tagregex), i = 0;
		var pass = false;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;
	
				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					font.cp = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;
	
				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;
	
				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;
	
				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;
	
				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;
	
				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': font.valign = y.val; break;
	
				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		return font;
	}
	
	var parse_rs = (function() {
		var tregex = matchtag("t"), rpregex = matchtag("rPr");
		/* 18.4.4 r CT_RElt */
		function parse_r(r) {
			/* 18.4.12 t ST_Xstring */
			var t = r.match(tregex)/*, cp = 65001*/;
			if(!t) return {t:"s", v:""};
	
			var o = ({t:'s', v:unescapexml(t[1])});
			var rpr = r.match(rpregex);
			if(rpr) o.s = parse_rpr(rpr[1]);
			return o;
		}
		var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
		return function parse_rs(rs) {
			return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
		};
	})();
	
	
	/* Parse a list of <r> tags */
	var rs_to_html = (function parse_rs_factory() {
		var nlregex = /(\r\n|\n)/g;
		function parse_rpr2(font, intro, outro) {
			var style = [];
	
			if(font.u) style.push("text-decoration: underline;");
			if(font.uval) style.push("text-underline-style:" + font.uval + ";");
			if(font.sz) style.push("font-size:" + font.sz + "pt;");
			if(font.outline) style.push("text-effect: outline;");
			if(font.shadow) style.push("text-shadow: auto;");
			intro.push('<span style="' + style.join("") + '">');
	
			if(font.b) { intro.push("<b>"); outro.push("</b>"); }
			if(font.i) { intro.push("<i>"); outro.push("</i>"); }
			if(font.strike) { intro.push("<s>"); outro.push("</s>"); }
	
			var align = font.valign || "";
			if(align == "superscript" || align == "super") align = "sup";
			else if(align == "subscript") align = "sub";
			if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }
	
			outro.push("</span>");
			return font;
		}
	
		/* 18.4.4 r CT_RElt */
		function r_to_html(r) {
			var terms = [[],r.v,[]];
			if(!r.v) return "";
	
			if(r.s) parse_rpr2(r.s, terms[0], terms[2]);
	
			return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
		}
	
		return function parse_rs(rs) {
			return rs.map(r_to_html).join("");
		};
	})();
	
	/* 18.4.8 si CT_Rst */
	var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
	var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
	function parse_si(x, opts) {
		var html = opts ? opts.cellHTML : true;
		var z = {};
		if(!x) return null;
		//var y;
		/* 18.4.12 t ST_Xstring (Plaintext String) */
		// TODO: is whitespace actually valid here?
		if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
			z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
			z.r = utf8read(x);
			if(html) z.h = escapehtml(z.t);
		}
		/* 18.4.4 r CT_RElt (Rich Text Run) */
		else if((/*y = */x.match(sirregex))) {
			z.r = utf8read(x);
			z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
			if(html) z.h = rs_to_html(parse_rs(z.r));
		}
		/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
		/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
		return z;
	}
	
	/* 18.4 Shared String Table */
	var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
	var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
	var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
	function parse_sst_xml(data, opts) {
		var s = ([]), ss = "";
		if(!data) return s;
		/* 18.4.9 sst CT_Sst */
		var sst = data.match(sstr0);
		if(sst) {
			ss = sst[2].replace(sstr1,"").split(sstr2);
			for(var i = 0; i != ss.length; ++i) {
				var o = parse_si(ss[i].trim(), opts);
				if(o != null) s[s.length] = o;
			}
			sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
		}
		return s;
	}
	
	RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
	var straywsregex = /^\s|\s$|[\t\n\r]/;
	function write_sst_xml(sst, opts) {
		if(!opts.bookSST) return "";
		var o = [XML_HEADER];
		o[o.length] = (writextag('sst', null, {
			xmlns: XMLNS.main[0],
			count: sst.Count,
			uniqueCount: sst.Unique
		}));
		for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
			var s = sst[i];
			var sitag = "<si>";
			if(s.r) sitag += s.r;
			else {
				sitag += "<t";
				if(!s.t) s.t = "";
				if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
				sitag += ">" + escapexml(s.t) + "</t>";
			}
			sitag += "</si>";
			o[o.length] = (sitag);
		}
		if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.221 BrtBeginSst */
	function parse_BrtBeginSst(data) {
		return [data.read_shift(4), data.read_shift(4)];
	}
	
	/* [MS-XLSB] 2.1.7.45 Shared Strings */
	function parse_sst_bin(data, opts) {
		var s = ([]);
		var pass = false;
		recordhopper(data, function hopper_sst(val, R_n, RT) {
			switch(RT) {
				case 0x009F: /* 'BrtBeginSst' */
					s.Count = val[0]; s.Unique = val[1]; break;
				case 0x0013: /* 'BrtSSTItem' */
					s.push(val); break;
				case 0x00A0: /* 'BrtEndSst' */
					return true;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if(R_n.indexOf("Begin") > 0){/* empty */}
					else if(R_n.indexOf("End") > 0){/* empty */}
					if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return s;
	}
	
	function write_BrtBeginSst(sst, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, sst.Count);
		o.write_shift(4, sst.Unique);
		return o;
	}
	
	var write_BrtSSTItem = write_RichStr;
	
	function write_sst_bin(sst) {
		var ba = buf_array();
		write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
		for(var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
		/* FRTSST */
		write_record(ba, "BrtEndSst");
		return ba.end();
	}
	function _JS2ANSI(str) {
		if(typeof cptable !== 'undefined') return cptable.utils.encode(current_ansi, str);
		var o = [], oo = str.split("");
		for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.4 Version */
	function parse_CRYPTOVersion(blob, length) {
		var o = {};
		o.Major = blob.read_shift(2);
		o.Minor = blob.read_shift(2);
	if(length >= 4) blob.l += length - 4;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
	function parse_DataSpaceVersionInfo(blob) {
		var o = {};
		o.id = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
	function parse_DataSpaceMapEntry(blob) {
		var len = blob.read_shift(4);
		var end = blob.l + len - 4;
		var o = {};
		var cnt = blob.read_shift(4);
		var comps = [];
		/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
		while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
		o.name = blob.read_shift(0, 'lpp4');
		o.comps = comps;
		if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
	function parse_DataSpaceMap(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
	function parse_DataSpaceDefinition(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
	function parse_TransformInfoHeader(blob) {
		var o = {};
		/*var len = */blob.read_shift(4);
		blob.l += 4; // must be 0x1
		o.id = blob.read_shift(0, 'lpp4');
		o.name = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	function parse_Primary(blob) {
		/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
		var hdr = parse_TransformInfoHeader(blob);
		/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
		hdr.ename = blob.read_shift(0, '8lpp4');
		hdr.blksz = blob.read_shift(4);
		hdr.cmode = blob.read_shift(4);
		if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
		return hdr;
	}
	
	/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
	function parse_EncryptionHeader(blob, length) {
		var tgt = blob.l + length;
		var o = {};
		o.Flags = (blob.read_shift(4) & 0x3F);
		blob.l += 4;
		o.AlgID = blob.read_shift(4);
		var valid = false;
		switch(o.AlgID) {
			case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
			case 0x6801: valid = (o.Flags == 0x04); break;
			case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
			default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
		}
		if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
		o.AlgIDHash = blob.read_shift(4);
		o.KeySize = blob.read_shift(4);
		o.ProviderType = blob.read_shift(4);
		blob.l += 8;
		o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
		blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
	function parse_EncryptionVerifier(blob, length) {
		var o = {}, tgt = blob.l + length;
		blob.l += 4; // SaltSize must be 0x10
		o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
		o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
		/*var sz = */blob.read_shift(4);
		o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
	function parse_EncryptionInfo(blob) {
		var vers = parse_CRYPTOVersion(blob);
		switch(vers.Minor) {
			case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
			case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
			case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
		}
		throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
	function parse_EncInfoStd(blob) {
		var flags = blob.read_shift(4);
		if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
		var sz = blob.read_shift(4);
		//var tgt = blob.l + sz;
		var hdr = parse_EncryptionHeader(blob, sz);
		var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
		return { t:"Std", h:hdr, v:verifier };
	}
	/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
	function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
	/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
	function parse_EncInfoAgl(blob) {
		var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
		blob.l+=4;
		var xml = blob.read_shift(blob.length - blob.l, 'utf8');
		var o = {};
		xml.replace(tagregex, function xml_agile(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
				case '<encryption': case '</encryption>': break;
				case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
				case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
				case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
				case '</keyEncryptors>': break;
	
				case '<keyEncryptor': o.uri = y.uri; break;
				case '</keyEncryptor>': break;
				case '<encryptedKey': o.encs.push(y); break;
				default: throw y[0];
			}
		});
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
	function parse_RC4CryptoHeader(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
		if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
		if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
		o.Flags = blob.read_shift(4); length -= 4;
		var sz = blob.read_shift(4); length -= 4;
		o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
		o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
	function parse_RC4Header(blob) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
		if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
		o.Salt = blob.read_shift(16);
		o.EncryptedVerifier = blob.read_shift(16);
		o.EncryptedVerifierHash = blob.read_shift(16);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
	function crypto_CreatePasswordVerifier_Method1(Password) {
		var Verifier = 0x0000, PasswordArray;
		var PasswordDecoded = _JS2ANSI(Password);
		var len = PasswordDecoded.length + 1, i, PasswordByte;
		var Intermediate1, Intermediate2, Intermediate3;
		PasswordArray = new_raw_buf(len);
		PasswordArray[0] = PasswordDecoded.length;
		for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
		for(i = len-1; i >= 0; --i) {
			PasswordByte = PasswordArray[i];
			Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
			Intermediate2 = (Verifier << 1) & 0x7FFF;
			Intermediate3 = Intermediate1 | Intermediate2;
			Verifier = Intermediate3 ^ PasswordByte;
		}
		return Verifier ^ 0xCE4B;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
	var crypto_CreateXorArray_Method1 = (function() {
		var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
		var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
		var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
		var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
		var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
		var CreateXorKey_Method1 = function(Password) {
			var XorKey = InitialCode[Password.length - 1];
			var CurrentElement = 0x68;
			for(var i = Password.length-1; i >= 0; --i) {
				var Char = Password[i];
				for(var j = 0; j != 7; ++j) {
					if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
					Char *= 2; --CurrentElement;
				}
			}
			return XorKey;
		};
		return function(password) {
			var Password = _JS2ANSI(password);
			var XorKey = CreateXorKey_Method1(Password);
			var Index = Password.length;
			var ObfuscationArray = new_raw_buf(16);
			for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
			var Temp, PasswordLastChar, PadIndex;
			if((Index & 1) === 1) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				PasswordLastChar = Password[Password.length - 1];
				ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
			}
			while(Index > 0) {
				--Index;
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			}
			Index = 15;
			PadIndex = 15 - Password.length;
			while(PadIndex > 0) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
				--Index;
				--PadIndex;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				--PadIndex;
			}
			return ObfuscationArray;
		};
	})();
	
	/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
	var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
		/* If XorArray is set, use it; if O is not set, make changes in-place */
		if(!O) O = Data;
		if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
		var Index, Value;
		for(Index = 0; Index != Data.length; ++Index) {
			Value = Data[Index];
			Value ^= XorArray[XorArrayIndex];
			Value = ((Value>>5) | (Value<<3)) & 0xFF;
			O[Index] = Value;
			++XorArrayIndex;
		}
		return [O, XorArrayIndex, XorArray];
	};
	
	var crypto_MakeXorDecryptor = function(password) {
		var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
		return function(Data) {
			var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
			XorArrayIndex = O[1];
			return O[0];
		};
	};
	
	/* 2.5.343 */
	function parse_XORObfuscation(blob, length, opts, out) {
		var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
		if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
		out.valid = o.verificationBytes === o.verifier;
		if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
		return o;
	}
	
	/* 2.4.117 */
	function parse_FilePassHeader(blob, length, oo) {
		var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
		if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
		else o.Data = parse_RC4CryptoHeader(blob, length);
		return o;
	}
	function parse_FilePass(blob, length, opts) {
		var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
		if(o.Type) parse_FilePassHeader(blob, length-2, o);
		else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
		return o;
	}
	
	
	var RTF = (function() {
		function rtf_to_sheet(d, opts) {
			switch(opts.type) {
				case 'base64': return rtf_to_sheet_str(Base64.decode(d), opts);
				case 'binary': return rtf_to_sheet_str(d, opts);
				case 'buffer': return rtf_to_sheet_str(d.toString('binary'), opts);
				case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
	
		function rtf_to_sheet_str(str, opts) {
			var o = opts || {};
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			// TODO: parse
			if(!str.match(/\\trowd/)) throw new Error("RTF missing table");
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }
	
		/* TODO: this is a stub */
		function sheet_to_rtf(ws) {
			var o = ["{\\rtf1\\ansi"];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				o.push("\\trowd\\trautofit1");
				for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
				o.push("\\pard\\intbl");
				for(C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
					o.push(" " + (cell.w || (format_cell(cell), cell.w)));
					o.push("\\cell");
				}
				o.push("\\pard\\intbl\\row");
			}
			return o.join("") + "}";
		}
	
		return {
			to_workbook: rtf_to_workbook,
			to_sheet: rtf_to_sheet,
			from_sheet: sheet_to_rtf
		};
	})();
	function hex2RGB(h) {
		var o = h.slice(h[0]==="#"?1:0).slice(0,6);
		return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
	}
	function rgb2Hex(rgb) {
		for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
		return o.toString(16).toUpperCase().slice(1);
	}
	
	function rgb2HSL(rgb) {
		var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
		var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
		if(C === 0) return [0, 0, R];
	
		var H6 = 0, S = 0, L2 = (M + m);
		S = C / (L2 > 1 ? 2 - L2 : L2);
		switch(M){
			case R: H6 = ((G - B) / C + 6)%6; break;
			case G: H6 = ((B - R) / C + 2); break;
			case B: H6 = ((R - G) / C + 4); break;
		}
		return [H6 / 6, S, L2 / 2];
	}
	
	function hsl2RGB(hsl){
		var H = hsl[0], S = hsl[1], L = hsl[2];
		var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
		var rgb = [m,m,m], h6 = 6*H;
	
		var X;
		if(S !== 0) switch(h6|0) {
			case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
			case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
			case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
			case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
			case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
			case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
		}
		for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
		return rgb;
	}
	
	/* 18.8.3 bgColor tint algorithm */
	function rgb_tint(hex, tint) {
		if(tint === 0) return hex;
		var hsl = rgb2HSL(hex2RGB(hex));
		if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
		else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
		return rgb2Hex(hsl2RGB(hsl));
	}
	
	/* 18.3.1.13 width calculations */
	/* [MS-OI29500] 2.1.595 Column Width & Formatting */
	var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
	function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
	function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
	function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
	//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
	//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
	function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
	/* XLSX/XLSB/XLS specify width in units of MDW */
	function find_mdw_colw(collw) {
		var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
		if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
		MDW = _MDW;
	}
	/* XLML specifies width in terms of pixels */
	/*function find_mdw_wpx(wpx) {
		var delta = Infinity, guess = 0, _MDW = MIN_MDW;
		for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
			guess = char2width_(px2char_(wpx))*256;
			guess = (guess) % 1;
			if(guess > 0.5) guess--;
			if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
		}
		MDW = _MDW;
	}*/
	
	function process_col(coll) {
		if(coll.width) {
			coll.wpx = width2px(coll.width);
			coll.wch = px2char(coll.wpx);
			coll.MDW = MDW;
		} else if(coll.wpx) {
			coll.wch = px2char(coll.wpx);
			coll.width = char2width(coll.wch);
			coll.MDW = MDW;
		} else if(typeof coll.wch == 'number') {
			coll.width = char2width(coll.wch);
			coll.wpx = width2px(coll.width);
			coll.MDW = MDW;
		}
		if(coll.customWidth) delete coll.customWidth;
	}
	
	var DEF_PPI = 96, PPI = DEF_PPI;
	function px2pt(px) { return px * 96 / PPI; }
	function pt2px(pt) { return pt * PPI / 96; }
	
	/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
	var XLMLPatternTypeMap = {
		"None": "none",
		"Solid": "solid",
		"Gray50": "mediumGray",
		"Gray75": "darkGray",
		"Gray25": "lightGray",
		"HorzStripe": "darkHorizontal",
		"VertStripe": "darkVertical",
		"ReverseDiagStripe": "darkDown",
		"DiagStripe": "darkUp",
		"DiagCross": "darkGrid",
		"ThickDiagCross": "darkTrellis",
		"ThinHorzStripe": "lightHorizontal",
		"ThinVertStripe": "lightVertical",
		"ThinReverseDiagStripe": "lightDown",
		"ThinHorzCross": "lightGrid"
	};
	
	/* 18.8.5 borders CT_Borders */
	function parse_borders(t, styles, themes, opts) {
		styles.Borders = [];
		var border = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<borders': case '<borders>': case '</borders>': break;
	
				/* 18.8.4 border CT_Border */
				case '<border': case '<border>': case '<border/>':
					border = {};
					if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
					if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
					styles.Borders.push(border);
					break;
				case '</border>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<left/>': break;
				case '<left': case '<left>': break;
				case '</left>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<right/>': break;
				case '<right': case '<right>': break;
				case '</right>': break;
	
				/* 18.8.43 top CT_BorderPr */
				case '<top/>': break;
				case '<top': case '<top>': break;
				case '</top>': break;
	
				/* 18.8.6 bottom CT_BorderPr */
				case '<bottom/>': break;
				case '<bottom': case '<bottom>': break;
				case '</bottom>': break;
	
				/* 18.8.13 diagonal CT_BorderPr */
				case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
				case '</diagonal>': break;
	
				/* 18.8.25 horizontal CT_BorderPr */
				case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
				case '</horizontal>': break;
	
				/* 18.8.44 vertical CT_BorderPr */
				case '<vertical': case '<vertical>': case '<vertical/>': break;
				case '</vertical>': break;
	
				/* 18.8.37 start CT_BorderPr */
				case '<start': case '<start>': case '<start/>': break;
				case '</start>': break;
	
				/* 18.8.16 end CT_BorderPr */
				case '<end': case '<end>': case '<end/>': break;
				case '</end>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color>':
					break;
				case '<color/>': case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
				}
			}
		});
	}
	
	/* 18.8.21 fills CT_Fills */
	function parse_fills(t, styles, themes, opts) {
		styles.Fills = [];
		var fill = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fills': case '<fills>': case '</fills>': break;
	
				/* 18.8.20 fill CT_Fill */
				case '<fill>': case '<fill': case '<fill/>':
					fill = {}; styles.Fills.push(fill); break;
				case '</fill>': break;
	
				/* 18.8.24 gradientFill CT_GradientFill */
				case '<gradientFill>': break;
				case '<gradientFill':
				case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;
	
				/* 18.8.32 patternFill CT_PatternFill */
				case '<patternFill': case '<patternFill>':
					if(y.patternType) fill.patternType = y.patternType;
					break;
				case '<patternFill/>': case '</patternFill>': break;
	
				/* 18.8.3 bgColor CT_Color */
				case '<bgColor':
					if(!fill.bgColor) fill.bgColor = {};
					if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
					if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
					break;
				case '<bgColor/>': case '</bgColor>': break;
	
				/* 18.8.19 fgColor CT_Color */
				case '<fgColor':
					if(!fill.fgColor) fill.fgColor = {};
					if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
					break;
				case '<fgColor/>': case '</fgColor>': break;
	
				/* 18.8.38 stop CT_GradientStop */
				case '<stop': case '<stop/>': break;
				case '</stop>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color/>': break;
				case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
				}
			}
		});
	}
	
	/* 18.8.23 fonts CT_Fonts */
	function parse_fonts(t, styles, themes, opts) {
		styles.Fonts = [];
		var font = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fonts': case '<fonts>': case '</fonts>': break;
	
				/* 18.8.22 font CT_Font */
				case '<font': case '<font>': break;
				case '</font>': case '<font/>':
					styles.Fonts.push(font);
					font = {};
					break;
	
				/* 18.8.29 name CT_FontName */
				case '<name': if(y.val) font.name = y.val; break;
				case '<name/>': case '</name>': break;
	
				/* 18.8.2  b CT_BooleanProperty */
				case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
				case '<b/>': font.bold = 1; break;
	
				/* 18.8.26 i CT_BooleanProperty */
				case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
				case '<i/>': font.italic = 1; break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					switch(y.val) {
						case "none": font.underline = 0x00; break;
						case "single": font.underline = 0x01; break;
						case "double": font.underline = 0x02; break;
						case "singleAccounting": font.underline = 0x21; break;
						case "doubleAccounting": font.underline = 0x22; break;
					} break;
				case '<u/>': font.underline = 1; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
				case '<strike/>': font.strike = 1; break;
	
				/* 18.4.2  outline CT_BooleanProperty */
				case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
				case '<outline/>': font.outline = 1; break;
	
				/* 18.8.36 shadow CT_BooleanProperty */
				case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
				case '<shadow/>': font.shadow = 1; break;
	
				/* 18.8.12 condense CT_BooleanProperty */
				case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
				case '<condense/>': font.condense = 1; break;
	
				/* 18.8.17 extend CT_BooleanProperty */
				case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
				case '<extend/>': font.extend = 1; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': if(y.val) font.sz = +y.val; break;
				case '<sz/>': case '</sz>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
				case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
				case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.18 family CT_FontFamily */
				case '<family': if(y.val) font.family = parseInt(y.val,10); break;
				case '<family/>': case '</family>': break;
	
				/* 18.8.35 scheme CT_FontScheme */
				case '<scheme': if(y.val) font.scheme = y.val; break;
				case '<scheme/>': case '</scheme>': break;
	
				/* 18.4.1 charset CT_IntProperty */
				case '<charset':
					if(y.val == '1') break;
					y.codepage = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.?.? color CT_Color */
				case '<color':
					if(!font.color) font.color = {};
					if(y.auto) font.color.auto = parsexmlbool(y.auto);
	
					if(y.rgb) font.color.rgb = y.rgb.slice(-6);
					else if(y.indexed) {
						font.color.index = parseInt(y.indexed, 10);
						var icv = XLSIcv[font.color.index];
						if(font.color.index == 81) icv = XLSIcv[1];
						if(!icv) throw new Error(x);
						font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
					} else if(y.theme) {
						font.color.theme = parseInt(y.theme, 10);
						if(y.tint) font.color.tint = parseFloat(y.tint);
						if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
							font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
						}
					}
	
					break;
				case '<color/>': case '</color>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
				}
			}
		});
	}
	
	/* 18.8.31 numFmts CT_NumFmts */
	function parse_numFmts(t, styles, opts) {
		styles.NumberFmt = [];
		var k/*Array<number>*/ = (keys(SSF._table));
		for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]];
		var m = t[0].match(tagregex);
		if(!m) return;
		for(i=0; i < m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(strip_ns(y[0])) {
				case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
				case '<numFmt': {
					var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
					styles.NumberFmt[j] = f;
					if(j>0) {
						if(j > 0x188) {
							for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
							styles.NumberFmt[j] = f;
						}
						SSF.load(f,j);
					}
				} break;
				case '</numFmt>': break;
				default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
			}
		}
	}
	
	function write_numFmts(NF) {
		var o = ["<numFmts>"];
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
			for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
		});
		if(o.length === 1) return "";
		o[o.length] = ("</numFmts>");
		o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
		return o.join("");
	}
	
	/* 18.8.10 cellXfs CT_CellXfs */
	var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
	var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
	function parse_cellXfs(t, styles, opts) {
		styles.CellXf = [];
		var xf;
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x), i = 0;
			switch(strip_ns(y[0])) {
				case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;
	
				/* 18.8.45 xf CT_Xf */
				case '<xf': case '<xf/>':
					xf = y;
					delete xf[0];
					for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
						xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
					for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
						xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
					if(xf.numFmtId > 0x188) {
						for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
					}
					styles.CellXf.push(xf); break;
				case '</xf>': break;
	
				/* 18.8.1 alignment CT_CellAlignment */
				case '<alignment': case '<alignment/>':
					var alignment = {};
					if(y.vertical) alignment.vertical = y.vertical;
					if(y.horizontal) alignment.horizontal = y.horizontal;
					if(y.textRotation != null) alignment.textRotation = y.textRotation;
					if(y.indent) alignment.indent = y.indent;
					if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
					xf.alignment = alignment;
					break;
				case '</alignment>': break;
	
				/* 18.8.33 protection CT_CellProtection */
				case '<protection':
					break;
				case '</protection>': case '<protection/>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
				}
			}
		});
	}
	
	function write_cellXfs(cellXfs) {
		var o = [];
		o[o.length] = (writextag('cellXfs',null));
		cellXfs.forEach(function(c) {
			o[o.length] = (writextag('xf', null, c));
		});
		o[o.length] = ("</cellXfs>");
		if(o.length === 2) return "";
		o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
		return o.join("");
	}
	
	/* 18.8 Styles CT_Stylesheet*/
	var parse_sty_xml= (function make_pstyx() {
	var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
	var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
	var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
	var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
	var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
	
	return function parse_sty_xml(data, themes, opts) {
		var styles = {};
		if(!data) return styles;
		data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		/* 18.8.39 styleSheet CT_Stylesheet */
		var t;
	
		/* 18.8.31 numFmts CT_NumFmts ? */
		if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);
	
		/* 18.8.23 fonts CT_Fonts ? */
		if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);
	
		/* 18.8.21 fills CT_Fills ? */
		if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);
	
		/* 18.8.5  borders CT_Borders ? */
		if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);
	
		/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
	
		/* 18.8.10 cellXfs CT_CellXfs ? */
		if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);
	
		/* 18.8.8  cellStyles CT_CellStyles ? */
		/* 18.8.15 dxfs CT_Dxfs ? */
		/* 18.8.42 tableStyles CT_TableStyles ? */
		/* 18.8.11 colors CT_Colors ? */
		/* 18.2.10 extLst CT_ExtensionList ? */
	
		return styles;
	};
	})();
	
	var STYLES_XML_ROOT = writextag('styleSheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:vt': XMLNS.vt
	});
	
	RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
	
	function write_sty_xml(wb, opts) {
		var o = [XML_HEADER, STYLES_XML_ROOT], w;
		if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
		o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
		o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
		o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
		o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
		if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
		o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
		o[o.length] = ('<dxfs count="0"/>');
		o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');
	
		if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.657 BrtFmt */
	function parse_BrtFmt(data, length) {
		var numFmtId = data.read_shift(2);
		var stFmtCode = parse_XLWideString(data,length-2);
		return [numFmtId, stFmtCode];
	}
	function write_BrtFmt(i, f, o) {
		if(!o) o = new_buf(6 + 4 * f.length);
		o.write_shift(2, i);
		write_XLWideString(f, o);
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(o.l == null) o.l = o.length;
		return out;
	}
	
	/* [MS-XLSB] 2.4.659 BrtFont TODO */
	function parse_BrtFont(data, length, opts) {
		var out = ({});
	
		out.sz = data.read_shift(2) / 20;
	
		var grbit = parse_FontFlags(data, 2, opts);
		if(grbit.fItalic) out.italic = 1;
		if(grbit.fCondense) out.condense = 1;
		if(grbit.fExtend) out.extend = 1;
		if(grbit.fShadow) out.shadow = 1;
		if(grbit.fOutline) out.outline = 1;
		if(grbit.fStrikeout) out.strike = 1;
	
		var bls = data.read_shift(2);
		if(bls === 0x02BC) out.bold = 1;
	
		switch(data.read_shift(2)) {
			/* case 0: out.vertAlign = "baseline"; break; */
			case 1: out.vertAlign = "superscript"; break;
			case 2: out.vertAlign = "subscript"; break;
		}
	
		var underline = data.read_shift(1);
		if(underline != 0) out.underline = underline;
	
		var family = data.read_shift(1);
		if(family > 0) out.family = family;
	
		var bCharSet = data.read_shift(1);
		if(bCharSet > 0) out.charset = bCharSet;
	
		data.l++;
		out.color = parse_BrtColor(data, 8);
	
		switch(data.read_shift(1)) {
			/* case 0: out.scheme = "none": break; */
			case 1: out.scheme = "major"; break;
			case 2: out.scheme = "minor"; break;
		}
	
		out.name = parse_XLWideString(data, length - 21);
	
		return out;
	}
	function write_BrtFont(font, o) {
		if(!o) o = new_buf(25+4*32);
		o.write_shift(2, font.sz * 20);
		write_FontFlags(font, o);
		o.write_shift(2, font.bold ? 0x02BC : 0x0190);
		var sss = 0;
		if(font.vertAlign == "superscript") sss = 1;
		else if(font.vertAlign == "subscript") sss = 2;
		o.write_shift(2, sss);
		o.write_shift(1, font.underline || 0);
		o.write_shift(1, font.family || 0);
		o.write_shift(1, font.charset || 0);
		o.write_shift(1, 0);
		write_BrtColor(font.color, o);
		var scheme = 0;
		if(font.scheme == "major") scheme = 1;
		if(font.scheme == "minor") scheme = 2;
		o.write_shift(1, scheme);
		write_XLWideString(font.name, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.650 BrtFill */
	var XLSBFillPTNames = [
		"none",
		"solid",
		"mediumGray",
		"darkGray",
		"lightGray",
		"darkHorizontal",
		"darkVertical",
		"darkDown",
		"darkUp",
		"darkGrid",
		"darkTrellis",
		"lightHorizontal",
		"lightVertical",
		"lightDown",
		"lightUp",
		"lightGrid",
		"lightTrellis",
		"gray125",
		"gray0625"
	];
	var rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
	/* TODO: gradient fill representation */
	var parse_BrtFill = parsenoop;
	function write_BrtFill(fill, o) {
		if(!o) o = new_buf(4*3 + 8*7 + 16*1);
		var fls = rev_XLSBFillPTNames[fill.patternType];
		if(fls == null) fls = 0x28;
		o.write_shift(4, fls);
		var j = 0;
		if(fls != 0x28) {
			/* TODO: custom FG Color */
			write_BrtColor({auto:1}, o);
			/* TODO: custom BG Color */
			write_BrtColor({auto:1}, o);
	
			for(; j < 12; ++j) o.write_shift(4, 0);
		} else {
			for(; j < 4; ++j) o.write_shift(4, 0);
	
			for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
			/* iGradientType */
			/* xnumDegree */
			/* xnumFillToLeft */
			/* xnumFillToRight */
			/* xnumFillToTop */
			/* xnumFillToBottom */
			/* cNumStop */
			/* xfillGradientStop */
		}
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.824 BrtXF */
	function parse_BrtXF(data, length) {
		var tgt = data.l + length;
		var ixfeParent = data.read_shift(2);
		var ifmt = data.read_shift(2);
		data.l = tgt;
		return {ixfe:ixfeParent, numFmtId:ifmt };
	}
	function write_BrtXF(data, ixfeP, o) {
		if(!o) o = new_buf(16);
		o.write_shift(2, ixfeP||0);
		o.write_shift(2, data.numFmtId||0);
		o.write_shift(2, 0); /* iFont */
		o.write_shift(2, 0); /* iFill */
		o.write_shift(2, 0); /* ixBorder */
		o.write_shift(1, 0); /* trot */
		o.write_shift(1, 0); /* indent */
		var flow = 0;
		o.write_shift(1, flow); /* flags */
		o.write_shift(1, 0); /* flags */
		o.write_shift(1, 0); /* xfGrbitAtr */
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.4 Blxf TODO */
	function write_Blxf(data, o) {
		if(!o) o = new_buf(10);
		o.write_shift(1, 0); /* dg */
		o.write_shift(1, 0);
		o.write_shift(4, 0); /* color */
		o.write_shift(4, 0); /* color */
		return o;
	}
	/* [MS-XLSB] 2.4.302 BrtBorder TODO */
	var parse_BrtBorder = parsenoop;
	function write_BrtBorder(border, o) {
		if(!o) o = new_buf(51);
		o.write_shift(1, 0); /* diagonal */
		write_Blxf(null, o); /* top */
		write_Blxf(null, o); /* bottom */
		write_Blxf(null, o); /* left */
		write_Blxf(null, o); /* right */
		write_Blxf(null, o); /* diag */
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.763 BrtStyle TODO */
	function write_BrtStyle(style, o) {
		if(!o) o = new_buf(12+4*10);
		o.write_shift(4, style.xfId);
		o.write_shift(2, 1);
		o.write_shift(1, +style.builtinId);
		o.write_shift(1, 0); /* iLevel */
		write_XLNullableWideString(style.name || "", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
	function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
		var o = new_buf(4+256*2*4);
		o.write_shift(4, cnt);
		write_XLNullableWideString(defTableStyle, o);
		write_XLNullableWideString(defPivotStyle, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function parse_sty_bin(data, themes, opts) {
		var styles = {};
		styles.NumberFmt = ([]);
		for(var y in SSF._table) styles.NumberFmt[y] = SSF._table[y];
	
		styles.CellXf = [];
		styles.Fonts = [];
		var state = [];
		var pass = false;
		recordhopper(data, function hopper_sty(val, R_n, RT) {
			switch(RT) {
				case 0x002C: /* 'BrtFmt' */
					styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]);
					break;
				case 0x002B: /* 'BrtFont' */
					styles.Fonts.push(val);
					if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
						val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
					}
					break;
				case 0x0401: /* 'BrtKnownFonts' */ break;
				case 0x002D: /* 'BrtFill' */
					break;
				case 0x002E: /* 'BrtBorder' */
					break;
				case 0x002F: /* 'BrtXF' */
					if(state[state.length - 1] == "BrtBeginCellXFs") {
						styles.CellXf.push(val);
					}
					break;
				case 0x0030: /* 'BrtStyle' */
				case 0x01FB: /* 'BrtDXF' */
				case 0x023C: /* 'BrtMRUColor' */
				case 0x01DB: /* 'BrtIndexedColor': */
					break;
	
				case 0x0493: /* 'BrtDXF14' */
				case 0x0836: /* 'BrtDXF15' */
				case 0x046A: /* 'BrtSlicerStyleElement' */
				case 0x0200: /* 'BrtTableStyleElement' */
				case 0x082F: /* 'BrtTimelineStyleElement' */
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
					else if((R_n||"").indexOf("End") > 0) state.pop();
					else if(!pass || (opts.WTF && state[state.length-1] != "BrtACBegin")) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return styles;
	}
	
	function write_FMTS_bin(ba, NF) {
		if(!NF) return;
		var cnt = 0;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
		});
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFmts", write_UInt32LE(cnt));
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, "BrtFmt", write_BrtFmt(i, NF[i]));
		});
		write_record(ba, "BrtEndFmts");
	}
	
	function write_FONTS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFonts", write_UInt32LE(cnt));
		write_record(ba, "BrtFont", write_BrtFont({
			sz:12,
			color: {theme:1},
			name: "Calibri",
			family: 2,
			scheme: "minor"
		}));
		/* 1*65491BrtFont [ACFONTS] */
		write_record(ba, "BrtEndFonts");
	}
	
	function write_FILLS_bin(ba) {
		var cnt = 2;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFills", write_UInt32LE(cnt));
		write_record(ba, "BrtFill", write_BrtFill({patternType:"none"}));
		write_record(ba, "BrtFill", write_BrtFill({patternType:"gray125"}));
		/* 1*65431BrtFill */
		write_record(ba, "BrtEndFills");
	}
	
	function write_BORDERS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginBorders", write_UInt32LE(cnt));
		write_record(ba, "BrtBorder", write_BrtBorder({}));
		/* 1*65430BrtBorder */
		write_record(ba, "BrtEndBorders");
	}
	
	function write_CELLSTYLEXFS_bin(ba) {
		var cnt = 1;
		write_record(ba, "BrtBeginCellStyleXFs", write_UInt32LE(cnt));
		write_record(ba, "BrtXF", write_BrtXF({
			numFmtId: 0,
			fontId:   0,
			fillId:   0,
			borderId: 0
		}, 0xFFFF));
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, "BrtEndCellStyleXFs");
	}
	
	function write_CELLXFS_bin(ba, data) {
		write_record(ba, "BrtBeginCellXFs", write_UInt32LE(data.length));
		data.forEach(function(c) { write_record(ba, "BrtXF", write_BrtXF(c,0)); });
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, "BrtEndCellXFs");
	}
	
	function write_STYLES_bin(ba) {
		var cnt = 1;
	
		write_record(ba, "BrtBeginStyles", write_UInt32LE(cnt));
		write_record(ba, "BrtStyle", write_BrtStyle({
			xfId:0,
			builtinId:0,
			name:"Normal"
		}));
		/* 1*65430(BrtStyle *FRT) */
		write_record(ba, "BrtEndStyles");
	}
	
	function write_DXFS_bin(ba) {
		var cnt = 0;
	
		write_record(ba, "BrtBeginDXFs", write_UInt32LE(cnt));
		/* *2147483647(BrtDXF *FRT) */
		write_record(ba, "BrtEndDXFs");
	}
	
	function write_TABLESTYLES_bin(ba) {
		var cnt = 0;
	
		write_record(ba, "BrtBeginTableStyles", write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
		/* *TABLESTYLE */
		write_record(ba, "BrtEndTableStyles");
	}
	
	function write_COLORPALETTE_bin() {
		return;
		/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function write_sty_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginStyleSheet");
		write_FMTS_bin(ba, wb.SSF);
		write_FONTS_bin(ba, wb);
		write_FILLS_bin(ba, wb);
		write_BORDERS_bin(ba, wb);
		write_CELLSTYLEXFS_bin(ba, wb);
		write_CELLXFS_bin(ba, opts.cellXfs);
		write_STYLES_bin(ba, wb);
		write_DXFS_bin(ba, wb);
		write_TABLESTYLES_bin(ba, wb);
		write_COLORPALETTE_bin(ba, wb);
		/* FRTSTYLESHEET*/
		write_record(ba, "BrtEndStyleSheet");
		return ba.end();
	}
	RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
	
	/* 20.1.6.2 clrScheme CT_ColorScheme */
	function parse_clrScheme(t, themes, opts) {
		themes.themeElements.clrScheme = [];
		var color = {};
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
				case '<a:clrScheme': case '</a:clrScheme>': break;
	
				/* 20.1.2.3.32 srgbClr CT_SRgbColor */
				case '<a:srgbClr':
					color.rgb = y.val; break;
	
				/* 20.1.2.3.33 sysClr CT_SystemColor */
				case '<a:sysClr':
					color.rgb = y.lastClr; break;
	
				/* 20.1.4.1.1 accent1 (Accent 1) */
				/* 20.1.4.1.2 accent2 (Accent 2) */
				/* 20.1.4.1.3 accent3 (Accent 3) */
				/* 20.1.4.1.4 accent4 (Accent 4) */
				/* 20.1.4.1.5 accent5 (Accent 5) */
				/* 20.1.4.1.6 accent6 (Accent 6) */
				/* 20.1.4.1.9 dk1 (Dark 1) */
				/* 20.1.4.1.10 dk2 (Dark 2) */
				/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
				/* 20.1.4.1.19 hlink (Hyperlink) */
				/* 20.1.4.1.22 lt1 (Light 1) */
				/* 20.1.4.1.23 lt2 (Light 2) */
				case '<a:dk1>': case '</a:dk1>':
				case '<a:lt1>': case '</a:lt1>':
				case '<a:dk2>': case '</a:dk2>':
				case '<a:lt2>': case '</a:lt2>':
				case '<a:accent1>': case '</a:accent1>':
				case '<a:accent2>': case '</a:accent2>':
				case '<a:accent3>': case '</a:accent3>':
				case '<a:accent4>': case '</a:accent4>':
				case '<a:accent5>': case '</a:accent5>':
				case '<a:accent6>': case '</a:accent6>':
				case '<a:hlink>': case '</a:hlink>':
				case '<a:folHlink>': case '</a:folHlink>':
					if (y[0].charAt(1) === '/') {
						themes.themeElements.clrScheme.push(color);
						color = {};
					} else {
						color.name = y[0].slice(3, y[0].length - 1);
					}
					break;
	
				default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
			}
		});
	}
	
	/* 20.1.4.1.18 fontScheme CT_FontScheme */
	function parse_fontScheme() { }
	
	/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
	function parse_fmtScheme() { }
	
	var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
	var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
	var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
	
	/* 20.1.6.10 themeElements CT_BaseStyles */
	function parse_themeElements(data, themes, opts) {
		themes.themeElements = {};
	
		var t;
	
		[
			/* clrScheme CT_ColorScheme */
			['clrScheme', clrsregex, parse_clrScheme],
			/* fontScheme CT_FontScheme */
			['fontScheme', fntsregex, parse_fontScheme],
			/* fmtScheme CT_StyleMatrix */
			['fmtScheme', fmtsregex, parse_fmtScheme]
		].forEach(function(m) {
			if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
			m[2](t, themes, opts);
		});
	}
	
	var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
	
	/* 14.2.7 Theme Part */
	function parse_theme_xml(data, opts) {
		/* 20.1.6.9 theme CT_OfficeStyleSheet */
		if(!data || data.length === 0) return parse_theme_xml(write_theme());
	
		var t;
		var themes = {};
	
		/* themeElements CT_BaseStyles */
		if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
		parse_themeElements(t[0], themes, opts);
		themes.raw = data;
		return themes;
	}
	
	function write_theme(Themes, opts) {
		if(opts && opts.themeXLSX) return opts.themeXLSX;
		if(Themes && typeof Themes.raw == "string") return Themes.raw;
		var o = [XML_HEADER];
		o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
		o[o.length] =  '<a:themeElements>';
	
		o[o.length] =   '<a:clrScheme name="Office">';
		o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
		o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
		o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
		o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
		o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
		o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
		o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
		o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
		o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
		o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
		o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
		o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
		o[o.length] =   '</a:clrScheme>';
	
		o[o.length] =   '<a:fontScheme name="Office">';
		o[o.length] =    '<a:majorFont>';
		o[o.length] =     '<a:latin typeface="Cambria"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:majorFont>';
		o[o.length] =    '<a:minorFont>';
		o[o.length] =     '<a:latin typeface="Calibri"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:minorFont>';
		o[o.length] =   '</a:fontScheme>';
	
		o[o.length] =   '<a:fmtScheme name="Office">';
		o[o.length] =    '<a:fillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:fillStyleLst>';
		o[o.length] =    '<a:lnStyleLst>';
		o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =    '</a:lnStyleLst>';
		o[o.length] =    '<a:effectStyleLst>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
		o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =    '</a:effectStyleLst>';
		o[o.length] =    '<a:bgFillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:bgFillStyleLst>';
		o[o.length] =   '</a:fmtScheme>';
		o[o.length] =  '</a:themeElements>';
	
		o[o.length] =  '<a:objectDefaults>';
		o[o.length] =   '<a:spDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:spDef>';
		o[o.length] =   '<a:lnDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:lnDef>';
		o[o.length] =  '</a:objectDefaults>';
		o[o.length] =  '<a:extraClrSchemeLst/>';
		o[o.length] = '</a:theme>';
		return o.join("");
	}
	/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
	function parse_Theme(blob, length, opts) {
		var end = blob.l + length;
		var dwThemeVersion = blob.read_shift(4);
		if(dwThemeVersion === 124226) return;
		if(!opts.cellStyles || !jszip) { blob.l = end; return; }
		var data = blob.slice(blob.l);
		blob.l = end;
		var zip; try { zip = new jszip(data); } catch(e) { return; }
		var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
		if(!themeXML) return;
		return parse_theme_xml(themeXML, opts);
	}
	
	/* 2.5.49 */
	function parse_ColorTheme(blob) { return blob.read_shift(4); }
	
	/* 2.5.155 */
	function parse_FullColorExt(blob) {
		var o = {};
		o.xclrType = blob.read_shift(2);
		o.nTintShade = blob.read_shift(2);
		switch(o.xclrType) {
			case 0: blob.l += 4; break;
			case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
			case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
			case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
			case 4: blob.l += 4; break;
		}
		blob.l += 8;
		return o;
	}
	
	/* 2.5.164 TODO: read 7 bits*/
	function parse_IcvXF(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.280 */
	function parse_XFExtGradient(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* [MS-XLS] 2.5.108 */
	function parse_ExtProp(blob) {
		var extType = blob.read_shift(2);
		var cb = blob.read_shift(2) - 4;
		var o = [extType];
		switch(extType) {
			case 0x04: case 0x05: case 0x07: case 0x08:
			case 0x09: case 0x0A: case 0x0B: case 0x0D:
				o[1] = parse_FullColorExt(blob, cb); break;
			case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
			case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
			default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
		}
		return o;
	}
	
	/* 2.4.355 */
	function parse_XFExt(blob, length) {
		var end = blob.l + length;
		blob.l += 2;
		var ixfe = blob.read_shift(2);
		blob.l += 2;
		var cexts = blob.read_shift(2);
		var ext = [];
		while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
		return {ixfe:ixfe, ext:ext};
	}
	
	/* xf is an XF, see parse_XFExt for xfext */
	function update_xfext(xf, xfext) {
		xfext.forEach(function(xfe) {
			switch(xfe[0]) { /* 2.5.108 extPropData */
				case 0x04: break; /* foreground color */
				case 0x05: break; /* background color */
				case 0x06: break; /* gradient fill */
				case 0x07: break; /* top cell border color */
				case 0x08: break; /* bottom cell border color */
				case 0x09: break; /* left cell border color */
				case 0x0a: break; /* right cell border color */
				case 0x0b: break; /* diagonal cell border color */
				case 0x0d: /* text color */
					break;
				case 0x0e: break; /* font scheme */
				case 0x0f: break; /* indentation level */
			}
		});
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_xml(data) {
		var d = [];
		if(!data) return d;
		var i = 1;
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				/* 18.6.2  calcChain CT_CalcChain 1 */
				case '<calcChain': case '<calcChain>': case '</calcChain>': break;
				/* 18.6.1  c CT_CalcCell 1 */
				case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
			}
		});
		return d;
	}
	
	//function write_cc_xml(data, opts) { }
	
	/* [MS-XLSB] 2.6.4.1 */
	function parse_BrtCalcChainItem$(data) {
		var out = {};
		out.i = data.read_shift(4);
		var cell = {};
		cell.r = data.read_shift(4);
		cell.c = data.read_shift(4);
		out.r = encode_cell(cell);
		var flags = data.read_shift(1);
		if(flags & 0x2) out.l = '1';
		if(flags & 0x8) out.a = '1';
		return out;
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_bin(data, name, opts) {
		var out = [];
		var pass = false;
		recordhopper(data, function hopper_cc(val, R_n, RT) {
			switch(RT) {
				case 0x003F: /* 'BrtCalcChainItem$' */
					out.push(val); break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return out;
	}
	
	//function write_cc_bin(data, opts) { }
	/* 18.14 Supplementary Workbook Data */
	function parse_xlink_xml() {
		//var opts = _opts || {};
		//if(opts.WTF) throw "XLSX External Link";
	}
	
	/* [MS-XLSB] 2.1.7.25 External Link */
	function parse_xlink_bin(data, rel, name, _opts) {
		if(!data) return data;
		var opts = _opts || {};
	
		var pass = false, end = false;
	
		recordhopper(data, function xlink_parse(val, R_n, RT) {
			if(end) return;
			switch(RT) {
				case 0x0167: /* 'BrtSupTabs' */
				case 0x016B: /* 'BrtExternTableStart' */
				case 0x016C: /* 'BrtExternTableEnd' */
				case 0x016E: /* 'BrtExternRowHdr' */
				case 0x016F: /* 'BrtExternCellBlank' */
				case 0x0170: /* 'BrtExternCellReal' */
				case 0x0171: /* 'BrtExternCellBool' */
				case 0x0172: /* 'BrtExternCellError' */
				case 0x0173: /* 'BrtExternCellString' */
				case 0x01D8: /* 'BrtExternValueMeta' */
				case 0x0241: /* 'BrtSupNameStart' */
				case 0x0242: /* 'BrtSupNameValueStart' */
				case 0x0243: /* 'BrtSupNameValueEnd' */
				case 0x0244: /* 'BrtSupNameNum' */
				case 0x0245: /* 'BrtSupNameErr' */
				case 0x0246: /* 'BrtSupNameSt' */
				case 0x0247: /* 'BrtSupNameNil' */
				case 0x0248: /* 'BrtSupNameBool' */
				case 0x0249: /* 'BrtSupNameFmla' */
				case 0x024A: /* 'BrtSupNameBits' */
				case 0x024B: /* 'BrtSupNameEnd' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT.toString(16) + " " + R_n);
			}
		}, opts);
	}
	/* 20.5 DrawingML - SpreadsheetML Drawing */
	RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
	RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
	
	/* 20.5.2.35 wsDr CT_Drawing */
	function parse_drawing(data, rels) {
		if(!data) return "??";
		/*
		  Chartsheet Drawing:
		   - 20.5.2.35 wsDr CT_Drawing
		    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
		     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
		      - 20.1.2.2.16 graphic CT_GraphicalObject
		       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
	          - chart reference
		   the actual type is based on the URI of the graphicData
			TODO: handle embedded charts and other types of graphics
		*/
		var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];
	
		return rels['!id'][id].Target;
	}
	
	/* L.5.5.2 SpreadsheetML Comments + VML Schema */
	var _shapeid = 1024;
	function write_comments_vml(rId, comments) {
		var csize = [21600, 21600];
		/* L.5.2.1.2 Path Attribute */
		var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
		var o = [
			writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
			writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
			writextag("v:shapetype", [
				writextag("v:stroke", null, {joinstyle:"miter"}),
				writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
			].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
		];
		while(_shapeid < rId * 1000) _shapeid += 1000;
	
		comments.forEach(function(x) {
		var c = decode_cell(x[0]);
		var fillopts = {'color2':"#BEFF82", 'type':"gradient"};
		if(fillopts.type == "gradient") fillopts.angle = "-180";
		var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
		var fillxml = writextag('v:fill', fillparm, fillopts);
	
		var shadata = ({on:"t", 'obscured':"t"});
		++_shapeid;
	
		o = o.concat([
		'<v:shape' + wxt_helper({
			id:'_x0000_s' + _shapeid,
			type:"#_x0000_t202",
			style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
			fillcolor:"#ECFAD4",
			strokecolor:"#edeaa1"
		}) + '>',
			fillxml,
			writextag("v:shadow", null, shadata),
			writextag("v:path", null, {'o:connecttype':"none"}),
			'<v:textbox><div style="text-align:left"></div></v:textbox>',
			'<x:ClientData ObjectType="Note">',
				'<x:MoveWithCells/>',
				'<x:SizeWithCells/>',
				/* Part 4 19.4.2.3 Anchor (Anchor) */
				writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
				writetag('x:AutoFill', "False"),
				writetag('x:Row', String(c.r)),
				writetag('x:Column', String(c.c)),
				x[1].hidden ? '' : '<x:Visible/>',
			'</x:ClientData>',
		'</v:shape>'
		]); });
		o.push('</xml>');
		return o.join("");
	}
	RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
	
	function sheet_insert_comments(sheet, comments) {
		var dense = Array.isArray(sheet);
		var cell;
		comments.forEach(function(comment) {
			var r = decode_cell(comment.ref);
			if(dense) {
				if(!sheet[r.r]) sheet[r.r] = [];
				cell = sheet[r.r][r.c];
			} else cell = sheet[comment.ref];
			if (!cell) {
				cell = ({t:"z"});
				if(dense) sheet[r.r][r.c] = cell;
				else sheet[comment.ref] = cell;
				var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
				if(range.s.r > r.r) range.s.r = r.r;
				if(range.e.r < r.r) range.e.r = r.r;
				if(range.s.c > r.c) range.s.c = r.c;
				if(range.e.c < r.c) range.e.c = r.c;
				var encoded = encode_range(range);
				if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
			}
	
			if (!cell.c) cell.c = [];
			var o = ({a: comment.author, t: comment.t, r: comment.r});
			if(comment.h) o.h = comment.h;
			cell.c.push(o);
		});
	}
	
	/* 18.7 Comments */
	function parse_comments_xml(data, opts) {
		/* 18.7.6 CT_Comments */
		if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
		var authors = [];
		var commentList = [];
		var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
		if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
			if(a) authors.push(a[1]);
		});
		var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
		if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
			if(!cm) return;
			var y = parsexmltag(cm[0]);
			var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
			var cell = decode_cell(y.ref);
			if(opts.sheetRows && opts.sheetRows <= cell.r) return;
			var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
			var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
			comment.r = rt.r;
			if(rt.r == "<t></t>") rt.t = rt.h = "";
			comment.t = rt.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
			if(opts.cellHTML) comment.h = rt.h;
			commentList.push(comment);
		});
		return commentList;
	}
	
	var CMNT_XML_ROOT = writextag('comments', null, { 'xmlns': XMLNS.main[0] });
	function write_comments_xml(data) {
		var o = [XML_HEADER, CMNT_XML_ROOT];
	
		var iauthor = [];
		o.push("<authors>");
		data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
			if(iauthor.indexOf(a) > -1) return;
			iauthor.push(a);
			o.push("<author>" + a + "</author>");
		}); });
		o.push("</authors>");
		o.push("<commentList>");
		data.forEach(function(d) {
			d[1].forEach(function(c) {
				/* 18.7.3 CT_Comment */
				o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
				o.push(writetag("t", c.t == null ? "" : escapexml(c.t)));
				o.push('</text></comment>');
			});
		});
		o.push("</commentList>");
		if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.28 BrtBeginComment */
	function parse_BrtBeginComment(data) {
		var out = {};
		out.iauthor = data.read_shift(4);
		var rfx = parse_UncheckedRfX(data, 16);
		out.rfx = rfx.s;
		out.ref = encode_cell(rfx.s);
		data.l += 16; /*var guid = parse_GUID(data); */
		return out;
	}
	function write_BrtBeginComment(data, o) {
		if(o == null) o = new_buf(36);
		o.write_shift(4, data[1].iauthor);
		write_UncheckedRfX((data[0]), o);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
	var parse_BrtCommentAuthor = parse_XLWideString;
	function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }
	
	/* [MS-XLSB] 2.1.7.8 Comments */
	function parse_comments_bin(data, opts) {
		var out = [];
		var authors = [];
		var c = {};
		var pass = false;
		recordhopper(data, function hopper_cmnt(val, R_n, RT) {
			switch(RT) {
				case 0x0278: /* 'BrtCommentAuthor' */
					authors.push(val); break;
				case 0x027B: /* 'BrtBeginComment' */
					c = val; break;
				case 0x027D: /* 'BrtCommentText' */
					c.t = val.t; c.h = val.h; c.r = val.r; break;
				case 0x027C: /* 'BrtEndComment' */
					c.author = authors[c.iauthor];
					delete (c).iauthor;
					if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
					if(!c.t) c.t = "";
					delete c.rfx; out.push(c); break;
	
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return out;
	}
	
	function write_comments_bin(data) {
		var ba = buf_array();
		var iauthor = [];
		write_record(ba, "BrtBeginComments");
	
		write_record(ba, "BrtBeginCommentAuthors");
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				if(iauthor.indexOf(c.a) > -1) return;
				iauthor.push(c.a.slice(0,54));
				write_record(ba, "BrtCommentAuthor", write_BrtCommentAuthor(c.a));
			});
		});
		write_record(ba, "BrtEndCommentAuthors");
	
		write_record(ba, "BrtBeginCommentList");
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				c.iauthor = iauthor.indexOf(c.a);
				var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
				write_record(ba, "BrtBeginComment", write_BrtBeginComment([range, c]));
				if(c.t && c.t.length > 0) write_record(ba, "BrtCommentText", write_BrtCommentText(c));
				write_record(ba, "BrtEndComment");
				delete c.iauthor;
			});
		});
		write_record(ba, "BrtEndCommentList");
	
		write_record(ba, "BrtEndComments");
		return ba.end();
	}
	var CT_VBA = "application/vnd.ms-office.vbaProject";
	function make_vba_xls(cfb) {
		var newcfb = CFB.utils.cfb_new({root:"R"});
		cfb.FullPaths.forEach(function(p, i) {
			if(p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
			var newpath = p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
			CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
		});
		return CFB.write(newcfb);
	}
	
	function fill_vba_xls(cfb, vba) {
		vba.FullPaths.forEach(function(p, i) {
			if(i == 0) return;
			var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
			if(newpath.slice(-1) !== "/") CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
		});
	}
	
	var VBAFMTS = [ "xlsb", "xlsm", "xlam", "biff8", "xla" ];
	
	RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
	RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";
	
	/* macro and dialog sheet stubs */
	function parse_ds_bin() { return {'!type':'dialog'}; }
	function parse_ds_xml() { return {'!type':'dialog'}; }
	function parse_ms_bin() { return {'!type':'macro'}; }
	function parse_ms_xml() { return {'!type':'macro'}; }
	/* TODO: it will be useful to parse the function str */
	var rc_to_a1 = (function(){
		var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
		var rcbase = ({r:0,c:0});
		function rcfunc($$,$1,$2,$3) {
			var cRel = false, rRel = false;
	
			if($2.length == 0) rRel = true;
			else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }
	
			if($3.length == 0) cRel = true;
			else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }
	
			var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;
	
			if(cRel) C += rcbase.c; else --C;
			if(rRel) R += rcbase.r; else --R;
			return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
		}
		return function rc_to_a1(fstr, base) {
			rcbase = base;
			return fstr.replace(rcregex, rcfunc);
		};
	})();
	
	var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;
	var a1_to_rc =(function(){
		return function a1_to_rc(fstr, base) {
			return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
				var c = decode_col($3) - ($2 ? 0 : base.c);
				var r = decode_row($5) - ($4 ? 0 : base.r);
				var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
				var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
				return $1 + "R" + R + "C" + C;
			});
		};
	})();
	
	/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
	function shift_formula_str(f, delta) {
		return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
		});
	}
	
	function shift_formula_xlsx(f, range, cell) {
		var r = decode_range(range), s = r.s, c = decode_cell(cell);
		var delta = {r:c.r - s.r, c:c.c - s.c};
		return shift_formula_str(f, delta);
	}
	
	/* TODO: parse formula */
	function fuzzyfmla(f) {
		if(f.length == 1) return false;
		return true;
	}
	
	function _xlfn(f) {
		return f.replace(/_xlfn\./g,"");
	}
	function parseread1(blob) { blob.l+=1; return; }
	
	/* [MS-XLS] 2.5.51 */
	function parse_ColRelU(blob, length) {
		var c = blob.read_shift(length == 1 ? 1 : 2);
		return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
	function parse_RgceArea(blob, length, opts) {
		var w = 2;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
			else if(opts.biff == 12) w = 4;
		}
		var r=blob.read_shift(w), R=blob.read_shift(w);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	/* BIFF 2-5 encodes flags in the row field */
	function parse_RgceArea_BIFF2(blob) {
		var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
		var c=blob.read_shift(1);
		var C=blob.read_shift(1);
		return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
	function parse_RgceAreaRel(blob, length, opts) {
		if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
		var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
	function parse_RgceLoc(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
		var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
		var c = parse_ColRelU(blob, 2);
		return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
	}
	function parse_RgceLoc_BIFF2(blob) {
		var r = parse_ColRelU(blob, 2);
		var c = blob.read_shift(1);
		return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
	}
	
	/* [MS-XLS] 2.5.198.107, 2.5.47 */
	function parse_RgceElfLoc(blob) {
		var r = blob.read_shift(2);
		var c = blob.read_shift(2);
		return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
	}
	
	/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
	function parse_RgceLocRel(blob, length, opts) {
		var biff = opts && opts.biff ? opts.biff : 8;
		if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
		var r = blob.read_shift(biff >= 12 ? 4 : 2);
		var cl = blob.read_shift(2);
		var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
		cl &= 0x3FFF;
		if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
		if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
		return {r:r,c:cl,cRel:cRel,rRel:rRel};
	}
	function parse_RgceLocRel_BIFF2(blob) {
		var rl = blob.read_shift(2);
		var c = blob.read_shift(1);
		var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
		rl &= 0x3FFF;
		if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
		if(cRel == 1 && c >= 0x80) c = c - 0x100;
		return {r:rl,c:c,cRel:cRel,rRel:rRel};
	}
	
	/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
	function parse_PtgArea(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
	function parse_PtgArea3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2, 'i');
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		var area = parse_RgceArea(blob, w, opts);
		return [type, ixti, area];
	}
	
	/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
	function parse_PtgAreaErr(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
		return [type];
	}
	/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
	function parse_PtgAreaErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
	function parse_PtgAreaN(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceAreaRel(blob, length - 1, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
	function parse_PtgArray(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
	function parse_PtgAttrBaxcel(blob) {
		var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
		var bitBaxcel = 1;
		blob.l += 4;
		return [bitSemi, bitBaxcel];
	}
	
	/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
	function parse_PtgAttrChoose(blob, length, opts) {
		blob.l +=2;
		var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var o = [];
		/* offset is 1 less than the number of elements */
		for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
	function parse_PtgAttrGoto(blob, length, opts) {
		var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
	function parse_PtgAttrIf(blob, length, opts) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLSB] 2.5.97.28 */
	function parse_PtgAttrIfError(blob) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(2)];
	}
	
	/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
	function parse_PtgAttrSemi(blob, length, opts) {
		var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += opts && opts.biff == 2 ? 3 : 4;
		return [bitSemi];
	}
	
	/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
	function parse_PtgAttrSpaceType(blob) {
		var type = blob.read_shift(1), cch = blob.read_shift(1);
		return [type, cch];
	}
	
	/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
	function parse_PtgAttrSpace(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
	function parse_PtgAttrSpaceSemi(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
	function parse_PtgRef(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLoc(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
	function parse_PtgRefN(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLocRel(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
	function parse_PtgRef3d(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var ixti = blob.read_shift(2); // XtiIndex
		if(opts && opts.biff == 5) blob.l += 12;
		var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
		return [type, ixti, loc];
	}
	
	
	/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
	function parse_PtgFunc(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
		return [FtabArgc[iftab], Ftab[iftab], type];
	}
	/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
	function parse_PtgFuncVar(blob, length, opts) {
		var type = blob[blob.l++];
		var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
		return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
	}
	
	function parsetab(blob) {
		return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
	}
	
	/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
	function parse_PtgAttrSum(blob, length, opts) {
		blob.l += opts && opts.biff == 2 ? 3 : 4; return;
	}
	
	/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
	function parse_PtgExp(blob, length, opts) {
		blob.l++;
		if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
		var row = blob.read_shift(2);
		var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [row, col];
	}
	
	/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
	function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }
	
	/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
	function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }
	
	/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
	function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}
	
	/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
	function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }
	
	/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
	function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }
	
	/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
	/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
	function parse_SerAr(blob, biff) {
		var val = [blob.read_shift(1)];
		if(biff == 12) switch(val[0]) {
			case 0x02: val[0] = 0x04; break; /* SerBool */
			case 0x04: val[0] = 0x10; break; /* SerErr */
			case 0x00: val[0] = 0x01; break; /* SerNum */
			case 0x01: val[0] = 0x02; break; /* SerStr */
		}
		switch(val[0]) {
			case 0x04: /* SerBool -- boolean */
				val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
				if(biff != 12) blob.l += 7; break;
			case 0x25: /* appears to be an alias */
			case 0x10: /* SerErr -- error */
				val[1] = BErr[blob[blob.l]];
				blob.l += ((biff == 12) ? 4 : 8); break;
			case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
				blob.l += 8; break;
			case 0x01: /* SerNum -- Xnum */
				val[1] = parse_Xnum(blob, 8); break;
			case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
				val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
			default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
		}
		return val;
	}
	
	/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
	function parse_PtgExtraMem(blob, cce, opts) {
		var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
		var out = [];
		for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
		return out;
	}
	
	/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
	function parse_PtgExtraArray(blob, length, opts) {
		var rows = 0, cols = 0;
		if(opts.biff == 12) {
			rows = blob.read_shift(4); // DRw
			cols = blob.read_shift(4); // DCol
		} else {
			cols = 1 + blob.read_shift(1); //DColByteU
			rows = 1 + blob.read_shift(2); //DRw
		}
		if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
		// $FlowIgnore
		for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
			for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
		return o;
	}
	
	/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
	function parse_PtgName(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
		var nameindex = blob.read_shift(w);
		switch(opts.biff) {
			case 2: blob.l += 5; break;
			case 3: case 4: blob.l += 8; break;
			case 5: blob.l += 12; break;
		}
		return [type, 0, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
	function parse_PtgNameX(blob, length, opts) {
		if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2); // XtiIndex
		var nameindex = blob.read_shift(4);
		return [type, ixti, nameindex];
	}
	function parse_PtgNameX_BIFF5(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2, 'i'); // XtiIndex
		blob.l += 8;
		var nameindex = blob.read_shift(2);
		blob.l += 12;
		return [type, ixti, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
	function parse_PtgMemArea(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += (opts && opts.biff == 2 ? 3 : 4);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
	function parse_PtgMemFunc(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	
	/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
	function parse_PtgRefErr(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		if(opts.biff < 8) blob.l--;
		if(opts.biff == 12) blob.l += 2;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
	function parse_PtgRefErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 4;
		if(opts) switch(opts.biff) {
			case 5: w = 15; break;
			case 12: w = 6; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
	var parse_PtgMemErr = parsenoop;
	/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
	var parse_PtgMemNoMem = parsenoop;
	/* [MS-XLS] 2.5.198.92 */
	var parse_PtgTbl = parsenoop;
	
	function parse_PtgElfLoc(blob, length, opts) {
		blob.l += 2;
		return [parse_RgceElfLoc(blob, 4, opts)];
	}
	function parse_PtgElfNoop(blob) {
		blob.l += 6;
		return [];
	}
	/* [MS-XLS] 2.5.198.46 */
	var parse_PtgElfCol = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.47 */
	var parse_PtgElfColS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.48 */
	var parse_PtgElfColSV = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.49 */
	var parse_PtgElfColV = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.50 */
	function parse_PtgElfLel(blob) {
		blob.l += 2;
		return [parseuint16(blob), blob.read_shift(2) & 0x01];
	}
	/* [MS-XLS] 2.5.198.51 */
	var parse_PtgElfRadical = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.52 */
	var parse_PtgElfRadicalLel = parse_PtgElfLel;
	/* [MS-XLS] 2.5.198.53 */
	var parse_PtgElfRadicalS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.54 */
	var parse_PtgElfRw = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.55 */
	var parse_PtgElfRwV = parse_PtgElfLoc;
	
	/* [MS-XLSB] 2.5.97.52 TODO */
	var PtgListRT = [
		"Data",
		"All",
		"Headers",
		"??",
		"?Data2",
		"??",
		"?DataHeaders",
		"??",
		"Totals",
		"??",
		"??",
		"??",
		"?DataTotals",
		"??",
		"??",
		"??",
		"?Current"
	];
	function parse_PtgList(blob) {
		blob.l += 2;
		var ixti = blob.read_shift(2);
		var flags = blob.read_shift(2);
		var idx = blob.read_shift(4);
		var c = blob.read_shift(2);
		var C = blob.read_shift(2);
		var rt = PtgListRT[(flags >> 2) & 0x1F];
		return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
	}
	/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
	function parse_PtgSxName(blob) {
		blob.l += 2;
		return [blob.read_shift(4)];
	}
	
	/* [XLS] old spec */
	function parse_PtgSheet(blob, length, opts) {
		blob.l += 5;
		blob.l += 2;
		blob.l += (opts.biff == 2 ? 1 : 4);
		return ["PTGSHEET"];
	}
	function parse_PtgEndSheet(blob, length, opts) {
		blob.l += (opts.biff == 2 ? 4 : 5);
		return ["PTGENDSHEET"];
	}
	function parse_PtgMemAreaN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgMemNoMemN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgAttrNoop(blob) {
		blob.l += 4;
		return [0, 0];
	}
	
	/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
	var PtgTypes = {
	0x01: { n:'PtgExp', f:parse_PtgExp },
	0x02: { n:'PtgTbl', f:parse_PtgTbl },
	0x03: { n:'PtgAdd', f:parseread1 },
	0x04: { n:'PtgSub', f:parseread1 },
	0x05: { n:'PtgMul', f:parseread1 },
	0x06: { n:'PtgDiv', f:parseread1 },
	0x07: { n:'PtgPower', f:parseread1 },
	0x08: { n:'PtgConcat', f:parseread1 },
	0x09: { n:'PtgLt', f:parseread1 },
	0x0A: { n:'PtgLe', f:parseread1 },
	0x0B: { n:'PtgEq', f:parseread1 },
	0x0C: { n:'PtgGe', f:parseread1 },
	0x0D: { n:'PtgGt', f:parseread1 },
	0x0E: { n:'PtgNe', f:parseread1 },
	0x0F: { n:'PtgIsect', f:parseread1 },
	0x10: { n:'PtgUnion', f:parseread1 },
	0x11: { n:'PtgRange', f:parseread1 },
	0x12: { n:'PtgUplus', f:parseread1 },
	0x13: { n:'PtgUminus', f:parseread1 },
	0x14: { n:'PtgPercent', f:parseread1 },
	0x15: { n:'PtgParen', f:parseread1 },
	0x16: { n:'PtgMissArg', f:parseread1 },
	0x17: { n:'PtgStr', f:parse_PtgStr },
	0x1A: { n:'PtgSheet', f:parse_PtgSheet },
	0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
	0x1C: { n:'PtgErr', f:parse_PtgErr },
	0x1D: { n:'PtgBool', f:parse_PtgBool },
	0x1E: { n:'PtgInt', f:parse_PtgInt },
	0x1F: { n:'PtgNum', f:parse_PtgNum },
	0x20: { n:'PtgArray', f:parse_PtgArray },
	0x21: { n:'PtgFunc', f:parse_PtgFunc },
	0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	0x23: { n:'PtgName', f:parse_PtgName },
	0x24: { n:'PtgRef', f:parse_PtgRef },
	0x25: { n:'PtgArea', f:parse_PtgArea },
	0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
	0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
	0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
	0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	0x2C: { n:'PtgRefN', f:parse_PtgRefN },
	0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
	0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
	0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
	0x39: { n:'PtgNameX', f:parse_PtgNameX },
	0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
	0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
	0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	0xFF: {}
	};
	/* These are duplicated in the PtgTypes table */
	var PtgDupes = {
	0x40: 0x20, 0x60: 0x20,
	0x41: 0x21, 0x61: 0x21,
	0x42: 0x22, 0x62: 0x22,
	0x43: 0x23, 0x63: 0x23,
	0x44: 0x24, 0x64: 0x24,
	0x45: 0x25, 0x65: 0x25,
	0x46: 0x26, 0x66: 0x26,
	0x47: 0x27, 0x67: 0x27,
	0x48: 0x28, 0x68: 0x28,
	0x49: 0x29, 0x69: 0x29,
	0x4A: 0x2A, 0x6A: 0x2A,
	0x4B: 0x2B, 0x6B: 0x2B,
	0x4C: 0x2C, 0x6C: 0x2C,
	0x4D: 0x2D, 0x6D: 0x2D,
	0x4E: 0x2E, 0x6E: 0x2E,
	0x4F: 0x2F, 0x6F: 0x2F,
	0x58: 0x22, 0x78: 0x22,
	0x59: 0x39, 0x79: 0x39,
	0x5A: 0x3A, 0x7A: 0x3A,
	0x5B: 0x3B, 0x7B: 0x3B,
	0x5C: 0x3C, 0x7C: 0x3C,
	0x5D: 0x3D, 0x7D: 0x3D
	};
	(function(){for(var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];})();
	
	var Ptg18 = {
	0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
	0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
	0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
	0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
	0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
	0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	0x19: { n:'PtgList', f:parse_PtgList },
	0x1D: { n:'PtgSxName', f:parse_PtgSxName },
	0xFF: {}
	};
	var Ptg19 = {
	0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
	0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	0xFF: {}
	};
	Ptg19[0x21] = Ptg19[0x20];
	
	/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
	function parse_RgbExtra(blob, length, rgce, opts) {
		if(opts.biff < 8) return parsenoop(blob, length);
		var target = blob.l + length;
		var o = [];
		for(var i = 0; i !== rgce.length; ++i) {
			switch(rgce[i][0]) {
				case 'PtgArray': /* PtgArray -> PtgExtraArray */
					rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
					o.push(rgce[i][1]);
					break;
				case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
					rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
					o.push(rgce[i][2]);
					break;
				case 'PtgExp': /* PtgExp -> PtgExtraCol */
					if(opts && opts.biff == 12) {
						rgce[i][1][1] = blob.read_shift(4);
						o.push(rgce[i][1]);
					} break;
				case 'PtgList': /* TODO: PtgList -> PtgExtraList */
				case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
				case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
				case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
					throw "Unsupported " + rgce[i][0];
				default: break;
			}
		}
		length = target - blob.l;
		/* note: this is technically an error but Excel disregards */
		//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
		if(length !== 0) o.push(parsenoop(blob, length));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
	function parse_Rgce(blob, length, opts) {
		var target = blob.l + length;
		var R, id, ptgs = [];
		while(target != blob.l) {
			length = target - blob.l;
			id = blob[blob.l];
			R = PtgTypes[id];
			if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
			if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
			else { ptgs.push([R.n, R.f(blob, length, opts)]); }
		}
		return ptgs;
	}
	
	function stringify_array(f) {
		var o = [];
		for(var i = 0; i < f.length; ++i) {
			var x = f[i], r = [];
			for(var j = 0; j < x.length; ++j) {
				var y = x[j];
				if(y) switch(y[0]) {
					// TODO: handle embedded quotes
					case 0x02:
	r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
					default: r.push(y[1]);
				} else r.push("");
			}
			o.push(r.join(","));
		}
		return o.join(";");
	}
	
	/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
	var PtgBinOp = {
		PtgAdd: "+",
		PtgConcat: "&",
		PtgDiv: "/",
		PtgEq: "=",
		PtgGe: ">=",
		PtgGt: ">",
		PtgLe: "<=",
		PtgLt: "<",
		PtgMul: "*",
		PtgNe: "<>",
		PtgPower: "^",
		PtgSub: "-"
	};
	function formula_quote_sheet_name(sname, opts) {
		if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
		if(sname.indexOf(" ") > -1) return "'" + sname + "'";
		return sname;
	}
	function get_ixti_raw(supbooks, ixti, opts) {
		if(!supbooks) return "SH33TJSERR0";
		if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
		if(!supbooks.XTI) return "SH33TJSERR6";
		var XTI = supbooks.XTI[ixti];
		if(opts.biff < 8) {
			if(ixti > 10000) ixti-= 65536;
			if(ixti < 0) ixti = -ixti;
			return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
		}
		if(!XTI) return "SH33TJSERR1";
		var o = "";
		if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
			case 0x0165: /* 'BrtSupSelf' */
				o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x0166: /* 'BrtSupSame' */
				if(opts.SID != null) return supbooks.SheetNames[opts.SID];
				return "SH33TJSSAME" + supbooks[XTI[0]][0];
			case 0x0163: /* 'BrtSupBookSrc' */
				/* falls through */
			default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
		}
		switch(supbooks[XTI[0]][0][0]) {
			case 0x0401:
				o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
			default:
				if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
				o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
		}
	}
	function get_ixti(supbooks, ixti, opts) {
		return formula_quote_sheet_name(get_ixti_raw(supbooks, ixti, opts), opts);
	}
	function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
		var biff = (opts && opts.biff) || 8;
		var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
		var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
		if(!formula[0] || !formula[0][0]) return "";
		var last_sp = -1, sp = "";
		for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
			var f = formula[0][ff];
			switch(f[0]) {
				case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
					stack.push("-" + stack.pop()); break;
				case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
					stack.push("+" + stack.pop()); break;
				case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
					stack.push(stack.pop() + "%"); break;
	
				case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
				case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
				case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
				case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
				case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
				case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
				case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
				case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
				case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
				case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
				case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
				case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
					e1 = stack.pop(); e2 = stack.pop();
					if(last_sp >= 0) {
						switch(formula[0][last_sp][1][0]) {
							case 0:
								// $FlowIgnore
								sp = fill(" ", formula[0][last_sp][1][1]); break;
							case 1:
								// $FlowIgnore
								sp = fill("\r", formula[0][last_sp][1][1]); break;
							default:
								sp = "";
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						e2 = e2 + sp;
						last_sp = -1;
					}
					stack.push(e2+PtgBinOp[f[0]]+e1);
					break;
	
				case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+" "+e1);
					break;
				case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+","+e1);
					break;
				case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+":"+e1);
					break;
	
				case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
					break;
				case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
					break;
				case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
					break;
				case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
					break;
	
	
				case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
	c = shift_cell_xls((f[1][1]), _range, opts);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
	c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
	ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
					sname = get_ixti(supbooks, ixti, opts);
					var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
					stack.push(sname + "!" + encode_cell_xls(c, biff));
					break;
	
				case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
				case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
					/* f[1] = [argc, func, type] */
					var argc = (f[1][0]), func = (f[1][1]);
					if(!argc) argc = 0;
					argc &= 0x7F;
					var args = argc == 0 ? [] : stack.slice(-argc);
					stack.length -= argc;
					if(func === 'User') func = args.shift();
					stack.push(func + "(" + args.join(",") + ")");
					break;
	
				case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
					stack.push(f[1] ? "TRUE" : "FALSE"); break;
				case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
					stack.push(f[1]); break;
				case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
					stack.push(String(f[1])); break;
				case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
					// $FlowIgnore
					stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
				case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
					stack.push(f[1]); break;
				case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
	r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
	r = shift_range_xls(f[1][1], _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
	ixti = f[1][1]; r = f[1][2];
					sname = get_ixti(supbooks, ixti, opts);
					stack.push(sname + "!" + encode_range_xls((r), opts));
					break;
				case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
					stack.push("SUM(" + stack.pop() + ")");
					break;
	
				case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
				case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
					break;
	
				case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
					/* f[1] = type, 0, nameindex */
					nameidx = (f[1][2]);
					var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
					var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
					if(name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
					stack.push(name);
					break;
	
				case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
					/* f[1] = type, ixti, nameindex */
					var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
					/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
					if(opts.biff <= 5) {
						if(bookidx < 0) bookidx = -bookidx;
						if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
					} else {
						var o = "";
						if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
						else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
							if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
								o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
							}
						}
						else o = supbooks.SheetNames[nameidx-1]+ "!";
						if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
						else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
						else {
							var ixtidata = get_ixti_raw(supbooks, bookidx, opts).split(";;");
							if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
							else o += "SH33TJSERRX";
						}
						stack.push(o);
						break;
					}
					if(!externbook) externbook = {Name: "SH33TJSERRY"};
					stack.push(externbook.Name);
					break;
	
				case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
					var lp = '(', rp = ')';
					if(last_sp >= 0) {
						sp = "";
						switch(formula[0][last_sp][1][0]) {
							// $FlowIgnore
							case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
							// $FlowIgnore
							case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
							default:
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						last_sp = -1;
					}
					stack.push(lp + stack.pop() + rp); break;
	
				case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
					stack.push('#REF!'); break;
	
				case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
					stack.push('#REF!'); break;
	
				case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
					c = {c:(f[1][1]),r:(f[1][0])};
					var q = ({c: cell.c, r:cell.r});
					if(supbooks.sharedf[encode_cell(c)]) {
						var parsedf = (supbooks.sharedf[encode_cell(c)]);
						stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
					}
					else {
						var fnd = false;
						for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
							/* TODO: should be something like range_has */
							e2 = supbooks.arrayf[e1];
							if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
							if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
							stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
							fnd = true;
							break;
						}
						if(!fnd) stack.push(f[1]);
					}
					break;
	
				case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
					stack.push("{" + stringify_array(f[1]) + "}");
					break;
	
				case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
					//stack.push("(" + f[2].map(encode_range).join(",") + ")");
					break;
	
				case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
				case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
					last_sp = ff;
					break;
	
				case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
					break;
	
				case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
					break;
	
				case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
					stack.push("");
					break;
	
				case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
					stack.push("#REF!"); break;
	
				case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
					stack.push("#REF!"); break;
	
				case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
					// $FlowIgnore
					stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
					break;
	
				case 'PtgMemAreaN':
				case 'PtgMemNoMemN':
				case 'PtgAttrNoop':
				case 'PtgSheet':
				case 'PtgEndSheet':
					break;
	
				case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
					break;
				case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
					break;
	
				case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
				case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
				case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
				case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
				case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
				case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
				case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
				case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
				case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
				case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
					throw new Error("Unsupported ELFs");
	
				case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
				default: throw new Error('Unrecognized Formula Token: ' + String(f));
			}
			var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
			if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
				f = formula[0][last_sp];
				var _left = true;
				switch(f[1][0]) {
					/* note: some bad XLSB files omit the PtgParen */
					case 4: _left = false;
					/* falls through */
					case 0:
						// $FlowIgnore
						sp = fill(" ", f[1][1]); break;
					case 5: _left = false;
					/* falls through */
					case 1:
						// $FlowIgnore
						sp = fill("\r", f[1][1]); break;
					default:
						sp = "";
						// $FlowIgnore
						if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
				}
				stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
				last_sp = -1;
			}
		}
		if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
		return stack[0];
	}
	
	/* [MS-XLS] 2.5.198.1 TODO */
	function parse_ArrayParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.3 TODO */
	function parse_XLSCellParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.21 */
	function parse_NameParsedFormula(blob, length, opts, cce) {
		var target = blob.l + length;
		var rgce = parse_Rgce(blob, cce, opts);
		var rgcb;
		if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.118 TODO */
	function parse_SharedParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		var rgce = parse_Rgce(blob, cce, opts);
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
	function parse_FormulaValue(blob) {
		var b;
		if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
		switch(blob[blob.l]) {
			case 0x00: blob.l += 8; return ["String", 's'];
			case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
			case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
			case 0x03: blob.l += 8; return ["",'s'];
		}
		return [];
	}
	function write_FormulaValue(value) {
		if(value == null) {
			// Blank String Value
			var o = new_buf(8);
			o.write_shift(1, 0x03);
			o.write_shift(1, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		} else if(typeof value == "number") return write_Xnum(value);
		return write_Xnum(0);
	}
	
	/* [MS-XLS] 2.4.127 TODO */
	function parse_Formula(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_FormulaValue(blob,8);
		var flags = blob.read_shift(1);
		if(opts.biff != 2) {
			blob.read_shift(1);
			if(opts.biff >= 5) {
				/*var chn = */blob.read_shift(4);
			}
		}
		var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
		return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
	}
	function write_Formula(cell, R, C, opts, os) {
		// Cell
		var o1 = write_XLSCell(R, C, os);
	
		// FormulaValue
		var o2 = write_FormulaValue(cell.v);
	
		// flags + cache
		var o3 = new_buf(6);
		var flags = 0x01 | 0x20;
		o3.write_shift(2, flags);
		o3.write_shift(4, 0);
	
		// CellParsedFormula
		var bf = new_buf(cell.bf.length);
		for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];
	
		var out = bconcat([o1, o2, o3, bf]);
		return out;
	}
	
	
	/* XLSB Parsed Formula records have the same shape */
	function parse_XLSBParsedFormula(data, length, opts) {
		var cce = data.read_shift(4);
		var rgce = parse_Rgce(data, cce, opts);
		var cb = data.read_shift(4);
		var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
		return [rgce, rgcb];
	}
	
	/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
	var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
	var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
	//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
	//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
	/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
	var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
	var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLS] 2.5.198.4 */
	var Cetab = {
	0x0000: 'BEEP',
	0x0001: 'OPEN',
	0x0002: 'OPEN.LINKS',
	0x0003: 'CLOSE.ALL',
	0x0004: 'SAVE',
	0x0005: 'SAVE.AS',
	0x0006: 'FILE.DELETE',
	0x0007: 'PAGE.SETUP',
	0x0008: 'PRINT',
	0x0009: 'PRINTER.SETUP',
	0x000A: 'QUIT',
	0x000B: 'NEW.WINDOW',
	0x000C: 'ARRANGE.ALL',
	0x000D: 'WINDOW.SIZE',
	0x000E: 'WINDOW.MOVE',
	0x000F: 'FULL',
	0x0010: 'CLOSE',
	0x0011: 'RUN',
	0x0016: 'SET.PRINT.AREA',
	0x0017: 'SET.PRINT.TITLES',
	0x0018: 'SET.PAGE.BREAK',
	0x0019: 'REMOVE.PAGE.BREAK',
	0x001A: 'FONT',
	0x001B: 'DISPLAY',
	0x001C: 'PROTECT.DOCUMENT',
	0x001D: 'PRECISION',
	0x001E: 'A1.R1C1',
	0x001F: 'CALCULATE.NOW',
	0x0020: 'CALCULATION',
	0x0022: 'DATA.FIND',
	0x0023: 'EXTRACT',
	0x0024: 'DATA.DELETE',
	0x0025: 'SET.DATABASE',
	0x0026: 'SET.CRITERIA',
	0x0027: 'SORT',
	0x0028: 'DATA.SERIES',
	0x0029: 'TABLE',
	0x002A: 'FORMAT.NUMBER',
	0x002B: 'ALIGNMENT',
	0x002C: 'STYLE',
	0x002D: 'BORDER',
	0x002E: 'CELL.PROTECTION',
	0x002F: 'COLUMN.WIDTH',
	0x0030: 'UNDO',
	0x0031: 'CUT',
	0x0032: 'COPY',
	0x0033: 'PASTE',
	0x0034: 'CLEAR',
	0x0035: 'PASTE.SPECIAL',
	0x0036: 'EDIT.DELETE',
	0x0037: 'INSERT',
	0x0038: 'FILL.RIGHT',
	0x0039: 'FILL.DOWN',
	0x003D: 'DEFINE.NAME',
	0x003E: 'CREATE.NAMES',
	0x003F: 'FORMULA.GOTO',
	0x0040: 'FORMULA.FIND',
	0x0041: 'SELECT.LAST.CELL',
	0x0042: 'SHOW.ACTIVE.CELL',
	0x0043: 'GALLERY.AREA',
	0x0044: 'GALLERY.BAR',
	0x0045: 'GALLERY.COLUMN',
	0x0046: 'GALLERY.LINE',
	0x0047: 'GALLERY.PIE',
	0x0048: 'GALLERY.SCATTER',
	0x0049: 'COMBINATION',
	0x004A: 'PREFERRED',
	0x004B: 'ADD.OVERLAY',
	0x004C: 'GRIDLINES',
	0x004D: 'SET.PREFERRED',
	0x004E: 'AXES',
	0x004F: 'LEGEND',
	0x0050: 'ATTACH.TEXT',
	0x0051: 'ADD.ARROW',
	0x0052: 'SELECT.CHART',
	0x0053: 'SELECT.PLOT.AREA',
	0x0054: 'PATTERNS',
	0x0055: 'MAIN.CHART',
	0x0056: 'OVERLAY',
	0x0057: 'SCALE',
	0x0058: 'FORMAT.LEGEND',
	0x0059: 'FORMAT.TEXT',
	0x005A: 'EDIT.REPEAT',
	0x005B: 'PARSE',
	0x005C: 'JUSTIFY',
	0x005D: 'HIDE',
	0x005E: 'UNHIDE',
	0x005F: 'WORKSPACE',
	0x0060: 'FORMULA',
	0x0061: 'FORMULA.FILL',
	0x0062: 'FORMULA.ARRAY',
	0x0063: 'DATA.FIND.NEXT',
	0x0064: 'DATA.FIND.PREV',
	0x0065: 'FORMULA.FIND.NEXT',
	0x0066: 'FORMULA.FIND.PREV',
	0x0067: 'ACTIVATE',
	0x0068: 'ACTIVATE.NEXT',
	0x0069: 'ACTIVATE.PREV',
	0x006A: 'UNLOCKED.NEXT',
	0x006B: 'UNLOCKED.PREV',
	0x006C: 'COPY.PICTURE',
	0x006D: 'SELECT',
	0x006E: 'DELETE.NAME',
	0x006F: 'DELETE.FORMAT',
	0x0070: 'VLINE',
	0x0071: 'HLINE',
	0x0072: 'VPAGE',
	0x0073: 'HPAGE',
	0x0074: 'VSCROLL',
	0x0075: 'HSCROLL',
	0x0076: 'ALERT',
	0x0077: 'NEW',
	0x0078: 'CANCEL.COPY',
	0x0079: 'SHOW.CLIPBOARD',
	0x007A: 'MESSAGE',
	0x007C: 'PASTE.LINK',
	0x007D: 'APP.ACTIVATE',
	0x007E: 'DELETE.ARROW',
	0x007F: 'ROW.HEIGHT',
	0x0080: 'FORMAT.MOVE',
	0x0081: 'FORMAT.SIZE',
	0x0082: 'FORMULA.REPLACE',
	0x0083: 'SEND.KEYS',
	0x0084: 'SELECT.SPECIAL',
	0x0085: 'APPLY.NAMES',
	0x0086: 'REPLACE.FONT',
	0x0087: 'FREEZE.PANES',
	0x0088: 'SHOW.INFO',
	0x0089: 'SPLIT',
	0x008A: 'ON.WINDOW',
	0x008B: 'ON.DATA',
	0x008C: 'DISABLE.INPUT',
	0x008E: 'OUTLINE',
	0x008F: 'LIST.NAMES',
	0x0090: 'FILE.CLOSE',
	0x0091: 'SAVE.WORKBOOK',
	0x0092: 'DATA.FORM',
	0x0093: 'COPY.CHART',
	0x0094: 'ON.TIME',
	0x0095: 'WAIT',
	0x0096: 'FORMAT.FONT',
	0x0097: 'FILL.UP',
	0x0098: 'FILL.LEFT',
	0x0099: 'DELETE.OVERLAY',
	0x009B: 'SHORT.MENUS',
	0x009F: 'SET.UPDATE.STATUS',
	0x00A1: 'COLOR.PALETTE',
	0x00A2: 'DELETE.STYLE',
	0x00A3: 'WINDOW.RESTORE',
	0x00A4: 'WINDOW.MAXIMIZE',
	0x00A6: 'CHANGE.LINK',
	0x00A7: 'CALCULATE.DOCUMENT',
	0x00A8: 'ON.KEY',
	0x00A9: 'APP.RESTORE',
	0x00AA: 'APP.MOVE',
	0x00AB: 'APP.SIZE',
	0x00AC: 'APP.MINIMIZE',
	0x00AD: 'APP.MAXIMIZE',
	0x00AE: 'BRING.TO.FRONT',
	0x00AF: 'SEND.TO.BACK',
	0x00B9: 'MAIN.CHART.TYPE',
	0x00BA: 'OVERLAY.CHART.TYPE',
	0x00BB: 'SELECT.END',
	0x00BC: 'OPEN.MAIL',
	0x00BD: 'SEND.MAIL',
	0x00BE: 'STANDARD.FONT',
	0x00BF: 'CONSOLIDATE',
	0x00C0: 'SORT.SPECIAL',
	0x00C1: 'GALLERY.3D.AREA',
	0x00C2: 'GALLERY.3D.COLUMN',
	0x00C3: 'GALLERY.3D.LINE',
	0x00C4: 'GALLERY.3D.PIE',
	0x00C5: 'VIEW.3D',
	0x00C6: 'GOAL.SEEK',
	0x00C7: 'WORKGROUP',
	0x00C8: 'FILL.GROUP',
	0x00C9: 'UPDATE.LINK',
	0x00CA: 'PROMOTE',
	0x00CB: 'DEMOTE',
	0x00CC: 'SHOW.DETAIL',
	0x00CE: 'UNGROUP',
	0x00CF: 'OBJECT.PROPERTIES',
	0x00D0: 'SAVE.NEW.OBJECT',
	0x00D1: 'SHARE',
	0x00D2: 'SHARE.NAME',
	0x00D3: 'DUPLICATE',
	0x00D4: 'APPLY.STYLE',
	0x00D5: 'ASSIGN.TO.OBJECT',
	0x00D6: 'OBJECT.PROTECTION',
	0x00D7: 'HIDE.OBJECT',
	0x00D8: 'SET.EXTRACT',
	0x00D9: 'CREATE.PUBLISHER',
	0x00DA: 'SUBSCRIBE.TO',
	0x00DB: 'ATTRIBUTES',
	0x00DC: 'SHOW.TOOLBAR',
	0x00DE: 'PRINT.PREVIEW',
	0x00DF: 'EDIT.COLOR',
	0x00E0: 'SHOW.LEVELS',
	0x00E1: 'FORMAT.MAIN',
	0x00E2: 'FORMAT.OVERLAY',
	0x00E3: 'ON.RECALC',
	0x00E4: 'EDIT.SERIES',
	0x00E5: 'DEFINE.STYLE',
	0x00F0: 'LINE.PRINT',
	0x00F3: 'ENTER.DATA',
	0x00F9: 'GALLERY.RADAR',
	0x00FA: 'MERGE.STYLES',
	0x00FB: 'EDITION.OPTIONS',
	0x00FC: 'PASTE.PICTURE',
	0x00FD: 'PASTE.PICTURE.LINK',
	0x00FE: 'SPELLING',
	0x0100: 'ZOOM',
	0x0103: 'INSERT.OBJECT',
	0x0104: 'WINDOW.MINIMIZE',
	0x0109: 'SOUND.NOTE',
	0x010A: 'SOUND.PLAY',
	0x010B: 'FORMAT.SHAPE',
	0x010C: 'EXTEND.POLYGON',
	0x010D: 'FORMAT.AUTO',
	0x0110: 'GALLERY.3D.BAR',
	0x0111: 'GALLERY.3D.SURFACE',
	0x0112: 'FILL.AUTO',
	0x0114: 'CUSTOMIZE.TOOLBAR',
	0x0115: 'ADD.TOOL',
	0x0116: 'EDIT.OBJECT',
	0x0117: 'ON.DOUBLECLICK',
	0x0118: 'ON.ENTRY',
	0x0119: 'WORKBOOK.ADD',
	0x011A: 'WORKBOOK.MOVE',
	0x011B: 'WORKBOOK.COPY',
	0x011C: 'WORKBOOK.OPTIONS',
	0x011D: 'SAVE.WORKSPACE',
	0x0120: 'CHART.WIZARD',
	0x0121: 'DELETE.TOOL',
	0x0122: 'MOVE.TOOL',
	0x0123: 'WORKBOOK.SELECT',
	0x0124: 'WORKBOOK.ACTIVATE',
	0x0125: 'ASSIGN.TO.TOOL',
	0x0127: 'COPY.TOOL',
	0x0128: 'RESET.TOOL',
	0x0129: 'CONSTRAIN.NUMERIC',
	0x012A: 'PASTE.TOOL',
	0x012E: 'WORKBOOK.NEW',
	0x0131: 'SCENARIO.CELLS',
	0x0132: 'SCENARIO.DELETE',
	0x0133: 'SCENARIO.ADD',
	0x0134: 'SCENARIO.EDIT',
	0x0135: 'SCENARIO.SHOW',
	0x0136: 'SCENARIO.SHOW.NEXT',
	0x0137: 'SCENARIO.SUMMARY',
	0x0138: 'PIVOT.TABLE.WIZARD',
	0x0139: 'PIVOT.FIELD.PROPERTIES',
	0x013A: 'PIVOT.FIELD',
	0x013B: 'PIVOT.ITEM',
	0x013C: 'PIVOT.ADD.FIELDS',
	0x013E: 'OPTIONS.CALCULATION',
	0x013F: 'OPTIONS.EDIT',
	0x0140: 'OPTIONS.VIEW',
	0x0141: 'ADDIN.MANAGER',
	0x0142: 'MENU.EDITOR',
	0x0143: 'ATTACH.TOOLBARS',
	0x0144: 'VBAActivate',
	0x0145: 'OPTIONS.CHART',
	0x0148: 'VBA.INSERT.FILE',
	0x014A: 'VBA.PROCEDURE.DEFINITION',
	0x0150: 'ROUTING.SLIP',
	0x0152: 'ROUTE.DOCUMENT',
	0x0153: 'MAIL.LOGON',
	0x0156: 'INSERT.PICTURE',
	0x0157: 'EDIT.TOOL',
	0x0158: 'GALLERY.DOUGHNUT',
	0x015E: 'CHART.TREND',
	0x0160: 'PIVOT.ITEM.PROPERTIES',
	0x0162: 'WORKBOOK.INSERT',
	0x0163: 'OPTIONS.TRANSITION',
	0x0164: 'OPTIONS.GENERAL',
	0x0172: 'FILTER.ADVANCED',
	0x0175: 'MAIL.ADD.MAILER',
	0x0176: 'MAIL.DELETE.MAILER',
	0x0177: 'MAIL.REPLY',
	0x0178: 'MAIL.REPLY.ALL',
	0x0179: 'MAIL.FORWARD',
	0x017A: 'MAIL.NEXT.LETTER',
	0x017B: 'DATA.LABEL',
	0x017C: 'INSERT.TITLE',
	0x017D: 'FONT.PROPERTIES',
	0x017E: 'MACRO.OPTIONS',
	0x017F: 'WORKBOOK.HIDE',
	0x0180: 'WORKBOOK.UNHIDE',
	0x0181: 'WORKBOOK.DELETE',
	0x0182: 'WORKBOOK.NAME',
	0x0184: 'GALLERY.CUSTOM',
	0x0186: 'ADD.CHART.AUTOFORMAT',
	0x0187: 'DELETE.CHART.AUTOFORMAT',
	0x0188: 'CHART.ADD.DATA',
	0x0189: 'AUTO.OUTLINE',
	0x018A: 'TAB.ORDER',
	0x018B: 'SHOW.DIALOG',
	0x018C: 'SELECT.ALL',
	0x018D: 'UNGROUP.SHEETS',
	0x018E: 'SUBTOTAL.CREATE',
	0x018F: 'SUBTOTAL.REMOVE',
	0x0190: 'RENAME.OBJECT',
	0x019C: 'WORKBOOK.SCROLL',
	0x019D: 'WORKBOOK.NEXT',
	0x019E: 'WORKBOOK.PREV',
	0x019F: 'WORKBOOK.TAB.SPLIT',
	0x01A0: 'FULL.SCREEN',
	0x01A1: 'WORKBOOK.PROTECT',
	0x01A4: 'SCROLLBAR.PROPERTIES',
	0x01A5: 'PIVOT.SHOW.PAGES',
	0x01A6: 'TEXT.TO.COLUMNS',
	0x01A7: 'FORMAT.CHARTTYPE',
	0x01A8: 'LINK.FORMAT',
	0x01A9: 'TRACER.DISPLAY',
	0x01AE: 'TRACER.NAVIGATE',
	0x01AF: 'TRACER.CLEAR',
	0x01B0: 'TRACER.ERROR',
	0x01B1: 'PIVOT.FIELD.GROUP',
	0x01B2: 'PIVOT.FIELD.UNGROUP',
	0x01B3: 'CHECKBOX.PROPERTIES',
	0x01B4: 'LABEL.PROPERTIES',
	0x01B5: 'LISTBOX.PROPERTIES',
	0x01B6: 'EDITBOX.PROPERTIES',
	0x01B7: 'PIVOT.REFRESH',
	0x01B8: 'LINK.COMBO',
	0x01B9: 'OPEN.TEXT',
	0x01BA: 'HIDE.DIALOG',
	0x01BB: 'SET.DIALOG.FOCUS',
	0x01BC: 'ENABLE.OBJECT',
	0x01BD: 'PUSHBUTTON.PROPERTIES',
	0x01BE: 'SET.DIALOG.DEFAULT',
	0x01BF: 'FILTER',
	0x01C0: 'FILTER.SHOW.ALL',
	0x01C1: 'CLEAR.OUTLINE',
	0x01C2: 'FUNCTION.WIZARD',
	0x01C3: 'ADD.LIST.ITEM',
	0x01C4: 'SET.LIST.ITEM',
	0x01C5: 'REMOVE.LIST.ITEM',
	0x01C6: 'SELECT.LIST.ITEM',
	0x01C7: 'SET.CONTROL.VALUE',
	0x01C8: 'SAVE.COPY.AS',
	0x01CA: 'OPTIONS.LISTS.ADD',
	0x01CB: 'OPTIONS.LISTS.DELETE',
	0x01CC: 'SERIES.AXES',
	0x01CD: 'SERIES.X',
	0x01CE: 'SERIES.Y',
	0x01CF: 'ERRORBAR.X',
	0x01D0: 'ERRORBAR.Y',
	0x01D1: 'FORMAT.CHART',
	0x01D2: 'SERIES.ORDER',
	0x01D3: 'MAIL.LOGOFF',
	0x01D4: 'CLEAR.ROUTING.SLIP',
	0x01D5: 'APP.ACTIVATE.MICROSOFT',
	0x01D6: 'MAIL.EDIT.MAILER',
	0x01D7: 'ON.SHEET',
	0x01D8: 'STANDARD.WIDTH',
	0x01D9: 'SCENARIO.MERGE',
	0x01DA: 'SUMMARY.INFO',
	0x01DB: 'FIND.FILE',
	0x01DC: 'ACTIVE.CELL.FONT',
	0x01DD: 'ENABLE.TIPWIZARD',
	0x01DE: 'VBA.MAKE.ADDIN',
	0x01E0: 'INSERTDATATABLE',
	0x01E1: 'WORKGROUP.OPTIONS',
	0x01E2: 'MAIL.SEND.MAILER',
	0x01E5: 'AUTOCORRECT',
	0x01E9: 'POST.DOCUMENT',
	0x01EB: 'PICKLIST',
	0x01ED: 'VIEW.SHOW',
	0x01EE: 'VIEW.DEFINE',
	0x01EF: 'VIEW.DELETE',
	0x01FD: 'SHEET.BACKGROUND',
	0x01FE: 'INSERT.MAP.OBJECT',
	0x01FF: 'OPTIONS.MENONO',
	0x0205: 'MSOCHECKS',
	0x0206: 'NORMAL',
	0x0207: 'LAYOUT',
	0x0208: 'RM.PRINT.AREA',
	0x0209: 'CLEAR.PRINT.AREA',
	0x020A: 'ADD.PRINT.AREA',
	0x020B: 'MOVE.BRK',
	0x0221: 'HIDECURR.NOTE',
	0x0222: 'HIDEALL.NOTES',
	0x0223: 'DELETE.NOTE',
	0x0224: 'TRAVERSE.NOTES',
	0x0225: 'ACTIVATE.NOTES',
	0x026C: 'PROTECT.REVISIONS',
	0x026D: 'UNPROTECT.REVISIONS',
	0x0287: 'OPTIONS.ME',
	0x028D: 'WEB.PUBLISH',
	0x029B: 'NEWWEBQUERY',
	0x02A1: 'PIVOT.TABLE.CHART',
	0x02F1: 'OPTIONS.SAVE',
	0x02F3: 'OPTIONS.SPELL',
	0x0328: 'HIDEALL.INKANNOTS'
	};
	
	/* [MS-XLS] 2.5.198.17 */
	/* [MS-XLSB] 2.5.97.10 */
	var Ftab = {
	0x0000: 'COUNT',
	0x0001: 'IF',
	0x0002: 'ISNA',
	0x0003: 'ISERROR',
	0x0004: 'SUM',
	0x0005: 'AVERAGE',
	0x0006: 'MIN',
	0x0007: 'MAX',
	0x0008: 'ROW',
	0x0009: 'COLUMN',
	0x000A: 'NA',
	0x000B: 'NPV',
	0x000C: 'STDEV',
	0x000D: 'DOLLAR',
	0x000E: 'FIXED',
	0x000F: 'SIN',
	0x0010: 'COS',
	0x0011: 'TAN',
	0x0012: 'ATAN',
	0x0013: 'PI',
	0x0014: 'SQRT',
	0x0015: 'EXP',
	0x0016: 'LN',
	0x0017: 'LOG10',
	0x0018: 'ABS',
	0x0019: 'INT',
	0x001A: 'SIGN',
	0x001B: 'ROUND',
	0x001C: 'LOOKUP',
	0x001D: 'INDEX',
	0x001E: 'REPT',
	0x001F: 'MID',
	0x0020: 'LEN',
	0x0021: 'VALUE',
	0x0022: 'TRUE',
	0x0023: 'FALSE',
	0x0024: 'AND',
	0x0025: 'OR',
	0x0026: 'NOT',
	0x0027: 'MOD',
	0x0028: 'DCOUNT',
	0x0029: 'DSUM',
	0x002A: 'DAVERAGE',
	0x002B: 'DMIN',
	0x002C: 'DMAX',
	0x002D: 'DSTDEV',
	0x002E: 'VAR',
	0x002F: 'DVAR',
	0x0030: 'TEXT',
	0x0031: 'LINEST',
	0x0032: 'TREND',
	0x0033: 'LOGEST',
	0x0034: 'GROWTH',
	0x0035: 'GOTO',
	0x0036: 'HALT',
	0x0037: 'RETURN',
	0x0038: 'PV',
	0x0039: 'FV',
	0x003A: 'NPER',
	0x003B: 'PMT',
	0x003C: 'RATE',
	0x003D: 'MIRR',
	0x003E: 'IRR',
	0x003F: 'RAND',
	0x0040: 'MATCH',
	0x0041: 'DATE',
	0x0042: 'TIME',
	0x0043: 'DAY',
	0x0044: 'MONTH',
	0x0045: 'YEAR',
	0x0046: 'WEEKDAY',
	0x0047: 'HOUR',
	0x0048: 'MINUTE',
	0x0049: 'SECOND',
	0x004A: 'NOW',
	0x004B: 'AREAS',
	0x004C: 'ROWS',
	0x004D: 'COLUMNS',
	0x004E: 'OFFSET',
	0x004F: 'ABSREF',
	0x0050: 'RELREF',
	0x0051: 'ARGUMENT',
	0x0052: 'SEARCH',
	0x0053: 'TRANSPOSE',
	0x0054: 'ERROR',
	0x0055: 'STEP',
	0x0056: 'TYPE',
	0x0057: 'ECHO',
	0x0058: 'SET.NAME',
	0x0059: 'CALLER',
	0x005A: 'DEREF',
	0x005B: 'WINDOWS',
	0x005C: 'SERIES',
	0x005D: 'DOCUMENTS',
	0x005E: 'ACTIVE.CELL',
	0x005F: 'SELECTION',
	0x0060: 'RESULT',
	0x0061: 'ATAN2',
	0x0062: 'ASIN',
	0x0063: 'ACOS',
	0x0064: 'CHOOSE',
	0x0065: 'HLOOKUP',
	0x0066: 'VLOOKUP',
	0x0067: 'LINKS',
	0x0068: 'INPUT',
	0x0069: 'ISREF',
	0x006A: 'GET.FORMULA',
	0x006B: 'GET.NAME',
	0x006C: 'SET.VALUE',
	0x006D: 'LOG',
	0x006E: 'EXEC',
	0x006F: 'CHAR',
	0x0070: 'LOWER',
	0x0071: 'UPPER',
	0x0072: 'PROPER',
	0x0073: 'LEFT',
	0x0074: 'RIGHT',
	0x0075: 'EXACT',
	0x0076: 'TRIM',
	0x0077: 'REPLACE',
	0x0078: 'SUBSTITUTE',
	0x0079: 'CODE',
	0x007A: 'NAMES',
	0x007B: 'DIRECTORY',
	0x007C: 'FIND',
	0x007D: 'CELL',
	0x007E: 'ISERR',
	0x007F: 'ISTEXT',
	0x0080: 'ISNUMBER',
	0x0081: 'ISBLANK',
	0x0082: 'T',
	0x0083: 'N',
	0x0084: 'FOPEN',
	0x0085: 'FCLOSE',
	0x0086: 'FSIZE',
	0x0087: 'FREADLN',
	0x0088: 'FREAD',
	0x0089: 'FWRITELN',
	0x008A: 'FWRITE',
	0x008B: 'FPOS',
	0x008C: 'DATEVALUE',
	0x008D: 'TIMEVALUE',
	0x008E: 'SLN',
	0x008F: 'SYD',
	0x0090: 'DDB',
	0x0091: 'GET.DEF',
	0x0092: 'REFTEXT',
	0x0093: 'TEXTREF',
	0x0094: 'INDIRECT',
	0x0095: 'REGISTER',
	0x0096: 'CALL',
	0x0097: 'ADD.BAR',
	0x0098: 'ADD.MENU',
	0x0099: 'ADD.COMMAND',
	0x009A: 'ENABLE.COMMAND',
	0x009B: 'CHECK.COMMAND',
	0x009C: 'RENAME.COMMAND',
	0x009D: 'SHOW.BAR',
	0x009E: 'DELETE.MENU',
	0x009F: 'DELETE.COMMAND',
	0x00A0: 'GET.CHART.ITEM',
	0x00A1: 'DIALOG.BOX',
	0x00A2: 'CLEAN',
	0x00A3: 'MDETERM',
	0x00A4: 'MINVERSE',
	0x00A5: 'MMULT',
	0x00A6: 'FILES',
	0x00A7: 'IPMT',
	0x00A8: 'PPMT',
	0x00A9: 'COUNTA',
	0x00AA: 'CANCEL.KEY',
	0x00AB: 'FOR',
	0x00AC: 'WHILE',
	0x00AD: 'BREAK',
	0x00AE: 'NEXT',
	0x00AF: 'INITIATE',
	0x00B0: 'REQUEST',
	0x00B1: 'POKE',
	0x00B2: 'EXECUTE',
	0x00B3: 'TERMINATE',
	0x00B4: 'RESTART',
	0x00B5: 'HELP',
	0x00B6: 'GET.BAR',
	0x00B7: 'PRODUCT',
	0x00B8: 'FACT',
	0x00B9: 'GET.CELL',
	0x00BA: 'GET.WORKSPACE',
	0x00BB: 'GET.WINDOW',
	0x00BC: 'GET.DOCUMENT',
	0x00BD: 'DPRODUCT',
	0x00BE: 'ISNONTEXT',
	0x00BF: 'GET.NOTE',
	0x00C0: 'NOTE',
	0x00C1: 'STDEVP',
	0x00C2: 'VARP',
	0x00C3: 'DSTDEVP',
	0x00C4: 'DVARP',
	0x00C5: 'TRUNC',
	0x00C6: 'ISLOGICAL',
	0x00C7: 'DCOUNTA',
	0x00C8: 'DELETE.BAR',
	0x00C9: 'UNREGISTER',
	0x00CC: 'USDOLLAR',
	0x00CD: 'FINDB',
	0x00CE: 'SEARCHB',
	0x00CF: 'REPLACEB',
	0x00D0: 'LEFTB',
	0x00D1: 'RIGHTB',
	0x00D2: 'MIDB',
	0x00D3: 'LENB',
	0x00D4: 'ROUNDUP',
	0x00D5: 'ROUNDDOWN',
	0x00D6: 'ASC',
	0x00D7: 'DBCS',
	0x00D8: 'RANK',
	0x00DB: 'ADDRESS',
	0x00DC: 'DAYS360',
	0x00DD: 'TODAY',
	0x00DE: 'VDB',
	0x00DF: 'ELSE',
	0x00E0: 'ELSE.IF',
	0x00E1: 'END.IF',
	0x00E2: 'FOR.CELL',
	0x00E3: 'MEDIAN',
	0x00E4: 'SUMPRODUCT',
	0x00E5: 'SINH',
	0x00E6: 'COSH',
	0x00E7: 'TANH',
	0x00E8: 'ASINH',
	0x00E9: 'ACOSH',
	0x00EA: 'ATANH',
	0x00EB: 'DGET',
	0x00EC: 'CREATE.OBJECT',
	0x00ED: 'VOLATILE',
	0x00EE: 'LAST.ERROR',
	0x00EF: 'CUSTOM.UNDO',
	0x00F0: 'CUSTOM.REPEAT',
	0x00F1: 'FORMULA.CONVERT',
	0x00F2: 'GET.LINK.INFO',
	0x00F3: 'TEXT.BOX',
	0x00F4: 'INFO',
	0x00F5: 'GROUP',
	0x00F6: 'GET.OBJECT',
	0x00F7: 'DB',
	0x00F8: 'PAUSE',
	0x00FB: 'RESUME',
	0x00FC: 'FREQUENCY',
	0x00FD: 'ADD.TOOLBAR',
	0x00FE: 'DELETE.TOOLBAR',
	0x00FF: 'User',
	0x0100: 'RESET.TOOLBAR',
	0x0101: 'EVALUATE',
	0x0102: 'GET.TOOLBAR',
	0x0103: 'GET.TOOL',
	0x0104: 'SPELLING.CHECK',
	0x0105: 'ERROR.TYPE',
	0x0106: 'APP.TITLE',
	0x0107: 'WINDOW.TITLE',
	0x0108: 'SAVE.TOOLBAR',
	0x0109: 'ENABLE.TOOL',
	0x010A: 'PRESS.TOOL',
	0x010B: 'REGISTER.ID',
	0x010C: 'GET.WORKBOOK',
	0x010D: 'AVEDEV',
	0x010E: 'BETADIST',
	0x010F: 'GAMMALN',
	0x0110: 'BETAINV',
	0x0111: 'BINOMDIST',
	0x0112: 'CHIDIST',
	0x0113: 'CHIINV',
	0x0114: 'COMBIN',
	0x0115: 'CONFIDENCE',
	0x0116: 'CRITBINOM',
	0x0117: 'EVEN',
	0x0118: 'EXPONDIST',
	0x0119: 'FDIST',
	0x011A: 'FINV',
	0x011B: 'FISHER',
	0x011C: 'FISHERINV',
	0x011D: 'FLOOR',
	0x011E: 'GAMMADIST',
	0x011F: 'GAMMAINV',
	0x0120: 'CEILING',
	0x0121: 'HYPGEOMDIST',
	0x0122: 'LOGNORMDIST',
	0x0123: 'LOGINV',
	0x0124: 'NEGBINOMDIST',
	0x0125: 'NORMDIST',
	0x0126: 'NORMSDIST',
	0x0127: 'NORMINV',
	0x0128: 'NORMSINV',
	0x0129: 'STANDARDIZE',
	0x012A: 'ODD',
	0x012B: 'PERMUT',
	0x012C: 'POISSON',
	0x012D: 'TDIST',
	0x012E: 'WEIBULL',
	0x012F: 'SUMXMY2',
	0x0130: 'SUMX2MY2',
	0x0131: 'SUMX2PY2',
	0x0132: 'CHITEST',
	0x0133: 'CORREL',
	0x0134: 'COVAR',
	0x0135: 'FORECAST',
	0x0136: 'FTEST',
	0x0137: 'INTERCEPT',
	0x0138: 'PEARSON',
	0x0139: 'RSQ',
	0x013A: 'STEYX',
	0x013B: 'SLOPE',
	0x013C: 'TTEST',
	0x013D: 'PROB',
	0x013E: 'DEVSQ',
	0x013F: 'GEOMEAN',
	0x0140: 'HARMEAN',
	0x0141: 'SUMSQ',
	0x0142: 'KURT',
	0x0143: 'SKEW',
	0x0144: 'ZTEST',
	0x0145: 'LARGE',
	0x0146: 'SMALL',
	0x0147: 'QUARTILE',
	0x0148: 'PERCENTILE',
	0x0149: 'PERCENTRANK',
	0x014A: 'MODE',
	0x014B: 'TRIMMEAN',
	0x014C: 'TINV',
	0x014E: 'MOVIE.COMMAND',
	0x014F: 'GET.MOVIE',
	0x0150: 'CONCATENATE',
	0x0151: 'POWER',
	0x0152: 'PIVOT.ADD.DATA',
	0x0153: 'GET.PIVOT.TABLE',
	0x0154: 'GET.PIVOT.FIELD',
	0x0155: 'GET.PIVOT.ITEM',
	0x0156: 'RADIANS',
	0x0157: 'DEGREES',
	0x0158: 'SUBTOTAL',
	0x0159: 'SUMIF',
	0x015A: 'COUNTIF',
	0x015B: 'COUNTBLANK',
	0x015C: 'SCENARIO.GET',
	0x015D: 'OPTIONS.LISTS.GET',
	0x015E: 'ISPMT',
	0x015F: 'DATEDIF',
	0x0160: 'DATESTRING',
	0x0161: 'NUMBERSTRING',
	0x0162: 'ROMAN',
	0x0163: 'OPEN.DIALOG',
	0x0164: 'SAVE.DIALOG',
	0x0165: 'VIEW.GET',
	0x0166: 'GETPIVOTDATA',
	0x0167: 'HYPERLINK',
	0x0168: 'PHONETIC',
	0x0169: 'AVERAGEA',
	0x016A: 'MAXA',
	0x016B: 'MINA',
	0x016C: 'STDEVPA',
	0x016D: 'VARPA',
	0x016E: 'STDEVA',
	0x016F: 'VARA',
	0x0170: 'BAHTTEXT',
	0x0171: 'THAIDAYOFWEEK',
	0x0172: 'THAIDIGIT',
	0x0173: 'THAIMONTHOFYEAR',
	0x0174: 'THAINUMSOUND',
	0x0175: 'THAINUMSTRING',
	0x0176: 'THAISTRINGLENGTH',
	0x0177: 'ISTHAIDIGIT',
	0x0178: 'ROUNDBAHTDOWN',
	0x0179: 'ROUNDBAHTUP',
	0x017A: 'THAIYEAR',
	0x017B: 'RTD',
	
	0x017C: 'CUBEVALUE',
	0x017D: 'CUBEMEMBER',
	0x017E: 'CUBEMEMBERPROPERTY',
	0x017F: 'CUBERANKEDMEMBER',
	0x0180: 'HEX2BIN',
	0x0181: 'HEX2DEC',
	0x0182: 'HEX2OCT',
	0x0183: 'DEC2BIN',
	0x0184: 'DEC2HEX',
	0x0185: 'DEC2OCT',
	0x0186: 'OCT2BIN',
	0x0187: 'OCT2HEX',
	0x0188: 'OCT2DEC',
	0x0189: 'BIN2DEC',
	0x018A: 'BIN2OCT',
	0x018B: 'BIN2HEX',
	0x018C: 'IMSUB',
	0x018D: 'IMDIV',
	0x018E: 'IMPOWER',
	0x018F: 'IMABS',
	0x0190: 'IMSQRT',
	0x0191: 'IMLN',
	0x0192: 'IMLOG2',
	0x0193: 'IMLOG10',
	0x0194: 'IMSIN',
	0x0195: 'IMCOS',
	0x0196: 'IMEXP',
	0x0197: 'IMARGUMENT',
	0x0198: 'IMCONJUGATE',
	0x0199: 'IMAGINARY',
	0x019A: 'IMREAL',
	0x019B: 'COMPLEX',
	0x019C: 'IMSUM',
	0x019D: 'IMPRODUCT',
	0x019E: 'SERIESSUM',
	0x019F: 'FACTDOUBLE',
	0x01A0: 'SQRTPI',
	0x01A1: 'QUOTIENT',
	0x01A2: 'DELTA',
	0x01A3: 'GESTEP',
	0x01A4: 'ISEVEN',
	0x01A5: 'ISODD',
	0x01A6: 'MROUND',
	0x01A7: 'ERF',
	0x01A8: 'ERFC',
	0x01A9: 'BESSELJ',
	0x01AA: 'BESSELK',
	0x01AB: 'BESSELY',
	0x01AC: 'BESSELI',
	0x01AD: 'XIRR',
	0x01AE: 'XNPV',
	0x01AF: 'PRICEMAT',
	0x01B0: 'YIELDMAT',
	0x01B1: 'INTRATE',
	0x01B2: 'RECEIVED',
	0x01B3: 'DISC',
	0x01B4: 'PRICEDISC',
	0x01B5: 'YIELDDISC',
	0x01B6: 'TBILLEQ',
	0x01B7: 'TBILLPRICE',
	0x01B8: 'TBILLYIELD',
	0x01B9: 'PRICE',
	0x01BA: 'YIELD',
	0x01BB: 'DOLLARDE',
	0x01BC: 'DOLLARFR',
	0x01BD: 'NOMINAL',
	0x01BE: 'EFFECT',
	0x01BF: 'CUMPRINC',
	0x01C0: 'CUMIPMT',
	0x01C1: 'EDATE',
	0x01C2: 'EOMONTH',
	0x01C3: 'YEARFRAC',
	0x01C4: 'COUPDAYBS',
	0x01C5: 'COUPDAYS',
	0x01C6: 'COUPDAYSNC',
	0x01C7: 'COUPNCD',
	0x01C8: 'COUPNUM',
	0x01C9: 'COUPPCD',
	0x01CA: 'DURATION',
	0x01CB: 'MDURATION',
	0x01CC: 'ODDLPRICE',
	0x01CD: 'ODDLYIELD',
	0x01CE: 'ODDFPRICE',
	0x01CF: 'ODDFYIELD',
	0x01D0: 'RANDBETWEEN',
	0x01D1: 'WEEKNUM',
	0x01D2: 'AMORDEGRC',
	0x01D3: 'AMORLINC',
	0x01D4: 'CONVERT',
	0x02D4: 'SHEETJS',
	0x01D5: 'ACCRINT',
	0x01D6: 'ACCRINTM',
	0x01D7: 'WORKDAY',
	0x01D8: 'NETWORKDAYS',
	0x01D9: 'GCD',
	0x01DA: 'MULTINOMIAL',
	0x01DB: 'LCM',
	0x01DC: 'FVSCHEDULE',
	0x01DD: 'CUBEKPIMEMBER',
	0x01DE: 'CUBESET',
	0x01DF: 'CUBESETCOUNT',
	0x01E0: 'IFERROR',
	0x01E1: 'COUNTIFS',
	0x01E2: 'SUMIFS',
	0x01E3: 'AVERAGEIF',
	0x01E4: 'AVERAGEIFS'
	};
	var FtabArgc = {
	0x0002: 1, /* ISNA */
	0x0003: 1, /* ISERROR */
	0x000A: 0, /* NA */
	0x000F: 1, /* SIN */
	0x0010: 1, /* COS */
	0x0011: 1, /* TAN */
	0x0012: 1, /* ATAN */
	0x0013: 0, /* PI */
	0x0014: 1, /* SQRT */
	0x0015: 1, /* EXP */
	0x0016: 1, /* LN */
	0x0017: 1, /* LOG10 */
	0x0018: 1, /* ABS */
	0x0019: 1, /* INT */
	0x001A: 1, /* SIGN */
	0x001B: 2, /* ROUND */
	0x001E: 2, /* REPT */
	0x001F: 3, /* MID */
	0x0020: 1, /* LEN */
	0x0021: 1, /* VALUE */
	0x0022: 0, /* TRUE */
	0x0023: 0, /* FALSE */
	0x0026: 1, /* NOT */
	0x0027: 2, /* MOD */
	0x0028: 3, /* DCOUNT */
	0x0029: 3, /* DSUM */
	0x002A: 3, /* DAVERAGE */
	0x002B: 3, /* DMIN */
	0x002C: 3, /* DMAX */
	0x002D: 3, /* DSTDEV */
	0x002F: 3, /* DVAR */
	0x0030: 2, /* TEXT */
	0x0035: 1, /* GOTO */
	0x003D: 3, /* MIRR */
	0x003F: 0, /* RAND */
	0x0041: 3, /* DATE */
	0x0042: 3, /* TIME */
	0x0043: 1, /* DAY */
	0x0044: 1, /* MONTH */
	0x0045: 1, /* YEAR */
	0x0046: 1, /* WEEKDAY */
	0x0047: 1, /* HOUR */
	0x0048: 1, /* MINUTE */
	0x0049: 1, /* SECOND */
	0x004A: 0, /* NOW */
	0x004B: 1, /* AREAS */
	0x004C: 1, /* ROWS */
	0x004D: 1, /* COLUMNS */
	0x004F: 2, /* ABSREF */
	0x0050: 2, /* RELREF */
	0x0053: 1, /* TRANSPOSE */
	0x0055: 0, /* STEP */
	0x0056: 1, /* TYPE */
	0x0059: 0, /* CALLER */
	0x005A: 1, /* DEREF */
	0x005E: 0, /* ACTIVE.CELL */
	0x005F: 0, /* SELECTION */
	0x0061: 2, /* ATAN2 */
	0x0062: 1, /* ASIN */
	0x0063: 1, /* ACOS */
	0x0065: 3, /* HLOOKUP */
	0x0066: 3, /* VLOOKUP */
	0x0069: 1, /* ISREF */
	0x006A: 1, /* GET.FORMULA */
	0x006C: 2, /* SET.VALUE */
	0x006F: 1, /* CHAR */
	0x0070: 1, /* LOWER */
	0x0071: 1, /* UPPER */
	0x0072: 1, /* PROPER */
	0x0075: 2, /* EXACT */
	0x0076: 1, /* TRIM */
	0x0077: 4, /* REPLACE */
	0x0079: 1, /* CODE */
	0x007E: 1, /* ISERR */
	0x007F: 1, /* ISTEXT */
	0x0080: 1, /* ISNUMBER */
	0x0081: 1, /* ISBLANK */
	0x0082: 1, /* T */
	0x0083: 1, /* N */
	0x0085: 1, /* FCLOSE */
	0x0086: 1, /* FSIZE */
	0x0087: 1, /* FREADLN */
	0x0088: 2, /* FREAD */
	0x0089: 2, /* FWRITELN */
	0x008A: 2, /* FWRITE */
	0x008C: 1, /* DATEVALUE */
	0x008D: 1, /* TIMEVALUE */
	0x008E: 3, /* SLN */
	0x008F: 4, /* SYD */
	0x0090: 4, /* DDB */
	0x00A1: 1, /* DIALOG.BOX */
	0x00A2: 1, /* CLEAN */
	0x00A3: 1, /* MDETERM */
	0x00A4: 1, /* MINVERSE */
	0x00A5: 2, /* MMULT */
	0x00AC: 1, /* WHILE */
	0x00AF: 2, /* INITIATE */
	0x00B0: 2, /* REQUEST */
	0x00B1: 3, /* POKE */
	0x00B2: 2, /* EXECUTE */
	0x00B3: 1, /* TERMINATE */
	0x00B8: 1, /* FACT */
	0x00BA: 1, /* GET.WORKSPACE */
	0x00BD: 3, /* DPRODUCT */
	0x00BE: 1, /* ISNONTEXT */
	0x00C3: 3, /* DSTDEVP */
	0x00C4: 3, /* DVARP */
	0x00C5: 1, /* TRUNC */
	0x00C6: 1, /* ISLOGICAL */
	0x00C7: 3, /* DCOUNTA */
	0x00C9: 1, /* UNREGISTER */
	0x00CF: 4, /* REPLACEB */
	0x00D2: 3, /* MIDB */
	0x00D3: 1, /* LENB */
	0x00D4: 2, /* ROUNDUP */
	0x00D5: 2, /* ROUNDDOWN */
	0x00D6: 1, /* ASC */
	0x00D7: 1, /* DBCS */
	0x00E1: 0, /* END.IF */
	0x00E5: 1, /* SINH */
	0x00E6: 1, /* COSH */
	0x00E7: 1, /* TANH */
	0x00E8: 1, /* ASINH */
	0x00E9: 1, /* ACOSH */
	0x00EA: 1, /* ATANH */
	0x00EB: 3, /* DGET */
	0x00F4: 1, /* INFO */
	0x00F7: 4, /* DB */
	0x00FC: 2, /* FREQUENCY */
	0x0101: 1, /* EVALUATE */
	0x0105: 1, /* ERROR.TYPE */
	0x010F: 1, /* GAMMALN */
	0x0111: 4, /* BINOMDIST */
	0x0112: 2, /* CHIDIST */
	0x0113: 2, /* CHIINV */
	0x0114: 2, /* COMBIN */
	0x0115: 3, /* CONFIDENCE */
	0x0116: 3, /* CRITBINOM */
	0x0117: 1, /* EVEN */
	0x0118: 3, /* EXPONDIST */
	0x0119: 3, /* FDIST */
	0x011A: 3, /* FINV */
	0x011B: 1, /* FISHER */
	0x011C: 1, /* FISHERINV */
	0x011D: 2, /* FLOOR */
	0x011E: 4, /* GAMMADIST */
	0x011F: 3, /* GAMMAINV */
	0x0120: 2, /* CEILING */
	0x0121: 4, /* HYPGEOMDIST */
	0x0122: 3, /* LOGNORMDIST */
	0x0123: 3, /* LOGINV */
	0x0124: 3, /* NEGBINOMDIST */
	0x0125: 4, /* NORMDIST */
	0x0126: 1, /* NORMSDIST */
	0x0127: 3, /* NORMINV */
	0x0128: 1, /* NORMSINV */
	0x0129: 3, /* STANDARDIZE */
	0x012A: 1, /* ODD */
	0x012B: 2, /* PERMUT */
	0x012C: 3, /* POISSON */
	0x012D: 3, /* TDIST */
	0x012E: 4, /* WEIBULL */
	0x012F: 2, /* SUMXMY2 */
	0x0130: 2, /* SUMX2MY2 */
	0x0131: 2, /* SUMX2PY2 */
	0x0132: 2, /* CHITEST */
	0x0133: 2, /* CORREL */
	0x0134: 2, /* COVAR */
	0x0135: 3, /* FORECAST */
	0x0136: 2, /* FTEST */
	0x0137: 2, /* INTERCEPT */
	0x0138: 2, /* PEARSON */
	0x0139: 2, /* RSQ */
	0x013A: 2, /* STEYX */
	0x013B: 2, /* SLOPE */
	0x013C: 4, /* TTEST */
	0x0145: 2, /* LARGE */
	0x0146: 2, /* SMALL */
	0x0147: 2, /* QUARTILE */
	0x0148: 2, /* PERCENTILE */
	0x014B: 2, /* TRIMMEAN */
	0x014C: 2, /* TINV */
	0x0151: 2, /* POWER */
	0x0156: 1, /* RADIANS */
	0x0157: 1, /* DEGREES */
	0x015A: 2, /* COUNTIF */
	0x015B: 1, /* COUNTBLANK */
	0x015E: 4, /* ISPMT */
	0x015F: 3, /* DATEDIF */
	0x0160: 1, /* DATESTRING */
	0x0161: 2, /* NUMBERSTRING */
	0x0168: 1, /* PHONETIC */
	0x0170: 1, /* BAHTTEXT */
	0x0171: 1, /* THAIDAYOFWEEK */
	0x0172: 1, /* THAIDIGIT */
	0x0173: 1, /* THAIMONTHOFYEAR */
	0x0174: 1, /* THAINUMSOUND */
	0x0175: 1, /* THAINUMSTRING */
	0x0176: 1, /* THAISTRINGLENGTH */
	0x0177: 1, /* ISTHAIDIGIT */
	0x0178: 1, /* ROUNDBAHTDOWN */
	0x0179: 1, /* ROUNDBAHTUP */
	0x017A: 1, /* THAIYEAR */
	0x017E: 3, /* CUBEMEMBERPROPERTY */
	0x0181: 1, /* HEX2DEC */
	0x0188: 1, /* OCT2DEC */
	0x0189: 1, /* BIN2DEC */
	0x018C: 2, /* IMSUB */
	0x018D: 2, /* IMDIV */
	0x018E: 2, /* IMPOWER */
	0x018F: 1, /* IMABS */
	0x0190: 1, /* IMSQRT */
	0x0191: 1, /* IMLN */
	0x0192: 1, /* IMLOG2 */
	0x0193: 1, /* IMLOG10 */
	0x0194: 1, /* IMSIN */
	0x0195: 1, /* IMCOS */
	0x0196: 1, /* IMEXP */
	0x0197: 1, /* IMARGUMENT */
	0x0198: 1, /* IMCONJUGATE */
	0x0199: 1, /* IMAGINARY */
	0x019A: 1, /* IMREAL */
	0x019E: 4, /* SERIESSUM */
	0x019F: 1, /* FACTDOUBLE */
	0x01A0: 1, /* SQRTPI */
	0x01A1: 2, /* QUOTIENT */
	0x01A4: 1, /* ISEVEN */
	0x01A5: 1, /* ISODD */
	0x01A6: 2, /* MROUND */
	0x01A8: 1, /* ERFC */
	0x01A9: 2, /* BESSELJ */
	0x01AA: 2, /* BESSELK */
	0x01AB: 2, /* BESSELY */
	0x01AC: 2, /* BESSELI */
	0x01AE: 3, /* XNPV */
	0x01B6: 3, /* TBILLEQ */
	0x01B7: 3, /* TBILLPRICE */
	0x01B8: 3, /* TBILLYIELD */
	0x01BB: 2, /* DOLLARDE */
	0x01BC: 2, /* DOLLARFR */
	0x01BD: 2, /* NOMINAL */
	0x01BE: 2, /* EFFECT */
	0x01BF: 6, /* CUMPRINC */
	0x01C0: 6, /* CUMIPMT */
	0x01C1: 2, /* EDATE */
	0x01C2: 2, /* EOMONTH */
	0x01D0: 2, /* RANDBETWEEN */
	0x01D4: 3, /* CONVERT */
	0x01DC: 2, /* FVSCHEDULE */
	0x01DF: 1, /* CUBESETCOUNT */
	0x01E0: 2, /* IFERROR */
	0xFFFF: 0
	};
	/* [MS-XLSX] 2.2.3 Functions */
	/* [MS-XLSB] 2.5.97.10 Ftab */
	var XLSXFutureFunctions = {
		"_xlfn.ACOT": "ACOT",
		"_xlfn.ACOTH": "ACOTH",
		"_xlfn.AGGREGATE": "AGGREGATE",
		"_xlfn.ARABIC": "ARABIC",
		"_xlfn.AVERAGEIF": "AVERAGEIF",
		"_xlfn.AVERAGEIFS": "AVERAGEIFS",
		"_xlfn.BASE": "BASE",
		"_xlfn.BETA.DIST": "BETA.DIST",
		"_xlfn.BETA.INV": "BETA.INV",
		"_xlfn.BINOM.DIST": "BINOM.DIST",
		"_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
		"_xlfn.BINOM.INV": "BINOM.INV",
		"_xlfn.BITAND": "BITAND",
		"_xlfn.BITLSHIFT": "BITLSHIFT",
		"_xlfn.BITOR": "BITOR",
		"_xlfn.BITRSHIFT": "BITRSHIFT",
		"_xlfn.BITXOR": "BITXOR",
		"_xlfn.CEILING.MATH": "CEILING.MATH",
		"_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
		"_xlfn.CHISQ.DIST": "CHISQ.DIST",
		"_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
		"_xlfn.CHISQ.INV": "CHISQ.INV",
		"_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
		"_xlfn.CHISQ.TEST": "CHISQ.TEST",
		"_xlfn.COMBINA": "COMBINA",
		"_xlfn.CONCAT": "CONCAT",
		"_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
		"_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
		"_xlfn.COT": "COT",
		"_xlfn.COTH": "COTH",
		"_xlfn.COUNTIFS": "COUNTIFS",
		"_xlfn.COVARIANCE.P": "COVARIANCE.P",
		"_xlfn.COVARIANCE.S": "COVARIANCE.S",
		"_xlfn.CSC": "CSC",
		"_xlfn.CSCH": "CSCH",
		"_xlfn.DAYS": "DAYS",
		"_xlfn.DECIMAL": "DECIMAL",
		"_xlfn.ECMA.CEILING": "ECMA.CEILING",
		"_xlfn.ERF.PRECISE": "ERF.PRECISE",
		"_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
		"_xlfn.EXPON.DIST": "EXPON.DIST",
		"_xlfn.F.DIST": "F.DIST",
		"_xlfn.F.DIST.RT": "F.DIST.RT",
		"_xlfn.F.INV": "F.INV",
		"_xlfn.F.INV.RT": "F.INV.RT",
		"_xlfn.F.TEST": "F.TEST",
		"_xlfn.FILTERXML": "FILTERXML",
		"_xlfn.FLOOR.MATH": "FLOOR.MATH",
		"_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
		"_xlfn.FORECAST.ETS": "FORECAST.ETS",
		"_xlfn.FORECAST.ETS.CONFINT": "FORECAST.ETS.CONFINT",
		"_xlfn.FORECAST.ETS.SEASONALITY": "FORECAST.ETS.SEASONALITY",
		"_xlfn.FORECAST.ETS.STAT": "FORECAST.ETS.STAT",
		"_xlfn.FORECAST.LINEAR": "FORECAST.LINEAR",
		"_xlfn.FORMULATEXT": "FORMULATEXT",
		"_xlfn.GAMMA": "GAMMA",
		"_xlfn.GAMMA.DIST": "GAMMA.DIST",
		"_xlfn.GAMMA.INV": "GAMMA.INV",
		"_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
		"_xlfn.GAUSS": "GAUSS",
		"_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
		"_xlfn.IFERROR": "IFERROR",
		"_xlfn.IFNA": "IFNA",
		"_xlfn.IFS": "IFS",
		"_xlfn.IMCOSH": "IMCOSH",
		"_xlfn.IMCOT": "IMCOT",
		"_xlfn.IMCSC": "IMCSC",
		"_xlfn.IMCSCH": "IMCSCH",
		"_xlfn.IMSEC": "IMSEC",
		"_xlfn.IMSECH": "IMSECH",
		"_xlfn.IMSINH": "IMSINH",
		"_xlfn.IMTAN": "IMTAN",
		"_xlfn.ISFORMULA": "ISFORMULA",
		"_xlfn.ISO.CEILING": "ISO.CEILING",
		"_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
		"_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
		"_xlfn.LOGNORM.INV": "LOGNORM.INV",
		"_xlfn.MAXIFS": "MAXIFS",
		"_xlfn.MINIFS": "MINIFS",
		"_xlfn.MODE.MULT": "MODE.MULT",
		"_xlfn.MODE.SNGL": "MODE.SNGL",
		"_xlfn.MUNIT": "MUNIT",
		"_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
		"_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
		"_xlfn.NIGBINOM": "NIGBINOM",
		"_xlfn.NORM.DIST": "NORM.DIST",
		"_xlfn.NORM.INV": "NORM.INV",
		"_xlfn.NORM.S.DIST": "NORM.S.DIST",
		"_xlfn.NORM.S.INV": "NORM.S.INV",
		"_xlfn.NUMBERVALUE": "NUMBERVALUE",
		"_xlfn.PDURATION": "PDURATION",
		"_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
		"_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
		"_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
		"_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
		"_xlfn.PERMUTATIONA": "PERMUTATIONA",
		"_xlfn.PHI": "PHI",
		"_xlfn.POISSON.DIST": "POISSON.DIST",
		"_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
		"_xlfn.QUARTILE.INC": "QUARTILE.INC",
		"_xlfn.QUERYSTRING": "QUERYSTRING",
		"_xlfn.RANK.AVG": "RANK.AVG",
		"_xlfn.RANK.EQ": "RANK.EQ",
		"_xlfn.RRI": "RRI",
		"_xlfn.SEC": "SEC",
		"_xlfn.SECH": "SECH",
		"_xlfn.SHEET": "SHEET",
		"_xlfn.SHEETS": "SHEETS",
		"_xlfn.SKEW.P": "SKEW.P",
		"_xlfn.STDEV.P": "STDEV.P",
		"_xlfn.STDEV.S": "STDEV.S",
		"_xlfn.SUMIFS": "SUMIFS",
		"_xlfn.SWITCH": "SWITCH",
		"_xlfn.T.DIST": "T.DIST",
		"_xlfn.T.DIST.2T": "T.DIST.2T",
		"_xlfn.T.DIST.RT": "T.DIST.RT",
		"_xlfn.T.INV": "T.INV",
		"_xlfn.T.INV.2T": "T.INV.2T",
		"_xlfn.T.TEST": "T.TEST",
		"_xlfn.TEXTJOIN": "TEXTJOIN",
		"_xlfn.UNICHAR": "UNICHAR",
		"_xlfn.UNICODE": "UNICODE",
		"_xlfn.VAR.P": "VAR.P",
		"_xlfn.VAR.S": "VAR.S",
		"_xlfn.WEBSERVICE": "WEBSERVICE",
		"_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
		"_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
		"_xlfn.XOR": "XOR",
		"_xlfn.Z.TEST": "Z.TEST"
	};
	
	/* Part 3 TODO: actually parse formulae */
	function ods_to_csf_formula(f) {
		if(f.slice(0,3) == "of:") f = f.slice(3);
		/* 5.2 Basic Expressions */
		if(f.charCodeAt(0) == 61) {
			f = f.slice(1);
			if(f.charCodeAt(0) == 61) f = f.slice(1);
		}
		f = f.replace(/COM\.MICROSOFT\./g, "");
		/* Part 3 Section 5.8 References */
		f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
		/* TODO: something other than this */
		f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
		return f.replace(/[;~]/g,",").replace(/\|/g,";");
	}
	
	function csf_to_ods_formula(f) {
		var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
		/* TODO: something other than this */
		return o.replace(/;/g, "|").replace(/,/g,";");
	}
	
	function ods_to_csf_3D(r) {
		var a = r.split(":");
		var s = a[0].split(".")[0];
		return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
	}
	
	function csf_to_ods_3D(r) {
		return r.replace(/\./,"!");
	}
	
	var strs = {}; // shared strings
	var _ssfopts = {}; // spreadsheet formatting options
	
	RELS.WS = [
		"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
		"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
	];
	
	/*global Map */
	var browser_has_Map = typeof Map !== 'undefined';
	
	function get_sst_id(sst, str, rev) {
		var i = 0, len = sst.length;
		if(rev) {
			if(browser_has_Map ? rev.has(str) : rev.hasOwnProperty(str)) {
				var revarr = browser_has_Map ? rev.get(str) : rev[str];
				for(; i < revarr.length; ++i) {
					if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
				}
			}
		} else for(; i < len; ++i) {
			if(sst[i].t === str) { sst.Count ++; return i; }
		}
		sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
		if(rev) {
			if(browser_has_Map) {
				if(!rev.has(str)) rev.set(str, []);
				rev.get(str).push(len);
			} else {
				if(!rev.hasOwnProperty(str)) rev[str] = [];
				rev[str].push(len);
			}
		}
		return len;
	}
	
	function col_obj_w(C, col) {
		var p = ({min:C+1,max:C+1});
		/* wch (chars), wpx (pixels) */
		var wch = -1;
		if(col.MDW) MDW = col.MDW;
		if(col.width != null) p.customWidth = 1;
		else if(col.wpx != null) wch = px2char(col.wpx);
		else if(col.wch != null) wch = col.wch;
		if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
		else if(col.width != null) p.width = col.width;
		if(col.hidden) p.hidden = true;
		return p;
	}
	
	function default_margins(margins, mode) {
		if(!margins) return;
		var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
		if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
		if(margins.left   == null) margins.left   = defs[0];
		if(margins.right  == null) margins.right  = defs[1];
		if(margins.top    == null) margins.top    = defs[2];
		if(margins.bottom == null) margins.bottom = defs[3];
		if(margins.header == null) margins.header = defs[4];
		if(margins.footer == null) margins.footer = defs[5];
	}
	
	function get_cell_style(styles, cell, opts) {
		var z = opts.revssf[cell.z != null ? cell.z : "General"];
		var i = 0x3c, len = styles.length;
		if(z == null && opts.ssf) {
			for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
				SSF.load(cell.z, i);
				// $FlowIgnore
				opts.ssf[i] = cell.z;
				opts.revssf[cell.z] = z = i;
				break;
			}
		}
		for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
		styles[len] = {
			numFmtId:z,
			fontId:0,
			fillId:0,
			borderId:0,
			xfId:0,
			applyNumberFormat:1
		};
		return len;
	}
	
	function safe_format(p, fmtid, fillid, opts, themes, styles) {
		try {
			if(opts.cellNF) p.z = SSF._table[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(p.t === 'z') return;
		if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
		if(!opts || opts.cellText !== false) try {
			if(SSF._table[fmtid] == null) SSF.load(SSFImplicit[fmtid] || "General", fmtid);
			if(p.t === 'e') p.w = p.w || BErr[p.v];
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
					else p.w = SSF._general_num(p.v);
				}
				else if(p.t === 'd') {
					var dd = datenum(p.v);
					if((dd|0) === dd) p.w = SSF._general_int(dd);
					else p.w = SSF._general_num(dd);
				}
				else if(p.v === undefined) return "";
				else p.w = SSF._general(p.v,_ssfopts);
			}
			else if(p.t === 'd') p.w = SSF.format(fmtid,datenum(p.v),_ssfopts);
			else p.w = SSF.format(fmtid,p.v,_ssfopts);
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts.cellStyles) return;
		if(fillid != null) try {
			p.s = styles.Fills[fillid];
			if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
				p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
				if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
			}
			if (p.s.bgColor && p.s.bgColor.theme) {
				p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
				if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
			}
		} catch(e) { if(opts.WTF && styles.Fills) throw e; }
	}
	
	function check_ws(ws, sname, i) {
		if(ws && ws['!ref']) {
			var range = safe_decode_range(ws['!ref']);
			if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
		}
	}
	function parse_ws_xml_dim(ws, s) {
		var d = safe_decode_range(s);
		if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
	}
	var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
	var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
	var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
	var dimregex = /"(\w*:\w*)"/;
	var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
	var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
	var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
	var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
	var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
	
	/* 18.3 Worksheets */
	function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	
		/* 18.3.1.99 worksheet CT_Worksheet */
		var s = opts.dense ? ([]) : ({});
		var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });
	
		var data1 = "", data2 = "";
		var mtch = data.match(sheetdataregex);
		if(mtch) {
			data1 = data.slice(0, mtch.index);
			data2 = data.slice(mtch.index + mtch[0].length);
		} else data1 = data2 = data;
	
		/* 18.3.1.82 sheetPr CT_SheetPr */
		var sheetPr = data1.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.35 dimension CT_SheetDimension */
		var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
		if(ridx > 0) {
			var ref = data1.slice(ridx,ridx+50).match(dimregex);
			if(ref) parse_ws_xml_dim(s, ref[1]);
		}
	
		/* 18.3.1.88 sheetViews CT_SheetViews */
		var svs = data1.match(svsregex);
		if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
	
		/* 18.3.1.17 cols CT_Cols */
		var columns = [];
		if(opts.cellStyles) {
			/* 18.3.1.13 col CT_Col */
			var cols = data1.match(colregex);
			if(cols) parse_ws_xml_cols(columns, cols);
		}
	
		/* 18.3.1.80 sheetData CT_SheetData ? */
		if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
	
		/* 18.3.1.2  autoFilter CT_AutoFilter */
		var afilter = data2.match(afregex);
		if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);
	
		/* 18.3.1.55 mergeCells CT_MergeCells */
		var merges = [];
		var _merge = data2.match(mergecregex);
		if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
			merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));
	
		/* 18.3.1.48 hyperlinks CT_Hyperlinks */
		var hlink = data2.match(hlinkregex);
		if(hlink) parse_ws_xml_hlinks(s, hlink, rels);
	
		/* 18.3.1.62 pageMargins CT_PageMargins */
		var margins = data2.match(marginregex);
		if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));
	
		if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
		if(opts.sheetRows > 0 && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(columns.length > 0) s["!cols"] = columns;
		if(merges.length > 0) s["!merges"] = merges;
		return s;
	}
	
	function write_ws_xml_merges(merges) {
		if(merges.length === 0) return "";
		var o = '<mergeCells count="' + merges.length + '">';
		for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
		return o + '</mergeCells>';
	}
	
	/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
	function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
		var data = parsexmltag(sheetPr);
		if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
		if(data.codeName) wb.Sheets[idx].CodeName = data.codeName;
	}
	function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
		var needed = false;
		var props = {}, payload = null;
		if(opts.bookType !== 'xlsx' && wb.vbaraw) {
			var cname = wb.SheetNames[idx];
			try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
			needed = true;
			props.codeName = escapexml(cname);
		}
	
		if(!needed && !payload) return;
		o[o.length] = (writextag('sheetPr', payload, props));
	}
	
	/* 18.3.1.85 sheetProtection CT_SheetProtection */
	var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var sheetprot_deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	function write_ws_xml_protection(sp) {
		// algorithmName, hashValue, saltValue, spinCountpassword
		var o = ({sheet:1});
		sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
		sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
		/* TODO: algorithm */
		if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
		return writextag('sheetProtection', null, o);
	}
	
	function parse_ws_xml_hlinks(s, data, rels) {
		var dense = Array.isArray(s);
		for(var i = 0; i != data.length; ++i) {
			var val = parsexmltag(utf8read(data[i]), true);
			if(!val.ref) return;
			var rel = ((rels || {})['!id']||[])[val.id];
			if(rel) {
				val.Target = rel.Target;
				if(val.location) val.Target += "#"+val.location;
			} else {
				val.Target = "#" + val.location;
				rel = {Target: val.Target, TargetMode: 'Internal'};
			}
			val.Rel = rel;
			if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
			var rng = safe_decode_range(val.ref);
			for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
				var addr = encode_cell({c:C,r:R});
				if(dense) {
					if(!s[R]) s[R] = [];
					if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
					s[R][C].l = val;
				} else {
					if(!s[addr]) s[addr] = {t:"z",v:undefined};
					s[addr].l = val;
				}
			}
		}
	}
	
	function parse_ws_xml_margins(margin) {
		var o = {};
		["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
			if(margin[k]) o[k] = parseFloat(margin[k]);
		});
		return o;
	}
	function write_ws_xml_margins(margin) {
		default_margins(margin);
		return writextag('pageMargins', null, margin);
	}
	
	function parse_ws_xml_cols(columns, cols) {
		var seencol = false;
		for(var coli = 0; coli != cols.length; ++coli) {
			var coll = parsexmltag(cols[coli], true);
			if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
			var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
			delete coll.min; delete coll.max; coll.width = +coll.width;
			if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
			process_col(coll);
			while(colm <= colM) columns[colm++] = dup(coll);
		}
	}
	function write_ws_xml_cols(ws, cols) {
		var o = ["<cols>"], col;
		for(var i = 0; i != cols.length; ++i) {
			if(!(col = cols[i])) continue;
			o[o.length] = (writextag('col', null, col_obj_w(i, col)));
		}
		o[o.length] = "</cols>";
		return o.join("");
	}
	
	function parse_ws_xml_autofilter(data) {
		var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
		return o;
	}
	function write_ws_xml_autofilter(data, ws, wb, idx) {
		var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
		return writextag("autoFilter", null, {ref:ref});
	}
	
	/* 18.3.1.88 sheetViews CT_SheetViews */
	/* 18.3.1.87 sheetView CT_SheetView */
	var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
	function parse_ws_xml_sheetviews(data, wb) {
		if(!wb.Views) wb.Views = [{}];
		(data.match(sviewregex)||[]).forEach(function(r, i) {
			var tag = parsexmltag(r);
			// $FlowIgnore
			if(!wb.Views[i]) wb.Views[i] = {};
			// $FlowIgnore
			if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
		});
	}
	function write_ws_xml_sheetviews(ws, opts, idx, wb) {
		var sview = ({workbookViewId:"0"});
		// $FlowIgnore
		if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
		return writextag("sheetViews", writextag("sheetView", null, sview), {});
	}
	
	function write_ws_xml_cell(cell, ref, ws, opts) {
		if(cell.v === undefined && cell.f === undefined || cell.t === 'z') return "";
		var vv = "";
		var oldt = cell.t, oldv = cell.v;
		if(cell.t !== "z") switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'n': vv = ''+cell.v; break;
			case 'e': vv = BErr[cell.v]; break;
			case 'd':
				if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
				else {
					cell = dup(cell);
					cell.t = 'n';
					vv = ''+(cell.v = datenum(parseDate(cell.v)));
				}
				if(typeof cell.z === 'undefined') cell.z = SSF._table[14];
				break;
			default: vv = cell.v; break;
		}
		var v = writetag('v', escapexml(vv)), o = ({r:ref});
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		if(os !== 0) o.s = os;
		switch(cell.t) {
			case 'n': break;
			case 'd': o.t = "d"; break;
			case 'b': o.t = "b"; break;
			case 'e': o.t = "e"; break;
			case 'z': break;
			default: if(cell.v == null) { delete cell.t; break; }
				if(opts && opts.bookSST) {
					v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
					o.t = "s"; break;
				}
				o.t = "str"; break;
		}
		if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
		if(cell.f) {
			var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
			v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
		}
		if(cell.l) ws['!links'].push([ref, cell.l]);
		if(cell.c) ws['!comments'].push([ref, cell.c]);
		return writextag('c', v, o);
	}
	
	var parse_ws_xml_data = (function() {
		var cellregex = /<(?:\w+:)?c[ >]/, rowregex = /<\/(?:\w+:)?row>/;
		var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
		var refregex = /ref=["']([^"']*)["']/;
		var match_v = matchtag("v"), match_f = matchtag("f");
	
	return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
		var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
		var tag, tagr = 0, tagc = 0;
		var sstr, ftag;
		var fmtid = 0, fillid = 0;
		var do_format = Array.isArray(styles.CellXf), cf;
		var arrayf = [];
		var sharedf = [];
		var dense = Array.isArray(s);
		var rows = [], rowobj = {}, rowrite = false;
		for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
			x = marr[mt].trim();
			var xlen = x.length;
			if(xlen === 0) continue;
	
			/* 18.3.1.73 row CT_Row */
			for(ri = 0; ri < xlen; ++ri) if(x.charCodeAt(ri) === 62) break; ++ri;
			tag = parsexmltag(x.slice(0,ri), true);
			tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
			if(opts.sheetRows && opts.sheetRows < tagr) continue;
			if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
			if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;
	
			if(opts && opts.cellStyles) {
				rowobj = {}; rowrite = false;
				if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
				if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
				if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
				if(rowrite) rows[tagr-1] = rowobj;
			}
	
			/* 18.3.1.4 c CT_Cell */
			cells = x.slice(ri).split(cellregex);
			for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
			cells = cells.slice(rslice);
			for(ri = 0; ri != cells.length; ++ri) {
				x = cells[ri].trim();
				if(x.length === 0) continue;
				cref = x.match(rregex); idx = ri; i=0; cc=0;
				x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
				if(cref != null && cref.length === 2) {
					idx = 0; d=cref[1];
					for(i=0; i != d.length; ++i) {
						if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
						idx = 26*idx + cc;
					}
					--idx;
					tagc = idx;
				} else ++tagc;
				for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
				tag = parsexmltag(x.slice(0,i), true);
				if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
				d = x.slice(i);
				p = ({t:""});
	
				if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
				if(opts.cellFormula) {
					if((cref=d.match(match_f))!= null && cref[1] !== '') {
						/* TODO: match against XLSXFutureFunctions */
						p.f=_xlfn(unescapexml(utf8read(cref[1])));
						if(cref[0].indexOf('t="array"') > -1) {
							p.F = (d.match(refregex)||[])[1];
							if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
						} else if(cref[0].indexOf('t="shared"') > -1) {
							// TODO: parse formula
							ftag = parsexmltag(cref[0]);
							sharedf[parseInt(ftag.si, 10)] = [ftag, _xlfn(unescapexml(utf8read(cref[1]))), tag.r];
						}
					} else if((cref=d.match(/<f[^>]*\/>/))) {
						ftag = parsexmltag(cref[0]);
						if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
					}
					/* TODO: factor out contains logic */
					var _tag = decode_cell(tag.r);
					for(i = 0; i < arrayf.length; ++i)
						if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
							if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
								p.F = arrayf[i][1];
				}
	
				if(tag.t == null && p.v === undefined) {
					if(p.f || p.F) {
						p.v = 0; p.t = "n";
					} else if(!opts.sheetStubs) continue;
					else p.t = "z";
				}
				else p.t = tag.t || "n";
				if(guess.s.c > tagc) guess.s.c = tagc;
				if(guess.e.c < tagc) guess.e.c = tagc;
				/* 18.18.11 t ST_CellType */
				switch(p.t) {
					case 'n':
						if(p.v == "" || p.v == null) {
							if(!opts.sheetStubs) continue;
							p.t = 'z';
						} else p.v = parseFloat(p.v);
						break;
					case 's':
						if(typeof p.v == 'undefined') {
							if(!opts.sheetStubs) continue;
							p.t = 'z';
						} else {
							sstr = strs[parseInt(p.v, 10)];
							p.v = sstr.t;
							p.r = sstr.r;
							if(opts.cellHTML) p.h = sstr.h;
						}
						break;
					case 'str':
						p.t = "s";
						p.v = (p.v!=null) ? utf8read(p.v) : '';
						if(opts.cellHTML) p.h = escapehtml(p.v);
						break;
					case 'inlineStr':
						cref = d.match(isregex);
						p.t = 's';
						if(cref != null && (sstr = parse_si(cref[1]))) {
							p.v = sstr.t;
							if(opts.cellHTML) p.h = sstr.h;
						} else p.v = "";
						break;
					case 'b': p.v = parsexmlbool(p.v); break;
					case 'd':
						if(opts.cellDates) p.v = parseDate(p.v, 1);
						else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
						break;
					/* error string in .w, number in .v */
					case 'e':
						if(!opts || opts.cellText !== false) p.w = p.v;
						p.v = RBErr[p.v]; break;
				}
				/* formatting */
				fmtid = fillid = 0;
				cf = null;
				if(do_format && tag.s !== undefined) {
					cf = styles.CellXf[tag.s];
					if(cf != null) {
						if(cf.numFmtId != null) fmtid = cf.numFmtId;
						if(opts.cellStyles) {
							if(cf.fillId != null) fillid = cf.fillId;
						}
					}
				}
				safe_format(p, fmtid, fillid, opts, themes, styles);
				if(opts.cellDates && do_format && p.t == 'n' && SSF.is_date(SSF._table[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
				if(dense) {
					var _r = decode_cell(tag.r);
					if(!s[_r.r]) s[_r.r] = [];
					s[_r.r][_r.c] = p;
				} else s[tag.r] = p;
			}
		}
		if(rows.length > 0) s['!rows'] = rows;
	}; })();
	
	function write_ws_xml_data(ws, opts, idx, wb) {
		var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
		var dense = Array.isArray(ws);
		var params = ({r:rr}), row, height = -1;
		for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
		for(R = range.s.r; R <= range.e.r; ++R) {
			r = [];
			rr = encode_row(R);
			for(C = range.s.c; C <= range.e.c; ++C) {
				ref = cols[C] + rr;
				var _cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(_cell === undefined) continue;
				if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
			}
			if(r.length > 0 || (rows && rows[R])) {
				params = ({r:rr});
				if(rows && rows[R]) {
					row = rows[R];
					if(row.hidden) params.hidden = 1;
					height = -1;
					if(row.hpx) height = px2pt(row.hpx);
					else if(row.hpt) height = row.hpt;
					if(height > -1) { params.ht = height; params.customHeight = 1; }
					if(row.level) { params.outlineLevel = row.level; }
				}
				o[o.length] = (writextag('row', r.join(""), params));
			}
		}
		if(rows) for(; R < rows.length; ++R) {
			if(rows && rows[R]) {
				params = ({r:R+1});
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
				o[o.length] = (writextag('row', "", params));
			}
		}
		return o.join("");
	}
	
	var WS_XML_ROOT = writextag('worksheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	function write_ws_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, WS_XML_ROOT];
		var s = wb.SheetNames[idx], sidx = 0, rdata = "";
		var ws = wb.Sheets[s];
		if(ws == null) ws = {};
		var ref = ws['!ref'] || 'A1';
		var range = safe_decode_range(ref);
		if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
			range.e.c = Math.min(range.e.c, 0x3FFF);
			range.e.r = Math.min(range.e.c, 0xFFFFF);
			ref = encode_range(range);
		}
		if(!rels) rels = {};
		ws['!comments'] = [];
		var _drawing = [];
	
		write_ws_xml_sheetpr(ws, wb, idx, opts, o);
	
		o[o.length] = (writextag('dimension', null, {'ref': ref}));
	
		o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
	
		/* TODO: store in WB, process styles */
		if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
			defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
			baseColWidth:opts.sheetFormat.baseColWidth||'10',
			outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
		}));
	
		if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));
	
		o[sidx = o.length] = '<sheetData/>';
		ws['!links'] = [];
		if(ws['!ref'] != null) {
			rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
			if(rdata.length > 0) o[o.length] = (rdata);
		}
		if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }
	
		/* sheetCalcPr */
	
		if(ws['!protect'] != null) o[o.length] = write_ws_xml_protection(ws['!protect']);
	
		/* protectedRanges */
		/* scenarios */
	
		if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
	
		/* sortState */
		/* dataConsolidate */
		/* customSheetViews */
	
		if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));
	
		/* phoneticPr */
		/* conditionalFormatting */
		/* dataValidations */
	
		var relc = -1, rel, rId = -1;
		if(ws['!links'].length > 0) {
			o[o.length] = "<hyperlinks>";
	ws['!links'].forEach(function(l) {
				if(!l[1].Target) return;
				rel = ({"ref":l[0]});
				if(l[1].Target.charAt(0) != "#") {
					rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
					rel["r:id"] = "rId"+rId;
				}
				if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
				if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
				o[o.length] = writextag("hyperlink",null,rel);
			});
			o[o.length] = "</hyperlinks>";
		}
		delete ws['!links'];
	
		/* printOptions */
	
		if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	
		/* pageSetup */
		/* headerFooter */
		/* rowBreaks */
		/* colBreaks */
		/* customProperties */
		/* cellWatches */
	
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));
	
		/* smartTags */
	
		if(_drawing.length > 0) {
			rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
			o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
			ws['!drawing'] = _drawing;
		}
	
		if(ws['!comments'].length > 0) {
			rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
			ws['!legacy'] = rId;
		}
	
		/* legacyDrawingHF */
		/* picture */
		/* oleObjects */
		/* controls */
		/* webPublishItems */
		/* tableParts */
		/* extLst */
	
		if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.726 BrtRowHdr */
	function parse_BrtRowHdr(data, length) {
		var z = ({});
		var tgt = data.l + length;
		z.r = data.read_shift(4);
		data.l += 4; // TODO: ixfe
		var miyRw = data.read_shift(2);
		data.l += 1; // TODO: top/bot padding
		var flags = data.read_shift(1);
		data.l = tgt;
		if(flags & 0x07) z.level = flags & 0x07;
		if(flags & 0x10) z.hidden = true;
		if(flags & 0x20) z.hpt = miyRw / 20;
		return z;
	}
	function write_BrtRowHdr(R, range, ws) {
		var o = new_buf(17+8*16);
		var row = (ws['!rows']||[])[R]||{};
		o.write_shift(4, R);
	
		o.write_shift(4, 0); /* TODO: ixfe */
	
		var miyRw = 0x0140;
		if(row.hpx) miyRw = px2pt(row.hpx) * 20;
		else if(row.hpt) miyRw = row.hpt * 20;
		o.write_shift(2, miyRw);
	
		o.write_shift(1, 0); /* top/bot padding */
	
		var flags = 0x0;
		if(row.level) flags |= row.level;
		if(row.hidden) flags |= 0x10;
		if(row.hpx || row.hpt) flags |= 0x20;
		o.write_shift(1, flags);
	
		o.write_shift(1, 0); /* phonetic guide */
	
		/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
		var ncolspan = 0, lcs = o.l;
		o.l += 4;
	
		var caddr = {r:R, c:0};
		for(var i = 0; i < 16; ++i) {
			if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
			var first = -1, last = -1;
			for(var j = (i<<10); j < ((i+1)<<10); ++j) {
				caddr.c = j;
				var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
				if(cell) { if(first < 0) first = j; last = j; }
			}
			if(first < 0) continue;
			++ncolspan;
			o.write_shift(4, first);
			o.write_shift(4, last);
		}
	
		var l = o.l;
		o.l = lcs;
		o.write_shift(4, ncolspan);
		o.l = l;
	
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function write_row_header(ba, ws, range, R) {
		var o = write_BrtRowHdr(R, range, ws);
		if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 'BrtRowHdr', o);
	}
	
	/* [MS-XLSB] 2.4.820 BrtWsDim */
	var parse_BrtWsDim = parse_UncheckedRfX;
	var write_BrtWsDim = write_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
	function parse_BrtWsFmtInfo() {
	}
	//function write_BrtWsFmtInfo(ws, o) { }
	
	/* [MS-XLSB] 2.4.823 BrtWsProp */
	function parse_BrtWsProp(data, length) {
		var z = {};
		/* TODO: pull flags */
		data.l += 19;
		z.name = parse_XLSBCodeName(data, length - 19);
		return z;
	}
	function write_BrtWsProp(str, o) {
		if(o == null) o = new_buf(84+4*str.length);
		for(var i = 0; i < 3; ++i) o.write_shift(1,0);
		write_BrtColor({auto:1}, o);
		o.write_shift(-4,-1);
		o.write_shift(-4,-1);
		write_XLSBCodeName(str, o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.306 BrtCellBlank */
	function parse_BrtCellBlank(data) {
		var cell = parse_XLSBCell(data);
		return [cell];
	}
	function write_BrtCellBlank(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		return write_XLSBCell(ncell, o);
	}
	
	
	/* [MS-XLSB] 2.4.307 BrtCellBool */
	function parse_BrtCellBool(data) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtCellBool(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.308 BrtCellError */
	function parse_BrtCellError(data) {
		var cell = parse_XLSBCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	
	/* [MS-XLSB] 2.4.311 BrtCellIsst */
	function parse_BrtCellIsst(data) {
		var cell = parse_XLSBCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtCellIsst(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	
	/* [MS-XLSB] 2.4.313 BrtCellReal */
	function parse_BrtCellReal(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellReal(cell, ncell, o) {
		if(o == null) o = new_buf(16);
		write_XLSBCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.314 BrtCellRk */
	function parse_BrtCellRk(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellRk(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	
	
	/* [MS-XLSB] 2.4.317 BrtCellSt */
	function parse_BrtCellSt(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtCellSt(cell, ncell, o) {
		if(o == null) o = new_buf(12 + 4 * cell.v.length);
		write_XLSBCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.653 BrtFmlaBool */
	function parse_BrtFmlaBool(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'b'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.654 BrtFmlaError */
	function parse_BrtFmlaError(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'e'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.655 BrtFmlaNum */
	function parse_BrtFmlaNum(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_Xnum(data);
		var o = [cell, value, 'n'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.656 BrtFmlaString */
	function parse_BrtFmlaString(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_XLWideString(data);
		var o = [cell, value, 'str'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.682 BrtMergeCell */
	var parse_BrtMergeCell = parse_UncheckedRfX;
	var write_BrtMergeCell = write_UncheckedRfX;
	/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
	function write_BrtBeginMergeCells(cnt, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(4, cnt);
		return o;
	}
	
	/* [MS-XLSB] 2.4.662 BrtHLink */
	function parse_BrtHLink(data, length) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var relId = parse_XLNullableWideString(data);
		var loc = parse_XLWideString(data);
		var tooltip = parse_XLWideString(data);
		var display = parse_XLWideString(data);
		data.l = end;
		var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
		if(tooltip) o.Tooltip = tooltip;
		return o;
	}
	function write_BrtHLink(l, rId) {
		var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
		write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
		write_RelID("rId" + rId, o);
		var locidx = l[1].Target.indexOf("#");
		var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
		write_XLWideString(loc || "", o);
		write_XLWideString(l[1].Tooltip || "", o);
		write_XLWideString("", o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.692 BrtPane */
	function parse_BrtPane(/*data, length, opts*/) {
	}
	
	/* [MS-XLSB] 2.4.6 BrtArrFmla */
	function parse_BrtArrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_RfX(data, 16);
		var fAlwaysCalc = data.read_shift(1);
		var o = [rfx]; o[2] = fAlwaysCalc;
		if(opts.cellFormula) {
			var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
			o[1] = formula;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.750 BrtShrFmla */
	function parse_BrtShrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var o = [rfx];
		if(opts.cellFormula) {
			var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
			o[1] = formula;
			data.l = end;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtColInfo */
	/* TODO: once XLS ColInfo is set, combine the functions */
	function write_BrtColInfo(C, col, o) {
		if(o == null) o = new_buf(18);
		var p = col_obj_w(C, col);
		o.write_shift(-4, C);
		o.write_shift(-4, C);
		o.write_shift(4, (p.width || 10) * 256);
		o.write_shift(4, 0/*ixfe*/); // style
		var flags = 0;
		if(col.hidden) flags |= 0x01;
		if(typeof p.width == 'number') flags |= 0x02;
		if(col.level) flags |= (col.level << 8);
		o.write_shift(2, flags); // bit flag
		return o;
	}
	
	/* [MS-XLSB] 2.4.678 BrtMargins */
	var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
	function parse_BrtMargins(data) {
		var margins = ({});
		BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
		return margins;
	}
	function write_BrtMargins(margins, o) {
		if(o == null) o = new_buf(6*8);
		default_margins(margins);
		BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
		return o;
	}
	
	/* [MS-XLSB] 2.4.299 BrtBeginWsView */
	function parse_BrtBeginWsView(data) {
		var f = data.read_shift(2);
		data.l += 28;
		return { RTL: f & 0x20 };
	}
	function write_BrtBeginWsView(ws, Workbook, o) {
		if(o == null) o = new_buf(30);
		var f = 0x39c;
		if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
		o.write_shift(2, f); // bit flag
		o.write_shift(4, 0);
		o.write_shift(4, 0); // view first row
		o.write_shift(4, 0); // view first col
		o.write_shift(1, 0); // gridline color ICV
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 100); // zoom scale
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0); // workbook view id
		return o;
	}
	
	/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
	function write_BrtCellIgnoreEC(ref) {
		var o = new_buf(24);
		o.write_shift(4, 4);
		o.write_shift(4, 1);
		write_UncheckedRfX(ref, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.748 BrtSheetProtection */
	function write_BrtSheetProtection(sp, o) {
		if(o == null) o = new_buf(16*4+2);
		o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
		o.write_shift(4, 1); // this record should not be written if no protection
		[
			["objects",             false], // fObjects
			["scenarios",           false], // fScenarios
			["formatCells",          true], // fFormatCells
			["formatColumns",        true], // fFormatColumns
			["formatRows",           true], // fFormatRows
			["insertColumns",        true], // fInsertColumns
			["insertRows",           true], // fInsertRows
			["insertHyperlinks",     true], // fInsertHyperlinks
			["deleteColumns",        true], // fDeleteColumns
			["deleteRows",           true], // fDeleteRows
			["selectLockedCells",   false], // fSelLockedCells
			["sort",                 true], // fSort
			["autoFilter",           true], // fAutoFilter
			["pivotTables",          true], // fPivotTables
			["selectUnlockedCells", false]  // fSelUnlockedCells
		].forEach(function(n) {
	if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
			else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
		});
		return o;
	}
	
	function parse_BrtDVal(/*data, length, opts*/) {
	}
	function parse_BrtDVal14(/*data, length, opts*/) {
	}
	/* [MS-XLSB] 2.1.7.61 Worksheet */
	function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		var opts = _opts || {};
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var s = (opts.dense ? [] : {});
	
		var ref;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		var state = [];
		var pass = false, end = false;
		var row, p, cf, R, C, addr, sstr, rr, cell;
		var merges = [];
		opts.biff = 12;
		opts['!row'] = 0;
	
		var ai = 0, af = false;
	
		var arrayf = [];
		var sharedf = {};
		var supbooks = opts.supbooks || wb.supbooks || ([[]]);
		supbooks.sharedf = sharedf;
		supbooks.arrayf = arrayf;
		supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
		if(!opts.supbooks) {
			opts.supbooks = supbooks;
			if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
		}
	
		var colinfo = [], rowinfo = [];
		var seencol = false;
	
		recordhopper(data, function ws_parse(val, R_n, RT) {
			if(end) return;
			switch(RT) {
				case 0x0094: /* 'BrtWsDim' */
					ref = val; break;
				case 0x0000: /* 'BrtRowHdr' */
					row = val;
					if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
					rr = encode_row(R = row.r);
					opts['!row'] = row.r;
					if(val.hidden || val.hpt || val.level != null) {
						if(val.hpt) val.hpx = pt2px(val.hpt);
						rowinfo[val.r] = val;
					}
					break;
	
				case 0x0002: /* 'BrtCellRk' */
				case 0x0003: /* 'BrtCellError' */
				case 0x0004: /* 'BrtCellBool' */
				case 0x0005: /* 'BrtCellReal' */
				case 0x0006: /* 'BrtCellSt' */
				case 0x0007: /* 'BrtCellIsst' */
				case 0x0008: /* 'BrtFmlaString' */
				case 0x0009: /* 'BrtFmlaNum' */
				case 0x000A: /* 'BrtFmlaBool' */
				case 0x000B: /* 'BrtFmlaError' */
					p = ({t:val[2]});
					switch(val[2]) {
						case 'n': p.v = val[1]; break;
						case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
						case 'b': p.v = val[1] ? true : false; break;
						case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
						case 'str': p.t = 's'; p.v = val[1]; break;
					}
					if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
					C = val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(opts.cellFormula) {
						af = false;
						for(ai = 0; ai < arrayf.length; ++ai) {
							var aii = arrayf[ai];
							if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
								if(C >= aii[0].s.c && C <= aii[0].e.c) {
									p.F = encode_range(aii[0]); af = true;
								}
						}
						if(!af && val.length > 3) p.f = val[3];
					}
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(opts.cellDates && cf && p.t == 'n' && SSF.is_date(SSF._table[cf.numFmtId])) {
						var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
					}
					break;
	
				case 0x0001: /* 'BrtCellBlank' */
					if(!opts.sheetStubs || pass) break;
					p = ({t:'z',v:undefined});
					C = val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					break;
	
				case 0x00B0: /* 'BrtMergeCell' */
					merges.push(val); break;
	
				case 0x01EE: /* 'BrtHLink' */
					var rel = rels['!id'][val.relId];
					if(rel) {
						val.Target = rel.Target;
						if(val.loc) val.Target += "#"+val.loc;
						val.Rel = rel;
					} else if(val.relId == '') {
						val.Target = "#" + val.loc;
					}
					for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
						if(opts.dense) {
							if(!s[R]) s[R] = [];
							if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
							s[R][C].l = val;
						} else {
							addr = encode_cell({c:C,r:R});
							if(!s[addr]) s[addr] = {t:'z',v:undefined};
							s[addr].l = val;
						}
					}
					break;
	
				case 0x01AA: /* 'BrtArrFmla' */
					if(!opts.cellFormula) break;
					arrayf.push(val);
					cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					cell.F = encode_range(val[0]);
					break;
				case 0x01AB: /* 'BrtShrFmla' */
					if(!opts.cellFormula) break;
					sharedf[encode_cell(val[0].s)] = val[1];
					cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					break;
	
				/* identical to 'ColInfo' in XLS */
				case 0x003C: /* 'BrtColInfo' */
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
					break;
	
				case 0x00A1: /* 'BrtBeginAFilter' */
					s['!autofilter'] = { ref:encode_range(val) };
					break;
	
				case 0x01DC: /* 'BrtMargins' */
					s['!margins'] = val;
					break;
	
				case 0x0093: /* 'BrtWsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				case 0x0089: /* 'BrtBeginWsView' */
					if(!wb.Views) wb.Views = [{}];
					if(!wb.Views[0]) wb.Views[0] = {};
					if(val.RTL) wb.Views[0].RTL = true;
					break;
	
				case 0x01E5: /* 'BrtWsFmtInfo' */
					break;
	
				case 0x0040: /* 'BrtDVal' */
				case 0x041D: /* 'BrtDVal14' */
					break;
	
				case 0x0097: /* 'BrtPane' */
					break;
				case 0x00AF: /* 'BrtAFilterDateGroupItem' */
				case 0x0284: /* 'BrtActiveX' */
				case 0x0271: /* 'BrtBigName' */
				case 0x0232: /* 'BrtBkHim' */
				case 0x018C: /* 'BrtBrk' */
				case 0x0458: /* 'BrtCFIcon' */
				case 0x047A: /* 'BrtCFRuleExt' */
				case 0x01D7: /* 'BrtCFVO' */
				case 0x041A: /* 'BrtCFVO14' */
				case 0x0289: /* 'BrtCellIgnoreEC' */
				case 0x0451: /* 'BrtCellIgnoreEC14' */
				case 0x0031: /* 'BrtCellMeta' */
				case 0x024D: /* 'BrtCellSmartTagProperty' */
				case 0x025F: /* 'BrtCellWatch' */
				case 0x0234: /* 'BrtColor' */
				case 0x041F: /* 'BrtColor14' */
				case 0x00A8: /* 'BrtColorFilter' */
				case 0x00AE: /* 'BrtCustomFilter' */
				case 0x049C: /* 'BrtCustomFilter14' */
				case 0x01F3: /* 'BrtDRef' */
				case 0x0226: /* 'BrtDrawing' */
				case 0x00AB: /* 'BrtDynamicFilter' */
				case 0x00A7: /* 'BrtFilter' */
				case 0x0499: /* 'BrtFilter14' */
				case 0x00A9: /* 'BrtIconFilter' */
				case 0x049D: /* 'BrtIconFilter14' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x0295: /* 'BrtListPart' */
				case 0x027F: /* 'BrtOleObject' */
				case 0x01DE: /* 'BrtPageSetup' */
				case 0x0219: /* 'BrtPhoneticInfo' */
				case 0x01DD: /* 'BrtPrintOptions' */
				case 0x0218: /* 'BrtRangeProtection' */
				case 0x044F: /* 'BrtRangeProtection14' */
				case 0x02A8: /* 'BrtRangeProtectionIso' */
				case 0x0450: /* 'BrtRangeProtectionIso14' */
				case 0x0400: /* 'BrtRwDescent' */
				case 0x0098: /* 'BrtSel' */
				case 0x0297: /* 'BrtSheetCalcProp' */
				case 0x0217: /* 'BrtSheetProtection' */
				case 0x02A6: /* 'BrtSheetProtectionIso' */
				case 0x01F8: /* 'BrtSlc' */
				case 0x0413: /* 'BrtSparkline' */
				case 0x01AC: /* 'BrtTable' */
				case 0x00AA: /* 'BrtTop10Filter' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0032: /* 'BrtValueMeta' */
				case 0x0816: /* 'BrtWebExtension' */
				case 0x0415: /* 'BrtWsFmtInfoEx14' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		delete opts.supbooks;
		delete opts['!row'];
	
		if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
		if(opts.sheetRows && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(merges.length > 0) s["!merges"] = merges;
		if(colinfo.length > 0) s["!cols"] = colinfo;
		if(rowinfo.length > 0) s["!rows"] = rowinfo;
		return s;
	}
	
	/* TODO: something useful -- this is a stub */
	function write_ws_bin_cell(ba, cell, R, C, opts, ws) {
		if(cell.v === undefined) return;
		var vv = "";
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'd': // no BrtCellDate :(
				cell = dup(cell);
				cell.z = cell.z || SSF._table[14];
				cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
				break;
			/* falls through */
			case 'n': case 'e': vv = ''+cell.v; break;
			default: vv = cell.v; break;
		}
		var o = ({r:R, c:C});
		/* TODO: cell style */
		o.s = get_cell_style(opts.cellXfs, cell, opts);
		if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
		if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
		switch(cell.t) {
			case 's': case 'str':
				if(opts.bookSST) {
					vv = get_sst_id(opts.Strings, (cell.v), opts.revStrings);
					o.t = "s"; o.v = vv;
					write_record(ba, "BrtCellIsst", write_BrtCellIsst(cell, o));
				} else {
					o.t = "str";
					write_record(ba, "BrtCellSt", write_BrtCellSt(cell, o));
				}
				return;
			case 'n':
				/* TODO: determine threshold for Real vs RK */
				if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) write_record(ba, "BrtCellRk", write_BrtCellRk(cell, o));
				else write_record(ba, "BrtCellReal", write_BrtCellReal(cell, o));
				return;
			case 'b':
				o.t = "b";
				write_record(ba, "BrtCellBool", write_BrtCellBool(cell, o));
				return;
			case 'e': /* TODO: error */ o.t = "e"; break;
		}
		write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
	}
	
	function write_CELLTABLE(ba, ws, idx, opts) {
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		write_record(ba, 'BrtBeginSheetData');
		var dense = Array.isArray(ws);
		var cap = range.e.r;
		if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
		for(var R = range.s.r; R <= cap; ++R) {
			rr = encode_row(R);
			/* [ACCELLTABLE] */
			/* BrtRowHdr */
			write_row_header(ba, ws, range, R);
			if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
				/* *16384CELL */
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_bin_cell(ba, cell, R, C, opts, ws);
			}
		}
		write_record(ba, 'BrtEndSheetData');
	}
	
	function write_MERGECELLS(ba, ws) {
		if(!ws || !ws['!merges']) return;
		write_record(ba, 'BrtBeginMergeCells', write_BrtBeginMergeCells(ws['!merges'].length));
		ws['!merges'].forEach(function(m) { write_record(ba, 'BrtMergeCell', write_BrtMergeCell(m)); });
		write_record(ba, 'BrtEndMergeCells');
	}
	
	function write_COLINFOS(ba, ws) {
		if(!ws || !ws['!cols']) return;
		write_record(ba, 'BrtBeginColInfos');
		ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 'BrtColInfo', write_BrtColInfo(i, m)); });
		write_record(ba, 'BrtEndColInfos');
	}
	
	function write_IGNOREECS(ba, ws) {
		if(!ws || !ws['!ref']) return;
		write_record(ba, 'BrtBeginCellIgnoreECs');
		write_record(ba, 'BrtCellIgnoreEC', write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
		write_record(ba, 'BrtEndCellIgnoreECs');
	}
	
	function write_HLINKS(ba, ws, rels) {
		/* *BrtHLink */
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
			write_record(ba, "BrtHLink", write_BrtHLink(l, rId));
		});
		delete ws['!links'];
	}
	function write_LEGACYDRAWING(ba, ws, idx, rels) {
		/* [BrtLegacyDrawing] */
		if(ws['!comments'].length > 0) {
			var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			write_record(ba, "BrtLegacyDrawing", write_RelID("rId" + rId));
			ws['!legacy'] = rId;
		}
	}
	
	function write_AUTOFILTER(ba, ws, wb, idx) {
		if(!ws['!autofilter']) return;
		var data = ws['!autofilter'];
		var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);
	
		/* Update FilterDatabase defined name for the worksheet */
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	
		write_record(ba, "BrtBeginAFilter", write_UncheckedRfX(safe_decode_range(ref)));
		/* *FILTERCOLUMN */
		/* [SORTSTATE] */
		/* BrtEndAFilter */
		write_record(ba, "BrtEndAFilter");
	}
	
	function write_WSVIEWS2(ba, ws, Workbook) {
		write_record(ba, "BrtBeginWsViews");
		{ /* 1*WSVIEW2 */
			/* [ACUID] */
			write_record(ba, "BrtBeginWsView", write_BrtBeginWsView(ws, Workbook));
			/* [BrtPane] */
			/* *4BrtSel */
			/* *4SXSELECT */
			/* *FRT */
			write_record(ba, "BrtEndWsView");
		}
		/* *FRT */
		write_record(ba, "BrtEndWsViews");
	}
	
	function write_WSFMTINFO() {
		/* [ACWSFMTINFO] */
		//write_record(ba, "BrtWsFmtInfo", write_BrtWsFmtInfo(ws));
	}
	
	function write_SHEETPROTECT(ba, ws) {
		if(!ws['!protect']) return;
		/* [BrtSheetProtectionIso] */
		write_record(ba, "BrtSheetProtection", write_BrtSheetProtection(ws['!protect']));
	}
	
	function write_ws_bin(idx, opts, wb, rels) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
		var r = safe_decode_range(ws['!ref'] || "A1");
		if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
			r.e.c = Math.min(r.e.c, 0x3FFF);
			r.e.r = Math.min(r.e.c, 0xFFFFF);
		}
		ws['!links'] = [];
		/* passed back to write_zip and removed there */
		ws['!comments'] = [];
		write_record(ba, "BrtBeginSheet");
		if(wb.vbaraw) write_record(ba, "BrtWsProp", write_BrtWsProp(c));
		write_record(ba, "BrtWsDim", write_BrtWsDim(r));
		write_WSVIEWS2(ba, ws, wb.Workbook);
		write_WSFMTINFO(ba, ws);
		write_COLINFOS(ba, ws, idx, opts, wb);
		write_CELLTABLE(ba, ws, idx, opts, wb);
		/* [BrtSheetCalcProp] */
		write_SHEETPROTECT(ba, ws);
		/* *([BrtRangeProtectionIso] BrtRangeProtection) */
		/* [SCENMAN] */
		write_AUTOFILTER(ba, ws, wb, idx);
		/* [SORTSTATE] */
		/* [DCON] */
		/* [USERSHVIEWS] */
		write_MERGECELLS(ba, ws);
		/* [BrtPhoneticInfo] */
		/* *CONDITIONALFORMATTING */
		/* [DVALS] */
		write_HLINKS(ba, ws, rels);
		/* [BrtPrintOptions] */
		if(ws['!margins']) write_record(ba, "BrtMargins", write_BrtMargins(ws['!margins']));
		/* [BrtPageSetup] */
		/* [HEADERFOOTER] */
		/* [RWBRK] */
		/* [COLBRK] */
		/* *BrtBigName */
		/* [CELLWATCHES] */
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
		/* [SMARTTAGS] */
		/* [BrtDrawing] */
		write_LEGACYDRAWING(ba, ws, idx, rels);
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [OLEOBJECTS] */
		/* [ACTIVEXCONTROLS] */
		/* [WEBPUBITEMS] */
		/* [LISTPARTS] */
		/* FRTWORKSHEET */
		write_record(ba, "BrtEndSheet");
		return ba.end();
	}
	RELS.CHART = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart";
	RELS.CHARTEX = "http://schemas.microsoft.com/office/2014/relationships/chartEx";
	
	function parse_Cache(data) {
		var col = [];
		var num = data.match(/^<c:numCache>/);
		var f;
	
		/* 21.2.2.150 pt CT_NumVal */
		(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
			var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
			if(!q) return;
			col[+q[1]] = num ? +q[2] : q[2];
		});
	
		/* 21.2.2.71 formatCode CT_Xstring */
		var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);
	
		(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });
	
		return [col, nf, f];
	}
	
	/* 21.2 DrawingML - Charts */
	function parse_chart(data, name, opts, rels, wb, csheet) {
		var cs = ((csheet || {"!type":"chart"}));
		if(!data) return csheet;
		/* 21.2.2.27 chart CT_Chart */
	
		var C = 0, R = 0, col = "A";
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		/* 21.2.2.120 numCache CT_NumData */
		(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
			var cache = parse_Cache(nc);
			refguess.s.r = refguess.s.c = 0;
			refguess.e.c = C;
			col = encode_col(C);
			cache[0].forEach(function(n,i) {
				cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
				R = i;
			});
			if(refguess.e.r < R) refguess.e.r = R;
			++C;
		});
		if(C > 0) cs["!ref"] = encode_range(refguess);
		return cs;
	}
	RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";
	
	var CS_XML_ROOT = writextag('chartsheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	/* 18.3 Worksheets also covers Chartsheets */
	function parse_cs_xml(data, opts, idx, rels, wb) {
		if(!data) return data;
		/* 18.3.1.12 chartsheet CT_ChartSheet */
		if(!rels) rels = {'!id':{}};
		var s = ({'!type':"chart", '!drawel':null, '!rel':""});
		var m;
	
		/* 18.3.1.83 sheetPr CT_ChartsheetPr */
		var sheetPr = data.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.36 drawing CT_Drawing */
		if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, CS_XML_ROOT];
		o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
		add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.331 BrtCsProp */
	function parse_BrtCsProp(data, length) {
		data.l += 10;
		var name = parse_XLWideString(data, length - 10);
		return { name: name };
	}
	
	/* [MS-XLSB] 2.1.7.7 Chart Sheet */
	function parse_cs_bin(data, opts, idx, rels, wb) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		var s = {'!type':"chart", '!drawel':null, '!rel':""};
		var state = [];
		var pass = false;
		recordhopper(data, function cs_parse(val, R_n, RT) {
			switch(RT) {
	
				case 0x0226: /* 'BrtDrawing' */
					s['!rel'] = val; break;
	
				case 0x028B: /* 'BrtCsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				case 0x0232: /* 'BrtBkHim' */
				case 0x028C: /* 'BrtCsPageSetup' */
				case 0x029D: /* 'BrtCsProtection' */
				case 0x02A7: /* 'BrtCsProtectionIso' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x01DC: /* 'BrtMargins' */
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
					else if((R_n||"").indexOf("End") > 0) state.pop();
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_bin() {
		var ba = buf_array();
		write_record(ba, "BrtBeginSheet");
		/* [BrtCsProp] */
		/* CSVIEWS */
		/* [[BrtCsProtectionIso] BrtCsProtection] */
		/* [USERCSVIEWS] */
		/* [BrtMargins] */
		/* [BrtCsPageSetup] */
		/* [HEADERFOOTER] */
		/* BrtDrawing */
		/* [BrtLegacyDrawing] */
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [WEBPUBITEMS] */
		/* FRTCHARTSHEET */
		write_record(ba, "BrtEndSheet");
		return ba.end();
	}
	/* 18.2.28 (CT_WorkbookProtection) Defaults */
	var WBPropsDef = [
		['allowRefreshQuery',           false, "bool"],
		['autoCompressPictures',        true,  "bool"],
		['backupFile',                  false, "bool"],
		['checkCompatibility',          false, "bool"],
		['CodeName',                    ''],
		['date1904',                    false, "bool"],
		['defaultThemeVersion',         0,      "int"],
		['filterPrivacy',               false, "bool"],
		['hidePivotFieldList',          false, "bool"],
		['promptedSolutions',           false, "bool"],
		['publishItems',                false, "bool"],
		['refreshAllConnections',       false, "bool"],
		['saveExternalLinkValues',      true,  "bool"],
		['showBorderUnselectedTables',  true,  "bool"],
		['showInkAnnotation',           true,  "bool"],
		['showObjects',                 'all'],
		['showPivotChartFilter',        false, "bool"],
		['updateLinks', 'userSet']
	];
	
	/* 18.2.30 (CT_BookView) Defaults */
	var WBViewDef = [
		['activeTab',                   0,      "int"],
		['autoFilterDateGrouping',      true,  "bool"],
		['firstSheet',                  0,      "int"],
		['minimized',                   false, "bool"],
		['showHorizontalScroll',        true,  "bool"],
		['showSheetTabs',               true,  "bool"],
		['showVerticalScroll',          true,  "bool"],
		['tabRatio',                    600,    "int"],
		['visibility',                  'visible']
		//window{Height,Width}, {x,y}Window
	];
	
	/* 18.2.19 (CT_Sheet) Defaults */
	var SheetDef = [
		//['state', 'visible']
	];
	
	/* 18.2.2  (CT_CalcPr) Defaults */
	var CalcPrDef = [
		['calcCompleted', 'true'],
		['calcMode', 'auto'],
		['calcOnSave', 'true'],
		['concurrentCalc', 'true'],
		['fullCalcOnLoad', 'false'],
		['fullPrecision', 'true'],
		['iterate', 'false'],
		['iterateCount', '100'],
		['iterateDelta', '0.001'],
		['refMode', 'A1']
	];
	
	/* 18.2.3 (CT_CustomWorkbookView) Defaults */
	/*var CustomWBViewDef = [
		['autoUpdate', 'false'],
		['changesSavedWin', 'false'],
		['includeHiddenRowCol', 'true'],
		['includePrintSettings', 'true'],
		['maximized', 'false'],
		['minimized', 'false'],
		['onlySync', 'false'],
		['personalView', 'false'],
		['showComments', 'commIndicator'],
		['showFormulaBar', 'true'],
		['showHorizontalScroll', 'true'],
		['showObjects', 'all'],
		['showSheetTabs', 'true'],
		['showStatusbar', 'true'],
		['showVerticalScroll', 'true'],
		['tabRatio', '600'],
		['xWindow', '0'],
		['yWindow', '0']
	];*/
	
	function push_defaults_array(target, defaults) {
		for(var j = 0; j != target.length; ++j) { var w = target[j];
			for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
				if(w[z[0]] == null) w[z[0]] = z[1];
				else switch(z[2]) {
				case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
				case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
				}
			}
		}
	}
	function push_defaults(target, defaults) {
		for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
			if(target[z[0]] == null) target[z[0]] = z[1];
			else switch(z[2]) {
				case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
				case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
			}
		}
	}
	
	function parse_wb_defaults(wb) {
		push_defaults(wb.WBProps, WBPropsDef);
		push_defaults(wb.CalcPr, CalcPrDef);
	
		push_defaults_array(wb.WBView, WBViewDef);
		push_defaults_array(wb.Sheets, SheetDef);
	
		_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
	}
	
	function safe1904(wb) {
		/* TODO: store date1904 somewhere else */
		if(!wb.Workbook) return "false";
		if(!wb.Workbook.WBProps) return "false";
		return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
	}
	
	var badchars = "][*?\/\\".split("");
	function check_ws_name(n, safe) {
		if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
		var _good = true;
		badchars.forEach(function(c) {
			if(n.indexOf(c) == -1) return;
			if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
			_good = false;
		});
		return _good;
	}
	function check_wb_names(N, S, codes) {
		N.forEach(function(n,i) {
			check_ws_name(n);
			for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
			if(codes) {
				var cn = (S && S[i] && S[i].CodeName) || n;
				if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
			}
		});
	}
	function check_wb(wb) {
		if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
		if(!wb.SheetNames.length) throw new Error("Workbook is empty");
		var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
		check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
		for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
		/* TODO: validate workbook */
	}
	/* 18.2 Workbook */
	var wbnsregex = /<\w+:workbook/;
	function parse_wb_xml(data, opts) {
		if(!data) throw new Error("Could not find file");
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
		var pass = false, xmlns = "xmlns";
		var dname = {}, dnstart = 0;
		data.replace(tagregex, function xml_wb(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 18.2.27 workbook CT_Workbook 1 */
				case '<workbook':
					if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
					wb.xmlns = y[xmlns];
					break;
				case '</workbook>': break;
	
				/* 18.2.13 fileVersion CT_FileVersion ? */
				case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
				case '<fileVersion/>': case '</fileVersion>': break;
	
				/* 18.2.12 fileSharing CT_FileSharing ? */
				case '<fileSharing':
					break;
				case '<fileSharing/>': break;
	
				/* 18.2.28 workbookPr CT_WorkbookPr ? */
				case '<workbookPr':
				case '<workbookPr/>':
					WBPropsDef.forEach(function(w) {
						if(y[w[0]] == null) return;
						switch(w[2]) {
							case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
							case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
							default: wb.WBProps[w[0]] = y[w[0]];
						}
					});
					if(y.codeName) wb.WBProps.CodeName = y.codeName;
					break;
				case '</workbookPr>': break;
	
				/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
				case '<workbookProtection':
					break;
				case '<workbookProtection/>': break;
	
				/* 18.2.1  bookViews CT_BookViews ? */
				case '<bookViews': case '<bookViews>': case '</bookViews>': break;
				/* 18.2.30   workbookView CT_BookView + */
				case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
				case '</workbookView>': break;
	
				/* 18.2.20 sheets CT_Sheets 1 */
				case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
				/* 18.2.19   sheet CT_Sheet + */
				case '<sheet':
					switch(y.state) {
						case "hidden": y.Hidden = 1; break;
						case "veryHidden": y.Hidden = 2; break;
						default: y.Hidden = 0;
					}
					delete y.state;
					y.name = unescapexml(utf8read(y.name));
					delete y[0]; wb.Sheets.push(y); break;
				case '</sheet>': break;
	
				/* 18.2.15 functionGroups CT_FunctionGroups ? */
				case '<functionGroups': case '<functionGroups/>': break;
				/* 18.2.14   functionGroup CT_FunctionGroup + */
				case '<functionGroup': break;
	
				/* 18.2.9  externalReferences CT_ExternalReferences ? */
				case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
				/* 18.2.8    externalReference CT_ExternalReference + */
				case '<externalReference': break;
	
				/* 18.2.6  definedNames CT_DefinedNames ? */
				case '<definedNames/>': break;
				case '<definedNames>': case '<definedNames': pass=true; break;
				case '</definedNames>': pass=false; break;
				/* 18.2.5    definedName CT_DefinedName + */
				case '<definedName': {
					dname = {};
					dname.Name = utf8read(y.name);
					if(y.comment) dname.Comment = y.comment;
					if(y.localSheetId) dname.Sheet = +y.localSheetId;
					if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
					dnstart = idx + x.length;
				}	break;
				case '</definedName>': {
					dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
					wb.Names.push(dname);
				} break;
				case '<definedName/>': break;
	
				/* 18.2.2  calcPr CT_CalcPr ? */
				case '<calcPr': delete y[0]; wb.CalcPr = y; break;
				case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
				case '</calcPr>': break;
	
				/* 18.2.16 oleSize CT_OleSize ? (ref required) */
				case '<oleSize': break;
	
				/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
				case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
				/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
				case '<customWorkbookView': case '</customWorkbookView>': break;
	
				/* 18.2.18 pivotCaches CT_PivotCaches ? */
				case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
				/* 18.2.17 pivotCache CT_PivotCache ? */
				case '<pivotCache': break;
	
				/* 18.2.21 smartTagPr CT_SmartTagPr ? */
				case '<smartTagPr': case '<smartTagPr/>': break;
	
				/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
				case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
				/* 18.2.22 smartTagType CT_SmartTagType ? */
				case '<smartTagType': break;
	
				/* 18.2.24 webPublishing CT_WebPublishing ? */
				case '<webPublishing': case '<webPublishing/>': break;
	
				/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
				case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;
	
				/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
				case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
				/* 18.2.25 webPublishObject CT_WebPublishObject ? */
				case '<webPublishObject': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break; //TODO: check with versions of excel
				case '</ext>': pass=false; break;
	
				/* Others */
				case '<ArchID': break;
				case '<AlternateContent':
				case '<AlternateContent>': pass=true; break;
				case '</AlternateContent>': pass=false; break;
	
				/* TODO */
				case '<revisionPtr': break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
			}
			return x;
		});
		if(XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	var WB_XML_ROOT = writextag('workbook', null, {
		'xmlns': XMLNS.main[0],
		//'xmlns:mx': XMLNS.mx,
		//'xmlns:s': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	function write_wb_xml(wb) {
		var o = [XML_HEADER];
		o[o.length] = WB_XML_ROOT;
	
		var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);
	
		/* fileVersion */
		/* fileSharing */
	
		var workbookPr = ({codeName:"ThisWorkbook"});
		if(wb.Workbook && wb.Workbook.WBProps) {
			WBPropsDef.forEach(function(x) {
	if((wb.Workbook.WBProps[x[0]]) == null) return;
				if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
				workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
			});
	if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
		}
		o[o.length] = (writextag('workbookPr', null, workbookPr));
	
		/* workbookProtection */
	
		var sheets = wb.Workbook && wb.Workbook.Sheets || [];
		var i = 0;
	
		/* bookViews */
	
		o[o.length] = "<sheets>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
			sht.sheetId = ""+(i+1);
			sht["r:id"] = "rId"+(i+1);
			if(sheets[i]) switch(sheets[i].Hidden) {
				case 1: sht.state = "hidden"; break;
				case 2: sht.state = "veryHidden"; break;
			}
			o[o.length] = (writextag('sheet',null,sht));
		}
		o[o.length] = "</sheets>";
	
		/* functionGroups */
		/* externalReferences */
	
		if(write_names) {
			o[o.length] = "<definedNames>";
			if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
				var d = {name:n.Name};
				if(n.Comment) d.comment = n.Comment;
				if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
				if(n.Hidden) d.hidden = "1";
				if(!n.Ref) return;
				o[o.length] = writextag('definedName', String(n.Ref).replace(/</g, "&lt;").replace(/>/g, "&gt;"), d);
			});
			o[o.length] = "</definedNames>";
		}
	
		/* calcPr */
		/* oleSize */
		/* customWorkbookViews */
		/* pivotCaches */
		/* smartTagPr */
		/* smartTagTypes */
		/* webPublishing */
		/* fileRecoveryPr */
		/* webPublishObjects */
		/* extLst */
	
		if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.304 BrtBundleSh */
	function parse_BrtBundleSh(data, length) {
		var z = {};
		z.Hidden = data.read_shift(4); //hsState ST_SheetState
		z.iTabID = data.read_shift(4);
		z.strRelID = parse_RelID(data,length-8);
		z.name = parse_XLWideString(data);
		return z;
	}
	function write_BrtBundleSh(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.Hidden);
		o.write_shift(4, data.iTabID);
		write_RelID(data.strRelID, o);
		write_XLWideString(data.name.slice(0,31), o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.815 BrtWbProp */
	function parse_BrtWbProp(data, length) {
		var o = ({});
		var flags = data.read_shift(4);
		o.defaultThemeVersion = data.read_shift(4);
		var strName = (length > 8) ? parse_XLWideString(data) : "";
		if(strName.length > 0) o.CodeName = strName;
		o.autoCompressPictures = !!(flags & 0x10000);
		o.backupFile = !!(flags & 0x40);
		o.checkCompatibility = !!(flags & 0x1000);
		o.date1904 = !!(flags & 0x01);
		o.filterPrivacy = !!(flags & 0x08);
		o.hidePivotFieldList = !!(flags & 0x400);
		o.promptedSolutions = !!(flags & 0x10);
		o.publishItems = !!(flags & 0x800);
		o.refreshAllConnections = !!(flags & 0x40000);
		o.saveExternalLinkValues = !!(flags & 0x80);
		o.showBorderUnselectedTables = !!(flags & 0x04);
		o.showInkAnnotation = !!(flags & 0x20);
		o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
		o.showPivotChartFilter = !!(flags & 0x8000);
		o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
		return o;
	}
	function write_BrtWbProp(data, o) {
		if(!o) o = new_buf(72);
		var flags = 0;
		if(data) {
			/* TODO: mirror parse_BrtWbProp fields */
			if(data.filterPrivacy) flags |= 0x08;
		}
		o.write_shift(4, flags);
		o.write_shift(4, 0);
		write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
		return o.slice(0, o.l);
	}
	
	function parse_BrtFRTArchID$(data, length) {
		var o = {};
		data.read_shift(4);
		o.ArchID = data.read_shift(4);
		data.l += length - 8;
		return o;
	}
	
	/* [MS-XLSB] 2.4.687 BrtName */
	function parse_BrtName(data, length, opts) {
		var end = data.l + length;
		data.l += 4; //var flags = data.read_shift(4);
		data.l += 1; //var chKey = data.read_shift(1);
		var itab = data.read_shift(4);
		var name = parse_XLNameWideString(data);
		var formula = parse_XLSBNameParsedFormula(data, 0, opts);
		var comment = parse_XLNullableWideString(data);
		//if(0 /* fProc */) {
			// unusedstring1: XLNullableWideString
			// description: XLNullableWideString
			// helpTopic: XLNullableWideString
			// unusedstring2: XLNullableWideString
		//}
		data.l = end;
		var out = ({Name:name, Ptg:formula});
		if(itab < 0xFFFFFFF) out.Sheet = itab;
		if(comment) out.Comment = comment;
		return out;
	}
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function parse_wb_bin(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var state = [];
		var pass = false;
	
		if(!opts) opts = {};
		opts.biff = 12;
	
		var Names = [];
		var supbooks = ([[]]);
		supbooks.SheetNames = [];
		supbooks.XTI = [];
	
		recordhopper(data, function hopper_wb(val, R_n, RT) {
			switch(RT) {
				case 0x009C: /* 'BrtBundleSh' */
					supbooks.SheetNames.push(val.name);
					wb.Sheets.push(val); break;
	
				case 0x0099: /* 'BrtWbProp' */
					wb.WBProps = val; break;
	
				case 0x0027: /* 'BrtName' */
					if(val.Sheet != null) opts.SID = val.Sheet;
					val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
					delete opts.SID;
					delete val.Ptg;
					Names.push(val);
					break;
				case 0x040C: /* 'BrtNameExt' */ break;
	
				case 0x0165: /* 'BrtSupSelf' */
				case 0x0166: /* 'BrtSupSame' */
				case 0x0163: /* 'BrtSupBookSrc' */
				case 0x029B: /* 'BrtSupAddin' */
					if(!supbooks[0].length) supbooks[0] = [RT, val];
					else supbooks.push([RT, val]);
					supbooks[supbooks.length - 1].XTI = [];
					break;
				case 0x016A: /* 'BrtExternSheet' */
					if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
					supbooks.XTI = supbooks.XTI.concat(val);
					break;
				case 0x0169: /* 'BrtPlaceholderName' */
					break;
	
				/* case 'BrtModelTimeGroupingCalcCol' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0C01: /* 'BrtRevisionPtr' */
				case 0x0817: /* 'BrtAbsPath15' */
				case 0x0216: /* 'BrtBookProtection' */
				case 0x02A5: /* 'BrtBookProtectionIso' */
				case 0x009E: /* 'BrtBookView' */
				case 0x009D: /* 'BrtCalcProp' */
				case 0x0262: /* 'BrtCrashRecErr' */
				case 0x0802: /* 'BrtDecoupledPivotCacheID' */
				case 0x009B: /* 'BrtFileRecover' */
				case 0x0224: /* 'BrtFileSharing' */
				case 0x02A4: /* 'BrtFileSharingIso' */
				case 0x0080: /* 'BrtFileVersion' */
				case 0x0299: /* 'BrtFnGroup' */
				case 0x0850: /* 'BrtModelRelationship' */
				case 0x084D: /* 'BrtModelTable' */
				case 0x0225: /* 'BrtOleSize' */
				case 0x0805: /* 'BrtPivotTableRef' */
				case 0x0254: /* 'BrtSmartTagType' */
				case 0x081C: /* 'BrtTableSlicerCacheID' */
				case 0x081B: /* 'BrtTableSlicerCacheIDs' */
				case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
				case 0x018D: /* 'BrtUserBookView' */
				case 0x009A: /* 'BrtWbFactoid' */
				case 0x045D: /* 'BrtWbProp14' */
				case 0x0229: /* 'BrtWebOpt' */
				case 0x082B: /* 'BrtWorkBookPr15' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					state.push(R_n); pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					state.pop(); pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				case 0x0010: /* 'BrtFRTArchID$' */ break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || (opts.WTF && state[state.length-1] != "BrtACBegin" && state[state.length-1] != "BrtFRTBegin")) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		parse_wb_defaults(wb);
	
		// $FlowIgnore
		wb.Names = Names;
	
		(wb).supbooks = supbooks;
		return wb;
	}
	
	function write_BUNDLESHS(ba, wb) {
		write_record(ba, "BrtBeginBundleShs");
		for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
			var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
			var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
			write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
		}
		write_record(ba, "BrtEndBundleShs");
	}
	
	/* [MS-XLSB] 2.4.649 BrtFileVersion */
	function write_BrtFileVersion(data, o) {
		if(!o) o = new_buf(127);
		for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
		write_XLWideString("SheetJS", o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString("7262", o);
		o.length = o.l;
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.301 BrtBookView */
	function write_BrtBookView(idx, o) {
		if(!o) o = new_buf(29);
		o.write_shift(-4, 0);
		o.write_shift(-4, 460);
		o.write_shift(4,  28800);
		o.write_shift(4,  17600);
		o.write_shift(4,  500);
		o.write_shift(4,  idx);
		o.write_shift(4,  idx);
		var flags = 0x78;
		o.write_shift(1,  flags);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	function write_BOOKVIEWS(ba, wb) {
		/* required if hidden tab appears before visible tab */
		if(!wb.Workbook || !wb.Workbook.Sheets) return;
		var sheets = wb.Workbook.Sheets;
		var i = 0, vistab = -1, hidden = -1;
		for(; i < sheets.length; ++i) {
			if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
			else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
		}
		if(hidden > vistab) return;
		write_record(ba, "BrtBeginBookViews");
		write_record(ba, "BrtBookView", write_BrtBookView(vistab));
		/* 1*(BrtBookView *FRT) */
		write_record(ba, "BrtEndBookViews");
	}
	
	/* [MS-XLSB] 2.4.305 BrtCalcProp */
	/*function write_BrtCalcProp(data, o) {
		if(!o) o = new_buf(26);
		o.write_shift(4,0); // force recalc
		o.write_shift(4,1);
		o.write_shift(4,0);
		write_Xnum(0, o);
		o.write_shift(-4, 1023);
		o.write_shift(1, 0x33);
		o.write_shift(1, 0x00);
		return o;
	}*/
	
	/* [MS-XLSB] 2.4.646 BrtFileRecover */
	/*function write_BrtFileRecover(data, o) {
		if(!o) o = new_buf(1);
		o.write_shift(1,0);
		return o;
	}*/
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function write_wb_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginBook");
		write_record(ba, "BrtFileVersion", write_BrtFileVersion());
		/* [[BrtFileSharingIso] BrtFileSharing] */
		write_record(ba, "BrtWbProp", write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
		/* [ACABSPATH] */
		/* [[BrtBookProtectionIso] BrtBookProtection] */
		write_BOOKVIEWS(ba, wb, opts);
		write_BUNDLESHS(ba, wb, opts);
		/* [FNGROUP] */
		/* [EXTERNALS] */
		/* *BrtName */
		/* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */
		/* [BrtOleSize] */
		/* *(BrtUserBookView *FRT) */
		/* [PIVOTCACHEIDS] */
		/* [BrtWbFactoid] */
		/* [SMARTTAGTYPES] */
		/* [BrtWebOpt] */
		/* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */
		/* [WEBPUBITEMS] */
		/* [CRERRS] */
		/* FRTWORKBOOK */
		write_record(ba, "BrtEndBook");
	
		return ba.end();
	}
	function parse_wb(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
		return parse_wb_xml((data), opts);
	}
	
	function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_sty(data, name, themes, opts) {
		if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
		return parse_sty_xml((data), themes, opts);
	}
	
	function parse_theme(data, name, opts) {
		return parse_theme_xml(data, opts);
	}
	
	function parse_sst(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
		return parse_sst_xml((data), opts);
	}
	
	function parse_cmnt(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
		return parse_comments_xml((data), opts);
	}
	
	function parse_cc(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
		return parse_cc_xml((data), name, opts);
	}
	
	function parse_xlink(data, rel, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlink_bin((data), rel, name, opts);
		return parse_xlink_xml((data), rel, name, opts);
	}
	
	function write_wb(wb, name, opts) {
		return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
	}
	
	function write_ws(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
	}
	
	// eslint-disable-next-line no-unused-vars
	function write_cs(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
	}
	
	function write_sty(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
	}
	
	function write_sst(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
	}
	
	function write_cmnt(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
	}
	/*
	function write_cc(data, name:string, opts) {
		return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
	}
	*/
	var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
	function xlml_parsexmltag(tag, skip_root) {
		var words = tag.split(/\s+/);
		var z = ([]); if(!skip_root) z[0] = words[0];
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	function xlml_parsexmltagobj(tag) {
		var words = tag.split(/\s+/);
		var z = {};
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	
	// ----
	
	function xlml_format(format, value) {
		var fmt = XLMLFormatMap[format] || unescapexml(format);
		if(fmt === "General") return SSF._general(value);
		return SSF.format(fmt, value);
	}
	
	function xlml_set_custprop(Custprops, key, cp, val) {
		var oval = val;
		switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
			case "boolean": oval = parsexmlbool(val); break;
			case "i2": case "int": oval = parseInt(val, 10); break;
			case "r4": case "float": oval = parseFloat(val); break;
			case "date": case "dateTime.tz": oval = parseDate(val); break;
			case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
			default: throw new Error("bad custprop:" + cp[0]);
		}
		Custprops[unescapexml(key)] = oval;
	}
	
	function safe_format_xlml(cell, nf, o) {
		if(cell.t === 'z') return;
		if(!o || o.cellText !== false) try {
			if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
			else if(nf === "General") {
				if(cell.t === 'n') {
					if((cell.v|0) === cell.v) cell.w = SSF._general_int(cell.v);
					else cell.w = SSF._general_num(cell.v);
				}
				else cell.w = SSF._general(cell.v);
			}
			else cell.w = xlml_format(nf||"General", cell.v);
		} catch(e) { if(o.WTF) throw e; }
		try {
			var z = XLMLFormatMap[nf]||nf||"General";
			if(o.cellNF) cell.z = z;
			if(o.cellDates && cell.t == 'n' && SSF.is_date(z)) {
				var _d = SSF.parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
			}
		} catch(e) { if(o.WTF) throw e; }
	}
	
	function process_style_xlml(styles, stag, opts) {
		if(opts.cellStyles) {
			if(stag.Interior) {
				var I = stag.Interior;
				if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
			}
		}
		styles[stag.ID] = stag;
	}
	
	/* TODO: there must exist some form of OSP-blessed spec */
	function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
		var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
		var interiors = [];
		var i = 0;
		if(sid === undefined && row) sid = row.StyleID;
		if(sid === undefined && csty) sid = csty.StyleID;
		while(styles[sid] !== undefined) {
			if(styles[sid].nf) nf = styles[sid].nf;
			if(styles[sid].Interior) interiors.push(styles[sid].Interior);
			if(!styles[sid].Parent) break;
			sid = styles[sid].Parent;
		}
		switch(data.Type) {
			case 'Boolean':
				cell.t = 'b';
				cell.v = parsexmlbool(xml);
				break;
			case 'String':
				cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
				cell.v = xml.indexOf("<") > -1 ? unescapexml(ss||xml) : cell.r;
				break;
			case 'DateTime':
				if(xml.slice(-1) != "Z") xml += "Z";
				cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				if(cell.v !== cell.v) cell.v = unescapexml(xml);
				else if(cell.v<60) cell.v = cell.v -1;
				if(!nf || nf == "General") nf = "yyyy-mm-dd";
				/* falls through */
			case 'Number':
				if(cell.v === undefined) cell.v=+xml;
				if(!cell.t) cell.t = 'n';
				break;
			case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
			default: cell.t = 's'; cell.v = xlml_fixstr(ss||xml); break;
		}
		safe_format_xlml(cell, nf, o);
		if(o.cellFormula !== false) {
			if(cell.Formula) {
				var fstr = unescapexml(cell.Formula);
				/* strictly speaking, the leading = is required but some writers omit */
				if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
				cell.f = rc_to_a1(fstr, base);
				delete cell.Formula;
				if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
				else if(cell.ArrayRange) {
					cell.F = rc_to_a1(cell.ArrayRange, base);
					arrayf.push([safe_decode_range(cell.F), cell.F]);
				}
			} else {
				for(i = 0; i < arrayf.length; ++i)
					if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
						if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
							cell.F = arrayf[i][1];
			}
		}
		if(o.cellStyles) {
			interiors.forEach(function(x) {
				if(!S.patternType && x.patternType) S.patternType = x.patternType;
			});
			cell.s = S;
		}
		if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
	}
	
	function xlml_clean_comment(comment) {
		comment.t = comment.v || "";
		comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		comment.v = comment.w = comment.ixfe = undefined;
	}
	
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		/* duktape */
		if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
		throw new Error("Bad input format: expected Buffer or string");
	}
	
	/* TODO: Everything */
	/* UOS uses CJK in tags */
	var xlmlregex = /<(\/?)([^\s?>!\/:]*:|)([^\s?>:\/]+)[^>]*>/mg;
	//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
	function parse_xlml_xml(d, _opts) {
		var opts = _opts || {};
		make_ssf(SSF);
		var str = debom(xlml_normalize(d));
		if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
			if(typeof cptable !== 'undefined') str = cptable.utils.decode(65001, char_codes(str));
			else str = utf8read(str);
		}
		var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
		if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
		if(ishtml) return HTML_.to_workbook(str, opts);
		var Rn;
		var state = [], tmp;
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
		var table = {}, cell = ({}), row = {};// eslint-disable-line no-unused-vars
		var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
		var c = 0, r = 0;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
		var styles = {}, stag = {};
		var ss = "", fidx = 0;
		var merges = [];
		var Props = {}, Custprops = {}, pidx = 0, cp = [];
		var comments = [], comment = ({});
		var cstys = [], csty, seencol = false;
		var arrayf = [];
		var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
		var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"");
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'Data':
				if(state[state.length-1][1]) break;
				if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]=="Comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
				else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
				break;
			case 'Cell':
				if(Rn[1]==='/'){
					if(comments.length > 0) cell.c = comments;
					if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
						if(opts.dense) {
							if(!cursheet[r]) cursheet[r] = [];
							cursheet[r][c] = cell;
						} else cursheet[encode_col(c) + encode_row(r)] = cell;
					}
					if(cell.HRef) {
						cell.l = ({Target:cell.HRef});
						if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
						delete cell.HRef; delete cell.HRefScreenTip;
					}
					if(cell.MergeAcross || cell.MergeDown) {
						cc = c + (parseInt(cell.MergeAcross,10)|0);
						rr = r + (parseInt(cell.MergeDown,10)|0);
						merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
					}
					if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
					else if(cell.MergeAcross || cell.MergeDown) {
	for(var cma = c; cma <= cc; ++cma) {
							for(var cmd = r; cmd <= rr; ++cmd) {
								if(cma > c || cmd > r) {
									if(opts.dense) {
										if(!cursheet[cmd]) cursheet[cmd] = [];
										cursheet[cmd][cma] = {t:'z'};
									} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
								}
							}
						}
						c = cc + 1;
					}
					else ++c;
				} else {
					cell = xlml_parsexmltagobj(Rn[0]);
					if(cell.Index) c = +cell.Index - 1;
					if(c < refguess.s.c) refguess.s.c = c;
					if(c > refguess.e.c) refguess.e.c = c;
					if(Rn[0].slice(-2) === "/>") ++c;
					comments = [];
				}
				break;
			case 'Row':
				if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
					if(r < refguess.s.r) refguess.s.r = r;
					if(r > refguess.e.r) refguess.e.r = r;
					if(Rn[0].slice(-2) === "/>") {
						row = xlml_parsexmltag(Rn[0]);
						if(row.Index) r = +row.Index - 1;
					}
					c = 0; ++r;
				} else {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
					rowobj = {};
					if(row.AutoFitHeight == "0" || row.Height) {
						rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
						rowinfo[r] = rowobj;
					}
					if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
				}
				break;
			case 'Worksheet': /* TODO: read range from FullRows/FullColumns */
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					sheetnames.push(sheetname);
					if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
						cursheet["!ref"] = encode_range(refguess);
						if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
							cursheet["!fullref"] = cursheet["!ref"];
							refguess.e.r = opts.sheetRows - 1;
							cursheet["!ref"] = encode_range(refguess);
						}
					}
					if(merges.length) cursheet["!merges"] = merges;
					if(cstys.length > 0) cursheet["!cols"] = cstys;
					if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
					sheets[sheetname] = cursheet;
				} else {
					refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
					r = c = 0;
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					sheetname = unescapexml(tmp.Name);
					cursheet = (opts.dense ? [] : {});
					merges = [];
					arrayf = [];
					rowinfo = [];
					wsprops = {name:sheetname, Hidden:0};
					Workbook.Sheets.push(wsprops);
				}
				break;
			case 'Table':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].slice(-2) == "/>") break;
				else {
					table = xlml_parsexmltag(Rn[0]);
					state.push([Rn[3], false]);
					cstys = []; seencol = false;
				}
				break;
	
			case 'Style':
				if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
				else stag = xlml_parsexmltag(Rn[0]);
				break;
	
			case 'NumberFormat':
				stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
				if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
				for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == stag.nf) break;
				if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == null) { SSF.load(stag.nf, ssfidx); break; }
				break;
	
			case 'Column':
				if(state[state.length-1][0] !== 'Table') break;
				csty = xlml_parsexmltag(Rn[0]);
				if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
				if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
				if(!seencol && csty.wpx > 10) {
					seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
					for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
				}
				if(seencol) process_col(csty);
				cstys[(csty.Index-1||cstys.length)] = csty;
				for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
				break;
	
			case 'NamedRange':
				if(!Workbook.Names) Workbook.Names = [];
				var _NamedRange = parsexmltag(Rn[0]);
				var _DefinedName = ({
					Name: _NamedRange.Name,
					Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
				});
				if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
	Workbook.Names.push(_DefinedName);
				break;
	
			case 'NamedCell': break;
			case 'B': break;
			case 'I': break;
			case 'U': break;
			case 'S': break;
			case 'Sub': break;
			case 'Sup': break;
			case 'Span': break;
			case 'Alignment':
				break;
			case 'Borders': break;
			case 'Border': break;
			case 'Font':
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
				else fidx = Rn.index + Rn[0].length;
				break;
			case 'Interior':
				if(!opts.cellStyles) break;
				stag.Interior = xlml_parsexmltag(Rn[0]);
				break;
			case 'Protection': break;
	
			case 'Author':
			case 'Title':
			case 'Description':
			case 'Created':
			case 'Keywords':
			case 'Subject':
			case 'Category':
			case 'Company':
			case 'LastAuthor':
			case 'LastSaved':
			case 'LastPrinted':
			case 'Version':
			case 'Revision':
			case 'TotalTime':
			case 'HyperlinkBase':
			case 'Manager':
			case 'ContentStatus':
			case 'Identifier':
			case 'Language':
			case 'AppName':
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_prop(Props, Rn[3], str.slice(pidx, Rn.index));
				else pidx = Rn.index + Rn[0].length;
				break;
			case 'Paragraphs': break;
	
			case 'Styles':
			case 'Workbook':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else state.push([Rn[3], false]);
				break;
	
			case 'Comment':
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					xlml_clean_comment(comment);
					comments.push(comment);
				} else {
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					comment = ({a:tmp.Author});
				}
				break;
	
			case 'AutoFilter':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					var AutoFilter = xlml_parsexmltag(Rn[0]);
					cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
					state.push([Rn[3], true]);
				}
				break;
	
			case 'Name': break;
	
			case 'DataValidation':
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				} else {
					if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				}
				break;
	
			case 'ComponentOptions':
			case 'DocumentProperties':
			case 'CustomDocumentProperties':
			case 'OfficeDocumentSettings':
			case 'PivotTable':
			case 'PivotCache':
			case 'Names':
			case 'MapInfo':
			case 'PageBreaks':
			case 'QueryTable':
			case 'Sorting':
			case 'Schema':
			case 'data':
			case 'ConditionalFormatting':
			case 'SmartTagType':
			case 'SmartTags':
			case 'ExcelWorkbook':
			case 'WorkbookOptions':
			case 'WorksheetOptions':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
	
			default:
				/* FODS file root is <office:document> */
				if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
				/* UOS file root is <uof:UOF> */
				if(state.length == 0 && Rn[3] == "UOF") return parse_fods(str, opts);
	
				var seen = true;
				switch(state[state.length-1][0]) {
					/* OfficeDocumentSettings */
					case 'OfficeDocumentSettings': switch(Rn[3]) {
						case 'AllowPNG': break;
						case 'RemovePersonalInformation': break;
						case 'DownloadComponents': break;
						case 'LocationOfComponents': break;
						case 'Colors': break;
						case 'Color': break;
						case 'Index': break;
						case 'RGB': break;
						case 'PixelsPerInch': break; // TODO: set PPI
						case 'TargetScreenSize': break;
						case 'ReadOnlyRecommended': break;
						default: seen = false;
					} break;
	
					/* ComponentOptions */
					case 'ComponentOptions': switch(Rn[3]) {
						case 'Toolbar': break;
						case 'HideOfficeLogo': break;
						case 'SpreadsheetAutoFit': break;
						case 'Label': break;
						case 'Caption': break;
						case 'MaxHeight': break;
						case 'MaxWidth': break;
						case 'NextSheetNumber': break;
						default: seen = false;
					} break;
	
					/* ExcelWorkbook */
					case 'ExcelWorkbook': switch(Rn[3]) {
						case 'Date1904':
	Workbook.WBProps.date1904 = true;
							break;
						case 'WindowHeight': break;
						case 'WindowWidth': break;
						case 'WindowTopX': break;
						case 'WindowTopY': break;
						case 'TabRatio': break;
						case 'ProtectStructure': break;
						case 'ProtectWindow': break;
						case 'ProtectWindows': break;
						case 'ActiveSheet': break;
						case 'DisplayInkNotes': break;
						case 'FirstVisibleSheet': break;
						case 'SupBook': break;
						case 'SheetName': break;
						case 'SheetIndex': break;
						case 'SheetIndexFirst': break;
						case 'SheetIndexLast': break;
						case 'Dll': break;
						case 'AcceptLabelsInFormulas': break;
						case 'DoNotSaveLinkValues': break;
						case 'Iteration': break;
						case 'MaxIterations': break;
						case 'MaxChange': break;
						case 'Path': break;
						case 'Xct': break;
						case 'Count': break;
						case 'SelectedSheets': break;
						case 'Calculation': break;
						case 'Uncalced': break;
						case 'StartupPrompt': break;
						case 'Crn': break;
						case 'ExternName': break;
						case 'Formula': break;
						case 'ColFirst': break;
						case 'ColLast': break;
						case 'WantAdvise': break;
						case 'Boolean': break;
						case 'Error': break;
						case 'Text': break;
						case 'OLE': break;
						case 'NoAutoRecover': break;
						case 'PublishObjects': break;
						case 'DoNotCalculateBeforeSave': break;
						case 'Number': break;
						case 'RefModeR1C1': break;
						case 'EmbedSaveSmartTags': break;
						default: seen = false;
					} break;
	
					/* WorkbookOptions */
					case 'WorkbookOptions': switch(Rn[3]) {
						case 'OWCVersion': break;
						case 'Height': break;
						case 'Width': break;
						default: seen = false;
					} break;
	
					/* WorksheetOptions */
					case 'WorksheetOptions': switch(Rn[3]) {
						case 'Visible':
							if(Rn[0].slice(-2) === "/>"){/* empty */}
							else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
								case "SheetHidden": wsprops.Hidden = 1; break;
								case "SheetVeryHidden": wsprops.Hidden = 2; break;
							}
							else pidx = Rn.index + Rn[0].length;
							break;
						case 'Header':
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							cursheet['!margins'].header = parsexmltag(Rn[0]).Margin;
							break;
						case 'Footer':
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							cursheet['!margins'].footer = parsexmltag(Rn[0]).Margin;
							break;
						case 'PageMargins':
							var pagemargins = parsexmltag(Rn[0]);
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
							if(pagemargins.Top) cursheet['!margins'].top = pagemargins.Top;
							if(pagemargins.Left) cursheet['!margins'].left = pagemargins.Left;
							if(pagemargins.Right) cursheet['!margins'].right = pagemargins.Right;
							if(pagemargins.Bottom) cursheet['!margins'].bottom = pagemargins.Bottom;
							break;
						case 'DisplayRightToLeft':
							if(!Workbook.Views) Workbook.Views = [];
							if(!Workbook.Views[0]) Workbook.Views[0] = {};
							Workbook.Views[0].RTL = true;
							break;
	
						case 'FreezePanes': break;
						case 'FrozenNoSplit': break;
	
						case 'SplitHorizontal':
						case 'SplitVertical':
							break;
	
						case 'DoNotDisplayGridlines':
							break;
	
						case 'TopRowBottomPane': break;
						case 'LeftColumnRightPane': break;
	
						case 'Unsynced': break;
						case 'Print': break;
						case 'Panes': break;
						case 'Scale': break;
						case 'Pane': break;
						case 'Number': break;
						case 'Layout': break;
						case 'PageSetup': break;
						case 'Selected': break;
						case 'ProtectObjects': break;
						case 'EnableSelection': break;
						case 'ProtectScenarios': break;
						case 'ValidPrinterInfo': break;
						case 'HorizontalResolution': break;
						case 'VerticalResolution': break;
						case 'NumberofCopies': break;
						case 'ActiveRow': break;
						case 'ActiveCol': break;
						case 'ActivePane': break;
						case 'TopRowVisible': break;
						case 'LeftColumnVisible': break;
						case 'FitToPage': break;
						case 'RangeSelection': break;
						case 'PaperSizeIndex': break;
						case 'PageLayoutZoom': break;
						case 'PageBreakZoom': break;
						case 'FilterOn': break;
						case 'FitWidth': break;
						case 'FitHeight': break;
						case 'CommentsLayout': break;
						case 'Zoom': break;
						case 'LeftToRight': break;
						case 'Gridlines': break;
						case 'AllowSort': break;
						case 'AllowFilter': break;
						case 'AllowInsertRows': break;
						case 'AllowDeleteRows': break;
						case 'AllowInsertCols': break;
						case 'AllowDeleteCols': break;
						case 'AllowInsertHyperlinks': break;
						case 'AllowFormatCells': break;
						case 'AllowSizeCols': break;
						case 'AllowSizeRows': break;
						case 'NoSummaryRowsBelowDetail': break;
						case 'TabColorIndex': break;
						case 'DoNotDisplayHeadings': break;
						case 'ShowPageLayoutZoom': break;
						case 'NoSummaryColumnsRightDetail': break;
						case 'BlackAndWhite': break;
						case 'DoNotDisplayZeros': break;
						case 'DisplayPageBreak': break;
						case 'RowColHeadings': break;
						case 'DoNotDisplayOutline': break;
						case 'NoOrientation': break;
						case 'AllowUsePivotTables': break;
						case 'ZeroHeight': break;
						case 'ViewableRange': break;
						case 'Selection': break;
						case 'ProtectContents': break;
						default: seen = false;
					} break;
	
					/* PivotTable */
					case 'PivotTable': case 'PivotCache': switch(Rn[3]) {
						case 'ImmediateItemsOnDrop': break;
						case 'ShowPageMultipleItemLabel': break;
						case 'CompactRowIndent': break;
						case 'Location': break;
						case 'PivotField': break;
						case 'Orientation': break;
						case 'LayoutForm': break;
						case 'LayoutSubtotalLocation': break;
						case 'LayoutCompactRow': break;
						case 'Position': break;
						case 'PivotItem': break;
						case 'DataType': break;
						case 'DataField': break;
						case 'SourceName': break;
						case 'ParentField': break;
						case 'PTLineItems': break;
						case 'PTLineItem': break;
						case 'CountOfSameItems': break;
						case 'Item': break;
						case 'ItemType': break;
						case 'PTSource': break;
						case 'CacheIndex': break;
						case 'ConsolidationReference': break;
						case 'FileName': break;
						case 'Reference': break;
						case 'NoColumnGrand': break;
						case 'NoRowGrand': break;
						case 'BlankLineAfterItems': break;
						case 'Hidden': break;
						case 'Subtotal': break;
						case 'BaseField': break;
						case 'MapChildItems': break;
						case 'Function': break;
						case 'RefreshOnFileOpen': break;
						case 'PrintSetTitles': break;
						case 'MergeLabels': break;
						case 'DefaultVersion': break;
						case 'RefreshName': break;
						case 'RefreshDate': break;
						case 'RefreshDateCopy': break;
						case 'VersionLastRefresh': break;
						case 'VersionLastUpdate': break;
						case 'VersionUpdateableMin': break;
						case 'VersionRefreshableMin': break;
						case 'Calculation': break;
						default: seen = false;
					} break;
	
					/* PageBreaks */
					case 'PageBreaks': switch(Rn[3]) {
						case 'ColBreaks': break;
						case 'ColBreak': break;
						case 'RowBreaks': break;
						case 'RowBreak': break;
						case 'ColStart': break;
						case 'ColEnd': break;
						case 'RowEnd': break;
						default: seen = false;
					} break;
	
					/* AutoFilter */
					case 'AutoFilter': switch(Rn[3]) {
						case 'AutoFilterColumn': break;
						case 'AutoFilterCondition': break;
						case 'AutoFilterAnd': break;
						case 'AutoFilterOr': break;
						default: seen = false;
					} break;
	
					/* QueryTable */
					case 'QueryTable': switch(Rn[3]) {
						case 'Id': break;
						case 'AutoFormatFont': break;
						case 'AutoFormatPattern': break;
						case 'QuerySource': break;
						case 'QueryType': break;
						case 'EnableRedirections': break;
						case 'RefreshedInXl9': break;
						case 'URLString': break;
						case 'HTMLTables': break;
						case 'Connection': break;
						case 'CommandText': break;
						case 'RefreshInfo': break;
						case 'NoTitles': break;
						case 'NextId': break;
						case 'ColumnInfo': break;
						case 'OverwriteCells': break;
						case 'DoNotPromptForFile': break;
						case 'TextWizardSettings': break;
						case 'Source': break;
						case 'Number': break;
						case 'Decimal': break;
						case 'ThousandSeparator': break;
						case 'TrailingMinusNumbers': break;
						case 'FormatSettings': break;
						case 'FieldType': break;
						case 'Delimiters': break;
						case 'Tab': break;
						case 'Comma': break;
						case 'AutoFormatName': break;
						case 'VersionLastEdit': break;
						case 'VersionLastRefresh': break;
						default: seen = false;
					} break;
	
					case 'DataValidation':
					switch(Rn[3]) {
						case 'Range': break;
	
						case 'Type': break;
						case 'Min': break;
						case 'Max': break;
						case 'Sort': break;
						case 'Descending': break;
						case 'Order': break;
						case 'CaseSensitive': break;
						case 'Value': break;
						case 'ErrorStyle': break;
						case 'ErrorMessage': break;
						case 'ErrorTitle': break;
						case 'InputMessage': break;
						case 'InputTitle': break;
						case 'ComboHide': break;
						case 'InputHide': break;
						case 'Condition': break;
						case 'Qualifier': break;
						case 'UseBlank': break;
						case 'Value1': break;
						case 'Value2': break;
						case 'Format': break;
	
						case 'CellRangeList': break;
						default: seen = false;
					} break;
	
					case 'Sorting':
					case 'ConditionalFormatting':
					switch(Rn[3]) {
						case 'Range': break;
						case 'Type': break;
						case 'Min': break;
						case 'Max': break;
						case 'Sort': break;
						case 'Descending': break;
						case 'Order': break;
						case 'CaseSensitive': break;
						case 'Value': break;
						case 'ErrorStyle': break;
						case 'ErrorMessage': break;
						case 'ErrorTitle': break;
						case 'CellRangeList': break;
						case 'InputMessage': break;
						case 'InputTitle': break;
						case 'ComboHide': break;
						case 'InputHide': break;
						case 'Condition': break;
						case 'Qualifier': break;
						case 'UseBlank': break;
						case 'Value1': break;
						case 'Value2': break;
						case 'Format': break;
						default: seen = false;
					} break;
	
					/* MapInfo (schema) */
					case 'MapInfo': case 'Schema': case 'data': switch(Rn[3]) {
						case 'Map': break;
						case 'Entry': break;
						case 'Range': break;
						case 'XPath': break;
						case 'Field': break;
						case 'XSDType': break;
						case 'FilterOn': break;
						case 'Aggregate': break;
						case 'ElementType': break;
						case 'AttributeType': break;
					/* These are from xsd (XML Schema Definition) */
						case 'schema':
						case 'element':
						case 'complexType':
						case 'datatype':
						case 'all':
						case 'attribute':
						case 'extends': break;
	
						case 'row': break;
						default: seen = false;
					} break;
	
					/* SmartTags (can be anything) */
					case 'SmartTags': break;
	
					default: seen = false; break;
				}
				if(seen) break;
				/* CustomDocumentProperties */
				if(Rn[3].match(/!\[CDATA/)) break;
				if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
				if(state[state.length-1][0]==='CustomDocumentProperties') {
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") xlml_set_custprop(Custprops, Rn[3], cp, str.slice(pidx, Rn.index));
					else { cp = Rn; pidx = Rn.index + Rn[0].length; }
					break;
				}
				if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
		}
		var out = ({});
		if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
		out.SheetNames = sheetnames;
		out.Workbook = Workbook;
		out.SSF = SSF.get_table();
		out.Props = Props;
		out.Custprops = Custprops;
		return out;
	}
	
	function parse_xlml(data, opts) {
		fix_read_opts(opts=opts||{});
		switch(opts.type||"base64") {
			case "base64": return parse_xlml_xml(Base64.decode(data), opts);
			case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
			case "array": return parse_xlml_xml(a2s(data), opts);
		}
	}
	
	/* TODO */
	function write_props_xlml(wb, opts) {
		var o = [];
		/* DocumentProperties */
		if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
		/* CustomDocumentProperties */
		if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
		return o.join("");
	}
	/* TODO */
	function write_wb_xlml() {
		/* OfficeDocumentSettings */
		/* ExcelWorkbook */
		return "";
	}
	/* TODO */
	function write_sty_xlml(wb, opts) {
		/* Styles */
		var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
		opts.cellXfs.forEach(function(xf, id) {
			var payload = [];
			payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(SSF._table[xf.numFmtId])}));
			styles.push(writextag('Style', payload.join(""), {"ss:ID": "s" + (21+id)}));
		});
		return writextag("Styles", styles.join(""));
	}
	function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
	function write_names_xlml(wb) {
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != null) continue;
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return writextag("Names", out.join(""));
	}
	function write_ws_xlml_names(ws, opts, idx, wb) {
		if(!ws) return "";
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != idx) continue;
			/*switch(n.Name) {
				case "_": continue;
			}*/
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return out.join("");
	}
	/* WorksheetOptions */
	function write_ws_xlml_wsopts(ws, opts, idx, wb) {
		if(!ws) return "";
		var o = [];
		/* NOTE: spec technically allows any order, but stick with implied order */
	
		/* FitToPage */
		/* DoNotDisplayColHeaders */
		/* DoNotDisplayRowHeaders */
		/* ViewableRange */
		/* Selection */
		/* GridlineColor */
		/* Name */
		/* ExcelWorksheetType */
		/* IntlMacro */
		/* Unsynced */
		/* Selected */
		/* CodeName */
	
		if(ws['!margins']) {
			o.push("<PageSetup>");
			if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
			if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
			o.push(writextag("PageMargins", null, {
				'x:Bottom': ws['!margins'].bottom || "0.75",
				'x:Left': ws['!margins'].left || "0.7",
				'x:Right': ws['!margins'].right || "0.7",
				'x:Top': ws['!margins'].top || "0.75"
			}));
			o.push("</PageSetup>");
		}
	
		/* PageSetup */
		/* DisplayPageBreak */
		/* TransitionExpressionEvaluation */
		/* TransitionFormulaEntry */
		/* Print */
		/* Zoom */
		/* PageLayoutZoom */
		/* PageBreakZoom */
		/* ShowPageBreakZoom */
		/* DefaultRowHeight */
		/* DefaultColumnWidth */
		/* StandardWidth */
	
		if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
			/* Visible */
			if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
			else {
				/* Selected */
				for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
				if(i == idx) o.push("<Selected/>");
			}
		}
	
		/* LeftColumnVisible */
	
		if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");
	
		/* GridlineColorIndex */
		/* DisplayFormulas */
		/* DoNotDisplayGridlines */
		/* DoNotDisplayHeadings */
		/* DoNotDisplayOutline */
		/* ApplyAutomaticOutlineStyles */
		/* NoSummaryRowsBelowDetail */
		/* NoSummaryColumnsRightDetail */
		/* DoNotDisplayZeros */
		/* ActiveRow */
		/* ActiveColumn */
		/* FilterOn */
		/* RangeSelection */
		/* TopRowVisible */
		/* TopRowBottomPane */
		/* LeftColumnRightPane */
		/* ActivePane */
		/* SplitHorizontal */
		/* SplitVertical */
		/* FreezePanes */
		/* FrozenNoSplit */
		/* TabColorIndex */
		/* Panes */
	
		/* NOTE: Password not supported in XLML Format */
		if(ws['!protect']) {
			o.push(writetag("ProtectContents", "True"));
			if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
			if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
			if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
			else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
		[
			[ "formatCells", "AllowFormatCells" ],
			[ "formatColumns", "AllowSizeCols" ],
			[ "formatRows", "AllowSizeRows" ],
			[ "insertColumns", "AllowInsertCols" ],
			[ "insertRows", "AllowInsertRows" ],
			[ "insertHyperlinks", "AllowInsertHyperlinks" ],
			[ "deleteColumns", "AllowDeleteCols" ],
			[ "deleteRows", "AllowDeleteRows" ],
			[ "sort", "AllowSort" ],
			[ "autoFilter", "AllowFilter" ],
			[ "pivotTables", "AllowUsePivotTables" ]
		].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
		}
	
		if(o.length == 0) return "";
		return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
	}
	function write_ws_xlml_comment(comments) {
		return comments.map(function(c) {
			// TODO: formatted text
			var t = xlml_unfixstr(c.t||"");
			var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
			return writextag("Comment", d, {"ss:Author":c.a});
		}).join("");
	}
	function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
		if(!cell || (cell.v == undefined && cell.f == undefined)) return "";
	
		var attr = {};
		if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
		if(cell.F && cell.F.slice(0, ref.length) == ref) {
			var end = decode_cell(cell.F.slice(ref.length + 1));
			attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
		}
	
		if(cell.l && cell.l.Target) {
			attr["ss:HRef"] = escapexml(cell.l.Target);
			if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
		}
	
		if(ws['!merges']) {
			var marr = ws['!merges'];
			for(var mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
				if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
				if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
			}
		}
	
		var t = "", p = "";
		switch(cell.t) {
			case 'z': if(!opts.sheetStubs) return ""; break;
			case 'n': t = 'Number'; p = String(cell.v); break;
			case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
			case 'e': t = 'Error'; p = BErr[cell.v]; break;
			case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || SSF._table[14]; break;
			case 's': t = 'String'; p = escapexlml(cell.v||""); break;
		}
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		attr["ss:StyleID"] = "s" + (21+os);
		attr["ss:Index"] = addr.c + 1;
		var _v = (cell.v != null ? p : "");
		var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');
	
		if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);
	
		return writextag("Cell", m, attr);
	}
	function write_ws_xlml_row(R, row) {
		var o = '<Row ss:Index="' + (R+1) + '"';
		if(row) {
			if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
			if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
			if(row.hidden) o += ' ss:Hidden="1"';
		}
		return o + '>';
	}
	/* TODO */
	function write_ws_xlml_table(ws, opts, idx, wb) {
		if(!ws['!ref']) return "";
		var range = safe_decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var o = [];
		if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
			process_col(n);
			var w = !!n.width;
			var p = col_obj_w(i, n);
			var k = {"ss:Index":i+1};
			if(w) k['ss:Width'] = width2px(p.width);
			if(n.hidden) k['ss:Hidden']="1";
			o.push(writextag("Column",null,k));
		});
		var dense = Array.isArray(ws);
		for(var R = range.s.r; R <= range.e.r; ++R) {
			var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
			for(var C = range.s.c; C <= range.e.c; ++C) {
				var skip = false;
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					break;
				}
				if(skip) continue;
				var addr = {r:R,c:C};
				var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
				row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
			}
			row.push("</Row>");
			if(row.length > 2) o.push(row.join(""));
		}
		return o.join("");
	}
	function write_ws_xlml(idx, opts, wb) {
		var o = [];
		var s = wb.SheetNames[idx];
		var ws = wb.Sheets[s];
	
		var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Names>" + t + "</Names>");
	
		/* Table */
		t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Table>" + t + "</Table>");
	
		/* WorksheetOptions */
		o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
	
		return o.join("");
	}
	function write_xlml(wb, opts) {
		if(!opts) opts = {};
		if(!wb.SSF) wb.SSF = SSF.get_table();
		if(wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
			opts.cellXfs = [];
			get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
		}
		var d = [];
		d.push(write_props_xlml(wb, opts));
		d.push(write_wb_xlml(wb, opts));
		d.push("");
		d.push("");
		for(var i = 0; i < wb.SheetNames.length; ++i)
			d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
		d[2] = write_sty_xlml(wb, opts);
		d[3] = write_names_xlml(wb, opts);
		return XML_HEADER + writextag("Workbook", d.join(""), {
			'xmlns':      XLMLNS.ss,
			'xmlns:o':    XLMLNS.o,
			'xmlns:x':    XLMLNS.x,
			'xmlns:ss':   XLMLNS.ss,
			'xmlns:dt':   XLMLNS.dt,
			'xmlns:html': XLMLNS.html
		});
	}
	/* [MS-OLEDS] 2.3.8 CompObjStream */
	function parse_compobj(obj) {
		var v = {};
		var o = obj.content;
	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
		o.l = 28;
	
		v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
		v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
	
		if(o.length - o.l <= 4) return v;
	
		var m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");
	
		if(o.length - o.l <= 4) return v;
		m = o.read_shift(4);
		if(m !== 0x71b239f4) return v;
		v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
	
		m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
	}
	
	/*
		Continue logic for:
		- 2.4.58 Continue
		- 2.4.59 ContinueBigName
		- 2.4.60 ContinueFrt
		- 2.4.61 ContinueFrt11
		- 2.4.62 ContinueFrt12
	*/
	function slurp(R, blob, length, opts) {
		var l = length;
		var bufs = [];
		var d = blob.slice(blob.l,blob.l+l);
		if(opts && opts.enc && opts.enc.insitu) switch(R.n) {
		case 'BOF': case 'FilePass': case 'FileLock': case 'InterfaceHdr': case 'RRDInfo': case 'RRDHead': case 'UsrExcl': break;
		default:
			if(d.length === 0) break;
			opts.enc.insitu(d);
		}
		bufs.push(d);
		blob.l += l;
		var next = (XLSRecordEnum[__readUInt16LE(blob,blob.l)]);
		var start = 0;
		while(next != null && next.n.slice(0,8) === 'Continue') {
			l = __readUInt16LE(blob,blob.l+2);
			start = blob.l + 4;
			if(next.n == 'ContinueFrt') start += 4;
			else if(next.n.slice(0,11) == 'ContinueFrt') start += 12;
			bufs.push(blob.slice(start,blob.l+4+l));
			blob.l += 4+l;
			next = (XLSRecordEnum[__readUInt16LE(blob, blob.l)]);
		}
		var b = (bconcat(bufs));
		prep_blob(b, 0);
		var ll = 0; b.lens = [];
		for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
		return R.f(b, b.length, opts);
	}
	
	function safe_format_xf(p, opts, date1904) {
		if(p.t === 'z') return;
		if(!p.XF) return;
		var fmtid = 0;
		try {
			fmtid = p.z || p.XF.numFmtId || 0;
			if(opts.cellNF) p.z = SSF._table[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts || opts.cellText !== false) try {
			if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
			else if(fmtid === 0 || fmtid == "General") {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
					else p.w = SSF._general_num(p.v);
				}
				else p.w = SSF._general(p.v);
			}
			else p.w = SSF.format(fmtid,p.v, {date1904:!!date1904});
		} catch(e) { if(opts.WTF) throw e; }
		if(opts.cellDates && fmtid && p.t == 'n' && SSF.is_date(SSF._table[fmtid] || String(fmtid))) {
			var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	}
	
	function make_cell(val, ixfe, t) {
		return ({v:val, ixfe:ixfe, t:t});
	}
	
	// 2.3.2
	function parse_workbook(blob, options) {
		var wb = ({opts:{}});
		var Sheets = {};
		if(DENSE != null && options.dense == null) options.dense = DENSE;
		var out = ((options.dense ? [] : {}));
		var Directory = {};
		var range = ({});
		var last_formula = null;
		var sst = ([]);
		var cur_sheet = "";
		var Preamble = {};
		var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
		var sharedf = {};
		var arrayf = [];
		var temp_val;
		var country;
		var cell_valid = true;
		var XFs = []; /* XF records */
		var palette = [];
		var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
		var get_rgb = function getrgb(icv) {
			if(icv < 8) return XLSIcv[icv];
			if(icv < 64) return palette[icv-8] || XLSIcv[icv];
			return XLSIcv[icv];
		};
		var process_cell_style = function pcs(cell, line, options) {
			var xfd = line.XF.data;
			if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
			line.s = ({});
			line.s.patternType = xfd.patternType;
			var t;
			if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
			if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
		};
		var addcell = function addcell(cell, line, options) {
			if(file_depth > 1) return;
			if(options.sheetRows && cell.r >= options.sheetRows) cell_valid = false;
			if(!cell_valid) return;
			if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
			delete line.ixfe; delete line.XF;
			lastcell = cell;
			last_cell = encode_cell(cell);
			if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
			if(cell.r < range.s.r) range.s.r = cell.r;
			if(cell.c < range.s.c) range.s.c = cell.c;
			if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
			if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
			if(options.cellFormula && line.f) {
				for(var afi = 0; afi < arrayf.length; ++afi) {
					if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
					if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
					line.F = encode_range(arrayf[afi][0]);
					if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
					if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
					break;
				}
			}
			{
				if(options.dense) {
					if(!out[cell.r]) out[cell.r] = [];
					out[cell.r][cell.c] = line;
				} else out[last_cell] = line;
			}
		};
		var opts = ({
			enc: false, // encrypted
			sbcch: 0, // cch in the preceding SupBook
			snames: [], // sheetnames
			sharedf: sharedf, // shared formulae by address
			arrayf: arrayf, // array formulae array
			rrtabid: [], // RRTabId
			lastuser: "", // Last User from WriteAccess
			biff: 8, // BIFF version
			codepage: 0, // CP from CodePage record
			winlocked: 0, // fLockWn from WinProtect
			cellStyles: !!options && !!options.cellStyles,
			WTF: !!options && !!options.wtf
		});
		if(options.password) opts.password = options.password;
		var themes;
		var merges = [];
		var objects = [];
		var colinfo = [], rowinfo = [];
		// eslint-disable-next-line no-unused-vars
		var defwidth = 0, defheight = 0; // twips / MDW respectively
		var seencol = false;
		var supbooks = ([]); // 1-indexed, will hold extern names
		supbooks.SheetNames = opts.snames;
		supbooks.sharedf = opts.sharedf;
		supbooks.arrayf = opts.arrayf;
		supbooks.names = [];
		supbooks.XTI = [];
		var last_Rn = '';
		var file_depth = 0; /* TODO: make a real stack */
		var BIFF2Fmt = 0, BIFF2FmtTable = [];
		var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
		var last_lbl;
	
		/* explicit override for some broken writers */
		opts.codepage = 1200;
		set_cp(1200);
		var seen_codepage = false;
		while(blob.l < blob.length - 1) {
			var s = blob.l;
			var RecordType = blob.read_shift(2);
			if(RecordType === 0 && last_Rn === 'EOF') break;
			var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
			var R = XLSRecordEnum[RecordType];
			//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
			//if(!R) console.log(blob.slice(blob.l, blob.l + length));
			if(R && R.f) {
				if(options.bookSheets) {
					if(last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
				}
				last_Rn = R.n;
				if(R.r === 2 || R.r == 12) {
					var rt = blob.read_shift(2); length -= 2;
					if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
					if(R.r == 12){ blob.l += 10; length -= 10; } // skip FRT
				}
				//console.error(R,blob.l,length,blob.length);
				var val = ({});
				if(R.n === 'EOF') val = R.f(blob, length, opts);
				else val = slurp(R, blob, length, opts);
				var Rn = R.n;
	if(file_depth == 0 && Rn != 'BOF') continue;
				/* nested switch statements to workaround V8 128 limit */
				switch(Rn) {
					/* Workbook Options */
					case 'Date1904':
	wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
					case 'WriteProtect': wb.opts.WriteProtect = true; break;
					case 'FilePass':
						if(!opts.enc) blob.l = 0;
						opts.enc = val;
						if(!options.password) throw new Error("File is password-protected");
						if(val.valid == null) throw new Error("Encryption scheme unsupported");
						if(!val.valid) throw new Error("Password is incorrect");
						break;
					case 'WriteAccess': opts.lastuser = val; break;
					case 'FileSharing': break; //TODO
					case 'CodePage':
						var cpval = Number(val);
						/* overrides based on test cases */
						switch(cpval) {
							case 0x5212: cpval =  1200; break;
							case 0x8000: cpval = 10000; break;
							case 0x8001: cpval =  1252; break;
						}
						set_cp(opts.codepage = cpval);
						seen_codepage = true;
						break;
					case 'RRTabId': opts.rrtabid = val; break;
					case 'WinProtect': opts.winlocked = val; break;
					case 'Template': break; // TODO
					case 'BookBool': break; // TODO
					case 'UsesELFs': break;
					case 'MTRSettings': break;
					case 'RefreshAll':
					case 'CalcCount':
					case 'CalcDelta':
					case 'CalcIter':
					case 'CalcMode':
					case 'CalcPrecision':
					case 'CalcSaveRecalc':
						wb.opts[Rn] = val; break;
					case 'CalcRefMode': opts.CalcRefMode = val; break; // TODO: implement R1C1
					case 'Uncalced': break;
					case 'ForceFullCalculation': wb.opts.FullCalc = val; break;
					case 'WsBool':
						if(val.fDialog) out["!type"] = "dialog";
						break; // TODO
					case 'XF':
						XFs.push(val); break;
					case 'ExtSST': break; // TODO
					case 'BookExt': break; // TODO
					case 'RichTextStream': break;
					case 'BkHim': break;
	
					case 'SupBook':
						supbooks.push([val]);
						supbooks[supbooks.length-1].XTI = [];
						break;
					case 'ExternName':
						supbooks[supbooks.length-1].push(val);
						break;
					case 'Index': break; // TODO
					case 'Lbl':
						last_lbl = ({
							Name: val.Name,
							Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
						});
						if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
						supbooks.names.push(last_lbl);
						if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length-1].push(val);
						if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
							if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
								FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
						break;
					case 'ExternCount': opts.ExternCount = val; break;
					case 'ExternSheet':
						if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
					case 'NameCmt':
						/* TODO: search for correct name */
						if(opts.biff < 8) break;
						if(last_lbl != null) last_lbl.Comment = val[1];
						break;
	
					case 'Protect': out["!protect"] = val; break; /* for sheet or book */
					case 'Password': if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
					case 'Prot4Rev': case 'Prot4RevPass': break; /*TODO: Revision Control*/
	
					case 'BoundSheet8': {
						Directory[val.pos] = val;
						opts.snames.push(val.name);
					} break;
					case 'EOF': {
						if(--file_depth) break;
						if(range.e) {
							if(range.e.r > 0 && range.e.c > 0) {
								range.e.r--; range.e.c--;
								out["!ref"] = encode_range(range);
								if(options.sheetRows && options.sheetRows <= range.e.r) {
									var tmpri = range.e.r;
									range.e.r = options.sheetRows - 1;
									out["!fullref"] = out["!ref"];
									out["!ref"] = encode_range(range);
									range.e.r = tmpri;
								}
								range.e.r++; range.e.c++;
							}
							if(merges.length > 0) out["!merges"] = merges;
							if(objects.length > 0) out["!objects"] = objects;
							if(colinfo.length > 0) out["!cols"] = colinfo;
							if(rowinfo.length > 0) out["!rows"] = rowinfo;
							Workbook.Sheets.push(wsprops);
						}
						if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
						out = ((options.dense ? [] : {}));
					} break;
					case 'BOF': {
						if(opts.biff === 8) opts.biff = {
	0x0009:2,
	0x0209:3,
	0x0409:4
						}[RecordType] || {
	0x0200:2,
	0x0300:3,
	0x0400:4,
	0x0500:5,
	0x0600:8,
	0x0002:2,
	0x0007:2
						}[val.BIFFVer] || 8;
						if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
						if(file_depth++) break;
						cell_valid = true;
						out = ((options.dense ? [] : {}));
	
						if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
						if(opts.biff < 5) {
							if(cur_sheet === "") cur_sheet = "Sheet1";
							range = {s:{r:0,c:0},e:{r:0,c:0}};
							/* fake BoundSheet8 */
							var fakebs8 = {pos: blob.l - length, name:cur_sheet};
							Directory[fakebs8.pos] = fakebs8;
							opts.snames.push(cur_sheet);
						}
						else cur_sheet = (Directory[s] || {name:""}).name;
						if(val.dt == 0x20) out["!type"] = "chart";
						if(val.dt == 0x40) out["!type"] = "macro";
						merges = [];
						objects = [];
						opts.arrayf = arrayf = [];
						colinfo = []; rowinfo = [];
						defwidth = defheight = 0;
						seencol = false;
						wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
					} break;
	
					case 'Number': case 'BIFF2NUM': case 'BIFF2INT': {
						if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'BoolErr': {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'RK': {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'MulRk': {
						for(var j = val.c; j <= val.C; ++j) {
							var ixfe = val.rkrec[j-val.c][0];
							temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:j, r:val.r}, temp_val, options);
						}
					} break;
					case 'Formula': {
						if(val.val == 'String') { last_formula = val; break; }
						temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							var _f = val.formula;
							if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
								var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
								var _fe = encode_cell({r:_fr, c:_fc});
								if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
								else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
							} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(val.cell, temp_val, options);
						last_formula = val;
					} break;
					case 'String': {
						if(last_formula) { /* technically always true */
							last_formula.val = val;
							temp_val = make_cell(val, last_formula.cell.ixfe, 's');
							temp_val.XF = XFs[temp_val.ixfe];
							if(options.cellFormula) {
								temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
							}
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell(last_formula.cell, temp_val, options);
							last_formula = null;
						} else throw new Error("String record expects Formula");
					} break;
					case 'Array': {
						arrayf.push(val);
						var _arraystart = encode_cell(val[0].s);
						cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
						if(options.cellFormula && cc) {
							if(!last_formula) break; /* technically unreachable */
							if(!_arraystart || !cc) break;
							cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
							cc.F = encode_range(val[0]);
						}
					} break;
					case 'ShrFmla': {
						if(!cell_valid) break;
						if(!options.cellFormula) break;
						if(last_cell) {
							/* TODO: capture range */
							if(!last_formula) break; /* technically unreachable */
							sharedf[encode_cell(last_formula.cell)]= val[0];
							cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
							(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
						}
					} break;
					case 'LabelSst':
						temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
						if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 'Blank': if(options.sheetStubs) {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'MulBlank': if(options.sheetStubs) {
						for(var _j = val.c; _j <= val.C; ++_j) {
							var _ixfe = val.ixfe[_j-val.c];
							temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:_j, r:val.r}, temp_val, options);
						}
					} break;
					case 'RString':
					case 'Label': case 'BIFF2STR':
						temp_val=make_cell(val.val, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
	
					case 'Dimensions': {
						if(file_depth === 1) range = val; /* TODO: stack */
					} break;
					case 'SST': {
						sst = val;
					} break;
					case 'Format': { /* val = [id, fmt] */
						if(opts.biff == 4) {
							BIFF2FmtTable[BIFF2Fmt++] = val[1];
							for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(SSF._table[b4idx] == val[1]) break;
							if(b4idx >= 163) SSF.load(val[1], BIFF2Fmt + 163);
						}
						else SSF.load(val[1], val[0]);
					} break;
					case 'BIFF2FORMAT': {
						BIFF2FmtTable[BIFF2Fmt++] = val;
						for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(SSF._table[b2idx] == val) break;
						if(b2idx >= 163) SSF.load(val, BIFF2Fmt + 163);
					} break;
	
					case 'MergeCells': merges = merges.concat(val); break;
	
					case 'Obj': objects[val.cmo[0]] = opts.lastobj = val; break;
					case 'TxO': opts.lastobj.TxO = val; break;
					case 'ImData': opts.lastobj.ImData = val; break;
	
					case 'HLink': {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc) cc.l = val[1];
							}
					} break;
					case 'HLinkTooltip': {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc && cc.l) cc.l.Tooltip = val[1];
								}
					} break;
	
					/* Comments */
					case 'Note': {
						if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
						cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
						var noteobj = objects[val[2]];
						if(!cc) {
							if(options.dense) {
								if(!out[val[0].r]) out[val[0].r] = [];
								cc = out[val[0].r][val[0].c] = ({t:"z"});
							} else {
								cc = out[encode_cell(val[0])] = ({t:"z"});
							}
							range.e.r = Math.max(range.e.r, val[0].r);
							range.s.r = Math.min(range.s.r, val[0].r);
							range.e.c = Math.max(range.e.c, val[0].c);
							range.s.c = Math.min(range.s.c, val[0].c);
						}
						if(!cc.c) cc.c = [];
						cmnt = {a:val[1],t:noteobj.TxO.t};
						cc.c.push(cmnt);
					} break;
	
					default: switch(R.n) { /* nested */
					case 'ClrtClient': break;
					case 'XFExt': update_xfext(XFs[val.ixfe], val.ext); break;
	
					case 'DefColWidth': defwidth = val; break;
					case 'DefaultRowHeight': defheight = val[1]; break; // TODO: flags
	
					case 'ColInfo': {
						if(!opts.cellStyles) break;
						while(val.e >= val.s) {
							colinfo[val.e--] = { width: val.w/256 };
							if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
							process_col(colinfo[val.e+1]);
						}
					} break;
					case 'Row': {
						var rowobj = {};
						if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
						if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
						if(val.hpt) {
							rowinfo[val.r] = rowobj;
							rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
						}
					} break;
	
					case 'LeftMargin':
					case 'RightMargin':
					case 'TopMargin':
					case 'BottomMargin':
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'][Rn.slice(0,-6).toLowerCase()] = val;
						break;
	
					case 'Setup': // TODO
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'].header = val.header;
						out['!margins'].footer = val.footer;
						break;
	
					case 'Window2': // TODO
						// $FlowIgnore
						if(val.RTL) Workbook.Views[0].RTL = true;
						break;
	
					case 'Header': break; // TODO
					case 'Footer': break; // TODO
					case 'HCenter': break; // TODO
					case 'VCenter': break; // TODO
					case 'Pls': break; // TODO
					case 'GCW': break;
					case 'LHRecord': break;
					case 'DBCell': break; // TODO
					case 'EntExU2': break; // TODO
					case 'SxView': break; // TODO
					case 'Sxvd': break; // TODO
					case 'SXVI': break; // TODO
					case 'SXVDEx': break; // TODO
					case 'SxIvd': break; // TODO
					case 'SXString': break; // TODO
					case 'Sync': break;
					case 'Addin': break;
					case 'SXDI': break; // TODO
					case 'SXLI': break; // TODO
					case 'SXEx': break; // TODO
					case 'QsiSXTag': break; // TODO
					case 'Selection': break;
					case 'Feat': break;
					case 'FeatHdr': case 'FeatHdr11': break;
					case 'Feature11': case 'Feature12': case 'List12': break;
					case 'Country': country = val; break;
					case 'RecalcId': break;
					case 'DxGCol': break; // TODO: htmlify
					case 'Fbi': case 'Fbi2': case 'GelFrame': break;
					case 'Font': break; // TODO
					case 'XFCRC': break; // TODO
					case 'Style': break; // TODO
					case 'StyleExt': break; // TODO
					case 'Palette': palette = val; break;
					case 'Theme': themes = val; break;
					/* Protection */
					case 'ScenarioProtect': break;
					case 'ObjProtect': break;
	
					/* Conditional Formatting */
					case 'CondFmt12': break;
	
					/* Table */
					case 'Table': break; // TODO
					case 'TableStyles': break; // TODO
					case 'TableStyle': break; // TODO
					case 'TableStyleElement': break; // TODO
	
					/* PivotTable */
					case 'SXStreamID': break; // TODO
					case 'SXVS': break; // TODO
					case 'DConRef': break; // TODO
					case 'SXAddl': break; // TODO
					case 'DConBin': break; // TODO
					case 'DConName': break; // TODO
					case 'SXPI': break; // TODO
					case 'SxFormat': break; // TODO
					case 'SxSelect': break; // TODO
					case 'SxRule': break; // TODO
					case 'SxFilt': break; // TODO
					case 'SxItm': break; // TODO
					case 'SxDXF': break; // TODO
	
					/* Scenario Manager */
					case 'ScenMan': break;
	
					/* Data Consolidation */
					case 'DCon': break;
	
					/* Watched Cell */
					case 'CellWatch': break;
	
					/* Print Settings */
					case 'PrintRowCol': break;
					case 'PrintGrid': break;
					case 'PrintSize': break;
	
					case 'XCT': break;
					case 'CRN': break;
	
					case 'Scl': {
						//console.log("Zoom Level:", val[0]/val[1],val);
					} break;
					case 'SheetExt': {
						/* empty */
					} break;
					case 'SheetExtOptional': {
						/* empty */
					} break;
	
					/* VBA */
					case 'ObNoMacros': {
						/* empty */
					} break;
					case 'ObProj': {
						/* empty */
					} break;
					case 'CodeName': {
	if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
						else wsprops.CodeName = val || wsprops.name;
					} break;
					case 'GUIDTypeLib': {
						/* empty */
					} break;
	
					case 'WOpt': break; // TODO: WTF?
					case 'PhoneticInfo': break;
	
					case 'OleObjectSize': break;
	
					/* Differential Formatting */
					case 'DXF': case 'DXFN': case 'DXFN12': case 'DXFN12List': case 'DXFN12NoCB': break;
	
					/* Data Validation */
					case 'Dv': case 'DVal': break;
	
					/* Data Series */
					case 'BRAI': case 'Series': case 'SeriesText': break;
	
					/* Data Connection */
					case 'DConn': break;
					case 'DbOrParamQry': break;
					case 'DBQueryExt': break;
	
					case 'OleDbConn': break;
					case 'ExtString': break;
	
					/* Formatting */
					case 'IFmtRecord': break;
					case 'CondFmt': case 'CF': case 'CF12': case 'CFEx': break;
	
					/* Explicitly Ignored */
					case 'Excel9File': break;
					case 'Units': break;
					case 'InterfaceHdr': case 'Mms': case 'InterfaceEnd': case 'DSF': break;
					case 'BuiltInFnGroupCount': /* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */ break;
					/* View Stuff */
					case 'Window1': case 'HideObj': case 'GridSet': case 'Guts':
					case 'UserBView': case 'UserSViewBegin': case 'UserSViewEnd': break;
					case 'Pane': break;
					default: switch(R.n) { /* nested */
					/* Chart */
					case 'Dat':
					case 'Begin': case 'End':
					case 'StartBlock': case 'EndBlock':
					case 'Frame': case 'Area':
					case 'Axis': case 'AxisLine': case 'Tick': break;
					case 'AxesUsed':
					case 'CrtLayout12': case 'CrtLayout12A': case 'CrtLink': case 'CrtLine': case 'CrtMlFrt': case 'CrtMlFrtContinue': break;
					case 'LineFormat': case 'AreaFormat':
					case 'Chart': case 'Chart3d': case 'Chart3DBarShape': case 'ChartFormat': case 'ChartFrtInfo': break;
					case 'PlotArea': case 'PlotGrowth': break;
					case 'SeriesList': case 'SerParent': case 'SerAuxTrend': break;
					case 'DataFormat': case 'SerToCrt': case 'FontX': break;
					case 'CatSerRange': case 'AxcExt': case 'SerFmt': break;
					case 'ShtProps': break;
					case 'DefaultText': case 'Text': case 'CatLab': break;
					case 'DataLabExtContents': break;
					case 'Legend': case 'LegendException': break;
					case 'Pie': case 'Scatter': break;
					case 'PieFormat': case 'MarkerFormat': break;
					case 'StartObject': case 'EndObject': break;
					case 'AlRuns': case 'ObjectLink': break;
					case 'SIIndex': break;
					case 'AttachedLabel': case 'YMult': break;
	
					/* Chart Group */
					case 'Line': case 'Bar': break;
					case 'Surf': break;
	
					/* Axis Group */
					case 'AxisParent': break;
					case 'Pos': break;
					case 'ValueRange': break;
	
					/* Pivot Chart */
					case 'SXViewEx9': break; // TODO
					case 'SXViewLink': break;
					case 'PivotChartBits': break;
					case 'SBaseRef': break;
					case 'TextPropsStream': break;
	
					/* Chart Misc */
					case 'LnExt': break;
					case 'MkrExt': break;
					case 'CrtCoopt': break;
	
					/* Query Table */
					case 'Qsi': case 'Qsif': case 'Qsir': case 'QsiSXTag': break;
					case 'TxtQry': break;
	
					/* Filter */
					case 'FilterMode': break;
					case 'AutoFilter': case 'AutoFilterInfo': break;
					case 'AutoFilter12': break;
					case 'DropDownObjIds': break;
					case 'Sort': break;
					case 'SortData': break;
	
					/* Drawing */
					case 'ShapePropsStream': break;
					case 'MsoDrawing': case 'MsoDrawingGroup': case 'MsoDrawingSelection': break;
					/* Pub Stuff */
					case 'WebPub': case 'AutoWebPub': break;
	
					/* Print Stuff */
					case 'HeaderFooter': case 'HFPicture': case 'PLV':
					case 'HorizontalPageBreaks': case 'VerticalPageBreaks': break;
					/* Behavioral */
					case 'Backup': case 'CompressPictures': case 'Compat12': break;
	
					/* Should not Happen */
					case 'Continue': case 'ContinueFrt12': break;
	
					/* Future Records */
					case 'FrtFontList': case 'FrtWrapper': break;
	
					default: switch(R.n) { /* nested */
					/* BIFF5 records */
					case 'TabIdConf': case 'Radar': case 'RadarArea': case 'DropBar': case 'Intl': case 'CoordList': case 'SerAuxErrBar': break;
	
					/* BIFF2-4 records */
					case 'BIFF2FONTCLR': case 'BIFF2FMTCNT': case 'BIFF2FONTXTRA': break;
					case 'BIFF2XF': case 'BIFF3XF': case 'BIFF4XF': break;
					case 'BIFF4FMTCNT': case 'BIFF2ROW': case 'BIFF2WINDOW2': break;
	
					/* Miscellaneous */
					case 'SCENARIO': case 'DConBin': case 'PicF': case 'DataLabExt':
					case 'Lel': case 'BopPop': case 'BopPopCustom': case 'RealTimeData':
					case 'Name': break;
					case 'LHNGraph': case 'FnGroupName': case 'AddMenu': case 'LPr': break;
					case 'ListObj': case 'ListField': break;
					case 'RRSort': break;
					case 'BigName': break;
					case 'ToolbarHdr': case 'ToolbarEnd': break;
					case 'DDEObjName': break;
					case 'FRTArchId$': break;
					default: if(options.WTF) throw 'Unrecognized Record ' + R.n;
				}}}}
			} else blob.l += length;
		}
		wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
		if(!options.bookSheets) wb.Sheets=Sheets;
		if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
		wb.Preamble=Preamble;
		wb.Strings = sst;
		wb.SSF = SSF.get_table();
		if(opts.enc) wb.Encryption = opts.enc;
		if(themes) wb.Themes = themes;
		wb.Metadata = {};
		if(country !== undefined) wb.Metadata.Country = country;
		if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
		wb.Workbook = Workbook;
		return wb;
	}
	
	/* TODO: split props*/
	var PSCLSID = {
		SI: "e0859ff2f94f6810ab9108002b27b3d9",
		DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
		UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
	};
	function parse_xls_props(cfb, props, o) {
		/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
		var DSI = CFB.find(cfb, '!DocumentSummaryInformation');
		if(DSI && DSI.size > 0) try {
			var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
			for(var d in DocSummary) props[d] = DocSummary[d];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
		var SI = CFB.find(cfb, '!SummaryInformation');
		if(SI && SI.size > 0) try {
			var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
			for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		if(props.HeadingPairs && props.TitlesOfParts) {
			load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
			delete props.HeadingPairs; delete props.TitlesOfParts;
		}
	}
	function write_xls_props(wb, cfb) {
		var DSEntries = [], SEntries = [], CEntries = [];
		var i = 0, Keys;
		if(wb.Props) {
			Keys = keys(wb.Props);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) (DocSummaryRE.hasOwnProperty(Keys[i]) ? DSEntries : SummaryRE.hasOwnProperty(Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
		}
		if(wb.Custprops) {
			Keys = keys(wb.Custprops);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) if(!(wb.Props||{}).hasOwnProperty(Keys[i])) (DocSummaryRE.hasOwnProperty(Keys[i]) ? DSEntries : SummaryRE.hasOwnProperty(Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
		}
		var CEntries2 = [];
		for(i = 0; i < CEntries.length; ++i) {
			if(XLSPSSkip.indexOf(CEntries[i][0]) > -1) continue;
			if(CEntries[i][1] == null) continue;
			CEntries2.push(CEntries[i]);
		}
		if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
		if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
	}
	
	function parse_xlscfb(cfb, options) {
	if(!options) options = {};
	fix_read_opts(options);
	reset_cp();
	if(options.codepage) set_ansi(options.codepage);
	var CompObj, WB;
	if(cfb.FullPaths) {
		if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
		CompObj = CFB.find(cfb, '!CompObj');
		WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
	} else {
		switch(options.type) {
			case 'base64': cfb = s2a(Base64.decode(cfb)); break;
			case 'binary': cfb = s2a(cfb); break;
			case 'buffer': break;
			case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
		}
		prep_blob(cfb, 0);
		WB = ({content: cfb});
	}
	var WorkbookP;
	
	var _data;
	if(CompObj) parse_compobj(CompObj);
	if(options.bookProps && !options.bookSheets) WorkbookP = ({});
	else {
		var T = has_buf ? 'buffer' : 'array';
		if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
		/* Quattro Pro 7-8 */
		else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Quattro Pro 9 */
		else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		else throw new Error("Cannot find Workbook stream");
		if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
	}
	
	var props = {};
	if(cfb.FullPaths) parse_xls_props(cfb, props, options);
	
	WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
	if(options.bookFiles) WorkbookP.cfb = cfb;
	/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
	return WorkbookP;
	}
	
	
	function write_xlscfb(wb, opts) {
		var o = opts || {};
		var cfb = CFB.utils.cfb_new({root:"R"});
		var wbpath = "/Workbook";
		switch(o.bookType || "xls") {
			case "xls": o.bookType = "biff8";
			/* falls through */
			case "xla": if(!o.bookType) o.bookType = "xla";
			/* falls through */
			case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
			case "biff5": wbpath = "/Book"; o.biff = 5; break;
			default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
		}
		CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
		if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
		// TODO: SI, DSI, CO
		if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
		return cfb;
	}
	/* [MS-XLSB] 2.3 Record Enumeration */
	var XLSBRecordEnum = {
	0x0000: { n:"BrtRowHdr", f:parse_BrtRowHdr },
	0x0001: { n:"BrtCellBlank", f:parse_BrtCellBlank },
	0x0002: { n:"BrtCellRk", f:parse_BrtCellRk },
	0x0003: { n:"BrtCellError", f:parse_BrtCellError },
	0x0004: { n:"BrtCellBool", f:parse_BrtCellBool },
	0x0005: { n:"BrtCellReal", f:parse_BrtCellReal },
	0x0006: { n:"BrtCellSt", f:parse_BrtCellSt },
	0x0007: { n:"BrtCellIsst", f:parse_BrtCellIsst },
	0x0008: { n:"BrtFmlaString", f:parse_BrtFmlaString },
	0x0009: { n:"BrtFmlaNum", f:parse_BrtFmlaNum },
	0x000A: { n:"BrtFmlaBool", f:parse_BrtFmlaBool },
	0x000B: { n:"BrtFmlaError", f:parse_BrtFmlaError },
	0x0010: { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ },
	0x0013: { n:"BrtSSTItem", f:parse_RichStr },
	0x0014: { n:"BrtPCDIMissing" },
	0x0015: { n:"BrtPCDINumber" },
	0x0016: { n:"BrtPCDIBoolean" },
	0x0017: { n:"BrtPCDIError" },
	0x0018: { n:"BrtPCDIString" },
	0x0019: { n:"BrtPCDIDatetime" },
	0x001A: { n:"BrtPCDIIndex" },
	0x001B: { n:"BrtPCDIAMissing" },
	0x001C: { n:"BrtPCDIANumber" },
	0x001D: { n:"BrtPCDIABoolean" },
	0x001E: { n:"BrtPCDIAError" },
	0x001F: { n:"BrtPCDIAString" },
	0x0020: { n:"BrtPCDIADatetime" },
	0x0021: { n:"BrtPCRRecord" },
	0x0022: { n:"BrtPCRRecordDt" },
	0x0023: { n:"BrtFRTBegin" },
	0x0024: { n:"BrtFRTEnd" },
	0x0025: { n:"BrtACBegin" },
	0x0026: { n:"BrtACEnd" },
	0x0027: { n:"BrtName", f:parse_BrtName },
	0x0028: { n:"BrtIndexRowBlock" },
	0x002A: { n:"BrtIndexBlock" },
	0x002B: { n:"BrtFont", f:parse_BrtFont },
	0x002C: { n:"BrtFmt", f:parse_BrtFmt },
	0x002D: { n:"BrtFill", f:parse_BrtFill },
	0x002E: { n:"BrtBorder", f:parse_BrtBorder },
	0x002F: { n:"BrtXF", f:parse_BrtXF },
	0x0030: { n:"BrtStyle" },
	0x0031: { n:"BrtCellMeta" },
	0x0032: { n:"BrtValueMeta" },
	0x0033: { n:"BrtMdb" },
	0x0034: { n:"BrtBeginFmd" },
	0x0035: { n:"BrtEndFmd" },
	0x0036: { n:"BrtBeginMdx" },
	0x0037: { n:"BrtEndMdx" },
	0x0038: { n:"BrtBeginMdxTuple" },
	0x0039: { n:"BrtEndMdxTuple" },
	0x003A: { n:"BrtMdxMbrIstr" },
	0x003B: { n:"BrtStr" },
	0x003C: { n:"BrtColInfo", f:parse_ColInfo },
	0x003E: { n:"BrtCellRString" },
	0x003F: { n:"BrtCalcChainItem$", f:parse_BrtCalcChainItem$ },
	0x0040: { n:"BrtDVal", f:parse_BrtDVal },
	0x0041: { n:"BrtSxvcellNum" },
	0x0042: { n:"BrtSxvcellStr" },
	0x0043: { n:"BrtSxvcellBool" },
	0x0044: { n:"BrtSxvcellErr" },
	0x0045: { n:"BrtSxvcellDate" },
	0x0046: { n:"BrtSxvcellNil" },
	0x0080: { n:"BrtFileVersion" },
	0x0081: { n:"BrtBeginSheet" },
	0x0082: { n:"BrtEndSheet" },
	0x0083: { n:"BrtBeginBook", f:parsenoop, p:0 },
	0x0084: { n:"BrtEndBook" },
	0x0085: { n:"BrtBeginWsViews" },
	0x0086: { n:"BrtEndWsViews" },
	0x0087: { n:"BrtBeginBookViews" },
	0x0088: { n:"BrtEndBookViews" },
	0x0089: { n:"BrtBeginWsView", f:parse_BrtBeginWsView },
	0x008A: { n:"BrtEndWsView" },
	0x008B: { n:"BrtBeginCsViews" },
	0x008C: { n:"BrtEndCsViews" },
	0x008D: { n:"BrtBeginCsView" },
	0x008E: { n:"BrtEndCsView" },
	0x008F: { n:"BrtBeginBundleShs" },
	0x0090: { n:"BrtEndBundleShs" },
	0x0091: { n:"BrtBeginSheetData" },
	0x0092: { n:"BrtEndSheetData" },
	0x0093: { n:"BrtWsProp", f:parse_BrtWsProp },
	0x0094: { n:"BrtWsDim", f:parse_BrtWsDim, p:16 },
	0x0097: { n:"BrtPane", f:parse_BrtPane },
	0x0098: { n:"BrtSel" },
	0x0099: { n:"BrtWbProp", f:parse_BrtWbProp },
	0x009A: { n:"BrtWbFactoid" },
	0x009B: { n:"BrtFileRecover" },
	0x009C: { n:"BrtBundleSh", f:parse_BrtBundleSh },
	0x009D: { n:"BrtCalcProp" },
	0x009E: { n:"BrtBookView" },
	0x009F: { n:"BrtBeginSst", f:parse_BrtBeginSst },
	0x00A0: { n:"BrtEndSst" },
	0x00A1: { n:"BrtBeginAFilter", f:parse_UncheckedRfX },
	0x00A2: { n:"BrtEndAFilter" },
	0x00A3: { n:"BrtBeginFilterColumn" },
	0x00A4: { n:"BrtEndFilterColumn" },
	0x00A5: { n:"BrtBeginFilters" },
	0x00A6: { n:"BrtEndFilters" },
	0x00A7: { n:"BrtFilter" },
	0x00A8: { n:"BrtColorFilter" },
	0x00A9: { n:"BrtIconFilter" },
	0x00AA: { n:"BrtTop10Filter" },
	0x00AB: { n:"BrtDynamicFilter" },
	0x00AC: { n:"BrtBeginCustomFilters" },
	0x00AD: { n:"BrtEndCustomFilters" },
	0x00AE: { n:"BrtCustomFilter" },
	0x00AF: { n:"BrtAFilterDateGroupItem" },
	0x00B0: { n:"BrtMergeCell", f:parse_BrtMergeCell },
	0x00B1: { n:"BrtBeginMergeCells" },
	0x00B2: { n:"BrtEndMergeCells" },
	0x00B3: { n:"BrtBeginPivotCacheDef" },
	0x00B4: { n:"BrtEndPivotCacheDef" },
	0x00B5: { n:"BrtBeginPCDFields" },
	0x00B6: { n:"BrtEndPCDFields" },
	0x00B7: { n:"BrtBeginPCDField" },
	0x00B8: { n:"BrtEndPCDField" },
	0x00B9: { n:"BrtBeginPCDSource" },
	0x00BA: { n:"BrtEndPCDSource" },
	0x00BB: { n:"BrtBeginPCDSRange" },
	0x00BC: { n:"BrtEndPCDSRange" },
	0x00BD: { n:"BrtBeginPCDFAtbl" },
	0x00BE: { n:"BrtEndPCDFAtbl" },
	0x00BF: { n:"BrtBeginPCDIRun" },
	0x00C0: { n:"BrtEndPCDIRun" },
	0x00C1: { n:"BrtBeginPivotCacheRecords" },
	0x00C2: { n:"BrtEndPivotCacheRecords" },
	0x00C3: { n:"BrtBeginPCDHierarchies" },
	0x00C4: { n:"BrtEndPCDHierarchies" },
	0x00C5: { n:"BrtBeginPCDHierarchy" },
	0x00C6: { n:"BrtEndPCDHierarchy" },
	0x00C7: { n:"BrtBeginPCDHFieldsUsage" },
	0x00C8: { n:"BrtEndPCDHFieldsUsage" },
	0x00C9: { n:"BrtBeginExtConnection" },
	0x00CA: { n:"BrtEndExtConnection" },
	0x00CB: { n:"BrtBeginECDbProps" },
	0x00CC: { n:"BrtEndECDbProps" },
	0x00CD: { n:"BrtBeginECOlapProps" },
	0x00CE: { n:"BrtEndECOlapProps" },
	0x00CF: { n:"BrtBeginPCDSConsol" },
	0x00D0: { n:"BrtEndPCDSConsol" },
	0x00D1: { n:"BrtBeginPCDSCPages" },
	0x00D2: { n:"BrtEndPCDSCPages" },
	0x00D3: { n:"BrtBeginPCDSCPage" },
	0x00D4: { n:"BrtEndPCDSCPage" },
	0x00D5: { n:"BrtBeginPCDSCPItem" },
	0x00D6: { n:"BrtEndPCDSCPItem" },
	0x00D7: { n:"BrtBeginPCDSCSets" },
	0x00D8: { n:"BrtEndPCDSCSets" },
	0x00D9: { n:"BrtBeginPCDSCSet" },
	0x00DA: { n:"BrtEndPCDSCSet" },
	0x00DB: { n:"BrtBeginPCDFGroup" },
	0x00DC: { n:"BrtEndPCDFGroup" },
	0x00DD: { n:"BrtBeginPCDFGItems" },
	0x00DE: { n:"BrtEndPCDFGItems" },
	0x00DF: { n:"BrtBeginPCDFGRange" },
	0x00E0: { n:"BrtEndPCDFGRange" },
	0x00E1: { n:"BrtBeginPCDFGDiscrete" },
	0x00E2: { n:"BrtEndPCDFGDiscrete" },
	0x00E3: { n:"BrtBeginPCDSDTupleCache" },
	0x00E4: { n:"BrtEndPCDSDTupleCache" },
	0x00E5: { n:"BrtBeginPCDSDTCEntries" },
	0x00E6: { n:"BrtEndPCDSDTCEntries" },
	0x00E7: { n:"BrtBeginPCDSDTCEMembers" },
	0x00E8: { n:"BrtEndPCDSDTCEMembers" },
	0x00E9: { n:"BrtBeginPCDSDTCEMember" },
	0x00EA: { n:"BrtEndPCDSDTCEMember" },
	0x00EB: { n:"BrtBeginPCDSDTCQueries" },
	0x00EC: { n:"BrtEndPCDSDTCQueries" },
	0x00ED: { n:"BrtBeginPCDSDTCQuery" },
	0x00EE: { n:"BrtEndPCDSDTCQuery" },
	0x00EF: { n:"BrtBeginPCDSDTCSets" },
	0x00F0: { n:"BrtEndPCDSDTCSets" },
	0x00F1: { n:"BrtBeginPCDSDTCSet" },
	0x00F2: { n:"BrtEndPCDSDTCSet" },
	0x00F3: { n:"BrtBeginPCDCalcItems" },
	0x00F4: { n:"BrtEndPCDCalcItems" },
	0x00F5: { n:"BrtBeginPCDCalcItem" },
	0x00F6: { n:"BrtEndPCDCalcItem" },
	0x00F7: { n:"BrtBeginPRule" },
	0x00F8: { n:"BrtEndPRule" },
	0x00F9: { n:"BrtBeginPRFilters" },
	0x00FA: { n:"BrtEndPRFilters" },
	0x00FB: { n:"BrtBeginPRFilter" },
	0x00FC: { n:"BrtEndPRFilter" },
	0x00FD: { n:"BrtBeginPNames" },
	0x00FE: { n:"BrtEndPNames" },
	0x00FF: { n:"BrtBeginPName" },
	0x0100: { n:"BrtEndPName" },
	0x0101: { n:"BrtBeginPNPairs" },
	0x0102: { n:"BrtEndPNPairs" },
	0x0103: { n:"BrtBeginPNPair" },
	0x0104: { n:"BrtEndPNPair" },
	0x0105: { n:"BrtBeginECWebProps" },
	0x0106: { n:"BrtEndECWebProps" },
	0x0107: { n:"BrtBeginEcWpTables" },
	0x0108: { n:"BrtEndECWPTables" },
	0x0109: { n:"BrtBeginECParams" },
	0x010A: { n:"BrtEndECParams" },
	0x010B: { n:"BrtBeginECParam" },
	0x010C: { n:"BrtEndECParam" },
	0x010D: { n:"BrtBeginPCDKPIs" },
	0x010E: { n:"BrtEndPCDKPIs" },
	0x010F: { n:"BrtBeginPCDKPI" },
	0x0110: { n:"BrtEndPCDKPI" },
	0x0111: { n:"BrtBeginDims" },
	0x0112: { n:"BrtEndDims" },
	0x0113: { n:"BrtBeginDim" },
	0x0114: { n:"BrtEndDim" },
	0x0115: { n:"BrtIndexPartEnd" },
	0x0116: { n:"BrtBeginStyleSheet" },
	0x0117: { n:"BrtEndStyleSheet" },
	0x0118: { n:"BrtBeginSXView" },
	0x0119: { n:"BrtEndSXVI" },
	0x011A: { n:"BrtBeginSXVI" },
	0x011B: { n:"BrtBeginSXVIs" },
	0x011C: { n:"BrtEndSXVIs" },
	0x011D: { n:"BrtBeginSXVD" },
	0x011E: { n:"BrtEndSXVD" },
	0x011F: { n:"BrtBeginSXVDs" },
	0x0120: { n:"BrtEndSXVDs" },
	0x0121: { n:"BrtBeginSXPI" },
	0x0122: { n:"BrtEndSXPI" },
	0x0123: { n:"BrtBeginSXPIs" },
	0x0124: { n:"BrtEndSXPIs" },
	0x0125: { n:"BrtBeginSXDI" },
	0x0126: { n:"BrtEndSXDI" },
	0x0127: { n:"BrtBeginSXDIs" },
	0x0128: { n:"BrtEndSXDIs" },
	0x0129: { n:"BrtBeginSXLI" },
	0x012A: { n:"BrtEndSXLI" },
	0x012B: { n:"BrtBeginSXLIRws" },
	0x012C: { n:"BrtEndSXLIRws" },
	0x012D: { n:"BrtBeginSXLICols" },
	0x012E: { n:"BrtEndSXLICols" },
	0x012F: { n:"BrtBeginSXFormat" },
	0x0130: { n:"BrtEndSXFormat" },
	0x0131: { n:"BrtBeginSXFormats" },
	0x0132: { n:"BrtEndSxFormats" },
	0x0133: { n:"BrtBeginSxSelect" },
	0x0134: { n:"BrtEndSxSelect" },
	0x0135: { n:"BrtBeginISXVDRws" },
	0x0136: { n:"BrtEndISXVDRws" },
	0x0137: { n:"BrtBeginISXVDCols" },
	0x0138: { n:"BrtEndISXVDCols" },
	0x0139: { n:"BrtEndSXLocation" },
	0x013A: { n:"BrtBeginSXLocation" },
	0x013B: { n:"BrtEndSXView" },
	0x013C: { n:"BrtBeginSXTHs" },
	0x013D: { n:"BrtEndSXTHs" },
	0x013E: { n:"BrtBeginSXTH" },
	0x013F: { n:"BrtEndSXTH" },
	0x0140: { n:"BrtBeginISXTHRws" },
	0x0141: { n:"BrtEndISXTHRws" },
	0x0142: { n:"BrtBeginISXTHCols" },
	0x0143: { n:"BrtEndISXTHCols" },
	0x0144: { n:"BrtBeginSXTDMPS" },
	0x0145: { n:"BrtEndSXTDMPs" },
	0x0146: { n:"BrtBeginSXTDMP" },
	0x0147: { n:"BrtEndSXTDMP" },
	0x0148: { n:"BrtBeginSXTHItems" },
	0x0149: { n:"BrtEndSXTHItems" },
	0x014A: { n:"BrtBeginSXTHItem" },
	0x014B: { n:"BrtEndSXTHItem" },
	0x014C: { n:"BrtBeginMetadata" },
	0x014D: { n:"BrtEndMetadata" },
	0x014E: { n:"BrtBeginEsmdtinfo" },
	0x014F: { n:"BrtMdtinfo" },
	0x0150: { n:"BrtEndEsmdtinfo" },
	0x0151: { n:"BrtBeginEsmdb" },
	0x0152: { n:"BrtEndEsmdb" },
	0x0153: { n:"BrtBeginEsfmd" },
	0x0154: { n:"BrtEndEsfmd" },
	0x0155: { n:"BrtBeginSingleCells" },
	0x0156: { n:"BrtEndSingleCells" },
	0x0157: { n:"BrtBeginList" },
	0x0158: { n:"BrtEndList" },
	0x0159: { n:"BrtBeginListCols" },
	0x015A: { n:"BrtEndListCols" },
	0x015B: { n:"BrtBeginListCol" },
	0x015C: { n:"BrtEndListCol" },
	0x015D: { n:"BrtBeginListXmlCPr" },
	0x015E: { n:"BrtEndListXmlCPr" },
	0x015F: { n:"BrtListCCFmla" },
	0x0160: { n:"BrtListTrFmla" },
	0x0161: { n:"BrtBeginExternals" },
	0x0162: { n:"BrtEndExternals" },
	0x0163: { n:"BrtSupBookSrc", f:parse_RelID},
	0x0165: { n:"BrtSupSelf" },
	0x0166: { n:"BrtSupSame" },
	0x0167: { n:"BrtSupTabs" },
	0x0168: { n:"BrtBeginSupBook" },
	0x0169: { n:"BrtPlaceholderName" },
	0x016A: { n:"BrtExternSheet", f:parse_ExternSheet },
	0x016B: { n:"BrtExternTableStart" },
	0x016C: { n:"BrtExternTableEnd" },
	0x016E: { n:"BrtExternRowHdr" },
	0x016F: { n:"BrtExternCellBlank" },
	0x0170: { n:"BrtExternCellReal" },
	0x0171: { n:"BrtExternCellBool" },
	0x0172: { n:"BrtExternCellError" },
	0x0173: { n:"BrtExternCellString" },
	0x0174: { n:"BrtBeginEsmdx" },
	0x0175: { n:"BrtEndEsmdx" },
	0x0176: { n:"BrtBeginMdxSet" },
	0x0177: { n:"BrtEndMdxSet" },
	0x0178: { n:"BrtBeginMdxMbrProp" },
	0x0179: { n:"BrtEndMdxMbrProp" },
	0x017A: { n:"BrtBeginMdxKPI" },
	0x017B: { n:"BrtEndMdxKPI" },
	0x017C: { n:"BrtBeginEsstr" },
	0x017D: { n:"BrtEndEsstr" },
	0x017E: { n:"BrtBeginPRFItem" },
	0x017F: { n:"BrtEndPRFItem" },
	0x0180: { n:"BrtBeginPivotCacheIDs" },
	0x0181: { n:"BrtEndPivotCacheIDs" },
	0x0182: { n:"BrtBeginPivotCacheID" },
	0x0183: { n:"BrtEndPivotCacheID" },
	0x0184: { n:"BrtBeginISXVIs" },
	0x0185: { n:"BrtEndISXVIs" },
	0x0186: { n:"BrtBeginColInfos" },
	0x0187: { n:"BrtEndColInfos" },
	0x0188: { n:"BrtBeginRwBrk" },
	0x0189: { n:"BrtEndRwBrk" },
	0x018A: { n:"BrtBeginColBrk" },
	0x018B: { n:"BrtEndColBrk" },
	0x018C: { n:"BrtBrk" },
	0x018D: { n:"BrtUserBookView" },
	0x018E: { n:"BrtInfo" },
	0x018F: { n:"BrtCUsr" },
	0x0190: { n:"BrtUsr" },
	0x0191: { n:"BrtBeginUsers" },
	0x0193: { n:"BrtEOF" },
	0x0194: { n:"BrtUCR" },
	0x0195: { n:"BrtRRInsDel" },
	0x0196: { n:"BrtRREndInsDel" },
	0x0197: { n:"BrtRRMove" },
	0x0198: { n:"BrtRREndMove" },
	0x0199: { n:"BrtRRChgCell" },
	0x019A: { n:"BrtRREndChgCell" },
	0x019B: { n:"BrtRRHeader" },
	0x019C: { n:"BrtRRUserView" },
	0x019D: { n:"BrtRRRenSheet" },
	0x019E: { n:"BrtRRInsertSh" },
	0x019F: { n:"BrtRRDefName" },
	0x01A0: { n:"BrtRRNote" },
	0x01A1: { n:"BrtRRConflict" },
	0x01A2: { n:"BrtRRTQSIF" },
	0x01A3: { n:"BrtRRFormat" },
	0x01A4: { n:"BrtRREndFormat" },
	0x01A5: { n:"BrtRRAutoFmt" },
	0x01A6: { n:"BrtBeginUserShViews" },
	0x01A7: { n:"BrtBeginUserShView" },
	0x01A8: { n:"BrtEndUserShView" },
	0x01A9: { n:"BrtEndUserShViews" },
	0x01AA: { n:"BrtArrFmla", f:parse_BrtArrFmla },
	0x01AB: { n:"BrtShrFmla", f:parse_BrtShrFmla },
	0x01AC: { n:"BrtTable" },
	0x01AD: { n:"BrtBeginExtConnections" },
	0x01AE: { n:"BrtEndExtConnections" },
	0x01AF: { n:"BrtBeginPCDCalcMems" },
	0x01B0: { n:"BrtEndPCDCalcMems" },
	0x01B1: { n:"BrtBeginPCDCalcMem" },
	0x01B2: { n:"BrtEndPCDCalcMem" },
	0x01B3: { n:"BrtBeginPCDHGLevels" },
	0x01B4: { n:"BrtEndPCDHGLevels" },
	0x01B5: { n:"BrtBeginPCDHGLevel" },
	0x01B6: { n:"BrtEndPCDHGLevel" },
	0x01B7: { n:"BrtBeginPCDHGLGroups" },
	0x01B8: { n:"BrtEndPCDHGLGroups" },
	0x01B9: { n:"BrtBeginPCDHGLGroup" },
	0x01BA: { n:"BrtEndPCDHGLGroup" },
	0x01BB: { n:"BrtBeginPCDHGLGMembers" },
	0x01BC: { n:"BrtEndPCDHGLGMembers" },
	0x01BD: { n:"BrtBeginPCDHGLGMember" },
	0x01BE: { n:"BrtEndPCDHGLGMember" },
	0x01BF: { n:"BrtBeginQSI" },
	0x01C0: { n:"BrtEndQSI" },
	0x01C1: { n:"BrtBeginQSIR" },
	0x01C2: { n:"BrtEndQSIR" },
	0x01C3: { n:"BrtBeginDeletedNames" },
	0x01C4: { n:"BrtEndDeletedNames" },
	0x01C5: { n:"BrtBeginDeletedName" },
	0x01C6: { n:"BrtEndDeletedName" },
	0x01C7: { n:"BrtBeginQSIFs" },
	0x01C8: { n:"BrtEndQSIFs" },
	0x01C9: { n:"BrtBeginQSIF" },
	0x01CA: { n:"BrtEndQSIF" },
	0x01CB: { n:"BrtBeginAutoSortScope" },
	0x01CC: { n:"BrtEndAutoSortScope" },
	0x01CD: { n:"BrtBeginConditionalFormatting" },
	0x01CE: { n:"BrtEndConditionalFormatting" },
	0x01CF: { n:"BrtBeginCFRule" },
	0x01D0: { n:"BrtEndCFRule" },
	0x01D1: { n:"BrtBeginIconSet" },
	0x01D2: { n:"BrtEndIconSet" },
	0x01D3: { n:"BrtBeginDatabar" },
	0x01D4: { n:"BrtEndDatabar" },
	0x01D5: { n:"BrtBeginColorScale" },
	0x01D6: { n:"BrtEndColorScale" },
	0x01D7: { n:"BrtCFVO" },
	0x01D8: { n:"BrtExternValueMeta" },
	0x01D9: { n:"BrtBeginColorPalette" },
	0x01DA: { n:"BrtEndColorPalette" },
	0x01DB: { n:"BrtIndexedColor" },
	0x01DC: { n:"BrtMargins", f:parse_BrtMargins },
	0x01DD: { n:"BrtPrintOptions" },
	0x01DE: { n:"BrtPageSetup" },
	0x01DF: { n:"BrtBeginHeaderFooter" },
	0x01E0: { n:"BrtEndHeaderFooter" },
	0x01E1: { n:"BrtBeginSXCrtFormat" },
	0x01E2: { n:"BrtEndSXCrtFormat" },
	0x01E3: { n:"BrtBeginSXCrtFormats" },
	0x01E4: { n:"BrtEndSXCrtFormats" },
	0x01E5: { n:"BrtWsFmtInfo", f:parse_BrtWsFmtInfo },
	0x01E6: { n:"BrtBeginMgs" },
	0x01E7: { n:"BrtEndMGs" },
	0x01E8: { n:"BrtBeginMGMaps" },
	0x01E9: { n:"BrtEndMGMaps" },
	0x01EA: { n:"BrtBeginMG" },
	0x01EB: { n:"BrtEndMG" },
	0x01EC: { n:"BrtBeginMap" },
	0x01ED: { n:"BrtEndMap" },
	0x01EE: { n:"BrtHLink", f:parse_BrtHLink },
	0x01EF: { n:"BrtBeginDCon" },
	0x01F0: { n:"BrtEndDCon" },
	0x01F1: { n:"BrtBeginDRefs" },
	0x01F2: { n:"BrtEndDRefs" },
	0x01F3: { n:"BrtDRef" },
	0x01F4: { n:"BrtBeginScenMan" },
	0x01F5: { n:"BrtEndScenMan" },
	0x01F6: { n:"BrtBeginSct" },
	0x01F7: { n:"BrtEndSct" },
	0x01F8: { n:"BrtSlc" },
	0x01F9: { n:"BrtBeginDXFs" },
	0x01FA: { n:"BrtEndDXFs" },
	0x01FB: { n:"BrtDXF" },
	0x01FC: { n:"BrtBeginTableStyles" },
	0x01FD: { n:"BrtEndTableStyles" },
	0x01FE: { n:"BrtBeginTableStyle" },
	0x01FF: { n:"BrtEndTableStyle" },
	0x0200: { n:"BrtTableStyleElement" },
	0x0201: { n:"BrtTableStyleClient" },
	0x0202: { n:"BrtBeginVolDeps" },
	0x0203: { n:"BrtEndVolDeps" },
	0x0204: { n:"BrtBeginVolType" },
	0x0205: { n:"BrtEndVolType" },
	0x0206: { n:"BrtBeginVolMain" },
	0x0207: { n:"BrtEndVolMain" },
	0x0208: { n:"BrtBeginVolTopic" },
	0x0209: { n:"BrtEndVolTopic" },
	0x020A: { n:"BrtVolSubtopic" },
	0x020B: { n:"BrtVolRef" },
	0x020C: { n:"BrtVolNum" },
	0x020D: { n:"BrtVolErr" },
	0x020E: { n:"BrtVolStr" },
	0x020F: { n:"BrtVolBool" },
	0x0210: { n:"BrtBeginCalcChain$" },
	0x0211: { n:"BrtEndCalcChain$" },
	0x0212: { n:"BrtBeginSortState" },
	0x0213: { n:"BrtEndSortState" },
	0x0214: { n:"BrtBeginSortCond" },
	0x0215: { n:"BrtEndSortCond" },
	0x0216: { n:"BrtBookProtection" },
	0x0217: { n:"BrtSheetProtection" },
	0x0218: { n:"BrtRangeProtection" },
	0x0219: { n:"BrtPhoneticInfo" },
	0x021A: { n:"BrtBeginECTxtWiz" },
	0x021B: { n:"BrtEndECTxtWiz" },
	0x021C: { n:"BrtBeginECTWFldInfoLst" },
	0x021D: { n:"BrtEndECTWFldInfoLst" },
	0x021E: { n:"BrtBeginECTwFldInfo" },
	0x0224: { n:"BrtFileSharing" },
	0x0225: { n:"BrtOleSize" },
	0x0226: { n:"BrtDrawing", f:parse_RelID },
	0x0227: { n:"BrtLegacyDrawing" },
	0x0228: { n:"BrtLegacyDrawingHF" },
	0x0229: { n:"BrtWebOpt" },
	0x022A: { n:"BrtBeginWebPubItems" },
	0x022B: { n:"BrtEndWebPubItems" },
	0x022C: { n:"BrtBeginWebPubItem" },
	0x022D: { n:"BrtEndWebPubItem" },
	0x022E: { n:"BrtBeginSXCondFmt" },
	0x022F: { n:"BrtEndSXCondFmt" },
	0x0230: { n:"BrtBeginSXCondFmts" },
	0x0231: { n:"BrtEndSXCondFmts" },
	0x0232: { n:"BrtBkHim" },
	0x0234: { n:"BrtColor" },
	0x0235: { n:"BrtBeginIndexedColors" },
	0x0236: { n:"BrtEndIndexedColors" },
	0x0239: { n:"BrtBeginMRUColors" },
	0x023A: { n:"BrtEndMRUColors" },
	0x023C: { n:"BrtMRUColor" },
	0x023D: { n:"BrtBeginDVals" },
	0x023E: { n:"BrtEndDVals" },
	0x0241: { n:"BrtSupNameStart" },
	0x0242: { n:"BrtSupNameValueStart" },
	0x0243: { n:"BrtSupNameValueEnd" },
	0x0244: { n:"BrtSupNameNum" },
	0x0245: { n:"BrtSupNameErr" },
	0x0246: { n:"BrtSupNameSt" },
	0x0247: { n:"BrtSupNameNil" },
	0x0248: { n:"BrtSupNameBool" },
	0x0249: { n:"BrtSupNameFmla" },
	0x024A: { n:"BrtSupNameBits" },
	0x024B: { n:"BrtSupNameEnd" },
	0x024C: { n:"BrtEndSupBook" },
	0x024D: { n:"BrtCellSmartTagProperty" },
	0x024E: { n:"BrtBeginCellSmartTag" },
	0x024F: { n:"BrtEndCellSmartTag" },
	0x0250: { n:"BrtBeginCellSmartTags" },
	0x0251: { n:"BrtEndCellSmartTags" },
	0x0252: { n:"BrtBeginSmartTags" },
	0x0253: { n:"BrtEndSmartTags" },
	0x0254: { n:"BrtSmartTagType" },
	0x0255: { n:"BrtBeginSmartTagTypes" },
	0x0256: { n:"BrtEndSmartTagTypes" },
	0x0257: { n:"BrtBeginSXFilters" },
	0x0258: { n:"BrtEndSXFilters" },
	0x0259: { n:"BrtBeginSXFILTER" },
	0x025A: { n:"BrtEndSXFilter" },
	0x025B: { n:"BrtBeginFills" },
	0x025C: { n:"BrtEndFills" },
	0x025D: { n:"BrtBeginCellWatches" },
	0x025E: { n:"BrtEndCellWatches" },
	0x025F: { n:"BrtCellWatch" },
	0x0260: { n:"BrtBeginCRErrs" },
	0x0261: { n:"BrtEndCRErrs" },
	0x0262: { n:"BrtCrashRecErr" },
	0x0263: { n:"BrtBeginFonts" },
	0x0264: { n:"BrtEndFonts" },
	0x0265: { n:"BrtBeginBorders" },
	0x0266: { n:"BrtEndBorders" },
	0x0267: { n:"BrtBeginFmts" },
	0x0268: { n:"BrtEndFmts" },
	0x0269: { n:"BrtBeginCellXFs" },
	0x026A: { n:"BrtEndCellXFs" },
	0x026B: { n:"BrtBeginStyles" },
	0x026C: { n:"BrtEndStyles" },
	0x0271: { n:"BrtBigName" },
	0x0272: { n:"BrtBeginCellStyleXFs" },
	0x0273: { n:"BrtEndCellStyleXFs" },
	0x0274: { n:"BrtBeginComments" },
	0x0275: { n:"BrtEndComments" },
	0x0276: { n:"BrtBeginCommentAuthors" },
	0x0277: { n:"BrtEndCommentAuthors" },
	0x0278: { n:"BrtCommentAuthor", f:parse_BrtCommentAuthor },
	0x0279: { n:"BrtBeginCommentList" },
	0x027A: { n:"BrtEndCommentList" },
	0x027B: { n:"BrtBeginComment", f:parse_BrtBeginComment},
	0x027C: { n:"BrtEndComment" },
	0x027D: { n:"BrtCommentText", f:parse_BrtCommentText },
	0x027E: { n:"BrtBeginOleObjects" },
	0x027F: { n:"BrtOleObject" },
	0x0280: { n:"BrtEndOleObjects" },
	0x0281: { n:"BrtBeginSxrules" },
	0x0282: { n:"BrtEndSxRules" },
	0x0283: { n:"BrtBeginActiveXControls" },
	0x0284: { n:"BrtActiveX" },
	0x0285: { n:"BrtEndActiveXControls" },
	0x0286: { n:"BrtBeginPCDSDTCEMembersSortBy" },
	0x0288: { n:"BrtBeginCellIgnoreECs" },
	0x0289: { n:"BrtCellIgnoreEC" },
	0x028A: { n:"BrtEndCellIgnoreECs" },
	0x028B: { n:"BrtCsProp", f:parse_BrtCsProp },
	0x028C: { n:"BrtCsPageSetup" },
	0x028D: { n:"BrtBeginUserCsViews" },
	0x028E: { n:"BrtEndUserCsViews" },
	0x028F: { n:"BrtBeginUserCsView" },
	0x0290: { n:"BrtEndUserCsView" },
	0x0291: { n:"BrtBeginPcdSFCIEntries" },
	0x0292: { n:"BrtEndPCDSFCIEntries" },
	0x0293: { n:"BrtPCDSFCIEntry" },
	0x0294: { n:"BrtBeginListParts" },
	0x0295: { n:"BrtListPart" },
	0x0296: { n:"BrtEndListParts" },
	0x0297: { n:"BrtSheetCalcProp" },
	0x0298: { n:"BrtBeginFnGroup" },
	0x0299: { n:"BrtFnGroup" },
	0x029A: { n:"BrtEndFnGroup" },
	0x029B: { n:"BrtSupAddin" },
	0x029C: { n:"BrtSXTDMPOrder" },
	0x029D: { n:"BrtCsProtection" },
	0x029F: { n:"BrtBeginWsSortMap" },
	0x02A0: { n:"BrtEndWsSortMap" },
	0x02A1: { n:"BrtBeginRRSort" },
	0x02A2: { n:"BrtEndRRSort" },
	0x02A3: { n:"BrtRRSortItem" },
	0x02A4: { n:"BrtFileSharingIso" },
	0x02A5: { n:"BrtBookProtectionIso" },
	0x02A6: { n:"BrtSheetProtectionIso" },
	0x02A7: { n:"BrtCsProtectionIso" },
	0x02A8: { n:"BrtRangeProtectionIso" },
	0x02A9: { n:"BrtDValList" },
	0x0400: { n:"BrtRwDescent" },
	0x0401: { n:"BrtKnownFonts" },
	0x0402: { n:"BrtBeginSXTupleSet" },
	0x0403: { n:"BrtEndSXTupleSet" },
	0x0404: { n:"BrtBeginSXTupleSetHeader" },
	0x0405: { n:"BrtEndSXTupleSetHeader" },
	0x0406: { n:"BrtSXTupleSetHeaderItem" },
	0x0407: { n:"BrtBeginSXTupleSetData" },
	0x0408: { n:"BrtEndSXTupleSetData" },
	0x0409: { n:"BrtBeginSXTupleSetRow" },
	0x040A: { n:"BrtEndSXTupleSetRow" },
	0x040B: { n:"BrtSXTupleSetRowItem" },
	0x040C: { n:"BrtNameExt" },
	0x040D: { n:"BrtPCDH14" },
	0x040E: { n:"BrtBeginPCDCalcMem14" },
	0x040F: { n:"BrtEndPCDCalcMem14" },
	0x0410: { n:"BrtSXTH14" },
	0x0411: { n:"BrtBeginSparklineGroup" },
	0x0412: { n:"BrtEndSparklineGroup" },
	0x0413: { n:"BrtSparkline" },
	0x0414: { n:"BrtSXDI14" },
	0x0415: { n:"BrtWsFmtInfoEx14" },
	0x0416: { n:"BrtBeginConditionalFormatting14" },
	0x0417: { n:"BrtEndConditionalFormatting14" },
	0x0418: { n:"BrtBeginCFRule14" },
	0x0419: { n:"BrtEndCFRule14" },
	0x041A: { n:"BrtCFVO14" },
	0x041B: { n:"BrtBeginDatabar14" },
	0x041C: { n:"BrtBeginIconSet14" },
	0x041D: { n:"BrtDVal14", f: parse_BrtDVal14 },
	0x041E: { n:"BrtBeginDVals14" },
	0x041F: { n:"BrtColor14" },
	0x0420: { n:"BrtBeginSparklines" },
	0x0421: { n:"BrtEndSparklines" },
	0x0422: { n:"BrtBeginSparklineGroups" },
	0x0423: { n:"BrtEndSparklineGroups" },
	0x0425: { n:"BrtSXVD14" },
	0x0426: { n:"BrtBeginSXView14" },
	0x0427: { n:"BrtEndSXView14" },
	0x0428: { n:"BrtBeginSXView16" },
	0x0429: { n:"BrtEndSXView16" },
	0x042A: { n:"BrtBeginPCD14" },
	0x042B: { n:"BrtEndPCD14" },
	0x042C: { n:"BrtBeginExtConn14" },
	0x042D: { n:"BrtEndExtConn14" },
	0x042E: { n:"BrtBeginSlicerCacheIDs" },
	0x042F: { n:"BrtEndSlicerCacheIDs" },
	0x0430: { n:"BrtBeginSlicerCacheID" },
	0x0431: { n:"BrtEndSlicerCacheID" },
	0x0433: { n:"BrtBeginSlicerCache" },
	0x0434: { n:"BrtEndSlicerCache" },
	0x0435: { n:"BrtBeginSlicerCacheDef" },
	0x0436: { n:"BrtEndSlicerCacheDef" },
	0x0437: { n:"BrtBeginSlicersEx" },
	0x0438: { n:"BrtEndSlicersEx" },
	0x0439: { n:"BrtBeginSlicerEx" },
	0x043A: { n:"BrtEndSlicerEx" },
	0x043B: { n:"BrtBeginSlicer" },
	0x043C: { n:"BrtEndSlicer" },
	0x043D: { n:"BrtSlicerCachePivotTables" },
	0x043E: { n:"BrtBeginSlicerCacheOlapImpl" },
	0x043F: { n:"BrtEndSlicerCacheOlapImpl" },
	0x0440: { n:"BrtBeginSlicerCacheLevelsData" },
	0x0441: { n:"BrtEndSlicerCacheLevelsData" },
	0x0442: { n:"BrtBeginSlicerCacheLevelData" },
	0x0443: { n:"BrtEndSlicerCacheLevelData" },
	0x0444: { n:"BrtBeginSlicerCacheSiRanges" },
	0x0445: { n:"BrtEndSlicerCacheSiRanges" },
	0x0446: { n:"BrtBeginSlicerCacheSiRange" },
	0x0447: { n:"BrtEndSlicerCacheSiRange" },
	0x0448: { n:"BrtSlicerCacheOlapItem" },
	0x0449: { n:"BrtBeginSlicerCacheSelections" },
	0x044A: { n:"BrtSlicerCacheSelection" },
	0x044B: { n:"BrtEndSlicerCacheSelections" },
	0x044C: { n:"BrtBeginSlicerCacheNative" },
	0x044D: { n:"BrtEndSlicerCacheNative" },
	0x044E: { n:"BrtSlicerCacheNativeItem" },
	0x044F: { n:"BrtRangeProtection14" },
	0x0450: { n:"BrtRangeProtectionIso14" },
	0x0451: { n:"BrtCellIgnoreEC14" },
	0x0457: { n:"BrtList14" },
	0x0458: { n:"BrtCFIcon" },
	0x0459: { n:"BrtBeginSlicerCachesPivotCacheIDs" },
	0x045A: { n:"BrtEndSlicerCachesPivotCacheIDs" },
	0x045B: { n:"BrtBeginSlicers" },
	0x045C: { n:"BrtEndSlicers" },
	0x045D: { n:"BrtWbProp14" },
	0x045E: { n:"BrtBeginSXEdit" },
	0x045F: { n:"BrtEndSXEdit" },
	0x0460: { n:"BrtBeginSXEdits" },
	0x0461: { n:"BrtEndSXEdits" },
	0x0462: { n:"BrtBeginSXChange" },
	0x0463: { n:"BrtEndSXChange" },
	0x0464: { n:"BrtBeginSXChanges" },
	0x0465: { n:"BrtEndSXChanges" },
	0x0466: { n:"BrtSXTupleItems" },
	0x0468: { n:"BrtBeginSlicerStyle" },
	0x0469: { n:"BrtEndSlicerStyle" },
	0x046A: { n:"BrtSlicerStyleElement" },
	0x046B: { n:"BrtBeginStyleSheetExt14" },
	0x046C: { n:"BrtEndStyleSheetExt14" },
	0x046D: { n:"BrtBeginSlicerCachesPivotCacheID" },
	0x046E: { n:"BrtEndSlicerCachesPivotCacheID" },
	0x046F: { n:"BrtBeginConditionalFormattings" },
	0x0470: { n:"BrtEndConditionalFormattings" },
	0x0471: { n:"BrtBeginPCDCalcMemExt" },
	0x0472: { n:"BrtEndPCDCalcMemExt" },
	0x0473: { n:"BrtBeginPCDCalcMemsExt" },
	0x0474: { n:"BrtEndPCDCalcMemsExt" },
	0x0475: { n:"BrtPCDField14" },
	0x0476: { n:"BrtBeginSlicerStyles" },
	0x0477: { n:"BrtEndSlicerStyles" },
	0x0478: { n:"BrtBeginSlicerStyleElements" },
	0x0479: { n:"BrtEndSlicerStyleElements" },
	0x047A: { n:"BrtCFRuleExt" },
	0x047B: { n:"BrtBeginSXCondFmt14" },
	0x047C: { n:"BrtEndSXCondFmt14" },
	0x047D: { n:"BrtBeginSXCondFmts14" },
	0x047E: { n:"BrtEndSXCondFmts14" },
	0x0480: { n:"BrtBeginSortCond14" },
	0x0481: { n:"BrtEndSortCond14" },
	0x0482: { n:"BrtEndDVals14" },
	0x0483: { n:"BrtEndIconSet14" },
	0x0484: { n:"BrtEndDatabar14" },
	0x0485: { n:"BrtBeginColorScale14" },
	0x0486: { n:"BrtEndColorScale14" },
	0x0487: { n:"BrtBeginSxrules14" },
	0x0488: { n:"BrtEndSxrules14" },
	0x0489: { n:"BrtBeginPRule14" },
	0x048A: { n:"BrtEndPRule14" },
	0x048B: { n:"BrtBeginPRFilters14" },
	0x048C: { n:"BrtEndPRFilters14" },
	0x048D: { n:"BrtBeginPRFilter14" },
	0x048E: { n:"BrtEndPRFilter14" },
	0x048F: { n:"BrtBeginPRFItem14" },
	0x0490: { n:"BrtEndPRFItem14" },
	0x0491: { n:"BrtBeginCellIgnoreECs14" },
	0x0492: { n:"BrtEndCellIgnoreECs14" },
	0x0493: { n:"BrtDxf14" },
	0x0494: { n:"BrtBeginDxF14s" },
	0x0495: { n:"BrtEndDxf14s" },
	0x0499: { n:"BrtFilter14" },
	0x049A: { n:"BrtBeginCustomFilters14" },
	0x049C: { n:"BrtCustomFilter14" },
	0x049D: { n:"BrtIconFilter14" },
	0x049E: { n:"BrtPivotCacheConnectionName" },
	0x0800: { n:"BrtBeginDecoupledPivotCacheIDs" },
	0x0801: { n:"BrtEndDecoupledPivotCacheIDs" },
	0x0802: { n:"BrtDecoupledPivotCacheID" },
	0x0803: { n:"BrtBeginPivotTableRefs" },
	0x0804: { n:"BrtEndPivotTableRefs" },
	0x0805: { n:"BrtPivotTableRef" },
	0x0806: { n:"BrtSlicerCacheBookPivotTables" },
	0x0807: { n:"BrtBeginSxvcells" },
	0x0808: { n:"BrtEndSxvcells" },
	0x0809: { n:"BrtBeginSxRow" },
	0x080A: { n:"BrtEndSxRow" },
	0x080C: { n:"BrtPcdCalcMem15" },
	0x0813: { n:"BrtQsi15" },
	0x0814: { n:"BrtBeginWebExtensions" },
	0x0815: { n:"BrtEndWebExtensions" },
	0x0816: { n:"BrtWebExtension" },
	0x0817: { n:"BrtAbsPath15" },
	0x0818: { n:"BrtBeginPivotTableUISettings" },
	0x0819: { n:"BrtEndPivotTableUISettings" },
	0x081B: { n:"BrtTableSlicerCacheIDs" },
	0x081C: { n:"BrtTableSlicerCacheID" },
	0x081D: { n:"BrtBeginTableSlicerCache" },
	0x081E: { n:"BrtEndTableSlicerCache" },
	0x081F: { n:"BrtSxFilter15" },
	0x0820: { n:"BrtBeginTimelineCachePivotCacheIDs" },
	0x0821: { n:"BrtEndTimelineCachePivotCacheIDs" },
	0x0822: { n:"BrtTimelineCachePivotCacheID" },
	0x0823: { n:"BrtBeginTimelineCacheIDs" },
	0x0824: { n:"BrtEndTimelineCacheIDs" },
	0x0825: { n:"BrtBeginTimelineCacheID" },
	0x0826: { n:"BrtEndTimelineCacheID" },
	0x0827: { n:"BrtBeginTimelinesEx" },
	0x0828: { n:"BrtEndTimelinesEx" },
	0x0829: { n:"BrtBeginTimelineEx" },
	0x082A: { n:"BrtEndTimelineEx" },
	0x082B: { n:"BrtWorkBookPr15" },
	0x082C: { n:"BrtPCDH15" },
	0x082D: { n:"BrtBeginTimelineStyle" },
	0x082E: { n:"BrtEndTimelineStyle" },
	0x082F: { n:"BrtTimelineStyleElement" },
	0x0830: { n:"BrtBeginTimelineStylesheetExt15" },
	0x0831: { n:"BrtEndTimelineStylesheetExt15" },
	0x0832: { n:"BrtBeginTimelineStyles" },
	0x0833: { n:"BrtEndTimelineStyles" },
	0x0834: { n:"BrtBeginTimelineStyleElements" },
	0x0835: { n:"BrtEndTimelineStyleElements" },
	0x0836: { n:"BrtDxf15" },
	0x0837: { n:"BrtBeginDxfs15" },
	0x0838: { n:"brtEndDxfs15" },
	0x0839: { n:"BrtSlicerCacheHideItemsWithNoData" },
	0x083A: { n:"BrtBeginItemUniqueNames" },
	0x083B: { n:"BrtEndItemUniqueNames" },
	0x083C: { n:"BrtItemUniqueName" },
	0x083D: { n:"BrtBeginExtConn15" },
	0x083E: { n:"BrtEndExtConn15" },
	0x083F: { n:"BrtBeginOledbPr15" },
	0x0840: { n:"BrtEndOledbPr15" },
	0x0841: { n:"BrtBeginDataFeedPr15" },
	0x0842: { n:"BrtEndDataFeedPr15" },
	0x0843: { n:"BrtTextPr15" },
	0x0844: { n:"BrtRangePr15" },
	0x0845: { n:"BrtDbCommand15" },
	0x0846: { n:"BrtBeginDbTables15" },
	0x0847: { n:"BrtEndDbTables15" },
	0x0848: { n:"BrtDbTable15" },
	0x0849: { n:"BrtBeginDataModel" },
	0x084A: { n:"BrtEndDataModel" },
	0x084B: { n:"BrtBeginModelTables" },
	0x084C: { n:"BrtEndModelTables" },
	0x084D: { n:"BrtModelTable" },
	0x084E: { n:"BrtBeginModelRelationships" },
	0x084F: { n:"BrtEndModelRelationships" },
	0x0850: { n:"BrtModelRelationship" },
	0x0851: { n:"BrtBeginECTxtWiz15" },
	0x0852: { n:"BrtEndECTxtWiz15" },
	0x0853: { n:"BrtBeginECTWFldInfoLst15" },
	0x0854: { n:"BrtEndECTWFldInfoLst15" },
	0x0855: { n:"BrtBeginECTWFldInfo15" },
	0x0856: { n:"BrtFieldListActiveItem" },
	0x0857: { n:"BrtPivotCacheIdVersion" },
	0x0858: { n:"BrtSXDI15" },
	0x0859: { n:"BrtBeginModelTimeGroupings" },
	0x085A: { n:"BrtEndModelTimeGroupings" },
	0x085B: { n:"BrtBeginModelTimeGrouping" },
	0x085C: { n:"BrtEndModelTimeGrouping" },
	0x085D: { n:"BrtModelTimeGroupingCalcCol" },
	0x0C00: { n:"BrtUid" },
	0x0C01: { n:"BrtRevisionPtr" },
	0x13e7: { n:"BrtBeginCalcFeatures" },
	0x13e8: { n:"BrtEndCalcFeatures" },
	0x13e9: { n:"BrtCalcFeature" },
	0xFFFF: { n:"" }
	};
	
	var XLSBRE = evert_key(XLSBRecordEnum, 'n');
	
	/* [MS-XLS] 2.3 Record Enumeration */
	var XLSRecordEnum = {
	0x0003: { n:"BIFF2NUM", f:parse_BIFF2NUM },
	0x0004: { n:"BIFF2STR", f:parse_BIFF2STR },
	0x0006: { n:"Formula", f:parse_Formula },
	0x0009: { n:'BOF', f:parse_BOF },
	0x000a: { n:'EOF', f:parsenoop2 },
	0x000c: { n:"CalcCount", f:parseuint16 },
	0x000d: { n:"CalcMode", f:parseuint16 },
	0x000e: { n:"CalcPrecision", f:parsebool },
	0x000f: { n:"CalcRefMode", f:parsebool },
	0x0010: { n:"CalcDelta", f:parse_Xnum },
	0x0011: { n:"CalcIter", f:parsebool },
	0x0012: { n:"Protect", f:parsebool },
	0x0013: { n:"Password", f:parseuint16 },
	0x0014: { n:"Header", f:parse_XLHeaderFooter },
	0x0015: { n:"Footer", f:parse_XLHeaderFooter },
	0x0017: { n:"ExternSheet", f:parse_ExternSheet },
	0x0018: { n:"Lbl", f:parse_Lbl },
	0x0019: { n:"WinProtect", f:parsebool },
	0x001a: { n:"VerticalPageBreaks" },
	0x001b: { n:"HorizontalPageBreaks" },
	0x001c: { n:"Note", f:parse_Note },
	0x001d: { n:"Selection" },
	0x0022: { n:"Date1904", f:parsebool },
	0x0023: { n:"ExternName", f:parse_ExternName },
	0x0024: { n:"COLWIDTH" },
	0x0026: { n:"LeftMargin", f:parse_Xnum },
	0x0027: { n:"RightMargin", f:parse_Xnum },
	0x0028: { n:"TopMargin", f:parse_Xnum },
	0x0029: { n:"BottomMargin", f:parse_Xnum },
	0x002a: { n:"PrintRowCol", f:parsebool },
	0x002b: { n:"PrintGrid", f:parsebool },
	0x002f: { n:"FilePass", f:parse_FilePass },
	0x0031: { n:"Font", f:parse_Font },
	0x0033: { n:"PrintSize", f:parseuint16 },
	0x003c: { n:"Continue" },
	0x003d: { n:"Window1", f:parse_Window1 },
	0x0040: { n:"Backup", f:parsebool },
	0x0041: { n:"Pane", f:parse_Pane },
	0x0042: { n:'CodePage', f:parseuint16 },
	0x004d: { n:"Pls" },
	0x0050: { n:"DCon" },
	0x0051: { n:"DConRef" },
	0x0052: { n:"DConName" },
	0x0055: { n:"DefColWidth", f:parseuint16 },
	0x0059: { n:"XCT" },
	0x005a: { n:"CRN" },
	0x005b: { n:"FileSharing" },
	0x005c: { n:'WriteAccess', f:parse_WriteAccess },
	0x005d: { n:"Obj", f:parse_Obj },
	0x005e: { n:"Uncalced" },
	0x005f: { n:"CalcSaveRecalc", f:parsebool },
	0x0060: { n:"Template" },
	0x0061: { n:"Intl" },
	0x0063: { n:"ObjProtect", f:parsebool },
	0x007d: { n:"ColInfo", f:parse_ColInfo },
	0x0080: { n:"Guts", f:parse_Guts },
	0x0081: { n:"WsBool", f:parse_WsBool },
	0x0082: { n:"GridSet", f:parseuint16 },
	0x0083: { n:"HCenter", f:parsebool },
	0x0084: { n:"VCenter", f:parsebool },
	0x0085: { n:'BoundSheet8', f:parse_BoundSheet8 },
	0x0086: { n:"WriteProtect" },
	0x008c: { n:"Country", f:parse_Country },
	0x008d: { n:"HideObj", f:parseuint16 },
	0x0090: { n:"Sort" },
	0x0092: { n:"Palette", f:parse_Palette },
	0x0097: { n:"Sync" },
	0x0098: { n:"LPr" },
	0x0099: { n:"DxGCol" },
	0x009a: { n:"FnGroupName" },
	0x009b: { n:"FilterMode" },
	0x009c: { n:"BuiltInFnGroupCount", f:parseuint16 },
	0x009d: { n:"AutoFilterInfo" },
	0x009e: { n:"AutoFilter" },
	0x00a0: { n:"Scl", f:parse_Scl },
	0x00a1: { n:"Setup", f:parse_Setup },
	0x00ae: { n:"ScenMan" },
	0x00af: { n:"SCENARIO" },
	0x00b0: { n:"SxView" },
	0x00b1: { n:"Sxvd" },
	0x00b2: { n:"SXVI" },
	0x00b4: { n:"SxIvd" },
	0x00b5: { n:"SXLI" },
	0x00b6: { n:"SXPI" },
	0x00b8: { n:"DocRoute" },
	0x00b9: { n:"RecipName" },
	0x00bd: { n:"MulRk", f:parse_MulRk },
	0x00be: { n:"MulBlank", f:parse_MulBlank },
	0x00c1: { n:'Mms', f:parsenoop2 },
	0x00c5: { n:"SXDI" },
	0x00c6: { n:"SXDB" },
	0x00c7: { n:"SXFDB" },
	0x00c8: { n:"SXDBB" },
	0x00c9: { n:"SXNum" },
	0x00ca: { n:"SxBool", f:parsebool },
	0x00cb: { n:"SxErr" },
	0x00cc: { n:"SXInt" },
	0x00cd: { n:"SXString" },
	0x00ce: { n:"SXDtr" },
	0x00cf: { n:"SxNil" },
	0x00d0: { n:"SXTbl" },
	0x00d1: { n:"SXTBRGIITM" },
	0x00d2: { n:"SxTbpg" },
	0x00d3: { n:"ObProj" },
	0x00d5: { n:"SXStreamID" },
	0x00d7: { n:"DBCell" },
	0x00d8: { n:"SXRng" },
	0x00d9: { n:"SxIsxoper" },
	0x00da: { n:"BookBool", f:parseuint16 },
	0x00dc: { n:"DbOrParamQry" },
	0x00dd: { n:"ScenarioProtect", f:parsebool },
	0x00de: { n:"OleObjectSize" },
	0x00e0: { n:"XF", f:parse_XF },
	0x00e1: { n:'InterfaceHdr', f:parse_InterfaceHdr },
	0x00e2: { n:'InterfaceEnd', f:parsenoop2 },
	0x00e3: { n:"SXVS" },
	0x00e5: { n:"MergeCells", f:parse_MergeCells },
	0x00e9: { n:"BkHim" },
	0x00eb: { n:"MsoDrawingGroup" },
	0x00ec: { n:"MsoDrawing" },
	0x00ed: { n:"MsoDrawingSelection" },
	0x00ef: { n:"PhoneticInfo" },
	0x00f0: { n:"SxRule" },
	0x00f1: { n:"SXEx" },
	0x00f2: { n:"SxFilt" },
	0x00f4: { n:"SxDXF" },
	0x00f5: { n:"SxItm" },
	0x00f6: { n:"SxName" },
	0x00f7: { n:"SxSelect" },
	0x00f8: { n:"SXPair" },
	0x00f9: { n:"SxFmla" },
	0x00fb: { n:"SxFormat" },
	0x00fc: { n:"SST", f:parse_SST },
	0x00fd: { n:"LabelSst", f:parse_LabelSst },
	0x00ff: { n:"ExtSST", f:parse_ExtSST },
	0x0100: { n:"SXVDEx" },
	0x0103: { n:"SXFormula" },
	0x0122: { n:"SXDBEx" },
	0x0137: { n:"RRDInsDel" },
	0x0138: { n:"RRDHead" },
	0x013b: { n:"RRDChgCell" },
	0x013d: { n:"RRTabId", f:parseuint16a },
	0x013e: { n:"RRDRenSheet" },
	0x013f: { n:"RRSort" },
	0x0140: { n:"RRDMove" },
	0x014a: { n:"RRFormat" },
	0x014b: { n:"RRAutoFmt" },
	0x014d: { n:"RRInsertSh" },
	0x014e: { n:"RRDMoveBegin" },
	0x014f: { n:"RRDMoveEnd" },
	0x0150: { n:"RRDInsDelBegin" },
	0x0151: { n:"RRDInsDelEnd" },
	0x0152: { n:"RRDConflict" },
	0x0153: { n:"RRDDefName" },
	0x0154: { n:"RRDRstEtxp" },
	0x015f: { n:"LRng" },
	0x0160: { n:"UsesELFs", f:parsebool },
	0x0161: { n:"DSF", f:parsenoop2 },
	0x0191: { n:"CUsr" },
	0x0192: { n:"CbUsr" },
	0x0193: { n:"UsrInfo" },
	0x0194: { n:"UsrExcl" },
	0x0195: { n:"FileLock" },
	0x0196: { n:"RRDInfo" },
	0x0197: { n:"BCUsrs" },
	0x0198: { n:"UsrChk" },
	0x01a9: { n:"UserBView" },
	0x01aa: { n:"UserSViewBegin" },
	0x01ab: { n:"UserSViewEnd" },
	0x01ac: { n:"RRDUserView" },
	0x01ad: { n:"Qsi" },
	0x01ae: { n:"SupBook", f:parse_SupBook },
	0x01af: { n:"Prot4Rev", f:parsebool },
	0x01b0: { n:"CondFmt" },
	0x01b1: { n:"CF" },
	0x01b2: { n:"DVal" },
	0x01b5: { n:"DConBin" },
	0x01b6: { n:"TxO", f:parse_TxO },
	0x01b7: { n:"RefreshAll", f:parsebool },
	0x01b8: { n:"HLink", f:parse_HLink },
	0x01b9: { n:"Lel" },
	0x01ba: { n:"CodeName", f:parse_XLUnicodeString },
	0x01bb: { n:"SXFDBType" },
	0x01bc: { n:"Prot4RevPass", f:parseuint16 },
	0x01bd: { n:"ObNoMacros" },
	0x01be: { n:"Dv" },
	0x01c0: { n:"Excel9File", f:parsenoop2 },
	0x01c1: { n:"RecalcId", f:parse_RecalcId, r:2},
	0x01c2: { n:"EntExU2", f:parsenoop2 },
	0x0200: { n:"Dimensions", f:parse_Dimensions },
	0x0201: { n:"Blank", f:parse_Blank },
	0x0203: { n:"Number", f:parse_Number },
	0x0204: { n:"Label", f:parse_Label },
	0x0205: { n:"BoolErr", f:parse_BoolErr },
	0x0206: { n:"Formula", f:parse_Formula },
	0x0207: { n:"String", f:parse_String },
	0x0208: { n:'Row', f:parse_Row },
	0x020b: { n:"Index" },
	0x0221: { n:"Array", f:parse_Array },
	0x0225: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
	0x0236: { n:"Table" },
	0x023e: { n:"Window2", f:parse_Window2 },
	0x027e: { n:"RK", f:parse_RK },
	0x0293: { n:"Style" },
	0x0406: { n:"Formula", f:parse_Formula },
	0x0418: { n:"BigName" },
	0x041e: { n:"Format", f:parse_Format },
	0x043c: { n:"ContinueBigName" },
	0x04bc: { n:"ShrFmla", f:parse_ShrFmla },
	0x0800: { n:"HLinkTooltip", f:parse_HLinkTooltip },
	0x0801: { n:"WebPub" },
	0x0802: { n:"QsiSXTag" },
	0x0803: { n:"DBQueryExt" },
	0x0804: { n:"ExtString" },
	0x0805: { n:"TxtQry" },
	0x0806: { n:"Qsir" },
	0x0807: { n:"Qsif" },
	0x0808: { n:"RRDTQSIF" },
	0x0809: { n:'BOF', f:parse_BOF },
	0x080a: { n:"OleDbConn" },
	0x080b: { n:"WOpt" },
	0x080c: { n:"SXViewEx" },
	0x080d: { n:"SXTH" },
	0x080e: { n:"SXPIEx" },
	0x080f: { n:"SXVDTEx" },
	0x0810: { n:"SXViewEx9" },
	0x0812: { n:"ContinueFrt" },
	0x0813: { n:"RealTimeData" },
	0x0850: { n:"ChartFrtInfo" },
	0x0851: { n:"FrtWrapper" },
	0x0852: { n:"StartBlock" },
	0x0853: { n:"EndBlock" },
	0x0854: { n:"StartObject" },
	0x0855: { n:"EndObject" },
	0x0856: { n:"CatLab" },
	0x0857: { n:"YMult" },
	0x0858: { n:"SXViewLink" },
	0x0859: { n:"PivotChartBits" },
	0x085a: { n:"FrtFontList" },
	0x0862: { n:"SheetExt" },
	0x0863: { n:"BookExt", r:12},
	0x0864: { n:"SXAddl" },
	0x0865: { n:"CrErr" },
	0x0866: { n:"HFPicture" },
	0x0867: { n:'FeatHdr', f:parsenoop2 },
	0x0868: { n:"Feat" },
	0x086a: { n:"DataLabExt" },
	0x086b: { n:"DataLabExtContents" },
	0x086c: { n:"CellWatch" },
	0x0871: { n:"FeatHdr11" },
	0x0872: { n:"Feature11" },
	0x0874: { n:"DropDownObjIds" },
	0x0875: { n:"ContinueFrt11" },
	0x0876: { n:"DConn" },
	0x0877: { n:"List12" },
	0x0878: { n:"Feature12" },
	0x0879: { n:"CondFmt12" },
	0x087a: { n:"CF12" },
	0x087b: { n:"CFEx" },
	0x087c: { n:"XFCRC", f:parse_XFCRC, r:12 },
	0x087d: { n:"XFExt", f:parse_XFExt, r:12 },
	0x087e: { n:"AutoFilter12" },
	0x087f: { n:"ContinueFrt12" },
	0x0884: { n:"MDTInfo" },
	0x0885: { n:"MDXStr" },
	0x0886: { n:"MDXTuple" },
	0x0887: { n:"MDXSet" },
	0x0888: { n:"MDXProp" },
	0x0889: { n:"MDXKPI" },
	0x088a: { n:"MDB" },
	0x088b: { n:"PLV" },
	0x088c: { n:"Compat12", f:parsebool, r:12 },
	0x088d: { n:"DXF" },
	0x088e: { n:"TableStyles", r:12 },
	0x088f: { n:"TableStyle" },
	0x0890: { n:"TableStyleElement" },
	0x0892: { n:"StyleExt" },
	0x0893: { n:"NamePublish" },
	0x0894: { n:"NameCmt", f:parse_NameCmt, r:12 },
	0x0895: { n:"SortData" },
	0x0896: { n:"Theme", f:parse_Theme, r:12 },
	0x0897: { n:"GUIDTypeLib" },
	0x0898: { n:"FnGrp12" },
	0x0899: { n:"NameFnGrp12" },
	0x089a: { n:"MTRSettings", f:parse_MTRSettings, r:12 },
	0x089b: { n:"CompressPictures", f:parsenoop2 },
	0x089c: { n:"HeaderFooter" },
	0x089d: { n:"CrtLayout12" },
	0x089e: { n:"CrtMlFrt" },
	0x089f: { n:"CrtMlFrtContinue" },
	0x08a3: { n:"ForceFullCalculation", f:parse_ForceFullCalculation },
	0x08a4: { n:"ShapePropsStream" },
	0x08a5: { n:"TextPropsStream" },
	0x08a6: { n:"RichTextStream" },
	0x08a7: { n:"CrtLayout12A" },
	0x1001: { n:"Units" },
	0x1002: { n:"Chart" },
	0x1003: { n:"Series" },
	0x1006: { n:"DataFormat" },
	0x1007: { n:"LineFormat" },
	0x1009: { n:"MarkerFormat" },
	0x100a: { n:"AreaFormat" },
	0x100b: { n:"PieFormat" },
	0x100c: { n:"AttachedLabel" },
	0x100d: { n:"SeriesText" },
	0x1014: { n:"ChartFormat" },
	0x1015: { n:"Legend" },
	0x1016: { n:"SeriesList" },
	0x1017: { n:"Bar" },
	0x1018: { n:"Line" },
	0x1019: { n:"Pie" },
	0x101a: { n:"Area" },
	0x101b: { n:"Scatter" },
	0x101c: { n:"CrtLine" },
	0x101d: { n:"Axis" },
	0x101e: { n:"Tick" },
	0x101f: { n:"ValueRange" },
	0x1020: { n:"CatSerRange" },
	0x1021: { n:"AxisLine" },
	0x1022: { n:"CrtLink" },
	0x1024: { n:"DefaultText" },
	0x1025: { n:"Text" },
	0x1026: { n:"FontX", f:parseuint16 },
	0x1027: { n:"ObjectLink" },
	0x1032: { n:"Frame" },
	0x1033: { n:"Begin" },
	0x1034: { n:"End" },
	0x1035: { n:"PlotArea" },
	0x103a: { n:"Chart3d" },
	0x103c: { n:"PicF" },
	0x103d: { n:"DropBar" },
	0x103e: { n:"Radar" },
	0x103f: { n:"Surf" },
	0x1040: { n:"RadarArea" },
	0x1041: { n:"AxisParent" },
	0x1043: { n:"LegendException" },
	0x1044: { n:"ShtProps", f:parse_ShtProps },
	0x1045: { n:"SerToCrt" },
	0x1046: { n:"AxesUsed" },
	0x1048: { n:"SBaseRef" },
	0x104a: { n:"SerParent" },
	0x104b: { n:"SerAuxTrend" },
	0x104e: { n:"IFmtRecord" },
	0x104f: { n:"Pos" },
	0x1050: { n:"AlRuns" },
	0x1051: { n:"BRAI" },
	0x105b: { n:"SerAuxErrBar" },
	0x105c: { n:"ClrtClient", f:parse_ClrtClient },
	0x105d: { n:"SerFmt" },
	0x105f: { n:"Chart3DBarShape" },
	0x1060: { n:"Fbi" },
	0x1061: { n:"BopPop" },
	0x1062: { n:"AxcExt" },
	0x1063: { n:"Dat" },
	0x1064: { n:"PlotGrowth" },
	0x1065: { n:"SIIndex" },
	0x1066: { n:"GelFrame" },
	0x1067: { n:"BopPopCustom" },
	0x1068: { n:"Fbi2" },
	
	0x0000: { n:"Dimensions", f:parse_Dimensions },
	0x0002: { n:"BIFF2INT", f:parse_BIFF2INT },
	0x0005: { n:"BoolErr", f:parse_BoolErr },
	0x0007: { n:"String", f:parse_BIFF2STRING },
	0x0008: { n:"BIFF2ROW" },
	0x000b: { n:"Index" },
	0x0016: { n:"ExternCount", f:parseuint16 },
	0x001e: { n:"BIFF2FORMAT", f:parse_BIFF2Format },
	0x001f: { n:"BIFF2FMTCNT" }, /* 16-bit cnt of BIFF2FORMAT records */
	0x0020: { n:"BIFF2COLINFO" },
	0x0021: { n:"Array", f:parse_Array },
	0x0025: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
	0x0032: { n:"BIFF2FONTXTRA", f:parse_BIFF2FONTXTRA },
	0x0034: { n:"DDEObjName" },
	0x003e: { n:"BIFF2WINDOW2" },
	0x0043: { n:"BIFF2XF" },
	0x0045: { n:"BIFF2FONTCLR" },
	0x0056: { n:"BIFF4FMTCNT" }, /* 16-bit cnt, similar to BIFF2 */
	0x007e: { n:"RK" }, /* Not necessarily same as 0x027e */
	0x007f: { n:"ImData", f:parse_ImData },
	0x0087: { n:"Addin" },
	0x0088: { n:"Edg" },
	0x0089: { n:"Pub" },
	0x0091: { n:"Sub" },
	0x0094: { n:"LHRecord" },
	0x0095: { n:"LHNGraph" },
	0x0096: { n:"Sound" },
	0x00a9: { n:"CoordList" },
	0x00ab: { n:"GCW" },
	0x00bc: { n:"ShrFmla" }, /* Not necessarily same as 0x04bc */
	0x00bf: { n:"ToolbarHdr" },
	0x00c0: { n:"ToolbarEnd" },
	0x00c2: { n:"AddMenu" },
	0x00c3: { n:"DelMenu" },
	0x00d6: { n:"RString", f:parse_RString },
	0x00df: { n:"UDDesc" },
	0x00ea: { n:"TabIdConf" },
	0x0162: { n:"XL5Modify" },
	0x01a5: { n:"FileSharing2" },
	0x0209: { n:'BOF', f:parse_BOF },
	0x0218: { n:"Lbl", f:parse_Lbl },
	0x0223: { n:"ExternName", f:parse_ExternName },
	0x0231: { n:"Font" },
	0x0243: { n:"BIFF3XF" },
	0x0409: { n:'BOF', f:parse_BOF },
	0x0443: { n:"BIFF4XF" },
	0x086d: { n:"FeatInfo" },
	0x0873: { n:"FeatInfo11" },
	0x0881: { n:"SXAddl12" },
	0x08c0: { n:"AutoWebPub" },
	0x08c1: { n:"ListObj" },
	0x08c2: { n:"ListField" },
	0x08c3: { n:"ListDV" },
	0x08c4: { n:"ListCondFmt" },
	0x08c5: { n:"ListCF" },
	0x08c6: { n:"FMQry" },
	0x08c7: { n:"FMSQry" },
	0x08c8: { n:"PLV" },
	0x08c9: { n:"LnExt" },
	0x08ca: { n:"MkrExt" },
	0x08cb: { n:"CrtCoopt" },
	0x08d6: { n:"FRTArchId$", r:12 },
	
	0x7262: {}
	};
	
	var XLSRE = evert_key(XLSRecordEnum, 'n');
	function write_biff_rec(ba, type, payload, length) {
		var t = +type || +XLSRE[type];
		if(isNaN(t)) return;
		var len = length || (payload||[]).length || 0;
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, len);
		if(len > 0 && is_buf(payload)) ba.push(payload);
	}
	
	function write_BIFF2Cell(out, r, c) {
		if(!out) out = new_buf(7);
		out.write_shift(2, r);
		out.write_shift(2, c);
		out.write_shift(2, 0);
		out.write_shift(1, 0);
		return out;
	}
	
	function write_BIFF2BERR(r, c, val, t) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		if(t == 'e') { out.write_shift(1, val); out.write_shift(1, 1); }
		else { out.write_shift(1, val?1:0); out.write_shift(1, 0); }
		return out;
	}
	
	/* TODO: codepage, large strings */
	function write_BIFF2LABEL(r, c, val) {
		var out = new_buf(8 + 2*val.length);
		write_BIFF2Cell(out, r, c);
		out.write_shift(1, val.length);
		out.write_shift(val.length, val, 'sbcs');
		return out.l < out.length ? out.slice(0, out.l) : out;
	}
	
	function write_ws_biff2_cell(ba, cell, R, C) {
		if(cell.v != null) switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				if((v == (v|0)) && (v >= 0) && (v < 65536))
					write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
				else
					write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
				return;
			case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, cell.v));
				return;
		}
		write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
	}
	
	function write_ws_biff2(ba, ws, idx, opts) {
		var dense = Array.isArray(ws);
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, 0x3FFF);
			ref = encode_range(range);
		}
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff2_cell(ba, cell, R, C, opts);
			}
		}
	}
	
	/* Based on test files */
	function write_biff2_buf(wb, opts) {
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ba = buf_array();
		var idx = 0;
		for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
		if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
		write_biff_rec(ba, 0x0009, write_BOF(wb, 0x10, o));
		/* ... */
		write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
		/* ... */
		write_biff_rec(ba, 0x000A);
		return ba.end();
	}
	
	function write_FONTS_biff8(ba, data, opts) {
		write_biff_rec(ba, "Font", write_Font({
			sz:12,
			color: {theme:1},
			name: "Arial",
			family: 2,
			scheme: "minor"
		}, opts));
	}
	
	
	function write_FMTS_biff8(ba, NF, opts) {
		if(!NF) return;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, "Format", write_Format(i, NF[i], opts));
		});
	}
	
	function write_FEAT(ba, ws) {
		/* [MS-XLS] 2.4.112 */
		var o = new_buf(19);
		o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
		write_biff_rec(ba, "FeatHdr", o);
		/* [MS-XLS] 2.4.111 */
		o = new_buf(39);
		o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
		o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
		write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
		o.write_shift(4, 4);
		write_biff_rec(ba, "Feat", o);
	}
	
	function write_CELLXFS_biff8(ba, opts) {
		for(var i = 0; i < 16; ++i) write_biff_rec(ba, "XF", write_XF({numFmtId:0, style:true}, 0, opts));
		opts.cellXfs.forEach(function(c) {
			write_biff_rec(ba, "XF", write_XF(c, 0, opts));
		});
	}
	
	function write_ws_biff8_hlinks(ba, ws) {
		for(var R=0; R<ws['!links'].length; ++R) {
			var HL = ws['!links'][R];
			write_biff_rec(ba, "HLink", write_HLink(HL));
			if(HL[1].Tooltip) write_biff_rec(ba, "HLinkTooltip", write_HLinkTooltip(HL));
		}
		delete ws['!links'];
	}
	
	function write_ws_biff8_cell(ba, cell, R, C, opts) {
		var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
		if(cell.v == null && !cell.bf) {
			write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
			return;
		}
		if(cell.bf) write_biff_rec(ba, "Formula", write_Formula(cell, R, C, opts, os));
		else switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				/* TODO: emit RK as appropriate */
				write_biff_rec(ba, "Number", write_Number(R, C, v, os, opts));
				break;
			case 'b': case 'e':
				write_biff_rec(ba, 0x0205, write_BoolErr(R, C, cell.v, os, opts, cell.t));
				break;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, "Label", write_Label(R, C, cell.v, os, opts));
				break;
			default:
				write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
		}
	}
	
	/* [MS-XLS] 2.1.7.20.5 */
	function write_ws_biff8(idx, opts, wb) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var _WB = ((wb||{}).Workbook||{});
		var _sheet = ((_WB.Sheets||[])[idx]||{});
		var dense = Array.isArray(ws);
		var b8 = opts.biff == 8;
		var ref, rr = "", cols = [];
		var range = safe_decode_range(ws['!ref'] || "A1");
		var MAX_ROWS = b8 ? 65536 : 16384;
		if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, MAX_ROWS-1);
		}
	
		write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
		/* [Uncalced] Index */
		write_biff_rec(ba, "CalcMode", writeuint16(1));
		write_biff_rec(ba, "CalcCount", writeuint16(100));
		write_biff_rec(ba, "CalcRefMode", writebool(true));
		write_biff_rec(ba, "CalcIter", writebool(false));
		write_biff_rec(ba, "CalcDelta", write_Xnum(0.001));
		write_biff_rec(ba, "CalcSaveRecalc", writebool(true));
		write_biff_rec(ba, "PrintRowCol", writebool(false));
		write_biff_rec(ba, "PrintGrid", writebool(false));
		write_biff_rec(ba, "GridSet", writeuint16(1));
		write_biff_rec(ba, "Guts", write_Guts([0,0]));
		/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
		/* Header (string) */
		/* Footer (string) */
		write_biff_rec(ba, "HCenter", writebool(false));
		write_biff_rec(ba, "VCenter", writebool(false));
		/* ... */
		write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
		/* ... */
	
		if(b8) ws['!links'] = [];
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff8_cell(ba, cell, R, C, opts);
				if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
			}
		}
		var cname = _sheet.CodeName || _sheet.name || s;
		/* ... */
		if(b8 && _WB.Views) write_biff_rec(ba, "Window2", write_Window2(_WB.Views[0]));
		/* ... */
		if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, "MergeCells", write_MergeCells(ws['!merges']));
		/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
		if(b8) write_ws_biff8_hlinks(ba, ws);
		/* [DVAL] */
		write_biff_rec(ba, "CodeName", write_XLUnicodeString(cname, opts));
		/* *WebPub *CellWatch [SheetExt] */
		if(b8) write_FEAT(ba, ws);
		/* *FEAT11 *RECORD12 */
		write_biff_rec(ba, "EOF");
		return ba.end();
	}
	
	/* [MS-XLS] 2.1.7.20.3 */
	function write_biff8_global(wb, bufs, opts) {
		var A = buf_array();
		var _WB = ((wb||{}).Workbook||{});
		var _sheets = (_WB.Sheets||[]);
		var _wb = _WB.WBProps||{};
		var b8 = opts.biff == 8, b5 = opts.biff == 5;
		write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
		if(opts.bookType == "xla") write_biff_rec(A, "Addin");
		write_biff_rec(A, "InterfaceHdr", b8 ? writeuint16(0x04b0) : null);
		write_biff_rec(A, "Mms", writezeroes(2));
		if(b5) write_biff_rec(A, "ToolbarHdr");
		if(b5) write_biff_rec(A, "ToolbarEnd");
		write_biff_rec(A, "InterfaceEnd");
		write_biff_rec(A, "WriteAccess", write_WriteAccess("SheetJS", opts));
		/* [FileSharing] */
		write_biff_rec(A, "CodePage", writeuint16(b8 ? 0x04b0 : 0x04E4));
		/* *2047 Lel */
		if(b8) write_biff_rec(A, "DSF", writeuint16(0));
		if(b8) write_biff_rec(A, "Excel9File");
		write_biff_rec(A, "RRTabId", write_RRTabId(wb.SheetNames.length));
		if(b8 && wb.vbaraw) write_biff_rec(A, "ObProj");
		/* [ObNoMacros] */
		if(b8 && wb.vbaraw) {
			var cname = _wb.CodeName || "ThisWorkbook";
			write_biff_rec(A, "CodeName", write_XLUnicodeString(cname, opts));
		}
		write_biff_rec(A, "BuiltInFnGroupCount", writeuint16(0x11));
		/* *FnGroupName *FnGrp12 */
		/* *Lbl */
		/* [OleObjectSize] */
		write_biff_rec(A, "WinProtect", writebool(false));
		write_biff_rec(A, "Protect", writebool(false));
		write_biff_rec(A, "Password", writeuint16(0));
		if(b8) write_biff_rec(A, "Prot4Rev", writebool(false));
		if(b8) write_biff_rec(A, "Prot4RevPass", writeuint16(0));
		write_biff_rec(A, "Window1", write_Window1(opts));
		write_biff_rec(A, "Backup", writebool(false));
		write_biff_rec(A, "HideObj", writeuint16(0));
		write_biff_rec(A, "Date1904", writebool(safe1904(wb)=="true"));
		write_biff_rec(A, "CalcPrecision", writebool(true));
		if(b8) write_biff_rec(A, "RefreshAll", writebool(false));
		write_biff_rec(A, "BookBool", writeuint16(0));
		/* ... */
		write_FONTS_biff8(A, wb, opts);
		write_FMTS_biff8(A, wb.SSF, opts);
		write_CELLXFS_biff8(A, opts);
		/* ... */
		if(b8) write_biff_rec(A, "UsesELFs", writebool(false));
		var a = A.end();
	
		var C = buf_array();
		/* METADATA [MTRSettings] [ForceFullCalculation] */
		if(b8) write_biff_rec(C, "Country", write_Country());
		/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */
		/* BIFF8: [SST *Continue] ExtSST */
		/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
		write_biff_rec(C, "EOF");
		var c = C.end();
	
		var B = buf_array();
		var blen = 0, j = 0;
		for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
		var start = a.length + blen + c.length;
		for(j = 0; j < wb.SheetNames.length; ++j) {
			var _sheet = _sheets[j] || ({});
			write_biff_rec(B, "BoundSheet8", write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
			start += bufs[j].length;
		}
		/* 1*BoundSheet8 */
		var b = B.end();
		if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
	
		var out = [];
		if(a.length) out.push(a);
		if(b.length) out.push(b);
		if(c.length) out.push(c);
		return __toBuffer([out]);
	}
	
	/* [MS-XLS] 2.1.7.20 Workbook Stream */
	function write_biff8_buf(wb, opts) {
		var o = opts || {};
		var bufs = [];
	
		if(wb && !wb.SSF) {
			wb.SSF = SSF.get_table();
		}
		if(wb && wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			// $FlowIgnore
			o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
			o.ssf = wb.SSF;
		}
	
		o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
		fix_write_opts(o);
	
		o.cellXfs = [];
		get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
		bufs.unshift(write_biff8_global(wb, bufs, o));
		return __toBuffer([bufs]);
	}
	
	function write_biff_buf(wb, opts) {
		var o = opts || {};
		switch(o.biff || 2) {
			case 8: case 5: return write_biff8_buf(wb, opts);
			case 4: case 3: case 2: return write_biff2_buf(wb, opts);
		}
		throw new Error("invalid type " + o.bookType + " for BIFF");
	}
	/* note: browser DOM element cannot see mso- style attrs, must parse */
	var HTML_ = (function() {
		function html_to_sheet(str, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var ws = opts.dense ? ([]) : ({});
			str = str.replace(/<!--.*?-->/g, "");
			var mtch = str.match(/<table/i);
			if(!mtch) throw new Error("Invalid HTML: could not find <table>");
			var mtch2 = str.match(/<\/table/i);
			var i = mtch.index, j = mtch2 && mtch2.index || str.length;
			var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
			var R = -1, C = 0, RS = 0, CS = 0;
			var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
			var merges = [];
			for(i = 0; i < rows.length; ++i) {
				var row = rows[i].trim();
				var hd = row.slice(0,3).toLowerCase();
				if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
				if(hd != "<td" && hd != "<th") continue;
				var cells = row.split(/<\/t[dh]>/i);
				for(j = 0; j < cells.length; ++j) {
					var cell = cells[j].trim();
					if(!cell.match(/<t[dh]/i)) continue;
					var m = cell, cc = 0;
					/* TODO: parse styles etc */
					while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
					for(var midx = 0; midx < merges.length; ++midx) {
						var _merge = merges[midx];
						if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
					}
					var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
					CS = tag.colspan ? +tag.colspan : 1;
					if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
					var _t = tag.t || "";
					/* TODO: generate stub cells */
					if(!m.length) { C += CS; continue; }
					m = htmldecode(m);
					if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
					if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
					if(!m.length) continue;
					var o = {t:'s', v:m};
					if(opts.raw || !m.trim().length || _t == 's'){}
					else if(m === 'TRUE') o = {t:'b', v:true};
					else if(m === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
					else if(!isNaN(fuzzydate(m).getDate())) {
						o = ({t:'d', v:parseDate(m)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || SSF._table[14];
					}
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
					else ws[encode_cell({r:R, c:C})] = o;
					C += CS;
				}
			}
			ws['!ref'] = encode_range(range);
			if(merges.length) ws["!merges"] = merges;
			return ws;
		}
		function html_to_book(str, opts) {
			return sheet_to_workbook(html_to_sheet(str, opts), opts);
		}
		function make_html_row(ws, r, R, o) {
			var M = (ws['!merges'] ||[]);
			var oo = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var RS = 0, CS = 0;
				for(var j = 0; j < M.length; ++j) {
					if(M[j].s.r > R || M[j].s.c > C) continue;
					if(M[j].e.r < R || M[j].e.c < C) continue;
					if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
					RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
				}
				if(RS < 0) continue;
				var coord = encode_cell({r:R,c:C});
				var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
				/* TODO: html entities */
				var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
				var sp = ({});
				if(RS > 1) sp.rowspan = RS;
				if(CS > 1) sp.colspan = CS;
				sp.t = cell && cell.t || 'z';
				if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
				sp.id = (o.id || "sjs") + "-" + coord;
				oo.push(writextag('td', w, sp));
			}
			var preamble = "<tr>";
			return preamble + oo.join("") + "</tr>";
		}
		function make_html_preamble(ws, R, o) {
			var out = [];
			return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
		}
		var _BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
		var _END = '</body></html>';
		function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
			var o = opts || {};
			var header = o.header != null ? o.header : _BEGIN;
			var footer = o.footer != null ? o.footer : _END;
			var out = [header];
			var r = decode_range(ws['!ref']);
			o.dense = Array.isArray(ws);
			out.push(make_html_preamble(ws, r, o));
			for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
			out.push("</table>" + footer);
			return out.join("");
		}
	
		return {
			to_workbook: html_to_book,
			to_sheet: html_to_sheet,
			_row: make_html_row,
			BEGIN: _BEGIN,
			END: _END,
			_preamble: make_html_preamble,
			from_sheet: sheet_to_html
		};
	})();
	
	function parse_dom_table(table, _opts) {
		var opts = _opts || {};
		if(DENSE != null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		var rows = table.getElementsByTagName('tr');
		var sheetRows = opts.sheetRows || 10000000;
		var range = {s:{r:0,c:0},e:{r:0,c:0}};
		var merges = [], midx = 0;
		var rowinfo = [];
		var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
		for(; _R < rows.length && R < sheetRows; ++_R) {
			var row = rows[_R];
			if (is_dom_element_hidden(row)) {
				if (opts.display) continue;
				rowinfo[R] = {hidden: true};
			}
			var elts = (row.children);
			for(_C = C = 0; _C < elts.length; ++_C) {
				var elt = elts[_C];
				if (opts.display && is_dom_element_hidden(elt)) continue;
				var v = htmldecode(elt.innerHTML);
				for(midx = 0; midx < merges.length; ++midx) {
					var m = merges[midx];
					if(m.s.c == C && m.s.r <= R && R <= m.e.r) { C = m.e.c+1; midx = -1; }
				}
				/* TODO: figure out how to extract nonstandard mso- style */
				CS = +elt.getAttribute("colspan") || 1;
				if((RS = +elt.getAttribute("rowspan"))>0 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var o = {t:'s', v:v};
				var _t = elt.getAttribute("t") || "";
				if(v != null) {
					if(v.length == 0) o.t = _t || 'z';
					else if(opts.raw || v.trim().length == 0 || _t == "s"){}
					else if(v === 'TRUE') o = {t:'b', v:true};
					else if(v === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
					else if(!isNaN(fuzzydate(v).getDate())) {
						o = ({t:'d', v:parseDate(v)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || SSF._table[14];
					}
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({c:C, r:R})] = o;
				if(range.e.c < C) range.e.c = C;
				C += CS;
			}
			++R;
		}
		if(merges.length) ws['!merges'] = merges;
		if(rowinfo.length) ws['!rows'] = rowinfo;
		range.e.r = R - 1;
		ws['!ref'] = encode_range(range);
		if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1,range)); // We can count the real number of rows to parse but we don't to improve the performance
		return ws;
	}
	
	function table_to_book(table, opts) {
		return sheet_to_workbook(parse_dom_table(table, opts), opts);
	}
	
	function is_dom_element_hidden(element) {
		var display = '';
		var get_computed_style = get_get_computed_style_function(element);
		if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
		if(!display) display = element.style.display; // Fallback for cases when getComputedStyle is not available (e.g. an old browser or some Node.js environments) or doesn't work (e.g. if the element is not inserted to a document)
		return display === 'none';
	}
	
	/* global getComputedStyle */
	function get_get_computed_style_function(element) {
		// The proper getComputedStyle implementation is the one defined in the element window
		if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
		// If it is not available, try to get one from the global namespace
		if(typeof getComputedStyle === 'function') return getComputedStyle;
		return null;
	}
	/* OpenDocument */
	var parse_content_xml = (function() {
	
		var parse_text_p = function(text) {
			/* 6.1.2 White Space Characters */
			var fixed = text
				.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
				.replace(/<text:s\/>/g," ")
				.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
				.replace(/<text:tab[^>]*\/>/g,"\t")
				.replace(/<text:line-break\/>/g,"\n");
			var v = unescapexml(fixed.replace(/<[^>]*>/g,""));
	
			return [v];
		};
	
		var number_formats = {
			/* ods name: [short ssf fmt, long ssf fmt] */
			day:           ["d",   "dd"],
			month:         ["m",   "mm"],
			year:          ["y",   "yy"],
			hours:         ["h",   "hh"],
			minutes:       ["m",   "mm"],
			seconds:       ["s",   "ss"],
			"am-pm":       ["A/P", "AM/PM"],
			"day-of-week": ["ddd", "dddd"],
			era:           ["e",   "ee"],
			/* there is no native representation of LO "Q" format */
			quarter:       ["\\Qm", "m\\\"th quarter\""]
		};
	
		return function pcx(d, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var str = xlml_normalize(d);
			var state = [], tmp;
			var tag;
			var NFtag = {name:""}, NF = "", pidx = 0;
			var sheetag;
			var rowtag;
			var Sheets = {}, SheetNames = [];
			var ws = opts.dense ? ([]) : ({});
			var Rn, q;
			var ctag = ({value:""});
			var textp = "", textpidx = 0, textptag;
			var textR = [];
			var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
			var row_ol = 0;
			var number_format_map = {};
			var merges = [], mrange = {}, mR = 0, mC = 0;
			var rowinfo = [], rowpeat = 1, colpeat = 1;
			var arrayf = [];
			var WB = {Names:[]};
			var atag = ({});
			var _Ref = ["", ""];
			var comments = [], comment = ({});
			var creator = "", creatoridx = 0;
			var isstub = false, intable = false;
			var i = 0;
			xlmlregex.lastIndex = 0;
			str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
			while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {
	
				case 'table': case '工作表': // 9.1.2 <table:table>
					if(Rn[1]==='/') {
						if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
						if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
							ws['!fullref'] = ws['!ref'];
							range.e.r = opts.sheetRows - 1;
							ws['!ref'] = encode_range(range);
						}
						if(merges.length) ws['!merges'] = merges;
						if(rowinfo.length) ws["!rows"] = rowinfo;
						sheetag.name = sheetag['名称'] || sheetag.name;
						if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
						SheetNames.push(sheetag.name);
						Sheets[sheetag.name] = ws;
						intable = false;
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						sheetag = parsexmltag(Rn[0], false);
						R = C = -1;
						range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
						ws = opts.dense ? ([]) : ({}); merges = [];
						rowinfo = [];
						intable = true;
					}
					break;
	
				case 'table-row-group': // 9.1.9 <table:table-row-group>
					if(Rn[1] === "/") --row_ol; else ++row_ol;
					break;
				case 'table-row': case '行': // 9.1.3 <table:table-row>
					if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
					rowtag = parsexmltag(Rn[0], false);
					if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
					rowpeat = +rowtag['number-rows-repeated'] || 1;
					/* TODO: remove magic */
					if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
					C = -1; break;
				case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
					if(Rn[1] !== '/') ++C;
					if(opts.sheetStubs) {
						if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
						else ws[encode_cell({r:R,c:C})] = {t:'z'};
					}
					textp = ""; textR = [];
					break; /* stub */
				case 'table-cell': case '数据':
					if(Rn[0].charAt(Rn[0].length-2) === '/') {
						++C;
						ctag = parsexmltag(Rn[0], false);
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						q = ({t:'z', v:null});
						if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
						if((ctag['数据类型'] || ctag['value-type']) == "string") {
							q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
							if(opts.dense) {
								if(!ws[R]) ws[R] = [];
								ws[R][C] = q;
							} else {
								ws[encode_cell({r:R,c:C})] = q;
							}
						}
						C+= colpeat-1;
					} else if(Rn[1]!=='/') {
						++C;
						colpeat = 1;
						var rptR = rowpeat ? R + rowpeat - 1 : R;
						if(C > range.e.c) range.e.c = C;
						if(C < range.s.c) range.s.c = C;
						if(R < range.s.r) range.s.r = R;
						if(rptR > range.e.r) range.e.r = rptR;
						ctag = parsexmltag(Rn[0], false);
						comments = []; comment = ({});
						q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
						if(opts.cellFormula) {
							if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
							if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
								mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
								mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
								mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
								q.F = encode_range(mrange);
								arrayf.push([mrange, q.F]);
							}
							if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
							else for(i = 0; i < arrayf.length; ++i)
								if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
									if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
										q.F = arrayf[i][1];
						}
						if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
							mR = parseInt(ctag['number-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							merges.push(mrange);
						}
	
						/* 19.675.2 table:number-columns-repeated */
						if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
	
						/* 19.385 office:value-type */
						switch(q.t) {
							case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
							case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
								if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
								q.z = 'm/d/yy'; break;
							case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400; break;
							case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
							default:
								if(q.t === 'string' || q.t === 'text' || !q.t) {
									q.t = 's';
									if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
								} else throw new Error('Unsupported value type ' + q.t);
						}
					} else {
						isstub = false;
						if(q.t === 's') {
							q.v = textp || '';
							if(textR.length) q.R = textR;
							isstub = textpidx == 0;
						}
						if(atag.Target) q.l = atag;
						if(comments.length > 0) { q.c = comments; comments = []; }
						if(textp && opts.cellText !== false) q.w = textp;
						if(!isstub || opts.sheetStubs) {
							if(!(opts.sheetRows && opts.sheetRows <= R)) {
								for(var rpt = 0; rpt < rowpeat; ++rpt) {
									colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
									if(opts.dense) {
										if(!ws[R + rpt]) ws[R + rpt] = [];
										ws[R + rpt][C] = rpt == 0 ? q : dup(q);
										while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
									} else {
										ws[encode_cell({r:R + rpt,c:C})] = q;
										while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
									}
									if(range.e.c <= C) range.e.c = C;
								}
							}
						}
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						C += colpeat-1; colpeat = 0;
						q = {};
						textp = ""; textR = [];
					}
					atag = ({});
					break; // 9.1.4 <table:table-cell>
	
				/* pure state */
				case 'document': // TODO: <office:document> is the root for FODS
				case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
				case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
				case 'scripts': // 3.12 <office:scripts>
				case 'styles': // TODO <office:styles>
				case 'font-face-decls': // 3.14 <office:font-face-decls>
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
	
				case 'annotation': // 14.1 <office:annotation>
					if(Rn[1]==='/'){
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
						comment.t = textp;
						if(textR.length) comment.R = textR;
						comment.a = creator;
						comments.push(comment);
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
					creator = ""; creatoridx = 0;
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'creator': // 4.3.2.7 <dc:creator>
					if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
					else creatoridx = Rn.index + Rn[0].length;
					break;
	
				/* ignore state */
				case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
				case 'settings': // TODO: <office:settings>
				case 'config-item-set': // TODO: <office:config-item-set>
				case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
				case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
				case 'config-item-map-named': // TODO: <office:config-item-map-entry>
				case 'shapes': // 9.2.8 <table:shapes>
				case 'frame': // 10.4.2 <draw:frame>
				case 'text-box': // 10.4.3 <draw:text-box>
				case 'image': // 10.4.4 <draw:image>
				case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
				case 'list-style': // 16.30 <text:list-style>
				case 'form': // 13.13 <form:form>
				case 'dde-links': // 9.8 <table:dde-links>
				case 'event-listeners': // TODO
				case 'chart': // TODO
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'scientific-number': // TODO: <number:scientific-number>
					break;
				case 'currency-symbol': // TODO: <number:currency-symbol>
					break;
				case 'currency-style': // TODO: <number:currency-style>
					break;
				case 'number-style': // 16.27.2 <number:number-style>
				case 'percentage-style': // 16.27.9 <number:percentage-style>
				case 'date-style': // 16.27.10 <number:date-style>
				case 'time-style': // 16.27.18 <number:time-style>
					if(Rn[1]==='/'){
						number_format_map[NFtag.name] = NF;
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						NF = "";
						NFtag = parsexmltag(Rn[0], false);
						state.push([Rn[3], true]);
					} break;
	
				case 'script': break; // 3.13 <office:script>
				case 'libraries': break; // TODO: <ooo:libraries>
				case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
				case 'master-styles': break; // TODO: <office:master-styles>
	
				case 'default-style': // TODO: <style:default-style>
				case 'page-layout': break; // TODO: <style:page-layout>
				case 'style': // 16.2 <style:style>
					break;
				case 'map': break; // 16.3 <style:map>
				case 'font-face': break; // 16.21 <style:font-face>
	
				case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
				case 'table-properties': break; // 17.15 <style:table-properties>
				case 'table-column-properties': break; // 17.16 <style:table-column-properties>
				case 'table-row-properties': break; // 17.17 <style:table-row-properties>
				case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>
	
				case 'number': // 16.27.3 <number:number>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'fraction': break; // TODO 16.27.6 <number:fraction>
	
				case 'day': // 16.27.11 <number:day>
				case 'month': // 16.27.12 <number:month>
				case 'year': // 16.27.13 <number:year>
				case 'era': // 16.27.14 <number:era>
				case 'day-of-week': // 16.27.15 <number:day-of-week>
				case 'week-of-year': // 16.27.16 <number:week-of-year>
				case 'quarter': // 16.27.17 <number:quarter>
				case 'hours': // 16.27.19 <number:hours>
				case 'minutes': // 16.27.20 <number:minutes>
				case 'seconds': // 16.27.21 <number:seconds>
				case 'am-pm': // 16.27.22 <number:am-pm>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'boolean-style': break; // 16.27.23 <number:boolean-style>
				case 'boolean': break; // 16.27.24 <number:boolean>
				case 'text-style': break; // 16.27.25 <number:text-style>
				case 'text': // 16.27.26 <number:text>
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") switch(state[state.length-1][0]) {
						case 'number-style':
						case 'date-style':
						case 'time-style':
							NF += str.slice(pidx, Rn.index);
							break;
					}
					else pidx = Rn.index + Rn[0].length;
					break;
	
				case 'named-range': // 9.4.12 <table:named-range>
					tag = parsexmltag(Rn[0], false);
					_Ref = ods_to_csf_3D(tag['cell-range-address']);
					var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
					if(intable) nrange.Sheet = SheetNames.length;
					WB.Names.push(nrange);
					break;
	
				case 'text-content': break; // 16.27.27 <number:text-content>
				case 'text-properties': break; // 16.27.27 <style:text-properties>
				case 'embedded-text': break; // 16.27.4 <number:embedded-text>
	
				case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3
	
				case 'forms': break; // 12.25.2 13.2
				case 'table-column': break; // 9.1.6 <table:table-column>
				case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
				case 'table-rows': break; // 9.1.12 <table:table-rows>
				/* TODO: outline levels */
				case 'table-column-group': break; // 9.1.10 <table:table-column-group>
				case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
				case 'table-columns': break; // 9.1.12 <table:table-columns>
	
				case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904
	
				case 'graphic-properties': break; // 17.21 <style:graphic-properties>
				case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
				case 'named-expressions': break; // 9.4.11 <table:named-expressions>
				case 'label-range': break; // 9.4.9 <table:label-range>
				case 'label-ranges': break; // 9.4.10 <table:label-ranges>
				case 'named-expression': break; // 9.4.13 <table:named-expression>
				case 'sort': break; // 9.4.19 <table:sort>
				case 'sort-by': break; // 9.4.20 <table:sort-by>
				case 'sort-groups': break; // 9.4.22 <table:sort-groups>
	
				case 'tab': break; // 6.1.4 <text:tab>
				case 'line-break': break; // 6.1.5 <text:line-break>
				case 'span': break; // 6.1.7 <text:span>
				case 'p': case '文本串': // 5.1.3 <text:p>
					if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
						var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
						textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
					} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
					break; // <text:p>
				case 's': break; // <text:s>
	
				case 'database-range': // 9.4.15 <table:database-range>
					if(Rn[1]==='/') break;
					try {
						_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
						Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
					} catch(e) {/* empty */}
					break;
	
				case 'date': break; // <*:date>
	
				case 'object': break; // 10.4.6.2 <draw:object>
				case 'title': case '标题': break; // <*:title> OR <uof:标题>
				case 'desc': break; // <*:desc>
				case 'binary-data': break; // 10.4.5 TODO: b64 blob
	
				/* 9.2 Advanced Tables */
				case 'table-source': break; // 9.2.6
				case 'scenario': break; // 9.2.6
	
				case 'iteration': break; // 9.4.3 <table:iteration>
				case 'content-validations': break; // 9.4.4 <table:
				case 'content-validation': break; // 9.4.5 <table:
				case 'help-message': break; // 9.4.6 <table:
				case 'error-message': break; // 9.4.7 <table:
				case 'database-ranges': break; // 9.4.14 <table:database-ranges>
				case 'filter': break; // 9.5.2 <table:filter>
				case 'filter-and': break; // 9.5.3 <table:filter-and>
				case 'filter-or': break; // 9.5.4 <table:filter-or>
				case 'filter-condition': break; // 9.5.5 <table:filter-condition>
	
				case 'list-level-style-bullet': break; // 16.31 <text:
				case 'list-level-style-number': break; // 16.32 <text:
				case 'list-level-properties': break; // 17.19 <style:
	
				/* 7.3 Document Fields */
				case 'sender-firstname': // 7.3.6.2
				case 'sender-lastname': // 7.3.6.3
				case 'sender-initials': // 7.3.6.4
				case 'sender-title': // 7.3.6.5
				case 'sender-position': // 7.3.6.6
				case 'sender-email': // 7.3.6.7
				case 'sender-phone-private': // 7.3.6.8
				case 'sender-fax': // 7.3.6.9
				case 'sender-company': // 7.3.6.10
				case 'sender-phone-work': // 7.3.6.11
				case 'sender-street': // 7.3.6.12
				case 'sender-city': // 7.3.6.13
				case 'sender-postal-code': // 7.3.6.14
				case 'sender-country': // 7.3.6.15
				case 'sender-state-or-province': // 7.3.6.16
				case 'author-name': // 7.3.7.1
				case 'author-initials': // 7.3.7.2
				case 'chapter': // 7.3.8
				case 'file-name': // 7.3.9
				case 'template-name': // 7.3.9
				case 'sheet-name': // 7.3.9
					break;
	
				case 'event-listener':
					break;
				/* TODO: FODS Properties */
				case 'initial-creator':
				case 'creation-date':
				case 'print-date':
				case 'generator':
				case 'document-statistic':
				case 'user-defined':
				case 'editing-duration':
				case 'editing-cycles':
					break;
	
				/* TODO: FODS Config */
				case 'config-item':
					break;
	
				/* TODO: style tokens */
				case 'page-number': break; // TODO <text:page-number>
				case 'page-count': break; // TODO <text:page-count>
				case 'time': break; // TODO <text:time>
	
				/* 9.3 Advanced Table Cells */
				case 'cell-range-source': break; // 9.3.1 <table:
				case 'detective': break; // 9.3.2 <table:
				case 'operation': break; // 9.3.3 <table:
				case 'highlighted-range': break; // 9.3.4 <table:
	
				/* 9.6 Data Pilot Tables <table: */
				case 'data-pilot-table': // 9.6.3
				case 'source-cell-range': // 9.6.5
				case 'source-service': // 9.6.6
				case 'data-pilot-field': // 9.6.7
				case 'data-pilot-level': // 9.6.8
				case 'data-pilot-subtotals': // 9.6.9
				case 'data-pilot-subtotal': // 9.6.10
				case 'data-pilot-members': // 9.6.11
				case 'data-pilot-member': // 9.6.12
				case 'data-pilot-display-info': // 9.6.13
				case 'data-pilot-sort-info': // 9.6.14
				case 'data-pilot-layout-info': // 9.6.15
				case 'data-pilot-field-reference': // 9.6.16
				case 'data-pilot-groups': // 9.6.17
				case 'data-pilot-group': // 9.6.18
				case 'data-pilot-group-member': // 9.6.19
					break;
	
				/* 10.3 Drawing Shapes */
				case 'rect': // 10.3.2
					break;
	
				/* 14.6 DDE Connections */
				case 'dde-connection-decls': // 14.6.2 <text:
				case 'dde-connection-decl': // 14.6.3 <text:
				case 'dde-link': // 14.6.4 <table:
				case 'dde-source': // 14.6.5 <office:
					break;
	
				case 'properties': break; // 13.7 <form:properties>
				case 'property': break; // 13.8 <form:property>
	
				case 'a': // 6.1.8 hyperlink
					if(Rn[1]!== '/') {
						atag = parsexmltag(Rn[0], false);
						if(!atag.href) break;
						atag.Target = atag.href; delete atag.href;
						if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
							_Ref = ods_to_csf_3D(atag.Target.slice(1));
							atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
						}
					}
					break;
	
				/* non-standard */
				case 'table-protection': break;
				case 'data-pilot-grand-total': break; // <table:
				case 'office-document-common-attrs': break; // bare
				default: switch(Rn[2]) {
					case 'dc:':       // TODO: properties
					case 'calcext:':  // ignore undocumented extensions
					case 'loext:':    // ignore undocumented extensions
					case 'ooo:':      // ignore undocumented extensions
					case 'chartooo:': // ignore undocumented extensions
					case 'draw:':     // TODO: drawing
					case 'style:':    // TODO: styles
					case 'chart:':    // TODO: charts
					case 'form:':     // TODO: forms
					case 'uof:':      // TODO: uof
					case '表:':       // TODO: uof
					case '字:':       // TODO: uof
						break;
					default: if(opts.WTF) throw new Error(Rn);
				}
			}
			var out = ({
				Sheets: Sheets,
				SheetNames: SheetNames,
				Workbook: WB
			});
			if(opts.bookSheets) delete out.Sheets;
			return out;
		};
	})();
	
	function parse_ods(zip, opts) {
		opts = opts || ({});
		var ods = !!safegetzipfile(zip, 'objectdata');
		if(ods) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
		var content = getzipstr(zip, 'content.xml');
		if(!content) throw new Error("Missing content.xml in " + (ods ? "ODS" : "UOF")+ " file");
		var wb = parse_content_xml(ods ? content : utf8read(content), opts);
		if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
		return wb;
	}
	function parse_fods(data, opts) {
		return parse_content_xml(data, opts);
	}
	
	/* OpenDocument */
	var write_styles_ods = (function() {
		var payload = '<office:document-styles ' + wxt_helper({
			'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':    "http://www.w3.org/1999/xlink",
			'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
			'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'office:version': "1.2"
		}) + '></office:document-styles>';
		return function wso() {
			return XML_HEADER + payload;
		};
	})();
	var write_content_ods = (function() {
		/* 6.1.2 White Space Characters */
		var write_text_p = function(text) {
			return escapexml(text)
				.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
				.replace(/\t/g, "<text:tab/>")
				.replace(/\n/g, "<text:line-break/>")
				.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
		};
	
		var null_cell_xml = '          <table:table-cell />\n';
		var covered_cell_xml = '          <table:covered-table-cell/>\n';
		var write_ws = function(ws, wb, i) {
			/* Section 9 Tables */
			var o = [];
			o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '">\n');
			var R=0,C=0, range = decode_range(ws['!ref']);
			var marr = ws['!merges'] || [], mi = 0;
			var dense = Array.isArray(ws);
			for(R = 0; R < range.s.r; ++R) o.push('        <table:table-row></table:table-row>\n');
			for(; R <= range.e.r; ++R) {
				o.push('        <table:table-row>\n');
				for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
				for(; C <= range.e.c; ++C) {
					var skip = false, ct = {}, textp = "";
					for(mi = 0; mi != marr.length; ++mi) {
						if(marr[mi].s.c > C) continue;
						if(marr[mi].s.r > R) continue;
						if(marr[mi].e.c < C) continue;
						if(marr[mi].e.r < R) continue;
						if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
						ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
						ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
						break;
					}
					if(skip) { o.push(covered_cell_xml); continue; }
					var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
					if(cell && cell.f) {
						ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
						if(cell.F) {
							if(cell.F.slice(0, ref.length) == ref) {
								var _Fref = decode_range(cell.F);
								ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
								ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
							}
						}
					}
					if(!cell) { o.push(null_cell_xml); continue; }
					switch(cell.t) {
						case 'b':
							textp = (cell.v ? 'TRUE' : 'FALSE');
							ct['office:value-type'] = "boolean";
							ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
							break;
						case 'n':
							textp = (cell.w||String(cell.v||0));
							ct['office:value-type'] = "float";
							ct['office:value'] = (cell.v||0);
							break;
						case 's': case 'str':
							textp = cell.v;
							ct['office:value-type'] = "string";
							break;
						case 'd':
							textp = (cell.w||(parseDate(cell.v).toISOString()));
							ct['office:value-type'] = "date";
							ct['office:date-value'] = (parseDate(cell.v).toISOString());
							ct['table:style-name'] = "ce1";
							break;
						//case 'e':
						default: o.push(null_cell_xml); continue;
					}
					var text_p = write_text_p(textp);
					if(cell.l && cell.l.Target) {
						var _tgt = cell.l.Target; _tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
						text_p = writextag('text:a', text_p, {'xlink:href': _tgt});
					}
					o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
				}
				o.push('        </table:table-row>\n');
			}
			o.push('      </table:table>\n');
			return o.join("");
		};
	
		var write_automatic_styles_ods = function(o) {
			o.push(' <office:automatic-styles>\n');
			o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
			o.push('   <number:month number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:day number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:year/>\n');
			o.push('  </number:date-style>\n');
			o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
			o.push(' </office:automatic-styles>\n');
		};
	
		return function wcx(wb, opts) {
			var o = [XML_HEADER];
			/* 3.1.3.2 */
			var attr = wxt_helper({
				'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
				'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
				'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
				'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
				'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
				'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
				'xmlns:xlink':        "http://www.w3.org/1999/xlink",
				'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
				'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
				'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
				'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
				'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
				'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
				'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
				'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
				'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
				'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
				'xmlns:ooo':          "http://openoffice.org/2004/office",
				'xmlns:ooow':         "http://openoffice.org/2004/writer",
				'xmlns:oooc':         "http://openoffice.org/2004/calc",
				'xmlns:dom':          "http://www.w3.org/2001/xml-events",
				'xmlns:xforms':       "http://www.w3.org/2002/xforms",
				'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
				'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
				'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
				'xmlns:rpt':          "http://openoffice.org/2005/report",
				'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
				'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
				'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
				'xmlns:tableooo':     "http://openoffice.org/2009/table",
				'xmlns:drawooo':      "http://openoffice.org/2010/draw",
				'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
				'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
				'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
				'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
				'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
				'office:version':     "1.2"
			});
	
			var fods = wxt_helper({
				'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
				'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
			});
	
			if(opts.bookType == "fods") o.push('<office:document' + attr + fods + '>\n');
			else o.push('<office:document-content' + attr  + '>\n');
			write_automatic_styles_ods(o);
			o.push('  <office:body>\n');
			o.push('    <office:spreadsheet>\n');
			for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
			o.push('    </office:spreadsheet>\n');
			o.push('  </office:body>\n');
			if(opts.bookType == "fods") o.push('</office:document>');
			else o.push('</office:document-content>');
			return o.join("");
		};
	})();
	
	function write_ods(wb, opts) {
		if(opts.bookType == "fods") return write_content_ods(wb, opts);
	
	var zip = zip_new();
		var f = "";
	
		var manifest = [];
		var rdf = [];
	
		/* Part 3 Section 3.3 MIME Media Type */
		f = "mimetype";
		zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
	
		/* Part 1 Section 2.2 Documents */
		f = "content.xml";
		zip_add_file(zip, f, write_content_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "ContentFile"]);
	
		/* TODO: these are hard-coded styles to satiate excel */
		f = "styles.xml";
		zip_add_file(zip, f, write_styles_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "StylesFile"]);
	
		/* TODO: this is hard-coded to satiate excel */
		f = "meta.xml";
		zip_add_file(zip, f, write_meta_ods());
		manifest.push([f, "text/xml"]);
		rdf.push([f, "MetadataFile"]);
	
		/* Part 3 Section 6 Metadata Manifest File */
		f = "manifest.rdf";
		zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
		manifest.push([f, "application/rdf+xml"]);
	
		/* Part 3 Section 4 Manifest File */
		f = "META-INF/manifest.xml";
		zip_add_file(zip, f, write_manifest(manifest/*, opts*/));
	
		return zip;
	}
	
	function write_sheet_index(wb, sheet) {
		if(!sheet) return 0;
		var idx = wb.SheetNames.indexOf(sheet);
		if(idx == -1) throw new Error("Sheet not found: " + sheet);
		return idx;
	}
	
	function write_obj_str(factory) {
		return function write_str(wb, o) {
			var idx = write_sheet_index(wb, o.sheet);
			return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb);
		};
	}
	
	var write_htm_str = write_obj_str(HTML_);
	var write_csv_str = write_obj_str({from_sheet:sheet_to_csv});
	var write_slk_str = write_obj_str(typeof SYLK !== "undefined" ? SYLK : {});
	var write_dif_str = write_obj_str(typeof DIF !== "undefined" ? DIF : {});
	var write_prn_str = write_obj_str(typeof PRN !== "undefined" ? PRN : {});
	var write_rtf_str = write_obj_str(typeof RTF !== "undefined" ? RTF : {});
	var write_txt_str = write_obj_str({from_sheet:sheet_to_txt});
	var write_dbf_buf = write_obj_str(typeof DBF !== "undefined" ? DBF : {});
	var write_eth_str = write_obj_str(typeof ETH !== "undefined" ? ETH : {});
	
	function fix_opts_func(defaults) {
		return function fix_opts(opts) {
			for(var i = 0; i != defaults.length; ++i) {
				var d = defaults[i];
				if(opts[d[0]] === undefined) opts[d[0]] = d[1];
				if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
			}
		};
	}
	
	var fix_read_opts = fix_opts_func([
		['cellNF', false], /* emit cell number format string as .z */
		['cellHTML', true], /* emit html string as .h */
		['cellFormula', true], /* emit formulae as .f */
		['cellStyles', false], /* emits style/theme as .s */
		['cellText', true], /* emit formatted text as .w */
		['cellDates', false], /* emit date cells with type `d` */
	
		['sheetStubs', false], /* emit empty cells */
		['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */
	
		['bookDeps', false], /* parse calculation chains */
		['bookSheets', false], /* only try to get sheet names (no Sheets) */
		['bookProps', false], /* only try to get properties (no Sheets) */
		['bookFiles', false], /* include raw file structure (keys, files, cfb) */
		['bookVBA', false], /* include vba raw data (vbaraw) */
	
		['password',''], /* password */
		['WTF', false] /* WTF mode (throws errors) */
	]);
	
	
	var fix_write_opts = fix_opts_func([
		['cellDates', false], /* write date cells with type `d` */
	
		['bookSST', false], /* Generate Shared String Table */
	
		['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */
	
		['compression', false], /* Use file compression */
	
		['WTF', false] /* WTF mode (throws errors) */
	]);
	function get_sheet_type(n) {
		if(RELS.WS.indexOf(n) > -1) return "sheet";
		if(RELS.CS && n == RELS.CS) return "chart";
		if(RELS.DS && n == RELS.DS) return "dialog";
		if(RELS.MS && n == RELS.MS) return "macro";
		return (n && n.length) ? n : "sheet";
	}
	function safe_parse_wbrels(wbrels, sheets) {
		if(!wbrels) return 0;
		try {
			wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
		} catch(e) { return null; }
		return !wbrels || wbrels.length === 0 ? null : wbrels;
	}
	
	function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
		try {
			sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
			var data = getzipdata(zip, path);
			var _ws;
			switch(stype) {
				case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
					if(!_ws || !_ws['!drawel']) break;
					var dfile = resolve_path(_ws['!drawel'].Target, path);
					var drelsp = get_rels_path(dfile);
					var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
					var chartp = resolve_path(draw, dfile);
					var crelsp = get_rels_path(chartp);
					_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
					break;
				case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				default: throw new Error("Unrecognized sheet type " + stype);
			}
			sheets[sheet] = _ws;
	
			/* scan rels for comments */
			var comments = [];
			if(sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
				if(sheetRels[sheet][n].Type == RELS.CMNT) {
					var dfile = resolve_path(sheetRels[sheet][n].Target, path);
					comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
					if(!comments || !comments.length) return;
					sheet_insert_comments(_ws, comments);
				}
			});
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }
	
	function parse_zip(zip, opts) {
		make_ssf(SSF);
		opts = opts || {};
		fix_read_opts(opts);
	
		/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
		/* UOC */
		if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
		/* Numbers */
		if(safegetzipfile(zip, 'Index/Document.iwa')) throw new Error('Unsupported NUMBERS file');
	
		var entries = zipentries(zip);
		var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
		var xlsb = false;
		var sheets, binname;
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.xml";
			if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
		}
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.bin";
			if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
			dir.workbooks.push(binname);
			xlsb = true;
		}
		if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;
	
		var themes = ({});
		var styles = ({});
		if(!opts.bookSheets && !opts.bookProps) {
			strs = [];
			if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }
	
			if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);
	
			if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
		}
	
		/*var externbooks = */dir.links.map(function(link) {
			try {
				var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
				return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
			} catch(e) {}
		});
	
		var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
	
		var props = {}, propdata = "";
	
		if(dir.coreprops.length) {
			propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
			if(propdata) props = parse_core_props(propdata);
			if(dir.extprops.length !== 0) {
				propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
				if(propdata) parse_ext_props(propdata, props, opts);
			}
		}
	
		var custprops = {};
		if(!opts.bookSheets || opts.bookProps) {
			if (dir.custprops.length !== 0) {
				propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
				if(propdata) custprops = parse_cust_props(propdata, opts);
			}
		}
	
		var out = ({});
		if(opts.bookSheets || opts.bookProps) {
			if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
			else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
			if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
			if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
			if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
		}
		sheets = {};
	
		var deps = {};
		if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);
	
		var i=0;
		var sheetRels = ({});
		var path, relsPath;
	
		{
			var wbsheets = wb.Sheets;
			props.Worksheets = wbsheets.length;
			props.SheetNames = [];
			for(var j = 0; j != wbsheets.length; ++j) {
				props.SheetNames[j] = wbsheets[j].name;
			}
		}
	
		var wbext = xlsb ? "bin" : "xml";
		var wbrelsi = dir.workbooks[0].lastIndexOf("/");
		var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
		if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
		var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile);
		if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
	
		/* Numbers iOS hack */
		var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
		wsloop: for(i = 0; i != props.Worksheets; ++i) {
			var stype = "sheet";
			if(wbrels && wbrels[i]) {
				path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
				if(!safegetzipfile(zip, path)) path = wbrels[i][1];
				if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
				stype = wbrels[i][2];
			} else {
				path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
				path = path.replace(/sheet0\./,"sheet.");
			}
			relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
			if(opts && opts.sheets != null) switch(typeof opts.sheets) {
				case "number": if(i != opts.sheets) continue wsloop; break;
				case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
				default: if(Array.isArray && Array.isArray(opts.sheets)) {
					var snjseen = false;
					for(var snj = 0; snj != opts.sheets.length; ++snj) {
						if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
						if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
					}
					if(!snjseen) continue wsloop;
				}
			}
			safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
		}
	
		out = ({
			Directory: dir,
			Workbook: wb,
			Props: props,
			Custprops: custprops,
			Deps: deps,
			Sheets: sheets,
			SheetNames: props.SheetNames,
			Strings: strs,
			Styles: styles,
			Themes: themes,
			SSF: SSF.get_table()
		});
		if(opts && opts.bookFiles) {
			out.keys = entries;
			out.files = zip.files;
		}
		if(opts && opts.bookVBA) {
			if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
			else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
		}
		return out;
	}
	
	/* [MS-OFFCRYPTO] 2.1.1 */
	function parse_xlsxcfb(cfb, _opts) {
		var opts = _opts || {};
		var f = 'Workbook', data = CFB.find(cfb, f);
		try {
		f = '/!DataSpaces/Version';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var version = */parse_DataSpaceVersionInfo(data.content);
	
		/* 2.3.4.1 */
		f = '/!DataSpaces/DataSpaceMap';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var dsm = parse_DataSpaceMap(data.content);
		if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.2 */
		f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var seds = parse_DataSpaceDefinition(data.content);
		if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.3 */
		f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var hdr = */parse_Primary(data.content);
		} catch(e) {}
	
		f = '/EncryptionInfo';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var einfo = parse_EncryptionInfo(data.content);
	
		/* 2.3.4.4 */
		f = '/EncryptedPackage';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	
	/*global decrypt_agile */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
	/*global decrypt_std76 */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
		throw new Error("File is password-protected");
	}
	
	function write_zip(wb, opts) {
		_shapeid = 1024;
		if(opts.bookType == "ods") return write_ods(wb, opts);
		if(wb && !wb.SSF) {
			wb.SSF = SSF.get_table();
		}
		if(wb && wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
	var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws(rId-1, f, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				if(comments && comments.length > 0) {
					var cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb(wb, f, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty(wb, f, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	function firstbyte(f,o) {
		var x = "";
		switch((o||{}).type || "base64") {
			case 'buffer': return [f[0], f[1], f[2], f[3]];
			case 'base64': x = Base64.decode(f.slice(0,24)); break;
			case 'binary': x = f; break;
			case 'array':  return [f[0], f[1], f[2], f[3]];
			default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
		}
		return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3)];
	}
	
	function read_cfb(cfb, opts) {
		if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
		return parse_xlscfb(cfb, opts);
	}
	
	function read_zip(data, opts) {
	var zip, d = data;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		zip = zip_read(d, o);
		return parse_zip(zip, o);
	}
	
	function read_plaintext(data, o) {
		var i = 0;
		main: while(i < data.length) switch(data.charCodeAt(i)) {
			case 0x0A: case 0x0D: case 0x20: ++i; break;
			case 0x3C: return parse_xlml(data.slice(i),o);
			default: break main;
		}
		return PRN.to_workbook(data, o);
	}
	
	function read_plaintext_raw(data, o) {
		var str = "", bytes = firstbyte(data, o);
		switch(o.type) {
			case 'base64': str = Base64.decode(data); break;
			case 'binary': str = data; break;
			case 'buffer': str = data.toString('binary'); break;
			case 'array': str = cc2str(data); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
		return read_plaintext(str, o);
	}
	
	function read_utf16(data, o) {
		var d = data;
		if(o.type == 'base64') d = Base64.decode(d);
		d = cptable.utils.decode(1200, d.slice(2), 'str');
		o.type = "binary";
		return read_plaintext(d, o);
	}
	
	function bstrify(data) {
		return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
	}
	
	function read_prn(data, d, o, str) {
		if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
		return PRN.to_workbook(d, o);
	}
	
	function readSync(data, opts) {
		reset_cp();
		if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), opts);
		var d = data, n = [0,0,0,0], str = false;
		var o = opts||{};
		if(o.cellStyles) { o.cellNF = true; }
		_ssfopts = {};
		if(o.dateNF) _ssfopts.dateNF = o.dateNF;
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); }
		if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
		if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
			// $FlowIgnore
			var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
			// $FlowIgnore
			if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
		}
		switch((n = firstbyte(d, o))[0]) {
			case 0xD0: return read_cfb(CFB.read(d, o), o);
			case 0x09: if(n[1] <= 0x04) return parse_xlscfb(d, o); break;
			case 0x3C: return parse_xlml(d, o);
			case 0x49: if(n[1] === 0x44) return read_wb_ID(d, o); break;
			case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
			case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
			case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
			case 0xFF: if(n[1] === 0xFE) { return read_utf16(d, o); } break;
			case 0x00: if(n[1] === 0x00 && n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o); break;
			case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
			case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
			case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
		}
		if(n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
		return read_prn(data, d, o, str);
	}
	
	function readFileSync(filename, opts) {
		var o = opts||{}; o.type = 'file';
		return readSync(filename, o);
	}
	function write_cfb_ctr(cfb, o) {
		switch(o.type) {
			case "base64": case "binary": break;
			case "buffer": case "array": o.type = ""; break;
			case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			default: throw new Error("Unrecognized type " + o.type);
		}
		return CFB.write(cfb, o);
	}
	
	/*global encrypt_agile */
	function write_zip_type(wb, opts) {
		var o = opts||{};
		var z = write_zip(wb, o);
		var oopts = {};
		if(o.compression) oopts.compression = 'DEFLATE';
		if(o.password) oopts.type = has_buf ? "nodebuffer" : "string";
		else switch(o.type) {
			case "base64": oopts.type = "base64"; break;
			case "binary": oopts.type = "string"; break;
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			case "buffer":
			case "file": oopts.type = has_buf ? "nodebuffer" : "string"; break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: {"nodebuffer": "buffer", "string": "binary"}[oopts.type] || oopts.type}) : z.generate(oopts);
		if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o);
		if(o.type === "file") return write_dl(o.file, out);
		return o.type == "string" ? utf8read(out) : out;
	}
	
	function write_cfb_type(wb, opts) {
		var o = opts||{};
		var cfb = write_xlscfb(wb, o);
		return write_cfb_ctr(cfb, o);
	}
	
	function write_string_type(out, opts, bom) {
		if(!bom) bom = "";
		var o = bom + out;
		switch(opts.type) {
			case "base64": return Base64.encode(utf8write(o));
			case "binary": return utf8write(o);
			case "string": return out;
			case "file": return write_dl(opts.file, o, 'utf8');
			case "buffer": {
				if(has_buf) return Buffer_from(o, 'utf8');
				else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	function write_stxt_type(out, opts) {
		switch(opts.type) {
			case "base64": return Base64.encode(out);
			case "binary": return out;
			case "string": return out; /* override in sheet_to_txt */
			case "file": return write_dl(opts.file, out, 'binary');
			case "buffer": {
				if(has_buf) return Buffer_from(out, 'binary');
				else return out.split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	/* TODO: test consistency */
	function write_binary_type(out, opts) {
		switch(opts.type) {
			case "string":
			case "base64":
			case "binary":
				var bstr = "";
				// $FlowIgnore
				for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
				return opts.type == 'base64' ? Base64.encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
			case "file": return write_dl(opts.file, out);
			case "buffer": return out;
			default: throw new Error("Unrecognized type " + opts.type);
		}
	}
	
	function writeSync(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = opts||{};
		if(o.cellStyles) { o.cellNF = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
		switch(o.bookType || 'xlsb') {
			case 'xml':
			case 'xlml': return write_string_type(write_xlml(wb, o), o);
			case 'slk':
			case 'sylk': return write_string_type(write_slk_str(wb, o), o);
			case 'htm':
			case 'html': return write_string_type(write_htm_str(wb, o), o);
			case 'txt': return write_stxt_type(write_txt_str(wb, o), o);
			case 'csv': return write_string_type(write_csv_str(wb, o), o, "\ufeff");
			case 'dif': return write_string_type(write_dif_str(wb, o), o);
			case 'dbf': return write_binary_type(write_dbf_buf(wb, o), o);
			case 'prn': return write_string_type(write_prn_str(wb, o), o);
			case 'rtf': return write_string_type(write_rtf_str(wb, o), o);
			case 'eth': return write_string_type(write_eth_str(wb, o), o);
			case 'fods': return write_string_type(write_ods(wb, o), o);
			case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
			case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
			case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
			case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
			case 'biff8':
			case 'xla':
			case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
			case 'xlsx':
			case 'xlsm':
			case 'xlam':
			case 'xlsb':
			case 'ods': return write_zip_type(wb, o);
			default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
		}
	}
	
	function resolve_book_type(o) {
		if(o.bookType) return;
		var _BT = {
			"xls": "biff8",
			"htm": "html",
			"slk": "sylk",
			"socialcalc": "eth",
			"Sh33tJS": "WTF"
		};
		var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
		if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
		o.bookType = _BT[o.bookType] || o.bookType;
	}
	
	function writeFileSync(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSync(wb, o);
	}
	
	function writeFileAsync(filename, wb, opts, cb) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		o.type = 'buffer';
		var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
		return _fs.writeFile(filename, writeSync(wb, o), _cb);
	}
	function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
		var rr = encode_row(R);
		var defval = o.defval, raw = o.raw || !o.hasOwnProperty("raw");
		var isempty = true;
		var row = (header === 1) ? [] : {};
		if(header !== 1) {
			if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
			else row.__rowNum__ = R;
		}
		if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
			var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			if(val === undefined || val.t === undefined) {
				if(defval === undefined) continue;
				if(hdr[C] != null) { row[hdr[C]] = defval; }
				continue;
			}
			var v = val.v;
			switch(val.t){
				case 'z': if(v == null) break; continue;
				case 'e': v = void 0; break;
				case 's': case 'd': case 'b': case 'n': break;
				default: throw new Error('unrecognized type ' + val.t);
			}
			if(hdr[C] != null) {
				if(v == null) {
					if(defval !== undefined) row[hdr[C]] = defval;
					else if(raw && v === null) row[hdr[C]] = null;
					else continue;
				} else {
					row[hdr[C]] = raw ? v : format_cell(val,v,o);
				}
				if(v != null) isempty = false;
			}
		}
		return { row: row, isempty: isempty };
	}
	
	
	function sheet_to_json(sheet, opts) {
		if(sheet == null || sheet["!ref"] == null) return [];
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		else if(o.header == null) header = 0;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var out = [];
		var outi = 0, counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0, CC = 0;
		if(dense && !sheet[R]) sheet[R] = [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = 0;
					for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
					hdr[C] = vv;
			}
		}
		for (R = r.s.r + offset; R <= r.e.r; ++R) {
			var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
			if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
		}
		out.length = outi;
		return out;
	}
	
	var qreg = /"/g;
	function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
		var isempty = true;
		var row = [], txt = "", rr = encode_row(R);
		for(var C = r.s.c; C <= r.e.c; ++C) {
			if (!cols[C]) continue;
			var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
			if(val == null) txt = "";
			else if(val.v != null) {
				isempty = false;
				txt = ''+format_cell(val, null, o);
				for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
				if(txt == "ID") txt = '"ID"';
			} else if(val.f != null && !val.F) {
				isempty = false;
				txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
			} else txt = "";
			/* NOTE: Excel CSV does not support array formulae */
			row.push(txt);
		}
		if(o.blankrows === false && isempty) return null;
		return row.join(FS);
	}
	
	function sheet_to_csv(sheet, opts) {
		var out = [];
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
			if(row == null) { continue; }
			if(o.strip) row = row.replace(endregex,"");
			out.push(row + RS);
		}
		delete o.dense;
		return out.join("");
	}
	
	function sheet_to_txt(sheet, opts) {
		if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
		var s = sheet_to_csv(sheet, opts);
		if(typeof cptable == 'undefined' || opts.type == 'string') return s;
		var o = cptable.utils.encode(1200, s, 'str');
		return String.fromCharCode(255) + String.fromCharCode(254) + o;
	}
	
	function sheet_to_formulae(sheet) {
		var y = "", x, val="";
		if(sheet == null || sheet["!ref"] == null) return [];
		var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
		var cmds = [];
		var dense = Array.isArray(sheet);
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				y = cols[C] + rr;
				x = dense ? (sheet[R]||[])[C] : sheet[y];
				val = "";
				if(x === undefined) continue;
				else if(x.F != null) {
					y = x.F;
					if(!x.f) continue;
					val = x.f;
					if(y.indexOf(":") == -1) y = y + ":" + y;
				}
				if(x.f != null) val = x.f;
				else if(x.t == 'z') continue;
				else if(x.t == 'n' && x.v != null) val = "" + x.v;
				else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
				else if(x.w !== undefined) val = "'" + x.w;
				else if(x.v === undefined) continue;
				else if(x.t == 's') val = "'" + x.v;
				else val = ""+x.v;
				cmds[cmds.length] = y + "=" + val;
			}
		}
		return cmds;
	}
	
	function sheet_add_json(_ws, js, opts) {
		var o = opts || {};
		var offset = +!o.skipHeader;
		var ws = _ws || ({});
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var cell;
		var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) { _R = range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
		}
		var hdr = o.header || [], C = 0;
	
		js.forEach(function (JS, R) {
			keys(JS).forEach(function(k) {
				if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
				var v = JS[k];
				var t = 'z';
				var z = "";
				var ref = encode_cell({c:_C + C,r:_R + R + offset});
				cell = utils.sheet_get_cell(ws, ref);
				if(v && typeof v === 'object' && !(v instanceof Date)){
					ws[ref] = v;
				} else {
					if(typeof v == 'number') t = 'n';
					else if(typeof v == 'boolean') t = 'b';
					else if(typeof v == 'string') t = 's';
					else if(v instanceof Date) {
						t = 'd';
						if(!o.cellDates) { t = 'n'; v = datenum(v); }
						z = (o.dateNF || SSF._table[14]);
					}
					if(!cell) ws[ref] = cell = ({t:t, v:v});
					else {
						cell.t = t; cell.v = v;
						delete cell.w; delete cell.R;
						if(z) cell.z = z;
					}
					if(z) cell.z = z;
				}
			});
		});
		range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
		var __R = encode_row(_R);
		if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }
	
	var utils = {
		encode_col: encode_col,
		encode_row: encode_row,
		encode_cell: encode_cell,
		encode_range: encode_range,
		decode_col: decode_col,
		decode_row: decode_row,
		split_cell: split_cell,
		decode_cell: decode_cell,
		decode_range: decode_range,
		format_cell: format_cell,
		get_formulae: sheet_to_formulae,
		make_csv: sheet_to_csv,
		make_json: sheet_to_json,
		make_formulae: sheet_to_formulae,
		sheet_add_aoa: sheet_add_aoa,
		sheet_add_json: sheet_add_json,
		aoa_to_sheet: aoa_to_sheet,
		json_to_sheet: json_to_sheet,
		table_to_sheet: parse_dom_table,
		table_to_book: table_to_book,
		sheet_to_csv: sheet_to_csv,
		sheet_to_txt: sheet_to_txt,
		sheet_to_json: sheet_to_json,
		sheet_to_html: HTML_.from_sheet,
		sheet_to_formulae: sheet_to_formulae,
		sheet_to_row_object_array: sheet_to_json
	};
	
	(function(utils) {
	utils.consts = utils.consts || {};
	function add_consts(R/*Array<any>*/) { R.forEach(function(a){ utils.consts[a[0]] = a[1]; }); }
	
	function get_default(x, y, z) { return x[y] != null ? x[y] : (x[y] = z); }
	
	/* get cell, creating a stub if necessary */
	function ws_get_cell_stub(ws, R, C) {
		/* A1 cell address */
		if(typeof R == "string") {
			/* dense */
			if(Array.isArray(ws)) {
				var RC = decode_cell(R);
				if(!ws[RC.r]) ws[RC.r] = [];
				return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
			}
			return ws[R] || (ws[R] = {t:'z'});
		}
		/* cell address object */
		if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
		/* R and C are 0-based indices */
		return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
	}
	utils.sheet_get_cell = ws_get_cell_stub;
	
	/* find sheet index for given name / validate index */
	function wb_sheet_idx(wb, sh) {
		if(typeof sh == "number") {
			if(sh >= 0 && wb.SheetNames.length > sh) return sh;
			throw new Error("Cannot find sheet # " + sh);
		} else if(typeof sh == "string") {
			var idx = wb.SheetNames.indexOf(sh);
			if(idx > -1) return idx;
			throw new Error("Cannot find sheet name |" + sh + "|");
		} else throw new Error("Cannot find sheet |" + sh + "|");
	}
	
	/* simple blank workbook object */
	utils.book_new = function() {
		return { SheetNames: [], Sheets: {} };
	};
	
	/* add a worksheet to the end of a given workbook */
	utils.book_append_sheet = function(wb, ws, name) {
		if(!name) for(var i = 1; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
		if(!name) throw new Error("Too many worksheets");
		check_ws_name(name);
		if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
	
		wb.SheetNames.push(name);
		wb.Sheets[name] = ws;
	};
	
	/* set sheet visibility (visible/hidden/very hidden) */
	utils.book_set_sheet_visibility = function(wb, sh, vis) {
		get_default(wb,"Workbook",{});
		get_default(wb.Workbook,"Sheets",[]);
	
		var idx = wb_sheet_idx(wb, sh);
		// $FlowIgnore
		get_default(wb.Workbook.Sheets,idx, {});
	
		switch(vis) {
			case 0: case 1: case 2: break;
			default: throw new Error("Bad sheet visibility setting " + vis);
		}
		// $FlowIgnore
		wb.Workbook.Sheets[idx].Hidden = vis;
	};
	add_consts([
		["SHEET_VISIBLE", 0],
		["SHEET_HIDDEN", 1],
		["SHEET_VERY_HIDDEN", 2]
	]);
	
	/* set number format */
	utils.cell_set_number_format = function(cell, fmt) {
		cell.z = fmt;
		return cell;
	};
	
	/* set cell hyperlink */
	utils.cell_set_hyperlink = function(cell, target, tooltip) {
		if(!target) {
			delete cell.l;
		} else {
			cell.l = ({ Target: target });
			if(tooltip) cell.l.Tooltip = tooltip;
		}
		return cell;
	};
	utils.cell_set_internal_link = function(cell, range, tooltip) { return utils.cell_set_hyperlink(cell, "#" + range, tooltip); };
	
	/* add to cell comments */
	utils.cell_add_comment = function(cell, text, author) {
		if(!cell.c) cell.c = [];
		cell.c.push({t:text, a:author||"SheetJS"});
	};
	
	/* set array formula and flush related cells */
	utils.sheet_set_array_formula = function(ws, range, formula) {
		var rng = typeof range != "string" ? range : safe_decode_range(range);
		var rngstr = typeof range == "string" ? range : encode_range(range);
		for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
			var cell = ws_get_cell_stub(ws, R, C);
			cell.t = 'n';
			cell.F = rngstr;
			delete cell.v;
			if(R == rng.s.r && C == rng.s.c) cell.f = formula;
		}
		return ws;
	};
	
	return utils;
	})(utils);
	
	if(has_buf && "function" != 'undefined') (function() {
		var Readable = __webpack_require__(242).Readable;
	
		var write_csv_stream = function(sheet, opts) {
			var stream = Readable();
			var o = opts == null ? {} : opts;
			if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
			var r = safe_decode_range(sheet["!ref"]);
			var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
			var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
			var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
			var row = "", cols = [];
			o.dense = Array.isArray(sheet);
			var colinfo = o.skipHidden && sheet["!cols"] || [];
			var rowinfo = o.skipHidden && sheet["!rows"] || [];
			for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
			var R = r.s.r;
			var BOM = false;
			stream._read = function() {
				if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
				while(R <= r.e.r) {
					++R;
					if ((rowinfo[R-1]||{}).hidden) continue;
					row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
					if(row != null) {
						if(o.strip) row = row.replace(endregex,"");
						stream.push(row + RS);
						break;
					}
				}
				if(R > r.e.r) return stream.push(null);
			};
			return stream;
		};
	
		var write_html_stream = function(ws, opts) {
			var stream = Readable();
	
			var o = opts || {};
			var header = o.header != null ? o.header : HTML_.BEGIN;
			var footer = o.footer != null ? o.footer : HTML_.END;
			stream.push(header);
			var r = decode_range(ws['!ref']);
			o.dense = Array.isArray(ws);
			stream.push(HTML_._preamble(ws, r, o));
			var R = r.s.r;
			var end = false;
			stream._read = function() {
				if(R > r.e.r) {
					if(!end) { end = true; stream.push("</table>" + footer); }
					return stream.push(null);
				}
				while(R <= r.e.r) {
					stream.push(HTML_._row(ws, r, R, o));
					++R;
					break;
				}
			};
			return stream;
		};
	
		var write_json_stream = function(sheet, opts) {
			var stream = Readable({objectMode:true});
	
			if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
			var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
			var r = {s:{r:0,c:0},e:{r:0,c:0}};
			var o = opts || {};
			var range = o.range != null ? o.range : sheet["!ref"];
			if(o.header === 1) header = 1;
			else if(o.header === "A") header = 2;
			else if(Array.isArray(o.header)) header = 3;
			switch(typeof range) {
				case 'string': r = safe_decode_range(range); break;
				case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
				default: r = range;
			}
			if(header > 0) offset = 0;
			var rr = encode_row(r.s.r);
			var cols = [];
			var counter = 0;
			var dense = Array.isArray(sheet);
			var R = r.s.r, C = 0, CC = 0;
			if(dense && !sheet[R]) sheet[R] = [];
			for(C = r.s.c; C <= r.e.c; ++C) {
				cols[C] = encode_col(C);
				val = dense ? sheet[R][C] : sheet[cols[C] + rr];
				switch(header) {
					case 1: hdr[C] = C - r.s.c; break;
					case 2: hdr[C] = cols[C]; break;
					case 3: hdr[C] = o.header[C - r.s.c]; break;
					default:
						if(val == null) val = {w: "__EMPTY", t: "s"};
						vv = v = format_cell(val, null, o);
						counter = 0;
						for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
						hdr[C] = vv;
				}
			}
			R = r.s.r + offset;
			stream._read = function() {
				if(R > r.e.r) return stream.push(null);
				while(R <= r.e.r) {
					//if ((rowinfo[R-1]||{}).hidden) continue;
					var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
					++R;
					if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
						stream.push(row.row);
						break;
					}
				}
			};
			return stream;
		};
	
		XLSX.stream = {
			to_json: write_json_stream,
			to_html: write_html_stream,
			to_csv: write_csv_stream
		};
	})();
	
	if(typeof parse_xlscfb !== "undefined") XLSX.parse_xlscfb = parse_xlscfb;
	XLSX.parse_zip = parse_zip;
	XLSX.read = readSync; //xlsread
	XLSX.readFile = readFileSync; //readFile
	XLSX.readFileSync = readFileSync;
	XLSX.write = writeSync;
	XLSX.writeFile = writeFileSync;
	XLSX.writeFileSync = writeFileSync;
	XLSX.writeFileAsync = writeFileAsync;
	XLSX.utils = utils;
	XLSX.SSF = SSF;
	if(typeof CFB !== "undefined") XLSX.CFB = CFB;
	}
	/*global define */
	if(true) make_xlsx_lib(exports);
	else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
	else if(typeof define === 'function' && define.amd) define('xlsx', function() { if(!XLSX.version) make_xlsx_lib(XLSX); return XLSX; });
	else make_xlsx_lib(XLSX);
	/*exported XLS, ODS */
	var XLS = XLSX, ODS = XLSX;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(232).Buffer, __webpack_require__(236)))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(233)
	var ieee754 = __webpack_require__(234)
	var isArray = __webpack_require__(235)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W100 */
	var cptable = {version:"1.14.0"};
	cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[932] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	return {"enc": e, "dec": d }; })();
	cptable[936] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
	return {"enc": e, "dec": d }; })();
	cptable[949] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	return {"enc": e, "dec": d }; })();
	cptable[950] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	return {"enc": e, "dec": d }; })();
	cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	return {"enc": e, "dec": d }; })();
	cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	// eslint-disable-next-line no-undef
	if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
	/* cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ft=javascript: */
	/*jshint newcap: false */
	(function(root, factory) {
	  /*jshint ignore:start */
	  /*eslint-disable */
	  "use strict";
	  if(typeof cptable === "undefined") {
	    if(true){
	      var cpt = cptable;
	      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
	      else root.cptable = factory(cpt);
	    } else throw new Error("cptable not found");
	  } else cptable = factory(cptable);
	  /*eslint-enable */
	  /*jshint ignore:end */
	}(this, function(cpt){
	  "use strict";
	  /*global module, Buffer */
	  var magic = {
	    "1200":"utf16le",
	    "1201":"utf16be",
	    "12000":"utf32le",
	    "12001":"utf32be",
	    "16969":"utf64le",
	    "20127":"ascii",
	    "65000":"utf7",
	    "65001":"utf8"
	  };
	
	  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
	  var dbcs_cache = [932,936,949,950];
	  var magic_cache = [65001];
	  var magic_decode = {};
	  var magic_encode = {};
	  var cpdcache = {};
	  var cpecache = {};
	
	  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
	  var cca = function cca(x) { return x.charCodeAt(0); };
	
	  var has_buf = (typeof Buffer !== 'undefined');
	  var Buffer_from = function(){};
	  if(has_buf) {
	    var nbfs = !Buffer.from;
	    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	    // $FlowIgnore
	    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
	
	    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
	    var make_EE = function make_EE(E){
	      var EE = Buffer.allocUnsafe(65536);
	      for(var i = 0; i < 65536;++i) EE[i] = 0;
	      var keys = Object.keys(E), len = keys.length;
	      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
	        if(!(e = keys[ee])) continue;
	        EE[e.charCodeAt(0)] = E[e];
	      }
	      return EE;
	    };
	    var sbcs_encode = function make_sbcs_encode(cp) {
	      var EE = make_EE(cpt[cp].enc);
	      return function sbcs_e(data, ofmt) {
	        var len = data.length;
	        var out, i=0, j=0, D=0, w=0;
	        if(typeof data === 'string') {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
	        } else if(Buffer.isBuffer(data)) {
	          out = Buffer.allocUnsafe(2*len);
	          j = 0;
	          for(i = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) out[j++] = EE[D];
	            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
	            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
	            else {
	              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
	              if(w < 65536) out[j++] = EE[w];
	              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
	            }
	          }
	          out = out.slice(0,j);
	        } else {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var sbcs_decode = function make_sbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c="";
	      for(d=0;d<D.length;++d) {
	        if(!(c=D[d])) continue;
	        var w = c.charCodeAt(0);
	        DD[2*d] = w&255; DD[2*d+1] = w>>8;
	      }
	      return function sbcs_d(data) {
	        var len = data.length, i=0, j=0;
	        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        }
	        return mdb.slice(0, 2 * len).toString('ucs2');
	      };
	    };
	    var dbcs_encode = function make_dbcs_encode(cp) {
	      var E = cpt[cp].enc;
	      var EE = Buffer.allocUnsafe(131072);
	      for(var i = 0; i < 131072; ++i) EE[i] = 0;
	      var keys = Object.keys(E);
	      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
	        if(!(e = keys[ee])) continue;
	        var f = e.charCodeAt(0);
	        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
	      }
	      return function dbcs_e(data, ofmt) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
	        if(typeof data === 'string') {
	          for(i = k = 0; i < len; ++i) {
	            j = data.charCodeAt(i)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	          out = out.slice(0,k);
	        } else if(Buffer.isBuffer(data)) {
	          for(i = k = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) j = D;
	            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
	            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
	            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
	            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
	            else { jj = j-65536;
	              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	            }
	          }
	          out = out.slice(0,k);
	        } else {
	          for(i = k = 0; i < len; i++) {
	            j = data[i].charCodeAt(0)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var dbcs_decode = function make_dbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
	      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
	      for(d = 0; d < D.length; ++d) {
	        if(!(c=D[d])) continue;
	        w = c.charCodeAt(0);
	        j = 2*d;
	        DD[j] = w&255; DD[j+1] = w>>8;
	      }
	      return function dbcs_d(data) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        }
	        return out.slice(0,k).toString('ucs2');
	      };
	    };
	    magic_decode[65001] = function utf8_d(data) {
	      if(typeof data === "string") return utf8_d(data.split("").map(cca));
	      var len = data.length, w = 0, ww = 0;
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      var i = 0;
	      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
	        j = 1; D = data[i];
	        if(D < 128) w = D;
	        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
	        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
	        else {
	          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
	        }
	      }
	      return mdb.slice(0,k).toString('ucs2');
	    };
	    magic_encode[65001] = function utf8_e(data, ofmt) {
	      if(has_buf && Buffer.isBuffer(data)) {
	        if(!ofmt || ofmt === 'buf') return data;
	        if(ofmt !== 'arr') return data.toString('binary');
	        return [].slice.call(data);
	      }
	      var len = data.length, w = 0, ww = 0, j = 0;
	      var direct = typeof data === "string";
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      for(var i = 0; i < len; ++i) {
	        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
	        if(w <= 0x007F) mdb[j++] = w;
	        else if(w <= 0x07FF) {
	          mdb[j++] = 192 + (w >> 6);
	          mdb[j++] = 128 + (w&63);
	        } else if(w >= 0xD800 && w <= 0xDFFF) {
	          w -= 0xD800; ++i;
	          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
	          mdb[j++] = 240 + ((ww>>>18) & 0x07);
	          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
	          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
	          mdb[j++] = 128 + (ww & 0x3F);
	        } else {
	          mdb[j++] = 224 + (w >> 12);
	          mdb[j++] = 128 + ((w >> 6)&63);
	          mdb[j++] = 128 + (w&63);
	        }
	      }
	      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
	      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
	      return [].slice.call(mdb, 0, j);
	    };
	  }
	
	  var encache = function encache() {
	    if(has_buf) {
	      if(cpdcache[sbcs_cache[0]]) return;
	      var i=0, s=0;
	      for(i = 0; i < sbcs_cache.length; ++i) {
	        s = sbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = sbcs_decode(s);
	          cpecache[s] = sbcs_encode(s);
	        }
	      }
	      for(i = 0; i < dbcs_cache.length; ++i) {
	        s = dbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = dbcs_decode(s);
	          cpecache[s] = dbcs_encode(s);
	        }
	      }
	      for(i = 0; i < magic_cache.length; ++i) {
	        s = magic_cache[i];
	        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
	        if(magic_encode[s]) cpecache[s] = magic_encode[s];
	      }
	    }
	  };
	  var null_enc = function(data, ofmt) { void ofmt; return ""; };
	  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
	  var decache = function decache() {
	    if(has_buf) {
	      if(!cpdcache[sbcs_cache[0]]) return;
	      sbcs_cache.forEach(cp_decache);
	      dbcs_cache.forEach(cp_decache);
	      magic_cache.forEach(cp_decache);
	    }
	    last_enc = null_enc; last_cp = 0;
	  };
	  var cache = {
	    encache: encache,
	    decache: decache,
	    sbcs: sbcs_cache,
	    dbcs: dbcs_cache
	  };
	
	  encache();
	
	  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
	  var last_enc = null_enc, last_cp = 0;
	  var encode = function encode(cp, data, ofmt) {
	    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
	    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
	    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
	    var len = data.length;
	    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
	    var C = cpt[cp], E, M = "";
	    var isstr = typeof data === 'string';
	    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
	      w = E[isstr? data.charAt(i) : data[i]];
	      if(w > 255) {
	        out[j] = w>>8;
	        out[++j] = w&255;
	      } else out[j] = w&255;
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else if(w <= 0x07FF) {
	            out[j]   = 192 + (w >> 6);
	            out[++j] = 128 + (w&63);
	          } else if(w >= 0xD800 && w <= 0xDFFF) {
	            w -= 0xD800;
	            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
	            out[j]   = 240 + ((ww>>>18) & 0x07);
	            out[++j] = 144 + ((ww>>>12) & 0x3F);
	            out[++j] = 128 + ((ww>>>6) & 0x3F);
	            out[++j] = 128 + (ww & 0x3F);
	          } else {
	            out[j]   = 224 + (w >> 12);
	            out[++j] = 128 + ((w >> 6)&63);
	            out[++j] = 128 + (w&63);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else throw new Error("bad ascii " + w);
	        }
	        break;
	      case "utf16le":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w&255;
	          out[j++] = w>>8;
	        }
	        break;
	      case "utf16be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w>>8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32le":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j+3] = w&255; w >>= 8;
	          out[j+2] = w&255; w >>= 8;
	          out[j+1] = w&255; w >>= 8;
	          out[j] = w&255;
	          j+=4;
	        }
	        break;
	      case "utf7":
	        for(i = 0; i < len; i++) {
	          var c = isstr ? data.charAt(i) : data[i].charAt(0);
	          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
	          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
	          var tt = encode(1201, c);
	          out[j++] = 0x2b;
	          out[j++] = BM.charCodeAt(tt[0]>>2);
	          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
	          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
	          out[j++] = 0x2d;
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out = out.slice(0,j);
	    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
	    if(!ofmt || ofmt === 'buf') return out;
	    if(ofmt !== 'arr') return out.toString('binary');
	    return [].slice.call(out);
	  };
	  var decode = function decode(cp, data) {
	    var F; if((F=cpdcache[cp])) return F(data);
	    if(typeof data === "string") return decode(cp, data.split("").map(cca));
	    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
	    var C = cpt[cp], D, M="";
	    if(C && (D=C.dec)) {
	      for(i = 0; i < len; i+=j) {
	        j = 2;
	        s = D[(data[i]<<8)+ data[i+1]];
	        if(!s) {
	          j = 1;
	          s = D[data[i]];
	        }
	        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
	        out[k++] = s;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	        for(; i < len; i+=j) {
	          j = 1;
	          if(data[i] < 128) w = data[i];
	          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
	          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	          if(w < 65536) { out[k++] = String.fromCharCode(w); }
	          else {
	            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
	        k = len; break;
	      case "utf16le":
	        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
	        }
	        break;
	      case "utf16be":
	        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
	        }
	        break;
	      case "utf32le":
	        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf32be":
	        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf7":
	        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
	          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
	          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
	        }
	        for(; i < len; i+=j) {
	          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
	          j=1;
	          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
	          // eslint-disable-next-line no-useless-escape
	          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
	          var dash = 0;
	          if(data[i+j] === 0x2d) { ++j; dash=1; }
	          var tt = [];
	          var o64 = "";
	          var c1=0, c2=0, c3=0;
	          var e1=0, e2=0, e3=0, e4=0;
	          for(var l = 1; l < j - dash;) {
	            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            c1 = e1 << 2 | e2 >> 4;
	            tt.push(c1);
	            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e3 === -1) break;
	            c2 = (e2 & 15) << 4 | e3 >> 2;
	            tt.push(c2);
	            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e4 === -1) break;
	            c3 = (e3 & 3) << 6 | e4;
	            if(e4 < 64) tt.push(c3);
	          }
	          o64 = decode(1201, tt);
	          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    return out.slice(0,k).join("");
	  };
	  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
	  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
	  return cpt;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(232).Buffer))

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*
	
	JSZip - A Javascript class for generating and reading zip files
	<http://stuartk.com/jszip>
	
	(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
	Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.
	
	JSZip uses the library pako released under the MIT license :
	https://github.com/nodeca/pako/blob/master/LICENSE
	
	Note: since JSZip 3 removed critical functionality, this version assigns to the
	`JSZipSync` variable.  Another JSZip version can be loaded in parallel.
	*/
	(function(e){
		if("object"==typeof exports&&"undefined"!=typeof module&&"undefined"==typeof DO_NOT_EXPORT_JSZIP)module.exports=e();
		else if("function"=="function"&&__webpack_require__(240)&&"undefined"==typeof DO_NOT_EXPORT_JSZIP){JSZipSync=e();!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}
		else{
			var f;
			"undefined"!=typeof window?f=window:
			"undefined"!=typeof global?f=global:
			"undefined"!=typeof $ && $.global?f=$.global:
			"undefined"!=typeof self&&(f=self),f.JSZipSync=e()
		}
	}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	
	    }
	
	    return output;
	};
	
	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }
	
	    }
	
	    return output;
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;
	
	},{}],3:[function(_dereq_,module,exports){
	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = _dereq_('./flate');
	
	},{"./flate":8}],4:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];
	
	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;
	
	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }
	
	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:
	
	},{"./utils":21}],5:[function(_dereq_,module,exports){
	'use strict';
	var utils = _dereq_('./utils');
	
	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;
	
	},{"./utils":21}],6:[function(_dereq_,module,exports){
	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.comment = null;
	
	},{}],7:[function(_dereq_,module,exports){
	'use strict';
	var utils = _dereq_('./utils');
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
	
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};
	
	
	},{"./utils":21}],8:[function(_dereq_,module,exports){
	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = _dereq_("pako");
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	exports.compress = function(input) {
	    return pako.deflateRaw(input);
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};
	
	},{"pako":24}],9:[function(_dereq_,module,exports){
	'use strict';
	
	var base64 = _dereq_('./base64');
	
	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");
	
	   base64zip = zip.generate();
	
	**/
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZipSync(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZipSync)) return new JSZipSync(data, options);
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZipSync();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZipSync.prototype = _dereq_('./object');
	JSZipSync.prototype.load = _dereq_('./load');
	JSZipSync.support = _dereq_('./support');
	JSZipSync.defaults = _dereq_('./defaults');
	
	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZipSync.utils = _dereq_('./deprecatedPublicUtils');
	
	JSZipSync.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZipSync.compressions = _dereq_('./compressions');
	module.exports = JSZipSync;
	
	},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(_dereq_,module,exports){
	'use strict';
	var base64 = _dereq_('./base64');
	var ZipEntries = _dereq_('./zipEntries');
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = options || {};
	    if (options.base64) {
	        data = base64.decode(data);
	    }
	
	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileName, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileComment.length ? input.fileComment : null,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }
	
	    return this;
	};
	
	},{"./base64":1,"./zipEntries":22}],11:[function(_dereq_,module,exports){
	(function (Buffer){
	'use strict';
	var Buffer_from = /*::(*/function(){}/*:: :any)*/;
	if(typeof Buffer !== 'undefined') {
		var nbfs = !Buffer.from;
		if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
		Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
		// $FlowIgnore
		if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
	}
	module.exports = function(data, encoding){
	    return typeof data == 'number' ? Buffer.alloc(data) : Buffer_from(data, encoding);
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};
	}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
	},{}],12:[function(_dereq_,module,exports){
	'use strict';
	var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
	
	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;
	
	},{"./uint8ArrayReader":18}],13:[function(_dereq_,module,exports){
	'use strict';
	var support = _dereq_('./support');
	var utils = _dereq_('./utils');
	var crc32 = _dereq_('./crc32');
	var signature = _dereq_('./signature');
	var defaults = _dereq_('./defaults');
	var base64 = _dereq_('./base64');
	var compressions = _dereq_('./compressions');
	var CompressedObject = _dereq_('./compressedObject');
	var nodeBuffer = _dereq_('./nodeBuffer');
	var utf8 = _dereq_('./utf8');
	var StringWriter = _dereq_('./stringWriter');
	var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');
	
	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;
	
	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};
	
	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};
	
	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }
	
	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	
	    this._data = data;
	    this.options = options;
	
	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	var extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();
	
	    return o;
	};
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	    o = prepareFileAttrs(o);
	
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;
	
	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }
	
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }
	
	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    // Check the name ends with a /
	    if (name.slice(-1) != "/") {
	        name += "/"; // IE doesn't like substr(-1)
	    }
	
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression) {
	    var result = new CompressedObject(),
	        content;
	
	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;
	
	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	    }
	
	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;
	
	    return result;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset) {
	    var data = compressedObject.compressedContent,
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;
	
	
	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }
	
	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }
	
	
	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;
	
	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(utfEncodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(utfEncodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(utfEncodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    "\x14\x00" +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(utfEncodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    // internal file attributes TODO
	    "\x00\x00" +
	    // external file attributes
	    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    utfEncodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    utfEncodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};
	
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            type: "base64",
	            comment: null
	        });
	
	        utils.checkSupport(options.type);
	
	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));
	
	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            if (!this.files.hasOwnProperty(name)) {
	                continue;
	            }
	            var file = this.files[name];
	
	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	
	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);
	
	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }
	
	        var dirEnd = "";
	
	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(utfEncodedComment.length, 2) +
	        // .ZIP file comment
	        utfEncodedComment;
	
	
	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }
	
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }
	
	        writer.append(dirEnd);
	
	        var zip = writer.finalize();
	
	
	
	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }
	
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;
	
	},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(_dereq_,module,exports){
	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";
	
	},{}],15:[function(_dereq_,module,exports){
	'use strict';
	var DataReader = _dereq_('./dataReader');
	var utils = _dereq_('./utils');
	
	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig);
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;
	
	},{"./dataReader":5,"./utils":21}],16:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};
	
	module.exports = StringWriter;
	
	},{"./utils":21}],17:[function(_dereq_,module,exports){
	(function (Buffer){
	'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
	},{}],18:[function(_dereq_,module,exports){
	'use strict';
	var DataReader = _dereq_('./dataReader');
	
	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	    }
	}
	Uint8ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	Uint8ArrayReader.prototype.byteAt = function(i) {
	    return this.data[i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;
	
	},{"./dataReader":5}],19:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};
	
	module.exports = Uint8ArrayWriter;
	
	},{"./utils":21}],20:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	var support = _dereq_('./support');
	var nodeBuffer = _dereq_('./nodeBuffer');
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if (((c & 0xfc00) === 0xd800) && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += (c < 0x80) ? 1 : ((c < 0x800) ? 2 : ((c < 0x10000) ? 3 : 4));
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
	            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");
	
	};
	// vim: set shiftwidth=4 softtabstop=4:
	
	},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(_dereq_,module,exports){
	'use strict';
	var support = _dereq_('./support');
	var compressions = _dereq_('./compressions');
	var nodeBuffer = _dereq_('./nodeBuffer');
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: "application/zip"
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob('application/zip');
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }
	
	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};
	
	
	},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(_dereq_,module,exports){
	'use strict';
	var StringReader = _dereq_('./stringReader');
	var NodeBufferReader = _dereq_('./nodeBufferReader');
	var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
	var utils = _dereq_('./utils');
	var sig = _dereq_('./signature');
	var ZipEntry = _dereq_('./zipEntry');
	var support = _dereq_('./support');
	var jszipProto = _dereq_('./object');
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        this.zipComment = this.reader.readString(this.zipCommentLength);
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded.
	        this.zipComment = jszipProto.utf8decode(this.zipComment);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset === -1) {
	            throw new Error("Corrupted zip : can't find end of central directory");
	        }
	        this.reader.setIndex(offset);
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset === -1) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;
	
	},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(_dereq_,module,exports){
	'use strict';
	var StringReader = _dereq_('./stringReader');
	var utils = _dereq_('./utils');
	var CompressedObject = _dereq_('./compressedObject');
	var jszipProto = _dereq_('./object');
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);
	
	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {
	
	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);
	
	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	
	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readString(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }
	
	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
	
	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readString(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        this.fileName = reader.readString(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readString(this.fileCommentLength);
	
	        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
	        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
	    },
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        this.extraFields = this.extraFields || {};
	
	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        if (this.useUTF8()) {
	            this.fileName = jszipProto.utf8decode(this.fileName);
	            this.fileComment = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileName = upath;
	            }
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileComment = ucomment;
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;
	
	},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(_dereq_,module,exports){
	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = _dereq_('./lib/utils/common').assign;
	
	var deflate   = _dereq_('./lib/deflate');
	var inflate   = _dereq_('./lib/inflate');
	var constants = _dereq_('./lib/zlib/constants');
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;
	},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(_dereq_,module,exports){
	'use strict';
	
	
	var zlib_deflate = _dereq_('./zlib/deflate.js');
	var utils = _dereq_('./utils/common');
	var strings = _dereq_('./utils/strings');
	var msg = _dereq_('./zlib/messages');
	var zstream = _dereq_('./zlib/zstream');
	
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overriden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	var Deflate = function(options) {
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new zstream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	};
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|String): input data. Strings will be converted to
	 *   utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
	 * [[Deflate#onEnd]].
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function(data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && _mode === Z_FINISH)) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function(chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that input stream complete
	 * or error happenned. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function(status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate alrorythm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;
	},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(_dereq_,module,exports){
	'use strict';
	
	
	var zlib_inflate = _dereq_('./zlib/inflate.js');
	var utils = _dereq_('./utils/common');
	var strings = _dereq_('./utils/strings');
	var c = _dereq_('./zlib/constants');
	var msg = _dereq_('./zlib/messages');
	var zstream = _dereq_('./zlib/zstream');
	var gzheader = _dereq_('./zlib/gzheader');
	
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overriden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	var Inflate = function(options) {
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new zstream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new gzheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	};
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
	 * [[Inflate#onEnd]].
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function(data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && _mode === c.Z_FINISH)) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	  } while ((strm.avail_in > 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function(chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell inflate that input stream complete
	 * or error happenned. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function(status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 alligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;
	
	},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(_dereq_,module,exports){
	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof(source) !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs+len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for(var i=0; i<len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function(chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i=0, l=chunks.length; i<l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i=0, l=chunks.length; i<l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for(var i=0; i<len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function(chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);
	},{}],28:[function(_dereq_,module,exports){
	// String encode/decode helpers
	'use strict';
	
	
	var utils = _dereq_('./common');
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safary
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [0]); } catch(__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch(__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	      c2 = str.charCodeAt(m_pos+1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	      c2 = str.charCodeAt(m_pos+1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // use fallback for big arrays to avoid stack overflow
	  if (len < 65537) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for(var i=0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function(buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function(str) {
	  var buf = new utils.Buf8(str.length);
	  for(var i=0, len=buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len*2);
	
	  for (out=0, i=0; i<len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function(buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max-1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Fuckup - very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means vuffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	},{"./common":27}],29:[function(_dereq_,module,exports){
	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0
	    , s2 = ((adler >>> 16) & 0xffff) |0
	    , n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;
	},{}],30:[function(_dereq_,module,exports){
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};
	},{}],31:[function(_dereq_,module,exports){
	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for(var n =0; n < 256; n++){
	    c = n;
	    for(var k =0; k < 8; k++){
	      c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable
	    , end = pos + len;
	
	  crc = crc ^ (-1);
	
	  for (var i = pos; i < end; i++ ) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;
	},{}],32:[function(_dereq_,module,exports){
	'use strict';
	
	var utils   = _dereq_('../utils/common');
	var trees   = _dereq_('./trees');
	var adler32 = _dereq_('./adler32');
	var crc32   = _dereq_('./crc32');
	var msg   = _dereq_('./messages');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2*L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only (s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH-1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH-1)) ? s.strstart : MIN_MATCH-1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH-1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size-MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH-1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1- s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length-1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH-1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH-1 ? s.strstart : MIN_MATCH-1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	};
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2*D_CODES+1) * 2);
	  this.bl_tree    = new utils.Buf16((2*BL_CODES+1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS+1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2*L_CODES+1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2*L_CODES+1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  s.d_buf = s.lit_bufsize >> 1;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg){
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	/* =========================================================================
	 * Copy the source state to the destination state
	 */
	//function deflateCopy(dest, source) {
	//
	//}
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/
	},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(_dereq_,module,exports){
	'use strict';
	
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;
	},{}],34:[function(_dereq_,module,exports){
	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  var window;                 /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};
	
	},{}],35:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	var adler32 = _dereq_('./adler32');
	var crc32   = _dereq_('./crc32');
	var inflate_fast = _dereq_('./inffast');
	var inflate_table = _dereq_('./inftrees');
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function ZSWAP32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, {bits: 9});
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, {bits: 5});
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window,src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window,src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window,src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = ZSWAP32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = {bits: state.lenbits};
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = {bits: state.lenbits};
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = {bits: state.distbits};
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) -1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) -1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
	        if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/
	},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	      base = extra = work;    /* dummy value--not used */
	      end = 19;
	  } else if (type === LENS) {
	      base = lbase;
	      base_index -= 257;
	      extra = lext;
	      extra_index -= 257;
	      end = 256;
	  } else {                    /* DISTS */
	      base = dbase;
	      extra = dext;
	      end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i=0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};
	
	},{"../utils/common":27}],37:[function(_dereq_,module,exports){
	'use strict';
	
	module.exports = {
	  '2':    'need dictionary',     /* Z_NEED_DICT       2  */
	  '1':    'stream end',          /* Z_STREAM_END      1  */
	  '0':    '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};
	},{}],38:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2*L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES+2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH-MIN_MATCH+1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	};
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	var TreeDesc = function(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	};
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short (s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c*2]/*.Code*/, tree[c*2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max]*2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max+1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n*2 +1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n*2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n-base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n*2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length-1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits+1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m*2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m*2 + 1]/*.Len*/)*tree[m*2]/*.Freq*/;
	        tree[m*2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS+1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits-1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n*2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n*2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS+1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES-1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1<<extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length-1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0 ; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1<<extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for ( ; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1<<(extra_dbits[code]-7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n*2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n*2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n*2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n*2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES+1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n*2 + 1]/*.Len*/ = 5;
	    static_dtree[n*2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS+1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc =new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n*2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n*2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n*2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK*2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n*2;
	  var _m2 = m*2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j+1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx*2] << 8) | (s.pending_buf[s.d_buf + lx*2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code+LITERALS+1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n*2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node*2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n*2 + 1]/*.Dad*/ = tree[m*2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code+1)*2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n+1)*2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6*2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10*2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138*2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n+1)*2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count-3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count-3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count-11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES-1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex]*2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3*(max_blindex+1) + 5+5+4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes-257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes-1,   5);
	  send_bits(s, blcodes-4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank]*2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes-1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes-1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n*2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK<<1)+(last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES<<1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len+3+7) >>> 3;
	    static_lenb = (s.static_len+3+7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len+4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES<<1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES<<1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code+1, s.d_desc.max_code+1, max_blindex+1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc*2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc]+LITERALS+1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize-1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;
	},{"../utils/common":27}],39:[function(_dereq_,module,exports){
	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;
	},{}]},{},[9])
	(9)
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(232).Buffer, (function() { return this; }())))

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 241 */
238,
/* 242 */
238,
/* 243 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">每日一句</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n\n                    <div class=\"col-sm-2\">\n                        <select name=\"language_type\" class=\"form-control input-sm\"\n                            ng-model=\"$ctrl.filters.language_type\"\n                            ng-options=\"type.value as type.name for type in $ctrl.languageType\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">请选择语言</option>\n                        </select>\n                    </div>\n\n\n\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.language_type\">\n                            语言类型:{{$ctrl.filters.language_type}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.language_type=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n\n                    </div>\n                </div>\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"9\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"2\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.importExcel()\">导入EXCEL</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>id</td>\n                            <td>卷名称</td>\n                            <td>卷ID</td>\n                            <td>章ID</td>\n                            <td>内容</td>\n                            <td>句ID开始</td>\n                            <td>句ID结束</td>\n                            <td>解释</td>\n                            <td>创建时间</td>\n                            <td>语言</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"oneday in $ctrl.onedays track by $index\">\n                            <td>\n                                {{oneday._id}}\n                            </td>\n                            <td>\n                                {{oneday.chapter}}\n                            </td>\n                            <td>\n                                {{oneday.chapter_id}}\n                            </td>\n                            <td>\n                                {{oneday.space}}\n                            </td>\n                            <td>\n                                {{oneday.content}}\n                            </td>\n                            <td>\n                                {{oneday.from}}\n                            </td>\n                            <td>\n                                {{oneday.to}}\n                            </td>\n                            <td>\n                                {{oneday.interpretation}}\n                            </td>\n                            <td>\n                                {{oneday.language_type ? oneday.language_type: 'pt'}}\n                            </td>\n                            <td>\n                                {{oneday.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteOneDay(oneday,$index)\">删除</button>\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"11\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechTypeEnController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechtypeen = __webpack_require__(245);
	
	var _speechtypeen2 = _interopRequireDefault(_speechtypeen);
	
	var _add = __webpack_require__(246);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechTypeEnController = exports.SpeechTypeEnController = function () {
	
	    /*@ngInject*/
	    SpeechTypeEnController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechTypeEnController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechTypeEnController);
	
	        this.awesomeThings = [];
	        this.speechTypes = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechTypeEnController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            console.log('sss');
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/speech_type_en/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechTypes = response.data.data;
	                        _this.socket.syncUpdates('speechTypes', _this.speechTypes);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_type_en/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechTypes = response.data.data;
	                        _this2.socket.syncUpdates('speechTypes', _this2.speechTypes);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechType',
	        value: function addSpeechType() {
	            var speechTypes = this.speechTypes;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/speech_type_en/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechTypes.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechType',
	        value: function editSpeechType(type, index) {
	            var speechTypes = this.speechTypes;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = _angular2.default.copy(type);
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	
	                            $http.put('/api/speech_type_en/' + type.speech_type_id + '/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechTypes[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechType',
	        value: function deleteSpeechType(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_type_en/' + type.speech_type_id + '/').then(function (response) {
	                if (response.status === 204) {
	                    _this3.speechTypes.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechTypeEnController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechtypeen', [_angularUiRouter2.default]).config(_speechtypeen2.default).component('speechtypeen', {
	    template: __webpack_require__(247),
	    controller: SpeechTypeEnController
	}).name;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechtypeen', {
	        url: '/speechtypeen',
	        template: '<speechtypeen></speechtypeen>'
	    });
	}

/***/ }),
/* 246 */
198,
/* 247 */
199,
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechProfileEnController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechprofileen = __webpack_require__(249);
	
	var _speechprofileen2 = _interopRequireDefault(_speechprofileen);
	
	var _add = __webpack_require__(250);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechProfileEnController = exports.SpeechProfileEnController = function () {
	
	    /*@ngInject*/
	    SpeechProfileEnController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechProfileEnController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechProfileEnController);
	
	        this.awesomeThings = [];
	        this.speechProfile = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechProfileEnController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_type_en/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.speechTypeName = response.data.data;
	                    }
	                });
	
	                this.getTypeName = function (id) {
	                    var _name = _lodash2.default.find(this.speechTypeName, { speech_type_id: id });
	                    return _name.speech_type_name;
	                };
	
	                this.$http.get('/api/speech_profile_en/1/2/3/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechProfile = response.data.data;
	                        _this.socket.syncUpdates('speechProfile', _this.speechProfile);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_profile_en/1/2/3/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechProfile = response.data.data;
	                        _this2.socket.syncUpdates('speechProfile', _this2.speechProfile);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechProfile',
	        value: function addSpeechProfile() {
	            var speechProfile = this.speechProfile;
	
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/speech_profiles/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.cover_img = response.data.cover_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $http.get('/api/speech_type_en/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    $scope.changeType = function (index) {
	
	                        if (index === 1) {
	                            $scope.isType_one = true;
	                            $scope.isType_two = false;
	                        }
	
	                        if (index !== 1) {
	                            $scope.isType_two = true;
	                            $scope.isType_one = false;
	                        }
	                    };
	
	                    $scope.save = function (myForm) {
	                        console.log($scope.vm.profile);
	                        if (myForm.$valid === false && $scope.isload === false) {
	                            return false;
	                        } else {
	                            var ret = {};
	                            if ($scope.vm.speech_type_id === 1) {
	                                ret['speech_type_id'] = $scope.vm.speech_type_id;
	                                ret['speech_name'] = $scope.vm.speech_name;
	                                ret['cover_img'] = $scope.vm.cover_img;
	                                ret['cover_small_img'] = $scope.vm.cover_small_img;
	                                ret['speech_url'] = $scope.vm.speech_url;
	                                ret['desc'] = $scope.vm.desc;
	                                ret['speech_size'] = $scope.vm.speech_size;
	                                ret['speech_during'] = $scope.vm.speech_during;
	                            }
	                            if ($scope.vm.speech_type_id !== 1) {
	                                ret['speech_type_id'] = $scope.vm.speech_type_id;
	                                ret['speech_name'] = $scope.vm.speech_name;
	                                ret['cover_img'] = $scope.vm.cover_img;
	                                ret['desc'] = $scope.vm.desc;
	                                ret['profile'] = $scope.vm.profile;
	                            }
	                            console.log(ret);
	                            $http.post('/api/speech_profile_en/', ret).then(function (response) {
	                                console.log(response.data.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechProfile.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechProfile',
	        value: function editSpeechProfile(type, index) {
	            var speechProfile = this.speechProfile;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    console.log(type);
	                    $scope.vm = _angular2.default.copy(type);
	
	                    $http.get('/api/speech_type_en/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    if ($scope.vm.speech_type_id === 1) {
	                        $scope.isType_one = true;
	                        $scope.isType_two = false;
	                    }
	                    if ($scope.vm.speech_type_id !== 1) {
	                        $scope.isType_two = true;
	                        $scope.isType_one = false;
	                    }
	
	                    $scope.changeType = function (index) {
	
	                        if (index === 1) {
	                            $scope.isType_one = true;
	                            $scope.isType_two = false;
	                        }
	
	                        if (index !== 1) {
	                            $scope.isType_two = true;
	                            $scope.isType_one = false;
	                        }
	                    };
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/speech_profiles/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.cover_img = response.data.cover_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.put('/api/speech_profile_en/' + type.speech_profile_id + '/', $scope.vm).then(function (response) {
	                                console.log(response);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechProfile[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechProfile',
	        value: function deleteSpeechProfile(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_profile_en/' + type.speech_profile_id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.speechProfile.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechProfileEnController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechprofileen', [_angularUiRouter2.default]).config(_speechprofileen2.default).component('speechprofileen', {
	    template: __webpack_require__(251),
	    controller: SpeechProfileEnController
	}).name;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechprofileen', {
	        url: '/speechprofileen',
	        template: '<speechprofileen></speechprofileen>'
	    });
	}

/***/ }),
/* 250 */
202,
/* 251 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">英语语音基本信息列表</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <select name=\"speech_type\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.speech_type_id\"\n                            ng-options=\"type.speech_type_id as type.speech_type_name for type in $ctrl.speechTypeName\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">选择语音类型</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.speech_type_id\">\n                            语音类型:{{$ctrl.getTypeName($ctrl.filters.speech_type_id)}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.speech_type_id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"10\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechProfile()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>语音类型</td>\n                            <td>语音名称</td>\n                            <td>语音文件url</td>\n                            <td>封面图</td>\n                            <td>播放器小图</td>\n                            <td>描述</td>\n                            <td>语音文件大小</td>\n                            <td>语音时长</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"profile in $ctrl.speechProfile track by $index\">\n                            <td>\n                                {{profile.speech_profile_id}}\n                            </td>\n                            <td>\n                                {{$ctrl.getTypeName(profile.speech_type_id)}}\n                            </td>\n                            <td>\n                                {{profile.speech_name}}\n                            </td>\n                            <td ng-if=\"profile.speech_url\">\n                                <a target=\"_blank\" ng-href=\"{{profile.speech_url}}\"\n                                    class=\"glyphicon glyphicon-new-window\" aria-hidden=\"true\"></a>\n                            </td>\n                            <td ng-if=\"!profile.speech_url\">\n                                {{profile.speech_url}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{profile.cover_img}}\" />\n                            </td>\n                            <td ng-if=\"profile.cover_small_img\">\n                                <img width=\"72\" height=\"51\" src=\"{{profile.cover_small_img}}\" />\n                            </td>\n                            <td ng-if=\"!profile.cover_small_img\">\n                                {{profile.cover_small_img}}\n                            </td>\n                            <td>\n                                {{profile.desc}}\n                            </td>\n                            <td>\n                                {{profile.speech_size ? (profile.speech_size +' M'): ''}}\n                            </td>\n                            <td>\n                                {{profile.speech_during ? profile.speech_during:''}}\n                            </td>\n                            <td>\n                                {{profile.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechProfile(profile, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechProfile(profile, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechDetailsEnController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechdetailsen = __webpack_require__(253);
	
	var _speechdetailsen2 = _interopRequireDefault(_speechdetailsen);
	
	var _add = __webpack_require__(254);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechDetailsEnController = exports.SpeechDetailsEnController = function () {
	
	    /*@ngInject*/
	    SpeechDetailsEnController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechDetailsEnController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechDetailsEnController);
	
	        this.awesomeThings = [];
	        this.speechDetails = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechDetailsEnController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_type_en/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.speechTypeName = response.data.data;
	                    }
	                });
	
	                this.getTypeName = function (id) {
	                    var _name = _lodash2.default.find(this.speechTypeName, { speech_type_id: id });
	                    return _name.speech_type_name;
	                };
	
	                this.$http.get('/api/speech_details_en/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechDetails = response.data.data;
	                        _this.socket.syncUpdates('speechDetails', _this.speechDetails);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_details_en/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechDetails = response.data.data;
	                        _this2.socket.syncUpdates('speechDetails', _this2.speechDetails);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechDetails',
	        value: function addSpeechDetails() {
	            var speechDetails = this.speechDetails;
	
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    $http.get('/api/speech_type_en/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            response.data.data.splice(0, 1);
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    $scope.changeType = function (index) {
	
	                        $http.get('/api/speech_profile_en/' + index + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                            }
	                        });
	                    };
	
	                    $scope.selectProfile = function (value) {
	                        var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': value });
	                        $scope.vm['cover_img'] = obj.cover_img;
	                        $scope.vm['collection_name'] = obj.speech_name;
	                        $scope.vm['profile'] = obj.profile;
	                        console.log($scope.vm);
	                    };
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            console.log(options);
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoversmallError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        console.log($scope.vm.profile);
	                        if (myForm.$valid === false && $scope.isload === false) {
	                            return false;
	                        } else {
	                            var ret = {
	                                speech_profile_id: $scope.vm.speech_profile_id,
	                                collection_name: $scope.vm.collection_name,
	                                speech_type_id: $scope.vm.speech_type_id,
	                                speech_name: $scope.vm.speech_name,
	                                speech_url: $scope.vm.speech_url,
	                                cover_img: $scope.vm.cover_img,
	                                cover_small_img: $scope.vm.cover_small_img,
	                                profile: $scope.vm.profile,
	                                desc: $scope.vm.desc,
	                                speech_size: $scope.vm.speech_size,
	                                speech_during: $scope.vm.speech_during
	                            };
	
	                            $http.post('/api/speech_details_en/', ret).then(function (response) {
	                                console.log(response.data.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechDetails.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechDetails',
	        value: function editSpeechDetails(type, index) {
	            var speechDetails = this.speechDetails;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = _angular2.default.copy(type);
	                    console.log($scope.vm);
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    $http.get('/api/speech_type_en/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            response.data.data.splice(0, 1);
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    if ($scope.vm.speech_type_id) {
	                        $http.get('/api/speech_profile_en/' + $scope.vm.speech_type_id + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                                var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': $scope.vm.speech_profile_id });
	                                if (obj) {
	                                    $scope.vm['cover_img'] = obj.cover_img;
	                                    $scope.vm['collection_name'] = obj.speech_name;
	                                    $scope.vm['profile'] = obj.profile;
	                                }
	                            }
	                        });
	                    }
	
	                    $scope.changeType = function (index) {
	
	                        $http.get('/api/speech_profile_en/' + index + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                            }
	                        });
	                    };
	
	                    $scope.selectProfile = function (value) {
	                        var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': value });
	                        if (obj) {
	                            $scope.vm['cover_img'] = obj.cover_img;
	                            $scope.vm['collection_name'] = obj.speech_name;
	                            $scope.vm['profile'] = obj.profile;
	                            console.log($scope.vm);
	                        }
	                    };
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            console.log(options);
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoversmallError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.put('/api/speech_details_en/' + type.details_id + '/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechDetails[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechDetails',
	        value: function deleteSpeechDetails(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_details_en/' + type.details_id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.speechDetails.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechDetailsEnController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechdetailsen', [_angularUiRouter2.default]).config(_speechdetailsen2.default).component('speechdetailsen', {
	    template: __webpack_require__(255),
	    controller: SpeechDetailsEnController
	}).name;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechdetailsen', {
	        url: '/speechdetailsen',
	        template: '<speechdetailsen></speechdetailsen>'
	    });
	}

/***/ }),
/* 254 */
206,
/* 255 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">英语语音专辑基本信息列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"10\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechDetails()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>语音类型</td>\n                            <td>专辑名称</td>\n                            <td>语音名称</td>\n                            <td>语音文件url</td>\n                            <td>封面图</td>\n                            <td>播放器小图</td>\n                            <td>描述</td>\n                            <td>语音文件大小</td>\n                            <td>语音时长</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"Details in $ctrl.speechDetails track by $index\">\n                            <td>\n                                {{Details.details_id}}\n                            </td>\n                            <td>\n                                {{$ctrl.getTypeName(Details.speech_type_id)}}\n                            </td>\n                            <td>\n                                {{Details.collection_name}}\n                            </td>\n                            <td>\n                                {{Details.speech_name}}\n                            </td>\n                            <td ng-if=\"Details.speech_url\">\n                                <a target=\"_blank\" ng-href=\"{{Details.speech_url}}\"\n                                    class=\"glyphicon glyphicon-new-window\" aria-hidden=\"true\"></a>\n                            </td>\n                            <td ng-if=\"!Details.speech_url\">\n                                {{Details.speech_url}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{Details.cover_img}}\" />\n                            </td>\n                            <td ng-if=\"Details.cover_small_img\">\n                                <img width=\"72\" height=\"51\" src=\"{{Details.cover_small_img}}\" />\n                            </td>\n                            <td ng-if=\"!Details.cover_small_img\">\n                                {{Details.cover_small_img}}\n                            </td>\n                            <td>\n                                {{Details.desc}}\n                            </td>\n                            <td>\n                                {{Details.speech_size ? (Details.speech_size +' M'): ''}}\n                            </td>\n                            <td>\n                                {{Details.speech_during ? Details.speech_during:''}}\n                            </td>\n                            <td>\n                                {{Details.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechDetails(Details, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechDetails(Details, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechTypeEsController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechtypees = __webpack_require__(257);
	
	var _speechtypees2 = _interopRequireDefault(_speechtypees);
	
	var _add = __webpack_require__(258);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechTypeEsController = exports.SpeechTypeEsController = function () {
	
	    /*@ngInject*/
	    SpeechTypeEsController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechTypeEsController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechTypeEsController);
	
	        this.awesomeThings = [];
	        this.speechTypes = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechTypeEsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/speech_type_es/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechTypes = response.data.data;
	                        _this.socket.syncUpdates('speechTypes', _this.speechTypes);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_type_es/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechTypes = response.data.data;
	                        _this2.socket.syncUpdates('speechTypes', _this2.speechTypes);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechType',
	        value: function addSpeechType() {
	            var speechTypes = this.speechTypes;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/speech_type_es/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechTypes.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechType',
	        value: function editSpeechType(type, index) {
	            var speechTypes = this.speechTypes;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = _angular2.default.copy(type);
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	
	                            $http.put('/api/speech_type_es/' + type.speech_type_id + '/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechTypes[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechType',
	        value: function deleteSpeechType(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_type_es/' + type.speech_type_id + '/').then(function (response) {
	                if (response.status === 204) {
	                    _this3.speechTypes.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechTypeEsController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechtypees', [_angularUiRouter2.default]).config(_speechtypees2.default).component('speechtypees', {
	    template: __webpack_require__(259),
	    controller: SpeechTypeEsController
	}).name;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechtypees', {
	        url: '/speechtypees',
	        template: '<speechtypees></speechtypees>'
	    });
	}

/***/ }),
/* 258 */
198,
/* 259 */
199,
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechProfileEsController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechprofilees = __webpack_require__(261);
	
	var _speechprofilees2 = _interopRequireDefault(_speechprofilees);
	
	var _add = __webpack_require__(262);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechProfileEsController = exports.SpeechProfileEsController = function () {
	
	    /*@ngInject*/
	    SpeechProfileEsController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechProfileEsController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechProfileEsController);
	
	        this.awesomeThings = [];
	        this.speechProfile = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechProfileEsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_type_es/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.speechTypeName = response.data.data;
	                    }
	                });
	
	                this.getTypeName = function (id) {
	                    console.log(id);
	                    var _name = _lodash2.default.find(this.speechTypeName, { speech_type_id: id });
	                    return _name.speech_type_name;
	                };
	
	                this.$http.get('/api/speech_profile_es/1/2/3/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechProfile = response.data.data;
	                        _this.socket.syncUpdates('speechProfile', _this.speechProfile);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_profile_es/1/2/3/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechProfile = response.data.data;
	                        _this2.socket.syncUpdates('speechProfile', _this2.speechProfile);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechProfile',
	        value: function addSpeechProfile() {
	            var speechProfile = this.speechProfile;
	
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/speech_profiles/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.cover_img = response.data.cover_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $http.get('/api/speech_type_es/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    $scope.changeType = function (index) {
	
	                        if (index === 1) {
	                            $scope.isType_one = true;
	                            $scope.isType_two = false;
	                        }
	
	                        if (index !== 1) {
	                            $scope.isType_two = true;
	                            $scope.isType_one = false;
	                        }
	                    };
	
	                    $scope.save = function (myForm) {
	                        console.log($scope.vm.profile);
	                        if (myForm.$valid === false && $scope.isload === false) {
	                            return false;
	                        } else {
	                            var ret = {};
	                            if ($scope.vm.speech_type_id === 1) {
	                                ret['speech_type_id'] = $scope.vm.speech_type_id;
	                                ret['speech_name'] = $scope.vm.speech_name;
	                                ret['cover_img'] = $scope.vm.cover_img;
	                                ret['cover_small_img'] = $scope.vm.cover_small_img;
	                                ret['speech_url'] = $scope.vm.speech_url;
	                                ret['desc'] = $scope.vm.desc;
	                                ret['speech_size'] = $scope.vm.speech_size;
	                                ret['speech_during'] = $scope.vm.speech_during;
	                            }
	                            if ($scope.vm.speech_type_id !== 1) {
	                                ret['speech_type_id'] = $scope.vm.speech_type_id;
	                                ret['speech_name'] = $scope.vm.speech_name;
	                                ret['cover_img'] = $scope.vm.cover_img;
	                                ret['desc'] = $scope.vm.desc;
	                                ret['profile'] = $scope.vm.profile;
	                            }
	                            console.log(ret);
	                            $http.post('/api/speech_profile_es/', ret).then(function (response) {
	                                console.log(response.data.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechProfile.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechProfile',
	        value: function editSpeechProfile(type, index) {
	            var speechProfile = this.speechProfile;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    console.log(type);
	                    $scope.vm = _angular2.default.copy(type);
	
	                    $http.get('/api/speech_type_es/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    if ($scope.vm.speech_type_id === 1) {
	                        $scope.isType_one = true;
	                        $scope.isType_two = false;
	                    }
	                    if ($scope.vm.speech_type_id !== 1) {
	                        $scope.isType_two = true;
	                        $scope.isType_one = false;
	                    }
	
	                    $scope.changeType = function (index) {
	
	                        if (index === 1) {
	                            $scope.isType_one = true;
	                            $scope.isType_two = false;
	                        }
	
	                        if (index !== 1) {
	                            $scope.isType_two = true;
	                            $scope.isType_one = false;
	                        }
	                    };
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/speech_profiles/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.cover_img = response.data.cover_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.put('/api/speech_profile_es/' + type.speech_profile_id + '/', $scope.vm).then(function (response) {
	                                console.log(response);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechProfile[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechProfile',
	        value: function deleteSpeechProfile(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_profile_es/' + type.speech_profile_id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.speechProfile.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechProfileEsController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechprofilees', [_angularUiRouter2.default]).config(_speechprofilees2.default).component('speechprofilees', {
	    template: __webpack_require__(263),
	    controller: SpeechProfileEsController
	}).name;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechprofilees', {
	        url: '/speechprofilees',
	        template: '<speechprofilees></speechprofilees>'
	    });
	}

/***/ }),
/* 262 */
202,
/* 263 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">西语语音基本信息列表</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <select name=\"speech_type\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.speech_type_id\"\n                            ng-options=\"type.speech_type_id as type.speech_type_name for type in $ctrl.speechTypeName\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">选择语音类型</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.speech_type_id\">\n                            语音类型:{{$ctrl.getTypeName($ctrl.filters.speech_type_id)}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.speech_type_id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"10\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechProfile()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>语音类型</td>\n                            <td>语音名称</td>\n                            <td>语音文件url</td>\n                            <td>封面图</td>\n                            <td>播放器小图</td>\n                            <td>描述</td>\n                            <td>语音文件大小</td>\n                            <td>语音时长</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"profile in $ctrl.speechProfile track by $index\">\n                            <td>\n                                {{profile.speech_profile_id}}\n                            </td>\n                            <td>\n                                {{$ctrl.getTypeName(profile.speech_type_id)}}\n                            </td>\n                            <td>\n                                {{profile.speech_name}}\n                            </td>\n                            <td ng-if=\"profile.speech_url\">\n                                <a target=\"_blank\" ng-href=\"{{profile.speech_url}}\"\n                                    class=\"glyphicon glyphicon-new-window\" aria-hidden=\"true\"></a>\n                            </td>\n                            <td ng-if=\"!profile.speech_url\">\n                                {{profile.speech_url}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{profile.cover_img}}\" />\n                            </td>\n                            <td ng-if=\"profile.cover_small_img\">\n                                <img width=\"72\" height=\"51\" src=\"{{profile.cover_small_img}}\" />\n                            </td>\n                            <td ng-if=\"!profile.cover_small_img\">\n                                {{profile.cover_small_img}}\n                            </td>\n                            <td>\n                                {{profile.desc}}\n                            </td>\n                            <td>\n                                {{profile.speech_size ? (profile.speech_size +' M'): ''}}\n                            </td>\n                            <td>\n                                {{profile.speech_during ? profile.speech_during:''}}\n                            </td>\n                            <td>\n                                {{profile.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechProfile(profile, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechProfile(profile, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeechDetailsEsController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _speechdetailses = __webpack_require__(265);
	
	var _speechdetailses2 = _interopRequireDefault(_speechdetailses);
	
	var _add = __webpack_require__(266);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpeechDetailsEsController = exports.SpeechDetailsEsController = function () {
	
	    /*@ngInject*/
	    SpeechDetailsEsController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SpeechDetailsEsController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SpeechDetailsEsController);
	
	        this.awesomeThings = [];
	        this.speechDetails = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(SpeechDetailsEsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_type_es/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.speechTypeName = response.data.data;
	                    }
	                });
	
	                this.getTypeName = function (id) {
	                    var _name = _lodash2.default.find(this.speechTypeName, { speech_type_id: id });
	                    return _name.speech_type_name;
	                };
	
	                this.$http.get('/api/speech_details_es/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.speechDetails = response.data.data;
	                        _this.socket.syncUpdates('speechDetails', _this.speechDetails);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/speech_details_es/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.speechDetails = response.data.data;
	                        _this2.socket.syncUpdates('speechDetails', _this2.speechDetails);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechDetails',
	        value: function addSpeechDetails() {
	            var speechDetails = this.speechDetails;
	
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    $http.get('/api/speech_type_es/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            response.data.data.splice(0, 1);
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    $scope.changeType = function (index) {
	
	                        $http.get('/api/speech_profile_es/' + index + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                            }
	                        });
	                    };
	
	                    $scope.selectProfile = function (value) {
	                        var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': value });
	                        $scope.vm['cover_img'] = obj.cover_img;
	                        $scope.vm['collection_name'] = obj.speech_name;
	                        $scope.vm['profile'] = obj.profile;
	                        console.log($scope.vm);
	                    };
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            console.log(options);
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoversmallError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        console.log($scope.vm.profile);
	                        if (myForm.$valid === false && $scope.isload === false) {
	                            return false;
	                        } else {
	                            var ret = {
	                                speech_profile_id: $scope.vm.speech_profile_id,
	                                collection_name: $scope.vm.collection_name,
	                                speech_type_id: $scope.vm.speech_type_id,
	                                speech_name: $scope.vm.speech_name,
	                                speech_url: $scope.vm.speech_url,
	                                cover_img: $scope.vm.cover_img,
	                                cover_small_img: $scope.vm.cover_small_img,
	                                profile: $scope.vm.profile,
	                                desc: $scope.vm.desc,
	                                speech_size: $scope.vm.speech_size,
	                                speech_during: $scope.vm.speech_during
	                            };
	
	                            $http.post('/api/speech_details_es/', ret).then(function (response) {
	                                console.log(response.data.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    speechDetails.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechDetails',
	        value: function editSpeechDetails(type, index) {
	            var speechDetails = this.speechDetails;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = _angular2.default.copy(type);
	                    console.log($scope.vm);
	                    $scope.isload = false;
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    $http.get('/api/speech_type_es/', {
	                        header: {
	                            'Accept': 'application/json',
	                            'Content-Type': 'application/json',
	                            'token': $cookies.get('token')
	                        }
	                    }).then(function (response) {
	                        if (response.data.data) {
	                            response.data.data.splice(0, 1);
	                            $scope.speechTypes = response.data.data;
	                        }
	                    });
	
	                    if ($scope.vm.speech_type_id) {
	                        $http.get('/api/speech_profile_es/' + $scope.vm.speech_type_id + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                                var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': $scope.vm.speech_profile_id });
	                                if (obj) {
	                                    $scope.vm['cover_img'] = obj.cover_img;
	                                    $scope.vm['collection_name'] = obj.speech_name;
	                                    $scope.vm['profile'] = obj.profile;
	                                }
	                            }
	                        });
	                    }
	
	                    $scope.changeType = function (index) {
	
	                        $http.get('/api/speech_profile_es/' + index + '/9527/').then(function (response) {
	                            if (response.data.data) {
	                                $scope.speechProfile = response.data.data;
	                            }
	                        });
	                    };
	
	                    $scope.selectProfile = function (value) {
	                        var obj = _lodash2.default.find($scope.speechProfile, { 'speech_profile_id': value });
	                        if (obj) {
	                            $scope.vm['cover_img'] = obj.cover_img;
	                            $scope.vm['collection_name'] = obj.speech_name;
	                            $scope.vm['profile'] = obj.profile;
	                            console.log($scope.vm);
	                        }
	                    };
	
	                    var uploader = $scope.uploader = new FileUploader({
	                        url: '/api/speech_profiles/9527/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/speech_profiles/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
	                                $scope.isload = true;
	                                $scope.isloadSpeechUrlError = false;
	                                var s = item.name.split('.');
	                                $scope.vm.speech_name = s[0];
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadSpeechUrlError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            console.log(item);
	                            console.log(options);
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoversmallError = true;
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isload = false;
	                            $scope.vm.speech_url = response.data.speech_url;
	                            $scope.vm.speech_size = response.data.speech_size;
	                        }
	                    };
	
	                    $scope.clearItems = function () {
	                        uploader.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.cover_small_img = response.data.cover_small_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.put('/api/speech_details_es/' + type.details_id + '/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    speechDetails[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechDetails',
	        value: function deleteSpeechDetails(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/speech_details_es/' + type.details_id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.speechDetails.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return SpeechDetailsEsController;
	}();
	
	exports.default = _angular2.default.module('tttApp.speechdetailses', [_angularUiRouter2.default]).config(_speechdetailses2.default).component('speechdetailses', {
	    template: __webpack_require__(267),
	    controller: SpeechDetailsEsController
	}).name;

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('speechdetailses', {
	        url: '/speechdetailses',
	        template: '<speechdetailses></speechdetailses>'
	    });
	}

/***/ }),
/* 266 */
206,
/* 267 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">西语语音专辑基本信息列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"10\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechDetails()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>语音类型</td>\n                            <td>专辑名称</td>\n                            <td>语音名称</td>\n                            <td>语音文件url</td>\n                            <td>封面图</td>\n                            <td>播放器小图</td>\n                            <td>描述</td>\n                            <td>语音文件大小</td>\n                            <td>语音时长</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"Details in $ctrl.speechDetails track by $index\">\n                            <td>\n                                {{Details.details_id}}\n                            </td>\n                            <td>\n                                {{$ctrl.getTypeName(Details.speech_type_id)}}\n                            </td>\n                            <td>\n                                {{Details.collection_name}}\n                            </td>\n                            <td>\n                                {{Details.speech_name}}\n                            </td>\n                            <td ng-if=\"Details.speech_url\">\n                                <a target=\"_blank\" ng-href=\"{{Details.speech_url}}\"\n                                    class=\"glyphicon glyphicon-new-window\" aria-hidden=\"true\"></a>\n                            </td>\n                            <td ng-if=\"!Details.speech_url\">\n                                {{Details.speech_url}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{Details.cover_img}}\" />\n                            </td>\n                            <td ng-if=\"Details.cover_small_img\">\n                                <img width=\"72\" height=\"51\" src=\"{{Details.cover_small_img}}\" />\n                            </td>\n                            <td ng-if=\"!Details.cover_small_img\">\n                                {{Details.cover_small_img}}\n                            </td>\n                            <td>\n                                {{Details.desc}}\n                            </td>\n                            <td>\n                                {{Details.speech_size ? (Details.speech_size +' M'): ''}}\n                            </td>\n                            <td>\n                                {{Details.speech_during ? Details.speech_during:''}}\n                            </td>\n                            <td>\n                                {{Details.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechDetails(Details, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechDetails(Details, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NewController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _new = __webpack_require__(269);
	
	var _new2 = _interopRequireDefault(_new);
	
	var _add = __webpack_require__(270);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NewController = exports.NewController = function () {
	
	    /*@ngInject*/
	    NewController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function NewController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, NewController);
	
	        this.news = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.isHot = [{ value: 0, name: '否' }, { value: 1, name: '是' }];
	
	        this.newsType = [{ value: 1, name: '新闻' }, { value: 2, name: '学习' }];
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('news');
	        });
	    }
	
	    _createClass(NewController, [{
	        key: 'TransformationIsHot',
	        value: function TransformationIsHot(value) {
	            var ret = _.find(this.isHot, { value: value });
	            if (ret) {
	                return ret.name;
	            }
	            return '';
	        }
	    }, {
	        key: 'TransformationNewsType',
	        value: function TransformationNewsType(value) {
	            var ret = _.find(this.newsType, { value: value });
	            if (ret) {
	                return ret.name;
	            }
	            return '';
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/news/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	                        _angular2.default.forEach(response.data.data, function (item) {
	                            if (item.img.indexOf('[') !== -1) {
	                                item.img = JSON.parse(item.img);
	                            } else {
	                                item.img = [item.img];
	                            }
	                        });
	                        _this.news = response.data.data;
	
	                        _this.socket.syncUpdates('news', _this.news);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/news/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _angular2.default.forEach(response.data.data, function (item) {
	                            if (item.img.indexOf('[') !== -1) {
	                                item.img = JSON.parse(item.img);
	                            } else {
	                                item.img = [item.img];
	                            }
	                        });
	                        _this2.news = response.data.data;
	
	                        _this2.socket.syncUpdates('news', _this2.news);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'getContent',
	        value: function getContent(content) {
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.content = content;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }]);
	
	    return NewController;
	}();
	
	exports.default = _angular2.default.module('tttApp.new', [_angularUiRouter2.default]).config(_new2.default).component('new', {
	    template: __webpack_require__(271),
	    controller: NewController
	}).name;

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('new', {
	        url: '/new',
	        template: '<new></new>'
	    });
	}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">内容</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>\n        {{content}}\n    </p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">关闭</button>\n</div>\n"

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">信息流数据</h3>\n            </div>\n            <div class=\"panel-body\">\n\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n\n\n                    <div class=\"col-xs-2\">\n                        <select name=\"news_type\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.news_type\"\n                            ng-options=\"item.value as item.name for item in $ctrl.newsType\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">信息流类型</option>\n                        </select>\n                    </div>\n\n                    <div class=\"col-xs-2\">\n                        <select name=\"hot\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.hot\"\n                            ng-options=\"item.value as item.name for item in $ctrl.isHot\" ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">是否COVID</option>\n                        </select>\n                    </div>\n\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.news_type\">\n                            是否COVID:{{$ctrl.TransformationNewsType($ctrl.filters.news_type)}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.news_type=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.hot || $ctrl.filters.hot === 0 \">\n                            是否COVID:{{$ctrl.TransformationIsHot($ctrl.filters.hot)}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.hot=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                    </div>\n                </div>\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"9\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>类型</td>\n                            <td>来源</td>\n                            <td>标题</td>\n                            <td>图片</td>\n                            <td>类容</td>\n                            <td>阅读量</td>\n                            <td>是否COVID</td>\n                            <td>创建时间(UTC)</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.news track by $index\">\n                            <td>\n                                {{item._id}}\n                            </td>\n                            <td>\n                                {{$ctrl.TransformationNewsType(item.news_type)}}\n                            </td>\n                            <td>\n                                <a target=\"_blank\" ng-href=\"{{item.url}}\" class=\"glyphicon glyphicon-new-window\"\n                                    aria-hidden=\"true\"></a>\n                            </td>\n                            <td>\n                                {{item.title}}\n                            </td>\n                            <td>\n                                <a href=\"javascript:void(0);\" ng-repeat=\"imges in item.img track by $index\">\n                                    <img width=\"72\" height=\"51\" src=\"{{imges}}\" />\n                                </a>\n\n                            </td>\n                            <td>\n                                <a ng-click=\"$ctrl.getContent(item.content)\" class=\"glyphicon glyphicon-new-window\"\n                                    aria-hidden=\"true\"></a>\n                            </td>\n                            <td>\n                                {{item.show}}\n                            </td>\n                            <td>\n                                {{$ctrl.TransformationIsHot(item.hot)}}\n                            </td>\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n\n\n\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"9\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SetPointController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _setpoint = __webpack_require__(273);
	
	var _setpoint2 = _interopRequireDefault(_setpoint);
	
	var _add = __webpack_require__(274);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SetPointController = exports.SetPointController = function () {
	
	    /*@ngInject*/
	    SetPointController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SetPointController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SetPointController);
	
	        this.awesomeThings = [];
	        this.setpoints = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('setpoint');
	        });
	    }
	
	    _createClass(SetPointController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                console.log(this.$cookies.get('token'));
	                this.$http.get('/api/set_point_exchange/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    console.log(response);
	                    if (response.data.data) {
	                        _this.setpoints = response.data.data;
	                        _this.socket.syncUpdates('setpoint', _this.setpoints);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'deleteMultiplication',
	        value: function deleteMultiplication(setpoint, index) {
	            var _this2 = this;
	
	            this.$http.delete('/api/set_point_exchange/' + setpoint._id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this2.setpoints.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }, {
	        key: 'addMultiplication',
	        value: function addMultiplication() {
	            var setpoints = this.setpoints;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.Type = [{ value: 1, name: '去广告' }, { value: 2, name: '听语音' }];
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/set_point_exchange/', $scope.vm).then(function (response) {
	                                console.log(response.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                console.log(ret);
	                if (ret) {
	                    setpoints.push(ret);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'updateMultiplication',
	        value: function updateMultiplication(setpoint, index) {
	            var setpoints = this.setpoints;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.Type = [{ value: 1, name: '去广告' }, { value: 2, name: '听语音' }];
	                    $scope.vm = _angular2.default.copy(setpoint);
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.put('/api/set_point_exchange/' + setpoint._id + '/', $scope.vm).then(function (response) {
	                                console.log(response.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                console.log(ret);
	                if (ret) {
	                    setpoints[index] = ret;
	                }
	            }, function () {});
	        }
	    }]);
	
	    return SetPointController;
	}();
	
	exports.default = _angular2.default.module('tttApp.setpoint', [_angularUiRouter2.default]).config(_setpoint2.default).component('setpoint', {
	    template: __webpack_require__(275),
	    controller: SetPointController
	}).name;

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('setpoint', {
	        url: '/setpoint',
	        template: '<setpoint></setpoint>'
	    });
	}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>类型</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.type\" name=\"type\"\n                    ng-options=\"item.value as item.name for item in Type\" required>\n                </select>\n                <span class=\"text-danger\" ng-if=\"myForm.type.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>分数</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.point\" name=\"point\" required placeholder=\"分数\">\n                <span class=\"text-danger\" ng-if=\"myForm.point.$error.required && myForm.$submitted==true\">必填项</span>\n                <span class=\"text-danger\" ng-if=\"myForm.point.$error.number && myForm.$submitted==true\">必须是数字</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>天数</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.days\" name=\"days\" required placeholder=\"天数\">\n                <span class=\"text-danger\" ng-if=\"myForm.days.$error.required && myForm.$submitted==true\">必填项</span>\n                <span class=\"text-danger\" ng-if=\"myForm.days.$error.number && myForm.$submitted==true\">必须是数字</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>描述</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.describe\" name=\"describe\" required\n                    placeholder=\"描述\">\n                <span class=\"text-danger\" ng-if=\"myForm.describe.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">权益</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.equity\" name=\"equity\" placeholder=\"权益\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">积分兑换设置列表</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"7\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addMultiplication()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>类型</td>\n                            <td>分数</td>\n                            <td>天数</td>\n                            <td>描述</td>\n                            <td>权益</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.setpoints track by $index\">\n                            <td>\n                                {{item._id}}\n                            </td>\n                            <td>\n                                {{item.type === 1 ? '去广告':'听语音' }}\n                            </td>\n\n                            <td>\n                                {{item.point}}\n                            </td>\n                            <td>\n                                {{item.days}}\n                            </td>\n                            <td>\n                                {{item.describe}}\n                            </td>\n                            <td>\n                                {{item.equity}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteMultiplication(item,$index)\">删除</button>\n                                <button type=\"button\" class=\"btn btn-warning\"\n                                    ng-click=\"$ctrl.updateMultiplication(item,$index)\">修改</button>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.IosDataController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _iosdata = __webpack_require__(277);
	
	var _iosdata2 = _interopRequireDefault(_iosdata);
	
	var _add = __webpack_require__(278);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IosDataController = exports.IosDataController = function () {
	
	    /*@ngInject*/
	    IosDataController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location', '$timeout'];
	    function IosDataController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout) {
	        _classCallCheck(this, IosDataController);
	
	        this.awesomeThings = [];
	        this.awesomeUsers = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	        this.$timeout = $timeout;
	    }
	
	    _createClass(IosDataController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'taskExcel',
	        value: function taskExcel() {
	            var _this = this;
	
	            this.$http.get('/api/complete_task_date/?mark=1', {}).then(function (response) {
	                if (response.status === 200) {
	                    console.log(response.data.data);
	                    _this.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }, {
	        key: 'exprotExcel',
	        value: function exprotExcel() {
	            var _this2 = this;
	
	            this.$http.get('/api/complete_task_date/?mark=2', {}).then(function (response) {
	                if (response.status === 200) {
	                    console.log(response.data.data);
	                    _this2.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }, {
	        key: 'payExcel',
	        value: function payExcel() {
	            var _this3 = this;
	
	            this.$http.get('/api/complete_task_date/?mark=3', {}).then(function (response) {
	                if (response.status === 200) {
	                    console.log(response.data.data);
	                    _this3.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return IosDataController;
	}();
	
	exports.default = _angular2.default.module('tttApp.iosdata', [_angularUiRouter2.default]).config(_iosdata2.default).component('iosdata', {
	    template: __webpack_require__(279),
	    controller: IosDataController
	}).name;

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('iosdata', {
	        url: '/iosdata',
	        template: '<iosdata></iosdata>'
	    });
	}

/***/ }),
/* 278 */
154,
/* 279 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">数据列表</h3>\n            </div>\n\n            <div class=\"panel-body\">\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"4\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.taskExcel()\">任务导出EXCEL</button>\n                            </td>\n                            <td colspan=\"4\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.exprotExcel()\">下载导出EXCEL</button>\n                            </td>\n                            <td colspan=\"4\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.payExcel()\">付款导出EXCEL</button>\n                            </td>\n                        </tr>\n\n\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ShareImgController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _shareimg = __webpack_require__(281);
	
	var _shareimg2 = _interopRequireDefault(_shareimg);
	
	var _add = __webpack_require__(282);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShareImgController = exports.ShareImgController = function () {
	
	    /*@ngInject*/
	    ShareImgController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function ShareImgController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, ShareImgController);
	
	        this.awesomeThings = [];
	        this.shareimg = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.languageTypes = [{ value: 'pt', name: '葡语' }, { value: 'en', name: '英语' }, { value: 'es', name: '西语' }];
	    }
	
	    _createClass(ShareImgController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/share_imgs/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.shareimgs = response.data.data;
	                        _this.socket.syncUpdates('shareimgs', _this.shareimgs);
	                    }
	                });
	
	                this.getTypeName = function (value) {
	                    var ret = _lodash2.default.find(this.languageTypes, { value: value });
	                    if (ret) {
	                        return ret.name;
	                    }
	                    return '';
	                };
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this2 = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/share_imgs/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': this.currentPage - 1,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.shareimgs = response.data.data;
	
	                        _this2.socket.syncUpdates('shareimgs', _this2.shareimgs);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addShareImg',
	        value: function addShareImg() {
	            var shareimgs = this.shareimgs;
	
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.languageTypes = [{ value: 'pt', name: '葡语' }, { value: 'en', name: '英语' }, { value: 'es', name: '西语' }];
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/share_imgs/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/share_imgs/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.small_img = response.data.small_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.max_img = response.data.max_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.post('/api/share_imgs/', $scope.vm).then(function (response) {
	                                console.log(response.data.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    shareimgs.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editShareImg',
	        value: function editShareImg(item, index) {
	            var shareimgs = this.shareimgs;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = _angular2.default.copy(item);
	                    $scope.languageTypes = [{ value: 'pt', name: '葡语' }, { value: 'en', name: '英语' }, { value: 'es', name: '西语' }];
	
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/share_imgs/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/share_imgs/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.small_img = response.data.small_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.max_img = response.data.max_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.put('/api/share_imgs/' + item._id + '/', $scope.vm).then(function (response) {
	                                console.log(response);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    shareimgs[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteShareImg',
	        value: function deleteShareImg(item, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/share_imgs/' + item._id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.shareimgs.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return ShareImgController;
	}();
	
	exports.default = _angular2.default.module('tttApp.shareimg', [_angularUiRouter2.default]).config(_shareimg2.default).component('shareimg', {
	    template: __webpack_require__(283),
	    controller: ShareImgController
	}).name;

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('shareimg', {
	        url: '/shareimg',
	        template: '<shareimg></shareimg>'
	    });
	}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语言版本</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.language_type\" name=\"language_type\"\n                    ng-options=\"item.value as item.name for item in languageTypes\" required></select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.language_type.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>小图</label>\n            <div class=\"col-sm-10\">\n                <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems1()\"\n                    ng-model=\"vm.small_img\" name=\"small_img\" uploader=\"uploaderImage\" />\n                <span class=\"text-danger\">{{vm.small_img}}</span>\n                <span class=\"text-danger\" ng-if=\"isloadcover\">上传中...</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoverError\">格式不正确</span>\n\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>大图</label>\n            <div class=\"col-sm-10\">\n                <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems2()\" ng-model=\"vm.max_img\"\n                    name=\"max_img\" uploader=\"uploaderImageSmall\" />\n                <span class=\"text-danger\">{{vm.max_img}}</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoversmall\">上传中...</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoversmallError\">格式不正确</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">分享图列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"6\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addShareImg()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>语言版本类型</td>\n                            <td>小图</td>\n                            <td>大图</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.shareimgs track by $index\">\n                            <td>\n                                {{item._id}}\n                            </td>\n                            <td>\n                                {{$ctrl.getTypeName(item.language_type)}}\n                            </td>\n\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{item.small_img}}\" />\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{item.max_img}}\" />\n                            </td>\n\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editShareImg(item, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteShareImg(item, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"12\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PlanTypeController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _plantype = __webpack_require__(285);
	
	var _plantype2 = _interopRequireDefault(_plantype);
	
	var _add = __webpack_require__(286);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlanTypeController = exports.PlanTypeController = function () {
	
	    /*@ngInject*/
	    PlanTypeController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function PlanTypeController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, PlanTypeController);
	
	        this.awesomeThings = [];
	        this.planTypes = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(PlanTypeController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/plan_types/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.planTypes = response.data.data;
	                        _this.socket.syncUpdates('planTypes', _this.planTypes);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/plan_types/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.planTypes = response.data.data;
	                        _this2.socket.syncUpdates('planTypes', _this2.planTypes);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechType',
	        value: function addSpeechType() {
	            var planTypes = this.planTypes;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.classifications = [{
	                        name: 'recommended', value: 1
	                    }, {
	                        name: 'read entire bible', value: 2
	                    }, {
	                        name: 'selected', value: 3
	                    }];
	
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/share_imgs/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/share_imgs/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.imges = response.data.small_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.small_imges = response.data.max_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/plan_types/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    planTypes.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editSpeechType',
	        value: function editSpeechType(type, index) {
	            var planTypes = this.planTypes;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                    $scope.vm = _angular2.default.copy(type);
	
	                    $scope.classifications = [{
	                        name: 'recommended', value: 1
	                    }, {
	                        name: 'read entire bible', value: 2
	                    }, {
	                        name: 'selected', value: 3
	                    }];
	
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/share_imgs/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/share_imgs/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                $scope.isloadcoversmallError = true;
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.imges = response.data.small_img;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            $scope.vm.small_imges = response.data.max_img;
	                        }
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	
	                            $http.put('/api/plan_types/' + type._id + '/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    planTypes[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechType',
	        value: function deleteSpeechType(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/plan_types/' + type._id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.planTypes.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return PlanTypeController;
	}();
	
	exports.default = _angular2.default.module('tttApp.plantype', [_angularUiRouter2.default]).config(_plantype2.default).component('plantype', {
	    template: __webpack_require__(287),
	    controller: PlanTypeController
	}).name;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('plantype', {
	        url: '/plantype',
	        template: '<plantype></plantype>'
	    });
	}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>分类</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.classification_id\" name=\"classification_id\"\n                    ng-options=\"item.value as item.name for item in classifications\" required></select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.classification_id.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>计划类型名称</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.plan_name\" name=\"plan_name\" required\n                    placeholder=\"计划类型名称\">\n                <span class=\"text-danger\" ng-if=\"myForm.plan_name.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>天数</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.days\" name=\"days\" required placeholder=\"天数\">\n                <span class=\"text-danger\" ng-if=\"myForm.days.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>图片</label>\n            <div class=\"col-sm-10\">\n                <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems1()\" ng-model=\"vm.imges\"\n                    name=\"imges\" uploader=\"uploaderImage\" />\n                <span class=\"text-danger\">{{vm.imges}}</span>\n                <span class=\"text-danger\" ng-if=\"isloadcover\">上传中...</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoverError\">格式不正确</span>\n\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>小图</label>\n            <div class=\"col-sm-10\">\n                <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems2()\"\n                    ng-model=\"vm.small_imges\" name=\"small_imges\" uploader=\"uploaderImageSmall\" />\n                <span class=\"text-danger\">{{vm.small_imges}}</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoversmall\">上传中...</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoversmallError\">格式不正确</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>描述</label>\n            <div class=\"col-sm-10\">\n\n                <textarea class=\"form-control\" ng-model=\"vm.describe\" name=\"describe\" required></textarea>\n                <span class=\"text-danger\" ng-if=\"myForm.describe.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>顺序</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.order\" name=\"order\" required placeholder=\"顺序\">\n                <span class=\"text-danger\" ng-if=\"myForm.order.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">计划类型列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"13\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechType()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>计划类型ID</td>\n                            <td>分类ID</td>\n                            <td>计划类型名称</td>\n                            <td>计划类型名称英语</td>\n                            <td>计划类型名称西语</td>\n                            <td>天数</td>\n                            <td>图片</td>\n                            <td>小图</td>\n                            <td>描述</td>\n                            <td>描述英语</td>\n                            <td>描述西语</td>\n                            <td>顺序</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.planTypes track by $index\">\n                            <td>\n                                {{item._id}}\n                            </td>\n                            <td>\n                                {{item.classification_id}}\n                            </td>\n                            <td>\n                                {{item.plan_name}}\n                            </td>\n                            <td>\n                                {{item.plan_name_en}}\n                            </td>\n                            <td>\n                                {{item.plan_name_es}}\n                            </td>\n                            <td>\n                                {{item.days}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{item.imges}}\" />\n                                {{item.imges}}\n                            </td>\n                            <td>\n                                <img width=\"72\" height=\"51\" src=\"{{item.small_imges}}\" />\n                                {{item.small_imges}}\n                            </td>\n\n                            <td>\n                                {{item.describe}}\n                            </td>\n                            <td>\n                                {{item.describe_en}}\n                            </td>\n                            <td>\n                                {{item.describe_es}}\n                            </td>\n                            <td>\n                                {{item.order}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechType(item, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechType(item, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"13\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PlanStatusController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _planstatus = __webpack_require__(289);
	
	var _planstatus2 = _interopRequireDefault(_planstatus);
	
	var _add = __webpack_require__(290);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlanStatusController = exports.PlanStatusController = function () {
	
	    /*@ngInject*/
	    PlanStatusController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function PlanStatusController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, PlanStatusController);
	
	        this.planstatus = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.planStatus = [{ value: 0, name: '浏览' }, { value: 1, name: '订阅' }, { value: 2, name: '完成' }];
	
	        this.isDisabled = false;
	        this.popup2 = {
	            opened: false
	        };
	
	        this.open2 = function () {
	            this.popup2.opened = true;
	        };
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('sharelinks');
	        });
	    }
	
	    _createClass(PlanStatusController, [{
	        key: 'TransformationFirstOpen',
	        value: function TransformationFirstOpen(value) {
	            var ret = _.find(this.firstOpen, { value: value });
	            if (ret) {
	                return ret.name;
	            }
	            return '';
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/sharelinks/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.sharelinks = response.data.data;
	                        _this.socket.syncUpdates('sharelinks', _this.sharelinks);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	
	            var payload = _angular2.default.copy(this.filters);
	            if (payload && payload.createdAt) {
	                payload.createdAt = new Date(payload.createdAt).valueOf();
	            }
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/sharelinks/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.sharelinks = response.data.data;
	
	                        _this2.socket.syncUpdates('sharelinks', _this2.sharelinks);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }]);
	
	    return PlanStatusController;
	}();
	
	exports.default = _angular2.default.module('tttApp.planstatus', [_angularUiRouter2.default]).config(_planstatus2.default).component('planstatus', {
	    template: __webpack_require__(291),
	    controller: PlanStatusController
	}).name;

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('planstatus', {
	        url: '/planstatus',
	        template: '<planstatus></planstatus>'
	    });
	}

/***/ }),
/* 290 */
210,
/* 291 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">计划状态</h3>\n            </div>\n            <div class=\"panel-body\">\n\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n\n                    <div class=\"col-xs-2\">\n                        <select name=\"status\" class=\"form-control input-sm\" ng-model=\"$ctrl.filters.status\"\n                            ng-options=\"item.value as item.name for item in $ctrl.planStatus\"\n                            ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">状态</option>\n                        </select>\n                    </div>\n\n\n                    <div class=\"col-xs-2\">\n                        <p class=\"input-group\">\n                            <input type=\"date\" class=\"form-control\" name=\"expires_date_ms\" uib-datepicker-popup\n                                ng-model=\"$ctrl.filters.createdAt\" is-open=\"$ctrl.popup2.opened\"\n                                datepicker-options=\"dateOptions\" required close-text=\"Close\"\n                                ng-change=\"$ctrl.search(true)\" />\n                            <span class=\"input-group-btn\">\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.open2()\"><i\n                                        class=\"glyphicon glyphicon-calendar\"></i></button>\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.share_platform\">\n                            状态:{{$ctrl.filters.share_platform}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.share_platform=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.createdAt\">\n                            日期:{{$ctrl.filters.createdAt | date:'yyyy-MM-dd'}} <span class=\"close\"\n                                ng-click=\"$ctrl.filters.createdAt=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"3\">\n                                <code style=\"text-align: right\">总数：{{0}}</code>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>计划ID</td>\n                            <td>状态</td>\n                            <td>创建时间(UTC)</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.planstatus track by $index\">\n                            <td>\n                                {{item.plan_list_id}}\n                            </td>\n                            <td>\n                                {{item.status}}\n                            </td>\n\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"3\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AdManageController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _admanage = __webpack_require__(293);
	
	var _admanage2 = _interopRequireDefault(_admanage);
	
	var _add = __webpack_require__(294);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _lodash = __webpack_require__(173);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdManageController = exports.AdManageController = function () {
	
	    /*@ngInject*/
	    AdManageController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function AdManageController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, AdManageController);
	
	        this.awesomeThings = [];
	        this.adManages = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.languageTypes = [{ value: 'pt', name: '葡语' }, { value: 'en', name: '英语' }, { value: 'es', name: '西语' }];
	    }
	
	    _createClass(AdManageController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/ad_manage/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.admanages = response.data.data;
	                        _this.socket.syncUpdates('admanages', _this.admanages);
	                    }
	                });
	
	                this.getTypeName = function (value) {
	                    var ret = _lodash2.default.find(this.languageTypes, { value: value });
	                    if (ret) {
	                        return ret.name;
	                    }
	                    return '';
	                };
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this2 = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/ad_manage/?all=true', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': this.currentPage - 1,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.admanages = response.data.data;
	
	                        _this2.socket.syncUpdates('admanages', _this2.admanages);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addShareImg',
	        value: function addShareImg() {
	            var admanages = this.admanages;
	
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = {};
	
	                    $scope.languageTypes = [{ value: 'pt', name: '葡语' }, { value: 'en', name: '英语' }, { value: 'es', name: '西语' }];
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/ad_manage/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    var uploader2 = $scope.uploaderImageSmall = new FileUploader({
	                        url: '/api/ad_manage/9529/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader2.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcoversmall = true;
	                                $scope.isloadcoversmallError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoversmallError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            console.log(response.data);
	                            $scope.vm.img_url = response.data.img_url;
	                        }
	                    };
	
	                    uploader2.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcoversmall = false;
	                            console.log(response.data);
	                            $scope.vm.banner_url = response.data.banner_url;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    $scope.clearItems2 = function () {
	                        uploader2.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.post('/api/ad_manage/', $scope.vm).then(function (response) {
	                                console.log(response.data.data);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (data) {
	                if (data) {
	                    admanages.push(data);
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'editShareImg',
	        value: function editShareImg(item, index) {
	            var admanages = this.admanages;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', '$cookies', 'FileUploader', function controller($scope, $http, $uibModalInstance, $cookies, FileUploader) {
	                    $scope.vm = _angular2.default.copy(item);
	                    $scope.languageTypes = [{ value: 'pt', name: '葡语' }, { value: 'en', name: '英语' }, { value: 'es', name: '西语' }];
	
	                    $scope.isloadcover = false;
	                    $scope.isloadcoversmall = false;
	
	                    var uploader1 = $scope.uploaderImage = new FileUploader({
	                        url: '/api/ad_manage/9528/',
	                        method: 'POST',
	                        autoUpload: true
	                    });
	
	                    uploader1.filters.push({
	                        name: 'Filter',
	                        fn: function fn(item, options) {
	                            if (item.type.indexOf('image') !== -1) {
	                                $scope.isloadcover = true;
	                                $scope.isloadcoverError = false;
	                                return true;
	                            } else {
	                                console.log('请选择正确的文件格式!', 'ERROR!');
	                                $scope.isloadcoverError = true;
	
	                                return false;
	                            }
	                        }
	                    });
	
	                    uploader1.onSuccessItem = function (fileItem, response, status, headers) {
	                        if (status === 200) {
	                            console.log('上传成功!', 'SUCCESS!');
	                            $scope.isloadcover = false;
	                            $scope.vm.img_url = response.data.img_url;
	                        }
	                    };
	
	                    $scope.clearItems1 = function () {
	                        uploader1.clearQueue();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            console.log($scope.vm);
	                            $http.put('/api/ad_manage/' + item._id + '/', $scope.vm).then(function (response) {
	                                console.log(response);
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    admanages[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteShareImg',
	        value: function deleteShareImg(item, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/ad_manage/' + item._id + '/').then(function (response) {
	                if (response.status === 200) {
	                    _this3.admanages.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return AdManageController;
	}();
	
	exports.default = _angular2.default.module('tttApp.admanage', [_angularUiRouter2.default]).config(_admanage2.default).component('admanage', {
	    template: __webpack_require__(295),
	    controller: AdManageController
	}).name;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('admanage', {
	        url: '/admanage',
	        template: '<admanage></admanage>'
	    });
	}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>语言版本</label>\n            <div class=\"col-sm-10\">\n                <select class=\"form-control\" ng-model=\"vm.language_type\" name=\"language_type\"\n                    ng-options=\"item.value as item.name for item in languageTypes\" required></select>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.language_type.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>名称</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.name\" name=\"name\" required placeholder=\"名称\">\n                <span class=\"text-danger\" ng-if=\"myForm.name.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>背景图片</label>\n            <div class=\"col-sm-10\">\n                <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems1()\" ng-model=\"vm.img_url\"\n                    name=\"img_url\" uploader=\"uploaderImage\" />\n                <span class=\"text-danger\">{{vm.img_url}}</span>\n                <span class=\"text-danger\" ng-if=\"isloadcover\">上传中...</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoverError\">格式不正确</span>\n            </div>\n        </div>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>banner图片</label>\n            <div class=\"col-sm-10\">\n                <input type=\"file\" nv-file-select=\"\" class=\"form-control\" ng-click=\"clearItems2()\"\n                    ng-model=\"vm.banner_url\" name=\"banner_url\" uploader=\"uploaderImageSmall\" />\n                <span class=\"text-danger\">{{vm.banner_url}}</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoversmall\">上传中...</span>\n                <span class=\"text-danger\" ng-if=\"isloadcoversmallError\">格式不正确</span>\n            </div>\n        </div>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>场景</label>\n            <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.scene\" name=\"scene\" required placeholder=\"场景\">\n                <span class=\"text-danger\" ng-if=\"myForm.scene.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>跳转链接</label>\n            <div class=\"col-sm-10\">\n                <input type=\"url\" class=\"form-control\" ng-model=\"vm.target_link\" name=\"target_link\" required\n                    placeholder=\"跳转链接\">\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.target_link.$error.required && myForm.$submitted==true\">必填项</span>\n                <span class=\"text-danger\"\n                    ng-if=\"myForm.target_link.$error.url && myForm.$submitted==true\">url格式错误</span>\n            </div>\n        </div>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>交付概率</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.chance\" name=\"chance\" required\n                    placeholder=\"交付概率\">\n                <span class=\"text-danger\" ng-if=\"myForm.chance.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">广告管理列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"9\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addShareImg()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>广告名称</td>\n                            <td>背景图</td>\n                            <td>banner图</td>\n                            <td>场景</td>\n                            <td>跳转链接</td>\n                            <td>交付概率</td>\n                            <td>语言</td>\n                            <td>提交时间</td>\n                            <td>修改时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.admanages track by $index\">\n                            <td>\n                                {{item._id}}\n                            </td>\n                            <td>\n                                {{item.name}}\n                            </td>\n                            <td>\n                                <a target=\"_blank\" ng-href=\"{{item.img_url}}\" class=\"glyphicon glyphicon-new-window\"\n                                    aria-hidden=\"true\"></a>\n                            </td>\n                            <td>\n                                <a target=\"_blank\" ng-href=\"{{item.banner_url}}\" class=\"glyphicon glyphicon-new-window\"\n                                    aria-hidden=\"true\"></a>\n                            </td>\n                            <td>\n                                {{item.scene}}\n                            </td>\n                            <td>\n                                <a target=\"_blank\" ng-href=\"{{item.target_link}}\" class=\"glyphicon glyphicon-new-window\"\n                                    aria-hidden=\"true\"></a>\n                            </td>\n\n                            <td>\n                                {{item.chance}}\n                            </td>\n\n\n                            <td>\n                                {{item.language_type}}\n                            </td>\n\n\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{item.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editShareImg(item, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteShareImg(item, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"11\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EmailEditorController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _emaileditor = __webpack_require__(297);
	
	var _emaileditor2 = _interopRequireDefault(_emaileditor);
	
	var _add = __webpack_require__(298);
	
	var _add2 = _interopRequireDefault(_add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmailEditorController = exports.EmailEditorController = function () {
	
	    /*@ngInject*/
	    EmailEditorController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function EmailEditorController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, EmailEditorController);
	
	        this.awesomeThings = [];
	        this.emaileditors = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(EmailEditorController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.IsHidden = false;
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/email_editor/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: {
	                        'page': 0,
	                        'size': 20
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.count;
	                        _this.totalItems = response.data.count / 2;
	                        _this.currentPage = 1;
	
	                        _this.emaileditors = response.data.data;
	                        _this.socket.syncUpdates('emaileditors', _this.emaileditors);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this2 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters);
	
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20
	            };
	            if (this.$cookies.get('token')) {
	
	                this.$http.get('/api/email_editor/', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 20;
	                        _this2.totalCount = response.data.count;
	                        _this2.totalItems = response.data.count / 2;
	                        _this2.emaileditors = response.data.data;
	                        _this2.socket.syncUpdates('emaileditors', _this2.emaileditors);
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'addSpeechType',
	        value: function addSpeechType() {
	
	            this.IsHidden = true;
	
	            this.vm = {};
	
	            this.ready = function (editor) {
	                console.log(editor);
	            };
	
	            var emaileditors = this.emaileditors;
	
	            this.save = function (myForm) {
	                if (myForm.$valid === false) {
	                    return false;
	                } else {
	                    console.log(this.vm);
	                }
	            };
	
	            this.cancel = function () {
	                this.IsHidden = false;
	            };
	        }
	    }, {
	        key: 'editSpeechType',
	        value: function editSpeechType(type, index) {
	            var emaileditors = this.emaileditors;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = _angular2.default.copy(type);
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	
	                            $http.put('/api/email_editor/' + type._id + '/', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            }).result.then(function (ret) {
	                if (ret) {
	                    emaileditors[index] = ret;
	                }
	            }, function () {});
	        }
	    }, {
	        key: 'deleteSpeechType',
	        value: function deleteSpeechType(type, index) {
	            var _this3 = this;
	
	            this.$http.delete('/api/email_editor/' + type._id + '/').then(function (response) {
	                if (response.status === 204) {
	                    _this3.emaileditors.splice(index, 1);
	                }
	            }, function (error) {
	                console.log(error);
	            });
	        }
	    }]);
	
	    return EmailEditorController;
	}();
	
	exports.default = _angular2.default.module('tttApp.emaileditor', [_angularUiRouter2.default]).config(_emaileditor2.default).component('emaileditor', {
	    template: __webpack_require__(299),
	    controller: EmailEditorController
	}).name;

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('emaileditor', {
	        url: '/emaileditor',
	        template: '<emaileditor></emaileditor>'
	    });
	}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body emaileditor\" id=\"modal-body\">\n    <form name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label for=\"name\"><span class=\"text-danger\">*</span>名称</label>\n            <input type=\"text\" class=\"form-control\" ng-model=\"vm.name\"\" name=\" name\" placeholder=\"名称\" required>\n            <span class=\"text-danger\" ng-if=\"myForm.name.$error.required && myForm.$submitted==true\">必填项</span>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"name\"><span class=\"text-danger\">*</span>内容</label>\n            <div class=\"ueditor\" ready=\"ready\" ng-model=\"vm.content\" required name=\"content\"></div>\n            <span class=\"text-danger\" ng-if=\"myForm.content.$error.required && myForm.$submitted==true\">必填项</span>\n            <!-- <input type=\"text\" class=\"form-control\" ng-model=\"vm.name\"\" name=\" name\" placeholder=\"名称\" required> -->\n            <!-- <span class=\"text-danger\" ng-if=\"myForm.name.$error.required && myForm.$submitted==true\">必填项</span> -->\n        </div>\n        <div class=\"form-group\">\n            <div class=\"text-center\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n\n\n\n\n</div>\n"

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"emaileditor\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <form name=\"myForm\" ng-submit=\"$ctrl.save(myForm)\" novalidate ng-if=\"$ctrl.IsHidden\">\n            <div class=\"form-group\">\n                <label for=\"name\"><span class=\"text-danger\">*</span>名称</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.vm.name\" name=\"name\" placeholder=\"名称\" required>\n                <span class=\"text-danger\" ng-if=\"myForm.name.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n            <div class=\"form-group\">\n                <label for=\"name\"><span class=\"text-danger\">*</span>内容</label>\n                <div class=\"ueditor\" ready=\"$ctrl.ready\" ng-model=\"$ctrl.vm.content\" required name=\"content\"></div>\n                <span class=\"text-danger\" ng-if=\"myForm.content.$error.required && myForm.$submitted==true\">必填项</span>\n                <!-- <input type=\"text\" class=\"form-control\" ng-model=\"vm.name\"\" name=\" name\" placeholder=\"名称\" required> -->\n                <!-- <span class=\"text-danger\" ng-if=\"myForm.name.$error.required && myForm.$submitted==true\">必填项</span> -->\n            </div>\n            <div class=\"form-group\">\n                <div class=\"text-center\">\n                    <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">取消</button>\n                </div>\n            </div>\n        </form>\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">邮件推送列表</h3>\n            </div>\n            <div class=\"panel-body\">\n\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"6\" class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\"\n                                    ng-click=\"$ctrl.addSpeechType()\">新增</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>名称</td>\n                            <td>内容</td>\n                            <td>推送日期</td>\n                            <td>提交时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.emaileditors track by $index\">\n                            <td>\n                                {{item._id}}\n                            </td>\n\n                            <td>\n                                {{item.name}}\n                            </td>\n                            <td>\n                                {{item.content}}\n                            </td>\n                            <td>\n                                {{item.push_date_time}}\n                            </td>\n                            <td>\n                                {{item.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.editSpeechType(type, $index)\">编辑</button>\n\n                                <button type=\"button\" class=\"btn btn-danger\"\n                                    ng-click=\"$ctrl.deleteSpeechType(type, $index)\">删除</button>\n\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"6\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n\n\n<!--<div class=\"container\">-->\n<!--<div class=\"row\">-->\n<!--<div class=\"col-lg-12\">-->\n<!--<h1 class=\"page-header\">Features:</h1>-->\n<!--<ul class=\"nav nav-tabs nav-stacked col-md-4 col-lg-4 col-sm-6\" ng-repeat=\"thing in $ctrl.awesomeThings\">-->\n<!--<li><a href=\"#\" uib-tooltip=\"{{thing.info}}\">{{thing.name}}<button type=\"button\" class=\"close\" ng-click=\"$ctrl.deleteThing(thing)\">&times;</button></a></li>-->\n<!--</ul>-->\n<!--</div>-->\n<!--</div>-->\n\n<!--<form class=\"thing-form\">-->\n<!--<label>Syncs in realtime across clients</label>-->\n<!--<p class=\"input-group\">-->\n<!--<input type=\"text\" class=\"form-control\" placeholder=\"Add a new thing here.\" ng-model=\"$ctrl.newThing\">-->\n<!--<span class=\"input-group-btn\">-->\n<!--<button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addThing()\">Add New</button>-->\n<!--</span>-->\n<!--</p>-->\n<!--</form>-->\n<!--</div>-->\n"

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StoryController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _story = __webpack_require__(301);
	
	var _story2 = _interopRequireDefault(_story);
	
	var _show = __webpack_require__(302);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _showComments = __webpack_require__(303);
	
	var _showComments2 = _interopRequireDefault(_showComments);
	
	var _addComment = __webpack_require__(304);
	
	var _addComment2 = _interopRequireDefault(_addComment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StoryController = exports.StoryController = function () {
	
	    /*@ngInject*/
	    StoryController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location', '$timeout', '$rootScope'];
	    function StoryController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout, $rootScope) {
	        _classCallCheck(this, StoryController);
	
	        this.awesomeStories = [];
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	        this.$timeout = $timeout;
	        this.$rootScope = $rootScope;
	
	        this.internal_type = {
	            1: '新',
	            2: '差',
	            3: '好',
	            4: '精选'
	        };
	
	        this.internal_type_selector = [{ value: 1, name: '新' }, { value: 2, name: '差' }, { value: 3, name: '好' }, { value: 4, name: '精选' }];
	
	        this.language_type = {
	            en: '英语',
	            pt: '葡语',
	            es: '西语'
	        };
	        this.language_type_selector = [{ value: 'en', name: '英语' }, { value: 'pt', name: '葡语' }, { value: 'es', name: '西语' }];
	
	        this.cold_datas = [{ value: '1', name: '用户发布' }, { value: '0', name: '运营发布' }];
	    }
	
	    _createClass(StoryController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/stranger_community_storys/', {
	                    header: {
	                        Accept: 'application/json',
	                        'Content-Type': 'application/json',
	                        token: this.$cookies.get('token')
	                    },
	                    params: {
	                        page: 0,
	                        size: 20,
	                        type: 'admin'
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.maxSize = 20;
	                        _this.totalCount = response.data.data.count;
	                        _this.totalItems = response.data.data.count / 2;
	                        _this.currentPage = 1;
	
	                        response.data.data.rows.forEach(function (story) {
	                            story.internal_type = _this.internal_type[story.internal_type];
	                        });
	
	                        _this.awesomeStories = response.data.data.rows;
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }, {
	        key: 'showContent',
	        value: function showContent(content, title) {
	            this.$uibModal.open({
	                template: _show2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.content = content;
	                    $scope.title = title;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'showComments',
	        value: function showComments(story) {
	            var _this2 = this;
	
	            var that = this;
	
	            return this.$http.get('/api/stranger_story_comments/', {
	                header: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json',
	                    token: this.$cookies.get('token')
	                },
	                params: {
	                    page: 0,
	                    size: 1000,
	                    story_id: story._id
	                }
	            }).then(function (response) {
	                if (response.data.data) {
	                    _this2.$uibModal.open({
	                        template: _showComments2.default,
	                        size: 'lg',
	                        /*@ngInject*/
	                        controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                            $scope.awesomeComments = response.data.data.rows;
	                            $scope.title = story.title;
	                            $scope.cancel = function () {
	                                $uibModalInstance.close();
	                            };
	                            $scope.deleteComment = function (entity) {
	                                that.$http.delete('/api/stranger_story_comments/' + entity._id).then(function (res) {
	                                    if (res.status === 204) {
	                                        $uibModalInstance.close();
	                                        that.showComments(story).then(function () {
	                                            that.search();
	                                        });
	                                    }
	                                });
	                            };
	                        }]
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'markEditorPicked',
	        value: function markEditorPicked(story) {
	            var _this3 = this;
	
	            this.$http.put('/api/stranger_community_storys/' + story._id, {
	                internal_type: 4,
	                user_id: story.user_id,
	                story_id: story._id
	            }, {
	                header: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json',
	                    token: this.$cookies.get('token')
	                }
	            }).then(function (res) {
	                if (res.data.data) {
	                    console.log(res);
	                    _this3.search();
	                }
	            });
	        }
	    }, {
	        key: 'unMarkEditorPicked',
	        value: function unMarkEditorPicked(story) {
	            var _this4 = this;
	
	            this.$http.put('/api/stranger_community_storys/' + story._id, { internal_type: 3 }, {
	                header: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json',
	                    token: this.$cookies.get('token')
	                }
	            }).then(function (res) {
	                if (res.data.data) {
	                    _this4.search();
	                }
	            });
	        }
	    }, {
	        key: 'unMarkExposure',
	        value: function unMarkExposure(story) {
	            var _this5 = this;
	
	            this.$http.put('/api/stranger_community_storys/' + story._id, { doesExposure: false }, {
	                header: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json',
	                    token: this.$cookies.get('token')
	                }
	            }).then(function (res) {
	                if (res.data.data) {
	                    _this5.search();
	                }
	            });
	        }
	    }, {
	        key: 'markExposure',
	        value: function markExposure(story) {
	            var _this6 = this;
	
	            this.$http.put('/api/stranger_community_storys/' + story._id, { doesExposure: true }, {
	                header: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json',
	                    token: this.$cookies.get('token')
	                }
	            }).then(function (res) {
	                if (res.data.data) {
	                    _this6.search();
	                }
	            });
	        }
	    }, {
	        key: 'addStoryComment',
	        value: function addStoryComment(story) {
	            var that = this;
	            this.$uibModal.open({
	                template: _addComment2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {
	                        story_id: story._id,
	                        user_id: 0
	                    };
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/stranger_story_comments', $scope.vm).then(function (response) {
	                                $uibModalInstance.close(response.data.data);
	                                that.showComments(story);
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'search',
	        value: function search(val) {
	            var _this7 = this;
	
	            if (val === true) {
	                this.currentPage = 1;
	            }
	            var payload = _angular2.default.copy(this.filters || {});
	
	            if (payload.hasOwnProperty('_id')) {
	                payload._id = parseInt(payload._id, 10);
	            }
	            if (payload.hasOwnProperty('user_id')) {
	                payload.user_id = parseInt(payload.user_id, 10);
	            }
	            if (payload.hasOwnProperty('internal_type')) {
	                payload.internal_type = parseInt(payload.internal_type, 10);
	            }
	
	            if (payload.hasOwnProperty('exposure_start')) {
	                payload.exposure_start = parseInt(payload.exposure_start, 10);
	            }
	            if (payload.hasOwnProperty('exposure_end')) {
	                payload.exposure_end = parseInt(payload.exposure_end, 10);
	            }
	
	            if (payload.hasOwnProperty('commented_start')) {
	                payload.commented_start = parseInt(payload.commented_start, 10);
	            }
	            if (payload.hasOwnProperty('commented_end')) {
	                payload.commented_end = parseInt(payload.commented_end, 10);
	            }
	
	            if (payload.hasOwnProperty('does_cold_data')) {
	                payload.does_cold_data = parseInt(payload.does_cold_data, 10);
	            }
	            var ret = {
	                filters: payload || {},
	                page: this.currentPage - 1,
	                size: 20,
	                type: 'admin'
	            };
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/stranger_community_storys/', {
	                    header: {
	                        Accept: 'application/json',
	                        'Content-Type': 'application/json',
	                        token: this.$cookies.get('token')
	                    },
	                    params: ret
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this7.maxSize = 20;
	                        _this7.totalCount = response.data.data.count;
	                        _this7.totalItems = response.data.data.count / 2;
	
	                        response.data.data.rows.forEach(function (story) {
	                            story.internal_type = _this7.internal_type[story.internal_type];
	                        });
	                        _this7.awesomeStories = response.data.data.rows;
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }]);
	
	    return StoryController;
	}();
	
	exports.default = _angular2.default.module('tttApp.story', [_angularUiRouter2.default]).config(_story2.default).component('story', {
	    template: __webpack_require__(305),
	    controller: StoryController
	}).name;

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('story', {
	        url: '/story',
	        template: '<story></story>'
	    });
	}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">{{title}}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>\n        {{content}}\n    </p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">关闭</button>\n</div>\n"

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">{{title}}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <div class=\"table-responsive\">\n        <table class=\"table table-bordered\">\n            <tr>\n                <td>comment_id</td>\n                <td>user_id</td>\n                <td>评论昵称</td>\n                <td>正文</td>\n                <td>发布时间</td>\n                <td colspan=\"2\">操作</td>\n            </tr>\n            <tr ng-repeat=\"comment in awesomeComments\">\n                <td>\n                    {{comment._id}}\n                </td>\n                <td>\n                    {{comment.user_id || 'cold data'}}\n                </td>\n                <td>\n                    {{comment.user_name}}\n                </td>\n                <td>\n                    {{comment.content}}\n                </td>\n                <td>\n                    {{comment.createdAt | date:'yyyy-MM-dd HH:mm:ss':'UTC'}}\n                </td>\n                <td>\n                    <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"deleteComment(comment)\">删除评论</button>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">关闭</button>\n</div>\n"

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>故事id</label>\n            <div class=\"col-sm-2\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.story_id\" name=\"story_id\" disabled>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>评论昵称</label>\n            <div class=\"col-sm-6\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.user_name\" name=\"user_name\" required\n                       placeholder=\"评论昵称\">\n                <span class=\"text-danger\"\n                      ng-if=\"myForm.user_name.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n            <button class=\"btn btn-primary btn-sm\" type=\"button\" ng-click=\"vm.user_name='Anonymous'\">EN</button>\n            <button class=\"btn btn-warning btn-sm\" type=\"button\" ng-click=\"vm.user_name='Anónimo'\">ES</button>\n            <button class=\"btn btn-success btn-sm\" type=\"button\" ng-click=\"vm.user_name='Anônimo'\">PT</button>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span>评论内容</label>\n            <div class=\"col-sm-10\">\n                <textarea class=\"form-control\" ng-model=\"vm.content\" name=\"content\" required minlength=\"5\"\n                          maxlength=\"5000\" rows=\"10\" cols=\"30\"\n                          placeholder=\"请填写内容\"></textarea>\n                <span class=\"text-danger\"\n                      ng-if=\"(myForm.content.$error.minlength|| myForm.content.$error.maxlength) && myForm.$submitted==true\">The value must be in range 5 to 1200!</span>\n                <span class=\"text-danger\"\n                      ng-if=\"myForm.content.$error.required && myForm.$submitted==true\">必填项</span>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n    </form>\n\n</div>\n"

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">故事列表</h3>\n            </div>\n\n            <div class=\"panel-body\">\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters._id\"\n                               placeholder=\"请输入故事id\">\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.user_id\"\n                               placeholder=\"请输入用户id\">\n                    </div>\n                    <div class=\"col-sm-2\">\n                        <select name=\"internal_type\" class=\"form-control input-sm\"\n                                ng-model=\"$ctrl.filters.internal_type\"\n                                ng-options=\"type.value as type.name for type in $ctrl.internal_type_selector\"\n                                ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">请选择故事类型</option>\n                        </select>\n                    </div>\n                    <div class=\"col-sm-2\">\n                        <select name=\"language_type\" class=\"form-control input-sm\"\n                                ng-model=\"$ctrl.filters.language_type\"\n                                ng-options=\"type.value as type.name for type in $ctrl.language_type_selector\"\n                                ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">请选择语种</option>\n                        </select>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.commented_start\"\n                               placeholder=\"请输入评论数区间起始\">\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.commented_end\"\n                               placeholder=\"请输入评论数区间终止\">\n                    </div>\n\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.exposure_start\"\n                               placeholder=\"请输入曝光量区间起始\">\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <input class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.filters.exposure_end\"\n                               placeholder=\"请输入曝光量区间终止\">\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n\n                    <div class=\"col-sm-2\">\n                        <select name=\"does_cold_data\" class=\"form-control input-sm\"\n                                ng-model=\"$ctrl.filters.does_cold_data\"\n                                ng-options=\"type.value as type.name for type in $ctrl.cold_datas\"\n                                ng-change=\"$ctrl.search(true)\"\n                        >\n                            <option value=\"\">请选择发布类型</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-left: 0\">\n                    <div class=\"criteria\">\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters._id\">\n                            故事id:{{$ctrl.filters._id}}\n                            <span class=\"close\" ng-click=\"$ctrl.filters._id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.user_id\">\n                            用户ID:{{$ctrl.filters.user_id}}\n                            <span class=\"close\" ng-click=\"$ctrl.filters.user_id=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.internal_type\">\n                            故事类型:{{$ctrl.internal_type[$ctrl.filters.internal_type]}}\n                            <span class=\"close\"\n                                  ng-click=\"$ctrl.filters.internal_type=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.language_type\">\n                            语种:{{$ctrl.language_type[$ctrl.filters.language_type]}}\n                            <span class=\"close\"\n                                  ng-click=\"$ctrl.filters.language_type=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.commented_start\">\n                            起始评论数:{{$ctrl.filters.commented_start}}\n                            <span class=\"close\"\n                                  ng-click=\"$ctrl.filters.commented_start=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.commented_end\">\n                            终止评论数:{{$ctrl.filters.commented_end}}\n                            <span class=\"close\"\n                                  ng-click=\"$ctrl.filters.commented_end=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.exposure_start\">\n                            起始曝光量:{{$ctrl.filters.exposure_start}}\n                            <span class=\"close\"\n                                  ng-click=\"$ctrl.filters.exposure_start=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.exposure_end\">\n                            终止曝光量:{{$ctrl.filters.exposure_end}}\n                            <span class=\"close\"\n                                  ng-click=\"$ctrl.filters.exposure_end=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                        <label class=\"criterion btn-primary\" ng-if=\"$ctrl.filters.does_cold_data\">\n                            发布类型:{{$ctrl.filters.does_cold_data}}\n                            <span class=\"close\"\n                                  ng-click=\"$ctrl.filters.does_cold_data=null;$ctrl.search(true)\">&times;</span>\n                        </label>\n                    </div>\n                </div>\n\n                <div class=\"table-responsive\">\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"10\">\n                                <code style=\"text-align: right\">故事总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <!--                            <td colspan=\"4\">-->\n                            <!--                                <button type=\"button\" class=\"btn btn-primary\"-->\n                            <!--                                        ng-click=\"$ctrl.exprotExcel()\">导出EXCEL-->\n                            <!--                                </button>-->\n                            <!--                            </td>-->\n                        </tr>\n                        <tr>\n                            <td>story_id</td>\n                            <td>user_id</td>\n                            <td>标题</td>\n                            <td>正文</td>\n                            <td>分享名</td>\n                            <td>年龄</td>\n                            <td>曝光量</td>\n                            <td>评论数</td>\n                            <td>点赞数</td>\n                            <td>故事类型</td>\n                            <td>语种</td>\n                            <td>是否曝光</td>\n                            <td>发布时间</td>\n                            <td colspan=\"2\">操作</td>\n                        </tr>\n                        <tr ng-repeat=\"story in $ctrl.awesomeStories track by $index\">\n                            <td>\n                                {{story._id}}\n                            </td>\n                            <td>\n                                {{story.user_id || 'cold data'}}\n                            </td>\n                            <td class=\"title\">\n                                {{story.title}}\n                            </td>\n                            <td class=\"content\" ng-click=\"$ctrl.showContent(story.content, story.title)\">\n                                {{story.content}}\n                            </td>\n                            <td>\n                                {{story.share_name}}\n                            </td>\n                            <td>\n                                {{story.age || 'not set'}}\n                            </td>\n                            <td>\n                                {{story.exposure || 0}}\n                            </td>\n                            <td>\n                                {{story.commented || 0}}\n                            </td>\n                            <td>\n                                {{story.prayed || 0}}\n                            </td>\n                            <td>\n                                {{story.internal_type}}\n                            </td>\n                            <td>\n                                {{story.language_type}}\n                            </td>\n                            <td>\n                                {{story.doesExposure}}\n                            </td>\n                            <td>\n                                {{story.createdAt | date:'yyyy-MM-dd HH:mm:ss':'UTC'}}\n                            </td>\n\n                            <td>\n                                <button ng-if=\"story.commented > 0\" type=\"button\" class=\"btn btn-success btn-sm\"\n                                        ng-click=\"$ctrl.showComments(story)\">查看评论\n                                </button>\n                                <button ng-if=\"story.internal_type !== '精选'\" type=\" button\"\n                                        class=\"btn btn-warning btn-sm\"\n                                        ng-click=\"$ctrl.markEditorPicked(story)\">设为精选\n                                </button>\n                                <button type=\" button\" class=\"btn btn-danger btn-sm\"\n                                        ng-click=\"$ctrl.addStoryComment(story)\">添加评论\n                                </button>\n                                <button ng-if=\"story.internal_type === '精选'\" type=\" button\" class=\"btn btn-info btn-sm\"\n                                        ng-click=\"$ctrl.unMarkEditorPicked(story)\">取消精选\n                                </button>\n                                <button ng-if=\"story.doesExposure === true\" type=\" button\"\n                                        class=\"btn btn-default btn-sm\"\n                                        ng-click=\"$ctrl.unMarkExposure(story)\">取消曝光\n                                </button>\n                                <button ng-if=\"story.doesExposure === false\" type=\" button\"\n                                        class=\"btn btn-warning btn-sm\"\n                                        ng-click=\"$ctrl.markExposure(story)\">曝光\n                                </button>\n                            </td>\n                        </tr>\n                        <tr class=\"text-center\">\n                            <td colspan=\"14\">\n                                <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\"\n                                    max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"\n                                    ng-change=\"$ctrl.search()\" previous-text=\"上一页\" next-text=\"下一页\" first-text=\"首页\"\n                                    last-text=\"尾页\"></ul>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n"

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdDefaultsComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adDefaults = __webpack_require__(307);
	
	var _adDefaults2 = _interopRequireDefault(_adDefaults);
	
	var _adDefaultModal = __webpack_require__(308);
	
	var _adDefaultModal2 = _interopRequireDefault(_adDefaultModal);
	
	var _FileUpload = __webpack_require__(309);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdDefaultsComponent = exports.AdDefaultsComponent = function () {
	
	  /*@ngInject*/
	  AdDefaultsComponent.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	  function AdDefaultsComponent($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	    _classCallCheck(this, AdDefaultsComponent);
	
	    this.adDefaults = [];
	
	    this.$http = $http;
	    this.socket = socket;
	    this.$uibModal = $uibModal;
	    this.$cookies = $cookies;
	    this.$cookieStore = $cookieStore;
	    this.$location = $location;
	
	    this.languageTypes = [{ value: "pt", name: "葡语" }, { value: "en", name: "英语" }, { value: "es", name: "西语" }];
	  }
	
	  _createClass(AdDefaultsComponent, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.$http.get("/api/ad_defaults?backendType=image").then(function (response) {
	        if (response.data.data) {
	          _this.adDefaults = response.data.data;
	          _this.totalCount = response.data.data.length;
	        }
	      });
	    }
	  }, {
	    key: "createOne",
	    value: function createOne() {
	      var that = this;
	      this.$uibModal.open({
	        template: _adDefaultModal2.default,
	        size: "lg",
	        /*@ngInject*/
	        controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	          $scope.vm = {};
	          $scope.cancel = function () {
	            $uibModalInstance.close();
	          };
	
	          $scope.save = function (myForm) {
	            if (myForm.$valid === false) {
	              return false;
	            } else {
	              $http.post("/api/ad_defaults", $scope.vm).then(function (response) {
	                that.$onInit();
	                $uibModalInstance.close();
	              }, function (error) {
	                console.log(error);
	              });
	            }
	          };
	
	          $scope.uploadAndGetUrl = function () {
	            that.$uibModal.open({
	              template: _FileUpload2.default,
	              size: "lg",
	              /*@ngInject*/
	              controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                $scope.vm = {};
	                $scope.isUpping = false;
	                $scope.isUppingError = false;
	                var uploader = $scope.imageUploader = new FileUploader({
	                  url: "/api/share_imgs/9528/",
	                  method: "POST",
	                  autoUpload: true
	                });
	                uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                  if (status === 200) {
	                    $scope.isUpping = false;
	                    $scope.vm.url = response.data.small_img;
	                  }
	                };
	                uploader.filters.push({
	                  name: "Filter",
	                  fn: function fn(item, options) {
	                    $scope.isUpping = true;
	                    $scope.isUppingError = false;
	                    return true;
	                  }
	                });
	                $scope.cancel = function () {
	                  $uibModalInstance.close();
	                };
	              }]
	            });
	          };
	        }]
	      });
	    }
	  }, {
	    key: "delete",
	    value: function _delete(ad) {
	      var _this2 = this;
	
	      this.$http.delete("/api/ad_defaults/" + ad._id).then(function (response) {
	        _this2.$onInit();
	      });
	    }
	  }, {
	    key: "edit",
	    value: function edit(ad) {
	      var that = this;
	      this.$uibModal.open({
	        template: _adDefaultModal2.default,
	        size: "lg",
	        /*@ngInject*/
	        controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	          $scope.vm = ad;
	          $scope.cancel = function () {
	            $uibModalInstance.close();
	          };
	
	          $scope.save = function (myForm) {
	            if (myForm.$valid === false) {
	              return false;
	            } else {
	              $http.post("/api/ad_defaults", $scope.vm).then(function (response) {
	                that.$onInit();
	                $uibModalInstance.close();
	              }, function (error) {
	                console.log(error);
	              });
	            }
	          };
	          $scope.uploadAndGetUrl = function () {
	            that.$uibModal.open({
	              template: _FileUpload2.default,
	              size: "lg",
	              /*@ngInject*/
	              controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                $scope.vm = {};
	                $scope.isUpping = false;
	                $scope.isUppingError = false;
	                var uploader = $scope.imageUploader = new FileUploader({
	                  url: "/api/share_imgs/9528/",
	                  method: "POST",
	                  autoUpload: true
	                });
	                uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                  if (status === 200) {
	                    $scope.isUpping = false;
	                    $scope.vm.url = response.data.small_img;
	                  }
	                };
	                uploader.filters.push({
	                  name: "Filter",
	                  fn: function fn(item, options) {
	                    $scope.isUpping = true;
	                    $scope.isUppingError = false;
	                    return true;
	                  }
	                });
	                $scope.cancel = function () {
	                  $uibModalInstance.close();
	                };
	              }]
	            });
	          };
	        }]
	      });
	    }
	  }]);
	
	  return AdDefaultsComponent;
	}();
	
	exports.default = _angular2.default.module("tttApp.adDefaults", [_angularUiRouter2.default]).config(_adDefaults2.default).component("adDefaults", {
	  template: __webpack_require__(310),
	  controller: AdDefaultsComponent
	}).name;

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('adDefaults', {
	        url: '/adDefaults',
	        template: '<ad-defaults></ad-defaults>'
	    });
	}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <form\n    class=\"form-horizontal\"\n    name=\"myForm\"\n    ng-submit=\"save(myForm)\"\n    novalidate\n  >\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">广告名称</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.name\"\n          name=\"name\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">包名</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.pack_name\"\n          name=\"pack_name\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">跳转链接</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.link_url\"\n          name=\"link_url\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">展示比例</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.display_ratio\"\n          name=\"display_ratio\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">国家</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.country\"\n          name=\"country\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">语言</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.language_type\"\n          name=\"language_type\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">banner</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.banner_url\"\n          name=\"banner_url\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">素材</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.img_url\"\n          name=\"img_url\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button\n          class=\"btn btn-success\"\n          type=\"button\"\n          ng-click=\"uploadAndGetUrl()\"\n        >\n          上传媒体文件并获取路径\n        </button>\n        <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">\n          取消\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">文件上传</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <form class=\"form-horizontal\" novalidate>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"\n        ><span class=\"text-danger\">*</span>媒体文件</label\n      >\n      <div class=\"col-sm-10\">\n        <input\n          type=\"file\"\n          nv-file-select\n          class=\"form-control\"\n          ng-model=\"vm.url\"\n          required\n          ng-click=\"clearQuene()\"\n          uploader=\"imageUploader\"\n        />\n        <span class=\"text-danger\" ng-if=\"isUpping\">上传中...</span>\n        <span class=\"text-danger\" ng-if=\"isUppingError\">格式不正确</span>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">路径</label>\n      <div class=\"col-sm-10\">\n        <input\n          id=\"url\"\n          class=\"form-control text-success\"\n          type=\"text\"\n          ng-model=\"vm.url\"\n          disabled\n        />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button\n          class=\"btn btn-success\"\n          ngclipboard\n          data-clipboard-text=\"{{vm.url}}\"\n          type=\"button\"\n          ng-click=\"cancel()\"\n        >\n          复制地址\n        </button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n          取消\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n  <!--class=\"hero-unit\"-->\n  <div class=\"container-fluid\">\n    <div class=\"panel panel-info\" style=\"margin-top: 20px\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">广告默认投放</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered\">\n            <tr>\n              <td colspan=\"2\">\n                <code style=\"text-align: right\"\n                  >总数：{{$ctrl.totalCount}}</code\n                >\n              </td>\n              <td colspan=\"1\">\n                <button class=\"btn btn-primary\" ng-click=\"$ctrl.createOne()\">\n                  新建\n                </button>\n              </td>\n            </tr>\n            <tr>\n              <td>ID</td>\n              <td>广告名称</td>\n              <td>包名</td>\n              <td>跳转链接</td>\n              <td>展示比例</td>\n              <td style=\"background-color: #08acee\">点击量</td>\n              <td style=\"background-color: chartreuse\">浏览量</td>\n              <td>国家</td>\n              <td>语言</td>\n              <td>banner</td>\n              <td>素材</td>\n              <td>添加时间</td>\n              <td>修改时间</td>\n              <td>操作</td>\n            </tr>\n            <tr ng-repeat=\"item in $ctrl.adDefaults track by $index\">\n              <td>{{item._id}}</td>\n              <td>{{item.name}}</td>\n              <td class=\"longText\">{{item.pack_name}}</td>\n              <td class=\"longText\">{{item.link_url}}</td>\n\n              <td>{{item.display_ratio}}</td>\n              <td style=\"color: #08acee\">{{item.clicks}}</td>\n              <td style=\"color: rgb(56, 110, 1)\">{{item.views}}</td>\n\n              <td>{{item.country}}</td>\n\n              <td>{{item.language_type}}</td>\n              <td>\n                <a\n                  ng-if=\"item.banner_url\"\n                  target=\"_blank\"\n                  ng-href=\"{{item.banner_url}}\"\n                  class=\"glyphicon glyphicon-new-window\"\n                  aria-hidden=\"true\"\n                ></a>\n              </td>\n              <td>\n                <a\n                  ng-if=\"item.img_url\"\n                  target=\"_blank\"\n                  ng-href=\"{{item.img_url}}\"\n                  class=\"glyphicon glyphicon-new-window\"\n                  aria-hidden=\"true\"\n                ></a>\n              </td>\n\n              <td>{{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}</td>\n              <td>{{item.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}</td>\n              <td>\n                <button\n                  class=\"btn btn-warning\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.edit(item)\"\n                >\n                  编辑\n                </button>\n                <button\n                  class=\"btn btn-danger\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.delete(item)\"\n                >\n                  删除\n                </button>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n"

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdDefaultsComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adDefaults = __webpack_require__(312);
	
	var _adDefaults2 = _interopRequireDefault(_adDefaults);
	
	var _adDefaultModal = __webpack_require__(313);
	
	var _adDefaultModal2 = _interopRequireDefault(_adDefaultModal);
	
	var _FileUpload = __webpack_require__(309);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdDefaultsComponent = exports.AdDefaultsComponent = function () {
	
	  /*@ngInject*/
	  AdDefaultsComponent.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	  function AdDefaultsComponent($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	    _classCallCheck(this, AdDefaultsComponent);
	
	    this.adDefaults = [];
	
	    this.$http = $http;
	    this.socket = socket;
	    this.$uibModal = $uibModal;
	    this.$cookies = $cookies;
	    this.$cookieStore = $cookieStore;
	    this.$location = $location;
	
	    this.languageTypes = [{ value: "pt", name: "葡语" }, { value: "en", name: "英语" }, { value: "es", name: "西语" }];
	  }
	
	  _createClass(AdDefaultsComponent, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.$http.get("/api/ad_defaults?backendType=video").then(function (response) {
	        if (response.data.data) {
	          _this.adDefaults = response.data.data;
	          _this.totalCount = response.data.data.length;
	        }
	      });
	    }
	  }, {
	    key: "createOne",
	    value: function createOne() {
	      var that = this;
	      this.$uibModal.open({
	        template: _adDefaultModal2.default,
	        size: "lg",
	        /*@ngInject*/
	        controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	          $scope.vm = {};
	          $scope.cancel = function () {
	            $uibModalInstance.close();
	          };
	
	          $scope.save = function (myForm) {
	            if (myForm.$valid === false) {
	              return false;
	            } else {
	              $http.post("/api/ad_defaults", $scope.vm).then(function (response) {
	                that.$onInit();
	                $uibModalInstance.close();
	              }, function (error) {
	                console.log(error);
	              });
	            }
	          };
	
	          $scope.uploadAndGetUrl = function () {
	            that.$uibModal.open({
	              template: _FileUpload2.default,
	              size: "lg",
	              /*@ngInject*/
	              controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                $scope.vm = {};
	                $scope.isUpping = false;
	                $scope.isUppingError = false;
	                var uploader = $scope.imageUploader = new FileUploader({
	                  url: "/api/share_imgs/9528/",
	                  method: "POST",
	                  autoUpload: true
	                });
	                uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                  if (status === 200) {
	                    $scope.isUpping = false;
	                    $scope.vm.url = response.data.small_img;
	                  }
	                };
	                uploader.filters.push({
	                  name: "Filter",
	                  fn: function fn(item, options) {
	                    $scope.isUpping = true;
	                    $scope.isUppingError = false;
	                    return true;
	                  }
	                });
	                $scope.cancel = function () {
	                  $uibModalInstance.close();
	                };
	              }]
	            });
	          };
	        }]
	      });
	    }
	  }, {
	    key: "delete",
	    value: function _delete(ad) {
	      var _this2 = this;
	
	      this.$http.delete("/api/ad_defaults/" + ad._id).then(function (response) {
	        _this2.$onInit();
	      });
	    }
	  }, {
	    key: "edit",
	    value: function edit(ad) {
	      var that = this;
	      this.$uibModal.open({
	        template: _adDefaultModal2.default,
	        size: "lg",
	        /*@ngInject*/
	        controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	          $scope.vm = ad;
	          $scope.cancel = function () {
	            $uibModalInstance.close();
	          };
	
	          $scope.save = function (myForm) {
	            if (myForm.$valid === false) {
	              return false;
	            } else {
	              $http.post("/api/ad_defaults", $scope.vm).then(function (response) {
	                that.$onInit();
	                $uibModalInstance.close();
	              }, function (error) {
	                console.log(error);
	              });
	            }
	          };
	          $scope.uploadAndGetUrl = function () {
	            that.$uibModal.open({
	              template: _FileUpload2.default,
	              size: "lg",
	              /*@ngInject*/
	              controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                $scope.vm = {};
	                $scope.isUpping = false;
	                $scope.isUppingError = false;
	                var uploader = $scope.imageUploader = new FileUploader({
	                  url: "/api/share_imgs/9528/",
	                  method: "POST",
	                  autoUpload: true
	                });
	                uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                  if (status === 200) {
	                    $scope.isUpping = false;
	                    $scope.vm.url = response.data.small_img;
	                  }
	                };
	                uploader.filters.push({
	                  name: "Filter",
	                  fn: function fn(item, options) {
	                    $scope.isUpping = true;
	                    $scope.isUppingError = false;
	                    return true;
	                  }
	                });
	                $scope.cancel = function () {
	                  $uibModalInstance.close();
	                };
	              }]
	            });
	          };
	        }]
	      });
	    }
	  }]);
	
	  return AdDefaultsComponent;
	}();
	
	exports.default = _angular2.default.module("tttApp.adDefaultsVideo", [_angularUiRouter2.default]).config(_adDefaults2.default).component("adDefaultsVideo", {
	  template: __webpack_require__(314),
	  controller: AdDefaultsComponent
	}).name;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	"use strict";
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("adDefaultsVideo", {
	    url: "/adDefaultsVideo",
	    template: "<ad-defaults-video></ad-defaults-video>"
	  });
	}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <form\n    class=\"form-horizontal\"\n    name=\"myForm\"\n    ng-submit=\"save(myForm)\"\n    novalidate\n  >\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">广告名称</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.name\"\n          name=\"name\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">包名</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.pack_name\"\n          name=\"pack_name\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">跳转链接</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.link_url\"\n          name=\"link_url\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">展示比例</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.display_ratio\"\n          name=\"display_ratio\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">国家</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.country\"\n          name=\"country\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">语言</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.language_type\"\n          name=\"language_type\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">banner</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.banner_url\"\n          name=\"banner_url\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">素材</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.img_url\"\n          name=\"img_url\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">google play跳转地址</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.play_url\"\n          name=\"play_url\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">视频播放地址</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"input\"\n          class=\"form-control\"\n          ng-model=\"vm.video_url\"\n          name=\"video_url\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">视频高度</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"number\"\n          class=\"form-control\"\n          ng-model=\"vm.video_height\"\n          name=\"video_height\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">视频宽度</label>\n      <div class=\"col-sm-10\">\n        <input\n          type=\"number\"\n          class=\"form-control\"\n          ng-model=\"vm.video_width\"\n          name=\"video_width\"\n          placeholder=\"\"\n        />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button\n          class=\"btn btn-success\"\n          type=\"button\"\n          ng-click=\"uploadAndGetUrl()\"\n        >\n          上传媒体文件并获取路径\n        </button>\n        <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">\n          取消\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n  <!--class=\"hero-unit\"-->\n  <div class=\"container-fluid\">\n    <div class=\"panel panel-info\" style=\"margin-top: 20px\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">广告默认投放（视频）</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered\">\n            <tr>\n              <td colspan=\"2\">\n                <code style=\"text-align: right\"\n                  >总数：{{$ctrl.totalCount}}</code\n                >\n              </td>\n              <td colspan=\"1\">\n                <button class=\"btn btn-primary\" ng-click=\"$ctrl.createOne()\">\n                  新建\n                </button>\n              </td>\n            </tr>\n            <tr>\n              <td>ID</td>\n              <td>广告名称</td>\n              <td>包名</td>\n              <td>跳转链接</td>\n              <td>展示比例</td>\n              <td style=\"background-color: #08acee\">点击量</td>\n              <td style=\"background-color: chartreuse\">浏览量</td>\n              <td>国家</td>\n              <td>语言</td>\n              <td>banner</td>\n              <td>素材</td>\n              <td>添加时间</td>\n              <td>修改时间</td>\n              <td>google play跳转地址</td>\n              <td>视频播放地址</td>\n              <td>视频宽度</td>\n              <td>视频高度</td>\n              <td>操作</td>\n            </tr>\n            <tr ng-repeat=\"item in $ctrl.adDefaults track by $index\">\n              <td>{{item._id}}</td>\n              <td>{{item.name}}</td>\n              <td class=\"longText\">{{item.pack_name}}</td>\n              <td class=\"longText\">{{item.link_url}}</td>\n\n              <td>{{item.display_ratio}}</td>\n              <td style=\"color: #08acee\">{{item.clicks}}</td>\n              <td style=\"color: rgb(56, 110, 1)\">{{item.views}}</td>\n\n              <td>{{item.country}}</td>\n\n              <td>{{item.language_type}}</td>\n              <td>\n                <a\n                  ng-if=\"item.banner_url\"\n                  target=\"_blank\"\n                  ng-href=\"{{item.banner_url}}\"\n                  class=\"glyphicon glyphicon-new-window\"\n                  aria-hidden=\"true\"\n                ></a>\n              </td>\n              <td>\n                <a\n                  ng-if=\"item.img_url\"\n                  target=\"_blank\"\n                  ng-href=\"{{item.img_url}}\"\n                  class=\"glyphicon glyphicon-new-window\"\n                  aria-hidden=\"true\"\n                ></a>\n              </td>\n\n              <td>{{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}</td>\n              <td>{{item.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}</td>\n              <td class=\"longText\">{{item.play_url}}</td>\n              <td>\n                <a\n                  ng-if=\"item.video_url\"\n                  target=\"_blank\"\n                  ng-href=\"{{item.video_url}}\"\n                  class=\"glyphicon glyphicon-new-window\"\n                  aria-hidden=\"true\"\n                ></a>\n              </td>\n              <td>{{item.video_width}}</td>\n              <td>{{item.video_height}}</td>\n              <td>\n                <button\n                  class=\"btn btn-warning\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.edit(item)\"\n                >\n                  编辑\n                </button>\n                <button\n                  class=\"btn btn-danger\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.delete(item)\"\n                >\n                  删除\n                </button>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n"

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdDefaultStatComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adDefaultStat = __webpack_require__(316);
	
	var _adDefaultStat2 = _interopRequireDefault(_adDefaultStat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(132);
	
	var uiRouter = __webpack_require__(144);
	
	var AdDefaultStatComponent = exports.AdDefaultStatComponent = function () {
	
	  /*@ngInject*/
	  AdDefaultStatComponent.$inject = ['$http', '$location', '$cookies'];
	  function AdDefaultStatComponent($http, $location, $cookies) {
	    _classCallCheck(this, AdDefaultStatComponent);
	
	    this.filters = {
	      begin: new Date("2021-01-01"),
	      end: new Date("2021-02-15")
	    };
	    this.sort = {
	      key: "views",
	      value: "1"
	    };
	    this.array = [];
	
	    this.message = "Hello";
	    this.$location = $location;
	    this.$cookies = $cookies;
	    this.$http = $http;
	  }
	
	  _createClass(AdDefaultStatComponent, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.filters.begin = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
	      this.filters.end = new Date();
	      this.search();
	    }
	  }, {
	    key: "search",
	    value: function search() {
	      var _this = this;
	
	      if (this.$cookies.get("token")) {
	        this.$http.get("/api/ad_defaults/stat", {
	          header: {
	            Accept: "application/json",
	            "Content-Type": "application/json",
	            token: this.$cookies.get("token")
	          },
	          params: this.filters
	        }).then(function (response) {
	          if (response.data.data) {
	            _this.array = response.data.data;
	            _this.$sort();
	          }
	        });
	      } else {
	        this.$location.path("main");
	      }
	    }
	  }, {
	    key: "$sort",
	    value: function $sort() {
	      var _this2 = this;
	
	      this.array.sort(function (a, b) {
	        if (Number(_this2.sort.value) > 0) {
	          return b[_this2.sort.key] - a[_this2.sort.key];
	        }
	        return a[_this2.sort.key] - b[_this2.sort.key];
	      });
	    }
	  }]);
	
	  return AdDefaultStatComponent;
	}();
	
	exports.default = angular.module("tttApp.adDefaultStat", [uiRouter]).config(_adDefaultStat2.default).component("adDefaultStat", {
	  template: __webpack_require__(317),
	  controller: AdDefaultStatComponent,
	  controllerAs: "adDefaultStatCtrl"
	}).name;

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('adDefaultStat', {
	    url: '/adDefaultStat',
	    template: '<ad-default-stat></ad-default-stat>'
	  });
	}];

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports = "<header>\n  <!--class=\"hero-unit\"-->\n  <div class=\"container-fluid\">\n    <div class=\"panel panel-info\" style=\"margin-top: 20px\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">默认广告投放统计列表</h3>\n      </div>\n\n      <div class=\"panel-body\">\n        <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px\">\n          <div class=\"col-sm-3\">\n            <div class=\"input-group\">\n              <input\n                class=\"form-control\"\n                uib-datepicker-popup\n                clear-text=\"Clear\"\n                close-on-date-selection=\"true\"\n                close-text=\"Done\"\n                current-text=\"Today\"\n                is-open=\"adDefaultStatCtrl.beginPopOpen\"\n                ng-model=\"adDefaultStatCtrl.filters.begin\"\n                type=\"text\"\n                datepicker-options=\"dateOptions\"\n                placeholder=\"统计日期起始\"\n              />\n              <span class=\"input-group-btn\">\n                <button\n                  type=\"button\"\n                  class=\"btn btn-default\"\n                  ng-click=\"adDefaultStatCtrl.beginPopOpen=true\"\n                >\n                  <i class=\"glyphicon glyphicon-calendar\"></i>\n                </button>\n              </span>\n            </div>\n          </div>\n          <div class=\"col-sm-3\">\n            <div class=\"input-group\">\n              <input\n                class=\"form-control\"\n                uib-datepicker-popup\n                clear-text=\"Clear\"\n                close-on-date-selection=\"true\"\n                close-text=\"Done\"\n                current-text=\"Today\"\n                is-open=\"adDefaultStatCtrl.endPopOpen\"\n                ng-model=\"adDefaultStatCtrl.filters.end\"\n                type=\"text\"\n                datepicker-options=\"dateOptions\"\n                placeholder=\"统计日期截止\"\n              />\n              <span class=\"input-group-btn\">\n                <button\n                  type=\"button\"\n                  class=\"btn btn-default\"\n                  ng-click=\"adDefaultStatCtrl.endPopOpen=true\"\n                >\n                  <i class=\"glyphicon glyphicon-calendar\"></i>\n                </button>\n              </span>\n            </div>\n          </div>\n          <div class=\"col-sm-3\">\n            <button\n              class=\"btn btn-sm btn-danger btn-o\"\n              ng-click=\"adDefaultStatCtrl.search(true)\"\n            >\n              搜索\n            </button>\n          </div>\n        </div>\n\n        <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px\">\n          <div class=\"col-sm-3\">\n            <div>\n              <input\n                style=\"margin-right: 5px\"\n                name=\"options-key\"\n                ng-control=\"options-key\"\n                type=\"radio\"\n                value=\"views\"\n                ng-model=\"adDefaultStatCtrl.sort.key\"\n                ng-click=\"adDefaultStatCtrl.$sort()\"\n              />\n              <span style=\"margin-right: 20px\"> 按浏览量排序</span>\n\n              <input\n                style=\"margin-right: 5px\"\n                name=\"options-key\"\n                ng-control=\"options-key\"\n                type=\"radio\"\n                value=\"clicks\"\n                ng-model=\"adDefaultStatCtrl.sort.key\"\n                ng-click=\"adDefaultStatCtrl.$sort()\"\n              />\n              <span style=\"margin-right: 20px\"> 按点击量排序</span>\n            </div>\n            <div>\n              <input\n                style=\"margin-right: 5px\"\n                name=\"options\"\n                ng-control=\"options\"\n                type=\"radio\"\n                value=\"1\"\n                ng-model=\"adDefaultStatCtrl.sort.value\"\n                ng-click=\"adDefaultStatCtrl.$sort()\"\n              />\n              <span style=\"margin-right: 20px\"> 正序</span>\n\n              <input\n                style=\"margin-right: 5px\"\n                name=\"options\"\n                ng-control=\"options\"\n                type=\"radio\"\n                value=\"-1\"\n                ng-model=\"adDefaultStatCtrl.sort.value\"\n                ng-click=\"adDefaultStatCtrl.$sort()\"\n              />\n              <span style=\"margin-right: 20px\"> 倒序</span>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered\">\n            <tr>\n              <td>ID</td>\n              <td>广告名称</td>\n              <td>包名</td>\n              <td>跳转链接</td>\n              <td>展示比例</td>\n              <td style=\"background-color: #08acee\">点击量</td>\n              <td style=\"background-color: chartreuse\">浏览量</td>\n              <td>国家</td>\n              <td>语言</td>\n              <td>banner</td>\n              <td>素材</td>\n              <td>添加时间</td>\n              <td>修改时间</td>\n            </tr>\n            <tr ng-repeat=\"item in adDefaultStatCtrl.array track by $index\">\n              <td>{{item._id}}</td>\n              <td>{{item.name}}</td>\n              <td class=\"longText\">{{item.pack_name}}</td>\n              <td class=\"longText\">{{item.link_url}}</td>\n\n              <td>{{item.display_ratio}}</td>\n              <td style=\"color: #08acee\">{{item.clicks}}</td>\n              <td style=\"color: rgb(56, 110, 1)\">{{item.views}}</td>\n\n              <td>{{item.country}}</td>\n\n              <td>{{item.language_type}}</td>\n              <td>\n                <a\n                  ng-if=\"item.banner_url\"\n                  target=\"_blank\"\n                  ng-href=\"{{item.banner_url}}\"\n                  class=\"glyphicon glyphicon-new-window\"\n                  aria-hidden=\"true\"\n                ></a>\n              </td>\n              <td>\n                <a\n                  ng-if=\"item.img_url\"\n                  target=\"_blank\"\n                  ng-href=\"{{item.img_url}}\"\n                  class=\"glyphicon glyphicon-new-window\"\n                  aria-hidden=\"true\"\n                ></a>\n              </td>\n              <td>{{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}</td>\n              <td>{{item.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}</td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n"

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AdAggregationComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adAggregationModel = __webpack_require__(319);
	
	var _adAggregationModel2 = _interopRequireDefault(_adAggregationModel);
	
	var _adAggregation = __webpack_require__(320);
	
	var _adAggregation2 = _interopRequireDefault(_adAggregation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(132);
	
	var uiRouter = __webpack_require__(144);
	
	var AdAggregationComponent = exports.AdAggregationComponent = function () {
	
	    /*@ngInject*/
	    AdAggregationComponent.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function AdAggregationComponent($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, AdAggregationComponent);
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(AdAggregationComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.totalCount = 0;
	            this.$http.get('/api/ad-aggregations').then(function (response) {
	                if (response.data.data) {
	                    _this.adDefaults = response.data.data;
	                    _this.totalCount = response.data.data.length;
	                }
	            });
	        }
	    }, {
	        key: 'createOne',
	        value: function createOne() {
	            var that = this;
	            this.$uibModal.open({
	                template: _adAggregationModel2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                    $scope.vm = {};
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/ad-aggregations', $scope.vm).then(function (response) {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	
	                    $scope.uploadAndGetUrl = function () {
	                        that.$uibModal.open({
	                            template: fu,
	                            size: 'lg',
	                            /*@ngInject*/
	                            controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                                $scope.vm = {};
	                                $scope.isUpping = false;
	                                $scope.isUppingError = false;
	                                var uploader = $scope.imageUploader = new FileUploader({
	                                    url: '/api/share_imgs/9528/',
	                                    method: 'POST',
	                                    autoUpload: true
	                                });
	                                uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                                    if (status === 200) {
	                                        $scope.isUpping = false;
	                                        $scope.vm.url = response.data.small_img;
	                                    }
	                                };
	                                uploader.filters.push({
	                                    name: 'Filter',
	                                    fn: function fn(item, options) {
	                                        if (item.type.indexOf('image') !== -1) {
	                                            $scope.isUpping = true;
	                                            $scope.isUppingError = false;
	                                            return true;
	                                        } else {
	                                            $scope.isUppingError = true;
	                                            return false;
	                                        }
	                                    }
	                                });
	                                $scope.cancel = function () {
	                                    $uibModalInstance.close();
	                                };
	                            }]
	                        });
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(ad) {
	            var _this2 = this;
	
	            this.$http.delete('/api/ad-aggregations/' + ad._id).then(function (response) {
	                _this2.$onInit();
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(ad) {
	            var that = this;
	            this.$uibModal.open({
	                template: _adAggregationModel2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                    $scope.vm = ad;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/ad-aggregations', $scope.vm).then(function (response) {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                }]
	            });
	        }
	    }]);
	
	    return AdAggregationComponent;
	}();
	
	exports.default = angular.module('tttApp.ad-aggregation', [uiRouter]).config(_adAggregation2.default).component('adAggregation', {
	    template: __webpack_require__(321),
	    controller: AdAggregationComponent
	}).name;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">单元位置</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.location\" name=\"location\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">国家</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.country\" name=\"country\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">渠道</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.channel\" name=\"channel\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">值</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.value\" name=\"value\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">类型</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.type\" name=\"type\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">单元定义</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.definition\" name=\"definition\"\n                       placeholder=\"\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n\n    </form>\n</div>\n"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('ad-aggregation', {
	        url: '/ad-aggregation',
	        template: '<ad-aggregation></ad-aggregation>'
	    });
	}];

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">广告聚合</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"1\">\n                                <button class=\"btn btn-primary\" ng-click=\"$ctrl.createOne()\">新建</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>单元位置</td>\n                            <td>国家</td>\n                            <td>渠道</td>\n                            <td>值</td>\n                            <td>广告类型</td>\n                            <td>单元定义</td>\n                            <td>添加时间</td>\n                            <td>修改时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.adDefaults track by $index\">\n                            <td>{{item._id}}</td>\n                            <td>{{item.location}}</td>\n                            <td>{{item.country}}</td>\n                            <td>{{item.channel}}</td>\n                            <td>{{item.value}}</td>\n                            <td>{{item.type}}</td>\n                            <td>{{item.definition}}</td>\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd':'UTC'}}\n                            </td>\n                            <td>\n                                {{item.updatedAt | date:'yyyy-MM-dd':'UTC'}}\n                            </td>\n                            <td>\n                                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.edit(item)\">编辑</button>\n                                <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.delete(item)\">删除</button>\n                            </td>\n\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.QuizComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quizModel = __webpack_require__(323);
	
	var _quizModel2 = _interopRequireDefault(_quizModel);
	
	var _quiz = __webpack_require__(324);
	
	var _quiz2 = _interopRequireDefault(_quiz);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(132);
	
	var uiRouter = __webpack_require__(144);
	
	var QuizComponent = exports.QuizComponent = function () {
	
	    /*@ngInject*/
	    QuizComponent.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function QuizComponent($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, QuizComponent);
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.language_type_selector = [{ value: 'en', name: '英语' }, { value: 'pt', name: '葡语' }, { value: 'es', name: '西语' }];
	
	        this.filters = {
	            language_type: 'en'
	        };
	    }
	
	    _createClass(QuizComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.totalCount = 0;
	            this.search();
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this = this;
	
	            if (!this.filters.language_type) {
	                this.filters.language_type = 'en';
	            }
	            this.$http.get('/api/quizs/backstage', {
	                params: this.filters
	            }).then(function (response) {
	                if (response.data.data) {
	                    _this.adDefaults = response.data.data;
	                    _this.totalCount = response.data.data.length;
	                }
	            });
	        }
	    }, {
	        key: 'createOne',
	        value: function createOne() {
	            var that = this;
	            this.$uibModal.open({
	                template: _quizModel2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/quizs', $scope.vm).then(function (response) {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(ad) {
	            var _this2 = this;
	
	            this.$http.delete('/api/quizs/' + ad._id).then(function (response) {
	                _this2.$onInit();
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(ad) {
	            var that = this;
	            this.$uibModal.open({
	                template: _quizModel2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                    $scope.vm = ad;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/quizs', $scope.vm).then(function (response) {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                }]
	            });
	        }
	    }]);
	
	    return QuizComponent;
	}();
	
	exports.default = angular.module('tttApp.quiz', [uiRouter]).config(_quiz2.default).component('quiz', {
	    template: __webpack_require__(325),
	    controller: QuizComponent
	}).name;

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" noValidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">问题</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.title\" name=\"title\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">选项</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.select_option\" name=\"select_option\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">答案</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.answer\" name=\"answer\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">等级</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.level\" name=\"level\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">VERSION</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.quiz_version\" name=\"quiz_version\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">语种</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.language_type\" name=\"language_type\"\n                       placeholder=\"\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n\n    </form>\n</div>\n"

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('quiz', {
	    url: '/quiz',
	    template: '<quiz></quiz>'
	  });
	}];

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">Quiz</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-sm-2\">\n                        <select name=\"language_type\" class=\"form-control input-sm\"\n                                ng-model=\"$ctrl.filters.language_type\"\n                                ng-options=\"type.value as type.name for type in $ctrl.language_type_selector\"\n                                ng-change=\"$ctrl.search(true)\">\n                            <option value=\"\">请选择语种</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"$ctrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"1\">\n                                <button class=\"btn btn-primary\" ng-click=\"$ctrl.createOne()\">新建</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>问题</td>\n                            <td>选项</td>\n                            <td>答案</td>\n                            <td>等级</td>\n                            <td>VERSION</td>\n                            <td>语言</td>\n                            <td>添加时间</td>\n                            <td>修改时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.adDefaults track by $index\">\n                            <td>{{item._id}}</td>\n                            <td>{{item.title}}</td>\n                            <td>{{item.select_option}}</td>\n                            <td>{{item.answer}}</td>\n                            <td>{{item.level}}</td>\n                            <td>{{item.quiz_version}}</td>\n                            <td>{{item.language_type}}</td>\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd':'UTC'}}\n                            </td>\n                            <td>\n                                {{item.updatedAt | date:'yyyy-MM-dd':'UTC'}}\n                            </td>\n                            <td>\n                                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.edit(item)\">编辑</button>\n                                <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.delete(item)\">删除</button>\n                            </td>\n\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tttApp.constants', []).constant('appConfig', __webpack_require__(327)).name;

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin']
	};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tttApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Socket.$inject = ['socketFactory'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(173);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socket = __webpack_require__(331);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function Socket(socketFactory) {
	  'ngInject';
	
	  var ioSocket = (0, _socket2.default)('', {
	    path: '/socket.io-client'
	  });
	
	  var socket = socketFactory({
	    ioSocket: ioSocket
	  });
	
	  return {
	    socket: socket,
	
	    syncUpdates: function syncUpdates(modelName, array, cb) {
	      cb = cb || _angular2.default.noop;
	
	      socket.on(modelName + ':save', function (item) {
	        var oldItem = _.find(array, {
	          _id: item._id
	        });
	        var index = array.indexOf(oldItem);
	        var event = 'created';
	
	        if (oldItem) {
	          array.splice(index, 1, item);
	          event = 'updated';
	        } else {
	          array.push(item);
	        }
	
	        cb(event, item, array);
	      });
	
	      socket.on(modelName + ':remove', function (item) {
	        var event = 'deleted';
	        _.remove(array, {
	          _id: item._id
	        });
	        cb(event, item, array);
	      });
	    },
	    unsyncUpdates: function unsyncUpdates(modelName) {
	      socket.removeAllListeners(modelName + ':save');
	      socket.removeAllListeners(modelName + ':remove');
	    }
	  };
	}
	
	exports.default = _angular2.default.module('tttApp.socket', []).factory('socket', Socket).name;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(332);
	var parser = __webpack_require__(337);
	var Manager = __webpack_require__(346);
	var debug = __webpack_require__(334)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(346);
	exports.Socket = __webpack_require__(376);


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(333);
	var debug = __webpack_require__(334)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),
/* 334 */
[682, 335],
/* 335 */
[683, 336],
/* 336 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(338)('socket.io-parser');
	var json = __webpack_require__(341);
	var Emitter = __webpack_require__(342);
	var binary = __webpack_require__(343);
	var isBuf = __webpack_require__(345);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(339);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(340);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(240);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(174)(module), (function() { return this; }())))

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(344);
	var isBuf = __webpack_require__(345);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(347);
	var Socket = __webpack_require__(376);
	var Emitter = __webpack_require__(377);
	var parser = __webpack_require__(337);
	var on = __webpack_require__(379);
	var bind = __webpack_require__(380);
	var debug = __webpack_require__(334)('socket.io-client:manager');
	var indexOf = __webpack_require__(374);
	var Backoff = __webpack_require__(381);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(348);


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(349);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(356);


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(350);
	var Emitter = __webpack_require__(364);
	var debug = __webpack_require__(368)('engine.io-client:socket');
	var index = __webpack_require__(374);
	var parser = __webpack_require__(356);
	var parseuri = __webpack_require__(333);
	var parsejson = __webpack_require__(375);
	var parseqs = __webpack_require__(365);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(355);
	Socket.transports = __webpack_require__(350);
	Socket.parser = __webpack_require__(356);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(351);
	var XHR = __webpack_require__(353);
	var JSONP = __webpack_require__(371);
	var websocket = __webpack_require__(372);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(352);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(351);
	var Polling = __webpack_require__(354);
	var Emitter = __webpack_require__(364);
	var inherit = __webpack_require__(366);
	var debug = __webpack_require__(368)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(355);
	var parseqs = __webpack_require__(365);
	var parser = __webpack_require__(356);
	var inherit = __webpack_require__(366);
	var yeast = __webpack_require__(367);
	var debug = __webpack_require__(368)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(351);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(356);
	var Emitter = __webpack_require__(364);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(357);
	var hasBinary = __webpack_require__(358);
	var sliceBuffer = __webpack_require__(359);
	var after = __webpack_require__(360);
	var utf8 = __webpack_require__(361);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(362);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(363);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(344);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(174)(module), (function() { return this; }())))

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),
/* 363 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 368 */
[682, 369],
/* 369 */
[683, 370],
/* 370 */
336,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(354);
	var inherit = __webpack_require__(366);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(355);
	var parser = __webpack_require__(356);
	var parseqs = __webpack_require__(365);
	var inherit = __webpack_require__(366);
	var yeast = __webpack_require__(367);
	var debug = __webpack_require__(368)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(373);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 373 */
238,
/* 374 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(337);
	var Emitter = __webpack_require__(377);
	var toArray = __webpack_require__(378);
	var on = __webpack_require__(379);
	var bind = __webpack_require__(380);
	var debug = __webpack_require__(334)('socket.io-client:socket');
	var hasBin = __webpack_require__(358);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),
/* 377 */
364,
/* 378 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StoryStatComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _storyStat = __webpack_require__(383);
	
	var _storyStat2 = _interopRequireDefault(_storyStat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(132);
	
	var uiRouter = __webpack_require__(144);
	
	var StoryStatComponent = exports.StoryStatComponent = function () {
	
	    /*@ngInject*/
	    StoryStatComponent.$inject = ['$http', '$location', '$cookies'];
	    function StoryStatComponent($http, $location, $cookies) {
	        _classCallCheck(this, StoryStatComponent);
	
	        this.filters = {
	            begin: new Date('2021-01-01'),
	            end: new Date('2021-02-15'),
	            language_type: 'en'
	        };
	        this.array = [];
	
	        this.message = 'Hello';
	        this.$location = $location;
	        this.$cookies = $cookies;
	        this.language_type_selector = [{ value: 'en', name: '英语' }, { value: 'pt', name: '葡语' }, { value: 'es', name: '西语' }];
	        this.$http = $http;
	    }
	
	    _createClass(StoryStatComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.search();
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/stranger_community_storys/statistics', {
	                    header: {
	                        Accept: 'application/json',
	                        'Content-Type': 'application/json',
	                        token: this.$cookies.get('token')
	                    },
	                    params: this.filters
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.array = response.data.data;
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	        }
	    }]);
	
	    return StoryStatComponent;
	}();
	
	exports.default = angular.module('tttApp.storyStat', [uiRouter]).config(_storyStat2.default).component('storyStat', {
	    template: __webpack_require__(384),
	    controller: StoryStatComponent,
	    controllerAs: 'storyStatCtrl'
	}).name;

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('storyStat', {
	    url: '/storyStat',
	    template: '<story-stat></story-stat>'
	  });
	}];

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">故事统计列表</h3>\n            </div>\n\n            <div class=\"panel-body\">\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-sm-3\">\n                        <div class=\"input-group\">\n                            <input\n                                    class=\"form-control\"\n                                    uib-datepicker-popup\n                                    clear-text=\"Clear\"\n                                    close-on-date-selection=\"true\"\n                                    close-text=\"Done\"\n                                    current-text=\"Today\"\n                                    is-open=\"storyStatCtrl.beginPopOpen\"\n                                    ng-model=\"storyStatCtrl.filters.begin\"\n                                    type=\"text\"\n                                    datepicker-options=\"dateOptions\"\n                                    placeholder=\"请输入注册起始日期\"\n                            />\n                            <span class=\"input-group-btn\">\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"storyStatCtrl.beginPopOpen=true\">\n                        <i class=\"glyphicon glyphicon-calendar\"></i>\n                    </button>\n                        </span>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-3\">\n                        <div class=\"input-group\">\n                            <input\n                                    class=\"form-control\"\n                                    uib-datepicker-popup\n                                    clear-text=\"Clear\"\n                                    close-on-date-selection=\"true\"\n                                    close-text=\"Done\"\n                                    current-text=\"Today\"\n                                    is-open=\"storyStatCtrl.endPopOpen\"\n                                    ng-model=\"storyStatCtrl.filters.end\"\n                                    type=\"text\"\n                                    datepicker-options=\"dateOptions\"\n                                    placeholder=\"请输入注册截止日期\"\n                            />\n                            <span class=\"input-group-btn\">\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"storyStatCtrl.endPopOpen=true\">\n                        <i class=\"glyphicon glyphicon-calendar\"></i>\n                    </button>\n                        </span>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-3\">\n                        <select name=\"language_type\" class=\"form-control input-sm\"\n                                ng-model=\"storyStatCtrl.filters.language_type\"\n                                ng-options=\"type.value as type.name for type in storyStatCtrl.language_type_selector\"\n                        >\n                            <option value=\"\">请选择语种</option>\n                        </select>\n                    </div>\n                </div>\n\n                <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px;\">\n                    <div class=\"col-xs-2\">\n                        <button class=\"btn btn-sm btn-danger btn-o\" ng-click=\"storyStatCtrl.search(true)\">搜索\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"table-responsive\">\n                    <table class=\"table table-bordered table\">\n                        <tr>\n                            <td>日期</td>\n                            <td>故事数</td>\n                            <td>评论数</td>\n                            <td>点赞数</td>\n                        </tr>\n                        <tr ng-repeat=\"story in storyStatCtrl.array track by $index\">\n                            <td>\n                                {{story.date}}\n                            </td>\n                            <td>\n                                {{story.story}}\n                            </td>\n                            <td>\n                                {{story.comment}}\n                            </td>\n                            <td>\n                                {{story.pray}}\n                            </td>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n\n"

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AppSwitchComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _appSwitchModel = __webpack_require__(386);
	
	var _appSwitchModel2 = _interopRequireDefault(_appSwitchModel);
	
	var _appSwitch = __webpack_require__(387);
	
	var _appSwitch2 = _interopRequireDefault(_appSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(132);
	
	var uiRouter = __webpack_require__(144);
	
	var AppSwitchComponent = exports.AppSwitchComponent = function () {
	    /*@ngInject*/
	    AppSwitchComponent.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function AppSwitchComponent($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, AppSwitchComponent);
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	    }
	
	    _createClass(AppSwitchComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.totalCount = 0;
	            this.search();
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this = this;
	
	            this.$http.get('/api/utills/app-switchs', {
	                params: this.filters
	            }).then(function (response) {
	                if (response.data.data) {
	                    _this.adDefaults = response.data.data;
	                    _this.totalCount = response.data.data.length;
	                }
	            });
	        }
	    }, {
	        key: 'createOne',
	        value: function createOne() {
	            var that = this;
	            this.$uibModal.open({
	                template: _appSwitchModel2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = {};
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/utills/app-switchs', $scope.vm).then(function (response) {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(ad) {
	            var _this2 = this;
	
	            this.$http.delete('/api/utills/app-switchs/' + ad.id).then(function (response) {
	                _this2.$onInit();
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(ad) {
	            var that = this;
	            this.$uibModal.open({
	                template: _appSwitchModel2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.vm = ad;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/utills/app-switchs', $scope.vm).then(function (response) {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                }]
	            });
	        }
	    }]);
	
	    return AppSwitchComponent;
	}();
	
	exports.default = angular.module('tttApp.app-switch', [uiRouter]).config(_appSwitch2.default).component('appSwitch', {
	    template: __webpack_require__(388),
	    controller: AppSwitchComponent
	}).name;

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" noValidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">id</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.id\" name=\"id\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">状态</label>\n            <div class=\"col-sm-10 form-group\">\n                <label class=\"col-sm-1 control-label\">开</label>\n                <div class=\"col-sm-2\">\n                    <input type=\"radio\" class=\"form-control\" ng-model=\"vm.status\" name=\"status\"\n                           placeholder=\"\" value=\"opened\">\n                </div>\n                <label class=\"col-sm-1 control-label\">关</label>\n                <div class=\"col-sm-2\">\n                    <input type=\"radio\" class=\"form-control\" ng-model=\"vm.status\" name=\"status\"\n                           placeholder=\"\" value=\"closed\">\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">描述</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.description\" name=\"description\"\n                       placeholder=\"\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n\n    </form>\n</div>\n"

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app-switch', {
	    url: '/app-switch',
	    template: '<app-switch></app-switch>'
	  });
	}];

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">Quiz</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"1\">\n                                <button class=\"btn btn-primary\" ng-click=\"$ctrl.createOne()\">新建</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>状态</td>\n                            <td>描述</td>\n                            <td>添加时间</td>\n                            <td>修改时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.adDefaults track by $index\">\n                            <td>{{item.id}}</td>\n                            <td>{{item.status}}</td>\n                            <td>{{item.description}}</td>\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd':'UTC'}}\n                            </td>\n                            <td>\n                                {{item.updatedAt | date:'yyyy-MM-dd':'UTC'}}\n                            </td>\n                            <td>\n                                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.edit(item)\">编辑</button>\n                                <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.delete(item)\">删除</button>\n                            </td>\n\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CommonImagesCenterComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _commonImagesModel = __webpack_require__(390);
	
	var _commonImagesModel2 = _interopRequireDefault(_commonImagesModel);
	
	var _FileUpload = __webpack_require__(309);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	var _commonImagesCenter = __webpack_require__(391);
	
	var _commonImagesCenter2 = _interopRequireDefault(_commonImagesCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(132);
	
	var uiRouter = __webpack_require__(144);
	
	var CommonImagesCenterComponent = exports.CommonImagesCenterComponent = function () {
	    /*@ngInject*/
	    CommonImagesCenterComponent.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function CommonImagesCenterComponent($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, CommonImagesCenterComponent);
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	        this.api = '/api/common-images-centers';
	    }
	
	    _createClass(CommonImagesCenterComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.$http.get(this.api).then(function (response) {
	                if (response.data.data) {
	                    _this.columns = response.data.data;
	                    _this.totalCount = response.data.data.length;
	                }
	            });
	        }
	    }, {
	        key: 'createOne',
	        value: function createOne() {
	            var that = this;
	            this.$uibModal.open({
	                template: _commonImagesModel2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.title = '新建';
	                    $scope.vm = {};
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post(that.api, $scope.vm).then(function () {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	
	                    $scope.uploadAndGetUrl = that.uploadAndGetUrl(that, $scope.vm);
	                }]
	            });
	        }
	    }, {
	        key: 'uploadAndGetUrl',
	        value: function uploadAndGetUrl(which, rewrite) {
	            return function () {
	                return which.$uibModal.open({
	                    template: _FileUpload2.default,
	                    size: 'lg',
	                    /*@ngInject*/
	                    controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                        $scope.vm = {};
	                        $scope.isUpping = false;
	                        $scope.isUppingError = false;
	                        var uploader = $scope.imageUploader = new FileUploader({
	                            url: '/api/share_imgs/9528/',
	                            method: 'POST',
	                            autoUpload: true
	                        });
	                        uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                            if (status === 200) {
	                                $scope.isUpping = false;
	                                $scope.vm.url = response.data.small_img;
	                            }
	                        };
	                        uploader.filters.push({
	                            name: 'Filter',
	                            fn: function fn(item, options) {
	                                $scope.vm.size = item.size;
	                                $scope.vm.type = item.type;
	                                if (item.type.indexOf('image') !== -1) {
	                                    $scope.isUpping = true;
	                                    $scope.isUppingError = false;
	                                    return true;
	                                } else {
	                                    $scope.isUppingError = true;
	                                    return false;
	                                }
	                            }
	                        });
	                        $scope.cancel = function () {
	                            $uibModalInstance.close();
	                        };
	                        $scope.back = function () {
	                            var img = document.getElementById('uploader');
	                            console.log(img.naturalWidth, img.naturalHeight);
	                            if (img.naturalWidth > 0 && img.naturalHeight > 0) {
	                                Object.assign(rewrite, $scope.vm);
	                                $uibModalInstance.close();
	                            } else {
	                                alert('正在获取大小');
	                            }
	                        };
	                        $scope.showInfo = function () {
	                            var img = document.getElementById('uploader');
	                            if (img.naturalWidth > 0 && img.naturalHeight > 0) {
	                                $scope.vm.naturalWidth = img.naturalWidth;
	                                $scope.vm.naturalHeight = img.naturalHeight;
	                            }
	                        };
	                    }]
	                });
	            };
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(ad) {
	            var _this2 = this;
	
	            this.$http.delete(this.api + '/' + ad._id).then(function () {
	                _this2.$onInit();
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(ad) {
	            var that = this;
	            this.$uibModal.open({
	                template: _commonImagesModel2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.title = '编辑';
	                    $scope.vm = ad;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post(that.api, $scope.vm).then(function () {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                    $scope.uploadAndGetUrl = that.uploadAndGetUrl(that, $scope.vm);
	                }]
	            });
	        }
	    }]);
	
	    return CommonImagesCenterComponent;
	}();
	
	exports.default = angular.module('tttApp.common-images-center', [uiRouter]).config(_commonImagesCenter2.default).component('commonImagesCenter', {
	    template: __webpack_require__(392),
	    controller: CommonImagesCenterComponent
	}).name;

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">{{title}}</h3>\n</div>;\n<div class=\"modal-body\" id=\"modal-body\">\n    <form class=\"form-horizontal\" name=\"myForm\" ng-submit=\"save(myForm)\" novalidate>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">唯一标识符</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.uuid\" name=\"uuid\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">所属类别</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.category\" name=\"category\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">地址</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.url\" name=\"url\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">图片类型</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.type\" name=\"type\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">大小</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.size\" name=\"size\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">宽度</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.naturalWidth\" name=\"naturalWidth\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">长度</label>\n            <div class=\"col-sm-10\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"vm.naturalHeight\" name=\"naturalHeight\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">国家</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.country\" name=\"country\"\n                       placeholder=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">语言</label>\n            <div class=\"col-sm-10\">\n                <input type=\"input\" class=\"form-control\" ng-model=\"vm.language_type\" name=\"language_type\"\n                       placeholder=\"\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"col-sm-offset-2 col-sm-10\">\n                <button class=\"btn btn-success\" type=\"button\" ng-click=\"uploadAndGetUrl()\">上传并获取图片路径</button>\n                <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">取消</button>\n            </div>\n        </div>\n\n    </form>\n</div>;\n"

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('common-images-center', {
	        url: '/common-images-center',
	        template: '<common-images-center></common-images-center>'
	    });
	}];

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">图片中心</h3>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"table-responsive\">\n\n                    <table class=\"table table-bordered\">\n                        <tr>\n                            <td colspan=\"2\">\n                                <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                            </td>\n                            <td colspan=\"1\">\n                                <button class=\"btn btn-primary\" ng-click=\"$ctrl.createOne()\">新建</button>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>ID</td>\n                            <td>唯一标识符</td>\n                            <td>所属类别</td>\n                            <td>地址</td>\n                            <td>图片类型</td>\n                            <td>大小</td>\n                            <td>宽度</td>\n                            <td>长度</td>\n                            <td>国家</td>\n                            <td>语言</td>\n                            <td>添加时间</td>\n                            <td>修改时间</td>\n                            <td>操作</td>\n                        </tr>\n                        <tr ng-repeat=\"item in $ctrl.columns track by $index\">\n                            <td>\n                                {{item._id}}\n                            </td>\n                            <td>\n                                {{item.uuid || '-'}}\n                            </td>\n\n                            <td>\n                                {{item.category}}\n                            </td>\n\n                            <td>\n                                <a target=\"_blank\" ng-href=\"{{item.url}}\"\n                                   class=\"glyphicon glyphicon-new-window\"\n                                   aria-hidden=\"true\"></a>\n                            </td>\n\n                            <td>\n                                {{item.type}}\n                            </td>\n                            <td>\n                                {{item.size}}\n                            </td>\n                            <td>\n                                {{item.naturalWidth}}\n                            </td>\n                            <td>\n                                {{item.naturalHeight}}\n                            </td>\n\n                            <td>\n                                {{item.country}}\n                            </td>\n\n                            <td>\n                                {{item.language_type}}\n                            </td>\n\n                            <td>\n                                {{item.createdAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                {{item.updatedAt | date:'yyyy-MM-dd hh:mm:ss a':'UTC'}}\n                            </td>\n                            <td>\n                                <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.edit(item)\">编辑</button>\n                                <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.delete(item)\">删除</button>\n                            </td>\n\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SurveyController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(132);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(144);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _complaint = __webpack_require__(394);
	
	var _complaint2 = _interopRequireDefault(_complaint);
	
	var _show = __webpack_require__(395);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SurveyController = exports.SurveyController = function () {
	
	    /*@ngInject*/
	    SurveyController.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function SurveyController($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, SurveyController);
	
	        this.awesomeThings = [];
	        this.surveys = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        $scope.$on('$destroy', function () {
	            socket.unsyncUpdates('survey');
	        });
	    }
	
	    _createClass(SurveyController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.$cookies.get('token')) {
	                this.$http.get('/api/utils/complaint', {
	                    header: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json',
	                        'token': this.$cookies.get('token')
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this.surveys = response.data.data;
	                        _this.surveys.forEach(function (s) {
	                            return s.complaint_key = key_to_text(s.complaint_key);
	                        });
	                        _this.totalCount = _this.surveys.length;
	                    }
	                });
	            } else {
	                this.$location.path('main');
	            }
	
	            function key_to_text(key) {
	                switch (key) {
	                    case 1:
	                        return '信息流评论';
	                    case 2:
	                        return '社区故事';
	                    case 3:
	                        return '社区评论';
	                    case 4:
	                        return '圣经文本评论';
	                }
	            }
	        }
	    }, {
	        key: 'checkTarget',
	        value: function checkTarget(complaint) {
	            var _this2 = this;
	
	            this.$http.get('/api/utils/complaint/' + complaint._id, {
	                header: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/json',
	                    'token': this.$cookies.get('token')
	                }
	            }).then(function (res) {
	                var data = res.data.data;
	                _this2.$uibModal.open({
	                    template: _show2.default,
	                    size: 'lg',
	                    /*@ngInject*/
	                    controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                        $scope.data = data;
	                        $scope.cancel = function () {
	                            $uibModalInstance.close();
	                        };
	                    }]
	                });
	            });
	        }
	    }]);
	
	    return SurveyController;
	}();
	
	exports.default = _angular2.default.module('tttApp.complaint', [_angularUiRouter2.default]).config(_complaint2.default).component('complaint', {
	    template: __webpack_require__(396),
	    controller: SurveyController
	}).name;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('complaint', {
	        url: '/complaint',
	        template: '<complaint></complaint>'
	    });
	}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">被举报条目</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <div>\n        <span class=\"i-label\">发布用户：</span>\n        <span class=\"i-label\">{{data.user_id}}</span>\n    </div>\n    <div>\n        <div class=\"i-label\">发布内容：</div>\n        <div class=\"i-content\">{{data.content}}</div>\n    </div>\n    <div>\n        <span class=\"i-label\">发布日期：</span>\n        <span class=\"i-label\">{{data.createdAt | date:'yyyy-MM-dd HH:mm:ss':'UTC'}}</span>\n    </div>\n    <div>\n        <div class=\"i-label\">举报留言：</div>\n        <div class=\"i-content\">{{data.complaint}}</div>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">关闭</button>\n</div>\n"

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n    <!--class=\"hero-unit\"-->\n    <div class=\"container-fluid\">\n        <div class=\"panel panel-info\" style=\"margin-top: 20px;\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">用户举报信息</h3>\n            </div>\n            <div class=\"panel-body\">\n                <table class=\"table table-bordered\">\n                    <tr>\n                        <td colspan=\"5\">\n                            <code style=\"text-align: right\">总数：{{$ctrl.totalCount}}</code>\n                        </td>\n                    </tr>\n                    <tr class=\"iHeader\">\n                        <td>举报人</td>\n                        <td>类型</td>\n                        <td>被举报条目id</td>\n                        <td>日期</td>\n                        <td>操作</td>\n                    </tr>\n                    <tr ng-repeat=\"survey in $ctrl.surveys track by $index\">\n                        <td>\n                            {{survey.user_id}}\n                        </td>\n                        <td>\n                            {{survey.complaint_key}}\n                        </td>\n                        <td>\n                            {{survey.target_data_id}}\n                        </td>\n                        <td>\n                            {{survey.createdAt | date:'yyyy-MM-dd HH:mm:ss':'UTC'}}\n                        </td>\n                        <td class=\"text-center\">\n                            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.checkTarget(survey)\">\n                                查看该条目\n                            </button>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n\n\n    </div>\n</header>\n"

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UbaComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _uba = __webpack_require__(398);
	
	var _uba2 = _interopRequireDefault(_uba);
	
	var _show = __webpack_require__(399);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _add = __webpack_require__(400);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _editOneday = __webpack_require__(401);
	
	var _editOneday2 = _interopRequireDefault(_editOneday);
	
	var _editSilent = __webpack_require__(402);
	
	var _editSilent2 = _interopRequireDefault(_editSilent);
	
	var _editPray = __webpack_require__(403);
	
	var _editPray2 = _interopRequireDefault(_editPray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(132);
	
	var uiRouter = __webpack_require__(144);
	var _ = __webpack_require__(173);
	
	var UbaComponent = exports.UbaComponent = function () {
	    /*@ngInject*/
	    UbaComponent.$inject = ['$http', '$scope', 'socket', '$uibModal', '$cookies', '$cookieStore', '$location'];
	    function UbaComponent($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
	        _classCallCheck(this, UbaComponent);
	
	        this.filters = {
	            language_type: 'en',
	            trinity: 'oneday',
	            date: new Date()
	        };
	        this.uba = {};
	        this.currentPage = 1;
	        this.point = {};
	
	        this.$http = $http;
	        this.socket = socket;
	        this.$uibModal = $uibModal;
	        this.$cookies = $cookies;
	        this.$cookieStore = $cookieStore;
	        this.$location = $location;
	
	        this.language_type_selector = [{ value: '', name: '选择语言' }, { value: 'en', name: '英语' }, { value: 'pt', name: '葡语' }, { value: 'es', name: '西语' }, { value: 'de', name: '德语' }, { value: 'fr', name: '法语' }, { value: 'zh_hans', name: '中简' }, { value: 'zh_hant', name: '中繁' }];
	        this.trinity_selector = [{ value: '', name: '选择内容类型' }, { value: 'oneday', name: '阅读' }, { value: 'silent', name: '默想' }, { value: 'pray', name: '祷告' }];
	        this.pointName = {
	            dailyVerse_read: 'verse点击率',
	            Share_DailyVerse_Click: 'verse分享率',
	            Share_DailyVerse_Image_Click: 'verse图片分享率',
	            Share_DailyVerse_Text_click: 'verse文字分享率',
	            verse_Show: 'verse展示率',
	            pray_start_button: 'verse祷告开始率',
	            pray_share_meditation: 'meditation分享率',
	            pray_share_pray: 'pray分享率',
	            NewPray_Amen: 'Amen率'
	        };
	    }
	
	    _createClass(UbaComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.search();
	        }
	    }, {
	        key: 'showContent',
	        value: function showContent(content, title) {
	            this.$uibModal.open({
	                template: _show2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', function controller($scope, $http, $uibModalInstance) {
	                    $scope.content = content;
	                    $scope.title = title;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'createOne',
	        value: function createOne() {
	            var that = this;
	            this.$uibModal.open({
	                template: _add2.default,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                    $scope.vm = {
	                        date_no: 'Day',
	                        language_type_selector: that.language_type_selector,
	                        language_type: ''
	                    };
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/ubas/trinity', {
	                                type: 'create',
	                                filters: that.filters,
	                                entity: $scope.vm
	                            }).then(function (response) {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var template = void 0;
	            switch (this.filters.trinity) {
	                case 'oneday':
	                    template = _editOneday2.default;
	                    break;
	                case 'silent':
	                    template = _editSilent2.default;
	                    break;
	                case 'pray':
	                    template = _editPray2.default;
	                    break;
	
	                default:
	                    break;
	            }
	            var that = this;
	            this.$uibModal.open({
	                template: template,
	                size: 'lg',
	                /*@ngInject*/
	                controller: ['$scope', '$http', '$uibModalInstance', 'FileUploader', function controller($scope, $http, $uibModalInstance, FileUploader) {
	                    $scope.vm = item;
	                    $scope.cancel = function () {
	                        $uibModalInstance.close();
	                    };
	
	                    $scope.save = function (myForm) {
	                        if (myForm.$valid === false) {
	                            return false;
	                        } else {
	                            $http.post('/api/ubas/trinity', {
	                                type: 'edit',
	                                filters: that.filters,
	                                entity: $scope.vm
	                            }).then(function (response) {
	                                that.$onInit();
	                                $uibModalInstance.close();
	                            }, function (error) {
	                                console.log(error);
	                            });
	                        }
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(ad) {
	            var _this = this;
	
	            this.$http.delete('/api/ad_defaults/' + ad._id).then(function (response) {
	                _this.$onInit();
	            });
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this2 = this;
	
	            if (this.filters.trinity && this.filters.language_type) {
	                this.$http.get('/api/ubas/trinity', {
	                    params: {
	                        page: this.currentPage - 1,
	                        size: 10,
	                        date: this.filters.date,
	                        trinity: this.filters.trinity,
	                        language_type: this.filters.language_type
	                    }
	                }).then(function (response) {
	                    if (response.data.data) {
	                        _this2.maxSize = 10;
	                        _this2.totalCount = response.data.data.count;
	                        _this2.totalItems = response.data.data.count;
	
	                        _this2.array = response.data.data.rows;
	                        _this2.uba = response.data.data.uba;
	                        _this2.getAllTrinity();
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'computePoint',
	        value: function computePoint() {
	            console.log(this.uba, '+++++++++');
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Object.keys(this.uba)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var ubaKey = _step.value;
	
	                    if (this.uba[ubaKey] !== 'sumCount' && !_.isEmpty(this.uba[ubaKey].numerator) && this.uba[ubaKey].denominator) {
	                        var Share_DailyVerse = 0;
	                        var _iteratorNormalCompletion2 = true;
	                        var _didIteratorError2 = false;
	                        var _iteratorError2 = undefined;
	
	                        try {
	                            for (var _iterator2 = this.uba[ubaKey].numerator[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                var ubaData = _step2.value;
	
	                                ubaData.name_zh = this.pointName[ubaData.name];
	                                if (ubaData.name === 'Share_DailyVerse_Image_Click' || ubaData.name === 'Share_DailyVerse_Text_click') {
	                                    Share_DailyVerse += ubaData.count;
	                                }
	                                ubaData.percentage = (ubaData.count / this.uba[ubaKey].denominator * 100).toFixed(2) + '%';
	                                ubaData.percentageNum = ubaData.count + ' / ' + this.uba[ubaKey].denominator;
	                            }
	                        } catch (err) {
	                            _didIteratorError2 = true;
	                            _iteratorError2 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                    _iterator2.return();
	                                }
	                            } finally {
	                                if (_didIteratorError2) {
	                                    throw _iteratorError2;
	                                }
	                            }
	                        }
	
	                        var Share_DailyVerse_Click = {
	                            name: 'Share_DailyVerse_Click',
	                            count: Share_DailyVerse,
	                            percentage: (Share_DailyVerse / this.uba[ubaKey].denominator * 100).toFixed(2) + '%',
	                            name_zh: 'verse分享率',
	                            percentageNum: Share_DailyVerse + ' / ' + this.uba[ubaKey].denominator
	                        };
	                        this.uba[ubaKey].numerator.push(Share_DailyVerse_Click);
	                        var verse_Show = {
	                            name: 'verse_Show',
	                            count: this.uba[ubaKey].denominator,
	                            percentage: (this.uba[ubaKey].denominator / this.uba.sumCount * 100).toFixed(2) + '%',
	                            name_zh: 'verse展示率',
	                            percentageNum: this.uba[ubaKey].denominator + ' / ' + this.uba.sumCount
	                        };
	                        this.uba[ubaKey].numerator.push(verse_Show);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            console.log('ubaData+++++++++', this.uba);
	        }
	    }, {
	        key: 'getAllTrinity',
	        value: function getAllTrinity() {
	            var _this3 = this;
	
	            this.$http.get('/api/ubas/trinity/queryAllInfo/v1.0', {
	                params: {
	                    date: this.filters.date,
	                    trinity: this.filters.trinity,
	                    language_type: this.filters.language_type
	                }
	            }).then(function (allTrinityInfo) {
	                _this3.uba.sumCount = allTrinityInfo.data.data.length;
	            }).then(function () {
	                _this3.computePoint();
	            });
	        }
	    }]);
	
	    return UbaComponent;
	}();
	
	exports.default = angular.module('tttApp.uba', [uiRouter]).config(_uba2.default).component('uba', {
	    template: __webpack_require__(404),
	    controller: UbaComponent
	}).name;

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('uba', {
	    url: '/uba',
	    template: '<uba></uba>'
	  });
	}];

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">{{title}}</h3>\n</div>\n<div class=\"modal-body\" style=\"line-break: normal\">\n  <p>{{content}}</p>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">\n    关闭\n  </button>\n</div>\n"

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">新增</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <form\n    class=\"form-horizontal\"\n    name=\"myForm\"\n    ng-submit=\"save(myForm)\"\n    novalidate\n  >\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        语言\n      </label>\n      <div class=\"col-sm-6\">\n        <select\n          name=\"language_type\"\n          class=\"form-control\"\n          ng-model=\"vm.language_type\"\n          ng-options=\"type.value as type.name for type in vm.language_type_selector\"\n        ></select>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        日期序号\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.date_no\"\n          name=\"date_no\"\n        />\n      </div>\n      <div class=\"col-sm-4\">示例：Day12</div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        章名\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.chapter\"\n          name=\"chapter\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        章id\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.chapter_id\"\n          name=\"chapter_id\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        节\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.space\"\n          name=\"space\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        from\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.from\"\n          name=\"from\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        to\n      </label>\n      <div class=\"col-sm-6\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.to\" name=\"to\" />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        from_to\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.from_to\"\n          name=\"from_to\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        ab测试\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.abTest\"\n          name=\"abTest\"\n        />\n      </div>\n      <div class=\"col-sm-4\">默认分组：A</div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        标签\n      </label>\n      <div class=\"col-sm-6\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.tag\" name=\"tag\" />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        默想内容\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.silent\"\n          name=\"silent\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"> 祷告标题 </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.pray_title\"\n          name=\"pray_title\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        祷告内容\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.pray_content\"\n          name=\"pray_content\"\n        />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">\n          取消\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">编辑One Day</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <form\n    class=\"form-horizontal\"\n    name=\"myForm\"\n    ng-submit=\"save(myForm)\"\n    novalidate\n  >\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        章名\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.chapter\"\n          name=\"chapter\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        章id\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.chapter_id\"\n          name=\"chapter_id\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        节\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.space\"\n          name=\"space\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        from\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.from\"\n          name=\"from\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        to\n      </label>\n      <div class=\"col-sm-6\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.to\" name=\"to\" />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        from_to\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.from_to\"\n          name=\"from_to\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        ab测试\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.abTest\"\n          name=\"abTest\"\n        />\n      </div>\n      <div class=\"col-sm-4\">默认分组：A</div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        标签\n      </label>\n      <div class=\"col-sm-6\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.tag\" name=\"tag\" />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">\n          取消\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">编辑默想</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <form\n    class=\"form-horizontal\"\n    name=\"myForm\"\n    ng-submit=\"save(myForm)\"\n    novalidate\n  >\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        ab测试\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.abTest\"\n          name=\"abTest\"\n        />\n      </div>\n      <div class=\"col-sm-4\">默认分组：A</div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        标签\n      </label>\n      <div class=\"col-sm-6\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.tag\" name=\"tag\" />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        默想内容\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.content\"\n          name=\"content\"\n        />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">\n          取消\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">编辑pray</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <form\n    class=\"form-horizontal\"\n    name=\"myForm\"\n    ng-submit=\"save(myForm)\"\n    novalidate\n  >\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        ab测试\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.abTest\"\n          name=\"abTest\"\n        />\n      </div>\n      <div class=\"col-sm-4\">默认分组：A</div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        标签\n      </label>\n      <div class=\"col-sm-6\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.tag\" name=\"tag\" />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"> 祷告标题 </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.title\"\n          name=\"title\"\n        />\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"text-danger\">*</span>\n        祷告内容\n      </label>\n      <div class=\"col-sm-6\">\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          ng-model=\"vm.content\"\n          name=\"content\"\n        />\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button class=\"btn btn-primary\" type=\"submit\">提交</button>\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">\n          取消\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports = "<header id=\"banner\">\n  <!--class=\"hero-unit\"-->\n  <div class=\"container-fluid\">\n    <div class=\"panel panel-info\" style=\"margin-top: 20px\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">读想祷配置</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px\">\n          <div class=\"col-sm-3\">\n            <select\n              name=\"language_type\"\n              class=\"form-control\"\n              ng-model=\"$ctrl.filters.language_type\"\n              ng-options=\"type.value as type.name for type in $ctrl.language_type_selector\"\n              ng-change=\"$ctrl.search(true)\"\n            ></select>\n          </div>\n          <div class=\"col-sm-3\">\n            <select\n              name=\"language_type\"\n              class=\"form-control\"\n              ng-model=\"$ctrl.filters.trinity\"\n              ng-options=\"type.value as type.name for type in $ctrl.trinity_selector\"\n              ng-change=\"$ctrl.search(true)\"\n            ></select>\n          </div>\n          <div class=\"col-sm-3\">\n            <div class=\"input-group\">\n              <input\n                class=\"form-control\"\n                uib-datepicker-popup\n                clear-text=\"Clear\"\n                close-on-date-selection=\"true\"\n                close-text=\"Done\"\n                current-text=\"Today\"\n                is-open=\"adDefaultStatCtrl.beginPopOpen\"\n                ng-model=\"$ctrl.filters.date\"\n                type=\"text\"\n                datepicker-options=\"dateOptions\"\n                placeholder=\"统计日期\"\n                ng-change=\"$ctrl.search(true)\"\n                ng-model-options=\"{timezone: 'utc'}\"\n              />\n              <span class=\"input-group-btn\">\n                <button\n                  type=\"button\"\n                  class=\"btn btn-default\"\n                  ng-click=\"adDefaultStatCtrl.beginPopOpen=true\"\n                >\n                  <i class=\"glyphicon glyphicon-calendar\"></i>\n                </button>\n              </span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\" style=\"margin-bottom: 20px; margin-left: -15px\"></div>\n        <div class=\"table-responsive\">\n          <table class=\"table table-bordered\">\n            <tr>\n              <td colspan=\"2\">\n                <code style=\"text-align: right\"\n                  >总数：{{$ctrl.totalCount}}</code\n                >\n              </td>\n              <td colspan=\"1\">\n                <button class=\"btn btn-primary\" ng-click=\"$ctrl.createOne()\">\n                  新建\n                </button>\n              </td>\n            </tr>\n\n            <tr ng-if=\"$ctrl.filters.trinity === 'oneday'\">\n              <td>数据序号</td>\n              <td>uba</td>\n              <td>日期序号</td>\n              <td>章名</td>\n              <td>章id</td>\n              <td>节</td>\n              <td>from</td>\n              <td>to</td>\n              <td>from_to</td>\n              <td>abTest</td>\n              <!-- <td>指定日期</td> -->\n              <!-- <td>指定早晚</td> -->\n              <!-- <td>创建</td> -->\n              <td>修改</td>\n              <td>标签</td>\n              <td>操作</td>\n            </tr>\n            <tr\n              ng-if=\"$ctrl.filters.trinity === 'oneday'\"\n              ng-repeat=\"item in $ctrl.array track by $index\"\n            >\n              <td>{{item._id}}</td>\n              <td>\n                <table class=\"table table-bordered\" style=\"margin-bottom: 0%\">\n                  <tr\n                    ng-repeat=\"uba in $ctrl.uba[item.uba].numerator track by $index\"\n                  >\n                    <td style=\"color: rgb(124, 6, 6); font-weight: bold\">\n                      {{uba.name_zh}}\n                    </td>\n                    <td style=\"color: green; font-weight: bold\">\n                      {{uba.percentage}}\n                    </td>\n                    <td>\n                      {{ uba.percentageNum }}\n                    </td>\n                  </tr>\n                </table>\n              </td>\n              <td>{{item.dates}}</td>\n              <td>{{item.chapter}}</td>\n              <td>{{item.chapter_id}}</td>\n              <td>{{item.space}}</td>\n              <td>{{item.from}}</td>\n              <td>{{item.to}}</td>\n              <td>{{item.from_to}}</td>\n              <td>{{item.abTest}}</td>\n              <!-- <td>{{item.specDate}}</td> -->\n              <!-- <td>{{item.specTime}}</td> -->\n              <!-- <td>{{item.createdAt | date:'yyyy-MM-dd':'UTC'}}</td> -->\n              <td>{{item.updatedAt | date:'yyyy-MM-dd':'UTC'}}</td>\n              <td>{{item.tag}}</td>\n              <td>\n                <button\n                  class=\"btn btn-warning\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.edit(item)\"\n                >\n                  编辑\n                </button>\n                <button\n                  class=\"btn btn-danger\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.delete(item)\"\n                >\n                  删除\n                </button>\n              </td>\n            </tr>\n\n            <tr ng-if=\"$ctrl.filters.trinity === 'silent'\">\n              <td>数据序号</td>\n              <td>uba</td>\n              <td>日期序号</td>\n              <td>内容</td>\n              <td>abTest</td>\n              <!-- <td>指定日期</td> -->\n              <!-- <td>指定早晚</td> -->\n              <!-- <td>创建</td> -->\n              <td>修改</td>\n              <td>标签</td>\n              <td>操作</td>\n            </tr>\n            <tr\n              ng-if=\"$ctrl.filters.trinity === 'silent'\"\n              ng-repeat=\"item in $ctrl.array track by $index\"\n            >\n              <td>{{item._id}}</td>\n              <td>\n                <table class=\"table table-bordered table-sm\" style=\"margin-bottom: 0%\">\n                  <tr\n                    ng-repeat=\"uba in $ctrl.uba[item.uba].numerator track by $index\"\n                  >\n                    <td style=\"color: rgb(124, 6, 6); font-weight: bold\">\n                      {{uba.name_zh}}\n                    </td>\n                    <td style=\"color: green; font-weight: bold\">\n                      {{uba.percentage}}\n                    </td>\n                    <td>\n                      {{ uba.percentageNum }}\n                    </td>\n                  </tr>\n                </table>\n              </td>\n              <td>{{item.prayer_date}}</td>\n              <td\n                class=\"content\"\n                ng-click=\"$ctrl.showContent(item.content, '默想')\"\n              >\n                {{item.content}}\n              </td>\n              <td>{{item.abTest}}</td>\n              <!-- <td>{{item.specDate}}</td> -->\n              <!-- <td>{{item.specTime}}</td> -->\n              <!-- <td>{{item.createdAt | date:'yyyy-MM-dd':'UTC'}}</td> -->\n              <td>{{item.updatedAt | date:'yyyy-MM-dd':'UTC'}}</td>\n              <td>{{item.tag}}</td>\n              <td>\n                <button\n                  class=\"btn btn-warning\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.edit(item)\"\n                >\n                  编辑\n                </button>\n                <button\n                  class=\"btn btn-danger\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.delete(item)\"\n                >\n                  删除\n                </button>\n              </td>\n            </tr>\n\n            <tr ng-if=\"$ctrl.filters.trinity === 'pray'\">\n              <td>数据序号</td>\n              <td>uba</td>\n              <td>日期序号</td>\n              <td>标题</td>\n              <td>内容</td>\n              <td>abTest</td>\n              <!-- <td>指定日期</td> -->\n              <!-- <td>指定早晚</td> -->\n              <!-- <td>创建</td> -->\n              <td>修改</td>\n              <td>标签</td>\n              <td>操作</td>\n            </tr>\n            <tr\n              ng-if=\"$ctrl.filters.trinity === 'pray'\"\n              ng-repeat=\"item in $ctrl.array track by $index\"\n            >\n              <td>{{item._id}}</td>\n              <td>\n                <table class=\"table table-bordered\" style=\"margin-bottom: 0%\">\n                  <tr\n                    ng-repeat=\"uba in $ctrl.uba[item.uba].numerator track by $index\"\n                  >\n                    <td style=\"color: rgb(124, 6, 6); font-weight: bold\">\n                      {{uba.name_zh}}\n                    </td>\n                    <td style=\"color: green; font-weight: bold\">\n                      {{uba.percentage}}\n                    </td>\n                    <td>\n                      {{ uba.percentageNum }}\n                    </td>\n                  </tr>\n                </table>\n              </td>\n              <td>{{item.day}}</td>\n              <td class=\"title\">{{item.title}}</td>\n              <td\n                class=\"content\"\n                ng-click=\"$ctrl.showContent(item.content, item.title)\"\n              >\n                {{item.content}}\n              </td>\n              <td>{{item.abTest}}</td>\n              <!-- <td>{{item.specDate}}</td> -->\n              <!-- <td>{{item.specTime}}</td> -->\n              <!-- <td>{{item.createdAt | date:'yyyy-MM-dd':'UTC'}}</td> -->\n              <td>{{item.updatedAt | date:'yyyy-MM-dd':'UTC'}}</td>\n              <td>{{item.tag}}</td>\n              <td>\n                <button\n                  class=\"btn btn-warning\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.edit(item)\"\n                >\n                  编辑\n                </button>\n                <button\n                  class=\"btn btn-danger\"\n                  type=\"button\"\n                  ng-click=\"$ctrl.delete(item)\"\n                >\n                  删除\n                </button>\n              </td>\n            </tr>\n\n            <tr class=\"text-center\">\n              <td colspan=\"15\">\n                <ul\n                  uib-pagination\n                  total-items=\"$ctrl.totalItems\"\n                  ng-model=\"$ctrl.currentPage\"\n                  max-size=\"$ctrl.maxSize\"\n                  class=\"pagination-sm\"\n                  boundary-links=\"true\"\n                  rotate=\"false\"\n                  ng-change=\"$ctrl.$onInit()\"\n                  previous-text=\"上一页\"\n                  next-text=\"下一页\"\n                  first-text=\"首页\"\n                  last-text=\"尾页\"\n                ></ul>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n"

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(406);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(408)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(407)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.row{margin-left:-15px;margin-right:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm{padding-left:0;padding-right:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{left:auto;right:0}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important;float:left}.navbar-right{float:right!important;float:right;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#080808;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.42857143;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-left:auto;margin-right:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}.longText{max-width:100px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.iHeader{background-color:hsla(0,0%,88%,.76);color:#000;font-size:23px}.i-label{margin:10px 1px;font-size:20px;color:rgba(34,34,34,.76);letter-spacing:2px}.i-content{border:1px solid rgba(33,33,33,.76);box-shadow:0 0 3px hsla(0,0%,64%,.76);background-color:hsla(0,0%,91%,.76);border-radius:5px;width:92%;margin:15px auto;min-height:300px;height:fit-content;padding:10px}.content{cursor:pointer;color:#00c}.content,.title{max-width:100px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.thing-form{margin:20px 0}#banner{border-bottom:none;margin-top:-20px}#banner h1{font-size:60px;line-height:1;letter-spacing:-1px}.hero-unit{position:relative;padding:30px 15px;color:#f5f5f5;text-align:center;text-shadow:0 1px 0 rgba(0,0,0,.1);background:#4393b9}.navbar-text{margin-left:15px}.form{background:hsla(0,0%,100%,.2);width:400px;margin:100px auto}#login_form{display:block}#register_form{display:none}.fa{display:inline-block;top:27px;left:6px;position:relative;color:#ccc}input[type=password],input[type=text]{padding-left:26px}.checkbox{padding-left:21px}footer.footer{text-align:center;padding:30px 0;margin-top:70px;border-top:1px solid #e5e5e5}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#5bc0de}.modal-success .modal-header{background:#5cb85c}.modal-warning .modal-header{background:#f0ad4e}.modal-danger .modal-header{background:#d9534f}", ""]);
	
	// exports


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production"}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)))

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.b0a5d2795e4587dc25b9.js